import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: VueCompositionApi.MaybeRefOrGetter<T[K]> };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  code: { input: any; output: any };
  cursor: { input: any; output: any };
  date: { input: any; output: any };
  dateTime: { input: any; output: any };
  uri: { input: any; output: any };
};

export type AccountConfiguration = {
  alarmAckTemplates?: Maybe<Array<Maybe<AlarmAckTemplateOutput>>>;
};

export type AccountFeatures = {
  alarmStreaming?: Maybe<Scalars['Boolean']['output']>;
  axisCameras?: Maybe<Scalars['Boolean']['output']>;
  beta: Scalars['Boolean']['output'];
  continuousSupervision?: Maybe<Scalars['Boolean']['output']>;
  dataAnalytics?: Maybe<Scalars['Boolean']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  disablePasswordForDialoggUsers?: Maybe<Scalars['Boolean']['output']>;
  disablePasswordForUsers?: Maybe<Scalars['Boolean']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  externalHumanIdTypeIdForDialoggUser?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForPatient?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForUser?: Maybe<Scalars['String']['output']>;
  hasAlmaIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasAscomIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasBestIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasCmp?: Maybe<Scalars['Boolean']['output']>;
  hasCmpAccount?: Maybe<Scalars['Boolean']['output']>;
  hasCoordcomIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasDemoAnonymization?: Maybe<Scalars['Boolean']['output']>;
  hasEntraIdProvisioning?: Maybe<Scalars['Boolean']['output']>;
  hasEntraIdSso?: Maybe<Scalars['Boolean']['output']>;
  hasFurnitureDetection?: Maybe<Scalars['Boolean']['output']>;
  hasIpOmsorgIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasJournalConfig?: Maybe<Scalars['Boolean']['output']>;
  hasPhoniroCloudIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasSipIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseCustomerGroup?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponsePartnerIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasTietoLmoIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasTrends?: Maybe<Scalars['Boolean']['output']>;
  hasUmo2GIntegration?: Maybe<Scalars['Boolean']['output']>;
  joinNhnMeeting?: Maybe<Scalars['Boolean']['output']>;
  legacyIntegration?: Maybe<Scalars['Boolean']['output']>;
  newSupervisionUserTabs?: Maybe<Scalars['Boolean']['output']>;
  safemateIntegration?: Maybe<Scalars['Boolean']['output']>;
  selfTreatmentPlan?: Maybe<Scalars['Boolean']['output']>;
  sendNotificationToNextOfKin?: Maybe<Scalars['Boolean']['output']>;
  skyresponse?: Maybe<Scalars['Boolean']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  tcifIntegration?: Maybe<Scalars['Boolean']['output']>;
  videoMeetings?: Maybe<Scalars['Boolean']['output']>;
  vkpSearchEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountLess = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type AccountSettings = {
  applications: Applications;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  features: AccountFeatures;
  name: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
  userAuth: AccountUserAuth;
  userSessionLifespan?: Maybe<Scalars['Int']['output']>;
};

export type AccountSettingsMutationResponse = {
  accountSettings?: Maybe<AccountSettings>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AccountUserAuth = {
  ipRestriction: Scalars['Boolean']['output'];
  resetPasswordAllowed: Scalars['Boolean']['output'];
  timeLimitedAccess: Scalars['Boolean']['output'];
  twoFactorAppRequired: Scalars['Boolean']['output'];
  twoFactorSms: Scalars['Boolean']['output'];
};

export type ActivityMeasurement = {
  endTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type ActivityPredictionMeasurement = {
  activity: Scalars['String']['output'];
  dateTime: Scalars['String']['output'];
  predictedValue: Scalars['Float']['output'];
  realValue: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type AddVideoMeetingTaskNotesResponse = {
  success: Scalars['Boolean']['output'];
  taskResponses: Array<TaskMutationResponse>;
};

export type Address = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  position?: Maybe<GpsPosition>;
  postalCode?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use?: Maybe<AddressUse>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  use?: InputMaybe<AddressUse>;
};

export enum AddressUse {
  Home = 'home',
  Old = 'old',
  Temp = 'temp',
  Work = 'work',
}

export enum AdministrativeGender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Unknown = 'unknown',
}

export type AlarmAckTemplate = {
  status: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type AlarmAckTemplateOutput = {
  status?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
};

export type AlarmActivity = {
  alarmIcon?: Maybe<Scalars['String']['output']>;
  callbackMinutes?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<CepConfig>;
  code: CodeableConcept;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  debounceDelay?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveTiming?: Maybe<Timing>;
  fromTemplate?: Maybe<Reference>;
  generatesAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  locationTraceOnly?: Maybe<Scalars['Boolean']['output']>;
  noCarePlanRequired?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  resolveAction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Scalars['String']['output'];
  tagAction?: Maybe<Array<Maybe<TagAction>>>;
  technical?: Maybe<Scalars['Boolean']['output']>;
  timedCep?: Maybe<TimedCepConfig>;
  toCode?: Maybe<Scalars['String']['output']>;
  vkpEncounter?: Maybe<VkpEncounter>;
};

export type AlarmCompletionOption = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  templates?: Maybe<Array<Maybe<AlarmCompletionOptionTemplate>>>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AlarmCompletionOptionMutationResponse = {
  alarmCompletionOption?: Maybe<AlarmCompletionOption>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AlarmCompletionOptionTemplate = {
  code: Scalars['String']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AlarmDetail = {
  cameraViews: Array<SupervisionCameraView>;
  skyresponseAlarmDetail?: Maybe<SkyresponseAlarmDetail>;
  telluAlarmDetail?: Maybe<Task>;
};

export type AlarmEventsPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events: Array<Observation>;
};

export type AlarmHandlingAttempt = {
  details?: Maybe<Scalars['String']['output']>;
  doneAt: Scalars['dateTime']['output'];
  handledBy?: Maybe<Array<Scalars['String']['output']>>;
  payload?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['dateTime']['output'];
  status: Scalars['String']['output'];
};

export type AlarmHandlingFeedbackInput = {
  alarmId: Scalars['ID']['input'];
  alarmList?: InputMaybe<Array<Scalars['String']['input']>>;
  alarmStatus?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<ClientStatus>;
  comment?: InputMaybe<Scalars['String']['input']>;
  devices?: InputMaybe<Array<Scalars['String']['input']>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmHandlingStatus = {
  attempts: Array<AlarmHandlingAttempt>;
  handler: Scalars['String']['output'];
  initiatedAt: Scalars['dateTime']['output'];
};

export type AlarmHistory = {
  acceptedAtInApp?: Maybe<Scalars['dateTime']['output']>;
  acceptedAtInRs?: Maybe<Scalars['dateTime']['output']>;
  alarmActionLast?: Maybe<Scalars['String']['output']>;
  alarmActionOne?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['String']['output']>;
  alarmCodeDescription?: Maybe<Scalars['String']['output']>;
  alarmEvent?: Maybe<Scalars['String']['output']>;
  alarmForwardedAt?: Maybe<Scalars['dateTime']['output']>;
  alarmHandling?: Maybe<Scalars['String']['output']>;
  alarmReasonLast?: Maybe<Scalars['String']['output']>;
  alarmReasonOne?: Maybe<Scalars['String']['output']>;
  alarmStartedInApp?: Maybe<Scalars['dateTime']['output']>;
  autoReleasedAt?: Maybe<Scalars['dateTime']['output']>;
  camerasOpened?: Maybe<Scalars['Int']['output']>;
  camerasOpenedBy: Array<CameraWatcher>;
  completionOptionNote?: Maybe<Scalars['String']['output']>;
  deactivationTimeInApp?: Maybe<Scalars['dateTime']['output']>;
  deactivationTimeInRs?: Maybe<Scalars['dateTime']['output']>;
  for?: Maybe<Reference>;
  freeTextNote?: Maybe<Scalars['String']['output']>;
  globalAlarmId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  handlingMode?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  journalWorkflowStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Reference>;
  operatorForApp?: Maybe<Scalars['String']['output']>;
  operatorForRs?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Reference>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Array<HumanName>>;
  priority: Scalars['String']['output'];
  priorityInput?: Maybe<TaskInput>;
  responseCenter?: Maybe<Scalars['String']['output']>;
  responseCenterAlarmId?: Maybe<Scalars['String']['output']>;
  routingType?: Maybe<AlarmRoutingType>;
  serverAlarmTime?: Maybe<Scalars['dateTime']['output']>;
  tag: Scalars['String']['output'];
  telluAlarmId?: Maybe<Scalars['String']['output']>;
  textMessage?: Maybe<Scalars['String']['output']>;
};

export type AlarmPatient = {
  address?: Maybe<Array<Maybe<Address>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Array<HumanName>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  skyresponseDetails?: Maybe<SkyresponseConfig>;
};

export type AlarmRoute = {
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  configType: Scalars['String']['output'];
  idMappingStrategy: Scalars['ID']['output'];
  incomingTemplate?: Maybe<SimpleAlarmTemplate>;
  outgoingTemplate?: Maybe<SimpleAlarmTemplate>;
  patientGroupId?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
};

export type AlarmRouteOptions = {
  configs: Array<Config>;
  idMappingStrategies: Array<ExternalHumanIdType>;
  templates: Array<SimpleAlarmTemplate>;
};

export enum AlarmRoutingType {
  DirectRouting = 'DIRECT_ROUTING',
  ResponseCenter = 'RESPONSE_CENTER',
  ResponseCenterForwarded = 'RESPONSE_CENTER_FORWARDED',
  Tellucare = 'TELLUCARE',
}

export type AlarmStatus = {
  deadlineAt?: Maybe<Scalars['dateTime']['output']>;
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  extendByMinutes?: Maybe<Scalars['Int']['output']>;
  handlingMode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  owner?: Maybe<Reference>;
  priorityInput?: Maybe<TaskInput>;
  status: Scalars['String']['output'];
};

export type AlarmSubscription = {
  deviceGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  healthProvider_fk?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  targetEmails?: Maybe<Array<Scalars['String']['output']>>;
  targetPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type AlarmSubscriptionCreateInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AlarmSubscriptionDeleteInput = {
  id: Scalars['String']['input'];
};

export type AlarmSubscriptionMutationResponse = {
  alarmSubscription?: Maybe<AlarmSubscription>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmSubscriptionUpdateInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AlarmTemplate = {
  acceptWithin?: Maybe<Scalars['Int']['output']>;
  alarmIcon?: Maybe<Scalars['String']['output']>;
  callbackMinutes?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<CepConfig>;
  code: CodeableConcept;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  debounceDelay?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveTiming?: Maybe<Timing>;
  generatesAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  locationTraceOnly?: Maybe<Scalars['Boolean']['output']>;
  noCarePlanRequired?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  resolveAction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resolveWithin?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  tagAction?: Maybe<Array<Maybe<TagAction>>>;
  technical?: Maybe<Scalars['Boolean']['output']>;
  timedCep?: Maybe<TemplateTimedCepConfig>;
  vkpEncounter?: Maybe<VkpEncounter>;
};

export type AlarmTemplateCreateInput = {
  acceptWithin?: InputMaybe<Scalars['Int']['input']>;
  alarmIcon?: InputMaybe<Scalars['String']['input']>;
  callbackMinutes?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<CepConfigInput>;
  code: CodeableConceptInput;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  debounceDelay?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  generatesAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  identifier: Array<InputMaybe<IdentifierInput>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  locationTraceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noCarePlanRequired?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  resolveAction?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolveWithin?: InputMaybe<Scalars['Int']['input']>;
  tagAction?: InputMaybe<Array<InputMaybe<TagActionInput>>>;
  technical?: InputMaybe<Scalars['Boolean']['input']>;
  timedCep?: InputMaybe<TemplateTimedCepConfigInput>;
  vkpEncounter?: InputMaybe<VkpEncounterInput>;
};

export type AlarmTemplateMutationResponse = {
  alarmTemplate?: Maybe<AlarmTemplate>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmTemplateUpdateInput = {
  acceptWithin?: InputMaybe<Scalars['Int']['input']>;
  alarmIcon?: InputMaybe<Scalars['String']['input']>;
  callbackMinutes?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<CepConfigInput>;
  code?: InputMaybe<CodeableConceptInput>;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  debounceDelay?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  generatesAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  locationTraceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noCarePlanRequired?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  resolveAction?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolveWithin?: InputMaybe<Scalars['Int']['input']>;
  tagAction?: InputMaybe<Array<InputMaybe<TagActionInput>>>;
  technical?: InputMaybe<Scalars['Boolean']['input']>;
  timedCep?: InputMaybe<TemplateTimedCepConfigInput>;
  vkpEncounter?: InputMaybe<VkpEncounterInput>;
};

export type AlarmTemplateWithCompletionOption = {
  code: Scalars['String']['output'];
  completionOptions: Array<AlarmCompletionOption>;
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AlarmTemplateWithVkpCodes = {
  code: Scalars['String']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  system: Scalars['String']['output'];
  technical: Scalars['Boolean']['output'];
  templateVkpCodes?: Maybe<TemplateVkpCodes>;
  title: Scalars['String']['output'];
};

export type AlarmTimeWindow = {
  checkTimeFrom: Scalars['String']['output'];
  checkTimeTo: Scalars['String']['output'];
  dayOfWeek: Array<DayOfWeek>;
};

export type AlarmTimeWindowInput = {
  checkTimeFrom: Scalars['String']['input'];
  checkTimeTo: Scalars['String']['input'];
  dayOfWeek: Array<DayOfWeek>;
};

export type AlarmVkpConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type AllPatientStats = {
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
};

export type AlmaForwarderConfiguration = {
  password?: Maybe<Scalars['String']['output']>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AlmaForwarderCreateInput = {
  password: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AlmaForwarderUpdateInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Annotation = {
  authorReference?: Maybe<Reference>;
  authorString?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AnnotationInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AppDevice = {
  appSettings?: Maybe<AppSettings>;
  deviceName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  medicalDevices?: Maybe<Array<Device>>;
  notificationSettings?: Maybe<NotificationSettings>;
  os: Scalars['String']['output'];
  remindedTasks?: Maybe<Array<ReminderStatus>>;
  username: Scalars['ID']['output'];
};

export type AppDeviceCreateInput = {
  appSettings: AppSettingsInput;
  deviceName: Scalars['String']['input'];
  os: Scalars['String']['input'];
};

export type AppDeviceForPatientUpdateInput = {
  appLocale?: InputMaybe<Scalars['String']['input']>;
  deviation: Scalars['Boolean']['input'];
  measurement: Scalars['Boolean']['input'];
  message: Scalars['Boolean']['input'];
  reminder: Scalars['Int']['input'];
  reviewed: Scalars['Boolean']['input'];
  videoMeetingReminder: Scalars['Boolean']['input'];
};

export type AppDeviceMutationResponse = {
  appDevice?: Maybe<AppDevice>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AppDeviceUpdateInput = {
  appSettings?: InputMaybe<AppSettingsInput>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
};

export type AppManagementStatus = {
  id: Scalars['ID']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileCount?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AppSettings = {
  appLocale?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  pushId?: Maybe<Scalars['String']['output']>;
};

export type AppSettingsInput = {
  appLocale?: InputMaybe<Scalars['String']['input']>;
  appName: Scalars['String']['input'];
  pushId: Scalars['String']['input'];
};

export enum Application {
  Dhv = 'dhv',
  Rpm = 'rpm',
  Supervision = 'supervision',
}

export type ApplicationToggleResponse = {
  application: Application;
  applications: Applications;
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  wasEnabled: Scalars['Boolean']['output'];
};

export type Applications = {
  default?: Maybe<Scalars['String']['output']>;
  dhv?: Maybe<Scalars['Boolean']['output']>;
  dialogg?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Scalars['Boolean']['output']>;
  rpm?: Maybe<Scalars['Boolean']['output']>;
  supervision?: Maybe<Scalars['Boolean']['output']>;
  supportTeam?: Maybe<Scalars['Boolean']['output']>;
};

export type Appointment = {
  /**  Reminders only: when the patient acknowledged the reminder, if they have  */
  acknowledgedAt?: Maybe<Scalars['dateTime']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  /**  Reminders only: the reminder covers the whole day, has no time of day, and is not notified about  */
  allDay: Scalars['Boolean']['output'];
  /**
   * Reminders only: the day an all-day reminder covers, in the health provider's time zone, and null
   * for any other appointment. That zone is not the client's, so this is the day to show it on
   * rather than one worked out from start and end.
   */
  allDayDate?: Maybe<Scalars['date']['output']>;
  appointmentGroupId?: Maybe<Scalars['ID']['output']>;
  appointmentType: Scalars['String']['output'];
  calendarSequence?: Maybe<Scalars['Int']['output']>;
  carePlan?: Maybe<CarePlan>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['dateTime']['output'];
  id: Scalars['ID']['output'];
  meetingEndTime?: Maybe<Scalars['dateTime']['output']>;
  meetingStartTime?: Maybe<Scalars['dateTime']['output']>;
  minutesBeforeReminder?: Maybe<Scalars['Int']['output']>;
  participant?: Maybe<Array<Maybe<AppointmentParticipant>>>;
  patient?: Maybe<Patient>;
  patients: Array<Patient>;
  /**  Reminders only: the patient has to acknowledge the reminder before it is completed  */
  requiresAcknowledgement: Scalars['Boolean']['output'];
  start: Scalars['dateTime']['output'];
  status: AppointmentStatus;
  supportingInformation?: Maybe<Array<Maybe<Reference>>>;
};

export type AppointmentParticipant = {
  actor?: Maybe<Reference>;
  task?: Maybe<Reference>;
};

export type AppointmentParticipantInput = {
  actor?: InputMaybe<ReferenceInput>;
};

export enum AppointmentStatus {
  Arrived = 'arrived',
  Booked = 'booked',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Pending = 'pending',
  Proposed = 'proposed',
}

export type AscomConnectionStatus = {
  details?: Maybe<Scalars['String']['output']>;
  httpStatus: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type AscomForwarderConfiguration = {
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  ascomIntegrationId?: Maybe<Scalars['String']['output']>;
  connectionStatus?: Maybe<AscomConnectionStatus>;
  heartbeatRate?: Maybe<Scalars['Int']['output']>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
};

export type AscomForwarderCreateInput = {
  active: Scalars['Boolean']['input'];
  apiKey: Scalars['String']['input'];
  ascomIntegrationId: Scalars['String']['input'];
  heartbeatRate: Scalars['Int']['input'];
  primaryUrl: Scalars['String']['input'];
};

export type AscomForwarderUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  ascomIntegrationId?: InputMaybe<Scalars['String']['input']>;
  heartbeatRate?: InputMaybe<Scalars['Int']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Asset = {
  contentType?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  uploadKey?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum AssetResourceType {
  WhiteLabelingTemplate = 'white_labeling_template',
}

export type Attachment = {
  contentType?: Maybe<Scalars['String']['output']>;
  creation?: Maybe<Scalars['dateTime']['output']>;
  documentReferenceId?: Maybe<Scalars['ID']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AudioManagementStatus = {
  audioSupported?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  inputGain?: Maybe<Scalars['String']['output']>;
  inputType?: Maybe<Scalars['String']['output']>;
  microphonePowerType?: Maybe<Scalars['String']['output']>;
  microphonePowered?: Maybe<Scalars['Boolean']['output']>;
};

export type AuditEntitySummaryEntry = {
  count: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
};

export type AuditEvent = {
  action?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Array<AuditEventAgent>>;
  entity?: Maybe<Array<AuditEventEntity>>;
  id: Scalars['ID']['output'];
  mainEntity?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcomeDesc?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  purposeOfEvent?: Maybe<Array<Maybe<CodeableConcept>>>;
  recorded?: Maybe<Scalars['dateTime']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AuditEventSource>;
  type: AuditEventType;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum AuditEventAction {
  C = 'C',
  D = 'D',
  E = 'E',
  R = 'R',
  U = 'U',
}

export type AuditEventAgent = {
  altId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<AuditEventAgentNetwork>;
  requestor: Scalars['Boolean']['output'];
  role?: Maybe<Array<CodeableConcept>>;
  who?: Maybe<Reference>;
};

export type AuditEventAgentNetwork = {
  address?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AuditEventDetail = {
  type?: Maybe<Scalars['String']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type AuditEventEntity = {
  detail?: Maybe<Array<AuditEventDetail>>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Coding>;
  type?: Maybe<Coding>;
  what?: Maybe<Reference>;
};

export type AuditEventSource = {
  observer: Reference;
};

export type AuditEventType = {
  code: Scalars['String']['output'];
};

export type AuditLogOperationSelector = {
  operation: Scalars['String']['input'];
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events?: Maybe<Array<AuditEvent>>;
};

export type AuditLogSummaries = {
  auditEntitySummary: Array<AuditEntitySummaryEntry>;
  auditLogSummary: Array<AuditLogSummaryEntry>;
  auditRoleSummary: Array<AuditRoleSummaryEntry>;
};

export type AuditLogSummaryEntry = {
  count: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type AuditRoleSummaryEntry = {
  count: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type AuditStats = {
  defaultRoleDefinitionId?: Maybe<Scalars['String']['output']>;
  healthProvider?: Maybe<Scalars['String']['output']>;
  loginSessionId?: Maybe<Scalars['String']['output']>;
  numberOfOperations?: Maybe<Scalars['Int']['output']>;
  roleDefinitionId?: Maybe<Scalars['String']['output']>;
  roleInstanceName?: Maybe<Scalars['String']['output']>;
  sessionEnd?: Maybe<Scalars['dateTime']['output']>;
  sessionStart?: Maybe<Scalars['dateTime']['output']>;
  userGroupName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuthEvent = {
  details?: Maybe<Array<AuthEventDetails>>;
  error?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
  type?: Maybe<AuthEventType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuthEventDetails = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AuthEventFilter = {
  dateFrom?: InputMaybe<Scalars['dateTime']['input']>;
  dateTo?: InputMaybe<Scalars['dateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<AuthEventType>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AuthEventType {
  FederatedIdentityLink = 'FEDERATED_IDENTITY_LINK',
  FederatedIdentityLinkError = 'FEDERATED_IDENTITY_LINK_ERROR',
  Login = 'LOGIN',
  LoginError = 'LOGIN_ERROR',
  Logout = 'LOGOUT',
  LogoutError = 'LOGOUT_ERROR',
}

export type AuthUpdateInput = {
  ipRestriction: Scalars['Boolean']['input'];
  resetPasswordAllowed: Scalars['Boolean']['input'];
  timeLimitedAccess: Scalars['Boolean']['input'];
  twoFactorSms: Scalars['Boolean']['input'];
};

export type AutoStartSettings = {
  afterSeconds?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type AutoStartSettingsInput = {
  afterSeconds?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
};

export type AvailableResourcesToContact = {
  lowerLevelContacts: Array<Contact>;
  topLevelContacts: Array<Contact>;
};

export type AzureAccount = {
  alias: Scalars['String']['output'];
  azureGroups?: Maybe<Array<Maybe<AzureGroup>>>;
  azureProvisioningCredentials?: Maybe<AzureProvisioningCredentials>;
  clientId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalIdentityProvider: ExternalIdentityProvider;
  id: Scalars['String']['output'];
  patientRealm: Scalars['Boolean']['output'];
  prio?: Maybe<Scalars['String']['output']>;
  support: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type AzureAccountMutationResponse = {
  azureAccount?: Maybe<ExternalIdentityProviderForHealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AzureGroup = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pendingExternalIdentityProviders?: Maybe<Array<Scalars['String']['output']>>;
  requestedExternalIdTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles?: Maybe<Array<Role>>;
};

export type AzureGroupMutationResponse = {
  azureGroup?: Maybe<AzureGroup>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AzureProvisioningCredentials = {
  secretToken?: Maybe<Scalars['String']['output']>;
  tenantUrl?: Maybe<Scalars['String']['output']>;
};

export type AzureProvisioningMutationResponse = {
  azureProvisioningCredentials?: Maybe<AzureProvisioningCredentials>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Badges = {
  syncAlarms: Scalars['Int']['output'];
  technicalAlarms: Scalars['Int']['output'];
};

export type BestForwarderConfiguration = {
  clientId: Scalars['String']['output'];
  primaryUrl: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type BestForwarderCreateInput = {
  clientId: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type BestForwarderUpdateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

/** Furniture detection types */
export type BoundingBox = {
  bottomRightX: Scalars['Float']['output'];
  bottomRightY: Scalars['Float']['output'];
  topLeftX: Scalars['Float']['output'];
  topLeftY: Scalars['Float']['output'];
};

export type BoundingBoxInput = {
  bottomRightX: Scalars['Float']['input'];
  bottomRightY: Scalars['Float']['input'];
  topLeftX: Scalars['Float']['input'];
  topLeftY: Scalars['Float']['input'];
};

export type Camera = {
  /**
   * Is the camera currently enabled?
   *
   * Example: true
   */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Defines when the camera video stream is accessible in Tellucare, following the standard opening_hours format. */
  availableHours?: Maybe<Scalars['String']['output']>;
  /**
   * The camera profile of the camera. It has no access check of its own: the access of the parent query
   * applies, as for deviceGroup. Null for a camera in an account without supervision, and for a camera that
   * the camera profile migration has not reached yet.
   */
  cameraProfile?: Maybe<CameraProfile>;
  /**
   * Text description of the camera, for humans
   *
   * Example: Camera watching the bedroom
   */
  description?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  deviceGroup?: Maybe<DeviceGroup>;
  /**
   * The settings that the API applies to the camera, from its camera profile and its own settings. It has no
   * access check of its own, as cameraProfile. Null for a camera without a camera profile.
   */
  effectiveSettings?: Maybe<CameraEffectiveSettings>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  /** Camera FHIR ID. */
  id: Scalars['ID']['output'];
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  /** MAC-address of the camera */
  macAddress: Scalars['String']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable name
   *
   * Example: bed room.
   */
  name: Scalars['String']['output'];
  /** Pings the camera. Only query when needed (e.g. before opening stream). */
  online?: Maybe<Scalars['Boolean']['output']>;
  /** FHIR reference to the patient the camera is attached to. */
  patientReference?: Maybe<Reference>;
  /** List of camera presets. */
  presets: Array<Maybe<Scalars['String']['output']>>;
  ptzEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Always an object. Its fields are null when the camera has no value of its own. */
  settings: CameraSettings;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
  /** Pan, tilt and zoom. */
  view?: Maybe<CameraView>;
};

export type CameraAdmin = {
  /** List applications related to the camera (URLs are fetched via getCameraAdminUrl) */
  adminApps?: Maybe<Array<Maybe<CameraAdminApp>>>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  filteredEvents?: Maybe<Array<FilteredCameraEvents>>;
  firmware?: Maybe<Scalars['String']['output']>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Those statuses query the camera (slow)
   * Do not query them together with getAllCameras
   */
  online?: Maybe<Scalars['Boolean']['output']>;
  patientReference?: Maybe<Reference>;
  /** Optional information about the router providing connectivity to the camera (e.g. Novo, Teltonika) */
  router?: Maybe<RouterInfo>;
};

/** A camera Admin APP can be used to configured an application */
export type CameraAdminApp = {
  /** ID of the admin app */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Profiles for apps like VMD, FG, OA */
  profiles?: Maybe<Array<CameraAppProfile>>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CameraAppProfile = {
  accountTemplate?: Maybe<SimpleAlarmTemplate>;
  cameraTopic?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientTemplate?: Maybe<SimpleAlarmTemplate>;
};

export type CameraAppUpdate = {
  activate: Scalars['Boolean']['output'];
  deactivate: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  install: Scalars['Boolean']['output'];
  uninstall: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type CameraAppUpdateInput = {
  activate: Scalars['Boolean']['input'];
  deactivate: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  install: Scalars['Boolean']['input'];
  uninstall: Scalars['Boolean']['input'];
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CameraAudioSettings = {
  enableAudio?: Maybe<Scalars['Boolean']['output']>;
  enableSpeaker?: Maybe<Scalars['Boolean']['output']>;
};

export type CameraAudioSettingsInput = {
  enableAudio?: InputMaybe<Scalars['Boolean']['input']>;
  enableSpeaker?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CameraAvailability {
  Deprecated = 'deprecated',
  Experimental = 'experimental',
  Supported = 'supported',
}

/**
 * The camera's live configuration. Each area is backed by one camera command and is fetched only
 * when it is selected; selected areas resolve concurrently.
 */
export type CameraConfiguration = {
  cameraId: Scalars['ID']['output'];
  /**
   * Event toggles, from the camera's getConfig command. Null only when the query did not select
   * it; see the zones field above.
   */
  detectionSettings?: Maybe<CameraDetectionSettingsResult>;
  /**
   * Detection zones, from the camera's getLandmarks command. Null only when the query did not
   * select it: an unselected area issues no camera command and so has no outcome to report. An
   * area you did select always answers - with success: false and a message when the camera did
   * not.
   */
  zones?: Maybe<CameraZonesResult>;
};

/** Why an area could not be read. CAMERA_REJECTED is not retryable with the same request. */
export enum CameraConfigurationErrorCode {
  CameraRejected = 'CAMERA_REJECTED',
  CameraTimeout = 'CAMERA_TIMEOUT',
  TransportUnavailable = 'TRANSPORT_UNAVAILABLE',
}

export type CameraConfigurationMutationResponse = {
  configuration?: Maybe<CameraConfiguration>;
  inputValidation?: Maybe<InputValidationResult>;
  /** A summary of what actually changed, or 'No changes'. Also the audit log's outcome description. */
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CameraDetailedStatus = {
  eventsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  eventsDeactivatedUntil?: Maybe<Scalars['dateTime']['output']>;
  hasViewersEnabled?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  isAssociatedToPatient?: Maybe<Scalars['Boolean']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  privacyModeUntil?: Maybe<Scalars['dateTime']['output']>;
  ttl?: Maybe<Scalars['Int']['output']>;
};

export type CameraDetectionSettings = {
  events: Array<CameraEventSetting>;
  /** Fall confirmation sensitivity. Independent of the FALL_DETECTION toggle. */
  fallSensitivity: CameraFallSensitivitySetting;
  /** How long a safe zone keeps suppressing after the engine stops seeing data in it. */
  safeZoneNoDataHold: CameraSafeZoneNoDataHoldSetting;
  /** Consider the area under the camera safe. Writing it changes the camera's zone geometry. */
  underCameraAreaSafe: Scalars['Boolean']['output'];
};

/** Omitted fields are unchanged. Explicit null is rejected. */
export type CameraDetectionSettingsInput = {
  events?: InputMaybe<Array<CameraEventSettingInput>>;
  fallSensitivity?: InputMaybe<CameraFallSensitivityMode>;
  /** Whole minutes, 1-60. */
  safeZoneNoDataHoldMinutes?: InputMaybe<Scalars['Int']['input']>;
  underCameraAreaSafe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CameraDetectionSettingsResult = {
  detectionSettings?: Maybe<CameraDetectionSettings>;
  errorCode?: Maybe<CameraConfigurationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CameraDoor = {
  name: CameraDoorName;
  vertices: Array<LandmarkVertex>;
};

export type CameraDoorInput = {
  name: CameraDoorName;
  vertices: Array<LandmarkVertexInput>;
};

export enum CameraDoorName {
  Bathroom = 'BATHROOM',
  Main = 'MAIN',
}

/** The safe-zone slots that may be written. */
export enum CameraEditableSafeZoneName {
  Chair = 'CHAIR',
  Couch = 'COUCH',
}

/**
 * The camera settings that the API applies to a camera with a camera profile. On a standard or a created
 * profile with continuous supervision, the settings that do not take effect have the values of the standard
 * "Continuous supervision" profile (see CameraProfile.continuousSupervision). A migrated profile keeps its
 * stored values.
 */
export type CameraEffectiveSettings = {
  allowUnplannedSupervision: Scalars['Boolean']['output'];
  continuousSupervision: Scalars['Boolean']['output'];
  enableExtendingCameraAvailability: Scalars['Boolean']['output'];
  enableSnapshots: Scalars['Boolean']['output'];
  enableSoundMonitoring: Scalars['Boolean']['output'];
  /** Whether snapshots are anonymized: the own value of a migrated profile, else true unless streamAnonymizationMode is disabled */
  snapshotAnonymization: Scalars['Boolean']['output'];
  /** dBFS. The sound threshold of the camera, else the soundMonitoringDefaultThreshold of the profile. */
  soundThreshold: Scalars['Int']['output'];
  streamAnonymizationMode: StreamAnonymizationMode;
  streamAnonymizationStrategy?: Maybe<StreamAnonymizationStrategy>;
  /** How long a stream is authorised before it is renewed, in seconds. 80000 under continuous supervision. Null when the profile sets none. */
  streamTTL?: Maybe<Scalars['Int']['output']>;
};

export type CameraEventConfig = {
  cameraId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['dateTime']['output'];
  displayText: Scalars['String']['output'];
  generatesAlarm: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientId: Scalars['ID']['output'];
  priority: EventConfigPriority;
  schedule?: Maybe<EventConfigSchedule>;
  toCode?: Maybe<Scalars['String']['output']>;
  type: CameraEventConfigEventType;
  updatedAt: Scalars['dateTime']['output'];
  workflow: EventConfigWorkflow;
};

export enum CameraEventConfigEventType {
  AxisCamera = 'axis_camera',
}

export type CameraEventConfigInput = {
  code: Scalars['String']['input'];
  displayText: Scalars['String']['input'];
  generatesAlarm: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  priority: EventConfigPriorityInput;
  schedule?: InputMaybe<EventConfigScheduleInput>;
  toCode?: InputMaybe<Scalars['String']['input']>;
  type: CameraEventConfigEventType;
  workflow: EventConfigWorkflow;
};

export type CameraEventConfigMutationResponse = {
  eventConfig?: Maybe<CameraEventConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** There is no "out of bathroom" event: the camera emits IntoBathroom only. */
export enum CameraEventKey {
  FallDetection = 'FALL_DETECTION',
  InsideBed = 'INSIDE_BED',
  IntoBathroom = 'INTO_BATHROOM',
  InRoom = 'IN_ROOM',
  OutOfBed = 'OUT_OF_BED',
  OutOfRoom = 'OUT_OF_ROOM',
}

/**
 * An event toggle. available is derived: the key must be present in the camera's reply. An
 * unavailable event cannot be written.
 */
export type CameraEventSetting = {
  available: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  event: CameraEventKey;
  unavailableReason?: Maybe<CameraEventUnavailableReason>;
};

export type CameraEventSettingInput = {
  enabled: Scalars['Boolean']['input'];
  event: CameraEventKey;
};

export enum CameraEventUnavailableReason {
  NotSupportedByFirmware = 'NOT_SUPPORTED_BY_FIRMWARE',
}

export type CameraExclusionZone = {
  name: CameraExclusionZoneName;
  vertices: Array<LandmarkVertex>;
};

export type CameraExclusionZoneInput = {
  name: CameraExclusionZoneName;
  vertices: Array<LandmarkVertexInput>;
};

export enum CameraExclusionZoneName {
  ExclusionZone_1 = 'EXCLUSION_ZONE_1',
  ExclusionZone_2 = 'EXCLUSION_ZONE_2',
}

/**
 * TEST removes the fall confirmation delay entirely (TEST 0 s / NORMAL 600 s / HIGH 120 s), so a
 * client offering it must label it as such.
 */
export enum CameraFallSensitivityMode {
  High = 'HIGH',
  Normal = 'NORMAL',
  Test = 'TEST',
}

/**
 * Fall confirmation sensitivity. It is written independently of the FALL_DETECTION toggle: the
 * camera accepts a mode change while fall detection is off and does not reset it when fall
 * detection is turned off, so greying the control out is a display rule for the client.
 */
export type CameraFallSensitivitySetting = {
  available: Scalars['Boolean']['output'];
  /** Null when the setting is unavailable. */
  mode?: Maybe<CameraFallSensitivityMode>;
  unavailableReason?: Maybe<CameraEventUnavailableReason>;
};

export type CameraFirmwareUpgrade = {
  reinstallIfSameVersion: Scalars['Boolean']['output'];
};

export type CameraFirmwareUpgradeInput = {
  reinstallIfSameVersion: Scalars['Boolean']['input'];
};

export type CameraInInventory = {
  macAddress?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
};

export type CameraIoPortConfigurationSettingsInput = {
  inputPortNormalState: CameraIoPortState;
};

export enum CameraIoPortState {
  Closed = 'closed',
  Open = 'open',
}

/**
 * Categories omitted are preserved. A category you include REPLACES every editable zone in it, so
 * always send every zone in a category you include - sending only the edited door deletes the
 * other one. An explicit empty list wipes the category; explicit null is rejected.
 */
export type CameraLandmarksInput = {
  bed?: InputMaybe<Array<LandmarkVertexInput>>;
  doors?: InputMaybe<Array<CameraDoorInput>>;
  exclusionZones?: InputMaybe<Array<CameraExclusionZoneInput>>;
  safeZones?: InputMaybe<Array<CameraSafeZoneInput>>;
};

/** Will allow to track each camera in the bacth */
export type CameraManagementInput = {
  id: Scalars['ID']['input'];
  macAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Will allow to track each camera in the bacth */
export type CameraManagementInputWithOptionalId = {
  id?: InputMaybe<Scalars['ID']['input']>;
  macAddress: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CameraManagementStatus = {
  apps?: Maybe<Array<CameraAppUpdate>>;
  cameraName: Scalars['String']['output'];
  cameraSetup?: Maybe<CameraSetup>;
  createdAt: Scalars['dateTime']['output'];
  firmwareUpgrade?: Maybe<CameraFirmwareUpgrade>;
  logs?: Maybe<Array<Scalars['String']['output']>>;
  serial: Scalars['String']['output'];
  settings?: Maybe<CameraAudioSettings>;
  status?: Maybe<Array<CameraManagementStepStatus>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['dateTime']['output'];
  user?: Maybe<Scalars['String']['output']>;
};

export type CameraManagementStepStatus = {
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  timestamp: Scalars['dateTime']['output'];
};

export type CameraModelWithCapabilities = {
  apps: Array<SupportedCameraApp>;
  availability: CameraAvailability;
  latestFirmware?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
};

export type CameraMutationResponse = {
  camera?: Maybe<Camera>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * A named set of camera settings in one account. Each camera uses one camera profile, and a change to a
 * profile changes every camera that uses it.
 */
export type CameraProfile = {
  allowUnplannedSupervision: Scalars['Boolean']['output'];
  /** The number of cameras that use the profile */
  cameraCount: Scalars['Int']['output'];
  /**
   * On a standard or a created profile, snapshots, snapshot anonymization, the streaming duration, unplanned
   * supervision and extended camera availability do not take effect while this is true: the cameras get the
   * values of the standard "Continuous supervision" profile. The anonymization policy and type take effect.
   * The fields here still return the stored values. A migrated profile keeps its stored values.
   */
  continuousSupervision: Scalars['Boolean']['output'];
  createdAt: Scalars['dateTime']['output'];
  enableExtendingCameraAvailability: Scalars['Boolean']['output'];
  /** Null follows the policy: snapshots are anonymized unless streamAnonymizationMode is disabled */
  enableSnapshotAnonymization?: Maybe<Scalars['Boolean']['output']>;
  enableSnapshots: Scalars['Boolean']['output'];
  enableSoundMonitoring: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The profile that new cameras get. Exactly one per account. */
  isDefault: Scalars['Boolean']['output'];
  /** Unique in the account, ignoring case */
  name: Scalars['String']['output'];
  origin: CameraProfileOrigin;
  /** dBFS, -60 to 0 */
  soundMonitoringDefaultThreshold: Scalars['Int']['output'];
  streamAnonymizationMode: StreamAnonymizationMode;
  streamAnonymizationStrategy?: Maybe<StreamAnonymizationStrategy>;
  /** Streaming duration in seconds */
  streamTTL?: Maybe<Scalars['Int']['output']>;
  /** Set when the origin is standard, and kept after edits */
  template?: Maybe<CameraProfileTemplate>;
  updatedAt: Scalars['dateTime']['output'];
};

/**
 * On create, name is required and every setting left out gets the default of a new profile. On update,
 * every field is optional and a field left out keeps its value.
 */
export type CameraProfileInput = {
  allowUnplannedSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  continuousSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  enableExtendingCameraAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only a migrated profile accepts true or false. Null follows the policy. */
  enableSnapshotAnonymization?: InputMaybe<Scalars['Boolean']['input']>;
  enableSnapshots?: InputMaybe<Scalars['Boolean']['input']>;
  enableSoundMonitoring?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  soundMonitoringDefaultThreshold?: InputMaybe<Scalars['Int']['input']>;
  streamAnonymizationMode?: InputMaybe<StreamAnonymizationMode>;
  streamAnonymizationStrategy?: InputMaybe<StreamAnonymizationStrategy>;
  streamTTL?: InputMaybe<Scalars['Int']['input']>;
};

export type CameraProfileMutationResponse = {
  cameraProfile?: Maybe<CameraProfile>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * Where a camera profile comes from: standard (a standard template), migrated (a device group, by the
 * camera profile migration) or created (a user).
 */
export enum CameraProfileOrigin {
  Created = 'created',
  Migrated = 'migrated',
  Standard = 'standard',
}

export enum CameraProfileTemplate {
  Anonymization = 'anonymization',
  ContinuousSupervision = 'continuousSupervision',
  NoAnonymization = 'noAnonymization',
}

export type CameraPtzProfile = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pan: Scalars['Float']['output'];
  tilt: Scalars['Float']['output'];
  zoom: Scalars['Float']['output'];
};

export type CameraPtzProfileConfig = {
  activeProfileId?: Maybe<Scalars['ID']['output']>;
  profiles: Array<CameraPtzProfile>;
};

export type CameraRotationSettings = {
  rotation: Scalars['Int']['output'];
};

export type CameraRotationSettingsInput = {
  rotation: Scalars['Int']['input'];
};

export type CameraSafeZone = {
  /** True for a zone the camera generated; it has no editable slot and is never valid input. */
  generated: Scalars['Boolean']['output'];
  name: CameraSafeZoneName;
  vertices: Array<LandmarkVertex>;
};

export type CameraSafeZoneInput = {
  name: CameraEditableSafeZoneName;
  vertices: Array<LandmarkVertexInput>;
};

/** UNDER_CAMERA is generated by the camera from underCameraAreaSafe and is read-only. */
export enum CameraSafeZoneName {
  Chair = 'CHAIR',
  Couch = 'COUCH',
  UnderCamera = 'UNDER_CAMERA',
}

/**
 * The no-data hold timer, in whole minutes - the unit the camera's own page uses. The camera stores
 * milliseconds; the conversion is the API's.
 */
export type CameraSafeZoneNoDataHoldSetting = {
  available: Scalars['Boolean']['output'];
  /** Null when the setting is unavailable. Between 1 and 60. */
  minutes?: Maybe<Scalars['Int']['output']>;
  unavailableReason?: Maybe<CameraEventUnavailableReason>;
};

/** Settings with one value for each camera. */
export type CameraSettings = {
  /** dBFS, -60 to 0. Null uses the soundMonitoringDefaultThreshold of the camera profile. */
  soundThreshold?: Maybe<Scalars['Int']['output']>;
};

export type CameraSettingsInput = {
  /** dBFS, -60 to 0. Null clears the value, so that the camera uses the default of its profile. */
  soundThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type CameraSettingsMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CameraSettings>;
  success: Scalars['Boolean']['output'];
};

export type CameraSetup = {
  cameraName: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  deviceGroupId: Scalars['ID']['output'];
  enableAudio: Scalars['Boolean']['output'];
  enableSpeaker: Scalars['Boolean']['output'];
  firmwareUpgrade: Scalars['Boolean']['output'];
  installApps: Scalars['Boolean']['output'];
  installFG: Scalars['Boolean']['output'];
  installOA: Scalars['Boolean']['output'];
  installPS: Scalars['Boolean']['output'];
  installTCAP: Scalars['Boolean']['output'];
  installTelluAnalytics: Scalars['Boolean']['output'];
  installVMD: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  oak: Scalars['String']['output'];
  rotation?: Maybe<Scalars['Int']['output']>;
  serial: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
};

export type CameraSetupInput = {
  cameraName: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  deviceGroupId: Scalars['ID']['input'];
  enableAudio: Scalars['Boolean']['input'];
  enableSpeaker: Scalars['Boolean']['input'];
  firmwareUpgrade: Scalars['Boolean']['input'];
  installApps: Scalars['Boolean']['input'];
  installFG: Scalars['Boolean']['input'];
  installOA: Scalars['Boolean']['input'];
  installPS: Scalars['Boolean']['input'];
  installTCAP: Scalars['Boolean']['input'];
  installTelluAnalytics: Scalars['Boolean']['input'];
  installVMD: Scalars['Boolean']['input'];
  model: Scalars['String']['input'];
  oak: Scalars['String']['input'];
  rotation?: InputMaybe<Scalars['Int']['input']>;
  serial: Scalars['String']['input'];
  siteId: Scalars['Int']['input'];
};

export enum CameraStateOrigin {
  App = 'app',
  Arrival = 'arrival',
  IoButton = 'ioButton',
}

export type CameraStatus = {
  apps?: Maybe<Array<Maybe<AppManagementStatus>>>;
  arch?: Maybe<Scalars['String']['output']>;
  audio?: Maybe<AudioManagementStatus>;
  connectedToMorphean: Scalars['Boolean']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  deviceGroupId?: Maybe<Scalars['String']['output']>;
  firmware?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inAccount: Scalars['Boolean']['output'];
  inMorphean: Scalars['Boolean']['output'];
  inRegistry: Scalars['Boolean']['output'];
  isAttachedToPatient: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  latestFirmware?: Maybe<Scalars['String']['output']>;
  macAddress: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  mqttConfig?: Maybe<MqttConfig>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<NetworkMangementStatus>;
  ptz?: Maybe<PtzManagementStatus>;
  routerMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  soc?: Maybe<Scalars['String']['output']>;
  time?: Maybe<TimeManagementStatus>;
  video?: Maybe<VideoManagementStatus>;
};

/** Camera stream details */
export type CameraStream = {
  /**
   * Date and time at which the stream expires and stops.
   *
   * Null if the stream never expires. The stream may be expanded by
   *
   * sending a /extend command.
   */
  expires?: Maybe<Scalars['dateTime']['output']>;
  /**
   * Stream ID.
   *
   * For a bounding-box stream, this is the canonical pair ID shared by the browser and camera. It
   * is also the streamId query parameter in url and the streamId sent to TCAP.
   *
   * Example: ea9648c9-25c0-468f-8a87-adde147d6feb
   */
  id: Scalars['ID']['output'];
  /**
   * Seconds after which the client should send its next keep-alive for this stream.
   *
   * Only set for bounding-box streams. Null means "do not renew": the stream will
   *
   * expire on its own (e.g. together with the remaining video availability window).
   */
  renewAfterSec?: Maybe<Scalars['Int']['output']>;
  /**
   * Time to live / duration of the stream in seconds before it expires and
   *
   * stops. The stream may be extended by sending a keep-alive command.
   *
   * 60 seconds by default, can be restricted in the device or JWT
   */
  ttl?: Maybe<Scalars['Int']['output']>;
  /**
   * Video stream type
   *
   * Unavailable in keepStreamAlive answers
   *
   * Example: rtsp-wss
   */
  type?: Maybe<Scalars['String']['output']>;
  /**
   * Stream URL.
   *
   * For a bounding-box stream, the API sends this exact URL to both the browser and TCAP without
   * rewriting it. The peers select bbox-browser and bbox-camera respectively.
   *
   * Example: rtsp://streaming.example.net/ea9648c9-25c0-468f-8a87-adde147d6feb.vod
   */
  url: Scalars['String']['output'];
};

/** Camera stream profile */
export type CameraStreamProfile = {
  /**
   * Does the stream profile includes audio ?
   *
   * Example: false
   */
  audio?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Video codec of the stream profile
   *
   * Example: h264
   */
  codec?: Maybe<Scalars['String']['output']>;
  /**
   * Number of frames per seconds
   *
   * Example: 24
   */
  framerate?: Maybe<Scalars['Int']['output']>;
  /**
   * Name of the string profile (used as ID)
   *
   * Example: High Quality
   */
  name: Scalars['String']['output'];
  /**
   * Resolution of the stream
   *
   * Example: 1920x1080
   */
  resolution?: Maybe<Scalars['String']['output']>;
};

export type CameraView = {
  maxPan?: Maybe<Scalars['Float']['output']>;
  maxTilt?: Maybe<Scalars['Float']['output']>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minPan?: Maybe<Scalars['Float']['output']>;
  minTilt?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  /**
   * pan of the camera (in degrees)
   *
   * 0 is north, 90 is east, 180 is south, 270 is west
   *
   * Synonym: Pan
   *
   * Example: 158.5
   */
  pan?: Maybe<Scalars['Float']['output']>;
  /**
   * tilt of the camera (in degrees)
   *
   * 0 is horizontal, 90 is pointing up, -90 is pointing down
   *
   * Synonym: Tilt
   *
   * Example: 18.0
   */
  tilt?: Maybe<Scalars['Float']['output']>;
  /**
   * Field of View of the camera.
   *
   * A high number represents a camera with a wide lens, while
   *
   * a low number represents a camera with a zoom.
   *
   * The ZOOM changes when the camera zoom is manipulated.
   *
   * Example: 90.0
   */
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type CameraWatcher = {
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CameraWithStatus = {
  /** Defines when the camera video stream is accessible in Tellucare, following the standard opening_hours format. */
  availableHours?: Maybe<Scalars['String']['output']>;
  /** As Camera.cameraProfile */
  cameraProfile?: Maybe<CameraProfile>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  deviceGroup?: Maybe<DeviceGroup>;
  /** As Camera.effectiveSettings */
  effectiveSettings?: Maybe<CameraEffectiveSettings>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientReference?: Maybe<Reference>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** As Camera.settings */
  settings: CameraSettings;
  status?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type CameraWithStatusForAlarm = {
  availableHours?: Maybe<Scalars['String']['output']>;
  /** As Camera.cameraProfile */
  cameraProfile?: Maybe<CameraProfile>;
  deviceGroup?: Maybe<DeviceGroup>;
  /** As Camera.effectiveSettings */
  effectiveSettings?: Maybe<CameraEffectiveSettings>;
  identifier: Scalars['String']['output'];
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  online?: Maybe<Scalars['Boolean']['output']>;
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  privacyModeUntil?: Maybe<Scalars['dateTime']['output']>;
  /** As Camera.settings */
  settings: CameraSettings;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Camera detection zones. Coordinates are normalized floats in [0, 1]; every polygon has exactly
 * 4 vertices. Zone names are fixed slots on the camera, so they are enums - display names are the
 * client's concern.
 */
export type CameraZones = {
  /** Empty when no bed zone is configured. */
  bed: Array<LandmarkVertex>;
  doors: Array<CameraDoor>;
  exclusionZones: Array<CameraExclusionZone>;
  safeZones: Array<CameraSafeZone>;
};

/**
 * A per-area read outcome: one slow or unreachable area must not blank the areas that answered.
 * A null payload with success: false is not "this camera has none" - message says why.
 */
export type CameraZonesResult = {
  errorCode?: Maybe<CameraConfigurationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  zones?: Maybe<CameraZones>;
};

export type CarePlan = {
  activity: Array<Maybe<CarePlanActivity>>;
  carePlanType?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['dateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<DocumentReference>>>;
  id: Scalars['ID']['output'];
  period?: Maybe<Period>;
  status: CarePlanStatus;
  subject: Reference;
  title?: Maybe<Scalars['String']['output']>;
};

export type CarePlanActivity = {
  detail: CarePlanActivityDef;
  observations?: Maybe<Array<Maybe<Observation>>>;
  outcomeReference?: Maybe<Array<Maybe<Reference>>>;
};

export type CarePlanActivityDef = {
  code?: Maybe<CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  questionnaires?: Maybe<Array<Maybe<Questionnaire>>>;
  scheduledPeriod?: Maybe<Period>;
  scheduledTiming?: Maybe<Timing>;
  status: Scalars['String']['output'];
};

export type CarePlanActivityDefInput = {
  code?: InputMaybe<CodeableConceptInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  instantiatesCanonical?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduledTiming?: InputMaybe<TimingInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanActivityInput = {
  detail: CarePlanActivityDefInput;
  outcomeReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type CarePlanInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  status?: InputMaybe<CarePlanStatus>;
  subject?: InputMaybe<ReferenceInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanMutationResponse = {
  carePlan?: Maybe<CarePlan>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CarePlanStatus {
  Active = 'active',
  Completed = 'completed',
  Draft = 'draft',
  Revoked = 'revoked',
}

export type CarePlanTemplateActivityInput = {
  detail: CarePlanActivityDefInput;
  outcomeReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type CarePlanTemplateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanTemplateActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  status?: InputMaybe<CarePlanStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanTemplateUpdateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanTemplateActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanUpdateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CareTeam = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type CepConfig = {
  after?: Maybe<Scalars['Int']['output']>;
  cancelledBy?: Maybe<Array<Scalars['String']['output']>>;
  trigger?: Maybe<Array<Scalars['String']['output']>>;
};

export type CepConfigInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  cancelledBy?: InputMaybe<Array<Scalars['String']['input']>>;
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CepEventConfig = {
  /**
   * Trigger-based CEP configuration. Fires once a trigger event has been active for
   * the configured after seconds and no cancelledBy event has arrived.
   * Contrast with timedCep: CepConfig fires when an event IS received,
   * while TimedCepConfig fires when an expected event is NOT received.
   */
  cep?: Maybe<CepConfig>;
  code: Scalars['String']['output'];
  createdAt: Scalars['dateTime']['output'];
  displayText: Scalars['String']['output'];
  generatesAlarm: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientId: Scalars['ID']['output'];
  priority: EventConfigPriority;
  schedule?: Maybe<EventConfigSchedule>;
  /**
   * Schedule-based CEP configuration. Raises an alarm when an expected observation
   * is NOT received within the configured time window.
   */
  timedCep?: Maybe<TimedCepConfig>;
  toCode?: Maybe<Scalars['String']['output']>;
  type: CepEventConfigEventType;
  updatedAt: Scalars['dateTime']['output'];
  workflow: EventConfigWorkflow;
};

export enum CepEventConfigEventType {
  ComplexEventProcessing = 'complexEventProcessing',
}

export type CepEventConfigInput = {
  /**
   * Trigger-based CEP configuration (triggers, cancelledBy, after).
   * When provided, overrides any template-derived CEP triggers for this event config.
   * See CepConfig for field semantics.
   */
  cep?: InputMaybe<CepConfigInput>;
  code: Scalars['String']['input'];
  displayText: Scalars['String']['input'];
  generatesAlarm: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  priority: EventConfigPriorityInput;
  schedule?: InputMaybe<EventConfigScheduleInput>;
  /** Schedule-based CEP configuration. Mutually exclusive in semantics with trigger-based cep. */
  timedCep?: InputMaybe<TimedCepConfigInput>;
  toCode?: InputMaybe<Scalars['String']['input']>;
  type: CepEventConfigEventType;
  workflow: EventConfigWorkflow;
};

export type CepEventConfigMutationResponse = {
  eventConfig?: Maybe<CepEventConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClientStatus = {
  browserHeight?: InputMaybe<Scalars['Int']['input']>;
  browserWidth?: InputMaybe<Scalars['Int']['input']>;
  useragent?: InputMaybe<Scalars['String']['input']>;
};

export type CmpAccount = {
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  customerGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type CmpAccountCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  customerGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CmpAccountMutationResponse = {
  cmpAccount?: Maybe<CmpAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CmpAccountUpdateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customerGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CmpChildDevice = {
  activeTimeSpan?: Maybe<CmpChildDeviceActiveTimeSpan>;
  batteryStatus?: Maybe<CmpResponseType>;
  equipmentType?: Maybe<CmpResponseType>;
  locationCode?: Maybe<CmpResponseType>;
  radioIdCode?: Maybe<Scalars['String']['output']>;
  supervisionStatus?: Maybe<CmpResponseWithDateTime>;
};

export type CmpChildDeviceActiveTimeSpan = {
  hasTimeSpan?: Maybe<Scalars['Boolean']['output']>;
  timeSpan?: Maybe<Scalars['String']['output']>;
};

export type CmpCredentialsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CmpDevice = {
  alarmCode?: Maybe<Scalars['String']['output']>;
  batteryStatus?: Maybe<CmpResponseWithDateTime>;
  children?: Maybe<Array<CmpChildDevice>>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  operationalStatus?: Maybe<CmpResponseType>;
  portalConnection?: Maybe<CmpResponseWithDateTime>;
  powerSupply?: Maybe<CmpResponseWithDateTime>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CmpResponseType = {
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CmpResponseWithDateTime = {
  name?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CodeableConcept = {
  coding?: Maybe<Array<Maybe<Coding>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptInput = {
  coding?: InputMaybe<Array<InputMaybe<CodingInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Coding = {
  code?: Maybe<Scalars['code']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['uri']['output']>;
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingInput = {
  code?: InputMaybe<Scalars['code']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['uri']['input']>;
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type Colleague = {
  /**  Full name as the shift session recorded it, absent for a session that never recorded one.  */
  name?: Maybe<Scalars['String']['output']>;
  shiftSessionPhoneNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type ColorGradient = {
  colorStops: Array<ColorStop>;
  direction: Scalars['String']['output'];
};

export type ColorGradientInput = {
  colorStops: Array<ColorStopInput>;
  direction: Scalars['String']['input'];
};

export type ColorStop = {
  color: Scalars['String']['output'];
  stopPosition: Scalars['Float']['output'];
};

export type ColorStopInput = {
  color: Scalars['String']['input'];
  stopPosition: Scalars['Float']['input'];
};

export type CombinedPatientContacts = {
  groupContacts: Array<Contact>;
  patientContacts: Array<Contact>;
};

export type Communication = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  patient?: Maybe<Patient>;
  payload?: Maybe<Array<Maybe<CommunicationPayload>>>;
  received?: Maybe<Scalars['dateTime']['output']>;
  sender?: Maybe<Reference>;
  sent?: Maybe<Scalars['dateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Reference>;
};

export type CommunicationInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subject?: InputMaybe<ReferenceOnlyInput>;
};

export type CommunicationMutationResponse = {
  communication?: Maybe<Communication>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CommunicationPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events?: Maybe<Array<Maybe<Communication>>>;
};

export type CommunicationPayload = {
  contentReference?: Maybe<Reference>;
  contentString?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<DocumentReference>;
};

export type CommunicationPayloadInput = {
  contentReference?: InputMaybe<ReferenceOnlyInput>;
  contentString?: InputMaybe<Scalars['String']['input']>;
};

export type CommunicationsMutationResponse = {
  communications: Array<Communication>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompleteAlarmInput = {
  completionOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  freeTextNote?: InputMaybe<Scalars['String']['input']>;
  journal?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
};

export type Config = {
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  configType: Scalars['String']['output'];
};

export type ConfigMutationResponse = {
  healthProviderId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Configuration = {
  hasExternalUrl?: Maybe<Scalars['Boolean']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
};

export type Contact = {
  availableHours: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  skyresponseConfig?: Maybe<ContactSkyresponseConfig>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type ContactPoint = {
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ContactPointInput = {
  system?: InputMaybe<ContactPointSystem>;
  use?: InputMaybe<ContactPointUse>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactPointSystem {
  Email = 'email',
  Fax = 'fax',
  Other = 'other',
  Pager = 'pager',
  Phone = 'phone',
  Sms = 'sms',
  Url = 'url',
}

export enum ContactPointUse {
  Home = 'home',
  Mobile = 'mobile',
  Old = 'old',
  Temp = 'temp',
  Work = 'work',
}

export type ContactSkyresponseConfig = {
  callMethod?: Maybe<Scalars['Int']['output']>;
};

export type ContactsExport = {
  name?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type ContinuousSupervisionCandidate = {
  cameras: Array<PatientSupervisionCamera>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CoordcomForwarderConfiguration = {
  customCaCertificate?: Maybe<Scalars['String']['output']>;
  inboundMrsTimeoutMs: Scalars['Int']['output'];
  localSipUser: Scalars['String']['output'];
  outboundSipOkTimeoutMs: Scalars['Int']['output'];
  relaxCertificateValidation: Scalars['Boolean']['output'];
  targetHost: Scalars['String']['output'];
  targetPort: Scalars['Int']['output'];
  tlsServerNameOverride?: Maybe<Scalars['String']['output']>;
  userAgent: Scalars['String']['output'];
};

export type CoordcomForwarderCreateInput = {
  customCaCertificate?: InputMaybe<Scalars['String']['input']>;
  inboundMrsTimeoutMs: Scalars['Int']['input'];
  localSipUser: Scalars['String']['input'];
  outboundSipOkTimeoutMs: Scalars['Int']['input'];
  relaxCertificateValidation?: InputMaybe<Scalars['Boolean']['input']>;
  targetHost: Scalars['String']['input'];
  targetPort: Scalars['Int']['input'];
  tlsServerNameOverride?: InputMaybe<Scalars['String']['input']>;
  userAgent: Scalars['String']['input'];
};

export type CoordcomForwarderUpdateInput = {
  customCaCertificate?: InputMaybe<Scalars['String']['input']>;
  inboundMrsTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  localSipUser?: InputMaybe<Scalars['String']['input']>;
  outboundSipOkTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  relaxCertificateValidation?: InputMaybe<Scalars['Boolean']['input']>;
  targetHost?: InputMaybe<Scalars['String']['input']>;
  targetPort?: InputMaybe<Scalars['Int']['input']>;
  tlsServerNameOverride?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetInput = {
  filename: Scalars['String']['input'];
  name: Scalars['String']['input'];
  resourceType: AssetResourceType;
};

export type CreateAssetResponse = {
  asset?: Maybe<Asset>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCameraInput = {
  deviceGroupId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  macAddress: Scalars['String']['input'];
};

export type CreateCameraPtzProfileInput = {
  name: Scalars['String']['input'];
  pan: Scalars['Float']['input'];
  tilt: Scalars['Float']['input'];
  zoom: Scalars['Float']['input'];
};

export type CreateCareTeamInput = {
  name: Scalars['String']['input'];
  telecom: Array<InputMaybe<ContactPointInput>>;
};

export type CreateContactInput = {
  availableHours: Scalars['String']['input'];
  name: Scalars['String']['input'];
  telecom: Array<ContactPointInput>;
};

export type CreateDialoggUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  externalIdentities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  externalUserIds?: InputMaybe<Array<ExternalHumanIdInput>>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordEnabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type CreateExternalAccessInput = {
  allowedAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  forwarderId?: InputMaybe<Scalars['ID']['input']>;
  ipRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateFhirDeviceInput = {
  deviceGroupId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};

export type CreateNextOfKinInput = {
  active: Scalars['Boolean']['input'];
  address?: InputMaybe<Array<AddressInput>>;
  name?: InputMaybe<HumanNameInput>;
  notifyNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  relationship: Scalars['String']['input'];
  telecom?: InputMaybe<Array<ContactPointInput>>;
};

export type CreatePatientInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  addressNote?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['date']['input']>;
  dialoggUser?: InputMaybe<CreateDialoggUserInput>;
  externalPatientIds?: InputMaybe<Array<ExternalHumanIdInput>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  keyCode?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<LanguageInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<HumanNameInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationInput>;
  secretAddress?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type CreateUserGroupInput = {
  name: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skyresponseConfig?: InputMaybe<SkyresponseConfigInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserManualInput = {
  applications?: InputMaybe<UserManualApplicationsInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  localeEntries: Array<UserManualLocaleEntryInput>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateWhiteLabelingTemplateInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  menuBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  menuBackgroundGradient?: InputMaybe<ColorGradientInput>;
  menuBackgroundImageId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primaryButtonGradient?: InputMaybe<ColorGradientInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryButtonGradient?: InputMaybe<ColorGradientInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleLogoId?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  accounts: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CustomerInput = {
  name: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CustomerLess = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerMutationResponse = {
  customer?: Maybe<Customer>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DailyAuditLogStatsPaginated = {
  count: Scalars['Int']['output'];
  stats: Array<AuditStats>;
};

export type DailyDeviceStats = {
  active?: Maybe<Scalars['Int']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  online?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  technicalAlarmEvents?: Maybe<Scalars['Int']['output']>;
  technicalAlarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DailyDeviceStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyDeviceStats>;
};

export type DailyDeviceStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DailyPatientStats = {
  activePatients?: Maybe<Scalars['Int']['output']>;
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  deviceObservations?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  inactivePatients?: Maybe<Scalars['Int']['output']>;
  manualObservations?: Maybe<Scalars['Int']['output']>;
  notifyEnabledNextOfKins?: Maybe<Scalars['Int']['output']>;
  questionnaireResponses?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DailyPatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyPatientStats>;
};

export type DailyPatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DailyUserStats = {
  dialoggUsers: Scalars['Int']['output'];
  dialoggUsersActive: Scalars['Int']['output'];
  dialoggUsersDefaultLogin: Scalars['Int']['output'];
  dialoggUsersExternalLogin: Scalars['Int']['output'];
  dialoggUsersLoginErrors: Scalars['Int']['output'];
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  healthPersonnelActive: Scalars['Int']['output'];
  healthPersonnelDefaultLogin: Scalars['Int']['output'];
  healthPersonnelExternalLogin: Scalars['Int']['output'];
  healthPersonnelLoginErrors: Scalars['Int']['output'];
  healthPersonnelUsers: Scalars['Int']['output'];
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
};

export type DailyUserStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyUserStats>;
};

export type DailyUserStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DatabaseSchemaMigration = {
  databaseName: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  healthProviderName: Scalars['String']['output'];
  report?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DatabaseSchemaSyncResponse = {
  databaseName: Scalars['String']['output'];
  healthProviderName: Scalars['String']['output'];
  isSynced?: Maybe<Scalars['Boolean']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DayNightManagementStatus = {
  cutFilterMode: Scalars['String']['output'];
  manualIrOverriden: Scalars['Boolean']['output'];
  shiftLevel: Scalars['String']['output'];
};

export enum DayOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed',
}

export type DefaultRoleDefinitionCreateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display: Array<InputMaybe<LocaleDefinitionInput>>;
  id: Scalars['String']['input'];
  isDefaultType: Scalars['String']['input'];
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultRoleDefinitionUpdateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Array<InputMaybe<LocaleDefinitionInput>>>;
  id: Scalars['String']['input'];
  isDefaultType?: InputMaybe<Scalars['String']['input']>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultTemplates = {
  accountTemplates: Array<SimpleAlarmTemplate>;
  camera: Array<SimpleAlarmTemplate>;
  delegation: Array<SimpleAlarmTemplate>;
  forwarding: Array<SimpleAlarmTemplate>;
  measurement: Array<SimpleAlarmTemplate>;
  novo: Array<SimpleAlarmTemplate>;
  safemate: Array<SimpleAlarmTemplate>;
  videoMeeting: Array<SimpleAlarmTemplate>;
};

export type DetectedObject = {
  boundingBox: BoundingBox;
  score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Device = {
  deviceGroup?: Maybe<DeviceGroup>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<CodeableConcept>;
  userFriendlyName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceExport = {
  identifier?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceGeofence = {
  name?: Maybe<Scalars['String']['output']>;
  polygon?: Maybe<Scalars['Boolean']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  vertices?: Maybe<Array<Maybe<DeviceGeofenceVertex>>>;
};

export type DeviceGeofenceVertex = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type DeviceGroup = {
  enableFurnitureDetection?: Maybe<Scalars['Boolean']['output']>;
  furnitureDetectionPeriodSec?: Maybe<Scalars['Int']['output']>;
  hasCmpCredentials?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DeviceGroupCreateInput = {
  enableFurnitureDetection?: InputMaybe<Scalars['Boolean']['input']>;
  furnitureDetectionPeriodSec?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type DeviceGroupMutationResponse = {
  deviceGroup?: Maybe<DeviceGroup>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeviceGroupUpdateInput = {
  enableFurnitureDetection?: InputMaybe<Scalars['Boolean']['input']>;
  furnitureDetectionPeriodSec?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceInList = {
  childDeviceIds?: Maybe<Array<Scalars['ID']['output']>>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceName = {
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DeviceProperty = {
  callbackPhoneNumber?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type DevicePropertyInput = {
  callbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceStats = {
  deviceType?: Maybe<Scalars['String']['output']>;
  technicalAlarmEvents?: Maybe<Scalars['Int']['output']>;
  technicalAlarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DeviceStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DeviceStats>;
};

export type DeviceStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DeviceStatus = {
  connected?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
};

export type DhvSubscription = ServiceSubscription & {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
  settings: DigitalHomeVisitsSettings;
};

export type DialoggUser = {
  appDeviceIds?: Maybe<Array<Scalars['ID']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  externalUserIds?: Maybe<Array<ExternalHumanId>>;
  firstName?: Maybe<Scalars['String']['output']>;
  ipRestrictions?: Maybe<Array<Scalars['String']['output']>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  onBehalf?: Maybe<OnBehalf>;
  otpStatus?: Maybe<Scalars['String']['output']>;
  passwordEnabled?: Maybe<Scalars['Boolean']['output']>;
  passwordStatus?: Maybe<Scalars['String']['output']>;
  picturePermission?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  smsOtpPhoneNumber?: Maybe<Scalars['String']['output']>;
  smsOtpStatus?: Maybe<Scalars['String']['output']>;
  timeLimitedAccess?: Maybe<Period>;
  username: Scalars['ID']['output'];
};

export type DialoggUserMutationResponse = {
  dialoggUser?: Maybe<DialoggUser>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DigitalHomeVisitsSettings = {
  autoStart: AutoStartSettings;
  playRingtoneOnStart: Scalars['Boolean']['output'];
  requestVideoMeetings: Scalars['Boolean']['output'];
  showParticipantVideoMeetingToolbar: Scalars['Boolean']['output'];
};

export type DigitalHomeVisitsSettingsInput = {
  autoStart: AutoStartSettingsInput;
  playRingtoneOnStart: Scalars['Boolean']['input'];
  requestVideoMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  showParticipantVideoMeetingToolbar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DirectRoutingDetails = {
  escalationStatus?: Maybe<Scalars['String']['output']>;
  hasActiveCall: Scalars['Boolean']['output'];
};

export type DisplaySummary = {
  computedTaskPriority?: Maybe<QuestionnairePrioritiesCode>;
  priorities?: Maybe<QuestionnairePriorities>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type DocumentReference = {
  content?: Maybe<Array<Maybe<DocumentReferenceContent>>>;
  context?: Maybe<DocumentReferenceContext>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Reference>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Reference>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReferenceContent = {
  attachment?: Maybe<Attachment>;
  documentReferenceId?: Maybe<Scalars['ID']['output']>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReferenceContentInput = {
  attachment?: InputMaybe<AttachmentInput>;
};

export type DocumentReferenceContext = {
  carePlan?: Maybe<CarePlan>;
  related?: Maybe<Array<Maybe<Reference>>>;
};

export type DocumentReferenceContextInput = {
  related?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type DocumentReferenceInput = {
  content?: InputMaybe<Array<InputMaybe<DocumentReferenceContentInput>>>;
  context?: InputMaybe<DocumentReferenceContextInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<ReferenceInput>;
};

export type DocumentReferenceMutationResult = {
  documentReference?: Maybe<DocumentReference>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EmbeddedLinkOptions = {
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  expireAfter?: InputMaybe<Scalars['Int']['input']>;
  hideControls?: InputMaybe<Scalars['Boolean']['input']>;
  hideStatusbar?: InputMaybe<Scalars['Boolean']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Equipment = {
  createdAt: Scalars['dateTime']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  hasExternalUrl?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  topPriorityAlarm?: Maybe<EquipmentAlarm>;
  type?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type EquipmentAlarm = {
  priority?: Maybe<Scalars['String']['output']>;
};

export type EventConfigDeleteResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum EventConfigPriority {
  Asap = 'asap',
  Routine = 'routine',
  Urgent = 'urgent',
}

export enum EventConfigPriorityInput {
  Asap = 'asap',
  Routine = 'routine',
  Urgent = 'urgent',
}

export type EventConfigSchedule = {
  repeat: EventConfigScheduleRepeat;
};

export type EventConfigScheduleInput = {
  repeat: EventConfigScheduleRepeatInput;
};

export type EventConfigScheduleRepeat = {
  dayOfWeek?: Maybe<Array<DayOfWeek>>;
  timeOfDay: Array<Scalars['String']['output']>;
};

export type EventConfigScheduleRepeatInput = {
  dayOfWeek?: InputMaybe<Array<DayOfWeek>>;
  timeOfDay: Array<Scalars['String']['input']>;
};

export enum EventConfigWorkflow {
  Patient = 'patient',
  Technical = 'technical',
}

export type EventForwardingLog = {
  createdAt: Scalars['dateTime']['output'];
  escalationMethod?: Maybe<ForwardingEscalationMethod>;
  escalationStatus?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  forwardingStatus: Scalars['String']['output'];
  integrationConfigId: Scalars['String']['output'];
  patientExternalId: Scalars['String']['output'];
};

export type Extension = {
  ValueId?: Maybe<Scalars['ID']['output']>;
  extension?: Maybe<Array<Extension>>;
  url?: Maybe<Scalars['String']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type ExtensionInput = {
  ValueId?: InputMaybe<Scalars['ID']['input']>;
  extension?: InputMaybe<Array<ExtensionInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalAccess = {
  allowedAccess?: Maybe<Array<Scalars['String']['output']>>;
  forwarderId?: Maybe<Scalars['ID']['output']>;
  healthProviderName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipRestrictions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patientGroupIds: Array<Scalars['String']['output']>;
  patientGroups?: Maybe<Array<PatientGroupLess>>;
};

export type ExternalAccessCreateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalAccessCredentials = {
  apiEndpoint: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type ExternalAccessEndpoints = {
  externalAccessName: Scalars['String']['output'];
  externalAccessNameToShow: Scalars['String']['output'];
};

export type ExternalAccessLess = {
  healthProviderName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  patientGroupIds: Array<Scalars['String']['output']>;
  scim?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalAccessNames = {
  externalAccessName: Scalars['String']['output'];
  externalAccessNameToShow: Scalars['String']['output'];
};

export type ExternalAccessUpdateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExternalHumanId = {
  externalHumanIdType: ExternalHumanIdType;
  externalId: Scalars['String']['output'];
};

export type ExternalHumanIdInput = {
  externalHumanIdTypeId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};

export type ExternalHumanIdType = {
  fhirIdentifier: Identifier;
  globalSearchAllowed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  localeEntries: Array<LocaleEntry>;
  use: ExternalHumanIdTypeUse;
  validationRegexp?: Maybe<Scalars['String']['output']>;
};

export type ExternalHumanIdTypeCreateInput = {
  fhirIdentifier: IdentifierInput;
  globalSearchAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  localeEntries: Array<LocaleEntryInput>;
  use: ExternalHumanIdTypeUseInput;
  validationRegexp?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalHumanIdTypeMutationResponse = {
  externalHumanIdType?: Maybe<ExternalHumanIdType>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalHumanIdTypePatientUse = {
  applicable?: Maybe<Scalars['Boolean']['output']>;
  canAddToFhirPatientOnly?: Maybe<Scalars['Boolean']['output']>;
  immutable?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalHumanIdTypePatientUseInput = {
  applicable: Scalars['Boolean']['input'];
  canAddToFhirPatientOnly: Scalars['Boolean']['input'];
};

export type ExternalHumanIdTypePersonnelUse = {
  applicable?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalHumanIdTypePersonnelUseInput = {
  applicable: Scalars['Boolean']['input'];
};

export type ExternalHumanIdTypeUpdateInput = {
  globalSearchAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  localeEntries?: InputMaybe<Array<LocaleEntryInput>>;
  use?: InputMaybe<ExternalHumanIdTypeUseInput>;
  validationRegexp?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalHumanIdTypeUse = {
  patientUse?: Maybe<ExternalHumanIdTypePatientUse>;
  personnelUse?: Maybe<ExternalHumanIdTypePersonnelUse>;
};

export type ExternalHumanIdTypeUseInput = {
  patientUse: ExternalHumanIdTypePatientUseInput;
  personnelUse: ExternalHumanIdTypePersonnelUseInput;
};

export type ExternalIdExport = {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExternalIdRequest = {
  externalHumanIdType: Scalars['String']['output'];
  requested: Scalars['Boolean']['output'];
};

export type ExternalIdentity = {
  externalIdentityUsername: Scalars['ID']['output'];
  provider: Scalars['ID']['output'];
};

export type ExternalIdentityInput = {
  externalIdentityUsername: Scalars['ID']['input'];
  provider: Scalars['ID']['input'];
};

export type ExternalIdentityProvider = {
  canSync: Scalars['Boolean']['output'];
  client: Array<LocaleEntry>;
  display: Array<LocaleEntry>;
  externalHumanIdType?: Maybe<ExternalHumanIdType>;
  provider: Scalars['String']['output'];
  tenant: Array<LocaleEntry>;
};

export type ExternalIdentityProviderAzureForHealthProviderCreateInput = {
  alias: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type ExternalIdentityProviderForHealthProvider = {
  alias: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalIdentityProvider: ExternalIdentityProvider;
  healthProviderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patientRealm: Scalars['Boolean']['output'];
  prio?: Maybe<Scalars['String']['output']>;
  support: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type ExternalIdentityProviderForHealthProviderCreateInput = {
  alias: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  patientRealm: Scalars['Boolean']['input'];
  prio?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  support?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};

export type ExternalIdentityProviderForHealthProviderMutationResponse = {
  externalIdentityProviderForHealthProvider?: Maybe<ExternalIdentityProviderForHealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalIdentityProviderForHealthProviderUpdateInput = {
  alias: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  prio?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalIdentityProviderRedirector = {
  alias?: Maybe<Scalars['String']['output']>;
  config?: Maybe<ExternalIdentityProviderRedirectorConfig>;
  id?: Maybe<Scalars['String']['output']>;
  isPatientRealm?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalIdentityProviderRedirectorConfig = {
  defaultProvider?: Maybe<Scalars['String']['output']>;
};

export enum FeatureFlag {
  Beta = 'beta',
  ContinuousSupervision = 'continuousSupervision',
  DataAnalytics = 'dataAnalytics',
  HasAlmaIntegration = 'hasAlmaIntegration',
  HasAscomIntegration = 'hasAscomIntegration',
  HasBestIntegration = 'hasBestIntegration',
  HasCmp = 'hasCmp',
  HasCoordcomIntegration = 'hasCoordcomIntegration',
  HasEntraIdProvisioning = 'hasEntraIdProvisioning',
  HasEntraIdSso = 'hasEntraIdSso',
  HasIpOmsorgIntegration = 'hasIpOmsorgIntegration',
  HasPhoniroCloudIntegration = 'hasPhoniroCloudIntegration',
  HasSipIntegration = 'hasSipIntegration',
  HasSkyresponsePartnerIntegration = 'hasSkyresponsePartnerIntegration',
  HasTietoLmoIntegration = 'hasTietoLmoIntegration',
  HasTrends = 'hasTrends',
  HasUmo2GIntegration = 'hasUmo2GIntegration',
  JoinNhnMeeting = 'joinNhnMeeting',
  SelfTreatmentPlan = 'selfTreatmentPlan',
  SendNotificationToNextOfKin = 'sendNotificationToNextOfKin',
}

export type FeatureFlagMutationResponse = {
  /** The camera profiles that block switching the feature off. Set only when that is why success is false. */
  blockingCameraProfiles?: Maybe<Array<CameraProfile>>;
  healthProvider?: Maybe<HealthProvider>;
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  wasEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureFlagToggleResponse = {
  /** The camera profiles that block switching the feature off. Set only when that is why success is false. */
  blockingCameraProfiles?: Maybe<Array<CameraProfile>>;
  features: AccountFeatures;
  flag: FeatureFlag;
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  wasEnabled: Scalars['Boolean']['output'];
};

export type FeatureFlags = {
  alarmStreaming?: Maybe<Scalars['Boolean']['output']>;
  beta?: Maybe<Scalars['Boolean']['output']>;
  continuousSupervision?: Maybe<Scalars['Boolean']['output']>;
  dataAnalytics?: Maybe<Scalars['Boolean']['output']>;
  hasAlmaIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasAscomIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasBestIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasCmp?: Maybe<Scalars['Boolean']['output']>;
  hasCoordcomIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasDemoAnonymization?: Maybe<Scalars['Boolean']['output']>;
  hasEntraIdProvisioning?: Maybe<Scalars['Boolean']['output']>;
  hasEntraIdSso?: Maybe<Scalars['Boolean']['output']>;
  hasFurnitureDetection?: Maybe<Scalars['Boolean']['output']>;
  hasIpOmsorgIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasPhoniroCloudIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasSipIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponsePartnerIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasTietoLmoIntegration?: Maybe<Scalars['Boolean']['output']>;
  hasTrends?: Maybe<Scalars['Boolean']['output']>;
  hasUmo2GIntegration?: Maybe<Scalars['Boolean']['output']>;
  joinNhnMeeting?: Maybe<Scalars['Boolean']['output']>;
  newSupervisionUserTabs?: Maybe<Scalars['Boolean']['output']>;
  selfTreatmentPlan?: Maybe<Scalars['Boolean']['output']>;
  sendNotificationToNextOfKin?: Maybe<Scalars['Boolean']['output']>;
};

export type FilteredCameraEvents = {
  counter: Scalars['Int']['output'];
  resetAt?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
  type: Scalars['String']['output'];
};

export type FlowAuditLogReference = {
  auditEventId: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type FlowStatus = {
  completed: Scalars['Boolean']['output'];
  currentStep: Scalars['Int']['output'];
  flowName: Scalars['String']['output'];
  hasFailed?: Maybe<Scalars['Boolean']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  logs: Array<FlowStatusLogEntry>;
  numberOfSteps: Scalars['Int']['output'];
  paused?: Maybe<Scalars['Boolean']['output']>;
  stepStatuses?: Maybe<Array<StepStatus>>;
  willBeCleanedUpAt?: Maybe<Scalars['dateTime']['output']>;
};

export type FlowStatusLogEntry = {
  attempts: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  localePath: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stepName: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ForwarderAlarmRoute = {
  forwarderConfigId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incomingTemplate: SimpleAlarmTemplate;
  outgoingTemplate: SimpleAlarmTemplate;
};

export enum ForwarderConfigType {
  AlmaForwarderConfig = 'AlmaForwarderConfig',
  AscomForwarderConfig = 'AscomForwarderConfig',
  BestForwarderConfig = 'BestForwarderConfig',
  CoordcomForwarderConfig = 'CoordcomForwarderConfig',
  IpOmsorgConfig = 'IpOmsorgConfig',
  PhoniroCloudForwarderConfig = 'PhoniroCloudForwarderConfig',
  SipConfig = 'SipConfig',
  SkyresponseForwarderConfig = 'SkyresponseForwarderConfig',
  SkyresponsePartnerForwarderConfig = 'SkyresponsePartnerForwarderConfig',
  TietoLmoConfig = 'TietoLmoConfig',
  Umo2gForwarderConfig = 'Umo2gForwarderConfig',
}

export type ForwarderCreateInput = {
  almaConfig?: InputMaybe<AlmaForwarderCreateInput>;
  ascomConfig?: InputMaybe<AscomForwarderCreateInput>;
  bestConfig?: InputMaybe<BestForwarderCreateInput>;
  coordcomConfig?: InputMaybe<CoordcomForwarderCreateInput>;
  phoniroConfig?: InputMaybe<PhoniroCloudForwarderCreateInput>;
  sipConfig?: InputMaybe<SipForwarderCreateInput>;
  skyresponseConfig?: InputMaybe<SkyresponseForwarderCreateInput>;
  skyresponsePartnerConfig?: InputMaybe<SkyresponsePartnerForwarderCreateInput>;
  umo2gConfig?: InputMaybe<Umo2gForwarderCreateInput>;
};

export type ForwarderErrorHandling = {
  createPatientAlarmOnFail: Scalars['Boolean']['output'];
  escalationEmailAddresses?: Maybe<Array<Scalars['String']['output']>>;
  escalationPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  sendEmailOnFail: Scalars['Boolean']['output'];
  sendSmsOnFail: Scalars['Boolean']['output'];
};

export type ForwarderErrorHandlingInput = {
  createPatientAlarmOnFail?: InputMaybe<Scalars['Boolean']['input']>;
  escalationEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  escalationPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sendEmailOnFail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSmsOnFail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForwarderRouteInput = {
  incomingTemplate: Scalars['String']['input'];
  outgoingTemplate: Scalars['String']['input'];
};

export type ForwarderUpdateInput = {
  almaConfig?: InputMaybe<AlmaForwarderUpdateInput>;
  ascomConfig?: InputMaybe<AscomForwarderUpdateInput>;
  bestConfig?: InputMaybe<BestForwarderUpdateInput>;
  coordcomConfig?: InputMaybe<CoordcomForwarderUpdateInput>;
  phoniroConfig?: InputMaybe<PhoniroCloudForwarderUpdateInput>;
  sipConfig?: InputMaybe<SipForwarderUpdateInput>;
  skyresponseConfig?: InputMaybe<SkyresponseForwarderUpdateInput>;
  skyresponsePartnerConfig?: InputMaybe<SkyresponsePartnerForwarderUpdateInput>;
  umo2gConfig?: InputMaybe<Umo2gForwarderUpdateInput>;
};

export enum ForwardingEscalationMethod {
  Email = 'email',
  PatientAlarm = 'patientAlarm',
  Sms = 'sms',
}

export type GenericMigration = {
  healthProviderName: Scalars['String']['output'];
  report?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenericMutationResponse = {
  id?: Maybe<Scalars['String']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenericTagConfig = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GenericTagConfigCreateInput = {
  displayName: Scalars['String']['input'];
};

export type GetExternalDevicesResponse = {
  hasSafemateIntegration: Scalars['Boolean']['output'];
  safemateDevices: Array<SafemateProDevice>;
};

export type GlobalStats = {
  allPatientStats: AllPatientStats;
  cameras: Scalars['Int']['output'];
  healthProvider: Scalars['String']['output'];
  notifyEnabledNextOfKins: Scalars['Int']['output'];
  novo: Scalars['Int']['output'];
  personnel: Scalars['Int']['output'];
};

export type Goal = {
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type GoalInput = {
  goal: Scalars['String']['input'];
};

export type GooglemapsAccount = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  apiToken?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type GooglemapsAccountCreateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GooglemapsAccountMutationResponse = {
  googlemapsAccount?: Maybe<GooglemapsAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GooglemapsAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GpsLocation = {
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']['output']>;
  gpsTimestamp?: Maybe<Scalars['dateTime']['output']>;
  position?: Maybe<GpsPosition>;
  receivedTimestamp?: Maybe<Scalars['dateTime']['output']>;
  type?: Maybe<GpsType>;
};

export type GpsPosition = {
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GpsPositionInput = {
  altitude?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GpsType = {
  code: Scalars['String']['output'];
  /**  Human-readable label for the code. Absent when the source coding carries none.  */
  display?: Maybe<Scalars['String']['output']>;
};

export type GraphQlGenericMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HealthProvider = {
  customer?: Maybe<CustomerLess>;
  defaultApplication?: Maybe<Scalars['String']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  dialoggCode?: Maybe<Scalars['String']['output']>;
  disablePasswordForDialoggUsers?: Maybe<Scalars['Boolean']['output']>;
  disablePasswordForUsers?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  externalHumanIdTypeIdForDialoggUser?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForPatient?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForUser?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureFlags>;
  googlemapsAccount?: Maybe<AccountLess>;
  hasDhv?: Maybe<Scalars['Boolean']['output']>;
  hasResponse?: Maybe<Scalars['Boolean']['output']>;
  hasRpm?: Maybe<Scalars['Boolean']['output']>;
  hasSupervision?: Maybe<Scalars['Boolean']['output']>;
  hasSupportTeam?: Maybe<Scalars['Boolean']['output']>;
  markedForDeletion: Scalars['Boolean']['output'];
  markedForDeletionAt?: Maybe<Scalars['dateTime']['output']>;
  morpheanAccount?: Maybe<AccountLess>;
  name: Scalars['ID']['output'];
  patientRealm?: Maybe<Scalars['String']['output']>;
  patientSessionLifespan?: Maybe<Scalars['Int']['output']>;
  safemateAccount?: Maybe<AccountLess>;
  sendGridAccount?: Maybe<AccountLess>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<HealthProviderSettings>;
  skyresponseAccount?: Maybe<AccountLess>;
  tcifAccount?: Maybe<AccountLess>;
  timeZone?: Maybe<Scalars['String']['output']>;
  twilioAccount?: Maybe<AccountLess>;
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  userSessionLifespan?: Maybe<Scalars['Int']['output']>;
  videonorAccount?: Maybe<AccountLess>;
};

export type HealthProviderAuthOptions = {
  externalIdP?: Maybe<Array<IdentityProvider>>;
  ipRestriction?: Maybe<Scalars['Boolean']['output']>;
  resetPasswordAllowed?: Maybe<Scalars['Boolean']['output']>;
  timeLimitedAccess?: Maybe<Scalars['Boolean']['output']>;
  twoFactorAppRequired?: Maybe<Scalars['Boolean']['output']>;
  twoFactorSms?: Maybe<Scalars['Boolean']['output']>;
};

/** The long running health provider flows whose stored state an operator can reset. */
export enum HealthProviderFlow {
  DeleteHealthProvider = 'deleteHealthProvider',
  MarkHealthProviderAsDeleted = 'markHealthProviderAsDeleted',
  RestoreHealthProviderMarkedForDeletion = 'restoreHealthProviderMarkedForDeletion',
}

export type HealthProviderInput = {
  autoCreatedSupportUserRoleDefinitionId?: InputMaybe<Scalars['String']['input']>;
  defaultApplication?: InputMaybe<Scalars['String']['input']>;
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  defaultRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dialoggCode?: InputMaybe<Scalars['String']['input']>;
  disablePasswordForDialoggUsers?: InputMaybe<Scalars['Boolean']['input']>;
  disablePasswordForUsers?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  externalHumanIdTypeIdForDialoggUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForPatient?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDhv?: InputMaybe<Scalars['Boolean']['input']>;
  hasRpm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportTeam?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['ID']['input'];
  skyresponseAccountId?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  topLevelRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  usage: Scalars['String']['input'];
};

export type HealthProviderLess = {
  customerName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureFlags>;
  hasDhv: Scalars['Boolean']['output'];
  hasResponse: Scalars['Boolean']['output'];
  hasRpm: Scalars['Boolean']['output'];
  hasSupervision: Scalars['Boolean']['output'];
  hasSupportTeam: Scalars['Boolean']['output'];
  name: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
};

export type HealthProviderMutationResponse = {
  healthProvider?: Maybe<HealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HealthProviderSettings = {
  externalHumanIdTypes?: Maybe<Array<ExternalHumanIdType>>;
  patientAuth?: Maybe<HealthProviderAuthOptions>;
  userAuth?: Maybe<HealthProviderAuthOptions>;
};

export type HealthProviderUpdateInput = {
  defaultApplication?: InputMaybe<Scalars['String']['input']>;
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  dialoggCode?: InputMaybe<Scalars['String']['input']>;
  disablePasswordForDialoggUsers?: InputMaybe<Scalars['Boolean']['input']>;
  disablePasswordForUsers?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForDialoggUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForPatient?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForUser?: InputMaybe<Scalars['String']['input']>;
  hasDhv?: InputMaybe<Scalars['Boolean']['input']>;
  hasRpm?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  skyresponseAccountId?: InputMaybe<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['String']['input']>;
};

export type HelseIdAccount = {
  accountDisplayName: Scalars['String']['output'];
  credentials?: Maybe<HelseIdCredentials>;
  id: Scalars['ID']['output'];
  organizationNumber: Scalars['String']['output'];
};

export type HelseIdAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  helseIdCredentials: HelseIdCredentialsInput;
  organizationNumber: Scalars['String']['input'];
};

export type HelseIdAccountMutationResponse = {
  helseIdAccount?: Maybe<HelseIdAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HelseIdAccountUpdateInput = {
  accountDisplayName: Scalars['String']['input'];
  authority: Scalars['String']['input'];
  organizationNumber: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type HelseIdCredentials = {
  authority: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  grantTypes: Array<Scalars['String']['output']>;
  maskedPrivateJwk: Scalars['String']['output'];
  maskedRsaPrivateKey: Scalars['String']['output'];
  rsaKeyExpiryDate: Scalars['dateTime']['output'];
  rsaKeySizeBits: Scalars['Int']['output'];
  scopes: Array<Scalars['String']['output']>;
  secretType: Scalars['String']['output'];
};

export type HelseIdCredentialsInput = {
  authority: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  grantTypes: Array<Scalars['String']['input']>;
  privateJwk: Scalars['String']['input'];
  rsaKeyExpiryDate: Scalars['String']['input'];
  rsaKeySizeBits: Scalars['Int']['input'];
  rsaPrivateKey?: InputMaybe<Scalars['String']['input']>;
  scopes: Array<Scalars['String']['input']>;
  secretType: Scalars['String']['input'];
};

export type HourlyPatientStats = {
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  deviceObservations?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  manualObservations?: Maybe<Scalars['Int']['output']>;
  openAlarms?: Maybe<Scalars['Int']['output']>;
  openTasks?: Maybe<Scalars['Int']['output']>;
  patientGroupId?: Maybe<Scalars['String']['output']>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  questionnaireResponses?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  subscribedResponders?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type HourlyPatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<HourlyPatientStats>;
};

export type HourlyPatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type HourlyUserStats = {
  dialoggUsersExternalLoginCount: Scalars['Int']['output'];
  dialoggUsersLoginCount: Scalars['Int']['output'];
  dialoggUsersLoginErrorCount: Scalars['Int']['output'];
  dialoggUserskeycloakLoginCount: Scalars['Int']['output'];
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  externalLoginCount: Scalars['Int']['output'];
  keycloakLoginCount: Scalars['Int']['output'];
  loginCount: Scalars['Int']['output'];
  loginErrorCount: Scalars['Int']['output'];
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
};

export type HourlyUserStatsPaginated = {
  count: Scalars['Int']['output'];
  stats: Array<HourlyUserStats>;
};

export type HpTaskAndPatientTasks = {
  patientTasks: Array<Maybe<Task>>;
  task: Task;
};

export type HumanName = {
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HumanNameInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  given?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Identifier = {
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
  use?: Maybe<IdentifierUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IdentifierInput = {
  system?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CodeableConceptInput>;
  use?: InputMaybe<IdentifierUse>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentifierUse {
  Official = 'official',
  Secondary = 'secondary',
  Usual = 'usual',
}

export type IdentityProvider = {
  alias?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
  usernamePolicy?: Maybe<Scalars['String']['output']>;
};

export enum ImageQuality {
  Bad = 'BAD',
  Badnight = 'BADNIGHT',
  Good = 'GOOD',
  Other = 'OTHER',
}

export type ImportAlarmTemplatesFromDefaultResponse = {
  importedTemplates: Array<ImportTemplateResponse>;
  success: Scalars['Boolean']['output'];
};

export type ImportDevicesInput = {
  devices: Array<WelfareDeviceCreateInput>;
};

export type ImportDevicesResponse = {
  devices: Array<WelfareDevice>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportTemplateResponse = {
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InconsistentHealthProviderReport = {
  healthProviderRealmName?: Maybe<Scalars['String']['output']>;
  patientRealmName?: Maybe<Scalars['String']['output']>;
  registryHealthProviderName?: Maybe<Scalars['String']['output']>;
};

export type InconsistentHealthProviderReportInput = {
  healthProviderRealmName?: InputMaybe<Scalars['String']['input']>;
  patientRealmName?: InputMaybe<Scalars['String']['input']>;
  registryHealthProviderName?: InputMaybe<Scalars['String']['input']>;
};

export type InputValidationResult = {
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type Integration = {
  almaConfig?: Maybe<AlmaForwarderConfiguration>;
  ascomConfig?: Maybe<AscomForwarderConfiguration>;
  availableExternalAccessEndpoints?: Maybe<Array<IntegrationExternalAccessEndpoint>>;
  bestConfig?: Maybe<BestForwarderConfiguration>;
  coordcomConfig?: Maybe<CoordcomForwarderConfiguration>;
  displayName?: Maybe<Scalars['String']['output']>;
  errorHandling?: Maybe<ForwarderErrorHandling>;
  externalAccess?: Maybe<ExternalAccess>;
  id: Scalars['ID']['output'];
  idMappingStrategy?: Maybe<Scalars['String']['output']>;
  patientGroups?: Maybe<Array<PatientGroupLess>>;
  phoniroConfig?: Maybe<PhoniroCloudForwarderConfiguration>;
  sipConfig?: Maybe<SipForwarderConfiguration>;
  skyresponseConfig?: Maybe<SkyresponseForwarderConfiguration>;
  skyresponsePartnerConfig?: Maybe<SkyresponsePartnerForwarderConfiguration>;
  type: ForwarderConfigType;
  umo2gConfig?: Maybe<Umo2gForwarderConfiguration>;
};

export type IntegrationConfigLess = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type IntegrationConfigValidationResult = {
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IntegrationCreateInput = {
  displayName: Scalars['String']['input'];
  idMappingStrategy: Scalars['String']['input'];
  type: ForwarderConfigType;
};

export type IntegrationExternalAccessEndpoint = {
  default: Scalars['Boolean']['output'];
  endpoint: Scalars['String']['output'];
};

export type IntegrationUpdateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  idMappingStrategy?: InputMaybe<Scalars['String']['input']>;
};

export type IntensityMeasurement = {
  intensity: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type JournalConfigForPatient = {
  remotePatientMonitoring: RemotePatientMonitoringConfigForPatient;
  remoteSupervision: RemoteSupervisionConfigForPatient;
};

export type JournalConfigForUserGroup = {
  forUserGroupId: Scalars['ID']['output'];
  inheritedFromUserGroup?: Maybe<Scalars['ID']['output']>;
  monitoringEmailAddresses: Array<Scalars['String']['output']>;
  read: JournalConfigRead;
  remotePatientMonitoring: JournalConfigRemotePatientMonitoring;
  remoteSupervision: JournalConfigRemoteSupervision;
  vkpAccountId: Scalars['ID']['output'];
};

export type JournalConfigForUserGroupInput = {
  monitoringEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  read?: InputMaybe<JournalConfigReadInput>;
  remotePatientMonitoring?: InputMaybe<JournalConfigRemotePatientMonitoringInput>;
  remoteSupervision?: InputMaybe<JournalConfigRemoteSupervisionInput>;
  vkpAccountId: Scalars['ID']['input'];
};

export type JournalConfigMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  journalConfigForUserGroup?: Maybe<JournalConfigForUserGroup>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JournalConfigRead = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  features?: Maybe<JournalConfigReadFeatures>;
};

export type JournalConfigReadFeatures = {
  hasCreatePatientFromVkp: Scalars['Boolean']['output'];
  responseCenter: JournalConfigResponseCenterFeatures;
};

export type JournalConfigReadFeaturesInput = {
  hasCreatePatientFromVkp: Scalars['Boolean']['input'];
  responseCenter: JournalConfigResponseCenterFeaturesInput;
};

export type JournalConfigReadInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  features?: InputMaybe<JournalConfigReadFeaturesInput>;
};

export type JournalConfigRemotePatientMonitoring = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  isLabModuleEnabled?: Maybe<Scalars['Boolean']['output']>;
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['output']>;
  taskCodesForJournaling?: Maybe<Array<Scalars['String']['output']>>;
};

export type JournalConfigRemotePatientMonitoringInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  isLabModuleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['input']>;
  taskCodesForJournaling?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JournalConfigRemoteSupervision = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['output']>;
};

export type JournalConfigRemoteSupervisionInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['input']>;
};

export type JournalConfigResponseCenterFeatures = {
  hasCarePlanRead: Scalars['Boolean']['output'];
  hasEpisodesOfCareRead: Scalars['Boolean']['output'];
  hasPatientRead: Scalars['Boolean']['output'];
};

export type JournalConfigResponseCenterFeaturesInput = {
  hasCarePlanRead: Scalars['Boolean']['input'];
  hasEpisodesOfCareRead: Scalars['Boolean']['input'];
  hasPatientRead: Scalars['Boolean']['input'];
};

export type JournalInput = {
  journal: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type JournalWorkflow = {
  completedAt?: Maybe<Scalars['dateTime']['output']>;
  completionOptions?: Maybe<Array<Scalars['String']['output']>>;
  debugDetails?: Maybe<Scalars['String']['output']>;
  freeTextNote?: Maybe<Scalars['String']['output']>;
  nextRetry?: Maybe<Scalars['dateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  retriedAt?: Maybe<Array<Maybe<Scalars['dateTime']['output']>>>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export type LandmarkVertex = {
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type LandmarkVertexInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Language = {
  language: Scalars['String']['output'];
  preferred: Scalars['Boolean']['output'];
};

export type LanguageCode = {
  code: Scalars['String']['output'];
};

export type LanguageInput = {
  language: Scalars['String']['input'];
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Link = {
  other?: Maybe<Reference>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LinkedHealthProvider = {
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ListAddress = {
  addressLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
};

export type ListAlarm = {
  authoredOn?: Maybe<Scalars['dateTime']['output']>;
  code?: Maybe<CodeableConcept>;
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  handlingMode?: Maybe<Scalars['String']['output']>;
  holdsCamera: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  locationTraces?: Maybe<Array<LocationTrace>>;
  owner?: Maybe<Reference>;
  patient?: Maybe<AlarmPatient>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityInput?: Maybe<TaskInput>;
  status: Scalars['String']['output'];
};

export type ListCamera = {
  /** As Camera.cameraProfile */
  cameraProfile?: Maybe<CameraProfile>;
  createdAt: Scalars['dateTime']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  /** As Camera.effectiveSettings */
  effectiveSettings?: Maybe<CameraEffectiveSettings>;
  enableExtendingCameraAvailability?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  /** Has the camera been temporarily put in privacy mode? */
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  privacyModeUntil?: Maybe<Scalars['dateTime']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  routeMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  topPriorityAlarm?: Maybe<EquipmentAlarm>;
  ttl?: Maybe<Scalars['Int']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type ListMqttDevice = {
  createdAt: Scalars['dateTime']['output'];
  deviceGroupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['dateTime']['output'];
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type ListPatient = {
  active: Scalars['Boolean']['output'];
  cmpSensors: Array<PatientListCmpSensor>;
  createdAt: Scalars['dateTime']['output'];
  devices: Array<PatientListDevice>;
  enabledServices: Array<Scalars['String']['output']>;
  externalIds: Array<PatientListExternalIds>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  openSyncAlarmId?: Maybe<Scalars['String']['output']>;
  patientGroupNames: Array<Scalars['String']['output']>;
  primaryAddress?: Maybe<ListAddress>;
  rpmLastActive?: Maybe<Scalars['dateTime']['output']>;
  secretAddress: Scalars['Boolean']['output'];
  shareAlarmWithPatients?: Maybe<Array<SharedAlarmPatients>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type LocaleEntry = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  localeId: Scalars['String']['output'];
};

export type LocaleEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  localeId: Scalars['String']['input'];
};

export type LocationTrace = {
  forDeviceId: Scalars['String']['output'];
  gpsLocations: Array<GpsLocation>;
  latestGpsLocation?: Maybe<GpsLocation>;
};

export type MeasurementDevice = {
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type MedicalState = {
  symptoms?: Maybe<Array<Scalars['String']['output']>>;
  treatments?: Maybe<Array<Scalars['String']['output']>>;
};

export type MedicalStateInput = {
  symptoms?: InputMaybe<Array<Scalars['String']['input']>>;
  treatments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MedicalStates = {
  green: MedicalState;
  red: MedicalState;
  yellow: MedicalState;
};

export type MedicalStatesInput = {
  green: MedicalStateInput;
  red: MedicalStateInput;
  yellow: MedicalStateInput;
};

export type MessageExchangeSubscription = ServiceSubscription & {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
};

export type Migration = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  scope: MigrationScope;
};

/**
 * Which database a migration runs against. The migration tab offers each one only for the rows it
 * applies to, so a registry migration is never dispatched per health provider and the other way
 * round.
 */
export enum MigrationScope {
  HealthProvider = 'healthProvider',
  Registry = 'registry',
}

export type MissedSubmission = {
  carePlan?: Maybe<Reference>;
  kind: MissedSubmissionKind;
  name?: Maybe<Scalars['String']['output']>;
  patientTask: Reference;
  reportedAt: Scalars['dateTime']['output'];
  scheduledFor: Scalars['dateTime']['output'];
};

export enum MissedSubmissionKind {
  Measurement = 'MEASUREMENT',
  Questionnaire = 'QUESTIONNAIRE',
}

export type MorpheanAccount = {
  accountDisplayName: Scalars['String']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  customerIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Scalars['ID']['output'];
  server: Scalars['String']['output'];
};

export type MorpheanAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  server?: InputMaybe<Scalars['String']['input']>;
};

export type MorpheanAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  morpheanAccount?: Maybe<MorpheanAccount>;
  success: Scalars['Boolean']['output'];
};

export type MorpheanAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  server?: InputMaybe<Scalars['String']['input']>;
};

export type MorpheanSite = {
  siteId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
};

export type MorpheanSitesForMorpheanCustomer = {
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  morpheanSites: Array<MorpheanSite>;
};

export type MoveAccessGroupResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MqttConfig = {
  connectionStatus: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MqttDevice = {
  createdAt: Scalars['dateTime']['output'];
  deviceGroupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['dateTime']['output'];
};

export type MqttDeviceCreateInput = {
  deviceGroupId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type MqttDeviceMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  mqttDevice?: Maybe<ListMqttDevice>;
  success: Scalars['Boolean']['output'];
};

export type MqttDeviceUpdateInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  _?: Maybe<Scalars['ID']['output']>;
  acceptVideoMeetingTask?: Maybe<TaskMutationResponse>;
  activateAlarmTemplate: AlarmTemplateMutationResponse;
  activateAzureProvisioning?: Maybe<AzureProvisioningMutationResponse>;
  activateCarePlan: CarePlanMutationResponse;
  activateCarePlanTemplate: CarePlanMutationResponse;
  activateDialoggUserOtp: Scalars['Boolean']['output'];
  activateDialoggUserSmsOtp: Scalars['Boolean']['output'];
  activateObservationTemplate?: Maybe<ObservationMutationResponse>;
  activateOtp?: Maybe<Scalars['Boolean']['output']>;
  activateQuestionnaireTemplate: QuestionnaireMutationResponse;
  activateSelfTreatmentPlan: SelfTreatmentPlanMutationResponse;
  activateSmsOtp?: Maybe<Scalars['Boolean']['output']>;
  addAccountToCustomer: CustomerMutationResponse;
  /**
   * Attaches a camera to a patient. With cameraProfileId, the camera also gets that camera profile; the
   * scopes for the attach cover it.
   */
  addCameraToPatient: CameraMutationResponse;
  addCameraToSetupBatchTelluSupport: Scalars['Boolean']['output'];
  addCareTeam: GenericMutationResponse;
  addDefaultRolesToHealthProvider: GenericMutationResponse;
  addExternalDialoggUserId: DialoggUserMutationResponse;
  addExternalHumanTypeToHealthProvider: Scalars['Boolean']['output'];
  addExternalIdP: Scalars['Boolean']['output'];
  addExternalIdentityProviderToHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  addExternalPatientIdToPatient: GenericMutationResponse;
  addExternalUserId: UserMutationResponse;
  addGooglemapsAccountToHealthProvider: HealthProviderMutationResponse;
  addMorpheanAccountToHealthProvider: HealthProviderMutationResponse;
  addMqttDeviceToPatient: MqttDeviceMutationResponse;
  addMyExternalId: UserMutationResponse;
  addNextOfKin: NextOfKinMutationResponse;
  addNotesToAlarm: TaskMutationResponse;
  addNotesToTask?: Maybe<TaskMutationResponse>;
  addNotesToTechnicalAlarm: TaskMutationResponse;
  addPatientByExternalId?: Maybe<PatientMutationResponse>;
  addPatientContact: GenericMutationResponse;
  addPlannedReminder?: Maybe<PlannedReminderMutationResponse>;
  addPlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  addPlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  addReferenceRangeToPatient?: Maybe<ObservationMutationResponse>;
  addRpmMedicalDeviceToPatient: RpmMedicalDeviceMutationResponse;
  addSafemateAccountToHealthProvider: HealthProviderMutationResponse;
  addSendGridAccountToHealthProvider: HealthProviderMutationResponse;
  addShareSkyresponseAlarmWithPatient?: Maybe<PatientMutationResponse>;
  addTagToPatient?: Maybe<PatientMutationResponse>;
  addTcifAccountToHealthProvider: HealthProviderMutationResponse;
  addTwilioAccountToHealthProvider: HealthProviderMutationResponse;
  addUserGroupContact: GenericMutationResponse;
  addUserReservation?: Maybe<Scalars['Boolean']['output']>;
  addUserToRole?: Maybe<GenericMutationResponse>;
  addVideoMeetingTaskNotes: AddVideoMeetingTaskNotesResponse;
  addVideonorAccountToHealthProvider: HealthProviderMutationResponse;
  addWelfareDeviceToPatient: WelfareDeviceMutationResponse;
  assignExternalAccessToForwarder: GenericMutationResponse;
  assignForwarderToPatientGroups: GenericMutationResponse;
  assignIntegrationToSkyresponseConfig: GenericMutationResponse;
  assignPatientToDialoggUser: DialoggUserMutationResponse;
  attachCompletionOptionToAlarmTemplate: Scalars['Boolean']['output'];
  cameraAppBulkUpdate: Scalars['Boolean']['output'];
  cameraAudioSettingsBulkUpdate: Scalars['Boolean']['output'];
  cameraConfigureTwoWayAudio: Scalars['Boolean']['output'];
  cameraFirmwareBulkUpgrade: Scalars['Boolean']['output'];
  cameraIoPortConfigurationBulkUpdate: Scalars['Boolean']['output'];
  cameraNetworkingBulkUpdate: Scalars['Boolean']['output'];
  cameraRebootBulkUpdate: Scalars['Boolean']['output'];
  cameraRotationBulkUpdate: Scalars['Boolean']['output'];
  cancelCarePlan: CarePlanMutationResponse;
  cancelDialoggUserOtp: Scalars['Boolean']['output'];
  cancelOtp?: Maybe<Scalars['Boolean']['output']>;
  cancelPatientReminder?: Maybe<PatientReminderMutationResponse>;
  cancelSkyresponseSyncAlarm: TaskMutationResponse;
  cancelVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  changePicturePermission: DialoggUserMutationResponse;
  completeAlarm: TaskMutationResponse;
  completeCarePlan: CarePlanMutationResponse;
  completeCarePlanTemplate: CarePlanMutationResponse;
  completeCompositeTask?: Maybe<TaskMutationResponse>;
  completeCompositeTaskAndItsSubTasks?: Maybe<TaskMutationResponse>;
  completePatientReminder?: Maybe<PatientReminderMutationResponse>;
  completeSubTask?: Maybe<TaskMutationResponse>;
  configureCameraEvents: CameraMutationResponse;
  correctValidationRules: Scalars['String']['output'];
  createAlarmForwarder: GenericMutationResponse;
  createAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  createAlarmTemplate: AlarmTemplateMutationResponse;
  createAsset: CreateAssetResponse;
  createAzureAccount: AzureAccountMutationResponse;
  createCamera: CameraMutationResponse;
  createCameraEventConfig: CameraEventConfigMutationResponse;
  createCameraProfile: CameraProfileMutationResponse;
  /** Create a PTZ profile for a camera */
  createCameraPtzProfile: CameraPtzProfileConfig;
  /** Set a new view preset for a camera */
  createCameraViewPreset: Scalars['Boolean']['output'];
  createCarePlanBasedOnExisting: CarePlanMutationResponse;
  createCarePlanForPatient: CarePlanMutationResponse;
  createCarePlanTemplate: CarePlanMutationResponse;
  createCarePlanTemplateBasedOnExisting: CarePlanMutationResponse;
  createCepEventConfig: CepEventConfigMutationResponse;
  createCmpAccount: CmpAccountMutationResponse;
  createCommunication: CommunicationMutationResponse;
  createCommunicationToSeveral: Array<CommunicationMutationResponse>;
  createCompletionOption: AlarmCompletionOptionMutationResponse;
  createCustomer: CustomerMutationResponse;
  createDefaultRoleDefinition: RoleDefinitionMutationResponse;
  createDeviceGroup: DeviceGroupMutationResponse;
  createDialoggUser: DialoggUserMutationResponse;
  createDocument?: Maybe<DocumentReferenceMutationResult>;
  createExternalAccess: ExternalAccessCreateResponse;
  createExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  createForwarderAlarmRoutes: GenericMutationResponse;
  createGooglemapsAccount: GooglemapsAccountMutationResponse;
  createHealthProvider: HealthProviderMutationResponse;
  createHelseIdAccount: HelseIdAccountMutationResponse;
  createIntegration: GenericMutationResponse;
  createJournalConfigForUserGroup: JournalConfigMutationResponse;
  createMorpheanAccount: MorpheanAccountMutationResponse;
  createMqttDevice: MqttDeviceMutationResponse;
  createObservationForActivityInCarePlan: ObservationMutationResponse;
  createObservationForActivityInCarePlanTemplate: ObservationMutationResponse;
  createObservationTemplate?: Maybe<ObservationMutationResponse>;
  createPatient?: Maybe<PatientMutationResponse>;
  createPatientEventConfig: PatientEventConfigMutationResponse;
  createPatientGoals: SelfTreatmentPlanMutationResponse;
  createPatientGroup?: Maybe<PatientGroupMutationResponse>;
  createPatientInGroup?: Maybe<PatientMutationResponse>;
  createPatientMedicalStates: SelfTreatmentPlanMutationResponse;
  createQuestionnaireForActivityInCarePlan: QuestionnaireMutationResponse;
  createQuestionnaireForActivityInCarePlanTemplate: QuestionnaireMutationResponse;
  createQuestionnaireTemplate: QuestionnaireMutationResponse;
  createRegistryDevice: RegistryDeviceMutationResponse;
  createRole: RoleMutationResponse;
  createRoleDefinition: RoleDefinitionMutationResponse;
  createRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  createSafemateAccount: SafemateAccountMutationResponse;
  createSelfTreatmentPlanTemplate: SelfTreatmentPlanMutationResponse;
  createSendGridAccount: SendGridAccountMutationResponse;
  createShiftSessionForPatientGroups?: Maybe<ShiftSession>;
  createSkyresponseAccount: SkyresponseAccountMutationResponse;
  createSkyresponseOrganizationNote: SkyresponseOrganizationNoteMutationResponse;
  createTcifAccount: TcifAccountMutationResponse;
  createTemplateVkpCodes: TemplateVkpCodesMutationResponse;
  createTimeLimitedFhirCredentialsForHealthProvider: Scalars['String']['output'];
  createTopLevelRolesForHealthProvider: RoleMutationResponse;
  createTranscareUser: GraphQlGenericMutationResponse;
  createTwilioAccount: TwilioAccountMutationResponse;
  createUnplannedSupervision: TaskMutationResponse;
  createUser?: Maybe<UserMutationResponse>;
  createUserGroup: UserGroupMutationResponse;
  createUserManual: UserManualMutationResponse;
  createVideonorAccount: VideonorAccountMutationResponse;
  createVkpAccount: VkpAccountMutationResponse;
  createWelfareDevice: WelfareDeviceMutationResponse;
  createWhiteLabelingTemplate: WhiteLabelingTemplateMutationResponse;
  deactivateDialoggUserSmsOtp: Scalars['Boolean']['output'];
  deactivateSelfTreatmentPlan: SelfTreatmentPlanMutationResponse;
  deactivateSmsOtp?: Maybe<Scalars['Boolean']['output']>;
  decommissionCameras: Scalars['Boolean']['output'];
  deleteAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  deleteAlarmTemplate: AlarmTemplateMutationResponse;
  deleteAppDeviceForPatient: AppDeviceMutationResponse;
  deleteAsset: GenericMutationResponse;
  /**
   * Deletes a camera profile. When cameras use it, replacementCameraProfileId is required, and the cameras
   * move to that profile in the same transaction. The default profile cannot be deleted: set another
   * default profile first.
   */
  deleteCameraProfile: GenericMutationResponse;
  /** Delete an active PTZ profile for a camera */
  deleteCameraPtzProfile: CameraPtzProfileConfig;
  deleteCameraViewPreset: Scalars['Boolean']['output'];
  deleteCmpAccount: CmpAccountMutationResponse;
  deleteCompletionOption: Scalars['Boolean']['output'];
  deleteCustomer: CustomerMutationResponse;
  deleteDefaultRoleDefinition: RoleDefinitionMutationResponse;
  deleteDeviceGroup: GenericMutationResponse;
  deleteDialoggUser: DialoggUserMutationResponse;
  deleteDialoggUserOtp: Scalars['Boolean']['output'];
  deleteDocument?: Maybe<DocumentReferenceMutationResult>;
  deleteDraftCarePlan: CarePlanMutationResponse;
  deleteDraftCarePlanTemplate: CarePlanMutationResponse;
  deleteEscalationDelay: GenericMutationResponse;
  deleteEventConfig: EventConfigDeleteResponse;
  deleteExternalAccess: Scalars['Boolean']['output'];
  deleteExternalAccessById: Scalars['Boolean']['output'];
  deleteExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  deleteExternalIdP: Scalars['Boolean']['output'];
  deleteExternalIdentityProviderFromHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  deleteExternalIdentityProviderRedirectorFromHealthProvider?: Maybe<GenericMutationResponse>;
  deleteForwarder: GenericMutationResponse;
  deleteForwarderAlarmRoute: GenericMutationResponse;
  deleteGooglemapsAccount: GooglemapsAccountMutationResponse;
  deleteHealthProvider: HealthProviderMutationResponse;
  deleteHelseIdAccount: HelseIdAccountMutationResponse;
  deleteInconsistentHealthProvider: HealthProviderMutationResponse;
  deleteIntegration: GenericMutationResponse;
  deleteJournalConfigForUserGroup: JournalConfigMutationResponse;
  deleteMorpheanAccount: MorpheanAccountMutationResponse;
  deleteMqttDevice: MqttDeviceMutationResponse;
  deleteNextOfKin: NextOfKinMutationResponse;
  deleteObservationTemplate?: Maybe<ObservationMutationResponse>;
  deleteOtp?: Maybe<Scalars['Boolean']['output']>;
  deletePatient?: Maybe<PatientMutationResponse>;
  deleteQuestionnaireResponse?: Maybe<QuestionnaireResponseMutationResponse>;
  deleteQuestionnaireTemplate: QuestionnaireMutationResponse;
  deleteRegistryDevice: RegistryDeviceMutationResponse;
  deleteRole: GenericMutationResponse;
  deleteRoleDefinition: RoleDefinitionMutationResponse;
  deleteRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  deleteSafemateAccount: SafemateAccountMutationResponse;
  deleteSendGridAccount: SendGridAccountMutationResponse;
  deleteSkyresponseAccount: SkyresponseAccountMutationResponse;
  deleteSkyresponseOrganizationNote: SkyresponseOrganizationNoteMutationResponse;
  deleteTcifAccount: TcifAccountMutationResponse;
  deleteTwilioAccount: TwilioAccountMutationResponse;
  deleteUser?: Maybe<GenericMutationResponse>;
  deleteUserGroup: UserGroupMutationResponse;
  deleteUserManual: UserManualMutationResponse;
  deleteVideonorAccount: VideonorAccountMutationResponse;
  deleteVkpAccount: VkpAccountMutationResponse;
  deleteWelfareDevice: WelfareDeviceMutationResponse;
  deleteWhiteLabelingTemplate: GenericMutationResponse;
  disableAlarmStreaming: FeatureFlagMutationResponse;
  disableAlmaIntegration: FeatureFlagMutationResponse;
  disableApplication: ApplicationToggleResponse;
  disableAscomIntegration: FeatureFlagMutationResponse;
  disableBestIntegration: FeatureFlagMutationResponse;
  disableBeta: FeatureFlagMutationResponse;
  disableCmp: FeatureFlagMutationResponse;
  disableContinuousSupervision: FeatureFlagMutationResponse;
  disableCoordcomIntegration: FeatureFlagMutationResponse;
  disableDataAnalytics: FeatureFlagMutationResponse;
  disableDemoAnonymization: FeatureFlagMutationResponse;
  disableEntraIdProvisioning: FeatureFlagMutationResponse;
  disableEntraIdSso: FeatureFlagMutationResponse;
  disableFeatureFlag: FeatureFlagToggleResponse;
  disableFurnitureDetection: FeatureFlagMutationResponse;
  disableIpOmsorgIntegration: FeatureFlagMutationResponse;
  disableJoinNhnMeeting: FeatureFlagMutationResponse;
  disableNewSupervisionUserTabs: FeatureFlagMutationResponse;
  disablePatientCameras: GenericMutationResponse;
  disablePhoniroCloudIntegration: FeatureFlagMutationResponse;
  disableSelfTreatmentPlan: FeatureFlagMutationResponse;
  disableSendNotificationToNextOfKin: FeatureFlagMutationResponse;
  disableServiceForPatient: ServiceSubscriptionMutationResponse;
  disableSipIntegration: FeatureFlagMutationResponse;
  disableSkyresponsePartnerIntegration: FeatureFlagMutationResponse;
  disableTietoLmoIntegration: FeatureFlagMutationResponse;
  disableTrends: FeatureFlagMutationResponse;
  disableUmo2GIntegration: FeatureFlagMutationResponse;
  disableUserAuthSetting: UserAuthSettingToggleResponse;
  disableUserPassword?: Maybe<Scalars['Boolean']['output']>;
  enableAlarmStreaming: FeatureFlagMutationResponse;
  enableAlmaIntegration: FeatureFlagMutationResponse;
  enableApplication: ApplicationToggleResponse;
  enableAscomIntegration: FeatureFlagMutationResponse;
  enableBestIntegration: FeatureFlagMutationResponse;
  enableBeta: FeatureFlagMutationResponse;
  enableCmp: FeatureFlagMutationResponse;
  enableContinuousSupervision: FeatureFlagMutationResponse;
  enableCoordcomIntegration: FeatureFlagMutationResponse;
  enableDataAnalytics: FeatureFlagMutationResponse;
  enableDemoAnonymization: FeatureFlagMutationResponse;
  enableEntraIdProvisioning: FeatureFlagMutationResponse;
  enableEntraIdSso: FeatureFlagMutationResponse;
  enableFeatureFlag: FeatureFlagToggleResponse;
  enableFurnitureDetection: FeatureFlagMutationResponse;
  enableIpOmsorgIntegration: FeatureFlagMutationResponse;
  enableJoinNhnMeeting: FeatureFlagMutationResponse;
  enableNewSupervisionUserTabs: FeatureFlagMutationResponse;
  enablePatientCameras: GenericMutationResponse;
  enablePhoniroCloudIntegration: FeatureFlagMutationResponse;
  enableSelfTreatmentPlan: FeatureFlagMutationResponse;
  enableSendNotificationToNextOfKin: FeatureFlagMutationResponse;
  enableServiceForPatient: ServiceSubscriptionMutationResponse;
  enableSipIntegration: FeatureFlagMutationResponse;
  enableSkyresponsePartnerIntegration: FeatureFlagMutationResponse;
  enableTietoLmoIntegration: FeatureFlagMutationResponse;
  enableTrends: FeatureFlagMutationResponse;
  enableUmo2GIntegration: FeatureFlagMutationResponse;
  enableUserAuthSetting: UserAuthSettingToggleResponse;
  enableUserPassword?: Maybe<Scalars['Boolean']['output']>;
  endJoinVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  endVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  executeDatabaseSchemaSync: Array<DatabaseSchemaSyncResponse>;
  executeMigration: Array<DatabaseSchemaMigration>;
  executeRegistrySchemaSync: RegistrySchemaSyncResponse;
  extendAlarmTimer: TaskMutationResponse;
  forceDeleteDialoggUser: DialoggUserMutationResponse;
  hideTechnicalAlarmNotificationsForPatientGroup?: Maybe<PatientGroupMutationResponse>;
  importAlarmTemplates: GenericMutationResponse;
  importAlarmTemplatesFromDefault: ImportAlarmTemplatesFromDefaultResponse;
  importDevicesFromSafematePro: ImportDevicesResponse;
  importEventForPatientRaw: TaskMutationResponse;
  importMeasurementTemplatesFromDefault: Array<ImportTemplateResponse>;
  importObservationTemplates: GenericMutationResponse;
  initializeExternalAccess: ExternalAccessCreateResponse;
  inviteToVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  /** Reset audio stream TTL */
  keepAudioStreamAlive: CameraStream;
  /** Re-authorize and refresh exactly one bounding-box pair's capability and TCAP TTL. */
  keepBoundingBoxStreamAlive: CameraStream;
  /** Re-authorize and refresh the pair carrying this viewer's raw-data grant. */
  keepRawDataStreamAlive: CameraStream;
  /** Keep a video stream alive */
  keepStreamAlive: CameraStream;
  /** Re-authorize and refresh the pair carrying this viewer's zone-status grant. */
  keepZoneStateStreamAlive: CameraStream;
  logLocalExport: GenericMutationResponse;
  markCommunicationAsRead: CommunicationMutationResponse;
  markHealthProviderForDeletion: HealthProviderMutationResponse;
  markNextOfKinAsMain?: Maybe<GenericMutationResponse>;
  migrateOwnerDatabase: Array<DatabaseSchemaMigration>;
  moveAccessGroup: MoveAccessGroupResponse;
  notifyNextOfKins?: Maybe<Array<NotificationLogResponse>>;
  openPatientGroupsForExternalAccess?: Maybe<GenericMutationResponse>;
  orderPatientContacts: GenericMutationResponse;
  orderUserGroupContacts: GenericMutationResponse;
  pauseHealthProviderDeletion: Scalars['Boolean']['output'];
  planPatientReminder?: Maybe<PatientReminderMutationResponse>;
  planVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  previewDatabaseSchemaSync: Array<DatabaseSchemaSyncResponse>;
  previewRegistrySchemaSync: RegistrySchemaSyncResponse;
  reboot: Scalars['Boolean']['output'];
  redoCameraSetupTelluSupport: Scalars['Boolean']['output'];
  refreshAzureProvisioningSecret?: Maybe<AzureProvisioningMutationResponse>;
  registerPushIdForShiftSession?: Maybe<GenericMutationResponse>;
  registerPushSubscription?: Maybe<GenericMutationResponse>;
  rejectCompositeTask?: Maybe<TaskMutationResponse>;
  rejectSubTask?: Maybe<TaskMutationResponse>;
  releaseVideoMeetingTask?: Maybe<TaskMutationResponse>;
  removeAccountFromCustomer: CustomerMutationResponse;
  removeCameraFromPatient: CameraMutationResponse;
  removeCareTeam: GenericMutationResponse;
  removeCompletionOptionFromAlarmTemplate: Scalars['Boolean']['output'];
  removeDefaultRolesFromHealthProvider: GenericMutationResponse;
  removeDialoggUserPassword: DialoggUserMutationResponse;
  removeExternalDialoggUserId: DialoggUserMutationResponse;
  removeExternalHumanTypeFromHealthProvider: Scalars['Boolean']['output'];
  removeExternalPatientIdFromPatient: GenericMutationResponse;
  removeExternalUserId: UserMutationResponse;
  removeGooglemapsAccountFromHealthProvider: HealthProviderMutationResponse;
  removeIntegrationFromSkyresponseConfig: GenericMutationResponse;
  removeMorpheanAccountFromHealthProvider: HealthProviderMutationResponse;
  removeMqttDeviceFromPatient: MqttDeviceMutationResponse;
  removeMyExternalId: UserMutationResponse;
  removePatientContact: GenericMutationResponse;
  removePatientFromDialoggUser: DialoggUserMutationResponse;
  removePatientGroupFromUserGroup?: Maybe<GenericMutationResponse>;
  removePlannedReminder?: Maybe<PlannedReminderMutationResponse>;
  removePlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  removePlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  removeReferenceRangeFromPatient?: Maybe<ObservationMutationResponse>;
  removeRpmMedicalDeviceFromPatient: RpmMedicalDeviceMutationResponse;
  removeSafemateAccountFromHealthProvider: HealthProviderMutationResponse;
  removeSendGridAccountFromHealthProvider: HealthProviderMutationResponse;
  removeTagFromPatient?: Maybe<PatientMutationResponse>;
  removeTcifAccountFromHealthProvider: HealthProviderMutationResponse;
  removeTemplateVkpCodesFromTemplate: TemplateVkpCodesMutationResponse;
  removeTwilioAccountFromHealthProvider: HealthProviderMutationResponse;
  removeUserFromRole?: Maybe<GenericMutationResponse>;
  removeUserGroupContact: GenericMutationResponse;
  removeUserReservation?: Maybe<Scalars['Boolean']['output']>;
  removeVideonorAccountFromHealthProvider: HealthProviderMutationResponse;
  removeWelfareDeviceFromPatient: WelfareDeviceMutationResponse;
  replaceWelfareDeviceIdentifier: WelfareDeviceMutationResponse;
  reschedulePatientReminder?: Maybe<PatientReminderMutationResponse>;
  rescheduleVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  resetCameraSetupBatchTelluSupport: Scalars['Boolean']['output'];
  resetCameraSetupTelluSupport: Scalars['Boolean']['output'];
  resetExternalAccessSecret: ExternalAccessCreateResponse;
  resetExternalIdentityProviderLinksForHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  resetHealthProviderFlow: HealthProviderMutationResponse;
  resetHelseIdCredentials: HelseIdAccountMutationResponse;
  resetMorpheanCacheTelluSupport: Scalars['Boolean']['output'];
  resetSecretForExternalAccess: ExternalAccessCreateResponse;
  resetUserPassword?: Maybe<Scalars['Boolean']['output']>;
  restoreHealthProviderMarkedForDeletion: HealthProviderMutationResponse;
  resumeHealthProviderDeletion: Scalars['Boolean']['output'];
  retireAlarmTemplate: AlarmTemplateMutationResponse;
  retireObservationTemplate?: Maybe<ObservationMutationResponse>;
  retireQuestionnaireTemplate: QuestionnaireMutationResponse;
  retryAlarmJournaling: TaskMutationResponse;
  retryTaskJournaling?: Maybe<TaskMutationResponse>;
  revertOwnerDatabase: Array<DatabaseSchemaMigration>;
  revokeInviteToVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  selectWhiteLabelingTemplateForHealthProvider: GenericMutationResponse;
  sendVideoMeetingInvitationSms?: Maybe<VideoMeetingMutationResponse>;
  /** Set the active PTZ profile for a camera. Will clear the active profile if profileId is null. */
  setActiveCameraPtzProfile: CameraPtzProfileConfig;
  /**
   * Writes camera detection settings. Omitted fields are unchanged.
   *
   * The response carries the settings the camera echoed back. Select zones as well when the
   * write includes underCameraAreaSafe: that setting changes the camera's zone geometry.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged, naming every setting that changed and its previous value.
   */
  setCameraDetectionSettings: CameraConfigurationMutationResponse;
  /**
   * Writes camera detection zones. A category included in the input replaces every editable zone
   * in it; omitted categories are preserved and an empty list wipes the category.
   *
   * The response carries the zones the camera echoed back, so selecting them costs nothing.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged, naming every zone that was created, edited or removed.
   */
  setCameraLandmarks: CameraConfigurationMutationResponse;
  /**
   * Gives one camera profile to many cameras, in one transaction. The caller must have access to each
   * camera, through its patient when it has one. Writes one audit event for each camera.
   *
   * Required access scopes: ['patient/Patient.write', 'user/Camera.read']
   */
  setCameraProfile: GenericMutationResponse;
  /** Rotate and zoom for a camera */
  setCameraViewWithAngles: Scalars['Boolean']['output'];
  setCameraViewWithPreset: Scalars['Boolean']['output'];
  /** Makes the camera profile the default profile of the account, which new cameras get. */
  setDefaultCameraProfile: CameraProfileMutationResponse;
  setDialoggUserEnabled: DialoggUserMutationResponse;
  setDialoggUserExternalIdP: Scalars['Boolean']['output'];
  setEmailAndSmsNotificationSettingsForShiftSession?: Maybe<ShiftSession>;
  setExternalIdP?: Maybe<Scalars['Boolean']['output']>;
  setExternalIdRequest: Scalars['Boolean']['output'];
  setExternalIdentities?: Maybe<Scalars['Boolean']['output']>;
  setExternalIdentityProviderRedirectorFromHealthProvider?: Maybe<GenericMutationResponse>;
  setPendingExternalIdentityProvider: Scalars['Boolean']['output'];
  /** Set a camera's reference objects for furniture detection */
  setReferenceObjectsForCamera: ReferenceObjectsMutationResponse;
  simulateCarePlanObservationResponse: ObservationMutationResponse;
  simulateCarePlanQuestionnaireResponse: QuestionnaireMutationResponse;
  simulateNovoEvent: GenericMutationResponse;
  simulateSafemateEvent: GenericMutationResponse;
  simulateSkyResponseEvent: GenericMutationResponse;
  simulateSyncEvent: TaskMutationResponse;
  sortTree: SortTreeResponse;
  startApp: Scalars['Boolean']['output'];
  /** Start an audio stream */
  startAudioStream: CameraStream;
  /**
   * Start one browser/camera bounding-box pair. The returned CameraStream.id is the streamId shared
   * by both peers and used in the URL query and TCAP command. The returned URL is sent unchanged to
   * TCAP. The browser must connect with bbox-browser; TCAP uses bbox-camera.
   *
   * Pass the streamId of a pair this viewer already holds to add the bounding-box channel to that
   * pair instead of opening a second one: same streamId, same URL, one socket. Omit it - or pass an
   * id that is no longer usable - and a fresh pair is minted.
   */
  startBoundingBoxStream: CameraStream;
  startCompositeTask?: Maybe<TaskMutationResponse>;
  startJoinVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  startPhoneCall?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Authorize raw-data telemetry for one viewer: the payloads behind the camera's own "Show Raw
   * Data" overlay, delivered as one grant rather than one grant per payload type.
   *
   * This is a channel grant on the SAME pair the bounding-box stream uses, not a second stream: the
   * camera has a fixed number of slots, so a viewer watching raw data alongside another overlay
   * still uses exactly one. Pass the streamId of a pair this viewer already holds to widen it -
   * same streamId, same URL, no reconnect. Omit it and a fresh pair is minted carrying raw only.
   */
  startRawDataStream: CameraStream;
  /** Start a video stream */
  startStream: CameraStream;
  startVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  /**
   * Authorize zone-status telemetry for one viewer.
   *
   * This is a channel grant on the SAME pair the bounding-box stream uses, not a second stream: the
   * camera has a fixed number of slots, so a viewer watching both overlays still uses exactly one.
   * Pass the streamId of a pair this viewer already holds to widen it - same streamId, same URL, no
   * reconnect. Omit it and a fresh pair is minted carrying zone status only.
   */
  startZoneStateStream: CameraStream;
  stopApp: Scalars['Boolean']['output'];
  /** Stop an audio stream */
  stopAudioStream: Scalars['Boolean']['output'];
  /** Revoke and stop exactly one bounding-box pair without affecting other viewers of the camera. */
  stopBoundingBoxStream: Scalars['Boolean']['output'];
  /**
   * Give up the raw-data grant. While the pair still carries another channel this narrows it and
   * the socket stays up; giving up the last grant revokes and stops that pair only.
   */
  stopRawDataStream: Scalars['Boolean']['output'];
  /** Stop a video stream */
  stopStream: Scalars['Boolean']['output'];
  /**
   * Give up the zone-status grant. While the pair still carries another channel this narrows it and
   * the socket stays up; giving up the last grant revokes and stops that pair only.
   */
  stopZoneStateStream: Scalars['Boolean']['output'];
  submitAlarmHandlingFeedback: Scalars['Boolean']['output'];
  supportTeamLinkToHealthProvider: GenericMutationResponse;
  supportTeamUnlinkFromHealthProvider: GenericMutationResponse;
  syncAlarmTemplates: ImportAlarmTemplatesFromDefaultResponse;
  syncDefaultDeviceTypes: GenericMutationResponse;
  syncDefaultExternalIdentityProviders: GenericMutationResponse;
  syncDefaultRoleDefinitions: GenericMutationResponse;
  syncExternalHumanIdTypesWithDefaults: GenericMutationResponse;
  syncPatientInfoWithSkyresponse: MutationResponseWithPagination;
  syncSpecificPatientWithSkyresponse: GenericMutationResponse;
  takeCall: TaskMutationResponse;
  takeCameraSnapshotWithDetections: TakeCameraSnapshotWithDetectionsResponse;
  terminateShiftSessionOnAllDevices?: Maybe<Scalars['Boolean']['output']>;
  terminateShiftSessionOnAllDevicesForUser: Scalars['Boolean']['output'];
  terminateShiftSessionOnDevice?: Maybe<ShiftSession>;
  testAzureAccountCredentials: TestAzureAccountCredentialsMutationResponse;
  testHelseIdCredentials: Scalars['Boolean']['output'];
  testPushNotification: ReminderStatus;
  triggerDailyStatCollection: Scalars['Boolean']['output'];
  triggerEventInCamera: Scalars['Boolean']['output'];
  triggerHourlyStatCollection: Scalars['Boolean']['output'];
  triggerResolveActionsForSyncAlarms: GenericMutationResponse;
  unselectWhiteLabelingTemplateForHealthProvider: GenericMutationResponse;
  updateAccountSettings: AccountSettingsMutationResponse;
  updateAlarmAckTemplates: GenericMutationResponse;
  updateAlarmForwarder: GenericMutationResponse;
  updateAlarmStatus: TaskMutationResponse;
  updateAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  updateAlarmTemplate: AlarmTemplateMutationResponse;
  updateAlarmTemplateStatus: GenericMutationResponse;
  /** Turn off camera anonymization temporarily, this mutation is mainly to audit log the action */
  updateAnonymization: Scalars['Boolean']['output'];
  updateAppDeviceForPatient: AppDeviceMutationResponse;
  updateAvailableHours: CameraMutationResponse;
  updateAzureAccount: AzureAccountMutationResponse;
  updateCamera: CameraMutationResponse;
  updateCameraDeviceGroup?: Maybe<CameraMutationResponse>;
  /**
   * Updates a camera-scoped EventConfig using full-payload semantics.
   * Provide the same input shape as create on every update request.
   * type and code are immutable and must match the existing EventConfig.
   */
  updateCameraEventConfig: CameraEventConfigMutationResponse;
  /** Changes a camera profile. The change applies at once to every camera that uses the profile. */
  updateCameraProfile: CameraProfileMutationResponse;
  /** Changes the settings of one camera. Every viewer of the camera can set the shared sound threshold. */
  updateCameraSettings: CameraSettingsMutationResponse;
  updateCarePlanQuestionnaire: QuestionnaireMutationResponse;
  updateCarePlanTemplateQuestionnaire: QuestionnaireMutationResponse;
  updateCareTeam: GenericMutationResponse;
  /**
   * Updates a CEP EventConfig using full-payload semantics.
   * Provide the same input shape as create on every update request.
   * type and code are immutable and must match the existing EventConfig.
   */
  updateCepEventConfig: CepEventConfigMutationResponse;
  updateCmpAccount: CmpAccountMutationResponse;
  updateCompletionOption: AlarmCompletionOptionMutationResponse;
  updateCompositeTaskPriority?: Maybe<TaskMutationResponse>;
  updateCustomer: CustomerMutationResponse;
  updateDefaultRoleDefinition: RoleDefinitionMutationResponse;
  updateDeviceGroup: DeviceGroupMutationResponse;
  updateDeviceGroupCmp: DeviceGroupMutationResponse;
  updateDeviceGroupForMqttDevice: MqttDeviceMutationResponse;
  updateDialoggUser: DialoggUserMutationResponse;
  updateDialoggUserIPRestrictions: DialoggUserMutationResponse;
  updateDialoggUserPassword: DialoggUserMutationResponse;
  updateDialoggUserTimeLimitedAccess: DialoggUserMutationResponse;
  updateDigitalHomeVisitsSettingsForPatient: UpdateDhvSettingsMutationResponse;
  updateDraftCarePlan: CarePlanMutationResponse;
  updateDraftCarePlanTemplate: CarePlanMutationResponse;
  updateEscalationDelay: GenericMutationResponse;
  updateExternalAccess: ExternalAccessUpdateResponse;
  updateExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  updateExternalIdRequestsOnAzureGroup: AzureGroupMutationResponse;
  updateExternalIdentityProviderForHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  updateForwarderAlarmRoute: GenericMutationResponse;
  updateForwarderErrorHandling: GenericMutationResponse;
  updateFurnitureDetectionAlarmSnapshot: Scalars['Boolean']['output'];
  updateGooglemapsAccount: GooglemapsAccountMutationResponse;
  updateGroupVideoMeetingParticipants?: Maybe<VideoMeetingMutationResponse>;
  updateHealthProvider: HealthProviderMutationResponse;
  updateHealthProviderPatientAuth: GenericMutationResponse;
  updateHealthProviderPatientSessionLifespan: GenericMutationResponse;
  updateHealthProviderRolesBasedOnDefaultRoles: GenericMutationResponse;
  updateHealthProviderUserAuth: GenericMutationResponse;
  updateHealthProviderUserSessionLifespan: GenericMutationResponse;
  updateHelseIdAccount: HelseIdAccountMutationResponse;
  updateHelseIdCredentials: HelseIdAccountMutationResponse;
  updateIPRestrictions?: Maybe<GenericMutationResponse>;
  updateInheritedJournalConfigForUserGroup: JournalConfigMutationResponse;
  updateIntegration: GenericMutationResponse;
  updateJournalConfigForUserGroup: JournalConfigMutationResponse;
  updateLinkedPatientGroups: UserGroupMutationResponse;
  updateMorpheanAccount: MorpheanAccountMutationResponse;
  updateMqttDevice: MqttDeviceMutationResponse;
  updateNameOrIpRestrictionsForExternalAccess: ExternalAccessUpdateResponse;
  updateNextOfKin: NextOfKinMutationResponse;
  updateObservationStatus?: Maybe<ObservationMutationResponse>;
  updateObservationTemplate?: Maybe<ObservationMutationResponse>;
  updateObservationTemplateStatus: GenericMutationResponse;
  updatePatient?: Maybe<PatientMutationResponse>;
  updatePatientContact: GenericMutationResponse;
  /**
   * Updates a patient-scoped EventConfig using full-payload semantics.
   * Provide the same input shape as create on every update request.
   * type and code are immutable and must match the existing EventConfig.
   */
  updatePatientEventConfig: PatientEventConfigMutationResponse;
  updatePatientGoals: SelfTreatmentPlanMutationResponse;
  updatePatientGroup?: Maybe<PatientGroupMutationResponse>;
  updatePatientGroupsOfPatient?: Maybe<PatientGroupsMutationResponse>;
  updatePatientLastActive?: Maybe<Scalars['Boolean']['output']>;
  updatePatientMedicalStates: SelfTreatmentPlanMutationResponse;
  updatePatientReferenceRange?: Maybe<ObservationMutationResponse>;
  updatePendingExternalIdentityProvidersOnAzureGroup: AzureGroupMutationResponse;
  updatePlannedReminder?: Maybe<PlannedReminderMutationResponse>;
  updatePlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  updatePlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  updateQuestionnaireTemplate: QuestionnaireMutationResponse;
  updateRegistryDevice: RegistryDeviceMutationResponse;
  updateRoleDefinition: RoleDefinitionMutationResponse;
  updateRoleDefinitionBasedOn: RoleDefinitionMutationResponse;
  updateRolesOnAzureGroup: AzureGroupMutationResponse;
  updateRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  updateSafemateAccount: SafemateAccountMutationResponse;
  updateSelfTreatmentPlanTemplate: SelfTreatmentPlanMutationResponse;
  updateSendGridAccount: SendGridAccountMutationResponse;
  updateShiftSessionPhoneNumber?: Maybe<GenericMutationResponse>;
  updateSkyresponseAccount: SkyresponseAccountMutationResponse;
  updateSkyresponseConfig: GenericMutationResponse;
  updateSkyresponseOrganizationNote: SkyresponseOrganizationNoteMutationResponse;
  updateSubTaskPriority?: Maybe<TaskMutationResponse>;
  updateTaskPresenceAt: TaskMutationResponse;
  updateTcifAccount: TcifAccountMutationResponse;
  updateTechnicalAlarmStatus: TaskMutationResponse;
  updateTemplateVkpCodes: TemplateVkpCodesMutationResponse;
  updateTwilioAccount: TwilioAccountMutationResponse;
  updateUser?: Maybe<UserMutationResponse>;
  updateUserGroup: UserGroupMutationResponse;
  updateUserGroupContact: GenericMutationResponse;
  updateUserManual: UserManualMutationResponse;
  updateUserPassword?: Maybe<Scalars['Boolean']['output']>;
  updateUserTimeLimitedAccess?: Maybe<GenericMutationResponse>;
  updateVideonorAccount: VideonorAccountMutationResponse;
  updateVkpAccount: VkpAccountMutationResponse;
  updateWelfareDevice: WelfareDeviceMutationResponse;
  updateWhiteLabelingTemplate: WhiteLabelingTemplateMutationResponse;
  validateCmpAccountTowardsCmp: CmpAccountMutationResponse;
  validateCustomerGroupTowardsCmp: ValidateCustomerGroupTowardsCmpResponse;
  validateForwarder: IntegrationConfigValidationResult;
};

export type MutationAcceptVideoMeetingTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationActivateAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateAzureProvisioningArgs = {
  azureAccountId: Scalars['ID']['input'];
};

export type MutationActivateCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationActivateCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateDialoggUserSmsOtpArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateSelfTreatmentPlanArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type MutationActivateSmsOtpArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAddAccountToCustomerArgs = {
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
};

export type MutationAddCameraToPatientArgs = {
  availableHours?: InputMaybe<Scalars['String']['input']>;
  cameraId: Scalars['ID']['input'];
  cameraProfileId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationAddCameraToSetupBatchTelluSupportArgs = {
  cameraSetupInput: CameraSetupInput;
};

export type MutationAddCareTeamArgs = {
  careTeam: CreateCareTeamInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationAddDefaultRolesToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type MutationAddExternalDialoggUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  username: Scalars['ID']['input'];
};

export type MutationAddExternalHumanTypeToHealthProviderArgs = {
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationAddExternalIdPArgs = {
  idP: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddExternalIdentityProviderToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: ExternalIdentityProviderForHealthProviderCreateInput;
};

export type MutationAddExternalPatientIdToPatientArgs = {
  externalPatientId: ExternalHumanIdInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddExternalUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  userId: Scalars['ID']['input'];
};

export type MutationAddGooglemapsAccountToHealthProviderArgs = {
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationAddMorpheanAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  morpheanAccountId: Scalars['ID']['input'];
};

export type MutationAddMqttDeviceToPatientArgs = {
  mqttDeviceId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationAddMyExternalIdArgs = {
  externalUserId: ExternalHumanIdInput;
};

export type MutationAddNextOfKinArgs = {
  nextOfKinInput: CreateNextOfKinInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddNotesToAlarmArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddNotesToTaskArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddNotesToTechnicalAlarmArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddPatientByExternalIdArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createDialoggAccount?: InputMaybe<Scalars['Boolean']['input']>;
  externalPatientId: ExternalHumanIdInput;
  patientGroupId: Scalars['ID']['input'];
};

export type MutationAddPatientContactArgs = {
  contact: CreateContactInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPlannedReminderArgs = {
  input: PlannedReminderCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPlannedSupervisionArgs = {
  input: PlannedSupervisionCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPlannedVideoMeetingArgs = {
  input: PlannedVideoMeetingCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddReferenceRangeToPatientArgs = {
  patientId: Scalars['ID']['input'];
  referenceRange: PatientReferenceRangeInput;
};

export type MutationAddRpmMedicalDeviceToPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationAddSafemateAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  safemateAccountId: Scalars['ID']['input'];
};

export type MutationAddSendGridAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  sendGridAccountId: Scalars['ID']['input'];
};

export type MutationAddShareSkyresponseAlarmWithPatientArgs = {
  patientId: Scalars['ID']['input'];
  shareWithPatientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type MutationAddTagToPatientArgs = {
  patientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type MutationAddTcifAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  tcifAccountId: Scalars['ID']['input'];
};

export type MutationAddTwilioAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  twilioAccountId: Scalars['ID']['input'];
};

export type MutationAddUserGroupContactArgs = {
  contact: CreateContactInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationAddUserReservationArgs = {
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddUserToRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddVideoMeetingTaskNotesArgs = {
  note: Array<InputMaybe<AnnotationInput>>;
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationAddVideonorAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  videonorAccountId: Scalars['ID']['input'];
};

export type MutationAddWelfareDeviceToPatientArgs = {
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
};

export type MutationAssignExternalAccessToForwarderArgs = {
  externalAccessId: Scalars['ID']['input'];
  forwarderConfigId: Scalars['ID']['input'];
};

export type MutationAssignForwarderToPatientGroupsArgs = {
  forwarderConfigId: Scalars['ID']['input'];
  patientGroupIds: Array<Scalars['ID']['input']>;
};

export type MutationAssignIntegrationToSkyresponseConfigArgs = {
  integrationId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationAssignPatientToDialoggUserArgs = {
  patientId: Scalars['ID']['input'];
  username: Scalars['ID']['input'];
};

export type MutationAttachCompletionOptionToAlarmTemplateArgs = {
  alarmTemplateId: Array<Scalars['ID']['input']>;
  completionOptionId: Scalars['ID']['input'];
};

export type MutationCameraAppBulkUpdateArgs = {
  appUpdates: Array<CameraAppUpdateInput>;
  cameras: Array<CameraManagementInput>;
};

export type MutationCameraAudioSettingsBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
  settings: CameraAudioSettingsInput;
};

export type MutationCameraConfigureTwoWayAudioArgs = {
  cameras: Array<CameraManagementInput>;
  revert?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCameraFirmwareBulkUpgradeArgs = {
  cameras: Array<CameraManagementInput>;
  firmwareUpgradeOptions: CameraFirmwareUpgradeInput;
};

export type MutationCameraIoPortConfigurationBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
  settings: CameraIoPortConfigurationSettingsInput;
};

export type MutationCameraNetworkingBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
};

export type MutationCameraRebootBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
};

export type MutationCameraRotationBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
  settings: CameraRotationSettingsInput;
};

export type MutationCancelCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationCancelDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCancelOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCancelPatientReminderArgs = {
  reminderId: Scalars['ID']['input'];
};

export type MutationCancelSkyresponseSyncAlarmArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationCancelVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationChangePicturePermissionArgs = {
  enabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type MutationCompleteAlarmArgs = {
  completionInput?: InputMaybe<CompleteAlarmInput>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompleteCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationCompleteCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCompleteCompositeTaskArgs = {
  journal?: InputMaybe<JournalInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompleteCompositeTaskAndItsSubTasksArgs = {
  journal?: InputMaybe<JournalInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompletePatientReminderArgs = {
  reminderId: Scalars['ID']['input'];
};

export type MutationCompleteSubTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationConfigureCameraEventsArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationCorrectValidationRulesArgs = {
  healthProviderName: Scalars['String']['input'];
};

export type MutationCreateAlarmForwarderArgs = {
  forwarderInput?: InputMaybe<ForwarderCreateInput>;
  id: Scalars['ID']['input'];
};

export type MutationCreateAlarmSubscriptionArgs = {
  createInput: AlarmSubscriptionCreateInput;
};

export type MutationCreateAlarmTemplateArgs = {
  input: AlarmTemplateCreateInput;
};

export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};

export type MutationCreateAzureAccountArgs = {
  input: ExternalIdentityProviderAzureForHealthProviderCreateInput;
};

export type MutationCreateCameraArgs = {
  createInput: CreateCameraInput;
};

export type MutationCreateCameraEventConfigArgs = {
  cameraId: Scalars['ID']['input'];
  input: CameraEventConfigInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreateCameraProfileArgs = {
  input: CameraProfileInput;
};

export type MutationCreateCameraPtzProfileArgs = {
  cameraId: Scalars['ID']['input'];
  input: CreateCameraPtzProfileInput;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateCameraViewPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationCreateCarePlanBasedOnExistingArgs = {
  existingCarePlanId: Scalars['ID']['input'];
  newCarePlanTitle: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationCreateCarePlanForPatientArgs = {
  createInput?: InputMaybe<CarePlanInput>;
};

export type MutationCreateCarePlanTemplateArgs = {
  createInput: CarePlanTemplateInput;
};

export type MutationCreateCarePlanTemplateBasedOnExistingArgs = {
  basedOn: Scalars['ID']['input'];
  newTitle: Scalars['String']['input'];
};

export type MutationCreateCepEventConfigArgs = {
  input: CepEventConfigInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreateCmpAccountArgs = {
  input: CmpAccountCreateInput;
};

export type MutationCreateCommunicationArgs = {
  communication: PersonnelCommunicationInput;
};

export type MutationCreateCommunicationToSeveralArgs = {
  communication: PersonnelCommunicationToSeveralInput;
};

export type MutationCreateCompletionOptionArgs = {
  text: Scalars['String']['input'];
};

export type MutationCreateCustomerArgs = {
  customer: CustomerInput;
};

export type MutationCreateDefaultRoleDefinitionArgs = {
  createInput: DefaultRoleDefinitionCreateInput;
};

export type MutationCreateDeviceGroupArgs = {
  createInput: DeviceGroupCreateInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateDialoggUserArgs = {
  dialoggUser: CreateDialoggUserInput;
};

export type MutationCreateDocumentArgs = {
  createInput: DocumentReferenceInput;
};

export type MutationCreateExternalAccessArgs = {
  input: CreateExternalAccessInput;
};

export type MutationCreateExternalHumanIdTypeArgs = {
  input: ExternalHumanIdTypeCreateInput;
};

export type MutationCreateForwarderAlarmRoutesArgs = {
  forwarderConfigId: Scalars['String']['input'];
  forwarderRoutes: Array<ForwarderRouteInput>;
};

export type MutationCreateGooglemapsAccountArgs = {
  input: GooglemapsAccountCreateInput;
};

export type MutationCreateHealthProviderArgs = {
  healthProvider: HealthProviderInput;
};

export type MutationCreateHelseIdAccountArgs = {
  input: HelseIdAccountCreateInput;
};

export type MutationCreateIntegrationArgs = {
  input: IntegrationCreateInput;
};

export type MutationCreateJournalConfigForUserGroupArgs = {
  input: JournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationCreateMorpheanAccountArgs = {
  input: MorpheanAccountCreateInput;
};

export type MutationCreateMqttDeviceArgs = {
  createInput: MqttDeviceCreateInput;
};

export type MutationCreateObservationForActivityInCarePlanArgs = {
  observationActivityInput?: InputMaybe<ObservationInput>;
};

export type MutationCreateObservationForActivityInCarePlanTemplateArgs = {
  observationActivityInput?: InputMaybe<ObservationInput>;
};

export type MutationCreateObservationTemplateArgs = {
  observationInput: ObservationInput;
};

export type MutationCreatePatientArgs = {
  patientGroupIds: Array<Scalars['ID']['input']>;
  patientInput?: InputMaybe<CreatePatientInput>;
};

export type MutationCreatePatientEventConfigArgs = {
  input: PatientEventConfigInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreatePatientGoalsArgs = {
  goalInput: GoalInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreatePatientGroupArgs = {
  createInput: PatientGroupInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreatePatientInGroupArgs = {
  patientGroup: Scalars['ID']['input'];
  patientInput?: InputMaybe<CreatePatientInput>;
};

export type MutationCreatePatientMedicalStatesArgs = {
  medicalStateInput: MedicalStatesInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireForActivityInCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireForActivityInCarePlanTemplateArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireTemplateArgs = {
  createInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationCreateRegistryDeviceArgs = {
  registryDeviceInput: RegistryDeviceInput;
};

export type MutationCreateRoleArgs = {
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationCreateRoleDefinitionArgs = {
  createInput: RoleDefinitionCreateInput;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationCreateRpmMedicalDeviceArgs = {
  createInput: RpmMedicalDeviceCreateInput;
};

export type MutationCreateSafemateAccountArgs = {
  input: SafemateAccountCreateInput;
};

export type MutationCreateSelfTreatmentPlanTemplateArgs = {
  selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput;
};

export type MutationCreateSendGridAccountArgs = {
  input: SendGridAccountCreateInput;
};

export type MutationCreateShiftSessionForPatientGroupsArgs = {
  patientGroupIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateSkyresponseAccountArgs = {
  input: SkyresponseAccountCreateInput;
};

export type MutationCreateSkyresponseOrganizationNoteArgs = {
  input: SkyresponseOrganizationNoteInput;
};

export type MutationCreateTcifAccountArgs = {
  input: TcifAccountCreateInput;
};

export type MutationCreateTemplateVkpCodesArgs = {
  input: TemplateVkpCodesInput;
  templateId: Scalars['ID']['input'];
};

export type MutationCreateTimeLimitedFhirCredentialsForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationCreateTopLevelRolesForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateTranscareUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationCreateTwilioAccountArgs = {
  input: TwilioAccountCreateInput;
};

export type MutationCreateUnplannedSupervisionArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationCreateUserArgs = {
  userInput: UserCreateInput;
};

export type MutationCreateUserGroupArgs = {
  parentId: Scalars['ID']['input'];
  userGroup: CreateUserGroupInput;
};

export type MutationCreateUserManualArgs = {
  createInput: CreateUserManualInput;
};

export type MutationCreateVideonorAccountArgs = {
  input: VideonorAccountCreateInput;
};

export type MutationCreateVkpAccountArgs = {
  input: VkpAccountInput;
};

export type MutationCreateWelfareDeviceArgs = {
  createInput: WelfareDeviceCreateInput;
};

export type MutationCreateWhiteLabelingTemplateArgs = {
  input: CreateWhiteLabelingTemplateInput;
};

export type MutationDeactivateDialoggUserSmsOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeactivateSelfTreatmentPlanArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type MutationDeactivateSmsOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDecommissionCamerasArgs = {
  cameras: Array<CameraManagementInputWithOptionalId>;
};

export type MutationDeleteAlarmSubscriptionArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAppDeviceForPatientArgs = {
  appDeviceId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCameraProfileArgs = {
  id: Scalars['ID']['input'];
  replacementCameraProfileId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteCameraPtzProfileArgs = {
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};

export type MutationDeleteCameraViewPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationDeleteCmpAccountArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteCompletionOptionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ID']['input'];
};

export type MutationDeleteDefaultRoleDefinitionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDeviceGroupArgs = {
  deviceGroupId: Scalars['ID']['input'];
};

export type MutationDeleteDialoggUserArgs = {
  username: Scalars['ID']['input'];
};

export type MutationDeleteDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteDraftCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationDeleteDraftCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEscalationDelayArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteEventConfigArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalAccessByIdArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalHumanIdTypeArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteExternalIdPArgs = {
  idP: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationDeleteExternalIdentityProviderFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalIdentityProviderRedirectorFromHealthProviderArgs = {
  isPatientRealm: Scalars['Boolean']['input'];
  realmName: Scalars['String']['input'];
  redirectorId: Scalars['String']['input'];
};

export type MutationDeleteForwarderArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteForwarderAlarmRouteArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteGooglemapsAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDeleteHelseIdAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInconsistentHealthProviderArgs = {
  report: InconsistentHealthProviderReportInput;
};

export type MutationDeleteIntegrationArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteJournalConfigForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteMorpheanAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMqttDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteNextOfKinArgs = {
  nokId: Scalars['ID']['input'];
};

export type MutationDeleteObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeletePatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationDeleteQuestionnaireResponseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRegistryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationDeleteRoleArgs = {
  roleId: Scalars['ID']['input'];
};

export type MutationDeleteRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSafemateAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSendGridAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSkyresponseAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSkyresponseOrganizationNoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTcifAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTwilioAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationDeleteUserGroupArgs = {
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteUserManualArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVideonorAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVkpAccountArgs = {
  vkpAccountId: Scalars['ID']['input'];
};

export type MutationDeleteWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWhiteLabelingTemplateArgs = {
  templateId: Scalars['ID']['input'];
};

export type MutationDisableAlarmStreamingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableAlmaIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableApplicationArgs = {
  application: Application;
};

export type MutationDisableAscomIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableBestIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableBetaArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableCmpArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableContinuousSupervisionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableCoordcomIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableDataAnalyticsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableDemoAnonymizationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableEntraIdProvisioningArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableEntraIdSsoArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableFeatureFlagArgs = {
  flag: FeatureFlag;
};

export type MutationDisableFurnitureDetectionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableIpOmsorgIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableJoinNhnMeetingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableNewSupervisionUserTabsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisablePatientCamerasArgs = {
  camerasReactivateAt: Scalars['dateTime']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationDisablePhoniroCloudIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableSelfTreatmentPlanArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableSendNotificationToNextOfKinArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableServiceForPatientArgs = {
  patientId: Scalars['ID']['input'];
  service: Scalars['String']['input'];
};

export type MutationDisableSipIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableSkyresponsePartnerIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableTietoLmoIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableTrendsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableUmo2GIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableUserAuthSettingArgs = {
  setting: UserAuthSetting;
};

export type MutationDisableUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationEnableAlarmStreamingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableAlmaIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableApplicationArgs = {
  application: Application;
};

export type MutationEnableAscomIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableBestIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableBetaArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableCmpArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableContinuousSupervisionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableCoordcomIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableDataAnalyticsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableDemoAnonymizationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableEntraIdProvisioningArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableEntraIdSsoArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableFeatureFlagArgs = {
  flag: FeatureFlag;
};

export type MutationEnableFurnitureDetectionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableIpOmsorgIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableJoinNhnMeetingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableNewSupervisionUserTabsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnablePatientCamerasArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationEnablePhoniroCloudIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableSelfTreatmentPlanArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableSendNotificationToNextOfKinArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableServiceForPatientArgs = {
  patientId: Scalars['ID']['input'];
  service: Scalars['String']['input'];
};

export type MutationEnableSipIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableSkyresponsePartnerIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableTietoLmoIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableTrendsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableUmo2GIntegrationArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableUserAuthSettingArgs = {
  setting: UserAuthSetting;
};

export type MutationEnableUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationEndJoinVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationEndVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationExecuteDatabaseSchemaSyncArgs = {
  healthProviderNames: Array<Scalars['String']['input']>;
};

export type MutationExecuteMigrationArgs = {
  healthProviderNames?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationId: Scalars['ID']['input'];
};

export type MutationExtendAlarmTimerArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationForceDeleteDialoggUserArgs = {
  username: Scalars['ID']['input'];
};

export type MutationHideTechnicalAlarmNotificationsForPatientGroupArgs = {
  hideTechnicalAlarmNotifications: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationImportAlarmTemplatesArgs = {
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
  fhirAlarmTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationImportAlarmTemplatesFromDefaultArgs = {
  alarmTemplateCodes: Array<Scalars['String']['input']>;
};

export type MutationImportDevicesFromSafemateProArgs = {
  createInput: ImportDevicesInput;
};

export type MutationImportEventForPatientRawArgs = {
  input: PatientEventRaw;
  patientId: Scalars['ID']['input'];
};

export type MutationImportMeasurementTemplatesFromDefaultArgs = {
  measurementTemplateCodes: Array<Scalars['String']['input']>;
};

export type MutationImportObservationTemplatesArgs = {
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
  fhirTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationInitializeExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  input: CreateExternalAccessInput;
};

export type MutationInviteToVideoMeetingArgs = {
  participants: Array<InputMaybe<AppointmentParticipantInput>>;
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationKeepAudioStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationKeepBoundingBoxStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationKeepRawDataStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationKeepStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationKeepZoneStateStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationLogLocalExportArgs = {
  count: Scalars['Int']['input'];
  resourceType: Scalars['String']['input'];
};

export type MutationMarkCommunicationAsReadArgs = {
  communicationId: Scalars['ID']['input'];
};

export type MutationMarkHealthProviderForDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationMarkNextOfKinAsMainArgs = {
  nokId: Scalars['ID']['input'];
};

export type MutationMoveAccessGroupArgs = {
  attachToUserGroup: Scalars['String']['input'];
  userGroupToMove: Scalars['String']['input'];
};

export type MutationNotifyNextOfKinsArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationOpenPatientGroupsForExternalAccessArgs = {
  input: UpdateExternalAccessInput;
};

export type MutationOrderPatientContactsArgs = {
  orderedContactIds: Array<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationOrderUserGroupContactsArgs = {
  orderedContactIds: Array<Scalars['ID']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationPauseHealthProviderDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationPlanPatientReminderArgs = {
  input: PatientReminderCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationPlanVideoMeetingArgs = {
  createInput?: InputMaybe<VideoMeetingInput>;
  patientIds: Array<Scalars['ID']['input']>;
};

export type MutationPreviewDatabaseSchemaSyncArgs = {
  healthProviderNames: Array<Scalars['String']['input']>;
};

export type MutationRebootArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationRedoCameraSetupTelluSupportArgs = {
  serial: Scalars['String']['input'];
};

export type MutationRefreshAzureProvisioningSecretArgs = {
  azureAccountId: Scalars['ID']['input'];
};

export type MutationRegisterPushIdForShiftSessionArgs = {
  pushNotificationSettings: PushNotificationSettingsInput;
};

export type MutationRegisterPushSubscriptionArgs = {
  pushSubscription: PushSubscriptionInput;
};

export type MutationRejectCompositeTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRejectSubTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationReleaseVideoMeetingTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRemoveAccountFromCustomerArgs = {
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
};

export type MutationRemoveCameraFromPatientArgs = {
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemoveCareTeamArgs = {
  careTeamId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemoveCompletionOptionFromAlarmTemplateArgs = {
  alarmTemplateId: Array<Scalars['ID']['input']>;
  completionOptionId: Scalars['ID']['input'];
};

export type MutationRemoveDefaultRolesFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveDialoggUserPasswordArgs = {
  username: Scalars['ID']['input'];
};

export type MutationRemoveExternalDialoggUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  username: Scalars['ID']['input'];
};

export type MutationRemoveExternalHumanTypeFromHealthProviderArgs = {
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationRemoveExternalPatientIdFromPatientArgs = {
  externalPatientId: ExternalHumanIdInput;
  patientId: Scalars['ID']['input'];
};

export type MutationRemoveExternalUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  userId: Scalars['ID']['input'];
};

export type MutationRemoveGooglemapsAccountFromHealthProviderArgs = {
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationRemoveIntegrationFromSkyresponseConfigArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemoveMorpheanAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  morpheanAccountId: Scalars['ID']['input'];
};

export type MutationRemoveMqttDeviceFromPatientArgs = {
  mqttDeviceId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemoveMyExternalIdArgs = {
  externalUserId: ExternalHumanIdInput;
};

export type MutationRemovePatientContactArgs = {
  contactId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemovePatientFromDialoggUserArgs = {
  patientId: Scalars['ID']['input'];
  username: Scalars['ID']['input'];
};

export type MutationRemovePatientGroupFromUserGroupArgs = {
  patientGroupId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemovePlannedReminderArgs = {
  patientId: Scalars['ID']['input'];
  plannedReminderId: Scalars['ID']['input'];
};

export type MutationRemovePlannedSupervisionArgs = {
  alarmActivityId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemovePlannedVideoMeetingArgs = {
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
};

export type MutationRemoveReferenceRangeFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
};

export type MutationRemoveRpmMedicalDeviceFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationRemoveSafemateAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  safemateAccountId: Scalars['ID']['input'];
};

export type MutationRemoveSendGridAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  sendGridAccountId: Scalars['ID']['input'];
};

export type MutationRemoveTagFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type MutationRemoveTcifAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  tcifAccountId: Scalars['ID']['input'];
};

export type MutationRemoveTemplateVkpCodesFromTemplateArgs = {
  templateId: Scalars['ID']['input'];
};

export type MutationRemoveTwilioAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  twilioAccountId: Scalars['ID']['input'];
};

export type MutationRemoveUserFromRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveUserGroupContactArgs = {
  contactId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemoveUserReservationArgs = {
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveVideonorAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  videonorAccountId: Scalars['ID']['input'];
};

export type MutationRemoveWelfareDeviceFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
};

export type MutationReplaceWelfareDeviceIdentifierArgs = {
  id: Scalars['ID']['input'];
  input: ReplaceWelfareDeviceIdentifierInput;
};

export type MutationReschedulePatientReminderArgs = {
  input: PatientReminderRescheduleInput;
  reminderId: Scalars['ID']['input'];
};

export type MutationRescheduleVideoMeetingArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['dateTime']['input'];
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  start: Scalars['dateTime']['input'];
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationResetCameraSetupTelluSupportArgs = {
  serial: Scalars['String']['input'];
};

export type MutationResetExternalAccessSecretArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResetExternalIdentityProviderLinksForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationResetHealthProviderFlowArgs = {
  flow: HealthProviderFlow;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationResetHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
};

export type MutationResetSecretForExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationResetUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRestoreHealthProviderMarkedForDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationResumeHealthProviderDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationRetireAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetireObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetireQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryAlarmJournalingArgs = {
  alarmId: Scalars['ID']['input'];
};

export type MutationRetryTaskJournalingArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRevokeInviteToVideoMeetingArgs = {
  participants: Array<InputMaybe<AppointmentParticipantInput>>;
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationSelectWhiteLabelingTemplateForHealthProviderArgs = {
  healthProvider: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type MutationSendVideoMeetingInvitationSmsArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationSetActiveCameraPtzProfileArgs = {
  cameraId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetCameraDetectionSettingsArgs = {
  cameraId: Scalars['ID']['input'];
  input: CameraDetectionSettingsInput;
};

export type MutationSetCameraLandmarksArgs = {
  cameraId: Scalars['ID']['input'];
  input: CameraLandmarksInput;
};

export type MutationSetCameraProfileArgs = {
  cameraIds: Array<Scalars['ID']['input']>;
  cameraProfileId: Scalars['ID']['input'];
};

export type MutationSetCameraViewWithAnglesArgs = {
  cameraId: Scalars['ID']['input'];
  pan?: InputMaybe<Scalars['Float']['input']>;
  tilt?: InputMaybe<Scalars['Float']['input']>;
  zoom?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationSetCameraViewWithPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationSetDefaultCameraProfileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetDialoggUserEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type MutationSetDialoggUserExternalIdPArgs = {
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetEmailAndSmsNotificationSettingsForShiftSessionArgs = {
  notificationSettings: SessionNotificationSettingsInput;
};

export type MutationSetExternalIdPArgs = {
  idP?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetExternalIdRequestArgs = {
  externalHumanIdType: Scalars['String']['input'];
  requested: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSetExternalIdentitiesArgs = {
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetExternalIdentityProviderRedirectorFromHealthProviderArgs = {
  alias: Scalars['String']['input'];
  isPatientRealm: Scalars['Boolean']['input'];
  realmName: Scalars['String']['input'];
};

export type MutationSetPendingExternalIdentityProviderArgs = {
  externalIdentityProvider: Scalars['String']['input'];
  pending: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSetReferenceObjectsForCameraArgs = {
  cameraId: Scalars['ID']['input'];
  referenceObjects: Array<ReferenceObjectInput>;
};

export type MutationSimulateCarePlanObservationResponseArgs = {
  activityId: Scalars['ID']['input'];
  observation: ObservationInput;
  patientId: Scalars['ID']['input'];
};

export type MutationSimulateCarePlanQuestionnaireResponseArgs = {
  patientId: Scalars['ID']['input'];
  questionnaireResponseInput: QuestionnaireResponseSimulatorInput;
};

export type MutationSimulateNovoEventArgs = {
  event: NovoEventInput;
};

export type MutationSimulateSafemateEventArgs = {
  event: SafemateEventInput;
};

export type MutationSimulateSkyResponseEventArgs = {
  event: SkyresponseEventInput;
  externalAccessId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type MutationSimulateSyncEventArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  eventCode: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  payload?: InputMaybe<SimulateSyncEventPayloadInput>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSortTreeArgs = {
  nextSiblingId?: InputMaybe<Scalars['String']['input']>;
  previousSiblingId?: InputMaybe<Scalars['String']['input']>;
  userGroupToSort: Scalars['String']['input'];
};

export type MutationStartAppArgs = {
  appId: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
};

export type MutationStartAudioStreamArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationStartBoundingBoxStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationStartCompositeTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationStartJoinVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
  videoMeetingURL?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartPhoneCallArgs = {
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: PhoneCallTargetType;
};

export type MutationStartRawDataStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationStartStreamArgs = {
  cameraId: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationStartZoneStateStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationStopAppArgs = {
  appId: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
};

export type MutationStopAudioStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationStopBoundingBoxStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationStopRawDataStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationStopStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationStopZoneStateStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationSubmitAlarmHandlingFeedbackArgs = {
  alarmHandlingFeedback?: InputMaybe<AlarmHandlingFeedbackInput>;
};

export type MutationSupportTeamLinkToHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  supportTeamName: Scalars['ID']['input'];
};

export type MutationSupportTeamUnlinkFromHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  supportTeamName: Scalars['ID']['input'];
};

export type MutationSyncAlarmTemplatesArgs = {
  alarmTemplateCodes: Array<Scalars['String']['input']>;
};

export type MutationSyncPatientInfoWithSkyresponseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  syncScenario?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationSyncSpecificPatientWithSkyresponseArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationTakeCallArgs = {
  takeCallInput?: InputMaybe<TakeCallInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationTakeCameraSnapshotWithDetectionsArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationTerminateShiftSessionOnAllDevicesForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationTerminateShiftSessionOnDeviceArgs = {
  device: Scalars['String']['input'];
};

export type MutationTestAzureAccountCredentialsArgs = {
  id: Scalars['ID']['input'];
};

export type MutationTestHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
};

export type MutationTestPushNotificationArgs = {
  appDeviceId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationTriggerEventInCameraArgs = {
  appName: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['Int']['input'];
};

export type MutationTriggerResolveActionsForSyncAlarmsArgs = {
  alarmIds: Array<Scalars['ID']['input']>;
};

export type MutationUnselectWhiteLabelingTemplateForHealthProviderArgs = {
  healthProvider: Scalars['ID']['input'];
};

export type MutationUpdateAccountSettingsArgs = {
  input: UpdateAccountSettingsInput;
};

export type MutationUpdateAlarmAckTemplatesArgs = {
  alarmAckTemplates?: InputMaybe<Array<AlarmAckTemplate>>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateAlarmForwarderArgs = {
  forwarderInput?: InputMaybe<ForwarderUpdateInput>;
  id: Scalars['String']['input'];
};

export type MutationUpdateAlarmStatusArgs = {
  handlingMode?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateAlarmSubscriptionArgs = {
  updateInput: AlarmSubscriptionUpdateInput;
};

export type MutationUpdateAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
  input: AlarmTemplateUpdateInput;
};

export type MutationUpdateAlarmTemplateStatusArgs = {
  allTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newStatus: ObservationTemplateStatus;
};

export type MutationUpdateAnonymizationArgs = {
  anonymization: Scalars['Boolean']['input'];
  cameraId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAppDeviceForPatientArgs = {
  appDeviceId: Scalars['ID']['input'];
  input: AppDeviceForPatientUpdateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdateAvailableHoursArgs = {
  availableHours: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationUpdateAzureAccountArgs = {
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
};

export type MutationUpdateCameraArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<UpdateCameraInput>;
};

export type MutationUpdateCameraDeviceGroupArgs = {
  cameraId: Scalars['ID']['input'];
  deviceGroupId: Scalars['ID']['input'];
};

export type MutationUpdateCameraEventConfigArgs = {
  id: Scalars['ID']['input'];
  input: CameraEventConfigInput;
};

export type MutationUpdateCameraProfileArgs = {
  id: Scalars['ID']['input'];
  input: CameraProfileInput;
};

export type MutationUpdateCameraSettingsArgs = {
  cameraId: Scalars['ID']['input'];
  input: CameraSettingsInput;
};

export type MutationUpdateCarePlanQuestionnaireArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationUpdateCarePlanTemplateQuestionnaireArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput: QuestionnaireInput;
};

export type MutationUpdateCareTeamArgs = {
  careTeam: UpdateCareTeamInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateCepEventConfigArgs = {
  id: Scalars['ID']['input'];
  input: CepEventConfigInput;
};

export type MutationUpdateCmpAccountArgs = {
  id: Scalars['String']['input'];
  input: CmpAccountUpdateInput;
};

export type MutationUpdateCompletionOptionArgs = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationUpdateCompositeTaskPriorityArgs = {
  priority?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateCustomerArgs = {
  customer: CustomerUpdateInput;
  customerId: Scalars['ID']['input'];
};

export type MutationUpdateDefaultRoleDefinitionArgs = {
  updateInput: DefaultRoleDefinitionUpdateInput;
};

export type MutationUpdateDeviceGroupArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<DeviceGroupUpdateInput>;
};

export type MutationUpdateDeviceGroupCmpArgs = {
  cmpCredentials: CmpCredentialsInput;
  deviceGroupId: Scalars['ID']['input'];
};

export type MutationUpdateDeviceGroupForMqttDeviceArgs = {
  deviceGroupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserArgs = {
  dialoggUser: UpdateDialoggUser;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserIpRestrictionsArgs = {
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserPasswordArgs = {
  password: Scalars['String']['input'];
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserTimeLimitedAccessArgs = {
  timeLimitedAccess?: InputMaybe<PeriodInput>;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDigitalHomeVisitsSettingsForPatientArgs = {
  patientId: Scalars['ID']['input'];
  settings: DigitalHomeVisitsSettingsInput;
};

export type MutationUpdateDraftCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanInput>;
};

export type MutationUpdateDraftCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanTemplateUpdateInput>;
};

export type MutationUpdateEscalationDelayArgs = {
  escalationDelay: Scalars['Int']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateExternalAccessArgs = {
  input: UpdateNameOrIpRestrictionForExternalAccessInput;
};

export type MutationUpdateExternalHumanIdTypeArgs = {
  id: Scalars['String']['input'];
  input: ExternalHumanIdTypeUpdateInput;
};

export type MutationUpdateExternalIdRequestsOnAzureGroupArgs = {
  id: Scalars['ID']['input'];
  requestedExternalIdTypeIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MutationUpdateExternalIdentityProviderForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
};

export type MutationUpdateForwarderAlarmRouteArgs = {
  id: Scalars['String']['input'];
  input: ForwarderRouteInput;
};

export type MutationUpdateForwarderErrorHandlingArgs = {
  errorHandling: ForwarderErrorHandlingInput;
  forwarderConfigId: Scalars['ID']['input'];
};

export type MutationUpdateFurnitureDetectionAlarmSnapshotArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateGooglemapsAccountArgs = {
  id: Scalars['ID']['input'];
  input: GooglemapsAccountUpdateInput;
};

export type MutationUpdateGroupVideoMeetingParticipantsArgs = {
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  videoMeetingGroupId: Scalars['ID']['input'];
};

export type MutationUpdateHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  updateInput: HealthProviderUpdateInput;
};

export type MutationUpdateHealthProviderPatientAuthArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
};

export type MutationUpdateHealthProviderPatientSessionLifespanArgs = {
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
};

export type MutationUpdateHealthProviderRolesBasedOnDefaultRolesArgs = {
  defaultRoleIds: Array<Scalars['ID']['input']>;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationUpdateHealthProviderUserAuthArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
};

export type MutationUpdateHealthProviderUserSessionLifespanArgs = {
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
};

export type MutationUpdateHelseIdAccountArgs = {
  helseIdAccountId: Scalars['ID']['input'];
  input: HelseIdAccountUpdateInput;
};

export type MutationUpdateHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
  helseIdCredentials: HelseIdCredentialsInput;
};

export type MutationUpdateIpRestrictionsArgs = {
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateInheritedJournalConfigForUserGroupArgs = {
  input: InheritedJournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: IntegrationUpdateInput;
};

export type MutationUpdateJournalConfigForUserGroupArgs = {
  input: JournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateLinkedPatientGroupsArgs = {
  addPatientGroups: Array<Scalars['String']['input']>;
  removePatientGroups: Array<Scalars['String']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateMorpheanAccountArgs = {
  id: Scalars['ID']['input'];
  input: MorpheanAccountUpdateInput;
};

export type MutationUpdateMqttDeviceArgs = {
  id: Scalars['ID']['input'];
  updateInput: MqttDeviceUpdateInput;
};

export type MutationUpdateNameOrIpRestrictionsForExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  input: UpdateNameOrIpRestrictionForExternalAccessInput;
};

export type MutationUpdateNextOfKinArgs = {
  nextOfKinInput: UpdateNextOfKinInput;
  nokId: Scalars['ID']['input'];
};

export type MutationUpdateObservationStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type MutationUpdateObservationTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput: ObservationInput;
};

export type MutationUpdateObservationTemplateStatusArgs = {
  allTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  newStatus: ObservationTemplateStatus;
};

export type MutationUpdatePatientArgs = {
  patientId: Scalars['ID']['input'];
  patientInput?: InputMaybe<UpdatePatientInput>;
};

export type MutationUpdatePatientContactArgs = {
  contact: UpdateContactInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientEventConfigArgs = {
  id: Scalars['ID']['input'];
  input: PatientEventConfigInput;
};

export type MutationUpdatePatientGoalsArgs = {
  goalInput: UpdateGoalInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientGroupArgs = {
  id: Scalars['ID']['input'];
  updateInput: PatientGroupInput;
};

export type MutationUpdatePatientGroupsOfPatientArgs = {
  addPatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId: Scalars['ID']['input'];
  removePatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdatePatientLastActiveArgs = {
  lastActive?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientMedicalStatesArgs = {
  medicalStateInput: MedicalStatesInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientReferenceRangeArgs = {
  patientId: Scalars['ID']['input'];
  referenceRange: Array<InputMaybe<ObservationComponentInput>>;
  referenceRangeId: Scalars['ID']['input'];
};

export type MutationUpdatePendingExternalIdentityProvidersOnAzureGroupArgs = {
  id: Scalars['ID']['input'];
  pendingExternalIdentityProviders: Array<Scalars['String']['input']>;
};

export type MutationUpdatePlannedReminderArgs = {
  input: PlannedReminderUpdateInput;
  patientId: Scalars['ID']['input'];
  plannedReminderId: Scalars['ID']['input'];
};

export type MutationUpdatePlannedSupervisionArgs = {
  alarmActivityId: Scalars['ID']['input'];
  input: PlannedSupervisionUpdateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePlannedVideoMeetingArgs = {
  input: PlannedVideoMeetingUpdateInput;
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
};

export type MutationUpdateQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationUpdateRegistryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updateInput: RoleDefinitionUpdateInput;
};

export type MutationUpdateRoleDefinitionBasedOnArgs = {
  basedOn: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationUpdateRolesOnAzureGroupArgs = {
  id: Scalars['ID']['input'];
  roleIds: Array<Scalars['String']['input']>;
};

export type MutationUpdateRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
  updateInput: RpmMedicalDeviceUpdateInput;
};

export type MutationUpdateSafemateAccountArgs = {
  id: Scalars['ID']['input'];
  input: SafemateAccountUpdateInput;
};

export type MutationUpdateSelfTreatmentPlanTemplateArgs = {
  selfTreatmentPlanTemplateId: Scalars['ID']['input'];
  selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput;
};

export type MutationUpdateSendGridAccountArgs = {
  id: Scalars['ID']['input'];
  input: SendGridAccountUpdateInput;
};

export type MutationUpdateShiftSessionPhoneNumberArgs = {
  shiftSessionPhoneNumber: Scalars['String']['input'];
};

export type MutationUpdateSkyresponseAccountArgs = {
  id: Scalars['ID']['input'];
  input: SkyresponseAccountUpdateInput;
};

export type MutationUpdateSkyresponseConfigArgs = {
  skyresponseConfig: SkyresponseConfigInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateSkyresponseOrganizationNoteArgs = {
  id: Scalars['ID']['input'];
  input: SkyresponseOrganizationNoteInput;
};

export type MutationUpdateSubTaskPriorityArgs = {
  priority?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTaskPresenceAtArgs = {
  taskId: Scalars['ID']['input'];
  when?: InputMaybe<Scalars['dateTime']['input']>;
};

export type MutationUpdateTcifAccountArgs = {
  id: Scalars['ID']['input'];
  input: TcifAccountUpdateInput;
};

export type MutationUpdateTechnicalAlarmStatusArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTemplateVkpCodesArgs = {
  input: TemplateVkpCodesInput;
  templateId: Scalars['ID']['input'];
};

export type MutationUpdateTwilioAccountArgs = {
  id: Scalars['ID']['input'];
  input: TwilioAccountUpdateInput;
};

export type MutationUpdateUserArgs = {
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
};

export type MutationUpdateUserGroupArgs = {
  userGroup: UpdateUserGroupInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateUserGroupContactArgs = {
  contact: UpdateContactInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateUserManualArgs = {
  id: Scalars['ID']['input'];
  updateInput: UpdateUserManualInput;
};

export type MutationUpdateUserPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUpdateUserTimeLimitedAccessArgs = {
  timeLimitedAccess?: InputMaybe<PeriodInput>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateVideonorAccountArgs = {
  id: Scalars['ID']['input'];
  input: VideonorAccountUpdateInput;
};

export type MutationUpdateVkpAccountArgs = {
  input: VkpAccountInput;
  vkpAccountId: Scalars['ID']['input'];
};

export type MutationUpdateWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
  updateInput: WelfareDeviceUpdateInput;
};

export type MutationUpdateWhiteLabelingTemplateArgs = {
  input: UpdateWhiteLabelingTemplateInput;
  templateId: Scalars['ID']['input'];
};

export type MutationValidateCmpAccountTowardsCmpArgs = {
  id: Scalars['String']['input'];
};

export type MutationValidateCustomerGroupTowardsCmpArgs = {
  id: Scalars['String']['input'];
};

export type MutationValidateForwarderArgs = {
  id: Scalars['String']['input'];
};

export type MutationResponseWithPagination = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  next?: Maybe<PaginationNext>;
  skip?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NetworkMangementStatus = {
  allowOldTLS: Scalars['Boolean']['output'];
  bandwidthLimit: Scalars['Boolean']['output'];
  bonjour: Scalars['Boolean']['output'];
  dot1x: Scalars['Boolean']['output'];
  ftp: Scalars['Boolean']['output'];
  https: Scalars['Boolean']['output'];
  isHardened: Scalars['Boolean']['output'];
  ssh: Scalars['Boolean']['output'];
  upnp: Scalars['Boolean']['output'];
  zeroConf: Scalars['Boolean']['output'];
};

export type NextOfKin = {
  active: Scalars['Boolean']['output'];
  address?: Maybe<Array<Address>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isMain: Scalars['Boolean']['output'];
  name?: Maybe<Array<HumanName>>;
  notifyNextOfKin?: Maybe<Scalars['Boolean']['output']>;
  patient: Reference;
  relationship?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type NextOfKinExport = {
  main?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  smsNotification?: Maybe<Scalars['Boolean']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type NextOfKinImport = {
  id: Scalars['ID']['output'];
  name?: Maybe<Array<HumanName>>;
};

export type NextOfKinMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<NextOfKin>;
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  inactiveSeconds?: Maybe<Scalars['Int']['output']>;
  inactiveSecondsSetBy?: Maybe<Scalars['String']['output']>;
  missedSubmissionSeconds?: Maybe<Scalars['Int']['output']>;
  missedSubmissionSecondsSetBy?: Maybe<Scalars['String']['output']>;
};

export type NotificationInput = {
  inactiveSeconds?: InputMaybe<Scalars['Int']['input']>;
  missedSubmissionSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationLog = {
  alarmId?: Maybe<Scalars['String']['output']>;
  apiStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  relatedPersonId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetEmailAddress?: Maybe<Scalars['String']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  twilioId?: Maybe<Scalars['String']['output']>;
  twilioPrice?: Maybe<Scalars['String']['output']>;
  twilioPriceUnit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  useCase?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NotificationLogResponse = {
  messageStatus: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type NotificationSettings = {
  deviation?: Maybe<Scalars['Boolean']['output']>;
  measurement?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['Boolean']['output']>;
  reminder?: Maybe<Scalars['Int']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  videoMeetingReminder?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationSettingsInput = {
  deviation?: InputMaybe<Scalars['Boolean']['input']>;
  measurement?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  reminder?: InputMaybe<Scalars['Int']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  videoMeetingReminder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NovoEventInput = {
  cha?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  did?: InputMaybe<Scalars['String']['input']>;
  dte?: InputMaybe<Scalars['String']['input']>;
  dty?: InputMaybe<Scalars['String']['input']>;
  dty_description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  ite?: InputMaybe<Scalars['String']['input']>;
  lco?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mty?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  stc?: InputMaybe<Scalars['String']['input']>;
  stc_description?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
};

export type Observation = {
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  code?: Maybe<CodeableConcept>;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  device?: Maybe<Reference>;
  effectiveDateTime?: Maybe<Scalars['dateTime']['output']>;
  effectiveTiming?: Maybe<Timing>;
  fromTemplate?: Maybe<Reference>;
  gateway?: Maybe<Reference>;
  handlingStatuses: Array<AlarmHandlingStatus>;
  hasPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  instantiates?: Maybe<Array<Maybe<Reference>>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  manual?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  payload?: Maybe<Scalars['String']['output']>;
  performer?: Maybe<Array<Maybe<Reference>>>;
  received?: Maybe<Scalars['dateTime']['output']>;
  status: Scalars['String']['output'];
  subject?: Maybe<Reference>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<Reference>;
  taskPriority?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponent = {
  code: CodeableConcept;
  dataAbsentReason?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  referenceRange?: Maybe<Array<Maybe<ReferenceRange>>>;
  valueQuantity?: Maybe<ValueQuantity>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponentInput = {
  code?: InputMaybe<CodeableConceptInput>;
  dataAbsentReason?: InputMaybe<CodeableConceptInput>;
  extension?: InputMaybe<Array<ExtensionInput>>;
  referenceRange?: InputMaybe<Array<InputMaybe<ReferenceRangeInput>>>;
  valueQuantity?: InputMaybe<ValueQuantityInput>;
};

export type ObservationInput = {
  basedOn?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  code?: InputMaybe<CodeableConceptInput>;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  effectiveDateTime?: InputMaybe<Scalars['dateTime']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  fromTemplate?: InputMaybe<ReferenceInput>;
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  instantiates?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  performer?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  subject?: InputMaybe<ReferenceInput>;
};

export type ObservationMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Observation>;
  success: Scalars['Boolean']['output'];
};

export enum ObservationTemplateStatus {
  Cancelled = 'cancelled',
  Final = 'final',
  Preliminary = 'preliminary',
}

export type ObservationsCsv = {
  csv?: Maybe<Scalars['String']['output']>;
};

export type OptionCoding = {
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
};

export type OptionCodingInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
};

export type OptionCodingSimulatorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationNext = {
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
};

export type PasswordPolicy = {
  digits?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lowerCase?: Maybe<Scalars['Int']['output']>;
  regexPattern?: Maybe<Scalars['String']['output']>;
  upperCase?: Maybe<Scalars['Int']['output']>;
};

export type Patient = {
  active: Scalars['Boolean']['output'];
  address?: Maybe<Array<Maybe<Address>>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  alarmRoutes?: Maybe<Array<AlarmRoute>>;
  areCamerasEnabled: Scalars['Boolean']['output'];
  birthDate?: Maybe<Scalars['date']['output']>;
  cameras?: Maybe<Array<Maybe<CameraWithStatus>>>;
  camerasDisabledAt?: Maybe<Scalars['dateTime']['output']>;
  camerasReactivateAt?: Maybe<Scalars['dateTime']['output']>;
  camerasStateOrigin?: Maybe<CameraStateOrigin>;
  carePlans?: Maybe<Array<Maybe<CarePlan>>>;
  contacts?: Maybe<CombinedPatientContacts>;
  dialoggUser?: Maybe<DialoggUser>;
  documents?: Maybe<Array<Maybe<DocumentReference>>>;
  externalPatientIds?: Maybe<Array<ExternalHumanId>>;
  gender?: Maybe<AdministrativeGender>;
  hasSkyresponseSyncFailed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  isMemberOfUnaccessiblePatientGroups?: Maybe<Scalars['Boolean']['output']>;
  journalConfigForPatient?: Maybe<JournalConfigForPatient>;
  keyCode?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Language>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastSupervisionPerformedByUserId?: Maybe<Scalars['String']['output']>;
  lastSupervisionTimestamp?: Maybe<Scalars['dateTime']['output']>;
  link?: Maybe<Array<Link>>;
  maritalStatus?: Maybe<CodeableConcept>;
  name?: Maybe<Array<HumanName>>;
  nextOfKin?: Maybe<Array<NextOfKin>>;
  note?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  photo?: Maybe<Array<Maybe<Attachment>>>;
  referenceRange?: Maybe<Array<Maybe<Observation>>>;
  responderIsPresent?: Maybe<Scalars['Boolean']['output']>;
  rpmMedicalDevices?: Maybe<Array<RpmMedicalDevice>>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  shareAlarmWith?: Maybe<Array<ShareAlarmWidth>>;
  skyresponseDetails?: Maybe<SkyresponseConfig>;
  skyresponseSyncOpenAlarms?: Maybe<Array<Maybe<SkyresponseSyncAlarm>>>;
  skyresponseSyncStatus?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  userReservations?: Maybe<Array<Maybe<UserReservation>>>;
  welfareDevices?: Maybe<Array<WelfareDevice>>;
};

export type PatientCarePlansArgs = {
  carePlanStatus?: InputMaybe<CarePlanStatus>;
};

export type PatientBundle = {
  bundle: Scalars['String']['output'];
};

export type PatientByIdentityResponse = {
  found?: Maybe<Scalars['Boolean']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  patient?: Maybe<PatientLess>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientEmbeddedRequestResponse = {
  link?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PatientEventConfig = {
  code: Scalars['String']['output'];
  createdAt: Scalars['dateTime']['output'];
  displayText: Scalars['String']['output'];
  generatesAlarm: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientId: Scalars['ID']['output'];
  priority: EventConfigPriority;
  schedule?: Maybe<EventConfigSchedule>;
  type: PatientEventConfigEventType;
  updatedAt: Scalars['dateTime']['output'];
  workflow: EventConfigWorkflow;
};

export enum PatientEventConfigEventType {
  Safemate = 'safemate',
  Scaip = 'scaip',
  Skyresponse = 'skyresponse',
}

export type PatientEventConfigInput = {
  code: Scalars['String']['input'];
  displayText: Scalars['String']['input'];
  generatesAlarm: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  priority: EventConfigPriorityInput;
  schedule?: InputMaybe<EventConfigScheduleInput>;
  type: PatientEventConfigEventType;
  workflow: EventConfigWorkflow;
};

export type PatientEventConfigMutationResponse = {
  eventConfig?: Maybe<PatientEventConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PatientEventRaw = {
  alarmId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  effective?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalType?: InputMaybe<Scalars['String']['input']>;
  fhirId?: InputMaybe<Scalars['String']['input']>;
  observationType?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  received?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type PatientExport = {
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Maybe<Address>>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  areCamerasEnabled: Scalars['Boolean']['output'];
  birthDate?: Maybe<Scalars['date']['output']>;
  contacts?: Maybe<Array<ContactsExport>>;
  createdAt?: Maybe<Scalars['dateTime']['output']>;
  devices: Array<DeviceExport>;
  externalIds: Array<ExternalIdExport>;
  fhirId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<AdministrativeGender>;
  keyCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nextOfKins?: Maybe<Array<NextOfKinExport>>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  patientNote?: Maybe<Scalars['String']['output']>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  updatedAt?: Maybe<Scalars['dateTime']['output']>;
};

export type PatientForImport = {
  contacts?: Maybe<Array<ContactsImport>>;
  externalIds: Array<ExternalIdExport>;
  id: Scalars['ID']['output'];
  nextOfKins: Array<NextOfKinImport>;
  patientGroups: Array<PatientGroupPatientsWithoutAuditLog>;
};

export type PatientGroup = {
  alarmRoutes: Array<AlarmRoute>;
  hideTechnicalAlarmNotifications?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patientsCount?: Maybe<Scalars['Int']['output']>;
};

export type PatientGroupIdAndName = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PatientGroupInput = {
  name: Scalars['String']['input'];
};

export type PatientGroupLess = {
  hideTechnicalAlarmNotifications?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientGroupMutationOutcome = {
  message: Scalars['String']['output'];
  patientGroupId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PatientGroupMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patientGroup?: Maybe<PatientGroup>;
  success: Scalars['Boolean']['output'];
};

export type PatientGroupPatientsWithoutAuditLog = {
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PatientGroupsMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<Maybe<PatientGroupMutationOutcome>>>;
  success: Scalars['Boolean']['output'];
};

export type PatientLess = {
  active: Scalars['Boolean']['output'];
  address: Array<Maybe<Address>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  enabledServices: Array<Scalars['String']['output']>;
  gender?: Maybe<AdministrativeGender>;
  id?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  keyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Array<HumanName>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  telecom: Array<Maybe<ContactPoint>>;
};

export type PatientLinkData = {
  patientId: Scalars['String']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient: Scalars['Boolean']['output'];
};

export type PatientListCmpSensor = {
  day: Scalars['dateTime']['output'];
  modelName: Scalars['String']['output'];
  modelValue: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type PatientListDevice = {
  deviceType?: Maybe<Scalars['String']['output']>;
  isSharedDevice?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientListExternalIds = {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientListFeatures = {
  cmpSensors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  success: Scalars['Boolean']['output'];
};

export type PatientReferenceRangeInput = {
  code?: InputMaybe<CodeableConceptInput>;
  component: Array<InputMaybe<ObservationComponentInput>>;
  fromTemplate: ReferenceInput;
  identifier: Array<InputMaybe<IdentifierInput>>;
  subject: ReferenceInput;
};

export type PatientReminderCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /**
   * The reminder covers the whole day: it is stored spanning the day the start falls on, in the
   * health provider's time zone, and no notification is sent for it. Defaults to false.
   */
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minutesBeforeReminder?: InputMaybe<Scalars['Int']['input']>;
  /**  The patient has to acknowledge the reminder before it is completed. Defaults to false.  */
  requiresAcknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['dateTime']['input'];
};

export type PatientReminderMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Appointment>;
  success: Scalars['Boolean']['output'];
};

export type PatientReminderRescheduleInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minutesBeforeReminder?: InputMaybe<Scalars['Int']['input']>;
  /**  An omitted flag leaves the stored value alone.  */
  requiresAcknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['dateTime']['input'];
};

export type PatientReminderResult = {
  id: Scalars['ID']['output'];
  reminder: Appointment;
};

export type PatientRemindersPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  hasMore: Scalars['Boolean']['output'];
  reminders: Array<Appointment>;
};

export type PatientStats = {
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type PatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<PatientStats>;
};

export type PatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type PatientSupervisionCamera = {
  deviceGroupName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  macAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientTaskAndHpTasks = {
  hpTasks: Array<Scalars['String']['output']>;
  task: Task;
};

export type PatientUserGroup = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PatientUserGroups = {
  patientId: Scalars['ID']['output'];
  userGroups: Array<PatientUserGroup>;
};

export type PatientVkp = {
  address?: Maybe<Array<Address>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  externalPatientIds?: Maybe<Array<ExternalHumanId>>;
  gender?: Maybe<AdministrativeGender>;
  hasSecretAddress?: Maybe<Scalars['Boolean']['output']>;
  keyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Array<HumanName>>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type PatientVkpResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<PatientVkp>;
  success: Scalars['Boolean']['output'];
};

export type PatientWithAlarms = {
  openPatientAlarms: Array<Task>;
  openTechnicalAlarms: Array<Task>;
  patient: Patient;
};

export type PatientWithAlarmsAndDevices = {
  cameras: Array<CameraWithStatusForAlarm>;
  devices: Array<WelfareDevice>;
  openCameraTechnicalAlarms: Array<Task>;
  openDeviceTechnicalAlarms: Array<Task>;
  openPatientAlarms: Array<Task>;
  patient: Patient;
  patientGroups: Array<Scalars['String']['output']>;
};

export type PendingExternalIdentityProvider = {
  pending: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
};

export type Period = {
  end?: Maybe<Scalars['dateTime']['output']>;
  start?: Maybe<Scalars['dateTime']['output']>;
};

export type PeriodInput = {
  /**  Absent leaves a stored end as it is; an explicit null clears it, which is how a recurrence is made open-ended.  */
  end?: InputMaybe<Scalars['dateTime']['input']>;
  /**  Absent leaves a stored start as it is; an explicit null clears it.  */
  start?: InputMaybe<Scalars['dateTime']['input']>;
};

export type PersonnelCommunicationInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subject: ReferenceOnlyInput;
};

export type PersonnelCommunicationToSeveralInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subjects: Array<InputMaybe<ReferenceOnlyInput>>;
};

export enum PhoneCallTargetType {
  Contact = 'Contact',
  NextOfKin = 'NextOfKin',
  Patient = 'Patient',
  User = 'User',
}

export type PhoniroCloudForwarderConfiguration = {
  alarmServerId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  escalationTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  isCloudPlas?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type PhoniroCloudForwarderCreateInput = {
  alarmServerId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  escalationTimeoutMinutes: Scalars['Int']['input'];
  isCloudPlas: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type PhoniroCloudForwarderUpdateInput = {
  alarmServerId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  escalationTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  isCloudPlas?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A recurring schedule a patient's appointments are generated from, so a client can plot future
 * occurrences itself rather than waiting for them to be created.
 *
 * Occurrences are the cross product of scheduledTiming.repeat.dayOfWeek and
 * scheduledTiming.repeat.timeOfDay, repeating weekly. timeOfDay is HH:MM:SS wall clock in the
 * health provider's time zone, not UTC and not the device's zone. boundsPeriod.start is inclusive
 * and boundsPeriod.end is exclusive. repeat.period and repeat.periodUnit are not honoured:
 * the recurrence is always weekly.
 */
export type PlannedAppointment = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  scheduledTiming: Timing;
};

export type PlannedReminder = PlannedAppointment & {
  action?: Maybe<Scalars['String']['output']>;
  allDay: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesBeforeReminder: Scalars['Int']['output'];
  requiresAcknowledgement: Scalars['Boolean']['output'];
  scheduledTiming: Timing;
};

export type PlannedReminderCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minutesBeforeReminder?: InputMaybe<Scalars['Int']['input']>;
  requiresAcknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledTiming: TimingInput;
};

export type PlannedReminderMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  plannedReminder?: Maybe<PlannedReminder>;
  success: Scalars['Boolean']['output'];
};

export type PlannedReminderUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minutesBeforeReminder?: InputMaybe<Scalars['Int']['input']>;
  /**  An omitted flag leaves the stored value alone.  */
  requiresAcknowledgement?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledTiming?: InputMaybe<TimingInput>;
};

export type PlannedSupervision = {
  alarmActivity: AlarmActivity;
  scheduledTiming: Timing;
};

export type PlannedSupervisionCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  scheduledTiming: TimingInput;
};

export type PlannedSupervisionMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  plannedSupervision?: Maybe<PlannedSupervision>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlannedSupervisionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  scheduledTiming?: InputMaybe<TimingInput>;
};

export type PlannedVideoMeeting = {
  activity: AlarmActivity;
  durationInMinutes: Scalars['Int']['output'];
  scheduledTiming: Timing;
};

export type PlannedVideoMeetingCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  interpretation?: InputMaybe<Array<CodeableConceptInput>>;
  scheduledTiming: TimingInput;
};

export type PlannedVideoMeetingMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  plannedVideoMeeting?: Maybe<PlannedVideoMeeting>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlannedVideoMeetingUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  interpretation?: InputMaybe<Array<CodeableConceptInput>>;
  scheduledTiming?: InputMaybe<TimingInput>;
};

export type PlayerStatus = {
  autoplayBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<Scalars['Float']['input']>;
  delayed?: InputMaybe<Scalars['Boolean']['input']>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  html5VideoAccumulatedWaiting?: InputMaybe<Scalars['Float']['input']>;
  html5VideoSetup?: InputMaybe<Scalars['Float']['input']>;
  html5VideoWaiting?: InputMaybe<Scalars['Float']['input']>;
  keepAliveShown?: InputMaybe<Scalars['Boolean']['input']>;
  keepAliveTTL?: InputMaybe<Scalars['Int']['input']>;
  lastSelectedPreset?: InputMaybe<Scalars['String']['input']>;
  latency?: InputMaybe<Scalars['Float']['input']>;
  loading?: InputMaybe<Scalars['Boolean']['input']>;
  mediaSourceSetup?: InputMaybe<Scalars['Float']['input']>;
  playButtonShown?: InputMaybe<Scalars['Boolean']['input']>;
  presetStatus?: InputMaybe<Scalars['String']['input']>;
  restarts?: InputMaybe<Scalars['Int']['input']>;
  soundAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  soundMuted?: InputMaybe<Scalars['Boolean']['input']>;
  stalled?: InputMaybe<Scalars['Boolean']['input']>;
  startStreamDuration?: InputMaybe<Scalars['Float']['input']>;
  startingDuration?: InputMaybe<Scalars['Float']['input']>;
  stopButtonShown?: InputMaybe<Scalars['Boolean']['input']>;
  supportedBrowser?: InputMaybe<Scalars['Boolean']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
  videoRatio?: InputMaybe<Scalars['Float']['input']>;
  waitedTooLong?: InputMaybe<Scalars['Boolean']['input']>;
  waiting?: InputMaybe<Scalars['Boolean']['input']>;
  websocketFirstMessageDuration?: InputMaybe<Scalars['Float']['input']>;
  websocketStartDuration?: InputMaybe<Scalars['Float']['input']>;
  wslatency?: InputMaybe<Scalars['Float']['input']>;
};

export type PtzManagementStatus = {
  enabled: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  returnToOverviewawait?: Maybe<Scalars['String']['output']>;
};

export enum PushNotificationEntityType {
  Event = 'EVENT',
  ShiftSession = 'SHIFT_SESSION',
}

export type PushNotificationEvent = {
  id: Scalars['ID']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationLogEntry = {
  ackedAt?: Maybe<Scalars['dateTime']['output']>;
  confirmedAt?: Maybe<Scalars['dateTime']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  event?: Maybe<PushNotificationEvent>;
  id: Scalars['ID']['output'];
  logType: PushNotificationLogEntryType;
  meta?: Maybe<Scalars['String']['output']>;
  pushNotificationType?: Maybe<PushNotificationType>;
  shiftSession?: Maybe<PushNotificationSession>;
  triggeredAt: Scalars['dateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export enum PushNotificationLogEntryType {
  AlarmDeadlineReminder = 'alarmDeadlineReminder',
  AutoReleaseAlarm = 'autoReleaseAlarm',
  CreateAlarm = 'createAlarm',
  ReleaseAlarm = 'releaseAlarm',
}

export type PushNotificationLogInput = {
  entityId: Scalars['ID']['input'];
  entityType: PushNotificationEntityType;
};

export type PushNotificationSession = {
  id: Scalars['ID']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationSettings = {
  createdAt: Scalars['dateTime']['output'];
  device: Scalars['String']['output'];
  type: PushNotificationType;
};

export type PushNotificationSettingsInput = {
  device: Scalars['String']['input'];
  key: Scalars['String']['input'];
  type: PushNotificationType;
};

export enum PushNotificationType {
  AndroidPush = 'androidPush',
  IosPush = 'iosPush',
}

export type PushSubscriptionInput = {
  deviceName: Scalars['String']['input'];
  os?: InputMaybe<Scalars['String']['input']>;
  pushId: Scalars['String']['input'];
};

export type Quantity = {
  code?: Maybe<Scalars['code']['output']>;
  system?: Maybe<Scalars['uri']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  _?: Maybe<Scalars['ID']['output']>;
  accountSettings: AccountSettings;
  allExternalAccess: Array<ExternalAccess>;
  allExternalAccesses: Array<ExternalAccess>;
  allShiftSessions: Array<ShiftSession>;
  /**
   * Fetches users visible to the current operator for export purposes.
   * Supports cursor-based pagination for scalable batch export.
   */
  allUsersExportPaginated: UsersExportPaginatedResponse;
  authEvents: Array<AuthEvent>;
  availableColleaguesForShift: Array<Colleague>;
  availableResourcesToContact: AvailableResourcesToContact;
  azureAccounts: Array<Maybe<AzureAccount>>;
  badges: Badges;
  /**
   * The camera's live configuration, read straight from the camera. Select only the areas you
   * render: an unselected area issues no camera command.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged.
   */
  cameraConfiguration: CameraConfiguration;
  /** Fetch all camera management logs (active or not) for a given camera serial */
  cameraManagementLogsBySerial: Array<CameraManagementStatus>;
  /**
   * One camera profile.
   *
   * Required access scopes: ['user/CameraProfile.read']
   */
  cameraProfile: CameraProfile;
  /**
   * The camera profiles of the account.
   *
   * Required access scopes: ['user/CameraProfile.read']
   */
  cameraProfiles: Array<CameraProfile>;
  cameraProvisioningBatchTelluSupport: Array<CameraManagementStatus>;
  /**
   * Generates a report for a camera, which can be used to investigate support cases.
   * It is really meant to be a text file that is attached together with support cases,
   * so no real point in making a proper type (and that type would be quite big/nested)
   */
  cameraSupportReport?: Maybe<Scalars['String']['output']>;
  /** Returns whether a camera supports two way audio (Supported by model and has two way audio ACAP) */
  checkCameraTwoWayAudioSupport: Scalars['Boolean']['output'];
  cmpAccount: CmpAccount;
  cmpAccounts?: Maybe<Array<CmpAccount>>;
  concreteObservation?: Maybe<Observation>;
  customers: Array<Customer>;
  dailyAuditLogStats?: Maybe<DailyAuditLogStatsPaginated>;
  dailyDeviceStats?: Maybe<DailyDeviceStatsPaginated>;
  dailyPatientStats?: Maybe<DailyPatientStatsPaginated>;
  dailyUserStats?: Maybe<DailyUserStatsPaginated>;
  defaultRoleDefinitions?: Maybe<Array<RoleDefinition>>;
  defaultTemplates: DefaultTemplates;
  deviceGroup: DeviceGroup;
  deviceGroups: Array<DeviceGroup>;
  deviceStats: DeviceStatsPaginated;
  dialoggUsers: Array<DialoggUser>;
  dialoggUsersWithAccessToPatient: Array<DialoggUser>;
  exportFhirPatientBundle: PatientBundle;
  externalAccesses: Array<ExternalAccessLess>;
  externalHumanIdTypes: Array<ExternalHumanIdType>;
  externalIdentityProviderRedirectorsForHealthProvider?: Maybe<Array<ExternalIdentityProviderRedirector>>;
  externalIdentityProviders: Array<ExternalIdentityProvider>;
  externalIdentityProvidersForAllHealthProviders: Array<ExternalIdentityProviderForHealthProvider>;
  externalIdentityProvidersForHealthProvider: Array<ExternalIdentityProviderForHealthProvider>;
  fetchCmpDeviceForForm?: Maybe<WelfareDeviceInInventory>;
  fetchTranscareUserActivity: Array<ActivityMeasurement>;
  fetchTranscareUserIntensity: Array<IntensityMeasurement>;
  fetchTranscareUserPredictionActivity: Array<ActivityPredictionMeasurement>;
  fhirAlarmTemplates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fhirObservationTemplates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAlarmById: Task;
  getAlarmHandlingRulesForUserGroup?: Maybe<Array<SkyresponseAlarmHandlingRule>>;
  getAlarmHistoryDetailById: AlarmDetail;
  getAlarmHistoryForPatient: Array<AlarmHistory>;
  getAlarmHistoryForResponder: Array<Task>;
  getAlarmSnapshotToken?: Maybe<Scalars['String']['output']>;
  getAlarmStatus: AlarmStatus;
  getAlarmSubscriptionById?: Maybe<AlarmSubscription>;
  getAlarmTemplate: AlarmTemplate;
  getAlarmTemplateWithCompletionOptions: Array<AlarmTemplateWithCompletionOption>;
  getAlarmTemplateWithVkpCodes: Array<AlarmTemplateWithVkpCodes>;
  getAlarmTemplates: Array<AlarmTemplate>;
  getAllAlarmEvents: Array<Observation>;
  getAllAlarmEventsForPatient: Array<Observation>;
  getAllAlarmEventsForPatientPaginated: AlarmEventsPaginated;
  getAllAlarmHistory: Array<AlarmHistory>;
  getAllAlarmSubscriptions: Array<AlarmSubscription>;
  getAllCameraEventConfigs: Array<CameraEventConfig>;
  getAllCarePlanObservations: Array<Observation>;
  getAllCarePlanTemplateQuestionnaires: Array<Questionnaire>;
  getAllCarePlanTemplates: Array<CarePlan>;
  getAllCompletionOptions: Array<AlarmCompletionOption>;
  getAllConcreteObservationsAsCsv?: Maybe<ObservationsCsv>;
  getAllExternalAccessForPatient: Array<ExternalAccessLess>;
  getAllFinishedHealthProviderDeletionFlowStatuses: Array<FlowStatus>;
  getAllHealthProviderDeletionFlowStatuses: Array<FlowStatus>;
  getAllMqttDevicesForPatient: Array<ListMqttDevice>;
  getAllObservationTemplates: Array<Maybe<Observation>>;
  getAllPatientAlarms: Array<Task>;
  getAllPatientAlarmsForPatient: Array<Task>;
  getAllPatientWithAllDevicesAndAlarms?: Maybe<Array<PatientWithAlarmsAndDevices>>;
  getAllQuestionnaireTemplates: Array<Questionnaire>;
  getAllRpmMedicalDevices: Array<RpmMedicalDevice>;
  getAllSelfTreatmentPlanTemplates: Array<SelfTreatmentPlan>;
  getAllTechnicalAlarmEventsForDevicePaginated?: Maybe<AlarmEventsPaginated>;
  getAllTechnicalAlarms: Array<Task>;
  getAllTechnicalAlarmsForDevice: Array<Task>;
  getAllUserGroupChildren: Array<UserGroupChild>;
  getAllUsersAlarmSubscriptions: Array<AlarmSubscription>;
  getAppDevicesForPatient: Array<AppDevice>;
  getAssets: Array<Asset>;
  getAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getAuditLogEventForPatientById?: Maybe<AuditEvent>;
  getAuditLogEventForUserGroupById?: Maybe<AuditEvent>;
  getAuditLogForPatientPaginated: AuditLogPaginated;
  getAuditLogForUserPaginated: AuditLogPaginated;
  getAuditLogPaginated: AuditLogPaginated;
  getAuditLogSummaries: AuditLogSummaries;
  getAuditLogSummary: Array<AuditLogSummaryEntry>;
  getAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getAvailableCamerasInInventory: Array<CameraInInventory>;
  getAvailableDevicesInSafematePro: GetExternalDevicesResponse;
  getAvailablePatientServiceSubscriptions: Array<Scalars['String']['output']>;
  getAvailableWelfareDevicesInInventory: Array<WelfareDeviceInInventory>;
  /**
   * Retrieves a single camera.
   *
   * Required access scopes: ['user/Camera.read']
   *
   * The operation is audit logged.
   */
  getCamera: Camera;
  /**
   * Retrieves administration information regarding the camera, herein connection status, firmware, as well as the URL for the administration interface of the camera.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged.
   */
  getCameraAdmin: CameraAdmin;
  /**
   * Retrieves the camera admin URL or an app-specific admin URL.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged.
   */
  getCameraAdminUrl?: Maybe<Scalars['String']['output']>;
  getCameraEventConfigEnabledByDefault: Array<CameraEventConfig>;
  getCameraEventConfigs: Array<CameraEventConfig>;
  /**
   * Retrieves all cameras.
   *
   * Required access scopes: ['user/Camera.read']
   *
   * The operation is NOT audit logged.
   */
  getCameraList: Array<ListCamera>;
  /**
   * Retrieves camera statuses from the invoicing microservices
   * for all the cameras in the account
   * ⚠️⚠️⚠️
   * ⚠️ - This status is not live, as the invoicing runs early morning (before 06:00AM CET)
   * ⚠️
   * ⚠️ - It will only return the statuses for cameras that are both in registry and in the account DB
   * ⚠️⚠️⚠️
   */
  getCameraManagementList: Array<CameraStatus>;
  /** Get PTZ profiles for a camera */
  getCameraPtzProfiles: CameraPtzProfileConfig;
  getCarePlanActivity: Observation;
  getCarePlanByID: CarePlan;
  getCarePlanQuestionnaire: Questionnaire;
  getCarePlanTemplate: CarePlan;
  getCarePlanTemplateQuestionnaire: Questionnaire;
  getCepEventConfigs: Array<CepEventConfig>;
  getCmpDeviceById?: Maybe<CmpDevice>;
  getCompletedPatientAlarms: Array<Task>;
  getConcreteObservationsForPatient: Array<Maybe<Observation>>;
  getConcreteObservationsForPatientAsCsv?: Maybe<ObservationsCsv>;
  getContinuousSupervisionCandidates?: Maybe<Array<ContinuousSupervisionCandidate>>;
  getDeviceGroupExternalUrl?: Maybe<Scalars['String']['output']>;
  getDevicesByGroup: Array<DeviceInList>;
  getEnabledServicesForPatient: Array<ServiceSubscription>;
  getEquipmentList: Array<Equipment>;
  getEventForwardingLogs?: Maybe<Array<Maybe<EventForwardingLog>>>;
  getExternalAccessEndpoints: Array<ExternalAccessEndpoints>;
  getExternalAccessNames: Array<ExternalAccessNames>;
  getExternalUrlForWelfareDevice: Scalars['String']['output'];
  getForwarderAlarmRoutes: Array<ForwarderAlarmRoute>;
  getGeofencesForSafemateDevice?: Maybe<Array<DeviceGeofence>>;
  getHealthPersonnelTaskForVideoMeeting?: Maybe<Task>;
  getHealthProviderDeletionFlowStatus?: Maybe<FlowStatus>;
  getHealthProviderMarkedForDeletionFlowStatus?: Maybe<FlowStatus>;
  getHealthProvidersMarkedForDeletion?: Maybe<Array<HealthProvider>>;
  getInconsistentHealthProviderReports: Array<InconsistentHealthProviderReport>;
  getIntegrationDetails?: Maybe<Integration>;
  getIntegrations: Array<Integration>;
  getJournalConfigForUserGroup?: Maybe<JournalConfigForUserGroup>;
  getLatestAlarmHistoryForPatient: Array<AlarmHistory>;
  getLatestEventSnapshotTokenForPatient?: Maybe<Scalars['String']['output']>;
  getListOfUnallocatedCameras: Array<Camera>;
  getListOfUnallocatedMqttDevices: Array<ListMqttDevice>;
  getListOfUnallocatedRpmMedicalDevices: Array<RpmMedicalDevice>;
  getListOfUnallocatedWelfareDevices: Array<WelfareDevice>;
  getMedicalDeviceForMeasurement?: Maybe<MeasurementDevice>;
  getMigrations: Array<Migration>;
  getMqttDevice?: Maybe<MqttDevice>;
  getMqttDeviceList: Array<ListMqttDevice>;
  getMyPersonalProfile: User;
  getMyUserProfile: User;
  getNextOfKin: Array<NextOfKin>;
  getNextOfKinById: NextOfKin;
  getNotificationLogs: Array<NotificationLog>;
  getNumberOfAccessiblePatients: Scalars['Int']['output'];
  getObservationTemplate?: Maybe<Observation>;
  getOpenPatientAlarms: Array<ListAlarm>;
  getOpenPatientAlarmsForPatient: Array<Task>;
  getOpenTechnicalAlarms: Array<Task>;
  getOpenTechnicalAlarmsForDevice: Array<Task>;
  getOpenTechnicalAlarmsForPatients: Array<Task>;
  getOwnerAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getOwnerAuditLogPaginated: AuditLogPaginated;
  getOwnerAuditLogSummaries: AuditLogSummaries;
  getOwnerAuditLogSummary: Array<AuditLogSummaryEntry>;
  getOwnerAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getPatientAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getPatientAuditLogSummary: Array<AuditLogSummaryEntry>;
  getPatientAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getPatientByExternalId: PatientByIdentityResponse;
  getPatientCmpDevices: Array<CmpDevice>;
  getPatientEventConfigEnabledByDefault: Array<PatientEventConfig>;
  getPatientEventConfigs: Array<PatientEventConfig>;
  getPatientFromVkp: PatientVkpResponse;
  getPatientReminderById?: Maybe<PatientReminderResult>;
  getPatientRemindersForPatient: Array<Appointment>;
  getPatientSelfTreatmentPlans?: Maybe<SelfTreatmentPlan>;
  getPatientTasksNotCompleted: Array<Maybe<HpTaskAndPatientTasks>>;
  getPatientWithAlarms?: Maybe<PatientWithAlarms>;
  getPatientWithAllDevicesAndAlarms: PatientWithAlarmsAndDevices;
  getPlannedRemindersForPatient: Array<PlannedReminder>;
  getPushNotificationLog: Array<PushNotificationLogEntry>;
  getQuestionnaireResponseById?: Maybe<QuestionnaireResponse>;
  getQuestionnaireResponsesForPatient: Array<Maybe<QuestionnaireResponse>>;
  getQuestionnaireTemplate: Questionnaire;
  getReadyTaskCount: ReadyCount;
  /** Get a camera's reference objects for furniture detection */
  getReferenceObjectsForCamera: Array<ReferenceObject>;
  getRestoreHealthProviderMarkedForDeletionFlowStatus?: Maybe<FlowStatus>;
  getRoleDefinition?: Maybe<RoleDefinition>;
  getRpmMedicalDevice?: Maybe<RpmMedicalDevice>;
  getSelfTreatmentPlanTemplateById: SelfTreatmentPlan;
  getSharedSkyResponseAlarmsPatientCandidates: Array<Maybe<SharedAlarmCandidates>>;
  getSkyresponseOrganizationNotes?: Maybe<Array<SkyresponseOrganizationNote>>;
  getSkyresponseStatusesForPatient?: Maybe<Array<SkyresponseSyncStatus>>;
  getSkyresponseStatusesForUserGroup?: Maybe<Array<SkyresponseSyncStatus>>;
  getSkyresponseSyncJobsCount: Scalars['Int']['output'];
  getSupervisionCarePlan?: Maybe<Array<Maybe<PlannedSupervision>>>;
  getSupportedLanguages?: Maybe<Array<LanguageCode>>;
  getTaskById?: Maybe<Task>;
  getTasks: Array<Maybe<Task>>;
  getTasksForPatient: Array<Maybe<Task>>;
  getTasksForPatientByDateRange: Array<Maybe<PatientTaskAndHpTasks>>;
  getTechnicalAlarmById: Task;
  getTemplateVkpCodesByTemplateId?: Maybe<TemplateVkpCodes>;
  getUserAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getUserAuditLogSummary: Array<AuditLogSummaryEntry>;
  getUserAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getUserByUsername?: Maybe<UserLess>;
  getVideoMeetingById?: Maybe<VideoMeeting>;
  getVideoMeetingCarePlan: Array<PlannedVideoMeeting>;
  getVideoMeetingTemplates: Array<AlarmTemplate>;
  getWelfareDevice?: Maybe<WelfareDevice>;
  getWhiteLabelingTemplates: Array<WhiteLabelingTemplate>;
  globalStats: Array<GlobalStats>;
  googlemapsAccounts?: Maybe<Array<GooglemapsAccount>>;
  healthProvider: HealthProvider;
  healthProviderSettings: HealthProviderSettings;
  healthProviders: Array<HealthProviderLess>;
  helseIdAccounts?: Maybe<Array<HelseIdAccount>>;
  hourlyPatientStats?: Maybe<HourlyPatientStatsPaginated>;
  hourlyUserStats?: Maybe<HourlyUserStatsPaginated>;
  lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient: Array<Observation>;
  listAllTranscareUsers: Array<TranscareUser>;
  morpheanAccounts?: Maybe<Array<MorpheanAccount>>;
  morpheanSitesPerMorpheanCustomerTelluSupport: Array<MorpheanSitesForMorpheanCustomer>;
  passwordPolicy?: Maybe<PasswordPolicy>;
  patient?: Maybe<Patient>;
  patientCommunications: Array<Communication>;
  patientCommunicationsPaginated: CommunicationPaginated;
  patientExportData?: Maybe<Array<PatientExport>>;
  patientGroup?: Maybe<PatientGroup>;
  patientGroups: Array<Maybe<PatientGroup>>;
  patientGroupsForPatientIds: Array<PatientUserGroups>;
  patientList: Array<ListPatient>;
  patientRemindersPaginated: PatientRemindersPaginated;
  patientStats: PatientStatsPaginated;
  patients: Array<Patient>;
  patientsForImport: Array<PatientForImport>;
  registryDeviceTypes?: Maybe<Array<Maybe<RegistryDeviceType>>>;
  registryDevices: Array<RegistryDevice>;
  requestSinglePatientUrl?: Maybe<Scalars['String']['output']>;
  roleDefinitions?: Maybe<Array<RoleDefinition>>;
  roleTypes: Array<RoleType>;
  rpmPatientExportData?: Maybe<Array<RpmPatientExport>>;
  safemateAccounts?: Maybe<Array<SafemateAccount>>;
  sendGridAccounts?: Maybe<Array<SendGridAccount>>;
  services?: Maybe<Array<Maybe<Service>>>;
  setOfPatients: Array<Maybe<Patient>>;
  shiftSession?: Maybe<ShiftSession>;
  shiftSessionForUser?: Maybe<ShiftSessionWithHistory>;
  skyresponseAccounts?: Maybe<Array<SkyresponseAccount>>;
  supportTeamLinkedHealthProviders?: Maybe<Array<LinkedHealthProvider>>;
  supportTeamsForHealthProvider: Array<SupportTeamForHealthProvider>;
  supportTeamsWithLinkedHealthProviders: Array<SupportTeamWithLinkedHealthProviders>;
  supportedCameraApps: Array<SupportedCameraApp>;
  supportedCameraModelsTelluSupport: Array<CameraModelWithCapabilities>;
  supportedTasksForJournaling?: Maybe<Array<Scalars['String']['output']>>;
  tcifAccounts?: Maybe<Array<TcifAccount>>;
  twilioAccounts?: Maybe<Array<TwilioAccount>>;
  unmanagedAccounts: Array<HealthProviderLess>;
  unreadCommunications: Array<Communication>;
  unreadCommunicationsCount: Scalars['Int']['output'];
  userGroup: UserGroup;
  userGroupPatientAccessList?: Maybe<Array<Maybe<UserWithUserGroupAccess>>>;
  userManuals: Array<UserManual>;
  users: Array<Maybe<User>>;
  usersPaginated: UsersPaginated;
  validatePatientInSkyresponse?: Maybe<ValidatePatientInSkyresponseResponse>;
  videoMeetingTasks?: Maybe<Array<VideoMeetingTask>>;
  videoMeetingTasksForPatient?: Maybe<Array<Maybe<VideoMeetingTask>>>;
  videonorAccounts?: Maybe<Array<VideonorAccount>>;
  vkpAccounts?: Maybe<Array<VkpAccount>>;
  vkpPatientCareplan?: Maybe<VkpResponse>;
  vkpPatientEpisodesOfCare?: Maybe<VkpResponse>;
};

export type QueryAllExternalAccessArgs = {
  healthProviderName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAllUsersExportPaginatedArgs = {
  paging: UsersPagingInput;
};

export type QueryAuthEventsArgs = {
  filter?: InputMaybe<AuthEventFilter>;
};

export type QueryAzureAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCameraConfigurationArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryCameraManagementLogsBySerialArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  serial: Scalars['String']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryCameraProfileArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCameraSupportReportArgs = {
  serial: Scalars['String']['input'];
};

export type QueryCheckCameraTwoWayAudioSupportArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryCmpAccountArgs = {
  id: Scalars['String']['input'];
};

export type QueryConcreteObservationArgs = {
  observationId: Scalars['ID']['input'];
};

export type QueryDailyAuditLogStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyDeviceStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyUserStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDefaultRoleDefinitionsArgs = {
  isDefaultType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDeviceGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDeviceStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDialoggUsersArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDialoggUsersWithAccessToPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryExportFhirPatientBundleArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryExternalHumanIdTypesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExternalIdentityProviderRedirectorsForHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  includePatientRealm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExternalIdentityProvidersArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExternalIdentityProvidersForHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFetchCmpDeviceForFormArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryFetchTranscareUserActivityArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryFetchTranscareUserIntensityArgs = {
  fromDate: Scalars['dateTime']['input'];
  toDate: Scalars['dateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type QueryFetchTranscareUserPredictionActivityArgs = {
  fromDate: Scalars['dateTime']['input'];
  toDate: Scalars['dateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type QueryFhirAlarmTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFhirObservationTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAlarmByIdArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetAlarmHandlingRulesForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAlarmHistoryDetailByIdArgs = {
  skyresponseAlarmId?: InputMaybe<Scalars['ID']['input']>;
  telluAlarmId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAlarmHistoryForPatientArgs = {
  from: Scalars['dateTime']['input'];
  includeSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
  to: Scalars['dateTime']['input'];
};

export type QueryGetAlarmHistoryForResponderArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  onlyClosedByResponder?: InputMaybe<Scalars['Boolean']['input']>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAlarmSnapshotTokenArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetAlarmStatusArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetAllAlarmEventsArgs = {
  eventCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllAlarmEventsForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllAlarmEventsForPatientPaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllAlarmHistoryArgs = {
  from: Scalars['dateTime']['input'];
  includeSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['dateTime']['input'];
};

export type QueryGetAllCameraEventConfigsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAllCarePlanObservationsArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type QueryGetAllCarePlanTemplateQuestionnairesArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
};

export type QueryGetAllCarePlanTemplatesArgs = {
  withStatus?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllExternalAccessForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAllMqttDevicesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAllPatientAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllPatientAlarmsForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllPatientWithAllDevicesAndAlarmsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetAllTechnicalAlarmEventsForDevicePaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  deviceId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllTechnicalAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllTechnicalAlarmsForDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllUserGroupChildrenArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAppDevicesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogEventForPatientByIdArgs = {
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetAuditLogEventForUserGroupByIdArgs = {
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAuditLogForPatientPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  patientId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogForUserPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetAuditLogPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogSummariesArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetCameraArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryGetCameraAdminArgs = {
  cameraId: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCameraAdminUrlArgs = {
  appId?: InputMaybe<Scalars['String']['input']>;
  cameraId: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCameraEventConfigEnabledByDefaultArgs = {
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetCameraEventConfigsArgs = {
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetCameraPtzProfilesArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryGetCarePlanActivityArgs = {
  carePlanId: Scalars['ID']['input'];
  observationId: Scalars['ID']['input'];
};

export type QueryGetCarePlanByIdArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type QueryGetCarePlanQuestionnaireArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
};

export type QueryGetCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetCarePlanTemplateQuestionnaireArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
};

export type QueryGetCepEventConfigsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetCmpDeviceByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetCompletedPatientAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetConcreteObservationsForPatientArgs = {
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetConcreteObservationsForPatientAsCsvArgs = {
  patientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetDeviceGroupExternalUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetDevicesByGroupArgs = {
  deviceGroupId: Scalars['ID']['input'];
};

export type QueryGetEnabledServicesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetEventForwardingLogsArgs = {
  errorHandlingStatus?: InputMaybe<Scalars['String']['input']>;
  forwardingStatus?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  integrationConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetExternalUrlForWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetForwarderAlarmRoutesArgs = {
  forwarderConfigId: Scalars['String']['input'];
};

export type QueryGetGeofencesForSafemateDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryGetHealthPersonnelTaskForVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type QueryGetHealthProviderDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetHealthProviderMarkedForDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetHealthProvidersMarkedForDeletionArgs = {
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetIntegrationDetailsArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type QueryGetJournalConfigForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetLatestAlarmHistoryForPatientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
};

export type QueryGetLatestEventSnapshotTokenForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetMedicalDeviceForMeasurementArgs = {
  measurementId: Scalars['ID']['input'];
  medicalDeviceId: Scalars['ID']['input'];
};

export type QueryGetMqttDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetNextOfKinArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetNextOfKinByIdArgs = {
  nokId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOpenPatientAlarmsArgs = {
  hideAssignedToOtherUsers?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetOpenPatientAlarmsForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetOpenTechnicalAlarmsArgs = {
  hasPatientLink?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetOpenTechnicalAlarmsForDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetOpenTechnicalAlarmsForPatientsArgs = {
  patientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetOwnerAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogSummariesArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientByExternalIdArgs = {
  externalHumanIdTypeId: Scalars['String']['input'];
  externalPatientId: Scalars['String']['input'];
};

export type QueryGetPatientCmpDevicesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPatientEventConfigEnabledByDefaultArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPatientEventConfigsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPatientFromVkpArgs = {
  norwegianId: Scalars['String']['input'];
};

export type QueryGetPatientReminderByIdArgs = {
  reminderId: Scalars['ID']['input'];
};

export type QueryGetPatientRemindersForPatientArgs = {
  patientId: Scalars['ID']['input'];
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryGetPatientSelfTreatmentPlansArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPatientTasksNotCompletedArgs = {
  tasks: Array<Scalars['String']['input']>;
};

export type QueryGetPatientWithAlarmsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPatientWithAllDevicesAndAlarmsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPlannedRemindersForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPushNotificationLogArgs = {
  input: PushNotificationLogInput;
};

export type QueryGetQuestionnaireResponseByIdArgs = {
  questionnaireResponseId: Scalars['ID']['input'];
};

export type QueryGetQuestionnaireResponsesForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetReadyTaskCountArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  onlyUpcomingVideoMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetReferenceObjectsForCameraArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryGetRestoreHealthProviderMarkedForDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryGetRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSelfTreatmentPlanTemplateByIdArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type QueryGetSharedSkyResponseAlarmsPatientCandidatesArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetSkyresponseStatusesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetSkyresponseStatusesForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetSupervisionCarePlanArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetTaskByIdArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetTasksArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTasksForPatientArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTasksForPatientByDateRangeArgs = {
  fromDate?: InputMaybe<Scalars['dateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTechnicalAlarmByIdArgs = {
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTemplateVkpCodesByTemplateIdArgs = {
  templateId: Scalars['ID']['input'];
};

export type QueryGetUserAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetUserAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetUserAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetUserByUsernameArgs = {
  username: Scalars['String']['input'];
};

export type QueryGetVideoMeetingByIdArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type QueryGetVideoMeetingCarePlanArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGlobalStatsArgs = {
  date: Scalars['date']['input'];
};

export type QueryHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryHourlyPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryHourlyUserStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientArgs = {
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};

export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPatientCommunicationsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryPatientCommunicationsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryPatientExportDataArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};

export type QueryPatientGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPatientGroupsForPatientIdsArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};

export type QueryPatientListArgs = {
  features?: InputMaybe<PatientListFeatures>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  withAnyEnabledServices?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryPatientRemindersPaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryPatientsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRegistryDevicesArgs = {
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryRequestSinglePatientUrlArgs = {
  externalAccessId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryRoleDefinitionsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryRpmPatientExportDataArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};

export type QuerySetOfPatientsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryShiftSessionForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QuerySupportTeamsForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryUnreadCommunicationsArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUnreadCommunicationsCountArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserGroupArgs = {
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserGroupPatientAccessListArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryUserManualsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUsersArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUsersPaginatedArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  paging?: InputMaybe<UsersPagingInput>;
};

export type QueryValidatePatientInSkyresponseArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryVideoMeetingTasksArgs = {
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryVideoMeetingTasksForPatientArgs = {
  patientId: Scalars['ID']['input'];
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryVkpPatientCareplanArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVkpPatientEpisodesOfCareArgs = {
  id: Scalars['ID']['input'];
};

export type Questionnaire = {
  approvalDate?: Maybe<Scalars['dateTime']['output']>;
  carePlan?: Maybe<Scalars['ID']['output']>;
  carePlanObject?: Maybe<CarePlan>;
  derivedFrom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  experimental: Scalars['Boolean']['output'];
  extension?: Maybe<Array<Maybe<Extension>>>;
  id: Scalars['ID']['output'];
  item?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  json?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patient?: Maybe<Scalars['ID']['output']>;
  patientObject?: Maybe<Patient>;
  priorities?: Maybe<QuestionnairePriorities>;
  publisher?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  status: QuestionnaireStatus;
  template: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type QuestionnaireInput = {
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectivePeriod?: InputMaybe<PeriodInput>;
  experimental?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Array<InputMaybe<QuestionnaireItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  priorities?: InputMaybe<QuestionnairePrioritiesInput>;
  publisher?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuestionnaireStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireItem = {
  answerOption?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  linkId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: QuestionnaireItemType;
};

export type QuestionnaireItemInput = {
  answerOption?: InputMaybe<Array<InputMaybe<QuestionnaireItemOptionInput>>>;
  linkId: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  type: QuestionnaireItemType;
};

export type QuestionnaireItemOption = {
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCoding?: Maybe<OptionCoding>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireItemOptionInput = {
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueCoding?: InputMaybe<OptionCodingInput>;
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionnaireItemType {
  Boolean = 'boolean',
  Choice = 'choice',
  Decimal = 'decimal',
  Integer = 'integer',
  String = 'string',
}

export type QuestionnaireMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  questionnaire?: Maybe<Questionnaire>;
  success: Scalars['Boolean']['output'];
};

export type QuestionnairePriorities = {
  mode?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Array<Maybe<QuestionnairePrioritiesCode>>>;
  thresholds?: Maybe<Array<Maybe<QuestionnairePrioritiesCode>>>;
};

export type QuestionnairePrioritiesCode = {
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnairePrioritiesCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnairePrioritiesInput = {
  mode?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<InputMaybe<QuestionnairePrioritiesCodeInput>>>;
  thresholds?: InputMaybe<Array<InputMaybe<QuestionnairePrioritiesCodeInput>>>;
};

export type QuestionnaireResponse = {
  authored: Scalars['dateTime']['output'];
  displayItem: Array<Maybe<QuestionnaireResponseDisplayItem>>;
  displaySummary?: Maybe<DisplaySummary>;
  extension?: Maybe<Array<Maybe<Extension>>>;
  id: Scalars['ID']['output'];
  item: Array<Maybe<QuestionnaireResponseItem>>;
  questionnaire: Scalars['String']['output'];
  questionnaireObject?: Maybe<Questionnaire>;
  received?: Maybe<Scalars['dateTime']['output']>;
  source: Reference;
  subject: Reference;
  taskPriority?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseDisplayItem = {
  answer?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  answerOption?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  answerText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['String']['output']>;
  linkId?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  type: QuestionnaireItemType;
};

export type QuestionnaireResponseItem = {
  answer?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  linkId?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  questionnaireResponse?: Maybe<QuestionnaireResponse>;
  success: Scalars['Boolean']['output'];
};

export type QuestionnaireResponseSimulatorInput = {
  authored?: InputMaybe<Scalars['dateTime']['input']>;
  item: Array<QuestionnaireResponseSimulatorItemInput>;
  questionnaire: Scalars['String']['input'];
  source?: InputMaybe<ReferenceInput>;
  subject: ReferenceInput;
};

export type QuestionnaireResponseSimulatorItemInput = {
  answer: Array<QuestionnaireSimulatorItemOptionInput>;
  linkId?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireSimulatorItemOptionInput = {
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueCoding?: InputMaybe<OptionCodingSimulatorInput>;
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionnaireStatus {
  Active = 'active',
  Draft = 'draft',
  Retired = 'retired',
  Unknown = 'unknown',
}

export type ReadyCount = {
  asap: Scalars['Int']['output'];
  pendingReminders: Scalars['Int']['output'];
  routine: Scalars['Int']['output'];
  stat: Scalars['Int']['output'];
  upcomingVideo: Scalars['Int']['output'];
  urgent: Scalars['Int']['output'];
  video: Scalars['Int']['output'];
};

export type Reference = {
  display?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Identifier>;
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReferenceInput = {
  display?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<IdentifierInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceObject = {
  boundingBox: BoundingBox;
  sensitivity: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type ReferenceObjectInput = {
  boundingBox: BoundingBoxInput;
  sensitivity: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

export type ReferenceObjectsMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  referenceObjects?: Maybe<Array<ReferenceObject>>;
  success: Scalars['Boolean']['output'];
};

export type ReferenceOnlyInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceRange = {
  high?: Maybe<ValueQuantity>;
  low?: Maybe<ValueQuantity>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
};

export type ReferenceRangeInput = {
  high?: InputMaybe<ValueQuantityInput>;
  low?: InputMaybe<ValueQuantityInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CodeableConceptInput>;
};

export type RegistryDevice = {
  arch?: Maybe<Scalars['String']['output']>;
  deviceGroup?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastHeartbeat?: Maybe<Scalars['dateTime']['output']>;
  lastObservation?: Maybe<Scalars['dateTime']['output']>;
  lastStatus?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  observationCount?: Maybe<Scalars['Int']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  routerMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RegistryDeviceInput = {
  createFhirDeviceInput?: InputMaybe<CreateFhirDeviceInput>;
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type RegistryDeviceMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  registryDevice?: Maybe<RegistryDevice>;
  success: Scalars['Boolean']['output'];
};

export type RegistryDeviceType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RegistrySchemaSyncResponse = {
  databaseName: Scalars['String']['output'];
  isSynced?: Maybe<Scalars['Boolean']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ReminderStatus = {
  date: Scalars['Float']['output'];
  objectReference: Reference;
  reminderType?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemotePatientMonitoringConfigForPatient = {
  enabled: Scalars['Boolean']['output'];
  taskCodesForJournaling: Array<Scalars['String']['output']>;
};

export type RemoteSupervisionConfigForPatient = {
  enabled: Scalars['Boolean']['output'];
};

export type ReplaceWelfareDeviceIdentifierInput = {
  modelNumber: Scalars['String']['input'];
  uniqueIdentifier: Scalars['String']['input'];
};

export type ResponseSubscription = ServiceSubscription & {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
};

export type Role = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  basedOn?: Maybe<Scalars['String']['output']>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  protected?: Maybe<Scalars['Boolean']['output']>;
  roleDefinitionId: Scalars['ID']['output'];
  userGroup?: Maybe<UserGroup>;
};

export type RoleDefinition = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  accessScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  basedOn?: Maybe<Scalars['ID']['output']>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  isDefaultType?: Maybe<Scalars['String']['output']>;
};

export type RoleDefinitionCreateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display: Array<InputMaybe<LocaleDefinitionInput>>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleDefinitionMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  roleDefinition?: Maybe<RoleDefinition>;
  success: Scalars['Boolean']['output'];
};

export type RoleDefinitionUpdateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Array<InputMaybe<LocaleDefinitionInput>>>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RoleType = {
  /**
   * The id of the built-in role definition this one was derived from, or null for a role
   * definition created from scratch through the owner API - createRoleDefinition takes no
   * basedOn, and updateRoleDefinitionBasedOn is a separate, optional call. Null is a real role
   * type, not a missing one.
   */
  basedOn_fk?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
};

export type RouterInfo = {
  mac?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type RpmDevice = {
  btAddress?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Array<Annotation>>;
};

export type RpmMedicalDevice = Device &
  RpmDevice & {
    btAddress?: Maybe<Scalars['String']['output']>;
    deviceGroup?: Maybe<DeviceGroup>;
    deviceName?: Maybe<Array<DeviceName>>;
    firmwareVersion?: Maybe<Scalars['String']['output']>;
    hardwareVersion?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    identifier?: Maybe<Array<Identifier>>;
    imei?: Maybe<Scalars['String']['output']>;
    isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
    manufacturer?: Maybe<Scalars['String']['output']>;
    modelName?: Maybe<Scalars['String']['output']>;
    modelNumber?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Array<Annotation>>;
    parent?: Maybe<Reference>;
    patient?: Maybe<Reference>;
    sensorType?: Maybe<Scalars['String']['output']>;
    serialNumber?: Maybe<Scalars['String']['output']>;
    simNumber?: Maybe<Scalars['String']['output']>;
    softwareVersion?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type?: Maybe<CodeableConcept>;
    userFriendlyName?: Maybe<Scalars['String']['output']>;
    userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
  };

export type RpmMedicalDeviceCreateInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelName: Scalars['String']['input'];
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<AnnotationInput>;
  sensorType: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  simNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum RpmMedicalDeviceModelNumber {
  AndUa651Ble = 'AND_UA651BLE',
  AndUa656Ble = 'AND_UA656BLE',
  AndUc352Ble = 'AND_UC352BLE',
  AndUt201Ble = 'AND_UT201BLE',
  ContourNextOne = 'CONTOUR_NEXT_ONE',
  Nonin_3230 = 'NONIN_3230',
}

export type RpmMedicalDeviceMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  rpmMedicalDevice?: Maybe<RpmMedicalDevice>;
  success: Scalars['Boolean']['output'];
};

export enum RpmMedicalDeviceSensorType {
  BloodPressureMonitor = 'bloodPressureMonitor',
  Glucometer = 'glucometer',
  InEar = 'inEar',
  Oximeter = 'oximeter',
  Scale = 'scale',
  Smartwatch = 'smartwatch',
  Spirometer = 'spirometer',
  Thermometer = 'thermometer',
  Unknown = 'unknown',
}

export type RpmMedicalDeviceUpdateInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<AnnotationInput>;
  sensorType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  simNumber?: InputMaybe<Scalars['String']['input']>;
  /**  Replaces the stored tags. Omit to leave them alone; null or an empty list removes every tag.  */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RpmPatientExport = {
  active?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  createdAt?: Maybe<Scalars['dateTime']['output']>;
  externalIds: Array<ExternalIdExport>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<AdministrativeGender>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['dateTime']['output']>;
};

export type RpmSubscription = ServiceSubscription & {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
};

export type SafemateAccount = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  apiUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  observationUsername?: Maybe<Scalars['String']['output']>;
};

export type SafemateAccountCreateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiPassword?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  apiUsername?: InputMaybe<Scalars['String']['input']>;
  observationPassword?: InputMaybe<Scalars['String']['input']>;
  observationUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  safemateAccount?: Maybe<SafemateAccount>;
  success: Scalars['Boolean']['output'];
};

export type SafemateAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiPassword?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  apiUsername?: InputMaybe<Scalars['String']['input']>;
  observationPassword?: InputMaybe<Scalars['String']['input']>;
  observationUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateEventInput = {
  battery?: InputMaybe<Scalars['Int']['input']>;
  deviceNumber?: InputMaybe<Scalars['String']['input']>;
  deviceSNNum?: InputMaybe<Scalars['String']['input']>;
  escalated?: InputMaybe<Scalars['Int']['input']>;
  geofenceName?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['String']['input']>;
  messageTime?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['Int']['input']>;
  msgId?: InputMaybe<Scalars['String']['input']>;
  posLat?: InputMaybe<Scalars['String']['input']>;
  posLon?: InputMaybe<Scalars['String']['input']>;
  posTime?: InputMaybe<Scalars['String']['input']>;
  refPoint?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateExternalDevice = {
  countryCode?: Maybe<Scalars['Int']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  lastMessageFromDevice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNum?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  simStatus?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  topLevelCustomerId?: Maybe<Scalars['Int']['output']>;
  topLevelCustomerName?: Maybe<Scalars['String']['output']>;
};

export type SafemateProDevice = {
  customerName?: Maybe<Scalars['String']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  isInRegistry: Scalars['Boolean']['output'];
  isInWrongHealthProvider: Scalars['Boolean']['output'];
  lastMessageFromDevice?: Maybe<Scalars['dateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNum?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  simStatus?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type SelfTreatmentPlan = {
  goals: Array<Goal>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  medicalStates?: Maybe<MedicalStates>;
  status: CarePlanStatus;
  subject: Reference;
  title?: Maybe<Scalars['String']['output']>;
};

export type SelfTreatmentPlanMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  selfTreatmentPlan?: Maybe<SelfTreatmentPlan>;
  success: Scalars['Boolean']['output'];
};

export type SelfTreatmentPlanTemplateInput = {
  goal?: InputMaybe<GoalInput>;
  medicalStates?: InputMaybe<MedicalStatesInput>;
  title: Scalars['String']['input'];
};

export type SelfTreatmentPlanTemplateUpdateInput = {
  goal?: InputMaybe<UpdateGoalInput>;
  medicalStates?: InputMaybe<MedicalStatesInput>;
  title: Scalars['String']['input'];
};

export type SendGridAccount = {
  accountDisplayName: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SendGridAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type SendGridAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  sendGridAccount?: Maybe<SendGridAccount>;
  success: Scalars['Boolean']['output'];
};

export type SendGridAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type Service = {
  applications?: Maybe<Applications>;
  configuration?: Maybe<AccountConfiguration>;
  features?: Maybe<AccountFeatures>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<ServiceRole>>>;
  whiteLabelingTemplate?: Maybe<WhiteLabelingTemplate>;
};

export type ServiceRole = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  basedOn?: Maybe<Scalars['String']['output']>;
  canAssignRoles?: Maybe<Array<Scalars['String']['output']>>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  roleDefinitionId: Scalars['ID']['output'];
  userGroup?: Maybe<ServiceUserGroup>;
  userManuals?: Maybe<Array<UserManual>>;
};

export type ServiceSubscription = {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
};

export type ServiceSubscriptionMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ServiceSubscription>;
  success: Scalars['Boolean']['output'];
};

export type ServiceUserGroup = {
  id: Scalars['ID']['output'];
  isTopLevel?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type SessionNotificationSettings = {
  email?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSms?: Maybe<Scalars['Boolean']['output']>;
  shiftSessionPhoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type SessionNotificationSettingsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  sendEmail: Scalars['Boolean']['input'];
  sendSms: Scalars['Boolean']['input'];
};

export type ShareAlarmWidth = {
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  norwegianId?: Maybe<Scalars['String']['output']>;
};

export type SharedAlarmCandidates = {
  externalPatientIds?: Maybe<Array<PatientListExternalIds>>;
  id: Scalars['String']['output'];
  name?: Maybe<Array<HumanName>>;
};

export type SharedAlarmPatients = {
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ShiftSession = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['dateTime']['output'];
  lastUpdated: Scalars['dateTime']['output'];
  notificationSettings: SessionNotificationSettings;
  patientGroupIdsAndNames: Array<PatientGroupIdAndName>;
  pushNotificationSettings: Array<PushNotificationSettings>;
};

export type ShiftSessionHistoryLog = {
  createdAt: Scalars['dateTime']['output'];
  endedAt?: Maybe<Scalars['dateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type ShiftSessionWithHistory = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['dateTime']['output'];
  history: Array<ShiftSessionHistoryLog>;
  lastUpdated: Scalars['dateTime']['output'];
  notificationSettings: SessionNotificationSettings;
  patientGroupIdsAndNames: Array<PatientGroupIdAndName>;
  pushNotificationSettings: Array<PushNotificationSettings>;
};

export type SimpleAlarm = {
  authoredOn: Scalars['dateTime']['output'];
  id: Scalars['String']['output'];
};

export type SimpleAlarmTemplate = {
  accountTemplate?: Maybe<AlarmTemplate>;
  code: Scalars['String']['output'];
  defaultTemplate?: Maybe<AlarmTemplate>;
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isPresentInAccount?: Maybe<Scalars['Boolean']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  technical?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SimpleMeasurementTemplate = {
  code: Scalars['String']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isPresentInAccount?: Maybe<Scalars['Boolean']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SimulateSyncEventPayloadInput = {
  _type?: InputMaybe<Scalars['String']['input']>;
  flowLogs?: InputMaybe<Scalars['String']['input']>;
  flowName?: InputMaybe<Scalars['String']['input']>;
  stepName?: InputMaybe<Scalars['String']['input']>;
};

export type SipForwarderConfiguration = {
  primaryUrl: Scalars['String']['output'];
  secondaryUrl?: Maybe<Scalars['String']['output']>;
};

export type SipForwarderCreateInput = {
  primaryUrl: Scalars['String']['input'];
  secondaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SipForwarderUpdateInput = {
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  secondaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateResponseCenterId?: Maybe<Scalars['String']['output']>;
  privateResponseCenterName?: Maybe<Scalars['String']['output']>;
  publicResponseCenterObjectId?: Maybe<Scalars['String']['output']>;
  responseCenterName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type SkyresponseAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  privateResponseCenterId?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterName?: InputMaybe<Scalars['String']['input']>;
  publicResponseCenterObjectId?: InputMaybe<Scalars['String']['input']>;
  responseCenterName?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type SkyresponseAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  skyresponseAccount?: Maybe<SkyresponseAccount>;
  success: Scalars['Boolean']['output'];
};

export type SkyresponseAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterId?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterName?: InputMaybe<Scalars['String']['input']>;
  publicResponseCenterObjectId?: InputMaybe<Scalars['String']['input']>;
  responseCenterName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseAlarmDetail = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  alarmCode: Scalars['Int']['output'];
  deactivationTime?: Maybe<Scalars['String']['output']>;
  globalAlarmId: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Array<SkyresponseAlarmLogs>>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  responseCenter: Scalars['String']['output'];
  serverAlarmTime: Scalars['String']['output'];
  textMessage?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type SkyresponseAlarmHandlingRule = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryRespondentGroup?: Maybe<Scalars['String']['output']>;
};

export type SkyresponseAlarmLogs = {
  created: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subType: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type SkyresponseConfig = {
  allowedAlarmHandlingRuleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseCredentials?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseExternalId?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  privateArcObjectId?: Maybe<Scalars['Int']['output']>;
  publicArcObjectId?: Maybe<Scalars['Int']['output']>;
  skyresponseAlarmHandlingRuleId?: Maybe<Scalars['Int']['output']>;
  webviewIntegrationConfig?: Maybe<IntegrationConfigLess>;
};

export type SkyresponseConfigInput = {
  allowedAlarmHandlingRuleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privateArcObjectId?: InputMaybe<Scalars['Int']['input']>;
  publicArcObjectId?: InputMaybe<Scalars['Int']['input']>;
  skyresponseAlarmHandlingRuleId?: InputMaybe<Scalars['Int']['input']>;
};

export type SkyresponseEventInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  alarmCodeText?: InputMaybe<Scalars['String']['input']>;
  alarmTextMessage?: InputMaybe<Scalars['String']['input']>;
  criticality?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  responseCenterComment?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseForwarder = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  primaryUrl: Scalars['String']['output'];
};

export type SkyresponseForwarderConfiguration = {
  primaryUrl: Scalars['String']['output'];
};

export type SkyresponseForwarderCreateInput = {
  primaryUrl: Scalars['String']['input'];
};

export type SkyresponseForwarderUpdateInput = {
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseOrganizationNote = {
  alarmHandlingId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  organizationNote: Scalars['String']['output'];
};

export type SkyresponseOrganizationNoteInput = {
  alarmHandlingId: Scalars['Int']['input'];
  organizationNote: Scalars['String']['input'];
};

export type SkyresponseOrganizationNoteMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  skyresponseOrganizationNote?: Maybe<SkyresponseOrganizationNote>;
  success: Scalars['Boolean']['output'];
};

export type SkyresponsePartnerForwarderConfiguration = {
  pin: Scalars['String']['output'];
  primaryUrl: Scalars['String']['output'];
};

export type SkyresponsePartnerForwarderCreateInput = {
  pin: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
};

export type SkyresponsePartnerForwarderUpdateInput = {
  pin?: InputMaybe<Scalars['String']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseSyncAlarm = {
  id: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseSyncLogEntry = {
  auditLogReferences: Array<FlowAuditLogReference>;
  details: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseSyncStatus = {
  flowName: Scalars['String']['output'];
  logs: Array<SkyresponseSyncLogEntry>;
  patientId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseValidationCheck = {
  differences: Array<SkyresponseValidationDifference>;
  name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SkyresponseValidationDifference = {
  description: Scalars['String']['output'];
  skyresponse?: Maybe<Scalars['String']['output']>;
  tellu?: Maybe<Scalars['String']['output']>;
};

export type SortTreeResponse = {
  lexoRankIndex?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StepStatus = {
  attempts: Scalars['Int']['output'];
  lastActivity?: Maybe<Scalars['dateTime']['output']>;
  lastLocalePath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum StreamAnonymizationMode {
  Disabled = 'disabled',
  RequiredCanBeTurnedOff = 'requiredCanBeTurnedOff',
  RequiredCanBeTurnedOffWithReason = 'requiredCanBeTurnedOffWithReason',
  RequiredCannotBeTurnedOff = 'requiredCannotBeTurnedOff',
}

export enum StreamAnonymizationStrategy {
  AiAnonymizeHumans = 'aiAnonymizeHumans',
  HighPrivacy = 'highPrivacy',
  NoAiFullPicture = 'noAiFullPicture',
  NoAiFullPictureLight = 'noAiFullPictureLight',
  StandardPrivacy = 'standardPrivacy',
}

export enum StreamQuality {
  Didnotstart = 'DIDNOTSTART',
  Frozen = 'FROZEN',
  Interrutped = 'INTERRUTPED',
  Other = 'OTHER',
  Slowtostart = 'SLOWTOSTART',
  Working = 'WORKING',
}

export type SupervisionCameraView = {
  cameraId: Scalars['ID']['output'];
  cameraName?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['dateTime']['output']>;
  startedAt?: Maybe<Scalars['dateTime']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
  watchedBy?: Maybe<Scalars['String']['output']>;
};

export type SupervisionSubscription = ServiceSubscription & {
  enabled: Scalars['Boolean']['output'];
  service: Scalars['String']['output'];
};

export type SupportTeamForHealthProvider = {
  displayName: Scalars['String']['output'];
  linked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['ID']['output'];
};

export type SupportTeamWithLinkedHealthProviders = {
  autoCreatedSupportUserRoleDefinitionId?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  linkedHealthProviders: Array<Scalars['String']['output']>;
  name: Scalars['ID']['output'];
  unlinkedHealthProviders?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupportedCameraApp = {
  default: Scalars['Boolean']['output'];
  experimental: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supportedModels: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type SyncAlarmDetails = {
  entityName?: Maybe<Scalars['String']['output']>;
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export type SyncEventDetails = {
  fhirId?: Maybe<Scalars['String']['output']>;
  flowLogs?: Maybe<Array<SkyresponseSyncLogEntry>>;
  flowName?: Maybe<Scalars['String']['output']>;
  skyresponseId?: Maybe<Scalars['String']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
  transmitterIdsToDelete?: Maybe<Scalars['String']['output']>;
};

export type SyncStatus = {
  openAlarms?: Maybe<Array<SimpleAlarm>>;
  status: Scalars['String']['output'];
};

export type Tag = {
  label?: Maybe<Scalars['String']['output']>;
};

export type TagAction = {
  label?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TagTarget>;
  type?: Maybe<TagActionType>;
};

export type TagActionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TagTarget>;
  type?: InputMaybe<TagActionType>;
};

export enum TagActionType {
  Add = 'add',
  Remove = 'remove',
}

export type TagInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum TagTarget {
  Device = 'Device',
  Observation = 'Observation',
  Patient = 'Patient',
  Task = 'Task',
}

export type TakeCallInput = {
  phoneNumber: Scalars['String']['input'];
};

export type TakeCameraSnapshotWithDetectionsResponse = {
  detectedObjects: Array<DetectedObject>;
  snapshotToken: Scalars['String']['output'];
};

export type Task = {
  acceptedAt?: Maybe<Scalars['dateTime']['output']>;
  authoredOn?: Maybe<Scalars['dateTime']['output']>;
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  canRetryJournaling?: Maybe<Scalars['Boolean']['output']>;
  carePlan?: Maybe<CarePlan>;
  code?: Maybe<CodeableConcept>;
  completedAt?: Maybe<Scalars['dateTime']['output']>;
  completionOptionNote?: Maybe<Scalars['String']['output']>;
  completionOptions?: Maybe<Array<Scalars['String']['output']>>;
  deadlineAt?: Maybe<Scalars['dateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceGroupName?: Maybe<Scalars['String']['output']>;
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  executionPeriod?: Maybe<Period>;
  extendByMinutes?: Maybe<Scalars['Int']['output']>;
  firstEventTimestamp?: Maybe<Scalars['dateTime']['output']>;
  focus?: Maybe<Reference>;
  for: Reference;
  forDeviceName?: Maybe<Scalars['String']['output']>;
  forDeviceType?: Maybe<Scalars['String']['output']>;
  freeTextNote?: Maybe<Scalars['String']['output']>;
  handlingMode?: Maybe<Scalars['String']['output']>;
  holdsCamera: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  intent?: Maybe<Scalars['String']['output']>;
  isJournalNoteRequired?: Maybe<Scalars['Boolean']['output']>;
  isSupervisionAlarm?: Maybe<Scalars['Boolean']['output']>;
  isSupervisionAlarmWithAnOpenedCameraStream?: Maybe<Scalars['Boolean']['output']>;
  journalWorkflow?: Maybe<Array<JournalWorkflow>>;
  lastCompleted?: Maybe<Scalars['dateTime']['output']>;
  lastModified: Scalars['dateTime']['output'];
  locationTraces?: Maybe<Array<LocationTrace>>;
  missedSubmissions?: Maybe<Array<MissedSubmission>>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  observation?: Maybe<Observation>;
  output?: Maybe<Array<Maybe<TaskOutput>>>;
  owner?: Maybe<Reference>;
  partOf?: Maybe<Array<Maybe<Reference>>>;
  patient?: Maybe<Patient>;
  patientLink?: Maybe<PatientLinkData>;
  presentAt?: Maybe<Scalars['dateTime']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityInput?: Maybe<TaskInput>;
  questionnaire?: Maybe<Questionnaire>;
  reminder?: Maybe<Appointment>;
  reminderDate?: Maybe<Scalars['dateTime']['output']>;
  reminderSent?: Maybe<Scalars['Boolean']['output']>;
  restriction?: Maybe<TaskRestriction>;
  status: Scalars['String']['output'];
  subTasks?: Maybe<Array<Maybe<Task>>>;
  syncAlarmDetails?: Maybe<SyncAlarmDetails>;
  syncPending?: Maybe<Scalars['Boolean']['output']>;
  videoMeeting?: Maybe<VideoMeeting>;
  vkpConfiguration?: Maybe<AlarmVkpConfiguration>;
};

export enum TaskCode {
  All = 'ALL',
  HpCheckInactivePatient = 'HP_CHECK_INACTIVE_PATIENT',
  HpCheckMissedSubmission = 'HP_CHECK_MISSED_SUBMISSION',
  HpPatientVideoMeetingRequest = 'HP_PATIENT_VIDEO_MEETING_REQUEST',
  HpReviewPatientData = 'HP_REVIEW_PATIENT_DATA',
}

export type TaskInput = {
  icon?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  syncEventDetails?: Maybe<SyncEventDetails>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateDisplayName?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  values: Array<TaskInputValue>;
};

export type TaskInputValue = {
  name: Scalars['String']['output'];
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueNumber?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TaskMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<Task>;
};

export type TaskOutput = {
  type?: Maybe<CodeableConcept>;
  valueReference?: Maybe<Reference>;
};

export type TaskRestriction = {
  period?: Maybe<Period>;
  recipient?: Maybe<Array<Maybe<Reference>>>;
};

export type TcifAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  prefixUrl: Scalars['String']['output'];
};

export type TcifAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  prefixUrl: Scalars['String']['input'];
};

export type TcifAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tcifAccount?: Maybe<TcifAccount>;
};

export type TcifAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  prefixUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateTimedCepConfig = {
  cancelledBy: Array<Scalars['String']['output']>;
  events: Array<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
};

export type TemplateTimedCepConfigInput = {
  cancelledBy?: InputMaybe<Array<Scalars['String']['input']>>;
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateVkpCodes = {
  alertCode?: Maybe<VkpCodeObject>;
  createdAt: Scalars['String']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mode?: Maybe<VkpCodeObject>;
  reasonCode?: Maybe<VkpCodeObject>;
  resourceType: Scalars['String']['output'];
  templateId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TemplateVkpCodesInput = {
  alertCode?: InputMaybe<VkpCodeObjectInput>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  mode?: InputMaybe<VkpCodeObjectInput>;
  reasonCode?: InputMaybe<VkpCodeObjectInput>;
  resourceType: Scalars['String']['input'];
};

export type TemplateVkpCodesMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  templateVkpCodes?: Maybe<TemplateVkpCodes>;
};

export type TestAzureAccountCredentialsMutationResponse = {
  code?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TimeManagementStatus = {
  obtainFromDHCP: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
};

export type TimedCepConfig = {
  alarmTimeWindow: AlarmTimeWindow;
  cancelledBy?: Maybe<Array<Scalars['String']['output']>>;
  events: Array<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
};

export type TimedCepConfigInput = {
  alarmTimeWindow: AlarmTimeWindowInput;
  cancelledBy?: InputMaybe<Array<Scalars['String']['input']>>;
  events: Array<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
};

export type Timing = {
  event?: Maybe<Array<Maybe<Scalars['dateTime']['output']>>>;
  repeat?: Maybe<TimingRepeat>;
};

export type TimingInput = {
  event?: InputMaybe<Array<InputMaybe<Scalars['dateTime']['input']>>>;
  repeat?: InputMaybe<TimingRepeatInput>;
};

export type TimingRepeat = {
  boundsPeriod?: Maybe<Period>;
  dayOfWeek?: Maybe<Array<DayOfWeek>>;
  period?: Maybe<Scalars['Int']['output']>;
  periodUnit?: Maybe<Scalars['String']['output']>;
  timeOfDay: Array<Scalars['String']['output']>;
};

export type TimingRepeatInput = {
  boundsPeriod?: InputMaybe<PeriodInput>;
  dayOfWeek?: InputMaybe<Array<DayOfWeek>>;
  period?: InputMaybe<Scalars['Int']['input']>;
  periodUnit?: InputMaybe<Scalars['String']['input']>;
  timeOfDay: Array<Scalars['String']['input']>;
};

export type TranscareUser = {
  id: Scalars['ID']['output'];
};

export type TwilioAccount = {
  accountDisplayName: Scalars['String']['output'];
  accountSid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type TwilioAccountCreateInput = {
  accountAuthToken: Scalars['String']['input'];
  accountDisplayName: Scalars['String']['input'];
  accountSid: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type TwilioAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  twilioAccount?: Maybe<TwilioAccount>;
};

export type TwilioAccountUpdateInput = {
  accountAuthToken?: InputMaybe<Scalars['String']['input']>;
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  accountSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Umo2gForwarderConfiguration = {
  endpointUrl: Scalars['String']['output'];
  password: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Umo2gForwarderCreateInput = {
  endpointUrl: Scalars['String']['input'];
  password: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Umo2gForwarderUpdateInput = {
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountSettingsInput = {
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userSessionLifespan?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCameraInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCareTeamInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  telecom: Array<InputMaybe<ContactPointInput>>;
};

export type UpdateContactInput = {
  availableHours: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  telecom: Array<ContactPointInput>;
};

export type UpdateDhvSettingsMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<DhvSubscription>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDialoggUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalAccessInput = {
  id: Scalars['ID']['input'];
  patientGroupIds: Array<Scalars['String']['input']>;
};

export type UpdateGoalInput = {
  goal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateNameOrIpRestrictionForExternalAccessInput = {
  allowedAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNextOfKinInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<AddressInput>>;
  name?: InputMaybe<HumanNameInput>;
  notifyNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type UpdatePatientInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  addressNote?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  keyCode?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<LanguageInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<HumanNameInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationInput>;
  secretAddress?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type UpdateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserGroupInput = {
  name: Scalars['String']['input'];
  skyresponseConfig?: InputMaybe<SkyresponseConfigInput>;
};

export type UpdateUserManualInput = {
  applications?: InputMaybe<UserManualApplicationsInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  localeEntries?: InputMaybe<Array<UserManualLocaleEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateWhiteLabelingTemplateInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  menuBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  menuBackgroundGradient?: InputMaybe<ColorGradientInput>;
  menuBackgroundImageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryButtonGradient?: InputMaybe<ColorGradientInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryButtonGradient?: InputMaybe<ColorGradientInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleLogoId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  autoCreatedSupportUser?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['dateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalIdP?: Maybe<Scalars['String']['output']>;
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  externalUserIds?: Maybe<Array<ExternalHumanId>>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  otpStatus?: Maybe<Scalars['String']['output']>;
  passwordStatus?: Maybe<Scalars['String']['output']>;
  pendingEmailInvitation?: Maybe<Scalars['Boolean']['output']>;
  pendingExternalIdentityProviders?: Maybe<Array<PendingExternalIdentityProvider>>;
  requestedExternalIds?: Maybe<Array<ExternalIdRequest>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  smsOtpPhoneNumber?: Maybe<Scalars['String']['output']>;
  smsOtpStatus?: Maybe<Scalars['String']['output']>;
  timeLimitedAccess?: Maybe<Period>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum UserAuthSetting {
  IpRestriction = 'ipRestriction',
  ResetPasswordAllowed = 'resetPasswordAllowed',
  TimeLimitedAccess = 'timeLimitedAccess',
  TwoFactorAppRequired = 'twoFactorAppRequired',
  TwoFactorSms = 'twoFactorSms',
}

export type UserAuthSettingToggleResponse = {
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  setting: UserAuthSetting;
  success: Scalars['Boolean']['output'];
  userAuth: AccountUserAuth;
  wasEnabled: Scalars['Boolean']['output'];
};

export type UserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIdP?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<ExternalHumanIdInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryPassword?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserExport = {
  created?: Maybe<Scalars['dateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  externalUserIds?: Maybe<Array<ExternalHumanId>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  otpStatus?: Maybe<Scalars['String']['output']>;
  passwordStatus?: Maybe<Scalars['String']['output']>;
  roles: Array<UserExportRoleAssignment>;
  smsOtpStatus?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserExportRoleAssignment = {
  role: RoleDefinition;
  userGroup: UserGroup;
};

export type UserGroup = {
  allowedRoleDefinitionIds?: Maybe<Array<Scalars['String']['output']>>;
  careTeams?: Maybe<Array<Maybe<CareTeam>>>;
  contacts?: Maybe<Array<Contact>>;
  deviceGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  deviceGroups?: Maybe<Array<Maybe<DeviceGroup>>>;
  escalationDelay?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lexoRankIndex?: Maybe<Scalars['String']['output']>;
  linkedPatientGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  linkedPatientGroups?: Maybe<Array<Maybe<PatientGroup>>>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  patientGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroup>>>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  skyresponse?: Maybe<SkyresponseConfig>;
  skyresponseSyncStatus?: Maybe<SyncStatus>;
  subGroups?: Maybe<Array<Maybe<UserGroup>>>;
  subTree?: Maybe<Array<Maybe<UserGroup>>>;
  templateGroupId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
};

export type UserGroupAccessRole = {
  display: Array<LocaleDefinition>;
  id: Scalars['String']['output'];
  userGroupId: Scalars['ID']['output'];
  userGroupName: Scalars['String']['output'];
};

export type UserGroupChild = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserGroupMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userGroup?: Maybe<UserGroup>;
};

export type UserLess = {
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserManual = {
  applications?: Maybe<UserManualApplications>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  localeEntries: Array<UserManualLocaleEntry>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  roleDefinitions?: Maybe<Array<RoleDefinition>>;
};

export type UserManualLocaleEntry = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  localeId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserManualLocaleEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UserManualMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userManual?: Maybe<UserManual>;
};

export type UserMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UserReservation = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserWithUserGroupAccess = {
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<UserGroupAccessRole>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UsersExportPaginatedResponse = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<UserExport>;
};

export type UsersFilterInput = {
  roleDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<UsersStatusFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  userGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UsersPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  hasMore: Scalars['Boolean']['output'];
  loadedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type UsersPagingInput = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum UsersStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE',
}

export type ValidateCustomerGroupTowardsCmpResponse = {
  device?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalDevices?: Maybe<Scalars['Int']['output']>;
};

export type ValidatePatientInSkyresponseResponse = {
  checks: Array<Maybe<SkyresponseValidationCheck>>;
  success: Scalars['Boolean']['output'];
};

export type ValidationError = {
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ValueQuantity = {
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValueQuantityInput = {
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type VideoManagementStatus = {
  captureFrequency: Scalars['String']['output'];
  compression: Scalars['String']['output'];
  dayNight: DayNightManagementStatus;
  enabled: Scalars['Boolean']['output'];
  exposureMode: Scalars['String']['output'];
  fps: Scalars['String']['output'];
  iCount: Scalars['String']['output'];
  mirrored: Scalars['Boolean']['output'];
  pCount: Scalars['String']['output'];
  rateControlPriority: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
  rotation: Scalars['String']['output'];
  rtsp: Scalars['Boolean']['output'];
  targetBitRate: Scalars['String']['output'];
  whiteBalanceMode: Scalars['String']['output'];
};

export type VideoMeeting = {
  appointment: Appointment;
  carePlan?: Maybe<CarePlan>;
  id: Scalars['ID']['output'];
  videonor?: Maybe<VideoNorMeeting>;
};

export type VideoMeetingInput = {
  basedOnRequest?: InputMaybe<ReferenceInput>;
  carePlanReference?: InputMaybe<ReferenceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['dateTime']['input'];
  start: Scalars['dateTime']['input'];
};

export type VideoMeetingMutationResponse = {
  calendarInvitation?: Maybe<Scalars['String']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  videoMeeting?: Maybe<VideoMeeting>;
};

export type VideoMeetingTask = {
  acceptedAt?: Maybe<Scalars['dateTime']['output']>;
  authoredOn: Scalars['dateTime']['output'];
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  code?: Maybe<CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  executionPeriod?: Maybe<Period>;
  firstEventTimestamp?: Maybe<Scalars['dateTime']['output']>;
  focus?: Maybe<Reference>;
  for: Reference;
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  intent?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['dateTime']['output'];
  note?: Maybe<Array<Maybe<Annotation>>>;
  output?: Maybe<Array<Maybe<TaskOutput>>>;
  owner?: Maybe<Reference>;
  patient: Patient;
  priority?: Maybe<Scalars['String']['output']>;
  restriction?: Maybe<TaskRestriction>;
  status: Scalars['String']['output'];
  videoMeeting: VideoMeeting;
};

export type VideoNorMeeting = {
  endDate?: Maybe<Scalars['dateTime']['output']>;
  hostRoomUrl?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  participantRoomUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['dateTime']['output']>;
};

export type VideonorAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  prefixUrl: Scalars['String']['output'];
  roomNamePrefix?: Maybe<Scalars['String']['output']>;
};

export type VideonorAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  bearer: Scalars['String']['input'];
  prefixUrl: Scalars['String']['input'];
  roomNamePrefix: Scalars['String']['input'];
};

export type VideonorAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  videonorAccount?: Maybe<VideonorAccount>;
};

export type VideonorAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  bearer?: InputMaybe<Scalars['String']['input']>;
  prefixUrl?: InputMaybe<Scalars['String']['input']>;
  roomNamePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type VkpAccount = {
  accountDisplayName: Scalars['String']['output'];
  helseIdAccount?: Maybe<HelseIdAccount>;
  helseIdAccountId: Scalars['ID']['output'];
  id: Scalars['String']['output'];
};

export type VkpAccountInput = {
  accountDisplayName: Scalars['String']['input'];
  helseIdAccountId: Scalars['String']['input'];
};

export type VkpAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  vkpAccount?: Maybe<VkpAccount>;
};

export type VkpCodeObject = {
  code: Scalars['String']['output'];
  display: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type VkpCodeObjectInput = {
  code: Scalars['String']['input'];
  display: Scalars['String']['input'];
  system: Scalars['String']['input'];
};

export type VkpEncounter = {
  reason?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type VkpEncounterInput = {
  reason?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type VkpResponse = {
  fnr: Scalars['ID']['output'];
  responseAsJson?: Maybe<Scalars['String']['output']>;
};

export type WelfareDevice = Device & {
  configuration?: Maybe<Configuration>;
  deviceGroup?: Maybe<DeviceGroup>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  property?: Maybe<DeviceProperty>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WelfareDeviceStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<CodeableConcept>;
  uniqueIdentifier: Scalars['String']['output'];
  userFriendlyName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type WelfareDeviceCreateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  modelNumber: Scalars['String']['input'];
  property?: InputMaybe<DevicePropertyInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueIdentifier: Scalars['String']['input'];
};

export type WelfareDeviceInInventory = {
  /**  The device model. Absent when the source system reports a model we do not recognise.  */
  modelNumber?: Maybe<Scalars['String']['output']>;
  /**  The device's alarm code. Absent when the source system holds none for it.  */
  uniqueIdentifier?: Maybe<Scalars['String']['output']>;
};

export type WelfareDeviceMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  welfareDevice?: Maybe<WelfareDevice>;
};

export type WelfareDeviceStatus = DeviceStatus & {
  connected?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
};

export type WelfareDeviceUpdateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<DevicePropertyInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WhiteLabelingTemplate = {
  accentColor?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  healthProviders?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Asset>;
  menuBackgroundColor?: Maybe<Scalars['String']['output']>;
  menuBackgroundGradient?: Maybe<ColorGradient>;
  menuBackgroundImage?: Maybe<Asset>;
  name: Scalars['String']['output'];
  primaryButtonGradient?: Maybe<ColorGradient>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryButtonGradient?: Maybe<ColorGradient>;
  title?: Maybe<Scalars['String']['output']>;
  titleLogo?: Maybe<Asset>;
};

export type WhiteLabelingTemplateMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  whiteLabelingTemplate?: Maybe<WhiteLabelingTemplate>;
};

export type Ability = {
  operation?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type AbilityInput = {
  operation?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type AppDeviceMeasurementDeviceInput = {
  appDeviceId: Scalars['String']['input'];
  medicalDevice: AppDeviceMeasurementMedicalDeviceInput;
};

export type AppDeviceMeasurementMedicalDeviceInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  hardwareVersion?: InputMaybe<Scalars['String']['input']>;
  manufacturer: Scalars['String']['input'];
  modelName: Scalars['String']['input'];
  modelNumber: Scalars['String']['input'];
  sensorType?: InputMaybe<RpmMedicalDeviceSensorType>;
  serialNumber: Scalars['String']['input'];
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ContactsImport = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type InheritedJournalConfigForUserGroupInput = {
  disableRemotePatientMonitoringForPatientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  disableRemoteSupervisionForPatientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocaleDefinition = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LocaleDefinitionInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OnBehalf = {
  accessiblePatients?: Maybe<Array<Scalars['ID']['output']>>;
  otherPatientIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type UserManualApplications = {
  dho?: Maybe<Scalars['Boolean']['output']>;
  dhv?: Maybe<Scalars['Boolean']['output']>;
  tilsyn?: Maybe<Scalars['Boolean']['output']>;
};

export type UserManualApplicationsInput = {
  dho?: InputMaybe<Scalars['Boolean']['input']>;
  dhv?: InputMaybe<Scalars['Boolean']['input']>;
  tilsyn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetSkyresponseOrganizationNotesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSkyresponseOrganizationNotesQuery = {
  getSkyresponseOrganizationNotes?: Array<{ id: string; alarmHandlingId: number; organizationNote: string }> | null;
};

export type CreateSkyresponseOrganizationNoteMutationVariables = Exact<{
  input: SkyresponseOrganizationNoteInput;
}>;

export type CreateSkyresponseOrganizationNoteMutation = {
  createSkyresponseOrganizationNote: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateSkyresponseOrganizationNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SkyresponseOrganizationNoteInput;
}>;

export type UpdateSkyresponseOrganizationNoteMutation = {
  updateSkyresponseOrganizationNote: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteSkyresponseOrganizationNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSkyresponseOrganizationNoteMutation = { deleteSkyresponseOrganizationNote: { success: boolean } };

export type AddExternalIdentityProviderToHealthProviderMutationVariables = Exact<{
  input: ExternalIdentityProviderForHealthProviderCreateInput;
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddExternalIdentityProviderToHealthProviderMutation = {
  addExternalIdentityProviderToHealthProvider: { success: boolean; message?: string | null };
};

export type CreateHealthProviderMutationVariables = Exact<{
  healthProvider: HealthProviderInput;
}>;

export type CreateHealthProviderMutation = { createHealthProvider: { success: boolean; message?: string | null } };

export type AddAccountToCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
}>;

export type AddAccountToCustomerMutation = {
  addAccountToCustomer: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    customer?: { id: string; name: string; reference?: string | null; type: string; accounts: Array<string> } | null;
  };
};

export type RemoveAccountFromCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
}>;

export type RemoveAccountFromCustomerMutation = {
  removeAccountFromCustomer: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    customer?: { id: string; name: string; reference?: string | null; type: string; accounts: Array<string> } | null;
  };
};

export type CreateCustomerMutationVariables = Exact<{
  customer: CustomerInput;
}>;

export type CreateCustomerMutation = {
  createCustomer: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    customer?: { id: string; name: string; reference?: string | null; type: string; accounts: Array<string> } | null;
  };
};

export type UpdateCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  customer: CustomerUpdateInput;
}>;

export type UpdateCustomerMutation = {
  updateCustomer: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    customer?: { id: string; name: string; reference?: string | null; type: string; accounts: Array<string> } | null;
  };
};

export type DeleteCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;

export type DeleteCustomerMutation = { deleteCustomer: { success: boolean; message?: string | null } };

export type DeleteExternalAccessMutationVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;

export type DeleteExternalAccessMutation = { deleteExternalAccess: boolean };

export type ResetSecretForExternalAccessMutationVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type ResetSecretForExternalAccessMutation = {
  resetSecretForExternalAccess: { id?: string | null; message: string; success: boolean; secret?: string | null };
};

export type InitializeExternalAccessMutationVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
  input: CreateExternalAccessInput;
}>;

export type InitializeExternalAccessMutation = {
  initializeExternalAccess: { id?: string | null; message: string; secret?: string | null; success: boolean };
};

export type UpdateNameOrIpRestrictionsForExternalAccessMutationVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
  input: UpdateNameOrIpRestrictionForExternalAccessInput;
}>;

export type UpdateNameOrIpRestrictionsForExternalAccessMutation = {
  updateNameOrIpRestrictionsForExternalAccess: { id?: string | null; message: string; success: boolean };
};

export type UpdateExternalIdentityProviderForHealthProviderMutationVariables = Exact<{
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
  healthProviderName: Scalars['ID']['input'];
}>;

export type UpdateExternalIdentityProviderForHealthProviderMutation = {
  updateExternalIdentityProviderForHealthProvider: { success: boolean; message?: string | null };
};

export type DeleteExternalIdentityProviderFromHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type DeleteExternalIdentityProviderFromHealthProviderMutation = {
  deleteExternalIdentityProviderFromHealthProvider: { success: boolean; message?: string | null };
};

export type DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationVariables = Exact<{
  realmName: Scalars['String']['input'];
  isPatientRealm: Scalars['Boolean']['input'];
  redirectorId: Scalars['String']['input'];
}>;

export type DeleteExternalIdentityProviderRedirectorFromHealthProviderMutation = {
  deleteExternalIdentityProviderRedirectorFromHealthProvider?: { success: boolean } | null;
};

export type SetExternalIdentityProviderRedirectorFromHealthProviderMutationVariables = Exact<{
  realmName: Scalars['String']['input'];
  isPatientRealm: Scalars['Boolean']['input'];
  alias: Scalars['String']['input'];
}>;

export type SetExternalIdentityProviderRedirectorFromHealthProviderMutation = {
  setExternalIdentityProviderRedirectorFromHealthProvider?: { success: boolean } | null;
};

export type ResetExternalIdentityProviderLinksForHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type ResetExternalIdentityProviderLinksForHealthProviderMutation = {
  resetExternalIdentityProviderLinksForHealthProvider: { success: boolean; message?: string | null };
};

export type CreateGooglemapsAccountMutationVariables = Exact<{
  input: GooglemapsAccountCreateInput;
}>;

export type CreateGooglemapsAccountMutation = {
  createGooglemapsAccount: { success: boolean; message?: string | null };
};

export type UpdateGooglemapsAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GooglemapsAccountUpdateInput;
}>;

export type UpdateGooglemapsAccountMutation = {
  updateGooglemapsAccount: { success: boolean; message?: string | null };
};

export type DeleteGooglemapsAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteGooglemapsAccountMutation = {
  deleteGooglemapsAccount: { success: boolean; message?: string | null };
};

export type UpdateHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  updateInput: HealthProviderUpdateInput;
}>;

export type UpdateHealthProviderMutation = { updateHealthProvider: { success: boolean; message?: string | null } };

export type SupportTeamLinkToHealthProviderMutationVariables = Exact<{
  supportTeamName: Scalars['ID']['input'];
  healthProviderName: Scalars['String']['input'];
}>;

export type SupportTeamLinkToHealthProviderMutation = {
  supportTeamLinkToHealthProvider: { success: boolean; message?: string | null };
};

export type SupportTeamUnlinkFromHealthProviderMutationVariables = Exact<{
  supportTeamName: Scalars['ID']['input'];
  healthProviderName: Scalars['String']['input'];
}>;

export type SupportTeamUnlinkFromHealthProviderMutation = {
  supportTeamUnlinkFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddExternalHumanTypeToHealthProviderMutationVariables = Exact<{
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddExternalHumanTypeToHealthProviderMutation = { addExternalHumanTypeToHealthProvider: boolean };

export type RemoveExternalHumanTypeFromHealthProviderMutationVariables = Exact<{
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveExternalHumanTypeFromHealthProviderMutation = { removeExternalHumanTypeFromHealthProvider: boolean };

export type UpdateHealthProviderUserSessionLifespanMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
}>;

export type UpdateHealthProviderUserSessionLifespanMutation = {
  updateHealthProviderUserSessionLifespan: { success: boolean };
};

export type UpdateHealthProviderPatientSessionLifespanMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
}>;

export type UpdateHealthProviderPatientSessionLifespanMutation = {
  updateHealthProviderPatientSessionLifespan: { success: boolean };
};

export type UpdateHealthProviderUserAuthMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
}>;

export type UpdateHealthProviderUserAuthMutation = { updateHealthProviderUserAuth: { success: boolean } };

export type UpdateHealthProviderPatientAuthMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
}>;

export type UpdateHealthProviderPatientAuthMutation = { updateHealthProviderPatientAuth: { success: boolean } };

export type MarkHealthProviderForDeletionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type MarkHealthProviderForDeletionMutation = {
  markHealthProviderForDeletion: { success: boolean; message?: string | null };
};

export type RestoreHealthProviderMarkedForDeletionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type RestoreHealthProviderMarkedForDeletionMutation = {
  restoreHealthProviderMarkedForDeletion: { success: boolean; message?: string | null };
};

export type DeleteHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DeleteHealthProviderMutation = { deleteHealthProvider: { success: boolean; message?: string | null } };

export type DeleteInconsistentHealthProviderMutationVariables = Exact<{
  report: InconsistentHealthProviderReportInput;
}>;

export type DeleteInconsistentHealthProviderMutation = {
  deleteInconsistentHealthProvider: { success: boolean; message?: string | null };
};

export type PauseHealthProviderDeletionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type PauseHealthProviderDeletionMutation = { pauseHealthProviderDeletion: boolean };

export type ResumeHealthProviderDeletionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type ResumeHealthProviderDeletionMutation = { resumeHealthProviderDeletion: boolean };

export type ResetHealthProviderFlowMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  flow: HealthProviderFlow;
}>;

export type ResetHealthProviderFlowMutation = {
  resetHealthProviderFlow: { success: boolean; message?: string | null };
};

export type EnableContinuousSupervisionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableContinuousSupervisionMutation = {
  enableContinuousSupervision: { success: boolean; message?: string | null };
};

export type DisableContinuousSupervisionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableContinuousSupervisionMutation = {
  disableContinuousSupervision: {
    success: boolean;
    message?: string | null;
    blockingCameraProfiles?: Array<{ id: string; name: string; template?: CameraProfileTemplate | null }> | null;
  };
};

export type EnableJoinNhnMeetingMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableJoinNhnMeetingMutation = { enableJoinNhnMeeting: { success: boolean; message?: string | null } };

export type DisableJoinNhnMeetingMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableJoinNhnMeetingMutation = { disableJoinNhnMeeting: { success: boolean; message?: string | null } };

export type EnableSendNotificationToNextOfKinMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableSendNotificationToNextOfKinMutation = {
  enableSendNotificationToNextOfKin: { success: boolean; message?: string | null };
};

export type DisableSendNotificationToNextOfKinMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableSendNotificationToNextOfKinMutation = {
  disableSendNotificationToNextOfKin: { success: boolean; message?: string | null };
};

export type EnableBetaMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableBetaMutation = { enableBeta: { success: boolean; message?: string | null } };

export type DisableBetaMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableBetaMutation = { disableBeta: { success: boolean; message?: string | null } };

export type EnableSelfTreatmentPlanMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableSelfTreatmentPlanMutation = {
  enableSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type DisableSelfTreatmentPlanMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableSelfTreatmentPlanMutation = {
  disableSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type EnableDataAnalyticsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableDataAnalyticsMutation = { enableDataAnalytics: { success: boolean; message?: string | null } };

export type DisableDataAnalyticsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableDataAnalyticsMutation = { disableDataAnalytics: { success: boolean; message?: string | null } };

export type EnableTrendsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableTrendsMutation = { enableTrends: { success: boolean; message?: string | null } };

export type DisableTrendsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableTrendsMutation = { disableTrends: { success: boolean; message?: string | null } };

export type EnableNewSupervisionUserTabsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableNewSupervisionUserTabsMutation = {
  enableNewSupervisionUserTabs: { success: boolean; message?: string | null };
};

export type DisableNewSupervisionUserTabsMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableNewSupervisionUserTabsMutation = {
  disableNewSupervisionUserTabs: { success: boolean; message?: string | null };
};

export type EnableFurnitureDetectionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableFurnitureDetectionMutation = {
  enableFurnitureDetection: { success: boolean; message?: string | null };
};

export type DisableFurnitureDetectionMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableFurnitureDetectionMutation = {
  disableFurnitureDetection: { success: boolean; message?: string | null };
};

export type EnableDemoAnonymizationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableDemoAnonymizationMutation = {
  enableDemoAnonymization: { success: boolean; message?: string | null };
};

export type DisableDemoAnonymizationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableDemoAnonymizationMutation = {
  disableDemoAnonymization: { success: boolean; message?: string | null };
};

export type EnableEntraIdSsoMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableEntraIdSsoMutation = { enableEntraIdSso: { success: boolean; message?: string | null } };

export type DisableEntraIdSsoMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableEntraIdSsoMutation = { disableEntraIdSso: { success: boolean; message?: string | null } };

export type EnableEntraIdProvisioningMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableEntraIdProvisioningMutation = {
  enableEntraIdProvisioning: { success: boolean; message?: string | null };
};

export type DisableEntraIdProvisioningMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableEntraIdProvisioningMutation = {
  disableEntraIdProvisioning: { success: boolean; message?: string | null };
};

export type EnableAlmaIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableAlmaIntegrationMutation = { enableAlmaIntegration: { success: boolean; message?: string | null } };

export type DisableAlmaIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableAlmaIntegrationMutation = { disableAlmaIntegration: { success: boolean; message?: string | null } };

export type EnableAscomIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableAscomIntegrationMutation = { enableAscomIntegration: { success: boolean; message?: string | null } };

export type DisableAscomIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableAscomIntegrationMutation = {
  disableAscomIntegration: { success: boolean; message?: string | null };
};

export type EnablePhoniroCloudIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnablePhoniroCloudIntegrationMutation = {
  enablePhoniroCloudIntegration: { success: boolean; message?: string | null };
};

export type DisablePhoniroCloudIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisablePhoniroCloudIntegrationMutation = {
  disablePhoniroCloudIntegration: { success: boolean; message?: string | null };
};

export type EnableSkyresponsePartnerIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableSkyresponsePartnerIntegrationMutation = {
  enableSkyresponsePartnerIntegration: { success: boolean; message?: string | null };
};

export type DisableSkyresponsePartnerIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableSkyresponsePartnerIntegrationMutation = {
  disableSkyresponsePartnerIntegration: { success: boolean; message?: string | null };
};

export type EnableSipIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableSipIntegrationMutation = { enableSipIntegration: { success: boolean; message?: string | null } };

export type DisableSipIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableSipIntegrationMutation = { disableSipIntegration: { success: boolean; message?: string | null } };

export type EnableCoordcomIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableCoordcomIntegrationMutation = {
  enableCoordcomIntegration: { success: boolean; message?: string | null };
};

export type DisableCoordcomIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableCoordcomIntegrationMutation = {
  disableCoordcomIntegration: { success: boolean; message?: string | null };
};

export type EnableTietoLmoIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableTietoLmoIntegrationMutation = {
  enableTietoLmoIntegration: { success: boolean; message?: string | null };
};

export type DisableTietoLmoIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableTietoLmoIntegrationMutation = {
  disableTietoLmoIntegration: { success: boolean; message?: string | null };
};

export type EnableIpOmsorgIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableIpOmsorgIntegrationMutation = {
  enableIpOmsorgIntegration: { success: boolean; message?: string | null };
};

export type DisableIpOmsorgIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableIpOmsorgIntegrationMutation = {
  disableIpOmsorgIntegration: { success: boolean; message?: string | null };
};

export type EnableUmo2GIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableUmo2GIntegrationMutation = { enableUmo2GIntegration: { success: boolean; message?: string | null } };

export type DisableUmo2GIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableUmo2GIntegrationMutation = {
  disableUmo2GIntegration: { success: boolean; message?: string | null };
};

export type EnableBestIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableBestIntegrationMutation = { enableBestIntegration: { success: boolean; message?: string | null } };

export type DisableBestIntegrationMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableBestIntegrationMutation = { disableBestIntegration: { success: boolean; message?: string | null } };

export type EnableCmpMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableCmpMutation = { enableCmp: { success: boolean; message?: string | null } };

export type DisableCmpMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableCmpMutation = { disableCmp: { success: boolean; message?: string | null } };

export type EnableAlarmStreamingMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type EnableAlarmStreamingMutation = { enableAlarmStreaming: { success: boolean; message?: string | null } };

export type DisableAlarmStreamingMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type DisableAlarmStreamingMutation = { disableAlarmStreaming: { success: boolean; message?: string | null } };

export type AddTcifAccountToHealthProviderMutationVariables = Exact<{
  tcifAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddTcifAccountToHealthProviderMutation = {
  addTcifAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveTcifAccountFromHealthProviderMutationVariables = Exact<{
  tcifAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveTcifAccountFromHealthProviderMutation = {
  removeTcifAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddSafemateAccountToHealthProviderMutationVariables = Exact<{
  safemateAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddSafemateAccountToHealthProviderMutation = {
  addSafemateAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveSafemateAccountFromHealthProviderMutationVariables = Exact<{
  safemateAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveSafemateAccountFromHealthProviderMutation = {
  removeSafemateAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddVideonorAccountToHealthProviderMutationVariables = Exact<{
  videonorAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddVideonorAccountToHealthProviderMutation = {
  addVideonorAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveVideonorAccountFromHealthProviderMutationVariables = Exact<{
  videonorAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveVideonorAccountFromHealthProviderMutation = {
  removeVideonorAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddMorpheanAccountToHealthProviderMutationVariables = Exact<{
  morpheanAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddMorpheanAccountToHealthProviderMutation = {
  addMorpheanAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveMorpheanAccountFromHealthProviderMutationVariables = Exact<{
  morpheanAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveMorpheanAccountFromHealthProviderMutation = {
  removeMorpheanAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddTwilioAccountToHealthProviderMutationVariables = Exact<{
  twilioAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddTwilioAccountToHealthProviderMutation = {
  addTwilioAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveTwilioAccountFromHealthProviderMutationVariables = Exact<{
  twilioAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveTwilioAccountFromHealthProviderMutation = {
  removeTwilioAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddSendGridAccountToHealthProviderMutationVariables = Exact<{
  sendGridAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddSendGridAccountToHealthProviderMutation = {
  addSendGridAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveSendGridAccountFromHealthProviderMutationVariables = Exact<{
  sendGridAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveSendGridAccountFromHealthProviderMutation = {
  removeSendGridAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type AddGooglemapsAccountToHealthProviderMutationVariables = Exact<{
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type AddGooglemapsAccountToHealthProviderMutation = {
  addGooglemapsAccountToHealthProvider: { success: boolean; message?: string | null };
};

export type RemoveGooglemapsAccountFromHealthProviderMutationVariables = Exact<{
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type RemoveGooglemapsAccountFromHealthProviderMutation = {
  removeGooglemapsAccountFromHealthProvider: { success: boolean; message?: string | null };
};

export type ExecuteRegistryMigrationMutationVariables = Exact<{
  migrationId: Scalars['ID']['input'];
}>;

export type ExecuteRegistryMigrationMutation = {
  executeMigration: Array<{
    healthProviderName: string;
    databaseName: string;
    success: boolean;
    report?: string | null;
    error?: string | null;
  }>;
};

export type ExecuteMigrationMutationVariables = Exact<{
  migrationId: Scalars['ID']['input'];
  healthProviderNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ExecuteMigrationMutation = {
  executeMigration: Array<{
    healthProviderName: string;
    databaseName: string;
    success: boolean;
    report?: string | null;
    error?: string | null;
  }>;
};

export type CorrectValidationRulesMutationVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
}>;

export type CorrectValidationRulesMutation = { correctValidationRules: string };

export type CreateMorpheanAccountMutationVariables = Exact<{
  input: MorpheanAccountCreateInput;
}>;

export type CreateMorpheanAccountMutation = { createMorpheanAccount: { success: boolean; message?: string | null } };

export type UpdateMorpheanAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MorpheanAccountUpdateInput;
}>;

export type UpdateMorpheanAccountMutation = { updateMorpheanAccount: { success: boolean; message?: string | null } };

export type DeleteMorpheanAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMorpheanAccountMutation = { deleteMorpheanAccount: { success: boolean; message?: string | null } };

export type UpdateRegistryDeviceMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateRegistryDeviceMutation = { updateRegistryDevice: { success: boolean; message?: string | null } };

export type CreateRegistryDeviceMutationVariables = Exact<{
  registryDeviceInput: RegistryDeviceInput;
}>;

export type CreateRegistryDeviceMutation = { createRegistryDevice: { success: boolean; message?: string | null } };

export type DeleteRegistryDeviceMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;

export type DeleteRegistryDeviceMutation = { deleteRegistryDevice: { success: boolean; message?: string | null } };

export type PreviewRegistrySchemaSyncMutationVariables = Exact<{ [key: string]: never }>;

export type PreviewRegistrySchemaSyncMutation = {
  previewRegistrySchemaSync: {
    databaseName: string;
    output?: string | null;
    success: boolean;
    isSynced?: boolean | null;
  };
};

export type ExecuteRegistrySchemaSyncMutationVariables = Exact<{ [key: string]: never }>;

export type ExecuteRegistrySchemaSyncMutation = {
  executeRegistrySchemaSync: {
    databaseName: string;
    output?: string | null;
    success: boolean;
    isSynced?: boolean | null;
  };
};

export type DeleteDefaultRoleDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteDefaultRoleDefinitionMutation = { deleteDefaultRoleDefinition: { success: boolean } };

export type UpdateRoleDefinitionBasedOnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  basedOn: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
}>;

export type UpdateRoleDefinitionBasedOnMutation = { updateRoleDefinitionBasedOn: { success: boolean } };

export type UpdateHealthProviderRolesBasedOnDefaultRolesMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  defaultRoleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UpdateHealthProviderRolesBasedOnDefaultRolesMutation = {
  updateHealthProviderRolesBasedOnDefaultRoles: { success: boolean; message?: string | null };
};

export type SyncDefaultRoleDefinitionsMutationVariables = Exact<{ [key: string]: never }>;

export type SyncDefaultRoleDefinitionsMutation = { syncDefaultRoleDefinitions: { success: boolean } };

export type AddDefaultRolesToHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddDefaultRolesToHealthProviderMutation = { addDefaultRolesToHealthProvider: { success: boolean } };

export type RemoveDefaultRolesFromHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveDefaultRolesFromHealthProviderMutation = {
  removeDefaultRolesFromHealthProvider: { success: boolean };
};

export type CreateTopLevelRolesForHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateTopLevelRolesForHealthProviderMutation = {
  createTopLevelRolesForHealthProvider: { success?: boolean | null; message?: string | null };
};

export type CreateSafemateAccountMutationVariables = Exact<{
  input: SafemateAccountCreateInput;
}>;

export type CreateSafemateAccountMutation = { createSafemateAccount: { success: boolean; message?: string | null } };

export type UpdateSafemateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SafemateAccountUpdateInput;
}>;

export type UpdateSafemateAccountMutation = { updateSafemateAccount: { success: boolean; message?: string | null } };

export type DeleteSafemateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSafemateAccountMutation = { deleteSafemateAccount: { success: boolean; message?: string | null } };

export type CreateSendGridAccountMutationVariables = Exact<{
  input: SendGridAccountCreateInput;
}>;

export type CreateSendGridAccountMutation = { createSendGridAccount: { success: boolean; message?: string | null } };

export type UpdateSendGridAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SendGridAccountUpdateInput;
}>;

export type UpdateSendGridAccountMutation = { updateSendGridAccount: { success: boolean; message?: string | null } };

export type DeleteSendGridAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSendGridAccountMutation = { deleteSendGridAccount: { success: boolean; message?: string | null } };

export type CreateSkyresponseAccountMutationVariables = Exact<{
  input: SkyresponseAccountCreateInput;
}>;

export type CreateSkyresponseAccountMutation = {
  createSkyresponseAccount: { success: boolean; message?: string | null };
};

export type UpdateSkyresponseAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SkyresponseAccountUpdateInput;
}>;

export type UpdateSkyresponseAccountMutation = {
  updateSkyresponseAccount: { success: boolean; message?: string | null };
};

export type DeleteSkyresponseAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSkyresponseAccountMutation = {
  deleteSkyresponseAccount: { success: boolean; message?: string | null };
};

export type SyncDefaultDeviceTypesMutationVariables = Exact<{ [key: string]: never }>;

export type SyncDefaultDeviceTypesMutation = { syncDefaultDeviceTypes: { success: boolean; message?: string | null } };

export type SyncDefaultExternalIdentityProvidersMutationVariables = Exact<{ [key: string]: never }>;

export type SyncDefaultExternalIdentityProvidersMutation = {
  syncDefaultExternalIdentityProviders: { success: boolean; message?: string | null };
};

export type SyncExternalHumanIdTypesWithDefaultsMutationVariables = Exact<{ [key: string]: never }>;

export type SyncExternalHumanIdTypesWithDefaultsMutation = {
  syncExternalHumanIdTypesWithDefaults: { success: boolean; message?: string | null };
};

export type CreateTcifAccountMutationVariables = Exact<{
  input: TcifAccountCreateInput;
}>;

export type CreateTcifAccountMutation = { createTcifAccount: { success: boolean; message?: string | null } };

export type DeleteTcifAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteTcifAccountMutation = { deleteTcifAccount: { success: boolean; message?: string | null } };

export type CreateTimeLimitedFhirCredentialsForHealthProviderMutationVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type CreateTimeLimitedFhirCredentialsForHealthProviderMutation = {
  createTimeLimitedFhirCredentialsForHealthProvider: string;
};

export type CreateTwilioAccountMutationVariables = Exact<{
  input: TwilioAccountCreateInput;
}>;

export type CreateTwilioAccountMutation = { createTwilioAccount: { success: boolean; message?: string | null } };

export type UpdateTwilioAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TwilioAccountUpdateInput;
}>;

export type UpdateTwilioAccountMutation = { updateTwilioAccount: { success: boolean; message?: string | null } };

export type DeleteTwilioAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteTwilioAccountMutation = { deleteTwilioAccount: { success: boolean; message?: string | null } };

export type DeleteUserManualMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteUserManualMutation = { deleteUserManual: { success: boolean; message?: string | null } };

export type UpdateUserManualMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: UpdateUserManualInput;
}>;

export type UpdateUserManualMutation = { updateUserManual: { success: boolean; message?: string | null } };

export type CreateUserManualMutationVariables = Exact<{
  createInput: CreateUserManualInput;
}>;

export type CreateUserManualMutation = { createUserManual: { success: boolean; message?: string | null } };

export type CreateVideonorAccountMutationVariables = Exact<{
  input: VideonorAccountCreateInput;
}>;

export type CreateVideonorAccountMutation = { createVideonorAccount: { success: boolean; message?: string | null } };

export type UpdateVideonorAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: VideonorAccountUpdateInput;
}>;

export type UpdateVideonorAccountMutation = { updateVideonorAccount: { success: boolean; message?: string | null } };

export type DeleteVideonorAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteVideonorAccountMutation = { deleteVideonorAccount: { success: boolean; message?: string | null } };

export type CustomersQueryVariables = Exact<{ [key: string]: never }>;

export type CustomersQuery = {
  customers: Array<{ id: string; name: string; reference?: string | null; type: string; accounts: Array<string> }>;
};

export type UnmanagedAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type UnmanagedAccountsQuery = {
  unmanagedAccounts: Array<{ name: string; hasRpm: boolean; hasSupervision: boolean; usage?: string | null }>;
};

export type DailyAuditLogStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DailyAuditLogStatsQuery = {
  dailyAuditLogStats?: {
    count: number;
    stats: Array<{
      sessionStart?: any | null;
      sessionEnd?: any | null;
      userId?: string | null;
      userGroupName?: string | null;
      roleInstanceName?: string | null;
      roleDefinitionId?: string | null;
      defaultRoleDefinitionId?: string | null;
      numberOfOperations?: number | null;
    }>;
  } | null;
};

export type DailyDeviceStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DailyDeviceStatsQuery = {
  dailyDeviceStats?: {
    count?: number | null;
    stats: Array<{
      timestamp?: any | null;
      startTimestamp?: any | null;
      endTimestamp?: any | null;
      deviceType?: string | null;
      devices?: number | null;
      online?: number | null;
      active?: number | null;
      technicalAlarms?: number | null;
      technicalAlarmEvents?: number | null;
    }>;
  } | null;
};

export type DailyPatientStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DailyPatientStatsQuery = {
  dailyPatientStats?: {
    count?: number | null;
    stats: Array<{
      timestamp?: any | null;
      activePatients?: number | null;
      inactivePatients?: number | null;
      startTimestamp?: any | null;
      endTimestamp?: any | null;
      questionnaireResponses?: number | null;
      manualObservations?: number | null;
      deviceObservations?: number | null;
      alarms?: number | null;
      alarmEvents?: number | null;
    }>;
  } | null;
};

export type DailyUserStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DailyUserStatsQuery = {
  dailyUserStats?: {
    count?: number | null;
    stats: Array<{
      timestamp: any;
      startTimestamp?: any | null;
      endTimestamp?: any | null;
      healthPersonnelUsers: number;
      healthPersonnelActive: number;
      healthPersonnelLoginErrors: number;
      healthPersonnelDefaultLogin: number;
      healthPersonnelExternalLogin: number;
      dialoggUsers: number;
      dialoggUsersActive: number;
      dialoggUsersLoginErrors: number;
      dialoggUsersDefaultLogin: number;
      dialoggUsersExternalLogin: number;
    }>;
  } | null;
};

export type AllExternalAccessQueryVariables = Exact<{
  healthProviderName?: InputMaybe<Scalars['String']['input']>;
}>;

export type AllExternalAccessQuery = {
  allExternalAccess: Array<{
    id: string;
    healthProviderName: string;
    name: string;
    ipRestrictions: Array<string>;
    patientGroupIds: Array<string>;
    allowedAccess?: Array<string> | null;
    forwarderId?: string | null;
  }>;
};

export type GetExternalAccessNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetExternalAccessNamesQuery = {
  getExternalAccessNames: Array<{ externalAccessNameToShow: string; externalAccessName: string }>;
};

export type ExternalIdentityProvidersForHealthProviderQueryVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
}>;

export type ExternalIdentityProvidersForHealthProviderQuery = {
  externalIdentityProvidersForHealthProvider: Array<{
    id: string;
    alias: string;
    clientId: string;
    displayName: string;
    tenantId: string;
    patientRealm: boolean;
    prio?: string | null;
    support: boolean;
    externalIdentityProvider: {
      provider: string;
      display: Array<{ localeId: string; displayName: string; description?: string | null }>;
      client: Array<{ localeId: string; displayName: string; description?: string | null }>;
      tenant: Array<{ localeId: string; displayName: string; description?: string | null }>;
    };
  }>;
};

export type ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables = Exact<{
  healthProviderName: Scalars['String']['input'];
  includePatientRealm?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExternalIdentityProviderRedirectorsForHealthProviderQuery = {
  externalIdentityProviderRedirectorsForHealthProvider?: Array<{
    id?: string | null;
    alias?: string | null;
    isPatientRealm?: boolean | null;
    config?: { defaultProvider?: string | null } | null;
  }> | null;
};

export type ExternalIdentityProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type ExternalIdentityProvidersQuery = {
  externalIdentityProviders: Array<{
    provider: string;
    display: Array<{ localeId: string; displayName: string; description?: string | null }>;
    client: Array<{ localeId: string; displayName: string; description?: string | null }>;
    tenant: Array<{ localeId: string; displayName: string; description?: string | null }>;
  }>;
};

export type ExternalIdentityProvidersForAllHealthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type ExternalIdentityProvidersForAllHealthProvidersQuery = {
  externalIdentityProvidersForAllHealthProviders: Array<{
    id: string;
    alias: string;
    healthProviderName: string;
    patientRealm: boolean;
    support: boolean;
    externalIdentityProvider: { provider: string };
  }>;
};

export type GlobalStatsQueryVariables = Exact<{
  date: Scalars['date']['input'];
}>;

export type GlobalStatsQuery = {
  globalStats: Array<{
    healthProvider: string;
    personnel: number;
    novo: number;
    cameras: number;
    notifyEnabledNextOfKins: number;
    allPatientStats: { active: number; inactive: number };
  }>;
};

export type GooglemapsAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type GooglemapsAccountsQuery = {
  googlemapsAccounts?: Array<{ id: string; accountDisplayName?: string | null; apiUrl?: string | null }> | null;
};

export type SupportTeamsForHealthProviderQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type SupportTeamsForHealthProviderQuery = {
  supportTeamsForHealthProvider: Array<{ name: string; displayName: string; linked?: boolean | null }>;
};

export type HealthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProvidersQuery = {
  healthProviders: Array<{
    name: string;
    displayName?: string | null;
    hasRpm: boolean;
    hasSupervision: boolean;
    hasSupportTeam: boolean;
    hasDhv: boolean;
    hasResponse: boolean;
    features?: { continuousSupervision?: boolean | null } | null;
  }>;
};

export type AdminHealthProviderFlowStatusFragment = {
  completed: boolean;
  paused?: boolean | null;
  hasFailed?: boolean | null;
  numberOfSteps: number;
  currentStep: number;
  logs: Array<{
    attempts: number;
    timestamp: string;
    errorMessage?: string | null;
    localePath: string;
    status: string;
  }>;
  stepStatuses?: Array<{ name: string; status: string; attempts: number; lastActivity?: any | null }> | null;
};

export type GetHealthProviderMarkedForDeletionFlowStatusQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type GetHealthProviderMarkedForDeletionFlowStatusQuery = {
  getHealthProviderMarkedForDeletionFlowStatus?: {
    completed: boolean;
    paused?: boolean | null;
    hasFailed?: boolean | null;
    numberOfSteps: number;
    currentStep: number;
    logs: Array<{
      attempts: number;
      timestamp: string;
      errorMessage?: string | null;
      localePath: string;
      status: string;
    }>;
    stepStatuses?: Array<{ name: string; status: string; attempts: number; lastActivity?: any | null }> | null;
  } | null;
};

export type GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery = {
  getRestoreHealthProviderMarkedForDeletionFlowStatus?: {
    completed: boolean;
    paused?: boolean | null;
    hasFailed?: boolean | null;
    numberOfSteps: number;
    currentStep: number;
    logs: Array<{
      attempts: number;
      timestamp: string;
      errorMessage?: string | null;
      localePath: string;
      status: string;
    }>;
    stepStatuses?: Array<{ name: string; status: string; attempts: number; lastActivity?: any | null }> | null;
  } | null;
};

export type GetHealthProviderDeletionFlowStatusQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type GetHealthProviderDeletionFlowStatusQuery = {
  getHealthProviderDeletionFlowStatus?: {
    completed: boolean;
    paused?: boolean | null;
    hasFailed?: boolean | null;
    numberOfSteps: number;
    currentStep: number;
    logs: Array<{
      attempts: number;
      timestamp: string;
      errorMessage?: string | null;
      localePath: string;
      status: string;
    }>;
    stepStatuses?: Array<{ name: string; status: string; attempts: number; lastActivity?: any | null }> | null;
  } | null;
};

export type GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllFinishedHealthProviderDeletionFlowStatusesQuery = {
  getAllFinishedHealthProviderDeletionFlowStatuses: Array<{
    healthProviderName?: string | null;
    willBeCleanedUpAt?: any | null;
    logs: Array<{ timestamp: string }>;
  }>;
};

export type GetAllHealthProviderDeletionFlowStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllHealthProviderDeletionFlowStatusesQuery = {
  getAllHealthProviderDeletionFlowStatuses: Array<{
    healthProviderName?: string | null;
    completed: boolean;
    hasFailed?: boolean | null;
  }>;
};

export type GetHealthProvidersMarkedForDeletionQueryVariables = Exact<{ [key: string]: never }>;

export type GetHealthProvidersMarkedForDeletionQuery = {
  getHealthProvidersMarkedForDeletion?: Array<{ name: string; displayName: string }> | null;
};

export type GetInconsistentHealthProviderReportsQueryVariables = Exact<{ [key: string]: never }>;

export type GetInconsistentHealthProviderReportsQuery = {
  getInconsistentHealthProviderReports: Array<{
    registryHealthProviderName?: string | null;
    healthProviderRealmName?: string | null;
    patientRealmName?: string | null;
  }>;
};

export type HealthProviderQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type HealthProviderQuery = {
  healthProvider: {
    name: string;
    displayName: string;
    usage?: string | null;
    externalHumanIdTypeIdForPatient?: string | null;
    externalHumanIdTypeIdForUser?: string | null;
    externalHumanIdTypeIdForDialoggUser?: string | null;
    userSessionLifespan?: number | null;
    patientSessionLifespan?: number | null;
    patientRealm?: string | null;
    timeZone?: string | null;
    url?: string | null;
    dialoggCode?: string | null;
    serviceId?: string | null;
    hasRpm?: boolean | null;
    hasDhv?: boolean | null;
    hasSupervision?: boolean | null;
    hasResponse?: boolean | null;
    hasSupportTeam?: boolean | null;
    defaultLocale?: string | null;
    customer?: { id?: string | null; name?: string | null } | null;
    service?: {
      id?: string | null;
      roles?: Array<{ id: string; userGroup?: { id: string } | null } | null> | null;
    } | null;
    features?: {
      continuousSupervision?: boolean | null;
      hasTrends?: boolean | null;
      newSupervisionUserTabs?: boolean | null;
      hasFurnitureDetection?: boolean | null;
      hasDemoAnonymization?: boolean | null;
      dataAnalytics?: boolean | null;
      joinNhnMeeting?: boolean | null;
      sendNotificationToNextOfKin?: boolean | null;
      hasCmp?: boolean | null;
      alarmStreaming?: boolean | null;
      beta?: boolean | null;
      selfTreatmentPlan?: boolean | null;
      hasEntraIdSso?: boolean | null;
      hasEntraIdProvisioning?: boolean | null;
      hasAlmaIntegration?: boolean | null;
      hasAscomIntegration?: boolean | null;
      hasPhoniroCloudIntegration?: boolean | null;
      hasSkyresponsePartnerIntegration?: boolean | null;
      hasSipIntegration?: boolean | null;
      hasCoordcomIntegration?: boolean | null;
      hasTietoLmoIntegration?: boolean | null;
      hasIpOmsorgIntegration?: boolean | null;
      hasUmo2GIntegration?: boolean | null;
      hasBestIntegration?: boolean | null;
    } | null;
    settings?: {
      externalHumanIdTypes?: Array<{
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string }>;
        use: {
          patientUse?: { applicable?: boolean | null } | null;
          personnelUse?: { applicable?: boolean | null } | null;
        };
      }> | null;
      userAuth?: {
        twoFactorSms?: boolean | null;
        ipRestriction?: boolean | null;
        timeLimitedAccess?: boolean | null;
        resetPasswordAllowed?: boolean | null;
        externalIdP?: Array<{
          alias?: string | null;
          displayName?: string | null;
          enabled?: boolean | null;
          usernamePolicy?: string | null;
          default?: boolean | null;
        }> | null;
      } | null;
      patientAuth?: {
        twoFactorSms?: boolean | null;
        ipRestriction?: boolean | null;
        timeLimitedAccess?: boolean | null;
        resetPasswordAllowed?: boolean | null;
        externalIdP?: Array<{
          alias?: string | null;
          displayName?: string | null;
          enabled?: boolean | null;
          usernamePolicy?: string | null;
          default?: boolean | null;
        }> | null;
      } | null;
    } | null;
    safemateAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    tcifAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    morpheanAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    twilioAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    videonorAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    sendGridAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    googlemapsAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
    skyresponseAccount?: { id?: string | null; accountDisplayName?: string | null } | null;
  };
};

export type ExternalHumanIdTypesQueryVariables = Exact<{ [key: string]: never }>;

export type ExternalHumanIdTypesQuery = {
  externalHumanIdTypes: Array<{
    id: string;
    localeEntries: Array<{ localeId: string; displayName: string }>;
    use: { patientUse?: { applicable?: boolean | null } | null; personnelUse?: { applicable?: boolean | null } | null };
  }>;
};

export type HealthProviderUsersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type HealthProviderUsersQuery = {
  healthProviderUsers: Array<{
    id: string;
    username?: string | null;
    email?: string | null;
    firstName: string;
    lastName: string;
    enabled?: boolean | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
  } | null>;
};

export type HourlyPatientStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type HourlyPatientStatsQuery = {
  hourlyPatientStats?: {
    count?: number | null;
    stats: Array<{
      timestamp?: any | null;
      startTimestamp?: any | null;
      endTimestamp?: any | null;
      questionnaireResponses?: number | null;
      manualObservations?: number | null;
      deviceObservations?: number | null;
      patientGroupName?: string | null;
      subscribedResponders?: number | null;
      openAlarms?: number | null;
      openTasks?: number | null;
    }>;
  } | null;
};

export type HourlyUserStatsQueryVariables = Exact<{
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
}>;

export type HourlyUserStatsQuery = {
  hourlyUserStats?: {
    count: number;
    stats: Array<{
      timestamp: any;
      startTimestamp?: any | null;
      endTimestamp?: any | null;
      loginCount: number;
      loginErrorCount: number;
      keycloakLoginCount: number;
      externalLoginCount: number;
      dialoggUsersLoginCount: number;
      dialoggUsersLoginErrorCount: number;
      dialoggUserskeycloakLoginCount: number;
      dialoggUsersExternalLoginCount: number;
    }>;
  } | null;
};

export type GetMigrationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMigrationsQuery = { getMigrations: Array<{ id: string; displayName: string; scope: MigrationScope }> };

export type MorpheanAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type MorpheanAccountsQuery = {
  morpheanAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    customerId?: number | null;
    customerIds?: Array<number | null> | null;
  }> | null;
};

export type RegistryDevicesQueryVariables = Exact<{
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
}>;

export type RegistryDevicesQuery = {
  registryDevices: Array<{
    id: string;
    type: string;
    healthProviderName?: string | null;
    lastHeartbeat?: any | null;
    lastBatteryStatus?: number | null;
    lastObservation?: any | null;
    lastStatus?: string | null;
    heartbeatCount?: number | null;
    observationCount?: number | null;
    online?: boolean | null;
    deviceName?: string | null;
    deviceGroup?: string | null;
    routerMac?: string | null;
    routerVendor?: string | null;
    modelName?: string | null;
    arch?: string | null;
  }>;
};

export type RegistryDeviceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type RegistryDeviceTypesQuery = { registryDeviceTypes?: Array<{ id: string; name: string } | null> | null };

export type DefaultRoleDefinitionsQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultRoleDefinitionsQuery = {
  defaultRoleDefinitions?: Array<{ id: string; display: Array<{ key: string; value: string } | null> }> | null;
};

export type DefaultRoleDefinitionsWithAbilitiesQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultRoleDefinitionsWithAbilitiesQuery = {
  defaultRoleDefinitions?: Array<{
    id: string;
    accessScopes?: Array<string | null> | null;
    dashboardRouteName?: string | null;
    isDefaultType?: string | null;
    display: Array<{ key: string; value: string } | null>;
    abilities?: Array<{ operation?: string | null; resource?: string | null } | null> | null;
  }> | null;
};

export type RoleDefinitionsQueryVariables = Exact<{
  healthProviderName: Scalars['ID']['input'];
}>;

export type RoleDefinitionsQuery = {
  roleDefinitions?: Array<{
    id: string;
    basedOn?: string | null;
    accessScopes?: Array<string | null> | null;
    dashboardRouteName?: string | null;
    display: Array<{ key: string; value: string } | null>;
    abilities?: Array<{ operation?: string | null; resource?: string | null } | null> | null;
  }> | null;
};

export type SafemateAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type SafemateAccountsQuery = {
  safemateAccounts?: Array<{
    id: string;
    accountDisplayName?: string | null;
    apiUsername?: string | null;
    observationUsername?: string | null;
    apiUrl?: string | null;
  }> | null;
};

export type SendGridAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type SendGridAccountsQuery = {
  sendGridAccounts?: Array<{ id: string; accountDisplayName: string; emailAddress: string }> | null;
};

export type SkyresponseAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type SkyresponseAccountsQuery = {
  skyresponseAccounts?: Array<{ id: string; accountDisplayName: string; username: string }> | null;
};

export type SupportTeamsWithLinkedHealthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type SupportTeamsWithLinkedHealthProvidersQuery = {
  supportTeamsWithLinkedHealthProviders: Array<{
    name: string;
    displayName: string;
    autoCreatedSupportUserRoleDefinitionId?: string | null;
    linkedHealthProviders: Array<string>;
    unlinkedHealthProviders?: Array<string> | null;
  }>;
};

export type TcifAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type TcifAccountsQuery = {
  tcifAccounts?: Array<{ id: string; accountDisplayName: string; prefixUrl: string }> | null;
};

export type TwilioAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type TwilioAccountsQuery = {
  twilioAccounts?: Array<{ id: string; accountDisplayName: string; phoneNumber: string; accountSid: string }> | null;
};

export type UserManualsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;

export type UserManualsQuery = {
  userManuals: Array<{
    id: string;
    name: string;
    icon?: string | null;
    priority?: number | null;
    applications?: { tilsyn?: boolean | null; dho?: boolean | null; dhv?: boolean | null } | null;
    localeEntries: Array<{ localeId: string; description?: string | null; displayName: string; url: string }>;
    roleDefinitions?: Array<{ id: string; display: Array<{ key: string; value: string } | null> }> | null;
  }>;
};

export type VideonorAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type VideonorAccountsQuery = {
  videonorAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    prefixUrl: string;
    roomNamePrefix?: string | null;
  }> | null;
};

export type ActivateCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type ActivateCarePlanMutation = {
  activateCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type ActivateCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateCarePlanTemplateMutation = {
  activateCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type ActivateObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateObservationTemplateMutation = {
  activateObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type ActivateQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateQuestionnaireTemplateMutation = {
  activateQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ path?: string | null } | null> | null } | null;
  };
};

export type CreateObservationForActivityInCarePlanTemplateMutationVariables = Exact<{
  observationActivityInput?: InputMaybe<ObservationInput>;
}>;

export type CreateObservationForActivityInCarePlanTemplateMutation = {
  createObservationForActivityInCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    observation?: {
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null;
  };
};

export type CreateObservationForActivityInCarePlanMutationVariables = Exact<{
  observationActivityInput?: InputMaybe<ObservationInput>;
}>;

export type CreateObservationForActivityInCarePlanMutation = {
  createObservationForActivityInCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    observation?: {
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null;
  };
};

export type CreateCarePlanBasedOnExistingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  newCarePlanTitle: Scalars['String']['input'];
  existingCarePlanId: Scalars['ID']['input'];
}>;

export type CreateCarePlanBasedOnExistingMutation = {
  createCarePlanBasedOnExisting: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanForPatientMutationVariables = Exact<{
  createInput?: InputMaybe<CarePlanInput>;
}>;

export type CreateCarePlanForPatientMutation = {
  createCarePlanForPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanTemplateMutationVariables = Exact<{
  createInput: CarePlanTemplateInput;
}>;

export type CreateCarePlanTemplateMutation = {
  createCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanTemplateBasedOnExistingMutationVariables = Exact<{
  newTitle: Scalars['String']['input'];
  basedOn: Scalars['ID']['input'];
}>;

export type CreateCarePlanTemplateBasedOnExistingMutation = {
  createCarePlanTemplateBasedOnExisting: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCommunicationToSeveralMutationVariables = Exact<{
  communication: PersonnelCommunicationToSeveralInput;
}>;

export type CreateCommunicationToSeveralMutation = {
  createCommunicationToSeveral: Array<{
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  }>;
};

export type CreateDocumentMutationVariables = Exact<{
  createInput: DocumentReferenceInput;
}>;

export type CreateDocumentMutation = {
  createDocument?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    documentReference?: {
      id: string;
      content?: Array<{ attachment?: { url?: string | null } | null } | null> | null;
    } | null;
  } | null;
};

export type CreateObservationTemplateMutationVariables = Exact<{
  observationInput: ObservationInput;
}>;

export type CreateObservationTemplateMutation = {
  createObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type CreateQuestionnaireForActivityInCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
}>;

export type CreateQuestionnaireForActivityInCarePlanMutation = {
  createQuestionnaireForActivityInCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: { id: string; title?: string | null; derivedFrom?: Array<string | null> | null } | null;
  };
};

export type CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
}>;

export type CreateQuestionnaireForActivityInCarePlanTemplateMutation = {
  createQuestionnaireForActivityInCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: { id: string; title?: string | null; derivedFrom?: Array<string | null> | null } | null;
  };
};

export type CreateQuestionnaireTemplateMutationVariables = Exact<{
  questionnaireInput: QuestionnaireInput;
}>;

export type CreateQuestionnaireTemplateMutation = {
  createQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DeleteDocumentMutation = { deleteDocument?: { success: boolean; message?: string | null } | null };

export type DeleteDraftCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type DeleteDraftCarePlanMutation = { deleteDraftCarePlan: { success: boolean; message?: string | null } };

export type CompleteCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type CompleteCarePlanMutation = {
  completeCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type CompleteCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CompleteCarePlanTemplateMutation = {
  completeCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type RetireObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireObservationTemplateMutation = {
  retireObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type RetireQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireQuestionnaireTemplateMutation = {
  retireQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ path?: string | null } | null> | null } | null;
  };
};

export type StartCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type StartCompositeTaskMutation = { startCompositeTask?: { success: boolean; message?: string | null } | null };

export type CompleteCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  journal?: InputMaybe<JournalInput>;
}>;

export type CompleteCompositeTaskMutation = {
  completeCompositeTask?: { success: boolean; message?: string | null } | null;
};

export type CompleteCompositeTaskAndItsSubTasksMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  journal?: InputMaybe<JournalInput>;
}>;

export type CompleteCompositeTaskAndItsSubTasksMutation = {
  completeCompositeTaskAndItsSubTasks?: { success: boolean; message?: string | null } | null;
};

export type RejectCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RejectCompositeTaskMutation = {
  rejectCompositeTask?: { success: boolean; message?: string | null } | null;
};

export type CompleteSubTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type CompleteSubTaskMutation = { completeSubTask?: { success: boolean; message?: string | null } | null };

export type RejectSubTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RejectSubTaskMutation = { rejectSubTask?: { success: boolean; message?: string | null } | null };

export type UpdateSubTaskPriorityMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSubTaskPriorityMutation = {
  updateSubTaskPriority?: { success: boolean; message?: string | null } | null;
};

export type UpdateCompositeTaskPriorityMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCompositeTaskPriorityMutation = {
  updateCompositeTaskPriority?: { success: boolean; message?: string | null } | null;
};

export type RetryTaskJournalingMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RetryTaskJournalingMutation = {
  retryTaskJournaling?: { success: boolean; message?: string | null } | null;
};

export type UpdateCarePlanTemplateQuestionnaireMutationVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput: QuestionnaireInput;
}>;

export type UpdateCarePlanTemplateQuestionnaireMutation = {
  updateCarePlanTemplateQuestionnaire: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateDraftCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanInput>;
}>;

export type UpdateDraftCarePlanMutation = {
  updateDraftCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateDraftCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanTemplateUpdateInput>;
}>;

export type UpdateDraftCarePlanTemplateMutation = {
  updateDraftCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: ObservationInput;
}>;

export type UpdateObservationTemplateMutation = {
  updateObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdateQuestionnaireMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
}>;

export type UpdateQuestionnaireMutation = {
  updateCarePlanQuestionnaire: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
}>;

export type UpdateQuestionnaireTemplateMutation = {
  updateQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type AcceptVideoMeetingTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type AcceptVideoMeetingTaskMutation = { acceptVideoMeetingTask?: { success: boolean } | null };

export type AddMyExternalIdMutationVariables = Exact<{
  externalUserId: ExternalHumanIdInput;
}>;

export type AddMyExternalIdMutation = {
  addMyExternalId: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddNotesToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>>;
}>;

export type AddNotesToTaskMutation = { addNotesToTask?: { success: boolean; message?: string | null } | null };

export type AddVideoMeetingTaskNotesMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
  note: Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>;
}>;

export type AddVideoMeetingTaskNotesMutation = {
  addVideoMeetingTaskNotes: { success: boolean; taskResponses: Array<{ success: boolean; message?: string | null }> };
};

export type AddRpmMedicalDeviceToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type AddRpmMedicalDeviceToPatientMutation = {
  addRpmMedicalDeviceToPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmMedicalDevice?: { modelName?: string | null; id: string } | null;
  };
};

export type CancelVideoMeetingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CancelVideoMeetingMutation = { cancelVideoMeeting?: { success: boolean; message?: string | null } | null };

export type CreateCommunicationMutationVariables = Exact<{
  communication: PersonnelCommunicationInput;
}>;

export type CreateCommunicationMutation = {
  createCommunication: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  };
};

export type CreateRpmMedicalDeviceMutationVariables = Exact<{
  createInput: RpmMedicalDeviceCreateInput;
}>;

export type CreateRpmMedicalDeviceMutation = {
  createRpmMedicalDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmMedicalDevice?: {
      id: string;
      manufacturer?: string | null;
      serialNumber?: string | null;
      modelNumber?: string | null;
      btAddress?: string | null;
    } | null;
  };
};

export type DeleteAppDeviceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
}>;

export type DeleteAppDeviceForPatientMutation = {
  deleteAppDeviceForPatient: { success: boolean; message?: string | null };
};

export type DeleteRpmMedicalDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteRpmMedicalDeviceMutation = { deleteRpmMedicalDevice: { success: boolean } };

export type ChangePicturePermissionMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;

export type ChangePicturePermissionMutation = { changePicturePermission: { success: boolean } };

export type RemovePatientFromDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type RemovePatientFromDialoggUserMutation = {
  removePatientFromDialoggUser: { success: boolean; dialoggUser?: { username: string } | null };
};

export type DisableServiceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  service: Scalars['String']['input'];
}>;

export type DisableServiceForPatientMutation = {
  disableServiceForPatient: {
    success: boolean;
    message?: string | null;
    subscription?:
      | { service: string }
      | { service: string }
      | { service: string }
      | { service: string }
      | { service: string }
      | null;
  };
};

export type EnableServiceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  service: Scalars['String']['input'];
}>;

export type EnableServiceForPatientMutation = {
  enableServiceForPatient: {
    success: boolean;
    message?: string | null;
    subscription?:
      | { service: string }
      | { service: string }
      | { service: string }
      | { service: string }
      | { service: string }
      | null;
  };
};

export type EndJoinVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type EndJoinVideoMeetingMutation = { endVideoMeeting?: { success: boolean; message?: string | null } | null };

export type EndVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type EndVideoMeetingMutation = { endVideoMeeting?: { success: boolean; message?: string | null } | null };

export type MarkCommunicationAsReadMutationVariables = Exact<{
  communicationId: Scalars['ID']['input'];
}>;

export type MarkCommunicationAsReadMutation = {
  markCommunicationAsRead: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  };
};

export type CreatePatientGoalsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  goalInput: GoalInput;
}>;

export type CreatePatientGoalsMutation = {
  createPatientGoals: { success: boolean; message?: string | null; selfTreatmentPlan?: { id: string } | null };
};

export type CreatePatientMedicalStatesMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  medicalStateInput: MedicalStatesInput;
}>;

export type CreatePatientMedicalStatesMutation = {
  createPatientMedicalStates: { success: boolean; message?: string | null; selfTreatmentPlan?: { id: string } | null };
};

export type ActivateSelfTreatmentPlanMutationVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type ActivateSelfTreatmentPlanMutation = {
  activateSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type DeactivateSelfTreatmentPlanMutationVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type DeactivateSelfTreatmentPlanMutation = {
  deactivateSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type UpdatePatientGoalsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  goalInput: UpdateGoalInput;
}>;

export type UpdatePatientGoalsMutation = { updatePatientGoals: { success: boolean; message?: string | null } };

export type UpdatePatientMedicalStatesMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  medicalStateInput: MedicalStatesInput;
}>;

export type UpdatePatientMedicalStatesMutation = {
  updatePatientMedicalStates: { success: boolean; message?: string | null };
};

export type UpdatePatientReferenceRangeMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
  referenceRange: Array<InputMaybe<ObservationComponentInput>> | InputMaybe<ObservationComponentInput>;
}>;

export type UpdatePatientReferenceRangeMutation = {
  updatePatientReferenceRange?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type AddReferenceRangeToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRange: PatientReferenceRangeInput;
}>;

export type AddReferenceRangeToPatientMutation = {
  addReferenceRangeToPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type RemoveReferenceRangeFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
}>;

export type RemoveReferenceRangeFromPatientMutation = {
  removeReferenceRangeFromPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type ReleaseVideoMeetingTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type ReleaseVideoMeetingTaskMutation = { releaseVideoMeetingTask?: { success: boolean } | null };

export type RemovePatientFromDialoggUserInPatientMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type RemovePatientFromDialoggUserInPatientMutation = {
  removePatientFromDialoggUser: {
    success: boolean;
    dialoggUser?: {
      username: string;
      onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
    } | null;
  };
};

export type RemoveRpmMedicalDeviceFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type RemoveRpmMedicalDeviceFromPatientMutation = {
  removeRpmMedicalDeviceFromPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type SendVideoMeetingInvitationSmsMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendVideoMeetingInvitationSmsMutation = {
  sendVideoMeetingInvitationSms?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    videoMeeting?: { id: string } | null;
  } | null;
};

export type StartJoinVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
  videoMeetingURL?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartJoinVideoMeetingMutation = {
  startJoinVideoMeeting?: { success: boolean; message?: string | null } | null;
};

export type StartVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type StartVideoMeetingMutation = { startVideoMeeting?: { success: boolean; message?: string | null } | null };

export type UpdateGroupVideoMeetingParticipantsMutationVariables = Exact<{
  videoMeetingGroupId: Scalars['ID']['input'];
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UpdateGroupVideoMeetingParticipantsMutation = {
  updateGroupVideoMeetingParticipants?: { success: boolean; message?: string | null } | null;
};

export type TestPushNotificationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
}>;

export type TestPushNotificationMutation = {
  testPushNotification: { success: boolean; date: number; objectReference: { reference?: string | null } };
};

export type UpdateAppDeviceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
  input: AppDeviceForPatientUpdateInput;
}>;

export type UpdateAppDeviceForPatientMutation = { updateAppDeviceForPatient: { success: boolean } };

export type UpdateDigitalHomeVisitsSettingsForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  settings: DigitalHomeVisitsSettingsInput;
}>;

export type UpdateDigitalHomeVisitsSettingsForPatientMutation = {
  updateDigitalHomeVisitsSettingsForPatient: {
    success: boolean;
    message?: string | null;
    subscription?: {
      service: string;
      settings: {
        playRingtoneOnStart: boolean;
        requestVideoMeetings: boolean;
        showParticipantVideoMeetingToolbar: boolean;
        autoStart: { enabled: boolean; afterSeconds?: number | null };
      };
    } | null;
  };
};

export type UpdateObservationStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;

export type UpdateObservationStatusMutation = { updateObservationStatus?: { success: boolean } | null };

export type UpdateRpmMedicalDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: RpmMedicalDeviceUpdateInput;
}>;

export type UpdateRpmMedicalDeviceMutation = { updateRpmMedicalDevice: { success: boolean; message?: string | null } };

export type ConcreteObservationQueryVariables = Exact<{
  observationId: Scalars['ID']['input'];
}>;

export type ConcreteObservationQuery = {
  concreteObservation?: {
    id: string;
    manual?: boolean | null;
    status: string;
    effectiveDateTime?: any | null;
    received?: any | null;
    gateway?: { display?: string | null } | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    device?: { reference?: string | null; display?: string | null } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  } | null;
};

export type GetCarePlanByIdQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanByIdQuery = {
  getCarePlanByID: {
    id: string;
    status: CarePlanStatus;
    title?: string | null;
    description?: string | null;
    created?: any | null;
    subject: { reference?: string | null };
    period?: { start?: any | null; end?: any | null } | null;
    activity: Array<{
      outcomeReference?: Array<{
        reference?: string | null;
        display?: string | null;
        type?: string | null;
        identifier?: { value?: string | null } | null;
      } | null> | null;
      observations?: Array<{
        id: string;
        text?: string | null;
        status: string;
        identifier?: Array<{ value?: string | null } | null> | null;
        basedOn?: Array<{ reference?: string | null } | null> | null;
        note?: Array<{ text?: string | null } | null> | null;
        fromTemplate?: { reference?: string | null } | null;
        code?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
          } | null> | null;
        } | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          };
          valueQuantity?: { value?: number | null; unit?: string | null } | null;
          referenceRange?: Array<{
            text?: string | null;
            low?: { value?: number | null; unit?: string | null } | null;
            high?: { value?: number | null; unit?: string | null } | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      detail: {
        instantiatesCanonical?: Array<string | null> | null;
        status: string;
        questionnaires?: Array<{
          id: string;
          title?: string | null;
          derivedFrom?: Array<string | null> | null;
        } | null> | null;
        scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      };
    } | null>;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetCarePlanTitleQueryQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanTitleQueryQuery = { getCarePlanByID: { title?: string | null } };

export type GetCarePlanDocumentsQueryQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanDocumentsQueryQuery = {
  getCarePlanByID: {
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetCarePlanTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCarePlanTemplateQuery = {
  getCarePlanTemplate: {
    id: string;
    status: CarePlanStatus;
    title?: string | null;
    description?: string | null;
    created?: any | null;
    carePlanType?: string | null;
    period?: { start?: any | null; end?: any | null } | null;
    activity: Array<{
      outcomeReference?: Array<{
        reference?: string | null;
        display?: string | null;
        type?: string | null;
        identifier?: { value?: string | null } | null;
      } | null> | null;
      observations?: Array<{
        id: string;
        text?: string | null;
        status: string;
        identifier?: Array<{ value?: string | null } | null> | null;
        basedOn?: Array<{ reference?: string | null } | null> | null;
        note?: Array<{ text?: string | null } | null> | null;
        fromTemplate?: { reference?: string | null } | null;
        code?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
          } | null> | null;
        } | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          };
          valueQuantity?: { value?: number | null; unit?: string | null } | null;
          referenceRange?: Array<{
            text?: string | null;
            low?: { value?: number | null; unit?: string | null } | null;
            high?: { value?: number | null; unit?: string | null } | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      detail: {
        instantiatesCanonical?: Array<string | null> | null;
        status: string;
        questionnaires?: Array<{
          id: string;
          title?: string | null;
          derivedFrom?: Array<string | null> | null;
        } | null> | null;
        scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      };
    } | null>;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetObservationTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetObservationTemplateQuery = {
  getObservationTemplate?: {
    id: string;
    systemDefined?: boolean | null;
    status: string;
    identifier?: Array<{ value?: string | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
    } | null;
    component?: Array<{
      valueQuantity?: { unit?: string | null } | null;
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null } | null;
        high?: { value?: number | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null;
      } | null> | null;
      dataAbsentReason?: { text?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetPatientTasksNotCompletedQueryVariables = Exact<{
  tasks: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetPatientTasksNotCompletedQuery = {
  getPatientTasksNotCompleted: Array<{
    task: { id: string; authoredOn?: any | null };
    patientTasks: Array<{
      id: string;
      code?: { text?: string | null } | null;
      restriction?: { period?: { start?: any | null; end?: any | null } | null } | null;
    } | null>;
  } | null>;
};

export type GetTasksForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetTasksForPatientQuery = {
  getTasksForPatient: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    code?: { text?: string | null } | null;
    missedSubmissions?: Array<{ kind: MissedSubmissionKind; name?: string | null }> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    patient?: {
      id: string;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
    subTasks?: Array<{
      id: string;
      authoredOn?: any | null;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type GetTasksForPatientByDateRangeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['dateTime']['input']>;
  toDate?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetTasksForPatientByDateRangeQuery = {
  getTasksForPatientByDateRange: Array<{
    hpTasks: Array<string>;
    task: {
      id: string;
      status: string;
      description?: string | null;
      priority?: string | null;
      authoredOn?: any | null;
      lastModified: any;
      reminderDate?: any | null;
      reminderSent?: boolean | null;
      code?: { text?: string | null } | null;
      restriction?: { period?: { start?: any | null; end?: any | null } | null } | null;
      carePlan?: { id: string; title?: string | null } | null;
    };
  } | null>;
};

export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery = {
  lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient: Array<{
    manual?: boolean | null;
    id: string;
    text?: string | null;
    status: string;
    effectiveDateTime?: any | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: {
          system?: string | null;
          use?: IdentifierUse | null;
          value?: string | null;
          type?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
              userSelected?: boolean | null;
            } | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  }>;
};

export type GetAllObservationTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllObservationTemplatesQuery = {
  getAllObservationTemplates: Array<{
    id: string;
    systemDefined?: boolean | null;
    status: string;
    identifier?: Array<{ value?: string | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
    } | null;
    component?: Array<{
      valueQuantity?: { unit?: string | null } | null;
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null>;
};

export type GetConcreteObservationsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetConcreteObservationsForPatientQuery = {
  getConcreteObservationsForPatient: Array<{
    manual?: boolean | null;
    id: string;
    text?: string | null;
    status: string;
    effectiveDateTime?: any | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: {
          system?: string | null;
          use?: IdentifierUse | null;
          value?: string | null;
          type?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
              userSelected?: boolean | null;
            } | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  } | null>;
};

export type GetConcreteObservationsForPatientAsCsvQueryVariables = Exact<{
  patientIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type GetConcreteObservationsForPatientAsCsvQuery = {
  getConcreteObservationsForPatientAsCsv?: { csv?: string | null } | null;
};

export type GetQuestionnaireTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetQuestionnaireTemplateQuery = {
  getQuestionnaireTemplate: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type GetCarePlanQuestionnaireQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
}>;

export type GetCarePlanQuestionnaireQuery = {
  getCarePlanQuestionnaire: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type GetCarePlanTemplateQuestionnaireQueryVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
}>;

export type GetCarePlanTemplateQuestionnaireQuery = {
  getCarePlanTemplateQuestionnaire: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type BookedMeetingsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type BookedMeetingsForPatientQuery = {
  bookedMeetingsForPatient?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    patient: { id: string; name?: Array<{ text?: string | null }> | null };
    videoMeeting: {
      id: string;
      appointment: {
        appointmentGroupId?: string | null;
        description?: string | null;
        status: AppointmentStatus;
        start: any;
        end: any;
        patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
        supportingInformation?: Array<{ reference?: string | null } | null> | null;
      };
      carePlan?: { id: string } | null;
    };
  } | null> | null;
};

export type BookedMeetingsForEveryoneQueryVariables = Exact<{
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type BookedMeetingsForEveryoneQuery = {
  bookedMeetingsForEveryone?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    patient: { id: string; name?: Array<{ text?: string | null }> | null };
    videoMeeting: {
      id: string;
      appointment: {
        description?: string | null;
        status: AppointmentStatus;
        appointmentGroupId?: string | null;
        start: any;
        end: any;
        meetingEndTime?: any | null;
        meetingStartTime?: any | null;
        patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
        supportingInformation?: Array<{ reference?: string | null } | null> | null;
      };
      carePlan?: { id: string } | null;
    };
  }> | null;
};

export type AllMeetingsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type AllMeetingsForPatientQuery = {
  allMeetingsForPatient?: Array<{
    id: string;
    status: string;
    patient: { id: string; name?: Array<{ text?: string | null }> | null };
    videoMeeting: {
      id: string;
      appointment: {
        description?: string | null;
        appointmentGroupId?: string | null;
        status: AppointmentStatus;
        start: any;
        end: any;
        patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
        supportingInformation?: Array<{ reference?: string | null } | null> | null;
      };
      carePlan?: { id: string } | null;
    };
  } | null> | null;
};

export type AllMeetingsForEveryoneQueryVariables = Exact<{
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type AllMeetingsForEveryoneQuery = {
  allMeetingsForEveryone?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    patient: { id: string; name?: Array<{ text?: string | null }> | null };
    videoMeeting: {
      id: string;
      appointment: {
        description?: string | null;
        appointmentGroupId?: string | null;
        status: AppointmentStatus;
        start: any;
        end: any;
        meetingEndTime?: any | null;
        meetingStartTime?: any | null;
        patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
        supportingInformation?: Array<{ reference?: string | null } | null> | null;
      };
      carePlan?: { id: string } | null;
    };
  }> | null;
};

export type PatientRequestQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type PatientRequestQuery = {
  patientRequest?: {
    id: string;
    status: string;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    note?: Array<{
      time?: any | null;
      text?: string | null;
      authorString?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetVideoMeetingCarePlanQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetVideoMeetingCarePlanQuery = {
  getVideoMeetingCarePlan: Array<{
    durationInMinutes: number;
    activity: {
      id: string;
      description?: string | null;
      status: string;
      identifier: Array<{ system?: string | null; value?: string | null } | null>;
      code: {
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      };
    };
    scheduledTiming: {
      repeat?: {
        dayOfWeek?: Array<DayOfWeek> | null;
        timeOfDay: Array<string>;
        periodUnit?: string | null;
        period?: number | null;
        boundsPeriod?: { start?: any | null; end?: any | null } | null;
      } | null;
    };
  }>;
};

export type AddPlannedVideoMeetingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PlannedVideoMeetingCreateInput;
}>;

export type AddPlannedVideoMeetingMutation = {
  addPlannedVideoMeeting?: {
    success?: boolean | null;
    message?: string | null;
    plannedVideoMeeting?: {
      durationInMinutes: number;
      scheduledTiming: {
        repeat?: {
          dayOfWeek?: Array<DayOfWeek> | null;
          timeOfDay: Array<string>;
          periodUnit?: string | null;
          period?: number | null;
          boundsPeriod?: { start?: any | null; end?: any | null } | null;
        } | null;
      };
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdatePlannedVideoMeetingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
  input: PlannedVideoMeetingUpdateInput;
}>;

export type UpdatePlannedVideoMeetingMutation = {
  updatePlannedVideoMeeting?: {
    success?: boolean | null;
    message?: string | null;
    plannedVideoMeeting?: {
      durationInMinutes: number;
      scheduledTiming: {
        repeat?: {
          dayOfWeek?: Array<DayOfWeek> | null;
          timeOfDay: Array<string>;
          periodUnit?: string | null;
          period?: number | null;
          boundsPeriod?: { start?: any | null; end?: any | null } | null;
        } | null;
      };
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type RescheduleVideoMeetingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  start: Scalars['dateTime']['input'];
  end: Scalars['dateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type RescheduleVideoMeetingMutation = {
  rescheduleVideoMeeting?: { success: boolean; calendarInvitation?: string | null } | null;
};

export type RemovePlannedVideoMeetingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
}>;

export type RemovePlannedVideoMeetingMutation = {
  removePlannedVideoMeeting?: {
    success?: boolean | null;
    message?: string | null;
    plannedVideoMeeting?: {
      durationInMinutes: number;
      activity: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        noCarePlanRequired?: boolean | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        fromTemplate?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        identifier: Array<{ system?: string | null; use?: IdentifierUse | null; value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        };
        effectiveTiming?: {
          event?: Array<any | null> | null;
          repeat?: {
            dayOfWeek?: Array<DayOfWeek> | null;
            timeOfDay: Array<string>;
            periodUnit?: string | null;
            period?: number | null;
            boundsPeriod?: { start?: any | null; end?: any | null } | null;
          } | null;
        } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null> | null;
        component?: Array<{
          valueString?: string | null;
          code: { text?: string | null };
          valueQuantity?: { value?: number | null; unit?: string | null } | null;
          referenceRange?: Array<{
            text?: string | null;
            low?: { value?: number | null; unit?: string | null } | null;
            high?: { value?: number | null; unit?: string | null } | null;
            type?: { text?: string | null } | null;
          } | null> | null;
          interpretation?: Array<{ text?: string | null } | null> | null;
          dataAbsentReason?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
              userSelected?: boolean | null;
            } | null> | null;
          } | null;
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
            extension?: Array<{
              url?: string | null;
              valueBoolean?: boolean | null;
              valueInteger?: number | null;
              valueString?: string | null;
              ValueId?: string | null;
            }> | null;
          }> | null;
        } | null> | null;
        note?: Array<{
          authorString?: string | null;
          time?: any | null;
          text?: string | null;
          authorReference?: {
            reference?: string | null;
            type?: string | null;
            display?: string | null;
            identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
          } | null;
        } | null> | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
      };
      scheduledTiming: {
        event?: Array<any | null> | null;
        repeat?: {
          dayOfWeek?: Array<DayOfWeek> | null;
          timeOfDay: Array<string>;
          periodUnit?: string | null;
          period?: number | null;
        } | null;
      };
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type PlanVideoMeetingMutationVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  createInput: VideoMeetingInput;
}>;

export type PlanVideoMeetingMutation = {
  planVideoMeeting?: {
    success: boolean;
    calendarInvitation?: string | null;
    videoMeeting?: { id: string } | null;
  } | null;
};

export type ReadySubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReadySubTasksQuery = {
  readySubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type ReadyTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReadyTasksQuery = {
  readyTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type InProgressSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProgressSubTasksQuery = {
  inProgressSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type InProgressTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProgressTasksQuery = {
  inProgressTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type RejectedSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectedSubTasksQuery = {
  rejectedSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type RejectedTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectedTasksQuery = {
  rejectedTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type CompletedSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompletedSubTasksQuery = {
  completedSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type CompletedTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompletedTasksQuery = {
  completedTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type DialoggUsersListQueryVariables = Exact<{ [key: string]: never }>;

export type DialoggUsersListQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
  }>;
};

export type DialoggUsersQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    picturePermission?: boolean | null;
    otpStatus?: string | null;
    ipRestrictions?: Array<string> | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    passwordStatus?: string | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
    timeLimitedAccess?: { start?: any | null; end?: any | null } | null;
    externalIdentities?: Array<{ provider: string }> | null;
  }>;
};

export type DialoggUsersDeleteQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersDeleteQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
  }>;
};

export type DialoggUsersForCreateDialogQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersForCreateDialogQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    externalIdentities?: Array<{ provider: string }> | null;
  }>;
};

export type DialoggUserCommonFieldsFragment = {
  username: string;
  firstName?: string | null;
  lastName?: string | null;
  enabled?: boolean | null;
  lastActive?: any | null;
  email?: string | null;
};

export type DialoggUsersWithAccessToPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type DialoggUsersWithAccessToPatientQuery = {
  dialoggUsersWithAccessToPatient: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    lastActive?: any | null;
    role?: string | null;
  }>;
};

export type GetAllCarePlanTemplatesQueryVariables = Exact<{
  withStatus?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllCarePlanTemplatesQuery = {
  getAllCarePlanTemplates: Array<{
    id: string;
    title?: string | null;
    status: CarePlanStatus;
    carePlanType?: string | null;
  }>;
};

export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    version: string;
    status: QuestionnaireStatus;
  }>;
};

export type GetAllRpmMedicalDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllRpmMedicalDevicesQuery = {
  getAllRpmMedicalDevices: Array<{
    id: string;
    status?: string | null;
    tags?: Array<string> | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    imei?: string | null;
    simNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  }>;
};

export type GetAppDevicesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAppDevicesForPatientQuery = {
  getAppDevicesForPatient: Array<{
    id: string;
    username: string;
    deviceName: string;
    os: string;
    lastActive?: any | null;
    appSettings?: { appLocale?: string | null; appName?: string | null; pushId?: string | null } | null;
    notificationSettings?: {
      message?: boolean | null;
      deviation?: boolean | null;
      measurement?: boolean | null;
      reviewed?: boolean | null;
      reminder?: number | null;
      videoMeetingReminder?: boolean | null;
    } | null;
    remindedTasks?: Array<{ success: boolean; date: number; objectReference: { reference?: string | null } }> | null;
  }>;
};

export type GetAvailablePatientServiceSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailablePatientServiceSubscriptionsQuery = { getAvailablePatientServiceSubscriptions: Array<string> };

export type GetEnabledServicesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetEnabledServicesForPatientQuery = {
  getEnabledServicesForPatient: Array<
    | {
        __typename: 'DhvSubscription';
        service: string;
        settings: {
          playRingtoneOnStart: boolean;
          requestVideoMeetings: boolean;
          showParticipantVideoMeetingToolbar: boolean;
          autoStart: { enabled: boolean; afterSeconds?: number | null };
        };
      }
    | { __typename: 'MessageExchangeSubscription'; service: string }
    | { __typename: 'ResponseSubscription'; service: string }
    | { __typename: 'RpmSubscription'; service: string }
    | { __typename: 'SupervisionSubscription'; service: string }
  >;
};

export type GetNotesForVideoMeetingQueryVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type GetNotesForVideoMeetingQuery = {
  getHealthPersonnelTaskForVideoMeeting?: {
    id: string;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  } | null;
};

export type GetTaskAndVideoMeetingQueryVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type GetTaskAndVideoMeetingQuery = {
  getHealthPersonnelTaskForVideoMeeting?: {
    id: string;
    status: string;
    owner?: { display?: string | null } | null;
    videoMeeting?: {
      id: string;
      appointment: {
        id: string;
        status: AppointmentStatus;
        start: any;
        end: any;
        meetingStartTime?: any | null;
        meetingEndTime?: any | null;
        description?: string | null;
        appointmentType: string;
        appointmentGroupId?: string | null;
        patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
        supportingInformation?: Array<{
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
        } | null> | null;
        participant?: Array<{
          actor?: {
            reference?: string | null;
            type?: string | null;
            display?: string | null;
            identifier?: { value?: string | null } | null;
          } | null;
        } | null> | null;
        patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
      };
      carePlan?: { id: string; title?: string | null } | null;
      videonor?: {
        meetingId?: string | null;
        participantRoomUrl?: string | null;
        hostRoomUrl?: string | null;
        startDate?: any | null;
        endDate?: any | null;
      } | null;
    } | null;
  } | null;
};

export type GetListOfUnallocatedRpmMedicalDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedRpmMedicalDevicesQuery = {
  getListOfUnallocatedRpmMedicalDevices: Array<{
    id: string;
    status?: string | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  }>;
};

export type GetMedicalDeviceForMeasurementQueryVariables = Exact<{
  measurementId: Scalars['ID']['input'];
  medicalDeviceId: Scalars['ID']['input'];
}>;

export type GetMedicalDeviceForMeasurementQuery = {
  getMedicalDeviceForMeasurement?: {
    id: string;
    serialNumber?: string | null;
    modelNumber?: string | null;
    manufacturer?: string | null;
  } | null;
};

export type GetPatientNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientNameQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
  } | null;
};

export type GetPatientSelfTreatmentPlansQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientSelfTreatmentPlansQuery = {
  getPatientSelfTreatmentPlans?: {
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  } | null;
};

export type GetReadyTaskCountQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  code?: InputMaybe<TaskCode>;
  onlyUpcomingVideoMeetings?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetReadyTaskCountQuery = {
  getReadyTaskCount: {
    routine: number;
    urgent: number;
    asap: number;
    stat: number;
    video: number;
    upcomingVideo: number;
    pendingReminders: number;
  };
};

export type GetRpmMedicalDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRpmMedicalDeviceQuery = {
  getRpmMedicalDevice?: {
    id: string;
    status?: string | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetTaskByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskByIdQuery = {
  getTaskById?: {
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    description?: string | null;
    code?: { text?: string | null } | null;
    missedSubmissions?: Array<{
      kind: MissedSubmissionKind;
      name?: string | null;
      scheduledFor: any;
      reportedAt: any;
      patientTask: { reference?: string | null; display?: string | null };
      carePlan?: { reference?: string | null; display?: string | null } | null;
    }> | null;
    journalWorkflow?: Array<{ status: string }> | null;
    executionPeriod?: { start?: any | null; end?: any | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
    subTasks?: Array<{
      id: string;
      authoredOn?: any | null;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any };
      videonor?: { meetingId?: string | null } | null;
    } | null;
  } | null;
};

export type GetTaskByIdWithJournalRetryQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskByIdWithJournalRetryQuery = {
  getTaskById?: {
    id: string;
    status: string;
    priority?: string | null;
    authoredOn?: any | null;
    description?: string | null;
    canRetryJournaling?: boolean | null;
    isJournalNoteRequired?: boolean | null;
    code?: { text?: string | null } | null;
    missedSubmissions?: Array<{
      kind: MissedSubmissionKind;
      name?: string | null;
      scheduledFor: any;
      reportedAt: any;
      patientTask: { reference?: string | null; display?: string | null };
      carePlan?: { reference?: string | null; display?: string | null } | null;
    }> | null;
    journalWorkflow?: Array<{
      type: string;
      status: string;
      userGroupId?: string | null;
      retriedAt?: Array<any | null> | null;
      nextRetry?: any | null;
      completedAt?: any | null;
      freeTextNote?: string | null;
      completionOptions?: Array<string> | null;
      debugDetails?: string | null;
    }> | null;
    executionPeriod?: { start?: any | null; end?: any | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
    subTasks?: Array<{
      id: string;
      authoredOn?: any | null;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any };
      videonor?: { meetingId?: string | null } | null;
    } | null;
  } | null;
};

export type MissedSubmissionDetailsFragment = {
  kind: MissedSubmissionKind;
  name?: string | null;
  scheduledFor: any;
  reportedAt: any;
  patientTask: { reference?: string | null; display?: string | null };
  carePlan?: { reference?: string | null; display?: string | null } | null;
};

export type PatientCommunicationsPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type PatientCommunicationsPaginatedQuery = {
  patientCommunicationsPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      status?: string | null;
      sent?: any | null;
      received?: any | null;
      payload?: Array<{
        contentString?: string | null;
        picture?: {
          id: string;
          deleted?: boolean | null;
          deletedAt?: string | null;
          deletedBy?: { display?: string | null; reference?: string | null } | null;
          content?: Array<{
            attachment?: {
              title?: string | null;
              contentType?: string | null;
              url?: string | null;
              size?: number | null;
              creation?: any | null;
            } | null;
          } | null> | null;
        } | null;
      } | null> | null;
      sender?: { reference?: string | null; display?: string | null } | null;
      subject?: { reference?: string | null } | null;
    } | null> | null;
  };
};

export type PatientWithJournalConfigQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PatientWithJournalConfigQuery = {
  patient?: {
    id: string;
    name?: Array<{ text?: string | null }> | null;
    journalConfigForPatient?: {
      remotePatientMonitoring: { enabled: boolean; taskCodesForJournaling: Array<string> };
    } | null;
  } | null;
};

export type QuestionnaireTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type QuestionnaireTemplatesQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    purpose?: string | null;
    experimental: boolean;
    version: string;
    status: QuestionnaireStatus;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
  }>;
};

export type SetOfPatientsQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type SetOfPatientsQuery = {
  setOfPatients: Array<{
    id: string;
    identifier: Array<{ use?: IdentifierUse | null; value?: string | null } | null>;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
  } | null>;
};

export type TaskListTaskFragment = {
  id: string;
  status: string;
  priority?: string | null;
  authoredOn?: any | null;
  lastModified: any;
  code?: { text?: string | null } | null;
  note?: Array<{
    authorString?: string | null;
    time?: any | null;
    text?: string | null;
    authorReference?: { reference?: string | null; display?: string | null } | null;
  } | null> | null;
  owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
  carePlan?: { title?: string | null } | null;
  patient?: {
    id: string;
    birthDate?: any | null;
    name?: Array<{ text?: string | null }> | null;
    identifier: Array<{ value?: string | null } | null>;
  } | null;
};

export type FetchTranscareUserActivityQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type FetchTranscareUserActivityQuery = {
  fetchTranscareUserActivity: Array<{ name: string; startTime: string; endTime: string }>;
};

export type FetchTranscareUserPredictionActivityQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  fromDate: Scalars['dateTime']['input'];
  toDate: Scalars['dateTime']['input'];
}>;

export type FetchTranscareUserPredictionActivityQuery = {
  fetchTranscareUserPredictionActivity: Array<{
    userId: string;
    dateTime: string;
    activity: string;
    predictedValue: number;
    realValue: number;
  }>;
};

export type FetchTranscareUserIntensityQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  fromDate: Scalars['dateTime']['input'];
  toDate: Scalars['dateTime']['input'];
}>;

export type FetchTranscareUserIntensityQuery = {
  fetchTranscareUserIntensity: Array<{ time: string; intensity: string }>;
};

export type ListAllTranscareUsersQueryVariables = Exact<{ [key: string]: never }>;

export type ListAllTranscareUsersQuery = { listAllTranscareUsers: Array<{ id: string }> };

export type CreateTranscareUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CreateTranscareUserMutation = {
  createTranscareUser: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UnreadCommunicationsQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UnreadCommunicationsQuery = {
  unreadCommunications: Array<{
    id: string;
    sent?: any | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
    } | null;
    payload?: Array<{ contentString?: string | null } | null> | null;
  }>;
};

export type UnreadCommunicationsCountQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UnreadCommunicationsCountQuery = { unreadCommunicationsCount: number };

export type VideoMeetingQueryVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type VideoMeetingQuery = {
  videoMeeting?: {
    id: string;
    appointment: {
      id: string;
      status: AppointmentStatus;
      start: any;
      end: any;
      description?: string | null;
      appointmentType: string;
      appointmentGroupId?: string | null;
      patients: Array<{ id: string; name?: Array<{ text?: string | null }> | null }>;
      supportingInformation?: Array<{
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      } | null> | null;
      participant?: Array<{
        actor?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: { value?: string | null } | null;
        } | null;
      } | null> | null;
      patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    };
    carePlan?: { id: string; title?: string | null } | null;
    videonor?: {
      meetingId?: string | null;
      participantRoomUrl?: string | null;
      hostRoomUrl?: string | null;
      startDate?: any | null;
      endDate?: any | null;
    } | null;
  } | null;
};

export type SimulateCarePlanObservationResponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  activityId: Scalars['ID']['input'];
  observation: ObservationInput;
}>;

export type SimulateCarePlanObservationResponseMutation = {
  simulateCarePlanObservationResponse: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type SimulateCarePlanQuestionnaireResponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  questionnaireResponseInput: QuestionnaireResponseSimulatorInput;
}>;

export type SimulateCarePlanQuestionnaireResponseMutation = {
  simulateCarePlanQuestionnaireResponse: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateDialoggUserMutationVariables = Exact<{
  dialoggUser: CreateDialoggUserInput;
}>;

export type CreateDialoggUserMutation = { createDialoggUser: { success: boolean; message?: string | null } };

export type UpdateDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  dialoggUser: UpdateDialoggUser;
}>;

export type UpdateDialoggUserMutation = { updateDialoggUser: { success: boolean; message?: string | null } };

export type ForceDeleteDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type ForceDeleteDialoggUserMutation = { forceDeleteDialoggUser: { success: boolean; message?: string | null } };

export type DeleteDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeleteDialoggUserMutation = { deleteDialoggUser: { success: boolean; message?: string | null } };

export type UpdateDialoggUserPasswordMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;

export type UpdateDialoggUserPasswordMutation = {
  updateDialoggUserPassword: { success: boolean; message?: string | null };
};

export type RemoveDialoggUserPasswordMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type RemoveDialoggUserPasswordMutation = {
  removeDialoggUserPassword: { success: boolean; message?: string | null };
};

export type AssignPatientToDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type AssignPatientToDialoggUserMutation = {
  assignPatientToDialoggUser: { success: boolean; message?: string | null };
};

export type ActivateDialoggUserSmsOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type ActivateDialoggUserSmsOtpMutation = { activateDialoggUserSmsOtp: boolean };

export type DeactivateDialoggUserSmsOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeactivateDialoggUserSmsOtpMutation = { deactivateDialoggUserSmsOtp: boolean };

export type ActivateDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type ActivateDialoggUserOtpMutation = { activateDialoggUserOtp: boolean };

export type DeleteDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeleteDialoggUserOtpMutation = { deleteDialoggUserOtp: boolean };

export type CancelDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type CancelDialoggUserOtpMutation = { cancelDialoggUserOtp: boolean };

export type UpdateDialoggUserIpRestrictionsMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateDialoggUserIpRestrictionsMutation = {
  updateDialoggUserIPRestrictions: {
    success: boolean;
    inputValidation?: { valid: boolean; message?: string | null } | null;
  };
};

export type UpdateDialggUserTimeLimitedAccessMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  timeLimitedAccess?: InputMaybe<PeriodInput>;
}>;

export type UpdateDialggUserTimeLimitedAccessMutation = {
  updateDialoggUserTimeLimitedAccess: { success: boolean; inputValidation?: { message?: string | null } | null };
};

export type SetDialoggUserExternalIdPMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>> | InputMaybe<ExternalIdentityInput>>;
}>;

export type SetDialoggUserExternalIdPMutation = { setDialoggUserExternalIdP: boolean };

export type RejectVideoMeetingRequestMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RejectVideoMeetingRequestMutation = {
  rejectVideoMeetingRequest?: { success: boolean; message?: string | null } | null;
};

export type StartVideoMeetingRequestMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type StartVideoMeetingRequestMutation = {
  startVideoMeetingRequest?: { success: boolean; message?: string | null } | null;
};

export type GetPatientRemindersForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<AppointmentStatus>;
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetPatientRemindersForPatientQuery = {
  remindersForPatient: Array<{
    id: string;
    status: AppointmentStatus;
    appointmentType: string;
    description?: string | null;
    minutesBeforeReminder?: number | null;
    action?: string | null;
    requiresAcknowledgement: boolean;
    allDay: boolean;
    allDayDate?: any | null;
    acknowledgedAt?: any | null;
    start: any;
    end: any;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    } | null;
    participant?: Array<{
      actor?: { reference?: string | null; display?: string | null } | null;
      task?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
  }>;
};

export type GetPlannedRemindersForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPlannedRemindersForPatientQuery = {
  getPlannedRemindersForPatient: Array<{
    id: string;
    description?: string | null;
    minutesBeforeReminder: number;
    action?: string | null;
    requiresAcknowledgement: boolean;
    allDay: boolean;
    scheduledTiming: {
      repeat?: {
        timeOfDay: Array<string>;
        dayOfWeek?: Array<DayOfWeek> | null;
        period?: number | null;
        periodUnit?: string | null;
        boundsPeriod?: { start?: any | null; end?: any | null } | null;
      } | null;
    };
  }>;
};

export type PatientRemindersPaginatedQueryVariables = Exact<{
  status?: InputMaybe<AppointmentStatus>;
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type PatientRemindersPaginatedQuery = {
  remindersForEveryone: {
    cursor?: any | null;
    hasMore: boolean;
    reminders: Array<{
      id: string;
      status: AppointmentStatus;
      appointmentType: string;
      description?: string | null;
      minutesBeforeReminder?: number | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      allDayDate?: any | null;
      acknowledgedAt?: any | null;
      start: any;
      end: any;
      patient?: {
        id: string;
        name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      } | null;
      participant?: Array<{
        actor?: { reference?: string | null; display?: string | null } | null;
        task?: { reference?: string | null; display?: string | null } | null;
      } | null> | null;
    }>;
  };
};

export type GetPatientReminderByIdQueryVariables = Exact<{
  reminderId: Scalars['ID']['input'];
}>;

export type GetPatientReminderByIdQuery = {
  getReminderById?: {
    id: string;
    reminder: {
      id: string;
      status: AppointmentStatus;
      appointmentType: string;
      start: any;
      end: any;
      meetingStartTime?: any | null;
      meetingEndTime?: any | null;
      description?: string | null;
      minutesBeforeReminder?: number | null;
      action?: string | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      allDayDate?: any | null;
      acknowledgedAt?: any | null;
      participant?: Array<{
        actor?: { reference?: string | null; display?: string | null } | null;
        task?: { reference?: string | null } | null;
      } | null> | null;
      supportingInformation?: Array<{ reference?: string | null; display?: string | null } | null> | null;
      carePlan?: { id: string; title?: string | null; status: CarePlanStatus } | null;
      patient?: {
        id: string;
        name?: Array<{ text?: string | null; given?: Array<string | null> | null; family?: string | null }> | null;
      } | null;
    };
  } | null;
};

export type UpdatePlannedReminderMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  plannedReminderId: Scalars['ID']['input'];
  input: PlannedReminderUpdateInput;
}>;

export type UpdatePlannedReminderMutation = {
  updatePlannedReminder?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    plannedReminder?: {
      id: string;
      description?: string | null;
      minutesBeforeReminder: number;
      action?: string | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      scheduledTiming: {
        repeat?: {
          timeOfDay: Array<string>;
          dayOfWeek?: Array<DayOfWeek> | null;
          periodUnit?: string | null;
          period?: number | null;
        } | null;
      };
    } | null;
  } | null;
};

export type PlanPatientReminderMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PatientReminderCreateInput;
}>;

export type PlanPatientReminderMutation = {
  planPatientReminder?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    reminder?: {
      id: string;
      status: AppointmentStatus;
      appointmentType: string;
      description?: string | null;
      minutesBeforeReminder?: number | null;
      action?: string | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      acknowledgedAt?: any | null;
      start: any;
      end: any;
      participant?: Array<{
        actor?: { reference?: string | null; display?: string | null } | null;
        task?: { reference?: string | null; display?: string | null } | null;
      } | null> | null;
      patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    } | null;
  } | null;
};

export type CancelPatientReminderMutationVariables = Exact<{
  reminderId: Scalars['ID']['input'];
}>;

export type CancelPatientReminderMutation = {
  cancelReminder?: {
    success: boolean;
    message?: string | null;
    reminder?: {
      id: string;
      status: AppointmentStatus;
      appointmentType: string;
      description?: string | null;
      start: any;
      end: any;
    } | null;
  } | null;
};

export type RemovePlannedReminderMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  plannedReminderId: Scalars['ID']['input'];
}>;

export type RemovePlannedReminderMutation = {
  removePlannedReminder?: { success: boolean; message?: string | null } | null;
};

export type AddPlannedReminderMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PlannedReminderCreateInput;
}>;

export type AddPlannedReminderMutation = {
  addPlannedReminder?: {
    success: boolean;
    message?: string | null;
    plannedReminder?: {
      id: string;
      description?: string | null;
      minutesBeforeReminder: number;
      action?: string | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      scheduledTiming: {
        repeat?: {
          timeOfDay: Array<string>;
          dayOfWeek?: Array<DayOfWeek> | null;
          periodUnit?: string | null;
          period?: number | null;
        } | null;
      };
    } | null;
  } | null;
};

export type ReschedulePatientReminderMutationVariables = Exact<{
  reminderId: Scalars['ID']['input'];
  input: PatientReminderRescheduleInput;
}>;

export type ReschedulePatientReminderMutation = {
  reschedulePatientReminder?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    reminder?: {
      id: string;
      status: AppointmentStatus;
      start: any;
      end: any;
      description?: string | null;
      minutesBeforeReminder?: number | null;
      action?: string | null;
      requiresAcknowledgement: boolean;
      allDay: boolean;
      acknowledgedAt?: any | null;
    } | null;
  } | null;
};

export type GetRequestQueryVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;

export type GetRequestQuery = {
  getTaskById?: {
    id: string;
    status: string;
    description?: string | null;
    authoredOn?: any | null;
    owner?: { display?: string | null } | null;
    patient?: {
      id: string;
      name?: Array<{ family?: string | null; given?: Array<string | null> | null }> | null;
    } | null;
    videoMeeting?: {
      id: string;
      appointment: { status: AppointmentStatus; start: any; end: any; description?: string | null };
    } | null;
    note?: Array<{
      text?: string | null;
      time?: any | null;
      authorString?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetRequestsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetRequestsQuery = {
  requests: Array<{
    id: string;
    status: string;
    authoredOn?: any | null;
    description?: string | null;
    owner?: { display?: string | null } | null;
    patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    videoMeeting?: { appointment: { id: string; status: AppointmentStatus } } | null;
  } | null>;
};

export type EmbeddedPatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EmbeddedPatientQuery = {
  patient?: {
    id: string;
    name?: Array<{ text?: string | null }> | null;
    cameras?: Array<{ id: string; name?: string | null; macAddress?: string | null } | null> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }> | null;
  } | null;
};

export type SetPendingExternalIdentityProviderMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalIdentityProvider: Scalars['String']['input'];
  pending: Scalars['Boolean']['input'];
}>;

export type SetPendingExternalIdentityProviderMutation = { setPendingExternalIdentityProvider: boolean };

export type SetExternalIdRequestMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalHumanIdType: Scalars['String']['input'];
  requested: Scalars['Boolean']['input'];
}>;

export type SetExternalIdRequestMutation = { setExternalIdRequest: boolean };

export type RemoveExternalDialoggUserIdMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type RemoveExternalDialoggUserIdMutation = { removeExternalDialoggUserId: { success: boolean } };

export type RemoveExternalUserIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type RemoveExternalUserIdMutation = { removeExternalUserId: { success: boolean } };

export type RemoveExternalPatientIdFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
}>;

export type RemoveExternalPatientIdFromPatientMutation = { removeExternalPatientIdFromPatient: { success: boolean } };

export type AddExternalDialoggUserIdMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type AddExternalDialoggUserIdMutation = { addExternalDialoggUserId: { success: boolean } };

export type AddExternalUserIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type AddExternalUserIdMutation = { addExternalUserId: { success: boolean } };

export type AddExternalPatientIdToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
}>;

export type AddExternalPatientIdToPatientMutation = { addExternalPatientIdToPatient: { success: boolean } };

export type RemoveUserReservationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveUserReservationMutation = { removeUserReservation?: boolean | null };

export type AddUserReservationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type AddUserReservationMutation = { addUserReservation?: boolean | null };

export type PatientWithUserReservationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithUserReservationsQuery = {
  patient?: {
    id: string;
    userReservations?: Array<{ userId: string; firstName?: string | null; lastName?: string | null } | null> | null;
  } | null;
};

export type RoleTypesForAuditEventAgentQueryVariables = Exact<{ [key: string]: never }>;

export type RoleTypesForAuditEventAgentQuery = {
  roleTypes: Array<{ id: string; display: Array<{ key: string; value: string } | null> }>;
};

export type DeleteUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteUserGroupMutation = { deleteUserGroup: { success?: boolean | null; message?: string | null } };

export type UpdateUserGroupMutationVariables = Exact<{
  userGroup: UpdateUserGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type UpdateUserGroupMutation = { updateUserGroup: { success?: boolean | null; message?: string | null } };

export type CreateUserGroupMutationVariables = Exact<{
  newUserGroup: CreateUserGroupInput;
  parentUserGroupId: Scalars['ID']['input'];
}>;

export type CreateUserGroupMutation = {
  createUserGroup: { success?: boolean | null; message?: string | null; userGroup?: { id: string } | null };
};

export type PatientGroupForAlarmForwardingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientGroupForAlarmForwardingQuery = {
  patientGroup?: {
    id: string;
    name?: string | null;
    alarmRoutes: Array<{
      configName: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        icon?: string | null;
      } | null;
    }>;
  } | null;
};

export type GetSkyresponseSyncJobsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetSkyresponseSyncJobsCountQuery = { getSkyresponseSyncJobsCount: number };

export type SyncPatientInfoWithSkyresponseForSyncModalMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  syncScenario?: InputMaybe<Scalars['String']['input']>;
}>;

export type SyncPatientInfoWithSkyresponseForSyncModalMutation = {
  syncPatientInfoWithSkyresponse: {
    success?: boolean | null;
    message?: string | null;
    total?: number | null;
    take?: number | null;
    skip?: number | null;
    next?: { skip?: number | null; take?: number | null } | null;
  };
};

export type UserGroupPatientAccessListQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type UserGroupPatientAccessListQuery = {
  userGroupPatientAccessList?: Array<{
    id: string;
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    roles: Array<{ id: string; userGroupName: string; display: Array<{ key: string; value: string }> }>;
  } | null> | null;
};

export type RoleTypesQueryVariables = Exact<{ [key: string]: never }>;

export type RoleTypesQuery = {
  roleTypes: Array<{ id: string; basedOn_fk?: string | null; display: Array<{ key: string; value: string } | null> }>;
};

export type GetAlarmHandlingRulesForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAlarmHandlingRulesForUserGroupQuery = {
  getAlarmHandlingRulesForUserGroup?: Array<{ id: number; name: string }> | null;
};

export type CreatePatientGroupMutationVariables = Exact<{
  createInput: PatientGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type CreatePatientGroupMutation = { createPatientGroup?: { success: boolean; message?: string | null } | null };

export type UpdatePatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  patientGroup: PatientGroupInput;
}>;

export type UpdatePatientGroupMutation = { updatePatientGroup?: { success: boolean; message?: string | null } | null };

export type HideTechnicalAlarmNotificationsForPatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  hideTechnicalAlarmNotifications: Scalars['Boolean']['input'];
}>;

export type HideTechnicalAlarmNotificationsForPatientGroupMutation = {
  hideTechnicalAlarmNotificationsForPatientGroup?: { success: boolean; message?: string | null } | null;
};

export type RemovePatientGroupFromUserGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type RemovePatientGroupFromUserGroupMutation = {
  removePatientGroupFromUserGroup?: { success: boolean; message?: string | null } | null;
};

export type CreateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type CreateRoleMutation = { createRole: { success?: boolean | null; message?: string | null } };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;

export type DeleteRoleMutation = { deleteRole: { success: boolean; message?: string | null } };

export type UpdateSkyresponseConfigMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  skyresponseConfig: SkyresponseConfigInput;
}>;

export type UpdateSkyresponseConfigMutation = {
  updateSkyresponseConfig: { success: boolean; message?: string | null };
};

export type UpdateEscalationDelayMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  escalationDelay: Scalars['Int']['input'];
}>;

export type UpdateEscalationDelayMutation = { updateEscalationDelay: { success: boolean; message?: string | null } };

export type DeleteEscalationDelayMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type DeleteEscalationDelayMutation = { deleteEscalationDelay: { success: boolean; message?: string | null } };

export type UpdateCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeam: UpdateCareTeamInput;
}>;

export type UpdateCareTeamMutation = { updateCareTeam: { success: boolean; message?: string | null } };

export type AddCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeam: CreateCareTeamInput;
}>;

export type AddCareTeamMutation = { addCareTeam: { success: boolean; message?: string | null } };

export type RemoveCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeamId: Scalars['ID']['input'];
}>;

export type RemoveCareTeamMutation = { removeCareTeam: { success: boolean; message?: string | null } };

export type CreateHelseIdAccountMutationVariables = Exact<{
  input: HelseIdAccountCreateInput;
}>;

export type CreateHelseIdAccountMutation = {
  createHelseIdAccount: { success: boolean; message?: string | null; helseIdAccount?: { id: string } | null };
};

export type UpdateHelseIdAccountMutationVariables = Exact<{
  helseIdAccountId: Scalars['ID']['input'];
  input: HelseIdAccountUpdateInput;
}>;

export type UpdateHelseIdAccountMutation = { updateHelseIdAccount: { success: boolean; message?: string | null } };

export type CreateVkpAccountMutationVariables = Exact<{
  input: VkpAccountInput;
}>;

export type CreateVkpAccountMutation = { createVkpAccount: { success: boolean; message?: string | null } };

export type UpdateVkpAccountMutationVariables = Exact<{
  vkpAccountId: Scalars['ID']['input'];
  input: VkpAccountInput;
}>;

export type UpdateVkpAccountMutation = { updateVkpAccount: { success: boolean; message?: string | null } };

export type DeleteVkpAccountMutationVariables = Exact<{
  vkpAccountId: Scalars['ID']['input'];
}>;

export type DeleteVkpAccountMutation = { deleteVkpAccount: { success: boolean; message?: string | null } };

export type DeleteHelseIdAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteHelseIdAccountMutation = { deleteHelseIdAccount: { success: boolean; message?: string | null } };

export type TestHelseIdCredentialsMutationVariables = Exact<{
  helseIdAccountId: Scalars['ID']['input'];
}>;

export type TestHelseIdCredentialsMutation = { testHelseIdCredentials: boolean };

export type HelseIdAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type HelseIdAccountsQuery = {
  helseIdAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    organizationNumber: string;
    credentials?: {
      authority: string;
      clientId: string;
      grantTypes: Array<string>;
      maskedPrivateJwk: string;
      rsaKeyExpiryDate: any;
      rsaKeySizeBits: number;
      maskedRsaPrivateKey: string;
      scopes: Array<string>;
      secretType: string;
    } | null;
  }> | null;
};

export type VkpAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type VkpAccountsQuery = {
  vkpAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    helseIdAccountId: string;
    helseIdAccount?: { credentials?: { scopes: Array<string> } | null } | null;
  }> | null;
};

export type CreateJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: JournalConfigForUserGroupInput;
}>;

export type CreateJournalConfigForUserGroupMutation = {
  createJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type UpdateJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: JournalConfigForUserGroupInput;
}>;

export type UpdateJournalConfigForUserGroupMutation = {
  updateJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type UpdateInheritedJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: InheritedJournalConfigForUserGroupInput;
}>;

export type UpdateInheritedJournalConfigForUserGroupMutation = {
  updateInheritedJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type DeleteJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type DeleteJournalConfigForUserGroupMutation = {
  deleteJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type GetJournalConfigForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetJournalConfigForUserGroupQuery = {
  getJournalConfigForUserGroup?: {
    vkpAccountId: string;
    forUserGroupId: string;
    monitoringEmailAddresses: Array<string>;
    inheritedFromUserGroup?: string | null;
    remotePatientMonitoring: {
      enabled: boolean;
      apiUrl?: string | null;
      journalingDisabledForPatientGroupIds: Array<string>;
      isLabModuleEnabled?: boolean | null;
      taskCodesForJournaling?: Array<string> | null;
    };
    remoteSupervision: {
      enabled: boolean;
      apiUrl?: string | null;
      journalingDisabledForPatientGroupIds: Array<string>;
    };
    read: {
      enabled: boolean;
      apiUrl?: string | null;
      features?: {
        hasCreatePatientFromVkp: boolean;
        responseCenter: { hasCarePlanRead: boolean; hasEpisodesOfCareRead: boolean; hasPatientRead: boolean };
      } | null;
    };
  } | null;
};

export type GetPatientFromVkpQueryVariables = Exact<{
  norwegianId: Scalars['String']['input'];
}>;

export type GetPatientFromVkpQuery = {
  getPatientFromVkp: {
    success: boolean;
    patient?: {
      birthDate?: any | null;
      gender?: AdministrativeGender | null;
      hasSecretAddress?: boolean | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      }> | null;
      address?: Array<{
        use?: AddressUse | null;
        line?: Array<string | null> | null;
        city?: string | null;
        postalCode?: string | null;
        country?: string | null;
        text?: string | null;
      }> | null;
      externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    } | null;
  };
};

export type UpdateIpRestrictionsModalMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateIpRestrictionsModalMutation = {
  updateIPRestrictions?: {
    success: boolean;
    inputValidation?: { valid: boolean; message?: string | null } | null;
  } | null;
};

export type EventConfigScheduleFieldsFragment = {
  repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> };
};

export type CepConfigFieldsFragment = {
  trigger?: Array<string> | null;
  cancelledBy?: Array<string> | null;
  after?: number | null;
};

export type TimedCepConfigFieldsFragment = {
  cancelledBy?: Array<string> | null;
  events: Array<string>;
  mode: string;
  alarmTimeWindow: { checkTimeFrom: string; checkTimeTo: string; dayOfWeek: Array<DayOfWeek> };
};

export type AddCameraToSetupBatchTelluSupportMutationVariables = Exact<{
  cameraSetupInput: CameraSetupInput;
}>;

export type AddCameraToSetupBatchTelluSupportMutation = { addCameraToSetupBatchTelluSupport: boolean };

export type RedoCameraSetupTelluSupportMutationVariables = Exact<{
  serial: Scalars['String']['input'];
}>;

export type RedoCameraSetupTelluSupportMutation = { redoCameraSetupTelluSupport: boolean };

export type ResetCameraSetupTelluSupportMutationVariables = Exact<{
  serial: Scalars['String']['input'];
}>;

export type ResetCameraSetupTelluSupportMutation = { resetCameraSetupTelluSupport: boolean };

export type ResetCameraSetupBatchTelluSupportMutationVariables = Exact<{ [key: string]: never }>;

export type ResetCameraSetupBatchTelluSupportMutation = { resetCameraSetupBatchTelluSupport: boolean };

export type ResetMorpheanCacheTelluSupportMutationVariables = Exact<{ [key: string]: never }>;

export type ResetMorpheanCacheTelluSupportMutation = { resetMorpheanCacheTelluSupport: boolean };

export type CameraAppBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  appUpdates: Array<CameraAppUpdateInput> | CameraAppUpdateInput;
}>;

export type CameraAppBulkUpdateMutation = { cameraAppBulkUpdate: boolean };

export type CameraAudioSettingsBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  settings: CameraAudioSettingsInput;
}>;

export type CameraAudioSettingsBulkUpdateMutation = { cameraAudioSettingsBulkUpdate: boolean };

export type CameraRotationBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  settings: CameraRotationSettingsInput;
}>;

export type CameraRotationBulkUpdateMutation = { cameraRotationBulkUpdate: boolean };

export type CameraRebootBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
}>;

export type CameraRebootBulkUpdateMutation = { cameraRebootBulkUpdate: boolean };

export type CameraFirmwareBulkUpgradeMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  firmwareUpgradeOptions: CameraFirmwareUpgradeInput;
}>;

export type CameraFirmwareBulkUpgradeMutation = { cameraFirmwareBulkUpgrade: boolean };

export type DecommissionCamerasMutationVariables = Exact<{
  cameras: Array<CameraManagementInputWithOptionalId> | CameraManagementInputWithOptionalId;
}>;

export type DecommissionCamerasMutation = { decommissionCameras: boolean };

export type CameraNetworkingBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
}>;

export type CameraNetworkingBulkUpdateMutation = { cameraNetworkingBulkUpdate: boolean };

export type CameraIoPortConfigurationBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  settings: CameraIoPortConfigurationSettingsInput;
}>;

export type CameraIoPortConfigurationBulkUpdateMutation = { cameraIoPortConfigurationBulkUpdate: boolean };

export type CompleteBoundingBoxFragment = {
  topLeftX: number;
  topLeftY: number;
  bottomRightX: number;
  bottomRightY: number;
};

export type TakeCameraSnapshotWithDetectionsMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type TakeCameraSnapshotWithDetectionsMutation = {
  takeCameraSnapshotWithDetections: {
    snapshotToken: string;
    detectedObjects: Array<{
      score: number;
      type: string;
      boundingBox: { topLeftX: number; topLeftY: number; bottomRightX: number; bottomRightY: number };
    }>;
  };
};

export type SetReferenceObjectsForCameraMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  referenceObjects: Array<ReferenceObjectInput> | ReferenceObjectInput;
}>;

export type SetReferenceObjectsForCameraMutation = {
  setReferenceObjectsForCamera: {
    referenceObjects?: Array<{
      type: string;
      sensitivity: number;
      boundingBox: { topLeftX: number; topLeftY: number; bottomRightX: number; bottomRightY: number };
    }> | null;
  };
};

export type UpdateFurnitureDetectionAlarmSnapshotMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type UpdateFurnitureDetectionAlarmSnapshotMutation = { updateFurnitureDetectionAlarmSnapshot: boolean };

export type TerminateShiftSessionOnDeviceMutationVariables = Exact<{
  device: Scalars['String']['input'];
}>;

export type TerminateShiftSessionOnDeviceMutation = {
  terminateShiftSessionOnDevice?: { createdAt: any; lastUpdated: any } | null;
};

export type TerminateShiftSessionOnAllDevicesMutationVariables = Exact<{ [key: string]: never }>;

export type TerminateShiftSessionOnAllDevicesMutation = { terminateShiftSessionOnAllDevices?: boolean | null };

export type TerminateShiftSessionOnAllDevicesForUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type TerminateShiftSessionOnAllDevicesForUserMutation = { terminateShiftSessionOnAllDevicesForUser: boolean };

export type UpdateShiftSessionPhoneNumberMutationVariables = Exact<{
  shiftSessionPhoneNumber: Scalars['String']['input'];
}>;

export type UpdateShiftSessionPhoneNumberMutation = {
  updateShiftSessionPhoneNumber?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type TakeCallMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  takeCallInput?: InputMaybe<TakeCallInput>;
}>;

export type TakeCallMutation = {
  takeCall: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAccountSettingsMutationVariables = Exact<{
  input: UpdateAccountSettingsInput;
}>;

export type UpdateAccountSettingsMutation = {
  updateAccountSettings: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    accountSettings?: {
      userSessionLifespan?: number | null;
      name: string;
      displayName: string;
      defaultLocale?: string | null;
      timeZone: string;
    } | null;
  };
};

export type EnableApplicationMutationVariables = Exact<{
  application: Application;
}>;

export type EnableApplicationMutation = {
  enableApplication: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    applications: { supervision?: boolean | null; dhv?: boolean | null; rpm?: boolean | null };
  };
};

export type DisableApplicationMutationVariables = Exact<{
  application: Application;
}>;

export type DisableApplicationMutation = {
  disableApplication: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    applications: { supervision?: boolean | null; dhv?: boolean | null; rpm?: boolean | null };
  };
};

export type EnableFeatureFlagMutationVariables = Exact<{
  flag: FeatureFlag;
}>;

export type EnableFeatureFlagMutation = {
  enableFeatureFlag: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    features: {
      continuousSupervision?: boolean | null;
      hasTrends?: boolean | null;
      hasEntraIdSso?: boolean | null;
      hasEntraIdProvisioning?: boolean | null;
    };
  };
};

export type DisableFeatureFlagMutationVariables = Exact<{
  flag: FeatureFlag;
}>;

export type DisableFeatureFlagMutation = {
  disableFeatureFlag: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    blockingCameraProfiles?: Array<{ id: string; name: string; template?: CameraProfileTemplate | null }> | null;
    features: {
      continuousSupervision?: boolean | null;
      hasTrends?: boolean | null;
      hasEntraIdSso?: boolean | null;
      hasEntraIdProvisioning?: boolean | null;
    };
  };
};

export type EnableUserAuthSettingMutationVariables = Exact<{
  setting: UserAuthSetting;
}>;

export type EnableUserAuthSettingMutation = {
  enableUserAuthSetting: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    userAuth: {
      resetPasswordAllowed: boolean;
      twoFactorAppRequired: boolean;
      timeLimitedAccess: boolean;
      ipRestriction: boolean;
    };
  };
};

export type DisableUserAuthSettingMutationVariables = Exact<{
  setting: UserAuthSetting;
}>;

export type DisableUserAuthSettingMutation = {
  disableUserAuthSetting: {
    success: boolean;
    message?: string | null;
    isEnabled: boolean;
    userAuth: {
      resetPasswordAllowed: boolean;
      twoFactorAppRequired: boolean;
      timeLimitedAccess: boolean;
      ipRestriction: boolean;
    };
  };
};

export type ActivateAzureProvisioningMutationVariables = Exact<{
  azureAccountId: Scalars['ID']['input'];
}>;

export type ActivateAzureProvisioningMutation = {
  activateAzureProvisioning?: {
    success: boolean;
    message?: string | null;
    azureProvisioningCredentials?: { tenantUrl?: string | null; secretToken?: string | null } | null;
  } | null;
};

export type AddExternalIdPMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  idP: Scalars['String']['input'];
}>;

export type AddExternalIdPMutation = { addExternalIdP: boolean };

export type AddMqttDeviceToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  mqttDeviceId: Scalars['ID']['input'];
}>;

export type AddMqttDeviceToPatientMutation = { addMqttDeviceToPatient: { success: boolean } };

export type AddWelfareDeviceToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
}>;

export type AddWelfareDeviceToPatientMutation = { addWelfareDeviceToPatient: { success: boolean } };

export type RemoveWelfareDeviceFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
}>;

export type RemoveWelfareDeviceFromPatientMutation = {
  removeWelfareDeviceFromPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type StartAudioStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type StartAudioStreamMutation = {
  stream: { id: string; url: string; type?: string | null; expires?: any | null; ttl?: number | null };
};

export type StopAudioStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopAudioStreamMutation = { stream: boolean };

export type KeepAudioStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepAudioStreamAliveMutation = {
  stream: { id: string; url: string; type?: string | null; expires?: any | null; ttl?: number | null };
};

export type StartBoundingBoxStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type StartBoundingBoxStreamMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type StopBoundingBoxStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopBoundingBoxStreamMutation = { stream: boolean };

export type KeepBoundingBoxStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepBoundingBoxStreamAliveMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type ConfigureCameraEventsMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type ConfigureCameraEventsMutation = { configureCameraEvents: { success: boolean } };

export type StartAppMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
}>;

export type StartAppMutation = { startApp: boolean };

export type StopAppMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
}>;

export type StopAppMutation = { stopApp: boolean };

export type RebootMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type RebootMutation = { reboot: boolean };

export type SetCameraLandmarksMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  input: CameraLandmarksInput;
}>;

export type SetCameraLandmarksMutation = {
  setCameraLandmarks: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    configuration?: {
      zones?: {
        success: boolean;
        message?: string | null;
        errorCode?: CameraConfigurationErrorCode | null;
        retryable?: boolean | null;
        zones?: {
          bed: Array<{ x: number; y: number }>;
          doors: Array<{ name: CameraDoorName; vertices: Array<{ x: number; y: number }> }>;
          safeZones: Array<{ name: CameraSafeZoneName; generated: boolean; vertices: Array<{ x: number; y: number }> }>;
          exclusionZones: Array<{ name: CameraExclusionZoneName; vertices: Array<{ x: number; y: number }> }>;
        } | null;
      } | null;
    } | null;
  };
};

export type SetCameraDetectionSettingsMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  input: CameraDetectionSettingsInput;
}>;

export type SetCameraDetectionSettingsMutation = {
  setCameraDetectionSettings: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    configuration?: {
      detectionSettings?: {
        success: boolean;
        message?: string | null;
        errorCode?: CameraConfigurationErrorCode | null;
        retryable?: boolean | null;
        detectionSettings?: {
          underCameraAreaSafe: boolean;
          events: Array<{
            event: CameraEventKey;
            enabled: boolean;
            available: boolean;
            unavailableReason?: CameraEventUnavailableReason | null;
          }>;
          fallSensitivity: {
            mode?: CameraFallSensitivityMode | null;
            available: boolean;
            unavailableReason?: CameraEventUnavailableReason | null;
          };
          safeZoneNoDataHold: {
            minutes?: number | null;
            available: boolean;
            unavailableReason?: CameraEventUnavailableReason | null;
          };
        } | null;
      } | null;
      zones?: {
        success: boolean;
        message?: string | null;
        errorCode?: CameraConfigurationErrorCode | null;
        retryable?: boolean | null;
        zones?: {
          bed: Array<{ x: number; y: number }>;
          doors: Array<{ name: CameraDoorName; vertices: Array<{ x: number; y: number }> }>;
          safeZones: Array<{ name: CameraSafeZoneName; generated: boolean; vertices: Array<{ x: number; y: number }> }>;
          exclusionZones: Array<{ name: CameraExclusionZoneName; vertices: Array<{ x: number; y: number }> }>;
        } | null;
      } | null;
    } | null;
  };
};

export type CreateCameraProfileMutationVariables = Exact<{
  input: CameraProfileInput;
}>;

export type CreateCameraProfileMutation = {
  createCameraProfile: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    cameraProfile?: {
      isDefault: boolean;
      cameraCount: number;
      id: string;
      name: string;
      template?: CameraProfileTemplate | null;
      origin: CameraProfileOrigin;
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      enableSnapshotAnonymization?: boolean | null;
      continuousSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundMonitoringDefaultThreshold: number;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableExtendingCameraAvailability: boolean;
    } | null;
  };
};

export type UpdateCameraProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CameraProfileInput;
}>;

export type UpdateCameraProfileMutation = {
  updateCameraProfile: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    cameraProfile?: {
      isDefault: boolean;
      cameraCount: number;
      id: string;
      name: string;
      template?: CameraProfileTemplate | null;
      origin: CameraProfileOrigin;
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      enableSnapshotAnonymization?: boolean | null;
      continuousSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundMonitoringDefaultThreshold: number;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableExtendingCameraAvailability: boolean;
    } | null;
  };
};

export type DeleteCameraProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  replacementCameraProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteCameraProfileMutation = {
  deleteCameraProfile: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type SetDefaultCameraProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SetDefaultCameraProfileMutation = {
  setDefaultCameraProfile: {
    success: boolean;
    message?: string | null;
    cameraProfile?: { id: string; isDefault: boolean } | null;
  };
};

export type SetCameraProfileMutationVariables = Exact<{
  cameraIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  cameraProfileId: Scalars['ID']['input'];
}>;

export type SetCameraProfileMutation = {
  setCameraProfile: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateCameraSettingsMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  input: CameraSettingsInput;
}>;

export type UpdateCameraSettingsMutation = {
  updateCameraSettings: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    settings?: { soundThreshold?: number | null } | null;
  };
};

export type CameraConfigureTwoWayAudioMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  revert?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CameraConfigureTwoWayAudioMutation = { cameraConfigureTwoWayAudio: boolean };

export type CreateAzureAccountMutationVariables = Exact<{
  input: ExternalIdentityProviderAzureForHealthProviderCreateInput;
}>;

export type CreateAzureAccountMutation = {
  createAzureAccount: { success: boolean; message?: string | null; azureAccount?: { id: string } | null };
};

export type CreateCameraMutationVariables = Exact<{
  createInput: CreateCameraInput;
}>;

export type CreateCameraMutation = {
  createCamera: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateMqttDeviceMutationVariables = Exact<{
  createInput: MqttDeviceCreateInput;
}>;

export type CreateMqttDeviceMutation = {
  createMqttDevice: {
    success: boolean;
    message?: string | null;
    mqttDevice?: { id: string; name?: string | null } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateTemplateVkpCodesMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  input: TemplateVkpCodesInput;
}>;

export type CreateTemplateVkpCodesMutation = {
  createTemplateVkpCodes: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateWelfareDeviceMutationVariables = Exact<{
  createInput: WelfareDeviceCreateInput;
}>;

export type CreateWelfareDeviceMutation = {
  createWelfareDevice: {
    success: boolean;
    message?: string | null;
    welfareDevice?: { id: string; uniqueIdentifier: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteExternalIdPMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  idP: Scalars['String']['input'];
}>;

export type DeleteExternalIdPMutation = { deleteExternalIdP: boolean };

export type DeleteMqttDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMqttDeviceMutation = {
  deleteMqttDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteObservationTemplateMutation = { deleteObservationTemplate?: { success: boolean } | null };

export type DeletePatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type DeletePatientMutation = {
  deletePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type DeleteWelfareDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteWelfareDeviceMutation = {
  deleteWelfareDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateDeviceGroupMutationVariables = Exact<{
  createInput: DeviceGroupCreateInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type CreateDeviceGroupMutation = {
  createDeviceGroup: { success: boolean; message?: string | null; deviceGroup?: { id: string } | null };
};

export type UpdateDeviceGroupMutationVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
  deviceGroup: DeviceGroupUpdateInput;
}>;

export type UpdateDeviceGroupMutation = {
  updateDeviceGroup: { success: boolean; message?: string | null; deviceGroup?: { id: string } | null };
};

export type UpdateDeviceGroupCmpMutationVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
  cmpCredentials: CmpCredentialsInput;
}>;

export type UpdateDeviceGroupCmpMutation = { updateDeviceGroupCmp: { success: boolean; message?: string | null } };

export type DeleteDeviceGroupMutationVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
}>;

export type DeleteDeviceGroupMutation = { deleteDeviceGroup: { success: boolean; message?: string | null } };

export type GetDevicesByGroupQueryVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
}>;

export type GetDevicesByGroupQuery = {
  getDevicesByGroup: Array<{
    id: string;
    modelNumber?: string | null;
    manufacturer?: string | null;
    patientId?: string | null;
    registeredInInventory?: boolean | null;
    childDeviceIds?: Array<string> | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
  }>;
};

export type SetCameraViewWithPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  preset: Scalars['String']['input'];
}>;

export type SetCameraViewWithPresetMutation = { setCameraViewWithPreset: boolean };

export type SetCameraViewWithAnglesMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  pan: Scalars['Float']['input'];
  tilt: Scalars['Float']['input'];
  zoom: Scalars['Float']['input'];
}>;

export type SetCameraViewWithAnglesMutation = { setCameraViewWithAngles: boolean };

export type CreateCameraViewPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type CreateCameraViewPresetMutation = { createCameraViewPreset: boolean };

export type DeleteCameraViewPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  preset: Scalars['String']['input'];
}>;

export type DeleteCameraViewPresetMutation = { deleteCameraViewPreset: boolean };

export type StartStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartStreamMutation = { stream: { id: string; url: string; type?: string | null; ttl?: number | null } };

export type KeepStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepStreamAliveMutation = {
  stream: { id: string; url: string; type?: string | null; expires?: any | null; ttl?: number | null };
};

export type StopStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopStreamMutation = { stream: boolean };

export type DeleteEventConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteEventConfigMutation = {
  deleteEventConfig: { success: boolean; message?: string | null; id?: string | null };
};

export type CreateCameraEventConfigMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
  input: CameraEventConfigInput;
}>;

export type CreateCameraEventConfigMutation = {
  createCameraEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      cameraId: string;
      type: CameraEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      toCode?: string | null;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    } | null;
  };
};

export type UpdateCameraEventConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CameraEventConfigInput;
}>;

export type UpdateCameraEventConfigMutation = {
  updateCameraEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      cameraId: string;
      type: CameraEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      toCode?: string | null;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    } | null;
  };
};

export type CreateCepEventConfigMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: CepEventConfigInput;
}>;

export type CreateCepEventConfigMutation = {
  createCepEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      type: CepEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      toCode?: string | null;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
      cep?: { trigger?: Array<string> | null; cancelledBy?: Array<string> | null; after?: number | null } | null;
      timedCep?: {
        cancelledBy?: Array<string> | null;
        events: Array<string>;
        mode: string;
        alarmTimeWindow: { checkTimeFrom: string; checkTimeTo: string; dayOfWeek: Array<DayOfWeek> };
      } | null;
    } | null;
  };
};

export type UpdateCepEventConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CepEventConfigInput;
}>;

export type UpdateCepEventConfigMutation = {
  updateCepEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      type: CepEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      toCode?: string | null;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
      cep?: { trigger?: Array<string> | null; cancelledBy?: Array<string> | null; after?: number | null } | null;
      timedCep?: {
        cancelledBy?: Array<string> | null;
        events: Array<string>;
        mode: string;
        alarmTimeWindow: { checkTimeFrom: string; checkTimeTo: string; dayOfWeek: Array<DayOfWeek> };
      } | null;
    } | null;
  };
};

export type CreatePatientEventConfigMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PatientEventConfigInput;
}>;

export type CreatePatientEventConfigMutation = {
  createPatientEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      type: PatientEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    } | null;
  };
};

export type UpdatePatientEventConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PatientEventConfigInput;
}>;

export type UpdatePatientEventConfigMutation = {
  updatePatientEventConfig: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    eventConfig?: {
      id: string;
      patientId: string;
      type: PatientEventConfigEventType;
      code: string;
      displayText: string;
      icon?: string | null;
      priority: EventConfigPriority;
      workflow: EventConfigWorkflow;
      generatesAlarm: boolean;
      createdAt: any;
      updatedAt: any;
      schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    } | null;
  };
};

export type DeleteExternalAccessByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteExternalAccessByIdMutation = { deleteExternalAccessById: boolean };

export type ResetExternalAccessSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ResetExternalAccessSecretMutation = {
  resetExternalAccessSecret: { id?: string | null; message: string; success: boolean; secret?: string | null };
};

export type UpdateExternalAccessMutationVariables = Exact<{
  input: UpdateNameOrIpRestrictionForExternalAccessInput;
}>;

export type UpdateExternalAccessMutation = {
  updateExternalAccess: { id?: string | null; message: string; success: boolean };
};

export type CreateExternalAccessMutationVariables = Exact<{
  input: CreateExternalAccessInput;
}>;

export type CreateExternalAccessMutation = {
  createExternalAccess: { id?: string | null; message: string; secret?: string | null; success: boolean };
};

export type CreateForwarderAlarmRoutesMutationVariables = Exact<{
  forwarderConfigId: Scalars['String']['input'];
  forwarderRoutes: Array<ForwarderRouteInput> | ForwarderRouteInput;
}>;

export type CreateForwarderAlarmRoutesMutation = {
  createForwarderAlarmRoutes: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateForwarderAlarmRouteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ForwarderRouteInput;
}>;

export type UpdateForwarderAlarmRouteMutation = {
  updateForwarderAlarmRoute: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteForwarderAlarmRouteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteForwarderAlarmRouteMutation = {
  deleteForwarderAlarmRoute: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateIpRestrictionsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateIpRestrictionsMutation = {
  updateIPRestrictions?: {
    success: boolean;
    inputValidation?: { valid: boolean; message?: string | null } | null;
  } | null;
};

export type LogLocalExportMutationVariables = Exact<{
  resourceType: Scalars['String']['input'];
  count: Scalars['Int']['input'];
}>;

export type LogLocalExportMutation = { logLocalExport: { success: boolean } };

export type MoveAccessGroupMutationVariables = Exact<{
  attachToUserGroup: Scalars['String']['input'];
  userGroupToMove: Scalars['String']['input'];
}>;

export type MoveAccessGroupMutation = { moveAccessGroup: { success: boolean; message: string } };

export type DeleteNextOfKinMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
}>;

export type DeleteNextOfKinMutation = { deleteNextOfKin: { success: boolean; message?: string | null } };

export type AddNextOfKinMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nextOfKinInput: CreateNextOfKinInput;
}>;

export type AddNextOfKinMutation = {
  addNextOfKin: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    nextOfKin?: { id: string } | null;
  };
};

export type MarkNextOfKinAsMainMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
}>;

export type MarkNextOfKinAsMainMutation = {
  markNextOfKinAsMain?: { success: boolean; message?: string | null } | null;
};

export type UpdateNextOfKinMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
  nextOfKinInput: UpdateNextOfKinInput;
}>;

export type UpdateNextOfKinMutation = {
  updateNextOfKin: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    nextOfKin?: { id: string } | null;
  };
};

export type NotifyNextOfKinsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;

export type NotifyNextOfKinsMutation = {
  notifyNextOfKins?: Array<{ phoneNumber: string; messageStatus: string }> | null;
};

export type OpenPatientGroupsForExternalAccessMutationVariables = Exact<{
  input: UpdateExternalAccessInput;
}>;

export type OpenPatientGroupsForExternalAccessMutation = {
  openPatientGroupsForExternalAccess?: { success: boolean; message?: string | null } | null;
};

export type AddPatientByExternalIdMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createDialoggAccount?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddPatientByExternalIdMutation = {
  addPatientByExternalId?: { success: boolean; message?: string | null; patient?: { id: string } | null } | null;
};

export type CreatePatientMutationVariables = Exact<{
  patientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  patientInput: CreatePatientInput;
}>;

export type CreatePatientMutation = {
  createPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    patient?: { id: string } | null;
  } | null;
};

export type AddCameraToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
  cameraProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AddCameraToPatientMutation = {
  addCameraToPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAvailableHoursForCameraMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
  availableHours: Scalars['String']['input'];
}>;

export type UpdateAvailableHoursForCameraMutation = { updateAvailableHours: { success: boolean } };

export type UpdateCameraDeviceGroupMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  deviceGroupId: Scalars['ID']['input'];
}>;

export type UpdateCameraDeviceGroupMutation = { updateCameraDeviceGroup?: { success: boolean } | null };

export type AddPatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contact: CreateContactInput;
}>;

export type AddPatientContactMutation = { addPatientContact: { success: boolean } };

export type UpdatePatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contact: UpdateContactInput;
}>;

export type UpdatePatientContactMutation = { updatePatientContact: { success: boolean } };

export type RemovePatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;

export type RemovePatientContactMutation = { removePatientContact: { success: boolean } };

export type OrderPatientContactsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  orderedContactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type OrderPatientContactsMutation = { orderPatientContacts: { success: boolean } };

export type StartRawDataStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type StartRawDataStreamMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type StopRawDataStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopRawDataStreamMutation = { stream: boolean };

export type KeepRawDataStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepRawDataStreamAliveMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type RefreshAzureProvisioningSecretMutationVariables = Exact<{
  azureAccountId: Scalars['ID']['input'];
}>;

export type RefreshAzureProvisioningSecretMutation = {
  refreshAzureProvisioningSecret?: {
    message?: string | null;
    success: boolean;
    azureProvisioningCredentials?: { tenantUrl?: string | null; secretToken?: string | null } | null;
  } | null;
};

export type RemoveMqttDeviceFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  mqttDeviceId: Scalars['ID']['input'];
}>;

export type RemoveMqttDeviceFromPatientMutation = { removeMqttDeviceFromPatient: { success: boolean } };

export type RemoveTemplateVkpCodesFromTemplateMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;

export type RemoveTemplateVkpCodesFromTemplateMutation = {
  removeTemplateVkpCodesFromTemplate: { success: boolean; message?: string | null };
};

export type CreateSelfTreatmentPlanTemplateMutationVariables = Exact<{
  selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput;
}>;

export type CreateSelfTreatmentPlanTemplateMutation = {
  createSelfTreatmentPlanTemplate: {
    success: boolean;
    message?: string | null;
    selfTreatmentPlan?: { id: string } | null;
  };
};

export type UpdateSelfTreatmentPlanTemplateMutationVariables = Exact<{
  selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput;
  selfTreatmentPlanTemplateId: Scalars['ID']['input'];
}>;

export type UpdateSelfTreatmentPlanTemplateMutation = {
  updateSelfTreatmentPlanTemplate: {
    success: boolean;
    message?: string | null;
    selfTreatmentPlan?: { id: string } | null;
  };
};

export type CreateCameraPtzProfileMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  input: CreateCameraPtzProfileInput;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateCameraPtzProfileMutation = {
  createCameraPtzProfile: {
    activeProfileId?: string | null;
    profiles: Array<{ id: string; name: string; pan: number; tilt: number; zoom: number }>;
  };
};

export type SetActiveCameraPtzProfileMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SetActiveCameraPtzProfileMutation = {
  setActiveCameraPtzProfile: {
    activeProfileId?: string | null;
    profiles: Array<{ id: string; name: string; pan: number; tilt: number; zoom: number }>;
  };
};

export type DeleteCameraPtzProfileMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
}>;

export type DeleteCameraPtzProfileMutation = {
  deleteCameraPtzProfile: {
    activeProfileId?: string | null;
    profiles: Array<{ id: string; name: string; pan: number; tilt: number; zoom: number }>;
  };
};

export type SimulateNovoEventMutationVariables = Exact<{
  event: NovoEventInput;
}>;

export type SimulateNovoEventMutation = { simulateNovoEvent: { success: boolean; message?: string | null } };

export type SimulateSafemateEventMutationVariables = Exact<{
  event: SafemateEventInput;
}>;

export type SimulateSafemateEventMutation = { simulateSafemateEvent: { success: boolean; message?: string | null } };

export type SimulateSkyResponseEventMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalAccessId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  event: SkyresponseEventInput;
}>;

export type SimulateSkyResponseEventMutation = {
  simulateSkyResponseEvent: { success: boolean; message?: string | null };
};

export type SortTreeMutationVariables = Exact<{
  userGroupToSort: Scalars['String']['input'];
  previousSiblingId?: InputMaybe<Scalars['String']['input']>;
  nextSiblingId?: InputMaybe<Scalars['String']['input']>;
}>;

export type SortTreeMutation = { sortTree: { success: boolean; message: string } };

export type SyncSpecificPatientWithSkyresponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type SyncSpecificPatientWithSkyresponseMutation = { syncSpecificPatientWithSkyresponse: { success: boolean } };

export type UpdateAzureAccountMutationVariables = Exact<{
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
}>;

export type UpdateAzureAccountMutation = { updateAzureAccount: { success: boolean; message?: string | null } };

export type UpdateCameraMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: UpdateCameraInput;
}>;

export type UpdateCameraMutation = {
  updateCamera: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateDeviceGroupForMqttDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deviceGroupId: Scalars['ID']['input'];
}>;

export type UpdateDeviceGroupForMqttDeviceMutation = {
  updateDeviceGroupForMqttDevice: {
    success: boolean;
    message?: string | null;
    mqttDevice?: { id: string; deviceGroupId: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateExternalIdRequestsOnAzureGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  requestedExternalIdTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateExternalIdRequestsOnAzureGroupMutation = {
  updateExternalIdRequestsOnAzureGroup: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateLinkedPatientGroupsMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  addPatientGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removePatientGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateLinkedPatientGroupsMutation = {
  updateLinkedPatientGroups: {
    success?: boolean | null;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateMqttDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: MqttDeviceUpdateInput;
}>;

export type UpdateMqttDeviceMutation = {
  updateMqttDevice: {
    success: boolean;
    message?: string | null;
    mqttDevice?: { id: string; name?: string | null } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdatePatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientMutation = {
  updatePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdatePatientNoteMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientNoteMutation = { updatePatient?: { success: boolean } | null };

export type UpdatePendingExternalIdentityProvidersOnAzureGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  pendingExternalIdentityProviders: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdatePendingExternalIdentityProvidersOnAzureGroupMutation = {
  updatePendingExternalIdentityProvidersOnAzureGroup: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateTemplateVkpCodesMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  input: TemplateVkpCodesInput;
}>;

export type UpdateTemplateVkpCodesMutation = {
  updateTemplateVkpCodes: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateWelfareDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: WelfareDeviceUpdateInput;
}>;

export type UpdateWelfareDeviceMutation = {
  updateWelfareDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contact: CreateContactInput;
}>;

export type AddUserGroupContactMutation = { addUserGroupContact: { success: boolean } };

export type UpdateUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contact: UpdateContactInput;
}>;

export type UpdateUserGroupContactMutation = { updateUserGroupContact: { success: boolean } };

export type RemoveUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;

export type RemoveUserGroupContactMutation = { removeUserGroupContact: { success: boolean } };

export type OrderUserGroupContactsMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  orderedContactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type OrderUserGroupContactsMutation = { orderUserGroupContacts: { success: boolean } };

export type AddUserToRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type AddUserToRoleMutation = { addUserToRole?: { success: boolean; message?: string | null } | null };

export type RemoveUserFromRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type RemoveUserFromRoleMutation = { removeUserFromRole?: { success: boolean; message?: string | null } | null };

export type UpdateUserTimeLimitedAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  timeLimitedAccess?: InputMaybe<PeriodInput>;
}>;

export type UpdateUserTimeLimitedAccessMutation = {
  updateUserTimeLimitedAccess?: { success: boolean; inputValidation?: { message?: string | null } | null } | null;
};

export type StartZoneStateStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type StartZoneStateStreamMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type StopZoneStateStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopZoneStateStreamMutation = { stream: boolean };

export type KeepZoneStateStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepZoneStateStreamAliveMutation = {
  stream: {
    id: string;
    url: string;
    type?: string | null;
    expires?: any | null;
    ttl?: number | null;
    renewAfterSec?: number | null;
  };
};

export type CameraProvisioningBatchTelluSupportQueryVariables = Exact<{ [key: string]: never }>;

export type CameraProvisioningBatchTelluSupportQuery = {
  cameraProvisioningBatchTelluSupport: Array<{
    type: string;
    serial: string;
    cameraName: string;
    logs?: Array<string> | null;
    cameraSetup?: {
      model: string;
      serial: string;
      oak: string;
      cameraName: string;
      customerId: number;
      siteId: number;
      deviceGroupId: string;
      installVMD: boolean;
      installFG: boolean;
      installPS: boolean;
      installOA: boolean;
      enableAudio: boolean;
      firmwareUpgrade: boolean;
      installApps: boolean;
    } | null;
    apps?: Array<{ id: string; install: boolean; activate: boolean; deactivate: boolean; uninstall: boolean }> | null;
    status?: Array<{ step: string; status: string; timestamp: any }> | null;
  }>;
};

export type CameraManagementLogsBySerialQueryVariables = Exact<{
  serial: Scalars['String']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type CameraManagementLogsBySerialQuery = {
  cameraManagementLogsBySerial: Array<{
    type: string;
    serial: string;
    cameraName: string;
    user?: string | null;
    createdAt: any;
    updatedAt: any;
    logs?: Array<string> | null;
  }>;
};

export type CameraSupportReportQueryVariables = Exact<{
  serial: Scalars['String']['input'];
}>;

export type CameraSupportReportQuery = { cameraSupportReport?: string | null };

export type CameraSetupQueryVariables = Exact<{ [key: string]: never }>;

export type CameraSetupQuery = {
  deviceGroups: Array<{ id: string; name?: string | null }>;
  morpheanSitesPerMorpheanCustomerTelluSupport: Array<{
    customerId: number;
    customerName: string;
    morpheanSites: Array<{ siteId: number; siteName: string }>;
  }>;
  supportedCameraModelsTelluSupport: Array<{
    model: string;
    availability: CameraAvailability;
    apps: Array<{ id: string; name: string; version: string; supportedModels: Array<string>; default: boolean }>;
  }>;
};

export type SupportedCameraAppsQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedCameraAppsQuery = {
  supportedCameraApps: Array<{
    id: string;
    name: string;
    version: string;
    supportedModels: Array<string>;
    default: boolean;
    experimental: boolean;
  }>;
};

export type GetCameraManagementListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraManagementListQuery = {
  getCameraManagementList: Array<{
    id?: string | null;
    name?: string | null;
    macAddress: string;
    model?: string | null;
    arch?: string | null;
    soc?: string | null;
    firmware?: string | null;
    latestFirmware?: string | null;
    deviceGroupId?: string | null;
    deviceGroup?: string | null;
    inRegistry: boolean;
    inAccount: boolean;
    isAttachedToPatient: boolean;
    inMorphean: boolean;
    connectedToMorphean: boolean;
    lastSeen?: any | null;
    routerVendor?: string | null;
    routerMac?: string | null;
    mqttConfig?: { url: string; state: string; connectionStatus: string } | null;
    time?: { timezone: string; obtainFromDHCP: boolean } | null;
    apps?: Array<{
      id: string;
      name: string;
      version: string;
      latestVersion: string;
      status: string;
      profileCount?: number | null;
    } | null> | null;
    network?: {
      bonjour: boolean;
      dot1x: boolean;
      ftp: boolean;
      ssh: boolean;
      upnp: boolean;
      zeroConf: boolean;
      allowOldTLS: boolean;
      https: boolean;
      bandwidthLimit: boolean;
      isHardened: boolean;
    } | null;
    audio?: {
      enabled: boolean;
      audioSupported?: boolean | null;
      inputGain?: string | null;
      inputType?: string | null;
      microphonePowerType?: string | null;
      microphonePowered?: boolean | null;
    } | null;
    ptz?: { enabled: boolean; locked: boolean; returnToOverviewawait?: string | null } | null;
    video?: {
      enabled: boolean;
      rtsp: boolean;
      compression: string;
      mirrored: boolean;
      resolution: string;
      rotation: string;
      iCount: string;
      pCount: string;
      rateControlPriority: string;
      targetBitRate: string;
      fps: string;
      captureFrequency: string;
      exposureMode: string;
      whiteBalanceMode: string;
      dayNight: { cutFilterMode: string; shiftLevel: string; manualIrOverriden: boolean };
    } | null;
  }>;
};

export type HealthProviderSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsQuery = {
  healthProviderSettings: {
    patientAuth?: {
      twoFactorSms?: boolean | null;
      ipRestriction?: boolean | null;
      timeLimitedAccess?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
        support?: boolean | null;
      }> | null;
    } | null;
    userAuth?: {
      twoFactorSms?: boolean | null;
      twoFactorAppRequired?: boolean | null;
      ipRestriction?: boolean | null;
      timeLimitedAccess?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
        support?: boolean | null;
        provider?: string | null;
      }> | null;
    } | null;
    externalHumanIdTypes?: Array<{
      id: string;
      use: {
        patientUse?: { applicable?: boolean | null; immutable?: boolean | null } | null;
        personnelUse?: { applicable?: boolean | null } | null;
      };
    }> | null;
  };
};

export type GetListOfUnallocatedCamerasQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedCamerasQuery = {
  getListOfUnallocatedCameras: Array<{
    id: string;
    name: string;
    macAddress: string;
    active?: boolean | null;
    modelName?: string | null;
    cameraProfile?: { id: string } | null;
  }>;
};

export type PatientForCameraSupervisionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientForCameraSupervisionQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    alarmRoutes?: Array<{
      configId: string;
      configName: string;
      configType: string;
      idMappingStrategy: string;
      patientGroupId?: string | null;
      routeId: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        technical?: boolean | null;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        technical?: boolean | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      userHasAccessToPatient?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
        privacyModeUntil?: any | null;
      } | null;
      deviceGroup?: { name?: string | null; id: string; enableFurnitureDetection?: boolean | null } | null;
      cameraProfile?: {
        id: string;
        name: string;
        template?: CameraProfileTemplate | null;
        origin: CameraProfileOrigin;
        streamAnonymizationMode: StreamAnonymizationMode;
        streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
        enableSnapshots: boolean;
        enableSnapshotAnonymization?: boolean | null;
        continuousSupervision: boolean;
        enableSoundMonitoring: boolean;
        soundMonitoringDefaultThreshold: number;
        streamTTL?: number | null;
        allowUnplannedSupervision: boolean;
        enableExtendingCameraAvailability: boolean;
      } | null;
      effectiveSettings?: {
        streamAnonymizationMode: StreamAnonymizationMode;
        streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
        enableSnapshots: boolean;
        snapshotAnonymization: boolean;
        continuousSupervision: boolean;
        streamTTL?: number | null;
        allowUnplannedSupervision: boolean;
        enableSoundMonitoring: boolean;
        soundThreshold: number;
        enableExtendingCameraAvailability: boolean;
      } | null;
      patientReference?: { reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetAlarmTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesQuery = {
  getAlarmTemplates: Array<{
    id: string;
    description?: string | null;
    status: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
    } | null> | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
    timedCep?: { events: Array<string>; cancelledBy: Array<string>; mode: string } | null;
  }>;
};

export type GetCameraAdminAppsQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraAdminAppsQuery = {
  getCameraAdmin: {
    id: string;
    adminApps?: Array<{
      id: string;
      status?: string | null;
      profiles?: Array<{ id?: number | null; name?: string | null; cameraTopic?: string | null }> | null;
    } | null> | null;
  };
};

export type GetCameraAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCameraAdminQuery = {
  getCameraAdmin: {
    id: string;
    online?: boolean | null;
    firmware?: string | null;
    adminApps?: Array<{ id: string; name?: string | null; status?: string | null } | null> | null;
    router?: { mac?: string | null; vendor?: string | null } | null;
  };
};

export type GetCameraAdminUrlQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  appId?: InputMaybe<Scalars['String']['input']>;
  overrideReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCameraAdminUrlQuery = { getCameraAdminUrl?: string | null };

export type GetAuditEntitySummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditEntitySummaryQuery = { getAuditEntitySummary: Array<{ entityType: string; count: number }> };

export type GetAuditLogPaginatedQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogPaginatedQuery = {
  getAuditLogPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogEventForPatientByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type GetAuditLogEventForPatientByIdQuery = {
  getAuditLogEventForPatientById?: {
    id: string;
    action?: string | null;
    recorded?: any | null;
    outcome?: string | null;
    outcomeDesc?: string | null;
    session?: string | null;
    operation?: string | null;
    patientName?: string | null;
    userName?: string | null;
    agent?: Array<{ name?: string | null }> | null;
    entity?: Array<{
      name?: string | null;
      what?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      role?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
    }> | null;
  } | null;
};

export type GetAuditLogEventForUserGroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAuditLogEventForUserGroupByIdQuery = {
  getAuditLogEventForUserGroupById?: {
    id: string;
    action?: string | null;
    recorded?: any | null;
    outcome?: string | null;
    outcomeDesc?: string | null;
    session?: string | null;
    operation?: string | null;
    patientName?: string | null;
    userName?: string | null;
    agent?: Array<{ name?: string | null }> | null;
    entity?: Array<{
      name?: string | null;
      what?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      type?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      role?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
    }> | null;
  } | null;
};

export type GetAuditLogForPatientPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogForPatientPaginatedQuery = {
  getAuditLogForPatientPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogForUserPaginatedQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogForUserPaginatedQuery = {
  getAuditLogForUserPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditLogSummaryQuery = {
  getAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetAuditRoleSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditRoleSummaryQuery = {
  getAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type AuthEventsQueryVariables = Exact<{
  filter?: InputMaybe<AuthEventFilter>;
}>;

export type AuthEventsQuery = {
  authEvents: Array<{
    time?: any | null;
    type?: AuthEventType | null;
    userId?: string | null;
    sessionId?: string | null;
    ipAddress?: string | null;
    error?: string | null;
    details?: Array<{ key: string; value: string }> | null;
  }>;
};

export type GetReferenceObjectsForCameraQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetReferenceObjectsForCameraQuery = {
  getReferenceObjectsForCamera: Array<{
    type: string;
    sensitivity: number;
    boundingBox: { topLeftX: number; topLeftY: number; bottomRightX: number; bottomRightY: number };
  }>;
};

export type GetOwnerAuditEntitySummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditEntitySummaryQuery = {
  getOwnerAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetOwnerAuditLogPaginatedQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetOwnerAuditLogPaginatedQuery = {
  getOwnerAuditLogPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      type: { code: string };
      period?: { start?: any | null; end?: any | null } | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetOwnerAuditLogSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditLogSummaryQuery = {
  getOwnerAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetOwnerAuditRoleSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditRoleSummaryQuery = {
  getOwnerAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type GetPatientAuditEntitySummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditEntitySummaryQuery = {
  getPatientAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetPatientAuditLogSummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditLogSummaryQuery = {
  getPatientAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetPatientAuditRoleSummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditRoleSummaryQuery = {
  getPatientAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type GetUserAuditEntitySummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditEntitySummaryQuery = {
  getUserAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetUserAuditLogSummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditLogSummaryQuery = {
  getUserAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetUserAuditRoleSummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditRoleSummaryQuery = {
  getUserAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type AccountProductApplicationsFragment = {
  supervision?: boolean | null;
  dhv?: boolean | null;
  rpm?: boolean | null;
};

export type AccountProductFeaturesFragment = { continuousSupervision?: boolean | null; hasTrends?: boolean | null };

export type AccountSecurityFeaturesFragment = {
  hasEntraIdSso?: boolean | null;
  hasEntraIdProvisioning?: boolean | null;
};

export type AccountUserAuthFragment = {
  resetPasswordAllowed: boolean;
  twoFactorAppRequired: boolean;
  timeLimitedAccess: boolean;
  ipRestriction: boolean;
};

export type AccountDetailsFragment = {
  name: string;
  displayName: string;
  defaultLocale?: string | null;
  timeZone: string;
};

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type AccountSettingsQuery = {
  accountSettings: {
    userSessionLifespan?: number | null;
    name: string;
    displayName: string;
    defaultLocale?: string | null;
    timeZone: string;
    userAuth: {
      resetPasswordAllowed: boolean;
      twoFactorAppRequired: boolean;
      timeLimitedAccess: boolean;
      ipRestriction: boolean;
    };
    applications: { supervision?: boolean | null; dhv?: boolean | null; rpm?: boolean | null };
    features: {
      continuousSupervision?: boolean | null;
      hasTrends?: boolean | null;
      hasEntraIdSso?: boolean | null;
      hasEntraIdProvisioning?: boolean | null;
    };
  };
};

export type AllShiftSessionsQueryVariables = Exact<{ [key: string]: never }>;

export type AllShiftSessionsQuery = {
  allShiftSessions: Array<{
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string; createdAt: any }>;
    notificationSettings: {
      shiftSessionPhoneNumber?: string | null;
      name?: string | null;
      username?: string | null;
      userId?: string | null;
    };
  }>;
};

export type AllUsersExportPaginatedQueryVariables = Exact<{
  paging: UsersPagingInput;
}>;

export type AllUsersExportPaginatedQuery = {
  allUsersExportPaginated: {
    cursor?: any | null;
    hasMore: boolean;
    totalCount: number;
    users: Array<{
      firstName?: string | null;
      lastName?: string | null;
      username: string;
      email?: string | null;
      lastActive?: any | null;
      ipRestrictions?: Array<string | null> | null;
      otpStatus?: string | null;
      smsOtpStatus?: string | null;
      created?: any | null;
      passwordStatus?: string | null;
      enabled: boolean;
      externalIdentities?: Array<{ provider: string }> | null;
      externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
      roles: Array<{ role: { display: Array<{ key: string; value: string } | null> }; userGroup: { name: string } }>;
    }>;
  };
};

export type AzureAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type AzureAccountsQuery = {
  azureAccounts: Array<{
    id: string;
    alias: string;
    clientId: string;
    displayName: string;
    tenantId: string;
    support: boolean;
    patientRealm: boolean;
  } | null>;
};

export type AzureAccountsDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AzureAccountsDetailsQuery = {
  azureAccounts: Array<{ id: string; alias: string; clientId: string; displayName: string; tenantId: string } | null>;
};

export type AzureAccountsProvisioningCredentialsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AzureAccountsProvisioningCredentialsQuery = {
  azureAccounts: Array<{
    id: string;
    tenantId: string;
    azureProvisioningCredentials?: { tenantUrl?: string | null; secretToken?: string | null } | null;
  } | null>;
};

export type LandmarkVertexFragment = { x: number; y: number };

export type CameraZonesFragment = {
  bed: Array<{ x: number; y: number }>;
  doors: Array<{ name: CameraDoorName; vertices: Array<{ x: number; y: number }> }>;
  safeZones: Array<{ name: CameraSafeZoneName; generated: boolean; vertices: Array<{ x: number; y: number }> }>;
  exclusionZones: Array<{ name: CameraExclusionZoneName; vertices: Array<{ x: number; y: number }> }>;
};

export type CameraZonesResultFragment = {
  success: boolean;
  message?: string | null;
  errorCode?: CameraConfigurationErrorCode | null;
  retryable?: boolean | null;
  zones?: {
    bed: Array<{ x: number; y: number }>;
    doors: Array<{ name: CameraDoorName; vertices: Array<{ x: number; y: number }> }>;
    safeZones: Array<{ name: CameraSafeZoneName; generated: boolean; vertices: Array<{ x: number; y: number }> }>;
    exclusionZones: Array<{ name: CameraExclusionZoneName; vertices: Array<{ x: number; y: number }> }>;
  } | null;
};

export type CameraDetectionSettingsFragment = {
  underCameraAreaSafe: boolean;
  events: Array<{
    event: CameraEventKey;
    enabled: boolean;
    available: boolean;
    unavailableReason?: CameraEventUnavailableReason | null;
  }>;
  fallSensitivity: {
    mode?: CameraFallSensitivityMode | null;
    available: boolean;
    unavailableReason?: CameraEventUnavailableReason | null;
  };
  safeZoneNoDataHold: {
    minutes?: number | null;
    available: boolean;
    unavailableReason?: CameraEventUnavailableReason | null;
  };
};

export type CameraDetectionSettingsResultFragment = {
  success: boolean;
  message?: string | null;
  errorCode?: CameraConfigurationErrorCode | null;
  retryable?: boolean | null;
  detectionSettings?: {
    underCameraAreaSafe: boolean;
    events: Array<{
      event: CameraEventKey;
      enabled: boolean;
      available: boolean;
      unavailableReason?: CameraEventUnavailableReason | null;
    }>;
    fallSensitivity: {
      mode?: CameraFallSensitivityMode | null;
      available: boolean;
      unavailableReason?: CameraEventUnavailableReason | null;
    };
    safeZoneNoDataHold: {
      minutes?: number | null;
      available: boolean;
      unavailableReason?: CameraEventUnavailableReason | null;
    };
  } | null;
};

export type CameraConfigurationQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type CameraConfigurationQuery = {
  cameraConfiguration: {
    cameraId: string;
    zones?: {
      success: boolean;
      message?: string | null;
      errorCode?: CameraConfigurationErrorCode | null;
      retryable?: boolean | null;
      zones?: {
        bed: Array<{ x: number; y: number }>;
        doors: Array<{ name: CameraDoorName; vertices: Array<{ x: number; y: number }> }>;
        safeZones: Array<{ name: CameraSafeZoneName; generated: boolean; vertices: Array<{ x: number; y: number }> }>;
        exclusionZones: Array<{ name: CameraExclusionZoneName; vertices: Array<{ x: number; y: number }> }>;
      } | null;
    } | null;
    detectionSettings?: {
      success: boolean;
      message?: string | null;
      errorCode?: CameraConfigurationErrorCode | null;
      retryable?: boolean | null;
      detectionSettings?: {
        underCameraAreaSafe: boolean;
        events: Array<{
          event: CameraEventKey;
          enabled: boolean;
          available: boolean;
          unavailableReason?: CameraEventUnavailableReason | null;
        }>;
        fallSensitivity: {
          mode?: CameraFallSensitivityMode | null;
          available: boolean;
          unavailableReason?: CameraEventUnavailableReason | null;
        };
        safeZoneNoDataHold: {
          minutes?: number | null;
          available: boolean;
          unavailableReason?: CameraEventUnavailableReason | null;
        };
      } | null;
    } | null;
  };
};

export type CameraProfileSettingsFragment = {
  id: string;
  name: string;
  template?: CameraProfileTemplate | null;
  origin: CameraProfileOrigin;
  streamAnonymizationMode: StreamAnonymizationMode;
  streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
  enableSnapshots: boolean;
  enableSnapshotAnonymization?: boolean | null;
  continuousSupervision: boolean;
  enableSoundMonitoring: boolean;
  soundMonitoringDefaultThreshold: number;
  streamTTL?: number | null;
  allowUnplannedSupervision: boolean;
  enableExtendingCameraAvailability: boolean;
};

export type CameraEffectiveSettingsFieldsFragment = {
  streamAnonymizationMode: StreamAnonymizationMode;
  streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
  enableSnapshots: boolean;
  snapshotAnonymization: boolean;
  continuousSupervision: boolean;
  streamTTL?: number | null;
  allowUnplannedSupervision: boolean;
  enableSoundMonitoring: boolean;
  soundThreshold: number;
  enableExtendingCameraAvailability: boolean;
};

export type CameraProfileFieldsFragment = {
  isDefault: boolean;
  cameraCount: number;
  id: string;
  name: string;
  template?: CameraProfileTemplate | null;
  origin: CameraProfileOrigin;
  streamAnonymizationMode: StreamAnonymizationMode;
  streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
  enableSnapshots: boolean;
  enableSnapshotAnonymization?: boolean | null;
  continuousSupervision: boolean;
  enableSoundMonitoring: boolean;
  soundMonitoringDefaultThreshold: number;
  streamTTL?: number | null;
  allowUnplannedSupervision: boolean;
  enableExtendingCameraAvailability: boolean;
};

export type CameraProfilesQueryVariables = Exact<{ [key: string]: never }>;

export type CameraProfilesQuery = {
  cameraProfiles: Array<{
    isDefault: boolean;
    cameraCount: number;
    id: string;
    name: string;
    template?: CameraProfileTemplate | null;
    origin: CameraProfileOrigin;
    streamAnonymizationMode: StreamAnonymizationMode;
    streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
    enableSnapshots: boolean;
    enableSnapshotAnonymization?: boolean | null;
    continuousSupervision: boolean;
    enableSoundMonitoring: boolean;
    soundMonitoringDefaultThreshold: number;
    streamTTL?: number | null;
    allowUnplannedSupervision: boolean;
    enableExtendingCameraAvailability: boolean;
  }>;
};

export type CameraProfileCameraCountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CameraProfileCameraCountQuery = { cameraProfile: { id: string; cameraCount: number } };

export type GetPatientForCarePlanSimulatorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientForCarePlanSimulatorQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    carePlans?: Array<{
      id: string;
      status: CarePlanStatus;
      title?: string | null;
      description?: string | null;
      created?: any | null;
      subject: { reference?: string | null };
      period?: { start?: any | null; end?: any | null } | null;
      activity: Array<{
        detail: {
          scheduledTiming?: {
            event?: Array<any | null> | null;
            repeat?: {
              dayOfWeek?: Array<DayOfWeek> | null;
              timeOfDay: Array<string>;
              periodUnit?: string | null;
              period?: number | null;
              boundsPeriod?: { start?: any | null; end?: any | null } | null;
            } | null;
          } | null;
          scheduledPeriod?: { start?: any | null; end?: any | null } | null;
          code?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          } | null;
          questionnaires?: Array<{
            id: string;
            name: string;
            title?: string | null;
            purpose?: string | null;
            status: QuestionnaireStatus;
            publisher?: string | null;
            description?: string | null;
            effectivePeriod?: { end?: any | null; start?: any | null } | null;
            item?: Array<{
              linkId: string;
              text: string;
              type: QuestionnaireItemType;
              required: boolean;
              answerOption?: Array<{
                valueBoolean?: boolean | null;
                valueInteger?: number | null;
                valueString?: string | null;
                valueDecimal?: number | null;
                valueCoding?: { code?: string | null; display?: string | null } | null;
              } | null> | null;
            } | null> | null;
          } | null> | null;
        };
        outcomeReference?: Array<{
          reference?: string | null;
          display?: string | null;
          type?: string | null;
          identifier?: { value?: string | null } | null;
        } | null> | null;
        observations?: Array<{
          id: string;
          text?: string | null;
          status: string;
          identifier?: Array<{ value?: string | null } | null> | null;
          basedOn?: Array<{ reference?: string | null } | null> | null;
          note?: Array<{ text?: string | null } | null> | null;
          fromTemplate?: { reference?: string | null } | null;
          code?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          } | null;
          component?: Array<{
            code: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            };
            valueQuantity?: { value?: number | null; unit?: string | null } | null;
            referenceRange?: Array<{
              text?: string | null;
              low?: { value?: number | null; unit?: string | null } | null;
              high?: { value?: number | null; unit?: string | null } | null;
              type?: {
                text?: string | null;
                coding?: Array<{
                  system?: any | null;
                  version?: string | null;
                  code?: any | null;
                  display?: string | null;
                } | null> | null;
              } | null;
            } | null> | null;
          } | null> | null;
        } | null> | null;
      } | null>;
    } | null> | null;
    referenceRange?: Array<{
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      component?: Array<{
        code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
        referenceRange?: Array<{
          low?: { unit?: string | null; value?: number | null } | null;
          high?: { unit?: string | null; value?: number | null } | null;
          type?: {
            text?: string | null;
            coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ContinuousSupervisionCandidatesQueryVariables = Exact<{ [key: string]: never }>;

export type ContinuousSupervisionCandidatesQuery = {
  getContinuousSupervisionCandidates?: Array<{
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    cameras: Array<{ id: string; name: string; macAddress: string; deviceGroupName: string }>;
  }> | null;
};

export type DefaultTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type DefaultTemplatesQuery = {
  defaultTemplates: {
    novo: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    camera: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    safemate: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    forwarding: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    delegation: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    videoMeeting: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      technical?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    measurement: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
      defaultTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
    accountTemplates: Array<{
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      accountTemplate?: {
        id: string;
        status: string;
        alarmIcon?: string | null;
        callbackMinutes?: number | null;
        debounceDelay?: number | null;
        technical?: boolean | null;
        generatesAlarm?: boolean | null;
        locationTraceOnly?: boolean | null;
        noCarePlanRequired?: boolean | null;
        resolveAction?: Array<string | null> | null;
        description?: string | null;
        cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
        timedCep?: { events: Array<string>; mode: string; cancelledBy: Array<string> } | null;
        tagAction?: Array<{
          target?: TagTarget | null;
          type?: TagActionType | null;
          label?: string | null;
        } | null> | null;
        vkpEncounter?: { type?: number | null; reason?: number | null } | null;
        identifier: Array<{ value?: string | null } | null>;
        code: {
          text?: string | null;
          coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
        };
        effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
        interpretation?: Array<{
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null> | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
          };
          extension?: Array<{
            url?: string | null;
            valueBoolean?: boolean | null;
            valueInteger?: number | null;
            valueString?: string | null;
            ValueId?: string | null;
          }> | null;
        } | null> | null;
      } | null;
    }>;
  };
};

export type FhirObservationTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type FhirObservationTemplatesQuery = { fhirObservationTemplates?: Array<string | null> | null };

export type FhirAlarmTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type FhirAlarmTemplatesQuery = { fhirAlarmTemplates?: Array<string | null> | null };

export type DeviceGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type DeviceGroupsQuery = { deviceGroups: Array<{ id: string; name?: string | null }> };

export type DeviceStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type DeviceStatsQuery = {
  deviceStats: {
    stats: Array<{
      timestamp?: any | null;
      technicalAlarms?: number | null;
      technicalAlarmEvents?: number | null;
      deviceType?: string | null;
    }>;
  };
};

export type CheckCameraTwoWayAudioSupportQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type CheckCameraTwoWayAudioSupportQuery = { checkCameraTwoWayAudioSupport: boolean };

export type GetAllPatientEventConfigsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllPatientEventConfigsQuery = {
  patientEventConfigs: Array<{
    id: string;
    patientId: string;
    type: PatientEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
  }>;
  patientEventConfigsBySystem: Array<{
    id: string;
    patientId: string;
    type: PatientEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
  }>;
  cepEventConfigs: Array<{
    id: string;
    patientId: string;
    type: CepEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    toCode?: string | null;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    cep?: { trigger?: Array<string> | null; cancelledBy?: Array<string> | null; after?: number | null } | null;
    timedCep?: {
      cancelledBy?: Array<string> | null;
      events: Array<string>;
      mode: string;
      alarmTimeWindow: { checkTimeFrom: string; checkTimeTo: string; dayOfWeek: Array<DayOfWeek> };
    } | null;
  }>;
};

export type GetCepEventConfigsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetCepEventConfigsQuery = {
  getCepEventConfigs: Array<{
    id: string;
    patientId: string;
    type: CepEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    toCode?: string | null;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
    cep?: { trigger?: Array<string> | null; cancelledBy?: Array<string> | null; after?: number | null } | null;
    timedCep?: {
      cancelledBy?: Array<string> | null;
      events: Array<string>;
      mode: string;
      alarmTimeWindow: { checkTimeFrom: string; checkTimeTo: string; dayOfWeek: Array<DayOfWeek> };
    } | null;
  }>;
};

export type GetAllCameraEventConfigsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllCameraEventConfigsQuery = {
  getAllCameraEventConfigs: Array<{
    id: string;
    patientId: string;
    cameraId: string;
    type: CameraEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    toCode?: string | null;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
  }>;
};

export type GetCameraEventConfigsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraEventConfigsQuery = {
  getCameraEventConfigs: Array<{
    id: string;
    patientId: string;
    cameraId: string;
    type: CameraEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    toCode?: string | null;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
  }>;
};

export type GetPatientEventConfigsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientEventConfigsQuery = {
  getPatientEventConfigs: Array<{
    id: string;
    patientId: string;
    type: PatientEventConfigEventType;
    code: string;
    displayText: string;
    icon?: string | null;
    priority: EventConfigPriority;
    workflow: EventConfigWorkflow;
    generatesAlarm: boolean;
    createdAt: any;
    updatedAt: any;
    schedule?: { repeat: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } } | null;
  }>;
};

export type AllExternalAccessesQueryVariables = Exact<{ [key: string]: never }>;

export type AllExternalAccessesQuery = {
  allExternalAccesses: Array<{
    id: string;
    name: string;
    ipRestrictions: Array<string>;
    allowedAccess?: Array<string> | null;
    forwarderId?: string | null;
    patientGroups?: Array<{ id: string; name: string }> | null;
  }>;
};

export type GetExternalAccessEndpointsQueryVariables = Exact<{ [key: string]: never }>;

export type GetExternalAccessEndpointsQuery = {
  getExternalAccessEndpoints: Array<{ externalAccessNameToShow: string; externalAccessName: string }>;
};

export type GetForwarderAlarmRoutesQueryVariables = Exact<{
  forwarderConfigId: Scalars['String']['input'];
}>;

export type GetForwarderAlarmRoutesQuery = {
  forwarderAlarmRoutes: Array<{
    id: string;
    forwarderConfigId: string;
    incomingTemplate: {
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      technical?: boolean | null;
    };
    outgoingTemplate: {
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
      isPresentInAccount?: boolean | null;
      technical?: boolean | null;
    };
  }>;
};

export type GetAlarmTemplateWithVkpCodesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplateWithVkpCodesQuery = {
  getAlarmTemplateWithVkpCodes: Array<{
    id: string;
    code: string;
    title: string;
    system: string;
    technical: boolean;
    status: string;
    displayText?: string | null;
    icon?: string | null;
    templateVkpCodes?: {
      id: string;
      enabled: boolean;
      resourceType: string;
      deviceType?: string | null;
      alertCode?: { code: string; display: string; system: string } | null;
      reasonCode?: { code: string; display: string; system: string } | null;
      mode?: { code: string; display: string; system: string } | null;
    } | null;
  }>;
};

export type GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForSyncAlarmSimulatorQuery = {
  getAlarmTemplates: Array<{
    id: string;
    status: string;
    alarmIcon?: string | null;
    description?: string | null;
    identifier: Array<{ value?: string | null } | null>;
    code: { coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null };
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
  }>;
};

export type GetAlarmTemplatesForTemplateCepQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForTemplateCepQuery = {
  getAlarmTemplates: Array<{
    id: string;
    technical?: boolean | null;
    alarmIcon?: string | null;
    status: string;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
  }>;
};

export type GetEquipmentListQueryVariables = Exact<{ [key: string]: never }>;

export type GetEquipmentListQuery = {
  getEquipmentList: Array<{
    id: string;
    createdAt: any;
    identifier?: string | null;
    type?: string | null;
    deviceGroup?: string | null;
    name?: string | null;
    patientId?: string | null;
    patientName?: string | null;
    tags?: Array<string> | null;
    userHasAccessToPatient?: boolean | null;
    registeredInInventory?: boolean | null;
    lastSeen?: any | null;
    hasExternalUrl?: boolean | null;
    lastBatteryStatus?: number | null;
    topPriorityAlarm?: { priority?: string | null } | null;
  }>;
};

export type GetAllExternalAccessForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllExternalAccessForPatientQuery = {
  getAllExternalAccessForPatient: Array<{ id: string; name: string }>;
};

export type GetAllQuestionnaireTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllQuestionnaireTemplatesQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    purpose?: string | null;
    experimental: boolean;
    version: string;
    status: QuestionnaireStatus;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
  }>;
};

export type GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type GetAllTechnicalAlarmEventsForDevicePaginatedQuery = {
  getAllTechnicalAlarmEventsForDevicePaginated?: {
    cursor?: any | null;
    events: Array<{
      id: string;
      effectiveDateTime?: any | null;
      status: string;
      code?: {
        coding?: Array<{ code?: any | null; display?: string | null; system?: any | null } | null> | null;
      } | null;
      handlingStatuses: Array<{
        handler: string;
        initiatedAt: any;
        attempts: Array<{
          startedAt: any;
          doneAt: any;
          status: string;
          handledBy?: Array<string> | null;
          payload?: string | null;
          rawResponse?: string | null;
          rawStatus?: string | null;
          details?: string | null;
        }>;
      }>;
    }>;
  } | null;
};

export type GetAuditLogSummariesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAuditLogSummariesQuery = {
  getAuditLogSummaries: {
    auditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
    auditEntitySummary: Array<{ entityType: string; count: number }>;
    auditRoleSummary: Array<{ operation: string; role: string; count: number }>;
  };
};

export type GetAvailableWelfareDevicesInInventoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableWelfareDevicesInInventoryQuery = {
  getAvailableWelfareDevicesInInventory: Array<{ uniqueIdentifier?: string | null; modelNumber?: string | null }>;
};

export type GetCameraQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraQuery = {
  getCamera: {
    id: string;
    name: string;
    macAddress: string;
    description?: string | null;
    presets: Array<string | null>;
    ptzEnabled?: boolean | null;
    cameraProfile?: {
      id: string;
      name: string;
      template?: CameraProfileTemplate | null;
      origin: CameraProfileOrigin;
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      enableSnapshotAnonymization?: boolean | null;
      continuousSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundMonitoringDefaultThreshold: number;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableExtendingCameraAvailability: boolean;
    } | null;
    effectiveSettings?: {
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      snapshotAnonymization: boolean;
      continuousSupervision: boolean;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundThreshold: number;
      enableExtendingCameraAvailability: boolean;
    } | null;
    settings: { soundThreshold?: number | null };
  };
};

export type LoadQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type LoadQuery = {
  camera: {
    ptzEnabled?: boolean | null;
    view?: {
      pan?: number | null;
      minPan?: number | null;
      maxPan?: number | null;
      tilt?: number | null;
      minTilt?: number | null;
      maxTilt?: number | null;
      zoom?: number | null;
      minZoom?: number | null;
      maxZoom?: number | null;
    } | null;
  };
};

export type GetCameraPtzProfilesQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraPtzProfilesQuery = {
  getCameraPtzProfiles: {
    activeProfileId?: string | null;
    profiles: Array<{ id: string; name: string; pan: number; tilt: number; zoom: number }>;
  };
};

export type GetCameraListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraListQuery = {
  getCameraList: Array<{
    id: string;
    name?: string | null;
    model?: string | null;
    serialNumber?: string | null;
    patientId?: string | null;
    patientName?: string | null;
    userHasAccessToPatient?: boolean | null;
    registeredInInventory?: boolean | null;
    deviceGroup?: string | null;
    enableExtendingCameraAvailability?: boolean | null;
    lastSeen?: any | null;
    ttl?: number | null;
    privacyMode?: boolean | null;
    privacyModeUntil?: any | null;
    cameraProfile?: { id: string; name: string; template?: CameraProfileTemplate | null } | null;
    effectiveSettings?: { allowUnplannedSupervision: boolean; enableExtendingCameraAvailability: boolean } | null;
    topPriorityAlarm?: { priority?: string | null } | null;
  }>;
};

export type GetDeviceByIdForSimulatorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdForSimulatorQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    tags?: Array<string> | null;
    deviceName?: Array<{ name?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetDeviceGroupExternalUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceGroupExternalUrlQuery = { getDeviceGroupExternalUrl?: string | null };

export type GetDeviceModelNumberByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceModelNumberByIdQuery = { getWelfareDevice?: { id: string; modelNumber?: string | null } | null };

export type GetDeviceNameByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceNameByIdQuery = {
  getWelfareDevice?: { id: string; deviceName?: Array<{ name?: string | null }> | null } | null;
};

export type GetListOfUnallocatedMqttDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedMqttDevicesQuery = {
  getListOfUnallocatedMqttDevices: Array<{
    id: string;
    name?: string | null;
    identifier: string;
    deviceGroupId: string;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type GetListOfUnallocatedWelfareDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedWelfareDevicesQuery = {
  getListOfUnallocatedWelfareDevices: Array<{
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    userFriendlyName?: string | null;
  }>;
};

export type GetMqttDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMqttDeviceQuery = {
  getMqttDevice?: {
    id: string;
    name?: string | null;
    password: string;
    identifier: string;
    deviceGroupId: string;
    createdAt: any;
    updatedAt: any;
  } | null;
};

export type GetMqttDeviceListQueryVariables = Exact<{ [key: string]: never }>;

export type GetMqttDeviceListQuery = {
  getMqttDeviceList: Array<{
    id: string;
    identifier: string;
    name?: string | null;
    patientId?: string | null;
    patientName?: string | null;
    createdAt: any;
    updatedAt: any;
    deviceGroupId: string;
    userHasAccessToPatient?: boolean | null;
  }>;
};

export type GetMyPersonalProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPersonalProfileQuery = {
  getMyPersonalProfile: {
    id: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    username?: string | null;
    mobileNumber?: string | null;
    lastActive?: any | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
    externalUserIds?: Array<{
      externalId: string;
      externalHumanIdType: {
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
      };
    }> | null;
  };
};

export type GetMyPersonalProfileForUserDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPersonalProfileForUserDetailsQuery = {
  getMyPersonalProfile: {
    id: string;
    username?: string | null;
    externalUserIds?: Array<{
      externalId: string;
      externalHumanIdType: {
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
      };
    }> | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
  };
};

export type GetNextOfKinByIdQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nokId: Scalars['ID']['input'];
}>;

export type GetNextOfKinByIdQuery = {
  getNextOfKinById: {
    id: string;
    notifyNextOfKin?: boolean | null;
    active: boolean;
    isMain: boolean;
    relationship?: string | null;
    patient: { reference?: string | null };
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    }> | null;
  };
};

export type GetOpenPatientAlarmsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetOpenPatientAlarmsForPatientQuery = {
  getOpenPatientAlarmsForPatient: Array<{
    id: string;
    status: string;
    priority?: string | null;
    for: { reference?: string | null };
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type GetOpenTechnicalAlarmsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  hasPatientLink?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOpenTechnicalAlarmsQuery = {
  getOpenTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn?: any | null;
    deviceGroupName?: string | null;
    description?: string | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null } | null;
    patientLink?: { patientId: string; patientName?: string | null; userHasAccessToPatient: boolean } | null;
  }>;
};

export type GetOpenTechnicalAlarmsForDeviceQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOpenTechnicalAlarmsForDeviceQuery = {
  getOpenTechnicalAlarmsForDevice: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type GetOwnerAuditLogSummariesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditLogSummariesQuery = {
  getOwnerAuditLogSummaries: {
    auditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
    auditEntitySummary: Array<{ entityType: string; count: number }>;
    auditRoleSummary: Array<{ operation: string; role: string; count: number }>;
  };
};

export type GetPatientNextOfKinQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientNextOfKinQuery = {
  getNextOfKin: Array<{
    id: string;
    notifyNextOfKin?: boolean | null;
    active: boolean;
    isMain: boolean;
    relationship?: string | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    }> | null;
  }>;
};

export type GetQuestionnaireResponseByIdQueryVariables = Exact<{
  questionnaireResponseId: Scalars['ID']['input'];
}>;

export type GetQuestionnaireResponseByIdQuery = {
  getQuestionnaireResponseById?: {
    id: string;
    authored: any;
    received?: any | null;
    subject: { reference?: string | null };
    source: { reference?: string | null; display?: string | null };
    displayItem: Array<{
      linkId?: string | null;
      type: QuestionnaireItemType;
      questionText?: string | null;
      answerText?: Array<string | null> | null;
      code?: string | null;
      score?: number | null;
    } | null>;
    displaySummary?: {
      score?: number | null;
      priorities?: {
        mode?: string | null;
        thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
        points?: Array<{ code?: string | null; value?: number | null } | null> | null;
      } | null;
      computedTaskPriority?: { code?: string | null; value?: number | null } | null;
    } | null;
    questionnaireObject?: {
      id: string;
      title?: string | null;
      carePlanObject?: { title?: string | null } | null;
      patientObject?: { name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null } | null;
    } | null;
  } | null;
};

export type GetQuestionnaireResponsesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetQuestionnaireResponsesForPatientQuery = {
  getQuestionnaireResponsesForPatient: Array<{
    id: string;
    authored: any;
    displayItem: Array<{
      answerText?: Array<string | null> | null;
      code?: string | null;
      linkId?: string | null;
      questionText?: string | null;
      score?: number | null;
      type: QuestionnaireItemType;
    } | null>;
    questionnaireObject?: {
      id: string;
      title?: string | null;
      carePlanObject?: { title?: string | null } | null;
      patientObject?: {
        id: string;
        name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      } | null;
    } | null;
  } | null>;
};

export type GetSkyresponseStatusesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetSkyresponseStatusesForPatientQuery = {
  getSkyresponseStatusesForPatient?: Array<{
    patientId: string;
    flowName: string;
    status: string;
    timestamp: string;
    logs: Array<{
      timestamp: string;
      details: string;
      auditLogReferences: Array<{ auditEventId: string; description: string }>;
    }>;
  }> | null;
};

export type GetSkyresponseStatusesForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetSkyresponseStatusesForUserGroupQuery = {
  getSkyresponseStatusesForUserGroup?: Array<{
    flowName: string;
    status: string;
    timestamp: string;
    logs: Array<{
      timestamp: string;
      details: string;
      auditLogReferences: Array<{ auditEventId: string; description: string }>;
    }>;
  }> | null;
};

export type GetDeviceByIdFullQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdFullQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    deviceGroup?: { id: string } | null;
    identifier?: Array<{ value?: string | null }> | null;
    status?: { connected?: boolean | null; lastSeen?: any | null } | null;
    patient?: { reference?: string | null } | null;
  } | null;
};

export type GetWelfareDeviceForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetWelfareDeviceForEditQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    tags?: Array<string> | null;
    property?: { callbackPhoneNumber?: string | null; pin?: string | null } | null;
    deviceName?: Array<{ name?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type HealthProviderSettingsForUserTableQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForUserTableQuery = {
  healthProviderSettings: {
    externalHumanIdTypes?: Array<{ id: string }> | null;
    userAuth?: {
      twoFactorAppRequired?: boolean | null;
      externalIdP?: Array<{ alias?: string | null; displayName?: string | null }> | null;
    } | null;
  };
};

export type HealthProviderSettingsForPatientRegistrationQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForPatientRegistrationQuery = {
  healthProviderSettings: {
    patientAuth?: {
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
      }> | null;
    } | null;
    externalHumanIdTypes?: Array<{ id: string }> | null;
  };
};

export type PatientContactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientContactsQuery = {
  patient?: {
    id: string;
    contacts?: {
      patientContacts: Array<{
        id: string;
        name: string;
        availableHours: string;
        priority?: number | null;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
        skyresponseConfig?: { callMethod?: number | null } | null;
      }>;
      groupContacts: Array<{
        id: string;
        name: string;
        availableHours: string;
        priority?: number | null;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
        skyresponseConfig?: { callMethod?: number | null } | null;
      }>;
    } | null;
  } | null;
};

export type RpmPatientExportDataQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RpmPatientExportDataQuery = {
  rpmPatientExportData?: Array<{
    active?: boolean | null;
    birthDate?: any | null;
    createdAt?: any | null;
    firstName?: string | null;
    gender?: AdministrativeGender | null;
    lastActive?: any | null;
    lastName?: string | null;
    patientGroupName?: string | null;
    updatedAt?: any | null;
    externalIds: Array<{ id: string; type: string }>;
  }> | null;
};

export type GetAllConcreteObservationsAsCsvQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllConcreteObservationsAsCsvQuery = { getAllConcreteObservationsAsCsv?: { csv?: string | null } | null };

export type PatientExportDataQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PatientExportDataQuery = {
  patientExportData?: Array<{
    firstName?: string | null;
    lastName?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    tags?: Array<string> | null;
    patientNote?: string | null;
    fhirId: string;
    areCamerasEnabled: boolean;
    active?: boolean | null;
    birthDate?: any | null;
    gender?: AdministrativeGender | null;
    patientGroupName?: string | null;
    addressNote?: string | null;
    keyCode?: string | null;
    externalIds: Array<{ id: string; type: string }>;
    devices: Array<{ identifier?: string | null; modelNumber?: string | null }>;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    nextOfKins?: Array<{
      name?: string | null;
      relationship?: string | null;
      main?: boolean | null;
      smsNotification?: boolean | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    }> | null;
    contacts?: Array<{
      name?: string | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    }> | null;
  }> | null;
};

export type PatientForPatientDashboardQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PatientForPatientDashboardQuery = {
  patient?: {
    id: string;
    active: boolean;
    birthDate?: any | null;
    addressNote?: string | null;
    keyCode?: string | null;
    gender?: AdministrativeGender | null;
    note?: string | null;
    areCamerasEnabled: boolean;
    camerasDisabledAt?: any | null;
    camerasStateOrigin?: CameraStateOrigin | null;
    responderIsPresent?: boolean | null;
    camerasReactivateAt?: any | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    languages?: Array<{ language: string; preferred: boolean }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    alarmRoutes?: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
        privacyModeUntil?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type PatientGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientGroupQuery = {
  patientGroup?: {
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    hideTechnicalAlarmNotifications?: boolean | null;
    alarmRoutes: Array<{
      routeId: string;
      configId: string;
      configType: string;
      configName: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
        technical?: boolean | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
        technical?: boolean | null;
      } | null;
    }>;
  } | null;
};

export type PatientGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type PatientGroupsQuery = { patientGroups: Array<{ id: string; name?: string | null } | null> };

export type PatientListNamesQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  withAnyEnabledServices?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type PatientListNamesQuery = {
  patientList: Array<{ id: string; firstName?: string | null; lastName?: string | null }>;
};

export type PatientNamesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNamesQuery = {
  patient?: { id: string; name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null } | null;
};

export type PatientNamesWithCarePlansQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNamesWithCarePlansQuery = {
  patient?: {
    id: string;
    carePlans?: Array<{ id: string; title?: string | null; status: CarePlanStatus } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
  } | null;
};

export type PatientSyncStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientSyncStatusQuery = {
  patient?: {
    id: string;
    skyresponseSyncStatus?: string | null;
    skyresponseSyncOpenAlarms?: Array<{ id: string; timestamp: string } | null> | null;
  } | null;
};

export type PatientReferenceQueryQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type PatientReferenceQueryQuery = {
  patientReferenceQuery: { patientReference?: { reference?: string | null } | null };
};

export type PatientWelfareDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWelfareDevicesQuery = {
  patientWelfareDevices?: {
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }> | null;
  } | null;
};

export type RequestSinglePatientUrlQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalAccessId: Scalars['ID']['input'];
}>;

export type RequestSinglePatientUrlQuery = { requestSinglePatientUrl?: string | null };

export type GetAllSelfTreatmentPlanTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllSelfTreatmentPlanTemplatesQuery = {
  getAllSelfTreatmentPlanTemplates: Array<{
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    title?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  }>;
};

export type GetSelfTreatmentPlanTemplateByIdQueryVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type GetSelfTreatmentPlanTemplateByIdQuery = {
  getSelfTreatmentPlanTemplateById: {
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    title?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  };
};

export type SupportTeamLinkedHealthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type SupportTeamLinkedHealthProvidersQuery = {
  supportTeamLinkedHealthProviders?: Array<{ name: string; displayName: string; url?: string | null }> | null;
};

export type UserGroupForMoveButtonQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForMoveButtonQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    rules?: Array<string> | null;
    parentId?: string | null;
    lexoRankIndex?: string | null;
    subTree?: Array<{
      id: string;
      name: string;
      parentId?: string | null;
      subGroups?: Array<{ id: string; name: string; type: string; rules?: Array<string> | null } | null> | null;
      roles?: Array<{ id: string } | null> | null;
    } | null> | null;
    subGroups?: Array<{ id: string; name: string } | null> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
  };
};

export type UserGroupQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupQuery = {
  userGroup: {
    id: string;
    name: string;
    subTree?: Array<{ id: string; name: string; roles?: Array<{ id: string } | null> | null } | null> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
  };
};

export type UserGroupCompleteQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupCompleteQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    rules?: Array<string> | null;
    parentId?: string | null;
    protected?: boolean | null;
    escalationDelay?: number | null;
    allowedRoleDefinitionIds?: Array<string> | null;
    lexoRankIndex?: string | null;
    skyresponse?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
      skyresponseAlarmHandlingRuleId?: number | null;
      allowedAlarmHandlingRuleIds?: Array<number | null> | null;
      publicArcObjectId?: number | null;
      privateArcObjectId?: number | null;
      webviewIntegrationConfig?: { id: string; displayName?: string | null } | null;
    } | null;
    careTeams?: Array<{
      id: string;
      name?: string | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      } | null> | null;
    } | null> | null;
    subGroups?: Array<{
      id: string;
      name: string;
      type: string;
      parentId?: string | null;
      skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
    } | null> | null;
    roles?: Array<{
      protected?: boolean | null;
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    contacts?: Array<{
      id: string;
      name: string;
      availableHours: string;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      skyresponseConfig?: { callMethod?: number | null } | null;
    }> | null;
    linkedPatientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      hideTechnicalAlarmNotifications?: boolean | null;
    } | null> | null;
    patientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      hideTechnicalAlarmNotifications?: boolean | null;
    } | null> | null;
    deviceGroups?: Array<{
      id: string;
      name?: string | null;
      hasCmpCredentials?: boolean | null;
      enableFurnitureDetection?: boolean | null;
      furnitureDetectionPeriodSec?: number | null;
    } | null> | null;
  };
};

export type GetAllUserGroupChildrenQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAllUserGroupChildrenQuery = { getAllUserGroupChildren: Array<{ id: string; name: string }> };

export type SubGroupsFragment = {
  id: string;
  name: string;
  type: string;
  parentId?: string | null;
  skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
};

export type SubTreeFragment = {
  id: string;
  name: string;
  type: string;
  rules?: Array<string> | null;
  parentId?: string | null;
  lexoRankIndex?: string | null;
  roles?: Array<{
    basedOn?: string | null;
    protected?: boolean | null;
    id: string;
    roleDefinitionId: string;
    display: Array<{ key: string; value: string } | null>;
  } | null> | null;
  linkedPatientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }>;
  } | null> | null;
  patientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }>;
  } | null> | null;
  skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
  deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
};

export type PatientGroupFragment = {
  id: string;
  name?: string | null;
  patientsCount?: number | null;
  alarmRoutes: Array<{
    configName: string;
    configType: string;
    idMappingStrategy: string;
    incomingTemplate?: {
      isPresentInAccount?: boolean | null;
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
    } | null;
    outgoingTemplate?: {
      isPresentInAccount?: boolean | null;
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
    } | null;
  }>;
};

export type RoleFragment = {
  id: string;
  roleDefinitionId: string;
  display: Array<{ key: string; value: string } | null>;
};

export type UserGroupContactsAndSkyresponseSyncStatusQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupContactsAndSkyresponseSyncStatusQuery = {
  userGroup: {
    id: string;
    contacts?: Array<{
      id: string;
      name: string;
      availableHours: string;
      priority?: number | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      skyresponseConfig?: { callMethod?: number | null } | null;
    }> | null;
    skyresponseSyncStatus?: { status: string; openAlarms?: Array<{ id: string; authoredOn: any }> | null } | null;
  };
};

export type UserGroupDynamicQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  includeRoles?: InputMaybe<Scalars['Boolean']['input']>;
  includePatientGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinkedPatientGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeAlarmRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UserGroupDynamicQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    parentId?: string | null;
    rules?: Array<string> | null;
    protected?: boolean | null;
    lexoRankIndex?: string | null;
    subTree?: Array<{
      id: string;
      name: string;
      type: string;
      parentId?: string | null;
      rules?: Array<string> | null;
      lexoRankIndex?: string | null;
      roles?: Array<{
        basedOn?: string | null;
        protected?: boolean | null;
        id: string;
        roleDefinitionId: string;
        display: Array<{ key: string; value: string } | null>;
      } | null> | null;
      linkedPatientGroups?: Array<{
        id: string;
        name?: string | null;
        patientsCount?: number | null;
        alarmRoutes?: Array<{
          configName: string;
          configType: string;
          idMappingStrategy: string;
          incomingTemplate?: {
            isPresentInAccount?: boolean | null;
            code: string;
            title?: string | null;
            system?: string | null;
            displayText?: string | null;
            icon?: string | null;
          } | null;
          outgoingTemplate?: {
            isPresentInAccount?: boolean | null;
            code: string;
            title?: string | null;
            system?: string | null;
            displayText?: string | null;
            icon?: string | null;
          } | null;
        }>;
      } | null> | null;
      patientGroups?: Array<{
        id: string;
        name?: string | null;
        patientsCount?: number | null;
        alarmRoutes?: Array<{
          configName: string;
          configType: string;
          idMappingStrategy: string;
          incomingTemplate?: {
            isPresentInAccount?: boolean | null;
            code: string;
            title?: string | null;
            system?: string | null;
            displayText?: string | null;
            icon?: string | null;
          } | null;
          outgoingTemplate?: {
            isPresentInAccount?: boolean | null;
            code: string;
            title?: string | null;
            system?: string | null;
            displayText?: string | null;
            icon?: string | null;
          } | null;
        }>;
      } | null> | null;
      skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
      deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
    roles?: Array<{
      basedOn?: string | null;
      protected?: boolean | null;
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    linkedPatientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      alarmRoutes?: Array<{
        configName: string;
        configType: string;
        idMappingStrategy: string;
        incomingTemplate?: {
          isPresentInAccount?: boolean | null;
          code: string;
          title?: string | null;
          system?: string | null;
          displayText?: string | null;
          icon?: string | null;
        } | null;
        outgoingTemplate?: {
          isPresentInAccount?: boolean | null;
          code: string;
          title?: string | null;
          system?: string | null;
          displayText?: string | null;
          icon?: string | null;
        } | null;
      }>;
    } | null> | null;
    patientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      alarmRoutes?: Array<{
        configName: string;
        configType: string;
        idMappingStrategy: string;
        incomingTemplate?: {
          isPresentInAccount?: boolean | null;
          code: string;
          title?: string | null;
          system?: string | null;
          displayText?: string | null;
          icon?: string | null;
        } | null;
        outgoingTemplate?: {
          isPresentInAccount?: boolean | null;
          code: string;
          title?: string | null;
          system?: string | null;
          displayText?: string | null;
          icon?: string | null;
        } | null;
      }>;
    } | null> | null;
    deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
  };
};

export type SubTreeDynamicFragment = {
  id: string;
  name: string;
  type: string;
  parentId?: string | null;
  rules?: Array<string> | null;
  lexoRankIndex?: string | null;
  roles?: Array<{
    basedOn?: string | null;
    protected?: boolean | null;
    id: string;
    roleDefinitionId: string;
    display: Array<{ key: string; value: string } | null>;
  } | null> | null;
  linkedPatientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes?: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }>;
  } | null> | null;
  patientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes?: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
      outgoingTemplate?: {
        isPresentInAccount?: boolean | null;
        code: string;
        title?: string | null;
        system?: string | null;
        displayText?: string | null;
        icon?: string | null;
      } | null;
    }>;
  } | null> | null;
  skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
  deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
};

export type PatientGroupDynamicFragment = {
  id: string;
  name?: string | null;
  patientsCount?: number | null;
  alarmRoutes?: Array<{
    configName: string;
    configType: string;
    idMappingStrategy: string;
    incomingTemplate?: {
      isPresentInAccount?: boolean | null;
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
    } | null;
    outgoingTemplate?: {
      isPresentInAccount?: boolean | null;
      code: string;
      title?: string | null;
      system?: string | null;
      displayText?: string | null;
      icon?: string | null;
    } | null;
  }>;
};

export type UserGroupForCmpQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForCmpQuery = {
  userGroup: {
    name: string;
    deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    subTree?: Array<{
      name: string;
      deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
  };
};

export type UserGroupForDashboardQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForDashboardQuery = {
  userGroup: {
    id: string;
    subTree?: Array<{ patientGroups?: Array<{ id: string; name?: string | null } | null> | null } | null> | null;
    linkedPatientGroups?: Array<{ id: string; name?: string | null } | null> | null;
    patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
  };
};

export type UserGroupForExternalAccessQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForExternalAccessQuery = {
  userGroup: {
    id: string;
    name: string;
    parentId?: string | null;
    protected?: boolean | null;
    subTree?: Array<{
      id: string;
      name: string;
      parentId?: string | null;
      patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
  };
};

export type UserGroupTypeQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type UserGroupTypeQuery = { userGroup: { id: string; type: string } };

export type UserNotificationsDataQueryVariables = Exact<{ [key: string]: never }>;

export type UserNotificationsDataQuery = {
  getMyUserProfile: { id: string; email?: string | null; mobileNumber?: string | null };
};

export type UserForEditFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserForEditFormQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    enabled?: boolean | null;
    username?: string | null;
    mobileNumber?: string | null;
    otpStatus?: string | null;
    pendingEmailInvitation?: boolean | null;
    ipRestrictions?: Array<string | null> | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    externalIdP?: string | null;
    passwordStatus?: string | null;
    externalIdentities?: Array<{ provider: string }> | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
    pendingExternalIdentityProviders?: Array<{ provider: string; pending: boolean }> | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    timeLimitedAccess?: { start?: any | null; end?: any | null } | null;
  } | null>;
};

export type UsersNamesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UsersNamesQuery = {
  users: Array<{
    pendingEmailInvitation?: boolean | null;
    id: string;
    username?: string | null;
    firstName: string;
    lastName: string;
    email?: string | null;
    enabled?: boolean | null;
  } | null>;
};

export type UsersForUserViewQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UsersForUserViewQuery = {
  users: Array<{
    pendingEmailInvitation?: boolean | null;
    id: string;
    username?: string | null;
    firstName: string;
    lastName: string;
    email?: string | null;
    enabled?: boolean | null;
    roles?: Array<{ basedOn?: string | null } | null> | null;
  } | null>;
};

export type UsersForSupervisionQueryVariables = Exact<{ [key: string]: never }>;

export type UsersForSupervisionQuery = { users: Array<{ id: string; firstName: string; lastName: string } | null> };

export type CreateUserMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;

export type CreateUserMutation = {
  createUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    user?: { id: string } | null;
  } | null;
};

export type UpdateUserBeforeDeletionMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
}>;

export type UpdateUserBeforeDeletionMutation = {
  updateUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeleteUserMutation = {
  deleteUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
}>;

export type UpdateUserMutation = { updateUser?: { success: boolean; message?: string | null } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ResetUserPasswordMutation = { resetUserPassword?: boolean | null };

export type DisableUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DisableUserPasswordMutation = { disableUserPassword?: boolean | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;

export type UpdateUserPasswordMutation = { updateUserPassword?: boolean | null };

export type ActivateOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ActivateOtpMutation = { activateOtp?: boolean | null };

export type DeleteOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeleteOtpMutation = { deleteOtp?: boolean | null };

export type CancelOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CancelOtpMutation = { cancelOtp?: boolean | null };

export type ActivateSmsOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type ActivateSmsOtpMutation = { activateSmsOtp?: boolean | null };

export type DeactivateSmsOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeactivateSmsOtpMutation = { deactivateSmsOtp?: boolean | null };

export type SetExternalIdentitiesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>> | InputMaybe<ExternalIdentityInput>>;
}>;

export type SetExternalIdentitiesMutation = { setExternalIdentities?: boolean | null };

export type SetExternalIdPMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  idP: Scalars['String']['input'];
}>;

export type SetExternalIdPMutation = { setExternalIdP?: boolean | null };

export type EnableUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type EnableUserPasswordMutation = { enableUserPassword?: boolean | null };

export type GetUserByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;

export type GetUserByUsernameQuery = {
  getUserByUsername?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    }> | null;
  } | null;
};

export type UsersDynamicQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  includeExternalIdentities?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UsersDynamicQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    enabled?: boolean | null;
    email?: string | null;
    username?: string | null;
    ipRestrictions?: Array<string | null> | null;
    otpStatus?: string | null;
    smsOtpStatus?: string | null;
    passwordStatus?: string | null;
    created?: any | null;
    externalIdP?: string | null;
    lastActive?: any | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
      userGroup?: { id: string; name: string } | null;
    } | null> | null;
    externalIdentities?: Array<{ provider: string }> | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
  } | null>;
};

export type UsersPaginatedQueryVariables = Exact<{
  paging?: InputMaybe<UsersPagingInput>;
  filter?: InputMaybe<UsersFilterInput>;
}>;

export type UsersPaginatedQuery = {
  usersPaginated: {
    cursor?: any | null;
    hasMore: boolean;
    totalCount: number;
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      enabled?: boolean | null;
      email?: string | null;
      username?: string | null;
      ipRestrictions?: Array<string | null> | null;
      otpStatus?: string | null;
      smsOtpStatus?: string | null;
      passwordStatus?: string | null;
      created?: any | null;
      externalIdP?: string | null;
      lastActive?: any | null;
      roles?: Array<{
        id: string;
        roleDefinitionId: string;
        display: Array<{ key: string; value: string } | null>;
        userGroup?: { id: string; name: string } | null;
      } | null> | null;
      externalIdentities?: Array<{ provider: string }> | null;
      externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    }>;
  };
};

export type VkpPatientCareplanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type VkpPatientCareplanQuery = { vkpPatientCareplan?: { fnr: string; responseAsJson?: string | null } | null };

export type VkpPatientEpisodesOfCareQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type VkpPatientEpisodesOfCareQuery = {
  vkpPatientEpisodesOfCare?: { fnr: string; responseAsJson?: string | null } | null;
};

export type ServicesQueryVariables = Exact<{ [key: string]: never }>;

export type ServicesQuery = {
  services?: Array<{
    id?: string | null;
    name?: string | null;
    roles?: Array<{
      basedOn?: string | null;
      id: string;
      roleDefinitionId: string;
      dashboardRouteName?: string | null;
      canAssignRoles?: Array<string> | null;
      userGroup?: { isTopLevel?: boolean | null; id: string; name: string } | null;
      userManuals?: Array<{
        id: string;
        name: string;
        icon?: string | null;
        applications?: { tilsyn?: boolean | null; dho?: boolean | null; dhv?: boolean | null } | null;
        localeEntries: Array<{ localeId: string; description?: string | null; displayName: string; url: string }>;
        roleDefinitions?: Array<{ id: string }> | null;
      }> | null;
      display: Array<{ key: string; value: string } | null>;
      abilities?: Array<{ operation?: string | null; resource?: string | null } | null> | null;
    } | null> | null;
    applications?: {
      dialogg?: boolean | null;
      supervision?: boolean | null;
      rpm?: boolean | null;
      dhv?: boolean | null;
      supportTeam?: boolean | null;
      response?: boolean | null;
    } | null;
    features?: {
      externalHumanIdTypeIdForPatient?: string | null;
      externalHumanIdTypeIdForUser?: string | null;
      externalHumanIdTypeIdForDialoggUser?: string | null;
      videoMeetings?: boolean | null;
      defaultLocale?: string | null;
      axisCameras?: boolean | null;
      disablePasswordForDialoggUsers?: boolean | null;
      smsNotifications?: boolean | null;
      emailNotifications?: boolean | null;
      continuousSupervision?: boolean | null;
      vkpSearchEnabled?: boolean | null;
      dataAnalytics?: boolean | null;
      joinNhnMeeting?: boolean | null;
      hasTrends?: boolean | null;
      newSupervisionUserTabs?: boolean | null;
      hasFurnitureDetection?: boolean | null;
      hasDemoAnonymization?: boolean | null;
      hasEntraIdSso?: boolean | null;
      hasEntraIdProvisioning?: boolean | null;
      sendNotificationToNextOfKin?: boolean | null;
      selfTreatmentPlan?: boolean | null;
      hasJournalConfig?: boolean | null;
      hasSkyresponseCustomerGroup?: boolean | null;
      hasCmpAccount?: boolean | null;
      hasCmp?: boolean | null;
      safemateIntegration?: boolean | null;
      tcifIntegration?: boolean | null;
      skyresponse?: boolean | null;
      hasAlmaIntegration?: boolean | null;
      hasAscomIntegration?: boolean | null;
      hasPhoniroCloudIntegration?: boolean | null;
      hasSkyresponsePartnerIntegration?: boolean | null;
      hasSipIntegration?: boolean | null;
      hasCoordcomIntegration?: boolean | null;
      hasTietoLmoIntegration?: boolean | null;
      hasIpOmsorgIntegration?: boolean | null;
      hasUmo2GIntegration?: boolean | null;
      hasBestIntegration?: boolean | null;
    } | null;
    configuration?: {
      alarmAckTemplates?: Array<{ template?: string | null; status?: string | null } | null> | null;
    } | null;
    whiteLabelingTemplate?: {
      id: string;
      name: string;
      title?: string | null;
      primaryColor?: string | null;
      accentColor?: string | null;
      icon?: { id: string; url: string } | null;
      logo?: { id: string; url: string } | null;
      titleLogo?: { id: string; url: string } | null;
      menuBackgroundGradient?: { direction: string; colorStops: Array<{ color: string; stopPosition: number }> } | null;
      primaryButtonGradient?: { direction: string; colorStops: Array<{ color: string; stopPosition: number }> } | null;
      secondaryButtonGradient?: {
        direction: string;
        colorStops: Array<{ color: string; stopPosition: number }>;
      } | null;
    } | null;
  } | null> | null;
};

export type RegisterPushIdForShiftSessionMutationVariables = Exact<{
  pushNotificationSettings: PushNotificationSettingsInput;
}>;

export type RegisterPushIdForShiftSessionMutation = {
  registerPushIdForShiftSession?: { success: boolean; message?: string | null } | null;
};

export type CreateShiftSessionForPatientGroupsMutationVariables = Exact<{
  patientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateShiftSessionForPatientGroupsMutation = {
  createShiftSessionForPatientGroups?: {
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      locale?: string | null;
      mobileNumber?: string | null;
      email?: string | null;
    };
  } | null;
};

export type SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables = Exact<{
  notificationSettings: SessionNotificationSettingsInput;
}>;

export type SetEmailAndSmsNotificationSettingsForShiftSessionMutation = {
  setEmailAndSmsNotificationSettingsForShiftSession?: {
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      locale?: string | null;
      mobileNumber?: string | null;
      email?: string | null;
    };
  } | null;
};

export type ShiftSessionQueryVariables = Exact<{ [key: string]: never }>;

export type ShiftSessionQuery = {
  shiftSession?: {
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string; createdAt: any }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      mobileNumber?: string | null;
      email?: string | null;
    };
  } | null;
};

export type AddNextOfKinInImportComponentMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nextOfKinInput: CreateNextOfKinInput;
}>;

export type AddNextOfKinInImportComponentMutation = {
  addNextOfKin: { success: boolean; message?: string | null; nextOfKin?: { id: string } | null };
};

export type UpdateNextOfKinInImportComponentMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
  nextOfKinInput: UpdateNextOfKinInput;
}>;

export type UpdateNextOfKinInImportComponentMutation = {
  updateNextOfKin: { success: boolean; message?: string | null };
};

export type CreateUserGroupForImportComponentMutationVariables = Exact<{
  newUserGroup: CreateUserGroupInput;
  parentUserGroupId: Scalars['ID']['input'];
}>;

export type CreateUserGroupForImportComponentMutation = {
  createUserGroup: { success?: boolean | null; message?: string | null; userGroup?: { id: string } | null };
};

export type UpdateUserGroupForImportComponentMutationVariables = Exact<{
  userGroup: UpdateUserGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type UpdateUserGroupForImportComponentMutation = {
  updateUserGroup: { success?: boolean | null; userGroup?: { id: string } | null };
};

export type UpdatePatientGroupsOfPatientMutationVariables = Exact<{
  addPatientGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  removePatientGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
}>;

export type UpdatePatientGroupsOfPatientMutation = { updatePatientGroupsOfPatient?: { success: boolean } | null };

export type GetSupportedLanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportedLanguagesQuery = { getSupportedLanguages?: Array<{ code: string }> | null };

export type PatientsForImportQueryVariables = Exact<{ [key: string]: never }>;

export type PatientsForImportQuery = {
  patientsForImport: Array<{
    id: string;
    externalIds: Array<{ type: string; id: string }>;
    contacts?: Array<{ id: string; name?: string | null }> | null;
    nextOfKins: Array<{
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    }>;
    patientGroups: Array<{ id: string; name?: string | null }>;
  }>;
};

export type UserGroupForImportComponentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForImportComponentQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    patientGroups?: Array<{ id: string; name?: string | null; patientsCount?: number | null } | null> | null;
    subTree?: Array<{
      id: string;
      name: string;
      type: string;
      rules?: Array<string> | null;
      parentId?: string | null;
      roles?: Array<{
        id: string;
        roleDefinitionId: string;
        protected?: boolean | null;
        display: Array<{ key: string; value: string } | null>;
      } | null> | null;
      patientGroups?: Array<{ id: string; name?: string | null; patientsCount?: number | null } | null> | null;
      contacts?: Array<{
        id: string;
        name: string;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      }> | null;
    } | null> | null;
    contacts?: Array<{
      id: string;
      name: string;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    }> | null;
  };
};

export type GetOpenPatientAlarmsQueryVariables = Exact<{
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hideAssignedToOtherUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOpenPatientAlarmsQuery = {
  getOpenPatientAlarms: Array<{
    id: string;
    status: string;
    handlingMode?: string | null;
    priority?: string | null;
    authoredOn?: any | null;
    code?: { text?: string | null } | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      priority?: string | null;
      icon?: string | null;
      valueReference?: { reference?: string | null } | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      type?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null> | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      patientGroups?: Array<{ id: string; name: string } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
        position?: { latitude: number; longitude: number } | null;
      } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
  }>;
};

export type GetPatientWithAlarmsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientWithAlarmsQuery = {
  getPatientWithAlarms?: {
    patient: { id: string; active: boolean };
    openTechnicalAlarms: Array<{
      forDeviceType?: string | null;
      forDeviceName?: string | null;
      id: string;
      status: string;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      description?: string | null;
      intent?: string | null;
      priority?: string | null;
      authoredOn?: any | null;
      firstEventTimestamp?: any | null;
      lastModified: any;
      code?: { text?: string | null } | null;
      for: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      };
      basedOn?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      focus?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      } | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      partOf?: Array<{
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      } | null> | null;
      executionPeriod?: { start?: any | null; end?: any | null } | null;
      note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
      restriction?: {
        period?: { start?: any | null; end?: any | null } | null;
        recipient?: Array<{
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
        } | null> | null;
      } | null;
    }>;
    openPatientAlarms: Array<{
      forDeviceType?: string | null;
      forDeviceName?: string | null;
      id: string;
      status: string;
      description?: string | null;
      intent?: string | null;
      priority?: string | null;
      authoredOn?: any | null;
      firstEventTimestamp?: any | null;
      lastModified: any;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      code?: { text?: string | null } | null;
      for: { reference?: string | null; type?: string | null; display?: string | null };
      basedOn?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      focus?: { reference?: string | null; type?: string | null; display?: string | null } | null;
      partOf?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      executionPeriod?: { start?: any | null; end?: any | null } | null;
      note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      owner?: { reference?: string | null; type?: string | null; display?: string | null } | null;
    }>;
  } | null;
};

export type GetAlarmStatusQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetAlarmStatusQuery = {
  getAlarmStatus: {
    id: string;
    status: string;
    handlingMode?: string | null;
    deadlineAt?: any | null;
    extendByMinutes?: number | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
    } | null> | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
  };
};

export type GetAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetAlarmByIdQuery = {
  getAlarmById: {
    id: string;
    status: string;
    handlingMode?: string | null;
    holdsCamera: boolean;
    deadlineAt?: any | null;
    extendByMinutes?: number | null;
    intent?: string | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    lastModified: any;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    completionOptions?: Array<string> | null;
    isSupervisionAlarmWithAnOpenedCameraStream?: boolean | null;
    isSupervisionAlarm?: boolean | null;
    code?: { text?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    for: { reference?: string | null };
    subTasks?: Array<{ id: string } | null> | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    vkpConfiguration?: { enabled: boolean } | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
    patient?: {
      id: string;
      keyCode?: string | null;
      addressNote?: string | null;
      areCamerasEnabled: boolean;
      camerasStateOrigin?: CameraStateOrigin | null;
      note?: string | null;
      secretAddress?: boolean | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
      journalConfigForPatient?: { remoteSupervision: { enabled: boolean } } | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
        position?: { latitude: number; longitude: number } | null;
      } | null> | null;
      cameras?: Array<{
        id: string;
        name?: string | null;
        macAddress?: string | null;
        serialNumber?: string | null;
        availableHours?: string | null;
        isConfiguredInRegistry?: boolean | null;
        hasOfflineAlarm?: boolean | null;
        userHasAccessToPatient?: boolean | null;
        isAttachedToPatient?: boolean | null;
        detailedStatus?: {
          lastSeen?: any | null;
          heartbeatCount?: number | null;
          isAssociatedToPatient?: boolean | null;
          ttl?: number | null;
          privacyMode?: boolean | null;
        } | null;
      } | null> | null;
      welfareDevices?: Array<{
        id: string;
        uniqueIdentifier: string;
        modelNumber?: string | null;
        deviceName?: Array<{ name?: string | null }> | null;
        configuration?: { registeredInInventory?: boolean | null } | null;
      }> | null;
      patientGroups?: Array<{ id: string; name: string } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
  };
};

export type GetAllTechnicalAlarmsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllTechnicalAlarmsQuery = {
  getAllTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn?: any | null;
    description?: string | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    deviceGroupName?: string | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
    patientLink?: { patientId: string; patientName?: string | null; userHasAccessToPatient: boolean } | null;
  }>;
};

export type GetAllTechnicalAlarmsForDeviceQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllTechnicalAlarmsForDeviceQuery = {
  getAllTechnicalAlarmsForDevice: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type GetOpenSyncAlarmsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOpenSyncAlarmsQuery = {
  getOpenTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn?: any | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    syncPending?: boolean | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
  }>;
};

export type GetTechnicalAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTechnicalAlarmByIdQuery = {
  getTechnicalAlarmById: {
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      templateDisplayName?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
      valueReference?: { reference?: string | null; display?: string | null; type?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  };
};

export type GetSyncAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSyncAlarmByIdQuery = {
  getTechnicalAlarmById: {
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    syncPending?: boolean | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      templateDisplayName?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
      valueReference?: { reference?: string | null; display?: string | null; type?: string | null } | null;
      syncEventDetails?: {
        flowName?: string | null;
        stepName?: string | null;
        flowLogs?: Array<{
          timestamp: string;
          details: string;
          auditLogReferences: Array<{ auditEventId: string; description: string }>;
        }> | null;
      } | null;
    } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
  };
};

export type CompleteAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  completionInput: CompleteAlarmInput;
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CompleteAlarmMutation = {
  completeAlarm: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateTechnicalAlarmStatusMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateTechnicalAlarmStatusMutation = {
  updateTechnicalAlarmStatus: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddNotesToAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>>;
}>;

export type AddNotesToAlarmMutation = { addNotesToAlarm: { success: boolean; message?: string | null } };

export type AddNotesToTechnicalAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>>;
}>;

export type AddNotesToTechnicalAlarmMutation = {
  addNotesToTechnicalAlarm: { success: boolean; message?: string | null };
};

export type TriggerResolveActionsForSyncAlarmsMutationVariables = Exact<{
  alarmIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type TriggerResolveActionsForSyncAlarmsMutation = {
  triggerResolveActionsForSyncAlarms: { success: boolean; message?: string | null };
};

export type CancelSkyresponseSyncAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type CancelSkyresponseSyncAlarmMutation = {
  cancelSkyresponseSyncAlarm: { success: boolean; message?: string | null };
};

export type SimulateSyncEventMutationVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
  eventCode: Scalars['String']['input'];
  payload?: InputMaybe<SimulateSyncEventPayloadInput>;
}>;

export type SimulateSyncEventMutation = { simulateSyncEvent: { success: boolean; message?: string | null } };

export type GetAlarmSnapshotTokenQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetAlarmSnapshotTokenQuery = { getAlarmSnapshotToken?: string | null };

export type ActivateAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateAlarmTemplateMutation = {
  activateAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreatePatientInGroupMutationVariables = Exact<{
  patientGroup: Scalars['ID']['input'];
  patientInput: CreatePatientInput;
}>;

export type CreatePatientInGroupMutation = {
  createPatientInGroup?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    patient?: { id: string } | null;
  } | null;
};

export type AddShareSkyresponseAlarmWithPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  shareWithPatientIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type AddShareSkyresponseAlarmWithPatientMutation = {
  addShareSkyresponseAlarmWithPatient?: { success: boolean; message?: string | null } | null;
};

export type RetireAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireAlarmTemplateMutation = {
  retireAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAlarmStatusMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  handlingMode?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAlarmStatusMutation = {
  updateAlarmStatus: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type ExtendAlarmTimerMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type ExtendAlarmTimerMutation = {
  extendAlarmTimer: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateAlarmSubscriptionMutationVariables = Exact<{
  createInput: AlarmSubscriptionCreateInput;
}>;

export type CreateAlarmSubscriptionMutation = {
  createAlarmSubscription?: {
    success?: boolean | null;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ message?: string | null } | null> | null } | null;
    alarmSubscription?: { id: string } | null;
  } | null;
};

export type CreateAlarmTemplateMutationVariables = Exact<{
  input: AlarmTemplateCreateInput;
}>;

export type CreateAlarmTemplateMutation = {
  createAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateUnplannedSupervisionMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type CreateUnplannedSupervisionMutation = {
  createUnplannedSupervision: { success: boolean; message?: string | null; task?: { id: string } | null };
};

export type DeleteAlarmSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteAlarmSubscriptionMutation = {
  deleteAlarmSubscription?: { success?: boolean | null; message?: string | null } | null;
};

export type DeleteAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteAlarmTemplateMutation = {
  deleteAlarmTemplate: { success?: boolean | null; message?: string | null };
};

export type DisablePatientCamerasMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  camerasReactivateAt: Scalars['dateTime']['input'];
}>;

export type DisablePatientCamerasMutation = { disablePatientCameras: { success: boolean } };

export type EnablePatientCamerasMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type EnablePatientCamerasMutation = { enablePatientCameras: { success: boolean } };

export type ImportAlarmTemplatesFromDefaultMutationVariables = Exact<{
  alarmTemplateCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ImportAlarmTemplatesFromDefaultMutation = {
  importAlarmTemplatesFromDefault: {
    success: boolean;
    importedTemplates: Array<{ code: string; success: boolean; message?: string | null }>;
  };
};

export type ImportAlarmTemplatesMutationVariables = Exact<{
  fhirAlarmTemplates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ImportAlarmTemplatesMutation = { importAlarmTemplates: { success: boolean } };

export type SyncAlarmTemplatesMutationVariables = Exact<{
  alarmTemplateCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SyncAlarmTemplatesMutation = {
  syncAlarmTemplates: {
    success: boolean;
    importedTemplates: Array<{ code: string; success: boolean; message?: string | null }>;
  };
};

export type ImportDevicesFromSafemateProMutationVariables = Exact<{
  createInput: ImportDevicesInput;
}>;

export type ImportDevicesFromSafemateProMutation = {
  importDevicesFromSafematePro: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    devices: Array<{ id: string }>;
  };
};

export type ImportEventForPatientRawMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PatientEventRaw;
}>;

export type ImportEventForPatientRawMutation = { importEventForPatientRaw: { success: boolean } };

export type ImportMeasurementTemplatesFromDefaultMutationVariables = Exact<{
  measurementTemplateCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ImportMeasurementTemplatesFromDefaultMutation = {
  importMeasurementTemplatesFromDefault: Array<{ success: boolean; message?: string | null; code: string }>;
};

export type ImportObservationTemplatesMutationVariables = Exact<{
  fhirTemplates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ImportObservationTemplatesMutation = { importObservationTemplates: { success: boolean } };

export type ValidateForwarderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ValidateForwarderMutation = {
  validateForwarder: { success: boolean; message: string; details?: string | null };
};

export type CreateIntegrationMutationVariables = Exact<{
  input: IntegrationCreateInput;
}>;

export type CreateIntegrationMutation = {
  createIntegration: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: IntegrationUpdateInput;
}>;

export type UpdateIntegrationMutation = {
  updateIntegration: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateAlarmForwarderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forwarderInput: ForwarderCreateInput;
}>;

export type CreateAlarmForwarderMutation = {
  createAlarmForwarder: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAlarmForwarderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  forwarderInput: ForwarderUpdateInput;
}>;

export type UpdateAlarmForwarderMutation = {
  updateAlarmForwarder: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateForwarderErrorHandlingMutationVariables = Exact<{
  forwarderConfigId: Scalars['ID']['input'];
  errorHandling: ForwarderErrorHandlingInput;
}>;

export type UpdateForwarderErrorHandlingMutation = {
  updateForwarderErrorHandling: {
    success: boolean;
    message?: string | null;
    id?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AssignForwarderToPatientGroupsMutationVariables = Exact<{
  forwarderConfigId: Scalars['ID']['input'];
  patientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AssignForwarderToPatientGroupsMutation = {
  assignForwarderToPatientGroups: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteIntegrationMutation = {
  deleteIntegration: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteForwarderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteForwarderMutation = {
  deleteForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AssignExternalAccessToForwarderMutationVariables = Exact<{
  forwarderConfigId: Scalars['ID']['input'];
  externalAccessId: Scalars['ID']['input'];
}>;

export type AssignExternalAccessToForwarderMutation = {
  assignExternalAccessToForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AssignIntegrationToSkyresponseConfigMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
}>;

export type AssignIntegrationToSkyresponseConfigMutation = {
  assignIntegrationToSkyresponseConfig: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type RemoveIntegrationFromSkyresponseConfigMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type RemoveIntegrationFromSkyresponseConfigMutation = {
  removeIntegrationFromSkyresponseConfig: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type RemoveCameraFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
}>;

export type RemoveCameraFromPatientMutation = { removeCameraFromPatient: { success: boolean } };

export type StartPhoneCallMutationVariables = Exact<{
  type: PhoneCallTargetType;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartPhoneCallMutation = { startPhoneCall?: boolean | null };

export type AddPlannedSupervisionMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: PlannedSupervisionCreateInput;
}>;

export type AddPlannedSupervisionMutation = {
  addPlannedSupervision?: {
    success?: boolean | null;
    plannedSupervision?: { alarmActivity: { id: string } } | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdatePlannedSupervisionMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  alarmActivityId: Scalars['ID']['input'];
  input: PlannedSupervisionUpdateInput;
}>;

export type UpdatePlannedSupervisionMutation = {
  updatePlannedSupervision?: {
    success?: boolean | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type RemovePlannedSupervisionMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  alarmActivityId: Scalars['ID']['input'];
}>;

export type RemovePlannedSupervisionMutation = {
  removePlannedSupervision?: { success?: boolean | null; message?: string | null } | null;
};

export type TriggerEventInCameraMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['Int']['input'];
  appName: Scalars['String']['input'];
}>;

export type TriggerEventInCameraMutation = { triggerEventInCamera: boolean };

export type UpdateAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AlarmTemplateUpdateInput;
}>;

export type UpdateAlarmTemplateMutation = {
  updateAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAnonymizationMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  anonymization: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAnonymizationMutation = { updateAnonymization: boolean };

export type UpdatePatientProfileMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientProfileMutation = {
  updatePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type GetAlarmTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetAlarmTemplateQuery = {
  getAlarmTemplate: {
    id: string;
    status: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    debounceDelay?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    locationTraceOnly?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    description?: string | null;
    cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
    timedCep?: { events: Array<string>; cancelledBy: Array<string>; mode: string } | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    vkpEncounter?: { type?: number | null; reason?: number | null } | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      extension?: Array<{
        url?: string | null;
        valueBoolean?: boolean | null;
        valueInteger?: number | null;
        valueString?: string | null;
        ValueId?: string | null;
      }> | null;
    } | null> | null;
  };
};

export type HealthProviderSettingsForExternalIdHumanInputQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForExternalIdHumanInputQuery = {
  healthProviderSettings: {
    userAuth?: {
      twoFactorSms?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        default?: boolean | null;
        displayName?: string | null;
        enabled?: boolean | null;
        support?: boolean | null;
      }> | null;
    } | null;
    patientAuth?: { twoFactorSms?: boolean | null } | null;
    externalHumanIdTypes?: Array<{ id: string }> | null;
  };
};

export type GetAllAlarmHistoryQueryVariables = Exact<{
  from: Scalars['dateTime']['input'];
  to: Scalars['dateTime']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeSupervision?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAllAlarmHistoryQuery = {
  getAllAlarmHistory: Array<{
    telluAlarmId?: string | null;
    responseCenterAlarmId?: string | null;
    tag: string;
    alarmEvent?: string | null;
    routingType?: AlarmRoutingType | null;
    serverAlarmTime?: any | null;
    deactivationTimeInApp?: any | null;
    deactivationTimeInRs?: any | null;
    acceptedAtInApp?: any | null;
    acceptedAtInRs?: any | null;
    alarmForwardedAt?: any | null;
    alarmStartedInApp?: any | null;
    handlingMode?: string | null;
    camerasOpened?: number | null;
    autoReleasedAt?: any | null;
    patientId?: string | null;
    alarmHandling?: string | null;
    journalWorkflowStatus?: string | null;
    alarmCode?: string | null;
    priority: string;
    organization?: string | null;
    group?: string | null;
    responseCenter?: string | null;
    textMessage?: string | null;
    globalAlarmId?: string | null;
    identifier?: string | null;
    operatorForRs?: string | null;
    operatorForApp?: string | null;
    alarmActionOne?: string | null;
    alarmActionLast?: string | null;
    alarmReasonOne?: string | null;
    alarmReasonLast?: string | null;
    completionOptionNote?: string | null;
    freeTextNote?: string | null;
    name?: { display?: string | null } | null;
    owner?: { display?: string | null } | null;
    camerasOpenedBy: Array<{ name: string; count: number }>;
    patientName?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type GetAlarmHistoryForPatientQueryVariables = Exact<{
  from: Scalars['dateTime']['input'];
  to: Scalars['dateTime']['input'];
  patientId: Scalars['ID']['input'];
  includeSupervision?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAlarmHistoryForPatientQuery = {
  getAlarmHistoryForPatient: Array<{
    telluAlarmId?: string | null;
    responseCenterAlarmId?: string | null;
    tag: string;
    alarmEvent?: string | null;
    serverAlarmTime?: any | null;
    routingType?: AlarmRoutingType | null;
    deactivationTimeInApp?: any | null;
    deactivationTimeInRs?: any | null;
    acceptedAtInApp?: any | null;
    acceptedAtInRs?: any | null;
    alarmForwardedAt?: any | null;
    alarmStartedInApp?: any | null;
    handlingMode?: string | null;
    camerasOpened?: number | null;
    autoReleasedAt?: any | null;
    patientId?: string | null;
    alarmHandling?: string | null;
    journalWorkflowStatus?: string | null;
    alarmCode?: string | null;
    priority: string;
    organization?: string | null;
    group?: string | null;
    responseCenter?: string | null;
    textMessage?: string | null;
    identifier?: string | null;
    globalAlarmId?: string | null;
    operatorForRs?: string | null;
    operatorForApp?: string | null;
    alarmActionOne?: string | null;
    alarmActionLast?: string | null;
    alarmReasonOne?: string | null;
    alarmReasonLast?: string | null;
    completionOptionNote?: string | null;
    freeTextNote?: string | null;
    name?: { display?: string | null } | null;
    owner?: { display?: string | null } | null;
    camerasOpenedBy: Array<{ name: string; count: number }>;
    patientName?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type UserGroupForAlarmHistoryQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForAlarmHistoryQuery = {
  userGroup: {
    id: string;
    name: string;
    skyresponse?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
  };
};

export type GetAlarmHistoryDetailByIdQueryVariables = Exact<{
  telluAlarmId?: InputMaybe<Scalars['ID']['input']>;
  skyresponseAlarmId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAlarmHistoryDetailByIdQuery = {
  getAlarmHistoryDetailById: {
    cameraViews: Array<{
      cameraId: string;
      cameraName?: string | null;
      watchedBy?: string | null;
      streamId?: string | null;
      startedAt?: any | null;
      endedAt?: any | null;
    }>;
    skyresponseAlarmDetail?: {
      id: string;
      userId: string;
      name: string;
      messages?: Array<string> | null;
      serverAlarmTime: string;
      deactivationTime?: string | null;
      responseCenter: string;
      globalAlarmId: string;
      reason?: string | null;
      identifier?: string | null;
      action?: string | null;
      acceptedAt?: string | null;
      textMessage?: string | null;
      alarmCode: number;
      logs?: Array<{ created: string; type: number; subType: number; text: string; name: string }> | null;
    } | null;
    telluAlarmDetail?: {
      id: string;
      description?: string | null;
      priority?: string | null;
      authoredOn?: any | null;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      completionOptionNote?: string | null;
      freeTextNote?: string | null;
      input?: Array<{
        icon?: string | null;
        priority?: string | null;
        timestamp?: string | null;
        values: Array<{
          name: string;
          valueString?: string | null;
          valueBoolean?: boolean | null;
          valueNumber?: number | null;
        }>;
        valueReference?: { reference?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ system?: any | null; code?: any | null } | null> | null;
        } | null;
      } | null> | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      patient?: {
        id: string;
        name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
        patientGroups?: Array<{ id: string; name: string } | null> | null;
      } | null;
      for: { display?: string | null };
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null } | null;
      } | null> | null;
      journalWorkflow?: Array<{
        type: string;
        status: string;
        userGroupId?: string | null;
        retriedAt?: Array<any | null> | null;
        nextRetry?: any | null;
        completedAt?: any | null;
        freeTextNote?: string | null;
        completionOptions?: Array<string> | null;
        debugDetails?: string | null;
      }> | null;
    } | null;
  };
};

export type GetAlarmHistoryForResponderQueryVariables = Exact<{
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  onlyClosedByResponder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAlarmHistoryForResponderQuery = {
  getAlarmHistoryForResponder: Array<{
    id: string;
    status: string;
    handlingMode?: string | null;
    intent?: string | null;
    priority?: string | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    description?: string | null;
    authoredOn?: any | null;
    firstEventTimestamp?: any | null;
    code?: { text?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      priority?: string | null;
      icon?: string | null;
      valueReference?: { reference?: string | null } | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      type?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
    journalWorkflow?: Array<{
      type: string;
      status: string;
      userGroupId?: string | null;
      retriedAt?: Array<any | null> | null;
      nextRetry?: any | null;
      completedAt?: any | null;
      freeTextNote?: string | null;
      completionOptions?: Array<string> | null;
      debugDetails?: string | null;
    }> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      patientGroups?: Array<{ id: string; name: string } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
  }>;
};

export type AvailableResourcesToContactQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableResourcesToContactQuery = {
  availableResourcesToContact: {
    topLevelContacts: Array<{
      id: string;
      name: string;
      availableHours: string;
      priority?: number | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      }> | null;
    }>;
    lowerLevelContacts: Array<{
      id: string;
      name: string;
      availableHours: string;
      priority?: number | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      }> | null;
    }>;
  };
};

export type GetAvailableCamerasInInventoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableCamerasInInventoryQuery = {
  getAvailableCamerasInInventory: Array<{ macAddress?: string | null; modelNumber?: string | null }>;
};

export type GetCameraForFormQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraForFormQuery = {
  getCamera: {
    id: string;
    isConfiguredInRegistry?: boolean | null;
    availableHours?: string | null;
    isAttachedToPatient?: boolean | null;
    name: string;
    macAddress: string;
    modelName?: string | null;
    manufacturer?: string | null;
    deviceGroup?: { id: string; name?: string | null } | null;
    cameraProfile?: {
      id: string;
      name: string;
      template?: CameraProfileTemplate | null;
      origin: CameraProfileOrigin;
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      enableSnapshotAnonymization?: boolean | null;
      continuousSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundMonitoringDefaultThreshold: number;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableExtendingCameraAvailability: boolean;
    } | null;
    effectiveSettings?: {
      streamAnonymizationMode: StreamAnonymizationMode;
      streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
      enableSnapshots: boolean;
      snapshotAnonymization: boolean;
      continuousSupervision: boolean;
      streamTTL?: number | null;
      allowUnplannedSupervision: boolean;
      enableSoundMonitoring: boolean;
      soundThreshold: number;
      enableExtendingCameraAvailability: boolean;
    } | null;
    settings: { soundThreshold?: number | null };
  };
};

export type CmpAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type CmpAccountsQuery = {
  cmpAccounts?: Array<{ id: string; clientId: string; clientSecret: string; customerGroup?: string | null }> | null;
};

export type ValidateCustomerGroupTowardsCmpMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ValidateCustomerGroupTowardsCmpMutation = {
  validateCustomerGroupTowardsCmp: {
    success: boolean;
    message?: string | null;
    device?: string | null;
    totalDevices?: number | null;
  };
};

export type DeleteCmpAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteCmpAccountMutation = { deleteCmpAccount: { success: boolean; message?: string | null } };

export type ValidateCmpAccountTowardsCmpMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ValidateCmpAccountTowardsCmpMutation = {
  validateCmpAccountTowardsCmp: { success: boolean; message?: string | null };
};

export type CreateCmpAccountMutationVariables = Exact<{
  input: CmpAccountCreateInput;
}>;

export type CreateCmpAccountMutation = {
  createCmpAccount: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateCmpAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CmpAccountUpdateInput;
}>;

export type UpdateCmpAccountMutation = {
  updateCmpAccount: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type GetPatientCmpDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientCmpDevicesQuery = {
  getPatientCmpDevices: Array<{
    id: string;
    alarmCode?: string | null;
    groupName?: string | null;
    url?: string | null;
    portalConnection?: { name?: string | null; value?: number | null; time?: any | null } | null;
    batteryStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    powerSupply?: { name?: string | null; value?: number | null; time?: any | null } | null;
    operationalStatus?: { name?: string | null; value?: number | null } | null;
    children?: Array<{
      radioIdCode?: string | null;
      activeTimeSpan?: { hasTimeSpan?: boolean | null; timeSpan?: string | null } | null;
      equipmentType?: { name?: string | null; value?: number | null } | null;
      locationCode?: { name?: string | null; value?: number | null } | null;
      batteryStatus?: { name?: string | null; value?: number | null } | null;
      supervisionStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    }> | null;
  }>;
};

export type FetchCmpDeviceForFormQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type FetchCmpDeviceForFormQuery = {
  fetchCmpDeviceForForm?: { uniqueIdentifier?: string | null; modelNumber?: string | null } | null;
};

export type GetCmpDeviceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCmpDeviceByIdQuery = {
  getCmpDeviceById?: {
    id: string;
    alarmCode?: string | null;
    groupName?: string | null;
    url?: string | null;
    portalConnection?: { name?: string | null; value?: number | null; time?: any | null } | null;
    batteryStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    powerSupply?: { name?: string | null; value?: number | null; time?: any | null } | null;
    operationalStatus?: { name?: string | null; value?: number | null } | null;
    children?: Array<{
      radioIdCode?: string | null;
      activeTimeSpan?: { hasTimeSpan?: boolean | null; timeSpan?: string | null } | null;
      equipmentType?: { name?: string | null; value?: number | null } | null;
      locationCode?: { name?: string | null; value?: number | null } | null;
      batteryStatus?: { name?: string | null; value?: number | null } | null;
      supervisionStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    }> | null;
  } | null;
};

export type GetAllAlarmSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllAlarmSubscriptionsQuery = {
  getAllAlarmSubscriptions: Array<{
    id: string;
    userId: string;
    type: string;
    targetEmails?: Array<string> | null;
    targetPhoneNumbers?: Array<string> | null;
    deviceGroupIds?: Array<string> | null;
    patientGroupIds?: Array<string> | null;
  }>;
};

export type GetAllAlarmEventsForTrendsQueryVariables = Exact<{
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  eventCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetAllAlarmEventsForTrendsQuery = {
  getAllAlarmEvents: Array<{
    id: string;
    effectiveDateTime?: any | null;
    status: string;
    code?: { coding?: Array<{ code?: any | null; display?: string | null } | null> | null } | null;
    component?: Array<{
      valueString?: string | null;
      code: { coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
    } | null> | null;
    subject?: { reference?: string | null } | null;
  }>;
};

export type GetAllPatientWithAllDevicesAndAlarmsQueryVariables = Exact<{
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAllPatientWithAllDevicesAndAlarmsQuery = {
  getAllPatientWithAllDevicesAndAlarms?: Array<{
    patientGroups: Array<string>;
    patient: {
      id: string;
      areCamerasEnabled: boolean;
      camerasStateOrigin?: CameraStateOrigin | null;
      responderIsPresent?: boolean | null;
      camerasDisabledAt?: any | null;
      camerasReactivateAt?: any | null;
      lastSupervisionTimestamp?: any | null;
      lastSupervisionPerformedByUserId?: string | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      } | null> | null;
      name?: Array<{ family?: string | null; given?: Array<string | null> | null; text?: string | null }> | null;
    };
    openDeviceTechnicalAlarms: Array<{
      id: string;
      status: string;
      priority?: string | null;
      authoredOn?: any | null;
      lastModified: any;
      forDeviceName?: string | null;
      forDeviceType?: string | null;
      for: { reference?: string | null };
      owner?: {
        reference?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
    }>;
    openCameraTechnicalAlarms: Array<{
      id: string;
      status: string;
      priority?: string | null;
      authoredOn?: any | null;
      lastModified: any;
      forDeviceName?: string | null;
      forDeviceType?: string | null;
      for: { reference?: string | null };
      owner?: {
        reference?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
    }>;
    openPatientAlarms: Array<{
      id: string;
      status: string;
      priority?: string | null;
      authoredOn?: any | null;
      firstEventTimestamp?: any | null;
      lastModified: any;
      code?: { text?: string | null } | null;
      for: { reference?: string | null; type?: string | null; display?: string | null };
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      owner?: { reference?: string | null; type?: string | null; display?: string | null } | null;
    }>;
    cameras: Array<{
      identifier: string;
      name: string;
      model: string;
      lastSeen?: any | null;
      privacyMode?: boolean | null;
      privacyModeUntil?: any | null;
      userHasAccessToPatient?: boolean | null;
      availableHours?: string | null;
      online?: boolean | null;
      deviceGroup?: {
        id: string;
        name?: string | null;
        enableFurnitureDetection?: boolean | null;
        furnitureDetectionPeriodSec?: number | null;
      } | null;
      cameraProfile?: {
        id: string;
        name: string;
        template?: CameraProfileTemplate | null;
        origin: CameraProfileOrigin;
        streamAnonymizationMode: StreamAnonymizationMode;
        streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
        enableSnapshots: boolean;
        enableSnapshotAnonymization?: boolean | null;
        continuousSupervision: boolean;
        enableSoundMonitoring: boolean;
        soundMonitoringDefaultThreshold: number;
        streamTTL?: number | null;
        allowUnplannedSupervision: boolean;
        enableExtendingCameraAvailability: boolean;
      } | null;
    }>;
    devices: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }>;
  }> | null;
};

export type GetAllUsersAlarmSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUsersAlarmSubscriptionsQuery = {
  getAllUsersAlarmSubscriptions: Array<{
    id: string;
    userId: string;
    type: string;
    targetEmails?: Array<string> | null;
    targetPhoneNumbers?: Array<string> | null;
    deviceGroupIds?: Array<string> | null;
    patientGroupIds?: Array<string> | null;
  }>;
};

export type GetDeviceByIdForTechnicalAlarmQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdForTechnicalAlarmQuery = {
  getWelfareDevice?: {
    id: string;
    modelNumber?: string | null;
    uniqueIdentifier: string;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
  } | null;
};

export type GetExternalUrlForWelfareDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetExternalUrlForWelfareDeviceQuery = { getExternalUrlForWelfareDevice: string };

export type GetLatestEventSnapshotTokenForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetLatestEventSnapshotTokenForPatientQuery = { getLatestEventSnapshotTokenForPatient?: string | null };

export type GetAllPatientAlarmsForAlarmCleanUpQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetAllPatientAlarmsForAlarmCleanUpQuery = {
  getAllPatientAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    lastModified: any;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
    } | null;
  }>;
};

export type IntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type IntegrationsQuery = {
  getIntegrations: Array<{ id: string; type: ForwarderConfigType; displayName?: string | null }>;
};

export type IntegrationDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;

export type IntegrationDetailsQuery = {
  getIntegrationDetails?: {
    id: string;
    type: ForwarderConfigType;
    displayName?: string | null;
    idMappingStrategy?: string | null;
    almaConfig?: { primaryUrl?: string | null; username?: string | null; password?: string | null } | null;
    ascomConfig?: {
      primaryUrl?: string | null;
      apiKey?: string | null;
      ascomIntegrationId?: string | null;
      heartbeatRate?: number | null;
      active?: boolean | null;
      connectionStatus?: { httpStatus: string; details?: string | null; timestamp?: string | null } | null;
    } | null;
    phoniroConfig?: {
      primaryUrl?: string | null;
      clientId?: string | null;
      clientSecret?: string | null;
      escalationTimeoutMinutes?: number | null;
      tenantId?: string | null;
      organizationId?: string | null;
      alarmServerId?: string | null;
      isCloudPlas?: boolean | null;
    } | null;
    umo2gConfig?: { endpointUrl: string; username: string; password: string; sender: string } | null;
    bestConfig?: { primaryUrl: string; clientId: string; secret: string } | null;
    skyresponseConfig?: { primaryUrl: string } | null;
    skyresponsePartnerConfig?: { primaryUrl: string; pin: string } | null;
    sipConfig?: { primaryUrl: string; secondaryUrl?: string | null } | null;
    coordcomConfig?: {
      targetHost: string;
      targetPort: number;
      localSipUser: string;
      userAgent: string;
      outboundSipOkTimeoutMs: number;
      inboundMrsTimeoutMs: number;
      tlsServerNameOverride?: string | null;
      customCaCertificate?: string | null;
      relaxCertificateValidation: boolean;
    } | null;
    errorHandling?: {
      createPatientAlarmOnFail: boolean;
      sendSmsOnFail: boolean;
      sendEmailOnFail: boolean;
      escalationPhoneNumbers?: Array<string> | null;
      escalationEmailAddresses?: Array<string> | null;
    } | null;
    patientGroups?: Array<{ id: string; name: string }> | null;
    externalAccess?: {
      id: string;
      name: string;
      allowedAccess?: Array<string> | null;
      ipRestrictions: Array<string>;
      patientGroups?: Array<{ id: string; name: string }> | null;
    } | null;
    availableExternalAccessEndpoints?: Array<{ endpoint: string; default: boolean }> | null;
  } | null;
};

export type GetEventForwardingLogsQueryVariables = Exact<{
  integrationConfigIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  forwardingStatus?: InputMaybe<Scalars['String']['input']>;
  errorHandlingStatus?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEventForwardingLogsQuery = {
  getEventForwardingLogs?: Array<{
    createdAt: any;
    escalationMethod?: ForwardingEscalationMethod | null;
    escalationStatus?: string | null;
    eventId: string;
    forwardingStatus: string;
    integrationConfigId: string;
    patientExternalId: string;
  } | null> | null;
};

export type GetAlarmTemplatesForForwardersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForForwardersQuery = {
  getAlarmTemplates: Array<{
    id: string;
    status: string;
    technical?: boolean | null;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
  }>;
};

export type GetNextOfKinQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetNextOfKinQuery = {
  getNextOfKin: Array<{
    id: string;
    notifyNextOfKin?: boolean | null;
    relationship?: string | null;
    name?: Array<{ text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
  }>;
};

export type PatientForViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientForViewQuery = {
  patient?: {
    id: string;
    active: boolean;
    areCamerasEnabled: boolean;
    birthDate?: any | null;
    gender?: AdministrativeGender | null;
    secretAddress?: boolean | null;
    addressNote?: string | null;
    keyCode?: string | null;
    tags?: Array<string | null> | null;
    note?: string | null;
    externalPatientIds?: Array<{
      externalId: string;
      externalHumanIdType: { id: string; use: { patientUse?: { immutable?: boolean | null } | null } };
    }> | null;
    userReservations?: Array<{ userId: string; firstName?: string | null; lastName?: string | null } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    languages?: Array<{ language: string; preferred: boolean }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    skyresponseDetails?: {
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    photo?: Array<{ url?: string | null } | null> | null;
    patientGroups?: Array<{ name: string; id: string } | null> | null;
    notification?: { inactiveSeconds?: number | null; missedSubmissionSeconds?: number | null } | null;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
      context?: { carePlan?: { id: string; title?: string | null } | null } | null;
    } | null> | null;
    carePlans?: Array<{
      id: string;
      status: CarePlanStatus;
      title?: string | null;
      description?: string | null;
      created?: any | null;
      subject: { reference?: string | null };
      period?: { start?: any | null; end?: any | null } | null;
      activity: Array<{
        detail: {
          instantiatesCanonical?: Array<string | null> | null;
          status: string;
          questionnaires?: Array<{ title?: string | null } | null> | null;
          scheduledTiming?: {
            repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null;
          } | null;
          scheduledPeriod?: { start?: any | null; end?: any | null } | null;
        };
      } | null>;
    } | null> | null;
    rpmMedicalDevices?: Array<{
      id: string;
      btAddress?: string | null;
      manufacturer?: string | null;
      modelName?: string | null;
      modelNumber?: string | null;
      sensorType?: string | null;
      serialNumber?: string | null;
      status?: string | null;
      deviceGroup?: { id: string; name?: string | null } | null;
      deviceName?: Array<{ name?: string | null; type: string }> | null;
      identifier?: Array<{ value?: string | null }> | null;
      patient?: { reference?: string | null } | null;
    }> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      status?: { connected?: boolean | null; lastSeen?: any | null } | null;
      patient?: { reference?: string | null } | null;
    }> | null;
    dialoggUser?: {
      username: string;
      enabled?: boolean | null;
      onBehalf?: { accessiblePatients?: Array<string> | null } | null;
    } | null;
    referenceRange?: Array<{
      id: string;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      identifier?: Array<{ value?: string | null } | null> | null;
      fromTemplate?: { reference?: string | null } | null;
      component?: Array<{
        code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
        valueQuantity?: { unit?: string | null; value?: number | null } | null;
        referenceRange?: Array<{
          text?: string | null;
          low?: { unit?: string | null; value?: number | null } | null;
          high?: { unit?: string | null; value?: number | null } | null;
          type?: {
            text?: string | null;
            coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ExternalPatientIdsFragment = {
  externalId: string;
  externalHumanIdType: { id: string; use: { patientUse?: { immutable?: boolean | null } | null } };
};

export type AddressFragment = {
  line?: Array<string | null> | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  text?: string | null;
};

export type PatientGroupsFragment = { name: string; id: string };

export type NotificationFragment = { inactiveSeconds?: number | null; missedSubmissionSeconds?: number | null };

export type DocumentsFragment = {
  id: string;
  content?: Array<{
    attachment?: {
      title?: string | null;
      contentType?: string | null;
      url?: string | null;
      size?: number | null;
      creation?: any | null;
    } | null;
  } | null> | null;
  context?: { carePlan?: { id: string; title?: string | null } | null } | null;
};

export type CarePlansFragment = {
  id: string;
  status: CarePlanStatus;
  title?: string | null;
  description?: string | null;
  created?: any | null;
  subject: { reference?: string | null };
  period?: { start?: any | null; end?: any | null } | null;
  activity: Array<{
    detail: {
      instantiatesCanonical?: Array<string | null> | null;
      status: string;
      questionnaires?: Array<{ title?: string | null } | null> | null;
      scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      scheduledPeriod?: { start?: any | null; end?: any | null } | null;
    };
  } | null>;
};

export type RpmMedicalDevicesFragment = {
  id: string;
  btAddress?: string | null;
  manufacturer?: string | null;
  modelName?: string | null;
  modelNumber?: string | null;
  sensorType?: string | null;
  serialNumber?: string | null;
  status?: string | null;
  deviceGroup?: { id: string; name?: string | null } | null;
  deviceName?: Array<{ name?: string | null; type: string }> | null;
  identifier?: Array<{ value?: string | null }> | null;
  patient?: { reference?: string | null } | null;
};

export type WelfareDevicesFragment = {
  id: string;
  uniqueIdentifier: string;
  modelNumber?: string | null;
  status?: { connected?: boolean | null; lastSeen?: any | null } | null;
  patient?: { reference?: string | null } | null;
};

export type DialoggUserFragment = {
  username: string;
  enabled?: boolean | null;
  onBehalf?: { accessiblePatients?: Array<string> | null } | null;
};

export type ReferenceRangeFragment = {
  id: string;
  code?: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null } | null;
  identifier?: Array<{ value?: string | null } | null> | null;
  fromTemplate?: { reference?: string | null } | null;
  component?: Array<{
    code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
    valueQuantity?: { unit?: string | null; value?: number | null } | null;
    referenceRange?: Array<{
      text?: string | null;
      low?: { unit?: string | null; value?: number | null } | null;
      high?: { unit?: string | null; value?: number | null } | null;
      type?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type PatientForSharedAlarmsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientForSharedAlarmsQuery = {
  patient?: {
    id: string;
    shareAlarmWith?: Array<{
      id: string;
      name?: string | null;
      norwegianId?: string | null;
      isPrimary?: boolean | null;
    }> | null;
  } | null;
};

export type GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetSharedSkyResponseAlarmsPatientCandidatesQuery = {
  getSharedSkyResponseAlarmsPatientCandidates: Array<{
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    externalPatientIds?: Array<{ type: string; id: string }> | null;
  } | null>;
};

export type GetPatientForSimpleViewQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientForSimpleViewQuery = {
  getPatientWithAllDevicesAndAlarms: {
    patientGroups: Array<string>;
    patient: {
      id: string;
      active: boolean;
      birthDate?: any | null;
      addressNote?: string | null;
      keyCode?: string | null;
      note?: string | null;
      areCamerasEnabled: boolean;
      camerasDisabledAt?: any | null;
      camerasStateOrigin?: CameraStateOrigin | null;
      responderIsPresent?: boolean | null;
      camerasReactivateAt?: any | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
      photo?: Array<{ url?: string | null } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    };
    cameras: Array<{
      identifier: string;
      name: string;
      privacyMode?: boolean | null;
      privacyModeUntil?: any | null;
      availableHours?: string | null;
      online?: boolean | null;
      deviceGroup?: {
        id: string;
        name?: string | null;
        enableFurnitureDetection?: boolean | null;
        furnitureDetectionPeriodSec?: number | null;
      } | null;
      cameraProfile?: {
        id: string;
        name: string;
        template?: CameraProfileTemplate | null;
        origin: CameraProfileOrigin;
        streamAnonymizationMode: StreamAnonymizationMode;
        streamAnonymizationStrategy?: StreamAnonymizationStrategy | null;
        enableSnapshots: boolean;
        enableSnapshotAnonymization?: boolean | null;
        continuousSupervision: boolean;
        enableSoundMonitoring: boolean;
        soundMonitoringDefaultThreshold: number;
        streamTTL?: number | null;
        allowUnplannedSupervision: boolean;
        enableExtendingCameraAvailability: boolean;
      } | null;
    }>;
  };
};

export type GetAllPatientAlarmsForSimpleViewQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllPatientAlarmsForSimpleViewQuery = {
  getAllPatientAlarmsForPatient: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn?: any | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    subTasks?: Array<{ id: string } | null> | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type PatientGroupsForPatientIdsQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PatientGroupsForPatientIdsQuery = {
  patientGroupsForPatientIds: Array<{ patientId: string; userGroups: Array<{ id: string; name: string }> }>;
};

export type GetPushNotificationLogQueryVariables = Exact<{
  input: PushNotificationLogInput;
}>;

export type GetPushNotificationLogQuery = {
  getPushNotificationLog: Array<{
    id: string;
    username?: string | null;
    deviceName?: string | null;
    logType: PushNotificationLogEntryType;
    pushNotificationType?: PushNotificationType | null;
    triggeredAt: any;
    ackedAt?: any | null;
    confirmedAt?: any | null;
    meta?: string | null;
    event?: { id: string; patientId?: string | null } | null;
    shiftSession?: { id: string; userId?: string | null } | null;
  }>;
};

export type PatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientQuery = {
  patient?: {
    id: string;
    active: boolean;
    patientGroups?: Array<{ name: string; id: string } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      configuration?: { registeredInInventory?: boolean | null } | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
      } | null;
    } | null> | null;
    journalConfigForPatient?: { remoteSupervision: { enabled: boolean } } | null;
  } | null;
};

export type RetryAlarmJournalingMutationVariables = Exact<{
  alarmId: Scalars['ID']['input'];
}>;

export type RetryAlarmJournalingMutation = { retryAlarmJournaling: { success: boolean; message?: string | null } };

export type AvailableColleaguesForShiftQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableColleaguesForShiftQuery = {
  availableColleaguesForShift: Array<{ userId: string; name?: string | null; shiftSessionPhoneNumber?: string | null }>;
};

export type ShiftSessionForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ShiftSessionForUserQuery = {
  shiftSessionForUser?: {
    createdAt: any;
    lastUpdated: any;
    active: boolean;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string; createdAt: any }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      mobileNumber?: string | null;
      shiftSessionPhoneNumber?: string | null;
      email?: string | null;
      locale?: string | null;
      name?: string | null;
      username?: string | null;
      userId?: string | null;
    };
    history: Array<{ id: string; createdAt: any; endedAt?: any | null }>;
  } | null;
};

export type GetSupervisionCarePlanQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetSupervisionCarePlanQuery = {
  getSupervisionCarePlan?: Array<{
    alarmActivity: {
      id: string;
      description?: string | null;
      alarmIcon?: string | null;
      identifier: Array<{ value?: string | null } | null>;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null> | null;
      code: { coding?: Array<{ display?: string | null; code?: any | null } | null> | null };
    };
    scheduledTiming: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null };
  } | null> | null;
};

export type GetAlarmTemplatesForCameraSupervisionQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForCameraSupervisionQuery = {
  getAlarmTemplates: Array<{
    id: string;
    status: string;
    alarmIcon?: string | null;
    description?: string | null;
    identifier: Array<{ value?: string | null } | null>;
    code: { coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null };
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
  }>;
};

export type GetAllCompletionOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllCompletionOptionsQuery = {
  getAllCompletionOptions: Array<{
    id: string;
    text: string;
    templates?: Array<{
      id: string;
      code: string;
      title: string;
      system: string;
      displayText?: string | null;
      icon?: string | null;
    } | null> | null;
  }>;
};

export type CreateCompletionOptionMutationVariables = Exact<{
  text: Scalars['String']['input'];
}>;

export type CreateCompletionOptionMutation = {
  createCompletionOption: {
    success: boolean;
    message?: string | null;
    alarmCompletionOption?: {
      id: string;
      text: string;
      templates?: Array<{
        id: string;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      } | null> | null;
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateCompletionOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type UpdateCompletionOptionMutation = {
  updateCompletionOption: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteCompletionOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteCompletionOptionMutation = { deleteCompletionOption: boolean };

export type AttachCompletionOptionToAlarmTemplateMutationVariables = Exact<{
  alarmTemplateId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  completionOptionId: Scalars['ID']['input'];
}>;

export type AttachCompletionOptionToAlarmTemplateMutation = { attachCompletionOptionToAlarmTemplate: boolean };

export type RemoveCompletionOptionFromAlarmTemplateMutationVariables = Exact<{
  alarmTemplateId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  completionOptionId: Scalars['ID']['input'];
}>;

export type RemoveCompletionOptionFromAlarmTemplateMutation = { removeCompletionOptionFromAlarmTemplate: boolean };

export type GetAvailableDevicesInSafemateProQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableDevicesInSafemateProQuery = {
  getAvailableDevicesInSafematePro: {
    hasSafemateIntegration: boolean;
    safemateDevices: Array<{
      serial?: string | null;
      name?: string | null;
      status?: number | null;
      lastMessageFromDevice?: any | null;
      customerName?: string | null;
      isInRegistry: boolean;
      isInWrongHealthProvider: boolean;
      healthProviderName?: string | null;
    }>;
  };
};

export type PatientWithCamerasQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithCamerasQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      configuration?: { hasExternalUrl?: boolean | null; registeredInInventory?: boolean | null } | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      userHasAccessToPatient?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
        privacyModeUntil?: any | null;
      } | null;
      deviceGroup?: { name?: string | null; id: string } | null;
      patientReference?: { reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type PatientWithWelfareDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithWelfareDevicesQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      tags?: Array<string> | null;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      deviceGroup?: { name?: string | null; id: string } | null;
      deviceName?: Array<{ name?: string | null }> | null;
      configuration?: { hasExternalUrl?: boolean | null; registeredInInventory?: boolean | null } | null;
      status?: { lastSeen?: any | null; lastBatteryStatus?: number | null; lastBatteryTimestamp?: any | null } | null;
    }> | null;
    skyresponseDetails?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
  } | null;
};

export type PatientListQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  features?: InputMaybe<PatientListFeatures>;
}>;

export type PatientListQuery = {
  patientList: Array<{
    id: string;
    createdAt: any;
    tags?: Array<string> | null;
    openSyncAlarmId?: string | null;
    active: boolean;
    firstName?: string | null;
    lastName?: string | null;
    patientGroupNames: Array<string>;
    location?: string | null;
    secretAddress: boolean;
    rpmLastActive?: any | null;
    enabledServices: Array<string>;
    externalIds: Array<{ type: string; id: string }>;
    shareAlarmWithPatients?: Array<{ isPrimary: boolean; id: string; name?: string | null }> | null;
    devices: Array<{ name: string; type: string; deviceType?: string | null; isSharedDevice?: boolean | null }>;
    primaryAddress?: {
      addressLine?: string | null;
      postalCode?: string | null;
      city?: string | null;
      room?: string | null;
    } | null;
    cmpSensors: Array<{ day: any; modelName: string; modelValue: string; serialNumber: string }>;
  }>;
};

export type PatientsByActivityQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PatientsByActivityQuery = {
  patients: Array<{
    id: string;
    active: boolean;
    areCamerasEnabled: boolean;
    gender?: AdministrativeGender | null;
    birthDate?: any | null;
    addressNote?: string | null;
    keyCode?: string | null;
    tags?: Array<string | null> | null;
    hasSkyresponseSyncFailed?: boolean | null;
    externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    cameras?: Array<{
      modelName?: string | null;
      manufacturer?: string | null;
      id: string;
      name?: string | null;
    } | null> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }> | null;
  }>;
};

export type HealthProviderSettingsWithExternalHumanIdTypesQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsWithExternalHumanIdTypesQuery = {
  healthProviderSettings: { externalHumanIdTypes?: Array<{ id: string }> | null };
};

export type GetPatientByExternalIdQueryVariables = Exact<{
  externalPatientId: Scalars['String']['input'];
  externalHumanIdTypeId: Scalars['String']['input'];
}>;

export type GetPatientByExternalIdQuery = {
  getPatientByExternalId: {
    success?: boolean | null;
    found?: boolean | null;
    patient?: {
      id?: string | null;
      identityNumber?: string | null;
      active: boolean;
      enabledServices: Array<string>;
      gender?: AdministrativeGender | null;
      birthDate?: any | null;
      addressNote?: string | null;
      keyCode?: string | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      telecom: Array<{ system?: ContactPointSystem | null; value?: string | null } | null>;
      address: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null>;
      patientGroups?: Array<{ id: string; name: string } | null> | null;
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type PatientNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNameQuery = {
  patient?: {
    id: string;
    active: boolean;
    areCamerasEnabled: boolean;
    camerasDisabledAt?: any | null;
    camerasReactivateAt?: any | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
  } | null;
};

export type GetAllAlarmEventsForPatientPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type GetAllAlarmEventsForPatientPaginatedQuery = {
  getAllAlarmEventsForPatientPaginated: {
    cursor?: any | null;
    events: Array<{
      effectiveDateTime?: any | null;
      id: string;
      status: string;
      payload?: string | null;
      hasPushNotifications?: boolean | null;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      handlingStatuses: Array<{
        handler: string;
        initiatedAt: any;
        attempts: Array<{
          startedAt: any;
          doneAt: any;
          status: string;
          handledBy?: Array<string> | null;
          payload?: string | null;
          rawResponse?: string | null;
          rawStatus?: string | null;
          details?: string | null;
        }>;
      }>;
      component?: Array<{ valueString?: string | null; code: { text?: string | null } } | null> | null;
    }>;
  };
};

export type GetAllAlarmEventsQueryVariables = Exact<{
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  eventCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetAllAlarmEventsQuery = {
  getAllAlarmEvents: Array<{
    effectiveDateTime?: any | null;
    id: string;
    status: string;
    code?: {
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null;
    handlingStatuses: Array<{
      handler: string;
      initiatedAt: any;
      attempts: Array<{
        startedAt: any;
        doneAt: any;
        status: string;
        handledBy?: Array<string> | null;
        payload?: string | null;
        rawResponse?: string | null;
        rawStatus?: string | null;
        details?: string | null;
      }>;
    }>;
    component?: Array<{ valueString?: string | null; code: { text?: string | null } } | null> | null;
  }>;
};

export const AdminHealthProviderFlowStatusFragmentDoc = gql`
  fragment AdminHealthProviderFlowStatus on FlowStatus {
    completed
    paused
    hasFailed
    numberOfSteps
    currentStep
    logs {
      attempts
      timestamp
      errorMessage
      localePath
      status
    }
    stepStatuses {
      name
      status
      attempts
      lastActivity
    }
  }
`;
export const DialoggUserCommonFieldsFragmentDoc = gql`
  fragment dialoggUserCommonFields on DialoggUser {
    username
    firstName
    lastName
    enabled
    lastActive
    email
  }
`;
export const MissedSubmissionDetailsFragmentDoc = gql`
  fragment missedSubmissionDetails on MissedSubmission {
    kind
    name
    scheduledFor
    reportedAt
    patientTask {
      reference
      display
    }
    carePlan {
      reference
      display
    }
  }
`;
export const TaskListTaskFragmentDoc = gql`
  fragment taskListTask on Task {
    id
    status
    priority
    authoredOn
    lastModified
    code {
      text
    }
    note {
      authorString
      time
      text
      authorReference {
        reference
        display
      }
    }
    owner {
      identifier {
        value
      }
      display
    }
    carePlan {
      title
    }
    patient {
      id
      name {
        text
      }
      identifier {
        value
      }
      birthDate
    }
  }
`;
export const EventConfigScheduleFieldsFragmentDoc = gql`
  fragment EventConfigScheduleFields on EventConfigSchedule {
    repeat {
      dayOfWeek
      timeOfDay
    }
  }
`;
export const CepConfigFieldsFragmentDoc = gql`
  fragment CepConfigFields on CepConfig {
    trigger
    cancelledBy
    after
  }
`;
export const TimedCepConfigFieldsFragmentDoc = gql`
  fragment TimedCepConfigFields on TimedCepConfig {
    alarmTimeWindow {
      checkTimeFrom
      checkTimeTo
      dayOfWeek
    }
    cancelledBy
    events
    mode
  }
`;
export const CompleteBoundingBoxFragmentDoc = gql`
  fragment completeBoundingBox on BoundingBox {
    topLeftX
    topLeftY
    bottomRightX
    bottomRightY
  }
`;
export const AccountProductApplicationsFragmentDoc = gql`
  fragment AccountProductApplications on Applications {
    supervision
    dhv
    rpm
  }
`;
export const AccountProductFeaturesFragmentDoc = gql`
  fragment AccountProductFeatures on AccountFeatures {
    continuousSupervision
    hasTrends
  }
`;
export const AccountSecurityFeaturesFragmentDoc = gql`
  fragment AccountSecurityFeatures on AccountFeatures {
    hasEntraIdSso
    hasEntraIdProvisioning
  }
`;
export const AccountUserAuthFragmentDoc = gql`
  fragment AccountUserAuth on AccountUserAuth {
    resetPasswordAllowed
    twoFactorAppRequired
    timeLimitedAccess
    ipRestriction
  }
`;
export const AccountDetailsFragmentDoc = gql`
  fragment AccountDetails on AccountSettings {
    name
    displayName
    defaultLocale
    timeZone
  }
`;
export const LandmarkVertexFragmentDoc = gql`
  fragment landmarkVertex on LandmarkVertex {
    x
    y
  }
`;
export const CameraZonesFragmentDoc = gql`
  fragment cameraZones on CameraZones {
    bed {
      ...landmarkVertex
    }
    doors {
      name
      vertices {
        ...landmarkVertex
      }
    }
    safeZones {
      name
      generated
      vertices {
        ...landmarkVertex
      }
    }
    exclusionZones {
      name
      vertices {
        ...landmarkVertex
      }
    }
  }
  ${LandmarkVertexFragmentDoc}
`;
export const CameraZonesResultFragmentDoc = gql`
  fragment cameraZonesResult on CameraZonesResult {
    success
    message
    errorCode
    retryable
    zones {
      ...cameraZones
    }
  }
  ${CameraZonesFragmentDoc}
`;
export const CameraDetectionSettingsFragmentDoc = gql`
  fragment cameraDetectionSettings on CameraDetectionSettings {
    events {
      event
      enabled
      available
      unavailableReason
    }
    underCameraAreaSafe
    fallSensitivity {
      mode
      available
      unavailableReason
    }
    safeZoneNoDataHold {
      minutes
      available
      unavailableReason
    }
  }
`;
export const CameraDetectionSettingsResultFragmentDoc = gql`
  fragment cameraDetectionSettingsResult on CameraDetectionSettingsResult {
    success
    message
    errorCode
    retryable
    detectionSettings {
      ...cameraDetectionSettings
    }
  }
  ${CameraDetectionSettingsFragmentDoc}
`;
export const CameraEffectiveSettingsFieldsFragmentDoc = gql`
  fragment CameraEffectiveSettingsFields on CameraEffectiveSettings {
    streamAnonymizationMode
    streamAnonymizationStrategy
    enableSnapshots
    snapshotAnonymization
    continuousSupervision
    streamTTL
    allowUnplannedSupervision
    enableSoundMonitoring
    soundThreshold
    enableExtendingCameraAvailability
  }
`;
export const CameraProfileSettingsFragmentDoc = gql`
  fragment CameraProfileSettings on CameraProfile {
    id
    name
    template
    origin
    streamAnonymizationMode
    streamAnonymizationStrategy
    enableSnapshots
    enableSnapshotAnonymization
    continuousSupervision
    enableSoundMonitoring
    soundMonitoringDefaultThreshold
    streamTTL
    allowUnplannedSupervision
    enableExtendingCameraAvailability
  }
`;
export const CameraProfileFieldsFragmentDoc = gql`
  fragment CameraProfileFields on CameraProfile {
    ...CameraProfileSettings
    isDefault
    cameraCount
  }
  ${CameraProfileSettingsFragmentDoc}
`;
export const SubGroupsFragmentDoc = gql`
  fragment subGroups on UserGroup {
    id
    name
    type
    parentId
    skyresponse {
      skyresponseAlarmHandlingRuleId
    }
  }
`;
export const RoleFragmentDoc = gql`
  fragment Role on Role {
    id
    roleDefinitionId
    display {
      key
      value
    }
  }
`;
export const PatientGroupFragmentDoc = gql`
  fragment PatientGroup on PatientGroup {
    id
    name
    patientsCount
    alarmRoutes {
      configName
      configType
      incomingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      outgoingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      idMappingStrategy
    }
  }
`;
export const SubTreeFragmentDoc = gql`
  fragment subTree on UserGroup {
    id
    name
    type
    rules
    parentId
    lexoRankIndex
    roles {
      basedOn
      protected
      ...Role
    }
    linkedPatientGroups {
      ...PatientGroup
    }
    patientGroups {
      ...PatientGroup
    }
    skyresponse {
      skyresponseAlarmHandlingRuleId
    }
    deviceGroups {
      id
      name
    }
  }
  ${RoleFragmentDoc}
  ${PatientGroupFragmentDoc}
`;
export const PatientGroupDynamicFragmentDoc = gql`
  fragment PatientGroupDynamic on PatientGroup {
    id
    name
    patientsCount @include(if: $includeMetadata)
    alarmRoutes @include(if: $includeAlarmRoutes) {
      configName
      configType
      incomingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      outgoingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      idMappingStrategy
    }
  }
`;
export const SubTreeDynamicFragmentDoc = gql`
  fragment subTreeDynamic on UserGroup {
    id
    name
    type
    parentId
    rules @include(if: $includeMetadata)
    lexoRankIndex @include(if: $includeMetadata)
    roles @include(if: $includeRoles) {
      basedOn
      protected
      ...Role
    }
    linkedPatientGroups @include(if: $includeLinkedPatientGroups) {
      ...PatientGroupDynamic
    }
    patientGroups @include(if: $includePatientGroups) {
      ...PatientGroupDynamic
    }
    skyresponse @include(if: $includePatientGroups) {
      skyresponseAlarmHandlingRuleId
    }
    deviceGroups @include(if: $includeDeviceGroups) {
      id
      name
    }
  }
  ${RoleFragmentDoc}
  ${PatientGroupDynamicFragmentDoc}
`;
export const ExternalPatientIdsFragmentDoc = gql`
  fragment externalPatientIds on ExternalHumanId {
    externalId
    externalHumanIdType {
      id
      use {
        patientUse {
          immutable
        }
      }
    }
  }
`;
export const AddressFragmentDoc = gql`
  fragment address on Address {
    line
    postalCode
    city
    country
    text
  }
`;
export const PatientGroupsFragmentDoc = gql`
  fragment patientGroups on PatientGroupLess {
    name
    id
  }
`;
export const NotificationFragmentDoc = gql`
  fragment notification on Notification {
    inactiveSeconds
    missedSubmissionSeconds
  }
`;
export const DocumentsFragmentDoc = gql`
  fragment documents on DocumentReference {
    id
    content {
      attachment {
        title
        contentType
        url
        size
        creation
      }
    }
    context {
      carePlan {
        id
        title
      }
    }
  }
`;
export const CarePlansFragmentDoc = gql`
  fragment carePlans on CarePlan {
    id
    status
    subject {
      reference
    }
    title
    description
    created
    period {
      start
      end
    }
    activity {
      detail {
        instantiatesCanonical
        questionnaires {
          title
        }
        status
        scheduledTiming {
          repeat {
            dayOfWeek
            timeOfDay
          }
        }
        scheduledPeriod {
          start
          end
        }
      }
    }
  }
`;
export const RpmMedicalDevicesFragmentDoc = gql`
  fragment rpmMedicalDevices on RpmMedicalDevice {
    id
    btAddress
    deviceGroup {
      id
      name
    }
    deviceName {
      name
      type
    }
    identifier {
      value
    }
    patient {
      reference
    }
    manufacturer
    modelName
    modelNumber
    sensorType
    serialNumber
    status
  }
`;
export const WelfareDevicesFragmentDoc = gql`
  fragment welfareDevices on WelfareDevice {
    id
    uniqueIdentifier
    modelNumber
    status {
      connected
      lastSeen
    }
    patient {
      reference
    }
  }
`;
export const DialoggUserFragmentDoc = gql`
  fragment dialoggUser on DialoggUser {
    username
    enabled
    onBehalf {
      accessiblePatients
    }
  }
`;
export const ReferenceRangeFragmentDoc = gql`
  fragment referenceRange on Observation {
    id
    code {
      text
      coding {
        code
        display
      }
    }
    identifier {
      value
    }
    fromTemplate {
      reference
    }
    component {
      code {
        text
        coding {
          code
          display
        }
      }
      valueQuantity {
        unit
        value
      }
      referenceRange {
        low {
          unit
          value
        }
        high {
          unit
          value
        }
        text
        type {
          text
          coding {
            code
            display
          }
        }
      }
    }
  }
`;
export const GetSkyresponseOrganizationNotesDocument = gql`
  query getSkyresponseOrganizationNotes {
    getSkyresponseOrganizationNotes {
      id
      alarmHandlingId
      organizationNote
    }
  }
`;

/**
 * __useGetSkyresponseOrganizationNotesQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseOrganizationNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseOrganizationNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseOrganizationNotesQuery();
 */
export function useGetSkyresponseOrganizationNotesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseOrganizationNotesQuery,
        GetSkyresponseOrganizationNotesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseOrganizationNotesQuery,
          GetSkyresponseOrganizationNotesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseOrganizationNotesQuery,
          GetSkyresponseOrganizationNotesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSkyresponseOrganizationNotesQuery,
    GetSkyresponseOrganizationNotesQueryVariables
  >(GetSkyresponseOrganizationNotesDocument, {}, options);
}
export function useGetSkyresponseOrganizationNotesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseOrganizationNotesQuery,
        GetSkyresponseOrganizationNotesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseOrganizationNotesQuery,
          GetSkyresponseOrganizationNotesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseOrganizationNotesQuery,
          GetSkyresponseOrganizationNotesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSkyresponseOrganizationNotesQuery,
    GetSkyresponseOrganizationNotesQueryVariables
  >(GetSkyresponseOrganizationNotesDocument, {}, options);
}
export type GetSkyresponseOrganizationNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseOrganizationNotesQuery,
  GetSkyresponseOrganizationNotesQueryVariables
>;
export const CreateSkyresponseOrganizationNoteDocument = gql`
  mutation createSkyresponseOrganizationNote($input: SkyresponseOrganizationNoteInput!) {
    createSkyresponseOrganizationNote(input: $input) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateSkyresponseOrganizationNoteMutation__
 *
 * To run a mutation, you first call `useCreateSkyresponseOrganizationNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkyresponseOrganizationNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSkyresponseOrganizationNoteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSkyresponseOrganizationNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateSkyresponseOrganizationNoteMutation,
        CreateSkyresponseOrganizationNoteMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateSkyresponseOrganizationNoteMutation,
          CreateSkyresponseOrganizationNoteMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateSkyresponseOrganizationNoteMutation,
    CreateSkyresponseOrganizationNoteMutationVariables
  >(CreateSkyresponseOrganizationNoteDocument, options);
}
export type CreateSkyresponseOrganizationNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSkyresponseOrganizationNoteMutation,
  CreateSkyresponseOrganizationNoteMutationVariables
>;
export const UpdateSkyresponseOrganizationNoteDocument = gql`
  mutation updateSkyresponseOrganizationNote($id: ID!, $input: SkyresponseOrganizationNoteInput!) {
    updateSkyresponseOrganizationNote(id: $id, input: $input) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateSkyresponseOrganizationNoteMutation__
 *
 * To run a mutation, you first call `useUpdateSkyresponseOrganizationNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkyresponseOrganizationNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSkyresponseOrganizationNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSkyresponseOrganizationNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateSkyresponseOrganizationNoteMutation,
        UpdateSkyresponseOrganizationNoteMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSkyresponseOrganizationNoteMutation,
          UpdateSkyresponseOrganizationNoteMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateSkyresponseOrganizationNoteMutation,
    UpdateSkyresponseOrganizationNoteMutationVariables
  >(UpdateSkyresponseOrganizationNoteDocument, options);
}
export type UpdateSkyresponseOrganizationNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSkyresponseOrganizationNoteMutation,
  UpdateSkyresponseOrganizationNoteMutationVariables
>;
export const DeleteSkyresponseOrganizationNoteDocument = gql`
  mutation deleteSkyresponseOrganizationNote($id: ID!) {
    deleteSkyresponseOrganizationNote(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteSkyresponseOrganizationNoteMutation__
 *
 * To run a mutation, you first call `useDeleteSkyresponseOrganizationNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkyresponseOrganizationNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSkyresponseOrganizationNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSkyresponseOrganizationNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteSkyresponseOrganizationNoteMutation,
        DeleteSkyresponseOrganizationNoteMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteSkyresponseOrganizationNoteMutation,
          DeleteSkyresponseOrganizationNoteMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteSkyresponseOrganizationNoteMutation,
    DeleteSkyresponseOrganizationNoteMutationVariables
  >(DeleteSkyresponseOrganizationNoteDocument, options);
}
export type DeleteSkyresponseOrganizationNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteSkyresponseOrganizationNoteMutation,
  DeleteSkyresponseOrganizationNoteMutationVariables
>;
export const AddExternalIdentityProviderToHealthProviderDocument = gql`
  mutation AddExternalIdentityProviderToHealthProvider(
    $input: ExternalIdentityProviderForHealthProviderCreateInput!
    $healthProviderName: ID!
  ) {
    addExternalIdentityProviderToHealthProvider(input: $input, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddExternalIdentityProviderToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddExternalIdentityProviderToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalIdentityProviderToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalIdentityProviderToHealthProviderMutation({
 *   variables: {
 *     input: // value for 'input'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddExternalIdentityProviderToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalIdentityProviderToHealthProviderMutation,
        AddExternalIdentityProviderToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalIdentityProviderToHealthProviderMutation,
          AddExternalIdentityProviderToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddExternalIdentityProviderToHealthProviderMutation,
    AddExternalIdentityProviderToHealthProviderMutationVariables
  >(AddExternalIdentityProviderToHealthProviderDocument, options);
}
export type AddExternalIdentityProviderToHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddExternalIdentityProviderToHealthProviderMutation,
    AddExternalIdentityProviderToHealthProviderMutationVariables
  >;
export const CreateHealthProviderDocument = gql`
  mutation createHealthProvider($healthProvider: HealthProviderInput!) {
    createHealthProvider(healthProvider: $healthProvider) {
      success
      message
    }
  }
`;

/**
 * __useCreateHealthProviderMutation__
 *
 * To run a mutation, you first call `useCreateHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHealthProviderMutation({
 *   variables: {
 *     healthProvider: // value for 'healthProvider'
 *   },
 * });
 */
export function useCreateHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateHealthProviderMutation, CreateHealthProviderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateHealthProviderMutation, CreateHealthProviderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateHealthProviderMutation, CreateHealthProviderMutationVariables>(
    CreateHealthProviderDocument,
    options,
  );
}
export type CreateHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateHealthProviderMutation,
  CreateHealthProviderMutationVariables
>;
export const AddAccountToCustomerDocument = gql`
  mutation addAccountToCustomer($customerId: ID!, $healthProviderId: ID!) {
    addAccountToCustomer(customerId: $customerId, healthProviderId: $healthProviderId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      customer {
        id
        name
        reference
        type
        accounts
      }
    }
  }
`;

/**
 * __useAddAccountToCustomerMutation__
 *
 * To run a mutation, you first call `useAddAccountToCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountToCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddAccountToCustomerMutation({
 *   variables: {
 *     customerId: // value for 'customerId'
 *     healthProviderId: // value for 'healthProviderId'
 *   },
 * });
 */
export function useAddAccountToCustomerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddAccountToCustomerMutation, AddAccountToCustomerMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddAccountToCustomerMutation, AddAccountToCustomerMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddAccountToCustomerMutation, AddAccountToCustomerMutationVariables>(
    AddAccountToCustomerDocument,
    options,
  );
}
export type AddAccountToCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddAccountToCustomerMutation,
  AddAccountToCustomerMutationVariables
>;
export const RemoveAccountFromCustomerDocument = gql`
  mutation removeAccountFromCustomer($customerId: ID!, $healthProviderId: ID!) {
    removeAccountFromCustomer(customerId: $customerId, healthProviderId: $healthProviderId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      customer {
        id
        name
        reference
        type
        accounts
      }
    }
  }
`;

/**
 * __useRemoveAccountFromCustomerMutation__
 *
 * To run a mutation, you first call `useRemoveAccountFromCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccountFromCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveAccountFromCustomerMutation({
 *   variables: {
 *     customerId: // value for 'customerId'
 *     healthProviderId: // value for 'healthProviderId'
 *   },
 * });
 */
export function useRemoveAccountFromCustomerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveAccountFromCustomerMutation,
        RemoveAccountFromCustomerMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveAccountFromCustomerMutation,
          RemoveAccountFromCustomerMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveAccountFromCustomerMutation, RemoveAccountFromCustomerMutationVariables>(
    RemoveAccountFromCustomerDocument,
    options,
  );
}
export type RemoveAccountFromCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveAccountFromCustomerMutation,
  RemoveAccountFromCustomerMutationVariables
>;
export const CreateCustomerDocument = gql`
  mutation createCustomer($customer: CustomerInput!) {
    createCustomer(customer: $customer) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      customer {
        id
        name
        reference
        type
        accounts
      }
    }
  }
`;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCustomerMutation({
 *   variables: {
 *     customer: // value for 'customer'
 *   },
 * });
 */
export function useCreateCustomerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(
    CreateCustomerDocument,
    options,
  );
}
export type CreateCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;
export const UpdateCustomerDocument = gql`
  mutation updateCustomer($customerId: ID!, $customer: CustomerUpdateInput!) {
    updateCustomer(customerId: $customerId, customer: $customer) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      customer {
        id
        name
        reference
        type
        accounts
      }
    }
  }
`;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCustomerMutation({
 *   variables: {
 *     customerId: // value for 'customerId'
 *     customer: // value for 'customer'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(
    UpdateCustomerDocument,
    options,
  );
}
export type UpdateCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export const DeleteCustomerDocument = gql`
  mutation deleteCustomer($customerId: ID!) {
    deleteCustomer(customerId: $customerId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCustomerMutation({
 *   variables: {
 *     customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDeleteCustomerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(
    DeleteCustomerDocument,
    options,
  );
}
export type DeleteCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCustomerMutation,
  DeleteCustomerMutationVariables
>;
export const DeleteExternalAccessDocument = gql`
  mutation deleteExternalAccess($healthProviderName: String!, $id: ID!) {
    deleteExternalAccess(healthProviderName: $healthProviderName, id: $id)
  }
`;

/**
 * __useDeleteExternalAccessMutation__
 *
 * To run a mutation, you first call `useDeleteExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExternalAccessMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteExternalAccessMutation, DeleteExternalAccessMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteExternalAccessMutation, DeleteExternalAccessMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteExternalAccessMutation, DeleteExternalAccessMutationVariables>(
    DeleteExternalAccessDocument,
    options,
  );
}
export type DeleteExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteExternalAccessMutation,
  DeleteExternalAccessMutationVariables
>;
export const ResetSecretForExternalAccessDocument = gql`
  mutation resetSecretForExternalAccess($healthProviderName: String!, $id: String!) {
    resetSecretForExternalAccess(healthProviderName: $healthProviderName, id: $id) {
      id
      message
      success
      secret
    }
  }
`;

/**
 * __useResetSecretForExternalAccessMutation__
 *
 * To run a mutation, you first call `useResetSecretForExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetSecretForExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetSecretForExternalAccessMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResetSecretForExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetSecretForExternalAccessMutation,
        ResetSecretForExternalAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetSecretForExternalAccessMutation,
          ResetSecretForExternalAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetSecretForExternalAccessMutation,
    ResetSecretForExternalAccessMutationVariables
  >(ResetSecretForExternalAccessDocument, options);
}
export type ResetSecretForExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetSecretForExternalAccessMutation,
  ResetSecretForExternalAccessMutationVariables
>;
export const InitializeExternalAccessDocument = gql`
  mutation initializeExternalAccess($healthProviderName: String!, $input: CreateExternalAccessInput!) {
    initializeExternalAccess(healthProviderName: $healthProviderName, input: $input) {
      id
      message
      secret
      success
    }
  }
`;

/**
 * __useInitializeExternalAccessMutation__
 *
 * To run a mutation, you first call `useInitializeExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitializeExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitializeExternalAccessMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useInitializeExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        InitializeExternalAccessMutation,
        InitializeExternalAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          InitializeExternalAccessMutation,
          InitializeExternalAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<InitializeExternalAccessMutation, InitializeExternalAccessMutationVariables>(
    InitializeExternalAccessDocument,
    options,
  );
}
export type InitializeExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  InitializeExternalAccessMutation,
  InitializeExternalAccessMutationVariables
>;
export const UpdateNameOrIpRestrictionsForExternalAccessDocument = gql`
  mutation updateNameOrIpRestrictionsForExternalAccess(
    $healthProviderName: String!
    $input: UpdateNameOrIpRestrictionForExternalAccessInput!
  ) {
    updateNameOrIpRestrictionsForExternalAccess(healthProviderName: $healthProviderName, input: $input) {
      id
      message
      success
    }
  }
`;

/**
 * __useUpdateNameOrIpRestrictionsForExternalAccessMutation__
 *
 * To run a mutation, you first call `useUpdateNameOrIpRestrictionsForExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameOrIpRestrictionsForExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNameOrIpRestrictionsForExternalAccessMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNameOrIpRestrictionsForExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateNameOrIpRestrictionsForExternalAccessMutation,
        UpdateNameOrIpRestrictionsForExternalAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateNameOrIpRestrictionsForExternalAccessMutation,
          UpdateNameOrIpRestrictionsForExternalAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateNameOrIpRestrictionsForExternalAccessMutation,
    UpdateNameOrIpRestrictionsForExternalAccessMutationVariables
  >(UpdateNameOrIpRestrictionsForExternalAccessDocument, options);
}
export type UpdateNameOrIpRestrictionsForExternalAccessMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateNameOrIpRestrictionsForExternalAccessMutation,
    UpdateNameOrIpRestrictionsForExternalAccessMutationVariables
  >;
export const UpdateExternalIdentityProviderForHealthProviderDocument = gql`
  mutation updateExternalIdentityProviderForHealthProvider(
    $input: ExternalIdentityProviderForHealthProviderUpdateInput!
    $healthProviderName: ID!
  ) {
    updateExternalIdentityProviderForHealthProvider(input: $input, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useUpdateExternalIdentityProviderForHealthProviderMutation__
 *
 * To run a mutation, you first call `useUpdateExternalIdentityProviderForHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalIdentityProviderForHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateExternalIdentityProviderForHealthProviderMutation({
 *   variables: {
 *     input: // value for 'input'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useUpdateExternalIdentityProviderForHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateExternalIdentityProviderForHealthProviderMutation,
        UpdateExternalIdentityProviderForHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateExternalIdentityProviderForHealthProviderMutation,
          UpdateExternalIdentityProviderForHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateExternalIdentityProviderForHealthProviderMutation,
    UpdateExternalIdentityProviderForHealthProviderMutationVariables
  >(UpdateExternalIdentityProviderForHealthProviderDocument, options);
}
export type UpdateExternalIdentityProviderForHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateExternalIdentityProviderForHealthProviderMutation,
    UpdateExternalIdentityProviderForHealthProviderMutationVariables
  >;
export const DeleteExternalIdentityProviderFromHealthProviderDocument = gql`
  mutation deleteExternalIdentityProviderFromHealthProvider($healthProviderName: ID!, $id: ID!) {
    deleteExternalIdentityProviderFromHealthProvider(healthProviderName: $healthProviderName, id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteExternalIdentityProviderFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteExternalIdentityProviderFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalIdentityProviderFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExternalIdentityProviderFromHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalIdentityProviderFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteExternalIdentityProviderFromHealthProviderMutation,
        DeleteExternalIdentityProviderFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteExternalIdentityProviderFromHealthProviderMutation,
          DeleteExternalIdentityProviderFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteExternalIdentityProviderFromHealthProviderMutation,
    DeleteExternalIdentityProviderFromHealthProviderMutationVariables
  >(DeleteExternalIdentityProviderFromHealthProviderDocument, options);
}
export type DeleteExternalIdentityProviderFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteExternalIdentityProviderFromHealthProviderMutation,
    DeleteExternalIdentityProviderFromHealthProviderMutationVariables
  >;
export const DeleteExternalIdentityProviderRedirectorFromHealthProviderDocument = gql`
  mutation deleteExternalIdentityProviderRedirectorFromHealthProvider(
    $realmName: String!
    $isPatientRealm: Boolean!
    $redirectorId: String!
  ) {
    deleteExternalIdentityProviderRedirectorFromHealthProvider(
      realmName: $realmName
      isPatientRealm: $isPatientRealm
      redirectorId: $redirectorId
    ) {
      success
    }
  }
`;

/**
 * __useDeleteExternalIdentityProviderRedirectorFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteExternalIdentityProviderRedirectorFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalIdentityProviderRedirectorFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExternalIdentityProviderRedirectorFromHealthProviderMutation({
 *   variables: {
 *     realmName: // value for 'realmName'
 *     isPatientRealm: // value for 'isPatientRealm'
 *     redirectorId: // value for 'redirectorId'
 *   },
 * });
 */
export function useDeleteExternalIdentityProviderRedirectorFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteExternalIdentityProviderRedirectorFromHealthProviderMutation,
        DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteExternalIdentityProviderRedirectorFromHealthProviderMutation,
          DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteExternalIdentityProviderRedirectorFromHealthProviderMutation,
    DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
  >(DeleteExternalIdentityProviderRedirectorFromHealthProviderDocument, options);
}
export type DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteExternalIdentityProviderRedirectorFromHealthProviderMutation,
    DeleteExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
  >;
export const SetExternalIdentityProviderRedirectorFromHealthProviderDocument = gql`
  mutation setExternalIdentityProviderRedirectorFromHealthProvider(
    $realmName: String!
    $isPatientRealm: Boolean!
    $alias: String!
  ) {
    setExternalIdentityProviderRedirectorFromHealthProvider(
      realmName: $realmName
      isPatientRealm: $isPatientRealm
      alias: $alias
    ) {
      success
    }
  }
`;

/**
 * __useSetExternalIdentityProviderRedirectorFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useSetExternalIdentityProviderRedirectorFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdentityProviderRedirectorFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdentityProviderRedirectorFromHealthProviderMutation({
 *   variables: {
 *     realmName: // value for 'realmName'
 *     isPatientRealm: // value for 'isPatientRealm'
 *     alias: // value for 'alias'
 *   },
 * });
 */
export function useSetExternalIdentityProviderRedirectorFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetExternalIdentityProviderRedirectorFromHealthProviderMutation,
        SetExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetExternalIdentityProviderRedirectorFromHealthProviderMutation,
          SetExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetExternalIdentityProviderRedirectorFromHealthProviderMutation,
    SetExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
  >(SetExternalIdentityProviderRedirectorFromHealthProviderDocument, options);
}
export type SetExternalIdentityProviderRedirectorFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SetExternalIdentityProviderRedirectorFromHealthProviderMutation,
    SetExternalIdentityProviderRedirectorFromHealthProviderMutationVariables
  >;
export const ResetExternalIdentityProviderLinksForHealthProviderDocument = gql`
  mutation resetExternalIdentityProviderLinksForHealthProvider($healthProviderName: ID!, $id: ID!) {
    resetExternalIdentityProviderLinksForHealthProvider(healthProviderName: $healthProviderName, id: $id) {
      success
      message
    }
  }
`;

/**
 * __useResetExternalIdentityProviderLinksForHealthProviderMutation__
 *
 * To run a mutation, you first call `useResetExternalIdentityProviderLinksForHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetExternalIdentityProviderLinksForHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetExternalIdentityProviderLinksForHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResetExternalIdentityProviderLinksForHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetExternalIdentityProviderLinksForHealthProviderMutation,
        ResetExternalIdentityProviderLinksForHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetExternalIdentityProviderLinksForHealthProviderMutation,
          ResetExternalIdentityProviderLinksForHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetExternalIdentityProviderLinksForHealthProviderMutation,
    ResetExternalIdentityProviderLinksForHealthProviderMutationVariables
  >(ResetExternalIdentityProviderLinksForHealthProviderDocument, options);
}
export type ResetExternalIdentityProviderLinksForHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ResetExternalIdentityProviderLinksForHealthProviderMutation,
    ResetExternalIdentityProviderLinksForHealthProviderMutationVariables
  >;
export const CreateGooglemapsAccountDocument = gql`
  mutation createGooglemapsAccount($input: GooglemapsAccountCreateInput!) {
    createGooglemapsAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateGooglemapsAccountMutation__
 *
 * To run a mutation, you first call `useCreateGooglemapsAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGooglemapsAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGooglemapsAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGooglemapsAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateGooglemapsAccountMutation, CreateGooglemapsAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateGooglemapsAccountMutation,
          CreateGooglemapsAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateGooglemapsAccountMutation, CreateGooglemapsAccountMutationVariables>(
    CreateGooglemapsAccountDocument,
    options,
  );
}
export type CreateGooglemapsAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateGooglemapsAccountMutation,
  CreateGooglemapsAccountMutationVariables
>;
export const UpdateGooglemapsAccountDocument = gql`
  mutation updateGooglemapsAccount($id: ID!, $input: GooglemapsAccountUpdateInput!) {
    updateGooglemapsAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateGooglemapsAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGooglemapsAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGooglemapsAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGooglemapsAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGooglemapsAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateGooglemapsAccountMutation, UpdateGooglemapsAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateGooglemapsAccountMutation,
          UpdateGooglemapsAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateGooglemapsAccountMutation, UpdateGooglemapsAccountMutationVariables>(
    UpdateGooglemapsAccountDocument,
    options,
  );
}
export type UpdateGooglemapsAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateGooglemapsAccountMutation,
  UpdateGooglemapsAccountMutationVariables
>;
export const DeleteGooglemapsAccountDocument = gql`
  mutation deleteGooglemapsAccount($id: ID!) {
    deleteGooglemapsAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteGooglemapsAccountMutation__
 *
 * To run a mutation, you first call `useDeleteGooglemapsAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGooglemapsAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGooglemapsAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGooglemapsAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteGooglemapsAccountMutation, DeleteGooglemapsAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteGooglemapsAccountMutation,
          DeleteGooglemapsAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteGooglemapsAccountMutation, DeleteGooglemapsAccountMutationVariables>(
    DeleteGooglemapsAccountDocument,
    options,
  );
}
export type DeleteGooglemapsAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteGooglemapsAccountMutation,
  DeleteGooglemapsAccountMutationVariables
>;
export const UpdateHealthProviderDocument = gql`
  mutation updateHealthProvider($healthProviderName: ID!, $updateInput: HealthProviderUpdateInput!) {
    updateHealthProvider(healthProviderName: $healthProviderName, updateInput: $updateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateHealthProviderMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateHealthProviderMutation, UpdateHealthProviderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateHealthProviderMutation, UpdateHealthProviderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateHealthProviderMutation, UpdateHealthProviderMutationVariables>(
    UpdateHealthProviderDocument,
    options,
  );
}
export type UpdateHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateHealthProviderMutation,
  UpdateHealthProviderMutationVariables
>;
export const SupportTeamLinkToHealthProviderDocument = gql`
  mutation supportTeamLinkToHealthProvider($supportTeamName: ID!, $healthProviderName: String!) {
    supportTeamLinkToHealthProvider(supportTeamName: $supportTeamName, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useSupportTeamLinkToHealthProviderMutation__
 *
 * To run a mutation, you first call `useSupportTeamLinkToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamLinkToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSupportTeamLinkToHealthProviderMutation({
 *   variables: {
 *     supportTeamName: // value for 'supportTeamName'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useSupportTeamLinkToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SupportTeamLinkToHealthProviderMutation,
        SupportTeamLinkToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SupportTeamLinkToHealthProviderMutation,
          SupportTeamLinkToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SupportTeamLinkToHealthProviderMutation,
    SupportTeamLinkToHealthProviderMutationVariables
  >(SupportTeamLinkToHealthProviderDocument, options);
}
export type SupportTeamLinkToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SupportTeamLinkToHealthProviderMutation,
  SupportTeamLinkToHealthProviderMutationVariables
>;
export const SupportTeamUnlinkFromHealthProviderDocument = gql`
  mutation supportTeamUnlinkFromHealthProvider($supportTeamName: ID!, $healthProviderName: String!) {
    supportTeamUnlinkFromHealthProvider(supportTeamName: $supportTeamName, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useSupportTeamUnlinkFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useSupportTeamUnlinkFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamUnlinkFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSupportTeamUnlinkFromHealthProviderMutation({
 *   variables: {
 *     supportTeamName: // value for 'supportTeamName'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useSupportTeamUnlinkFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SupportTeamUnlinkFromHealthProviderMutation,
        SupportTeamUnlinkFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SupportTeamUnlinkFromHealthProviderMutation,
          SupportTeamUnlinkFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SupportTeamUnlinkFromHealthProviderMutation,
    SupportTeamUnlinkFromHealthProviderMutationVariables
  >(SupportTeamUnlinkFromHealthProviderDocument, options);
}
export type SupportTeamUnlinkFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SupportTeamUnlinkFromHealthProviderMutation,
    SupportTeamUnlinkFromHealthProviderMutationVariables
  >;
export const AddExternalHumanTypeToHealthProviderDocument = gql`
  mutation addExternalHumanTypeToHealthProvider($externalHumanTypeId: ID!, $healthProviderName: ID!) {
    addExternalHumanTypeToHealthProvider(
      externalHumanTypeId: $externalHumanTypeId
      healthProviderName: $healthProviderName
    )
  }
`;

/**
 * __useAddExternalHumanTypeToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddExternalHumanTypeToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalHumanTypeToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalHumanTypeToHealthProviderMutation({
 *   variables: {
 *     externalHumanTypeId: // value for 'externalHumanTypeId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddExternalHumanTypeToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalHumanTypeToHealthProviderMutation,
        AddExternalHumanTypeToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalHumanTypeToHealthProviderMutation,
          AddExternalHumanTypeToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddExternalHumanTypeToHealthProviderMutation,
    AddExternalHumanTypeToHealthProviderMutationVariables
  >(AddExternalHumanTypeToHealthProviderDocument, options);
}
export type AddExternalHumanTypeToHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddExternalHumanTypeToHealthProviderMutation,
    AddExternalHumanTypeToHealthProviderMutationVariables
  >;
export const RemoveExternalHumanTypeFromHealthProviderDocument = gql`
  mutation removeExternalHumanTypeFromHealthProvider($externalHumanTypeId: ID!, $healthProviderName: ID!) {
    removeExternalHumanTypeFromHealthProvider(
      externalHumanTypeId: $externalHumanTypeId
      healthProviderName: $healthProviderName
    )
  }
`;

/**
 * __useRemoveExternalHumanTypeFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveExternalHumanTypeFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalHumanTypeFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalHumanTypeFromHealthProviderMutation({
 *   variables: {
 *     externalHumanTypeId: // value for 'externalHumanTypeId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveExternalHumanTypeFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveExternalHumanTypeFromHealthProviderMutation,
        RemoveExternalHumanTypeFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveExternalHumanTypeFromHealthProviderMutation,
          RemoveExternalHumanTypeFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveExternalHumanTypeFromHealthProviderMutation,
    RemoveExternalHumanTypeFromHealthProviderMutationVariables
  >(RemoveExternalHumanTypeFromHealthProviderDocument, options);
}
export type RemoveExternalHumanTypeFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveExternalHumanTypeFromHealthProviderMutation,
    RemoveExternalHumanTypeFromHealthProviderMutationVariables
  >;
export const UpdateHealthProviderUserSessionLifespanDocument = gql`
  mutation updateHealthProviderUserSessionLifespan($healthProviderName: ID!, $lifespan: Int!) {
    updateHealthProviderUserSessionLifespan(healthProviderName: $healthProviderName, lifespan: $lifespan) {
      success
    }
  }
`;

/**
 * __useUpdateHealthProviderUserSessionLifespanMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderUserSessionLifespanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderUserSessionLifespanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderUserSessionLifespanMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     lifespan: // value for 'lifespan'
 *   },
 * });
 */
export function useUpdateHealthProviderUserSessionLifespanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateHealthProviderUserSessionLifespanMutation,
        UpdateHealthProviderUserSessionLifespanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateHealthProviderUserSessionLifespanMutation,
          UpdateHealthProviderUserSessionLifespanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateHealthProviderUserSessionLifespanMutation,
    UpdateHealthProviderUserSessionLifespanMutationVariables
  >(UpdateHealthProviderUserSessionLifespanDocument, options);
}
export type UpdateHealthProviderUserSessionLifespanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateHealthProviderUserSessionLifespanMutation,
    UpdateHealthProviderUserSessionLifespanMutationVariables
  >;
export const UpdateHealthProviderPatientSessionLifespanDocument = gql`
  mutation updateHealthProviderPatientSessionLifespan($healthProviderName: ID!, $lifespan: Int!) {
    updateHealthProviderPatientSessionLifespan(healthProviderName: $healthProviderName, lifespan: $lifespan) {
      success
    }
  }
`;

/**
 * __useUpdateHealthProviderPatientSessionLifespanMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderPatientSessionLifespanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderPatientSessionLifespanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderPatientSessionLifespanMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     lifespan: // value for 'lifespan'
 *   },
 * });
 */
export function useUpdateHealthProviderPatientSessionLifespanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateHealthProviderPatientSessionLifespanMutation,
        UpdateHealthProviderPatientSessionLifespanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateHealthProviderPatientSessionLifespanMutation,
          UpdateHealthProviderPatientSessionLifespanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateHealthProviderPatientSessionLifespanMutation,
    UpdateHealthProviderPatientSessionLifespanMutationVariables
  >(UpdateHealthProviderPatientSessionLifespanDocument, options);
}
export type UpdateHealthProviderPatientSessionLifespanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateHealthProviderPatientSessionLifespanMutation,
    UpdateHealthProviderPatientSessionLifespanMutationVariables
  >;
export const UpdateHealthProviderUserAuthDocument = gql`
  mutation updateHealthProviderUserAuth($healthProviderName: ID!, $input: AuthUpdateInput!) {
    updateHealthProviderUserAuth(healthProviderName: $healthProviderName, input: $input) {
      success
    }
  }
`;

/**
 * __useUpdateHealthProviderUserAuthMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderUserAuthMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderUserAuthMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderUserAuthMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHealthProviderUserAuthMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateHealthProviderUserAuthMutation,
        UpdateHealthProviderUserAuthMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateHealthProviderUserAuthMutation,
          UpdateHealthProviderUserAuthMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateHealthProviderUserAuthMutation,
    UpdateHealthProviderUserAuthMutationVariables
  >(UpdateHealthProviderUserAuthDocument, options);
}
export type UpdateHealthProviderUserAuthMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateHealthProviderUserAuthMutation,
  UpdateHealthProviderUserAuthMutationVariables
>;
export const UpdateHealthProviderPatientAuthDocument = gql`
  mutation updateHealthProviderPatientAuth($healthProviderName: ID!, $input: AuthUpdateInput!) {
    updateHealthProviderPatientAuth(healthProviderName: $healthProviderName, input: $input) {
      success
    }
  }
`;

/**
 * __useUpdateHealthProviderPatientAuthMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderPatientAuthMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderPatientAuthMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderPatientAuthMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHealthProviderPatientAuthMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateHealthProviderPatientAuthMutation,
        UpdateHealthProviderPatientAuthMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateHealthProviderPatientAuthMutation,
          UpdateHealthProviderPatientAuthMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateHealthProviderPatientAuthMutation,
    UpdateHealthProviderPatientAuthMutationVariables
  >(UpdateHealthProviderPatientAuthDocument, options);
}
export type UpdateHealthProviderPatientAuthMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateHealthProviderPatientAuthMutation,
  UpdateHealthProviderPatientAuthMutationVariables
>;
export const MarkHealthProviderForDeletionDocument = gql`
  mutation markHealthProviderForDeletion($healthProviderName: ID!) {
    markHealthProviderForDeletion(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useMarkHealthProviderForDeletionMutation__
 *
 * To run a mutation, you first call `useMarkHealthProviderForDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkHealthProviderForDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkHealthProviderForDeletionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useMarkHealthProviderForDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        MarkHealthProviderForDeletionMutation,
        MarkHealthProviderForDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          MarkHealthProviderForDeletionMutation,
          MarkHealthProviderForDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    MarkHealthProviderForDeletionMutation,
    MarkHealthProviderForDeletionMutationVariables
  >(MarkHealthProviderForDeletionDocument, options);
}
export type MarkHealthProviderForDeletionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkHealthProviderForDeletionMutation,
  MarkHealthProviderForDeletionMutationVariables
>;
export const RestoreHealthProviderMarkedForDeletionDocument = gql`
  mutation restoreHealthProviderMarkedForDeletion($healthProviderName: ID!) {
    restoreHealthProviderMarkedForDeletion(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useRestoreHealthProviderMarkedForDeletionMutation__
 *
 * To run a mutation, you first call `useRestoreHealthProviderMarkedForDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreHealthProviderMarkedForDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreHealthProviderMarkedForDeletionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRestoreHealthProviderMarkedForDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RestoreHealthProviderMarkedForDeletionMutation,
        RestoreHealthProviderMarkedForDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RestoreHealthProviderMarkedForDeletionMutation,
          RestoreHealthProviderMarkedForDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RestoreHealthProviderMarkedForDeletionMutation,
    RestoreHealthProviderMarkedForDeletionMutationVariables
  >(RestoreHealthProviderMarkedForDeletionDocument, options);
}
export type RestoreHealthProviderMarkedForDeletionMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RestoreHealthProviderMarkedForDeletionMutation,
    RestoreHealthProviderMarkedForDeletionMutationVariables
  >;
export const DeleteHealthProviderDocument = gql`
  mutation deleteHealthProvider($healthProviderName: ID!) {
    deleteHealthProvider(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDeleteHealthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDeleteHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteHealthProviderMutation, DeleteHealthProviderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteHealthProviderMutation, DeleteHealthProviderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteHealthProviderMutation, DeleteHealthProviderMutationVariables>(
    DeleteHealthProviderDocument,
    options,
  );
}
export type DeleteHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteHealthProviderMutation,
  DeleteHealthProviderMutationVariables
>;
export const DeleteInconsistentHealthProviderDocument = gql`
  mutation deleteInconsistentHealthProvider($report: InconsistentHealthProviderReportInput!) {
    deleteInconsistentHealthProvider(report: $report) {
      success
      message
    }
  }
`;

/**
 * __useDeleteInconsistentHealthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteInconsistentHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInconsistentHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteInconsistentHealthProviderMutation({
 *   variables: {
 *     report: // value for 'report'
 *   },
 * });
 */
export function useDeleteInconsistentHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteInconsistentHealthProviderMutation,
        DeleteInconsistentHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteInconsistentHealthProviderMutation,
          DeleteInconsistentHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteInconsistentHealthProviderMutation,
    DeleteInconsistentHealthProviderMutationVariables
  >(DeleteInconsistentHealthProviderDocument, options);
}
export type DeleteInconsistentHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteInconsistentHealthProviderMutation,
  DeleteInconsistentHealthProviderMutationVariables
>;
export const PauseHealthProviderDeletionDocument = gql`
  mutation pauseHealthProviderDeletion($healthProviderName: ID!) {
    pauseHealthProviderDeletion(healthProviderName: $healthProviderName)
  }
`;

/**
 * __usePauseHealthProviderDeletionMutation__
 *
 * To run a mutation, you first call `usePauseHealthProviderDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePauseHealthProviderDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePauseHealthProviderDeletionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function usePauseHealthProviderDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        PauseHealthProviderDeletionMutation,
        PauseHealthProviderDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          PauseHealthProviderDeletionMutation,
          PauseHealthProviderDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    PauseHealthProviderDeletionMutation,
    PauseHealthProviderDeletionMutationVariables
  >(PauseHealthProviderDeletionDocument, options);
}
export type PauseHealthProviderDeletionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PauseHealthProviderDeletionMutation,
  PauseHealthProviderDeletionMutationVariables
>;
export const ResumeHealthProviderDeletionDocument = gql`
  mutation resumeHealthProviderDeletion($healthProviderName: ID!) {
    resumeHealthProviderDeletion(healthProviderName: $healthProviderName)
  }
`;

/**
 * __useResumeHealthProviderDeletionMutation__
 *
 * To run a mutation, you first call `useResumeHealthProviderDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResumeHealthProviderDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResumeHealthProviderDeletionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useResumeHealthProviderDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResumeHealthProviderDeletionMutation,
        ResumeHealthProviderDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResumeHealthProviderDeletionMutation,
          ResumeHealthProviderDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResumeHealthProviderDeletionMutation,
    ResumeHealthProviderDeletionMutationVariables
  >(ResumeHealthProviderDeletionDocument, options);
}
export type ResumeHealthProviderDeletionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResumeHealthProviderDeletionMutation,
  ResumeHealthProviderDeletionMutationVariables
>;
export const ResetHealthProviderFlowDocument = gql`
  mutation resetHealthProviderFlow($healthProviderName: ID!, $flow: HealthProviderFlow!) {
    resetHealthProviderFlow(healthProviderName: $healthProviderName, flow: $flow) {
      success
      message
    }
  }
`;

/**
 * __useResetHealthProviderFlowMutation__
 *
 * To run a mutation, you first call `useResetHealthProviderFlowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetHealthProviderFlowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetHealthProviderFlowMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     flow: // value for 'flow'
 *   },
 * });
 */
export function useResetHealthProviderFlowMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ResetHealthProviderFlowMutation, ResetHealthProviderFlowMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetHealthProviderFlowMutation,
          ResetHealthProviderFlowMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ResetHealthProviderFlowMutation, ResetHealthProviderFlowMutationVariables>(
    ResetHealthProviderFlowDocument,
    options,
  );
}
export type ResetHealthProviderFlowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetHealthProviderFlowMutation,
  ResetHealthProviderFlowMutationVariables
>;
export const EnableContinuousSupervisionDocument = gql`
  mutation enableContinuousSupervision($healthProviderName: ID!) {
    enableContinuousSupervision(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableContinuousSupervisionMutation__
 *
 * To run a mutation, you first call `useEnableContinuousSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableContinuousSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableContinuousSupervisionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableContinuousSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableContinuousSupervisionMutation,
        EnableContinuousSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableContinuousSupervisionMutation,
          EnableContinuousSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    EnableContinuousSupervisionMutation,
    EnableContinuousSupervisionMutationVariables
  >(EnableContinuousSupervisionDocument, options);
}
export type EnableContinuousSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableContinuousSupervisionMutation,
  EnableContinuousSupervisionMutationVariables
>;
export const DisableContinuousSupervisionDocument = gql`
  mutation disableContinuousSupervision($healthProviderName: ID!) {
    disableContinuousSupervision(healthProviderName: $healthProviderName) {
      success
      message
      blockingCameraProfiles {
        id
        name
        template
      }
    }
  }
`;

/**
 * __useDisableContinuousSupervisionMutation__
 *
 * To run a mutation, you first call `useDisableContinuousSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableContinuousSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableContinuousSupervisionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableContinuousSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableContinuousSupervisionMutation,
        DisableContinuousSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableContinuousSupervisionMutation,
          DisableContinuousSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableContinuousSupervisionMutation,
    DisableContinuousSupervisionMutationVariables
  >(DisableContinuousSupervisionDocument, options);
}
export type DisableContinuousSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableContinuousSupervisionMutation,
  DisableContinuousSupervisionMutationVariables
>;
export const EnableJoinNhnMeetingDocument = gql`
  mutation enableJoinNhnMeeting($healthProviderName: ID!) {
    enableJoinNhnMeeting(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableJoinNhnMeetingMutation__
 *
 * To run a mutation, you first call `useEnableJoinNhnMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableJoinNhnMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableJoinNhnMeetingMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableJoinNhnMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableJoinNhnMeetingMutation, EnableJoinNhnMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableJoinNhnMeetingMutation, EnableJoinNhnMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableJoinNhnMeetingMutation, EnableJoinNhnMeetingMutationVariables>(
    EnableJoinNhnMeetingDocument,
    options,
  );
}
export type EnableJoinNhnMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableJoinNhnMeetingMutation,
  EnableJoinNhnMeetingMutationVariables
>;
export const DisableJoinNhnMeetingDocument = gql`
  mutation disableJoinNhnMeeting($healthProviderName: ID!) {
    disableJoinNhnMeeting(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableJoinNhnMeetingMutation__
 *
 * To run a mutation, you first call `useDisableJoinNhnMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableJoinNhnMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableJoinNhnMeetingMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableJoinNhnMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableJoinNhnMeetingMutation, DisableJoinNhnMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableJoinNhnMeetingMutation, DisableJoinNhnMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableJoinNhnMeetingMutation, DisableJoinNhnMeetingMutationVariables>(
    DisableJoinNhnMeetingDocument,
    options,
  );
}
export type DisableJoinNhnMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableJoinNhnMeetingMutation,
  DisableJoinNhnMeetingMutationVariables
>;
export const EnableSendNotificationToNextOfKinDocument = gql`
  mutation enableSendNotificationToNextOfKin($healthProviderName: ID!) {
    enableSendNotificationToNextOfKin(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableSendNotificationToNextOfKinMutation__
 *
 * To run a mutation, you first call `useEnableSendNotificationToNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableSendNotificationToNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableSendNotificationToNextOfKinMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableSendNotificationToNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableSendNotificationToNextOfKinMutation,
        EnableSendNotificationToNextOfKinMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableSendNotificationToNextOfKinMutation,
          EnableSendNotificationToNextOfKinMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    EnableSendNotificationToNextOfKinMutation,
    EnableSendNotificationToNextOfKinMutationVariables
  >(EnableSendNotificationToNextOfKinDocument, options);
}
export type EnableSendNotificationToNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableSendNotificationToNextOfKinMutation,
  EnableSendNotificationToNextOfKinMutationVariables
>;
export const DisableSendNotificationToNextOfKinDocument = gql`
  mutation disableSendNotificationToNextOfKin($healthProviderName: ID!) {
    disableSendNotificationToNextOfKin(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableSendNotificationToNextOfKinMutation__
 *
 * To run a mutation, you first call `useDisableSendNotificationToNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableSendNotificationToNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableSendNotificationToNextOfKinMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableSendNotificationToNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableSendNotificationToNextOfKinMutation,
        DisableSendNotificationToNextOfKinMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableSendNotificationToNextOfKinMutation,
          DisableSendNotificationToNextOfKinMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableSendNotificationToNextOfKinMutation,
    DisableSendNotificationToNextOfKinMutationVariables
  >(DisableSendNotificationToNextOfKinDocument, options);
}
export type DisableSendNotificationToNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableSendNotificationToNextOfKinMutation,
  DisableSendNotificationToNextOfKinMutationVariables
>;
export const EnableBetaDocument = gql`
  mutation enableBeta($healthProviderName: ID!) {
    enableBeta(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableBetaMutation__
 *
 * To run a mutation, you first call `useEnableBetaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableBetaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableBetaMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableBetaMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableBetaMutation, EnableBetaMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnableBetaMutation, EnableBetaMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<EnableBetaMutation, EnableBetaMutationVariables>(EnableBetaDocument, options);
}
export type EnableBetaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableBetaMutation,
  EnableBetaMutationVariables
>;
export const DisableBetaDocument = gql`
  mutation disableBeta($healthProviderName: ID!) {
    disableBeta(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableBetaMutation__
 *
 * To run a mutation, you first call `useDisableBetaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableBetaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableBetaMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableBetaMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableBetaMutation, DisableBetaMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisableBetaMutation, DisableBetaMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DisableBetaMutation, DisableBetaMutationVariables>(
    DisableBetaDocument,
    options,
  );
}
export type DisableBetaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableBetaMutation,
  DisableBetaMutationVariables
>;
export const EnableSelfTreatmentPlanDocument = gql`
  mutation enableSelfTreatmentPlan($healthProviderName: ID!) {
    enableSelfTreatmentPlan(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useEnableSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableSelfTreatmentPlanMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableSelfTreatmentPlanMutation, EnableSelfTreatmentPlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableSelfTreatmentPlanMutation,
          EnableSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableSelfTreatmentPlanMutation, EnableSelfTreatmentPlanMutationVariables>(
    EnableSelfTreatmentPlanDocument,
    options,
  );
}
export type EnableSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableSelfTreatmentPlanMutation,
  EnableSelfTreatmentPlanMutationVariables
>;
export const DisableSelfTreatmentPlanDocument = gql`
  mutation disableSelfTreatmentPlan($healthProviderName: ID!) {
    disableSelfTreatmentPlan(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useDisableSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableSelfTreatmentPlanMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableSelfTreatmentPlanMutation,
        DisableSelfTreatmentPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableSelfTreatmentPlanMutation,
          DisableSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableSelfTreatmentPlanMutation, DisableSelfTreatmentPlanMutationVariables>(
    DisableSelfTreatmentPlanDocument,
    options,
  );
}
export type DisableSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableSelfTreatmentPlanMutation,
  DisableSelfTreatmentPlanMutationVariables
>;
export const EnableDataAnalyticsDocument = gql`
  mutation enableDataAnalytics($healthProviderName: ID!) {
    enableDataAnalytics(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableDataAnalyticsMutation__
 *
 * To run a mutation, you first call `useEnableDataAnalyticsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableDataAnalyticsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableDataAnalyticsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableDataAnalyticsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableDataAnalyticsMutation, EnableDataAnalyticsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableDataAnalyticsMutation, EnableDataAnalyticsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableDataAnalyticsMutation, EnableDataAnalyticsMutationVariables>(
    EnableDataAnalyticsDocument,
    options,
  );
}
export type EnableDataAnalyticsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableDataAnalyticsMutation,
  EnableDataAnalyticsMutationVariables
>;
export const DisableDataAnalyticsDocument = gql`
  mutation disableDataAnalytics($healthProviderName: ID!) {
    disableDataAnalytics(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableDataAnalyticsMutation__
 *
 * To run a mutation, you first call `useDisableDataAnalyticsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableDataAnalyticsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableDataAnalyticsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableDataAnalyticsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableDataAnalyticsMutation, DisableDataAnalyticsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableDataAnalyticsMutation, DisableDataAnalyticsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableDataAnalyticsMutation, DisableDataAnalyticsMutationVariables>(
    DisableDataAnalyticsDocument,
    options,
  );
}
export type DisableDataAnalyticsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableDataAnalyticsMutation,
  DisableDataAnalyticsMutationVariables
>;
export const EnableTrendsDocument = gql`
  mutation enableTrends($healthProviderName: ID!) {
    enableTrends(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableTrendsMutation__
 *
 * To run a mutation, you first call `useEnableTrendsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableTrendsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableTrendsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableTrendsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableTrendsMutation, EnableTrendsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableTrendsMutation, EnableTrendsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableTrendsMutation, EnableTrendsMutationVariables>(
    EnableTrendsDocument,
    options,
  );
}
export type EnableTrendsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableTrendsMutation,
  EnableTrendsMutationVariables
>;
export const DisableTrendsDocument = gql`
  mutation disableTrends($healthProviderName: ID!) {
    disableTrends(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableTrendsMutation__
 *
 * To run a mutation, you first call `useDisableTrendsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableTrendsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableTrendsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableTrendsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableTrendsMutation, DisableTrendsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableTrendsMutation, DisableTrendsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableTrendsMutation, DisableTrendsMutationVariables>(
    DisableTrendsDocument,
    options,
  );
}
export type DisableTrendsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableTrendsMutation,
  DisableTrendsMutationVariables
>;
export const EnableNewSupervisionUserTabsDocument = gql`
  mutation enableNewSupervisionUserTabs($healthProviderName: ID!) {
    enableNewSupervisionUserTabs(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableNewSupervisionUserTabsMutation__
 *
 * To run a mutation, you first call `useEnableNewSupervisionUserTabsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableNewSupervisionUserTabsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableNewSupervisionUserTabsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableNewSupervisionUserTabsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableNewSupervisionUserTabsMutation,
        EnableNewSupervisionUserTabsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableNewSupervisionUserTabsMutation,
          EnableNewSupervisionUserTabsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    EnableNewSupervisionUserTabsMutation,
    EnableNewSupervisionUserTabsMutationVariables
  >(EnableNewSupervisionUserTabsDocument, options);
}
export type EnableNewSupervisionUserTabsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableNewSupervisionUserTabsMutation,
  EnableNewSupervisionUserTabsMutationVariables
>;
export const DisableNewSupervisionUserTabsDocument = gql`
  mutation disableNewSupervisionUserTabs($healthProviderName: ID!) {
    disableNewSupervisionUserTabs(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableNewSupervisionUserTabsMutation__
 *
 * To run a mutation, you first call `useDisableNewSupervisionUserTabsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableNewSupervisionUserTabsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableNewSupervisionUserTabsMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableNewSupervisionUserTabsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableNewSupervisionUserTabsMutation,
        DisableNewSupervisionUserTabsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableNewSupervisionUserTabsMutation,
          DisableNewSupervisionUserTabsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableNewSupervisionUserTabsMutation,
    DisableNewSupervisionUserTabsMutationVariables
  >(DisableNewSupervisionUserTabsDocument, options);
}
export type DisableNewSupervisionUserTabsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableNewSupervisionUserTabsMutation,
  DisableNewSupervisionUserTabsMutationVariables
>;
export const EnableFurnitureDetectionDocument = gql`
  mutation enableFurnitureDetection($healthProviderName: ID!) {
    enableFurnitureDetection(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableFurnitureDetectionMutation__
 *
 * To run a mutation, you first call `useEnableFurnitureDetectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableFurnitureDetectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableFurnitureDetectionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableFurnitureDetectionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableFurnitureDetectionMutation,
        EnableFurnitureDetectionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableFurnitureDetectionMutation,
          EnableFurnitureDetectionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableFurnitureDetectionMutation, EnableFurnitureDetectionMutationVariables>(
    EnableFurnitureDetectionDocument,
    options,
  );
}
export type EnableFurnitureDetectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableFurnitureDetectionMutation,
  EnableFurnitureDetectionMutationVariables
>;
export const DisableFurnitureDetectionDocument = gql`
  mutation disableFurnitureDetection($healthProviderName: ID!) {
    disableFurnitureDetection(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableFurnitureDetectionMutation__
 *
 * To run a mutation, you first call `useDisableFurnitureDetectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableFurnitureDetectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableFurnitureDetectionMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableFurnitureDetectionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableFurnitureDetectionMutation,
        DisableFurnitureDetectionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableFurnitureDetectionMutation,
          DisableFurnitureDetectionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableFurnitureDetectionMutation, DisableFurnitureDetectionMutationVariables>(
    DisableFurnitureDetectionDocument,
    options,
  );
}
export type DisableFurnitureDetectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableFurnitureDetectionMutation,
  DisableFurnitureDetectionMutationVariables
>;
export const EnableDemoAnonymizationDocument = gql`
  mutation enableDemoAnonymization($healthProviderName: ID!) {
    enableDemoAnonymization(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableDemoAnonymizationMutation__
 *
 * To run a mutation, you first call `useEnableDemoAnonymizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableDemoAnonymizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableDemoAnonymizationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableDemoAnonymizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableDemoAnonymizationMutation, EnableDemoAnonymizationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableDemoAnonymizationMutation,
          EnableDemoAnonymizationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableDemoAnonymizationMutation, EnableDemoAnonymizationMutationVariables>(
    EnableDemoAnonymizationDocument,
    options,
  );
}
export type EnableDemoAnonymizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableDemoAnonymizationMutation,
  EnableDemoAnonymizationMutationVariables
>;
export const DisableDemoAnonymizationDocument = gql`
  mutation disableDemoAnonymization($healthProviderName: ID!) {
    disableDemoAnonymization(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableDemoAnonymizationMutation__
 *
 * To run a mutation, you first call `useDisableDemoAnonymizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableDemoAnonymizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableDemoAnonymizationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableDemoAnonymizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableDemoAnonymizationMutation,
        DisableDemoAnonymizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableDemoAnonymizationMutation,
          DisableDemoAnonymizationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableDemoAnonymizationMutation, DisableDemoAnonymizationMutationVariables>(
    DisableDemoAnonymizationDocument,
    options,
  );
}
export type DisableDemoAnonymizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableDemoAnonymizationMutation,
  DisableDemoAnonymizationMutationVariables
>;
export const EnableEntraIdSsoDocument = gql`
  mutation enableEntraIdSso($healthProviderName: ID!) {
    enableEntraIdSso(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableEntraIdSsoMutation__
 *
 * To run a mutation, you first call `useEnableEntraIdSsoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableEntraIdSsoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableEntraIdSsoMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableEntraIdSsoMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableEntraIdSsoMutation, EnableEntraIdSsoMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableEntraIdSsoMutation, EnableEntraIdSsoMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableEntraIdSsoMutation, EnableEntraIdSsoMutationVariables>(
    EnableEntraIdSsoDocument,
    options,
  );
}
export type EnableEntraIdSsoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableEntraIdSsoMutation,
  EnableEntraIdSsoMutationVariables
>;
export const DisableEntraIdSsoDocument = gql`
  mutation disableEntraIdSso($healthProviderName: ID!) {
    disableEntraIdSso(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableEntraIdSsoMutation__
 *
 * To run a mutation, you first call `useDisableEntraIdSsoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableEntraIdSsoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableEntraIdSsoMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableEntraIdSsoMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableEntraIdSsoMutation, DisableEntraIdSsoMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableEntraIdSsoMutation, DisableEntraIdSsoMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableEntraIdSsoMutation, DisableEntraIdSsoMutationVariables>(
    DisableEntraIdSsoDocument,
    options,
  );
}
export type DisableEntraIdSsoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableEntraIdSsoMutation,
  DisableEntraIdSsoMutationVariables
>;
export const EnableEntraIdProvisioningDocument = gql`
  mutation enableEntraIdProvisioning($healthProviderName: ID!) {
    enableEntraIdProvisioning(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableEntraIdProvisioningMutation__
 *
 * To run a mutation, you first call `useEnableEntraIdProvisioningMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableEntraIdProvisioningMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableEntraIdProvisioningMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableEntraIdProvisioningMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableEntraIdProvisioningMutation,
        EnableEntraIdProvisioningMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableEntraIdProvisioningMutation,
          EnableEntraIdProvisioningMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableEntraIdProvisioningMutation, EnableEntraIdProvisioningMutationVariables>(
    EnableEntraIdProvisioningDocument,
    options,
  );
}
export type EnableEntraIdProvisioningMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableEntraIdProvisioningMutation,
  EnableEntraIdProvisioningMutationVariables
>;
export const DisableEntraIdProvisioningDocument = gql`
  mutation disableEntraIdProvisioning($healthProviderName: ID!) {
    disableEntraIdProvisioning(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableEntraIdProvisioningMutation__
 *
 * To run a mutation, you first call `useDisableEntraIdProvisioningMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableEntraIdProvisioningMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableEntraIdProvisioningMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableEntraIdProvisioningMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableEntraIdProvisioningMutation,
        DisableEntraIdProvisioningMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableEntraIdProvisioningMutation,
          DisableEntraIdProvisioningMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableEntraIdProvisioningMutation,
    DisableEntraIdProvisioningMutationVariables
  >(DisableEntraIdProvisioningDocument, options);
}
export type DisableEntraIdProvisioningMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableEntraIdProvisioningMutation,
  DisableEntraIdProvisioningMutationVariables
>;
export const EnableAlmaIntegrationDocument = gql`
  mutation enableAlmaIntegration($healthProviderName: ID!) {
    enableAlmaIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableAlmaIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableAlmaIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableAlmaIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableAlmaIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableAlmaIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableAlmaIntegrationMutation, EnableAlmaIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableAlmaIntegrationMutation, EnableAlmaIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableAlmaIntegrationMutation, EnableAlmaIntegrationMutationVariables>(
    EnableAlmaIntegrationDocument,
    options,
  );
}
export type EnableAlmaIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableAlmaIntegrationMutation,
  EnableAlmaIntegrationMutationVariables
>;
export const DisableAlmaIntegrationDocument = gql`
  mutation disableAlmaIntegration($healthProviderName: ID!) {
    disableAlmaIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableAlmaIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableAlmaIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableAlmaIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableAlmaIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableAlmaIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableAlmaIntegrationMutation, DisableAlmaIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableAlmaIntegrationMutation, DisableAlmaIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableAlmaIntegrationMutation, DisableAlmaIntegrationMutationVariables>(
    DisableAlmaIntegrationDocument,
    options,
  );
}
export type DisableAlmaIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableAlmaIntegrationMutation,
  DisableAlmaIntegrationMutationVariables
>;
export const EnableAscomIntegrationDocument = gql`
  mutation enableAscomIntegration($healthProviderName: ID!) {
    enableAscomIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableAscomIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableAscomIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableAscomIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableAscomIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableAscomIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableAscomIntegrationMutation, EnableAscomIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableAscomIntegrationMutation, EnableAscomIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableAscomIntegrationMutation, EnableAscomIntegrationMutationVariables>(
    EnableAscomIntegrationDocument,
    options,
  );
}
export type EnableAscomIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableAscomIntegrationMutation,
  EnableAscomIntegrationMutationVariables
>;
export const DisableAscomIntegrationDocument = gql`
  mutation disableAscomIntegration($healthProviderName: ID!) {
    disableAscomIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableAscomIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableAscomIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableAscomIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableAscomIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableAscomIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableAscomIntegrationMutation, DisableAscomIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableAscomIntegrationMutation,
          DisableAscomIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableAscomIntegrationMutation, DisableAscomIntegrationMutationVariables>(
    DisableAscomIntegrationDocument,
    options,
  );
}
export type DisableAscomIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableAscomIntegrationMutation,
  DisableAscomIntegrationMutationVariables
>;
export const EnablePhoniroCloudIntegrationDocument = gql`
  mutation enablePhoniroCloudIntegration($healthProviderName: ID!) {
    enablePhoniroCloudIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnablePhoniroCloudIntegrationMutation__
 *
 * To run a mutation, you first call `useEnablePhoniroCloudIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnablePhoniroCloudIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnablePhoniroCloudIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnablePhoniroCloudIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnablePhoniroCloudIntegrationMutation,
        EnablePhoniroCloudIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnablePhoniroCloudIntegrationMutation,
          EnablePhoniroCloudIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    EnablePhoniroCloudIntegrationMutation,
    EnablePhoniroCloudIntegrationMutationVariables
  >(EnablePhoniroCloudIntegrationDocument, options);
}
export type EnablePhoniroCloudIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnablePhoniroCloudIntegrationMutation,
  EnablePhoniroCloudIntegrationMutationVariables
>;
export const DisablePhoniroCloudIntegrationDocument = gql`
  mutation disablePhoniroCloudIntegration($healthProviderName: ID!) {
    disablePhoniroCloudIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisablePhoniroCloudIntegrationMutation__
 *
 * To run a mutation, you first call `useDisablePhoniroCloudIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisablePhoniroCloudIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisablePhoniroCloudIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisablePhoniroCloudIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisablePhoniroCloudIntegrationMutation,
        DisablePhoniroCloudIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisablePhoniroCloudIntegrationMutation,
          DisablePhoniroCloudIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisablePhoniroCloudIntegrationMutation,
    DisablePhoniroCloudIntegrationMutationVariables
  >(DisablePhoniroCloudIntegrationDocument, options);
}
export type DisablePhoniroCloudIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisablePhoniroCloudIntegrationMutation,
  DisablePhoniroCloudIntegrationMutationVariables
>;
export const EnableSkyresponsePartnerIntegrationDocument = gql`
  mutation enableSkyresponsePartnerIntegration($healthProviderName: ID!) {
    enableSkyresponsePartnerIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableSkyresponsePartnerIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableSkyresponsePartnerIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableSkyresponsePartnerIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableSkyresponsePartnerIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableSkyresponsePartnerIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableSkyresponsePartnerIntegrationMutation,
        EnableSkyresponsePartnerIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableSkyresponsePartnerIntegrationMutation,
          EnableSkyresponsePartnerIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    EnableSkyresponsePartnerIntegrationMutation,
    EnableSkyresponsePartnerIntegrationMutationVariables
  >(EnableSkyresponsePartnerIntegrationDocument, options);
}
export type EnableSkyresponsePartnerIntegrationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    EnableSkyresponsePartnerIntegrationMutation,
    EnableSkyresponsePartnerIntegrationMutationVariables
  >;
export const DisableSkyresponsePartnerIntegrationDocument = gql`
  mutation disableSkyresponsePartnerIntegration($healthProviderName: ID!) {
    disableSkyresponsePartnerIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableSkyresponsePartnerIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableSkyresponsePartnerIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableSkyresponsePartnerIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableSkyresponsePartnerIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableSkyresponsePartnerIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableSkyresponsePartnerIntegrationMutation,
        DisableSkyresponsePartnerIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableSkyresponsePartnerIntegrationMutation,
          DisableSkyresponsePartnerIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableSkyresponsePartnerIntegrationMutation,
    DisableSkyresponsePartnerIntegrationMutationVariables
  >(DisableSkyresponsePartnerIntegrationDocument, options);
}
export type DisableSkyresponsePartnerIntegrationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DisableSkyresponsePartnerIntegrationMutation,
    DisableSkyresponsePartnerIntegrationMutationVariables
  >;
export const EnableSipIntegrationDocument = gql`
  mutation enableSipIntegration($healthProviderName: ID!) {
    enableSipIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableSipIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableSipIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableSipIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableSipIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableSipIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableSipIntegrationMutation, EnableSipIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableSipIntegrationMutation, EnableSipIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableSipIntegrationMutation, EnableSipIntegrationMutationVariables>(
    EnableSipIntegrationDocument,
    options,
  );
}
export type EnableSipIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableSipIntegrationMutation,
  EnableSipIntegrationMutationVariables
>;
export const DisableSipIntegrationDocument = gql`
  mutation disableSipIntegration($healthProviderName: ID!) {
    disableSipIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableSipIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableSipIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableSipIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableSipIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableSipIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableSipIntegrationMutation, DisableSipIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableSipIntegrationMutation, DisableSipIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableSipIntegrationMutation, DisableSipIntegrationMutationVariables>(
    DisableSipIntegrationDocument,
    options,
  );
}
export type DisableSipIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableSipIntegrationMutation,
  DisableSipIntegrationMutationVariables
>;
export const EnableCoordcomIntegrationDocument = gql`
  mutation enableCoordcomIntegration($healthProviderName: ID!) {
    enableCoordcomIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableCoordcomIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableCoordcomIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableCoordcomIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableCoordcomIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableCoordcomIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableCoordcomIntegrationMutation,
        EnableCoordcomIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableCoordcomIntegrationMutation,
          EnableCoordcomIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableCoordcomIntegrationMutation, EnableCoordcomIntegrationMutationVariables>(
    EnableCoordcomIntegrationDocument,
    options,
  );
}
export type EnableCoordcomIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableCoordcomIntegrationMutation,
  EnableCoordcomIntegrationMutationVariables
>;
export const DisableCoordcomIntegrationDocument = gql`
  mutation disableCoordcomIntegration($healthProviderName: ID!) {
    disableCoordcomIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableCoordcomIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableCoordcomIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableCoordcomIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableCoordcomIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableCoordcomIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableCoordcomIntegrationMutation,
        DisableCoordcomIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableCoordcomIntegrationMutation,
          DisableCoordcomIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableCoordcomIntegrationMutation,
    DisableCoordcomIntegrationMutationVariables
  >(DisableCoordcomIntegrationDocument, options);
}
export type DisableCoordcomIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableCoordcomIntegrationMutation,
  DisableCoordcomIntegrationMutationVariables
>;
export const EnableTietoLmoIntegrationDocument = gql`
  mutation enableTietoLmoIntegration($healthProviderName: ID!) {
    enableTietoLmoIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableTietoLmoIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableTietoLmoIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableTietoLmoIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableTietoLmoIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableTietoLmoIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableTietoLmoIntegrationMutation,
        EnableTietoLmoIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableTietoLmoIntegrationMutation,
          EnableTietoLmoIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableTietoLmoIntegrationMutation, EnableTietoLmoIntegrationMutationVariables>(
    EnableTietoLmoIntegrationDocument,
    options,
  );
}
export type EnableTietoLmoIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableTietoLmoIntegrationMutation,
  EnableTietoLmoIntegrationMutationVariables
>;
export const DisableTietoLmoIntegrationDocument = gql`
  mutation disableTietoLmoIntegration($healthProviderName: ID!) {
    disableTietoLmoIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableTietoLmoIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableTietoLmoIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableTietoLmoIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableTietoLmoIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableTietoLmoIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableTietoLmoIntegrationMutation,
        DisableTietoLmoIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableTietoLmoIntegrationMutation,
          DisableTietoLmoIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableTietoLmoIntegrationMutation,
    DisableTietoLmoIntegrationMutationVariables
  >(DisableTietoLmoIntegrationDocument, options);
}
export type DisableTietoLmoIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableTietoLmoIntegrationMutation,
  DisableTietoLmoIntegrationMutationVariables
>;
export const EnableIpOmsorgIntegrationDocument = gql`
  mutation enableIpOmsorgIntegration($healthProviderName: ID!) {
    enableIpOmsorgIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableIpOmsorgIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableIpOmsorgIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableIpOmsorgIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableIpOmsorgIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableIpOmsorgIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        EnableIpOmsorgIntegrationMutation,
        EnableIpOmsorgIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableIpOmsorgIntegrationMutation,
          EnableIpOmsorgIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableIpOmsorgIntegrationMutation, EnableIpOmsorgIntegrationMutationVariables>(
    EnableIpOmsorgIntegrationDocument,
    options,
  );
}
export type EnableIpOmsorgIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableIpOmsorgIntegrationMutation,
  EnableIpOmsorgIntegrationMutationVariables
>;
export const DisableIpOmsorgIntegrationDocument = gql`
  mutation disableIpOmsorgIntegration($healthProviderName: ID!) {
    disableIpOmsorgIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableIpOmsorgIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableIpOmsorgIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableIpOmsorgIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableIpOmsorgIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableIpOmsorgIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableIpOmsorgIntegrationMutation,
        DisableIpOmsorgIntegrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableIpOmsorgIntegrationMutation,
          DisableIpOmsorgIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DisableIpOmsorgIntegrationMutation,
    DisableIpOmsorgIntegrationMutationVariables
  >(DisableIpOmsorgIntegrationDocument, options);
}
export type DisableIpOmsorgIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableIpOmsorgIntegrationMutation,
  DisableIpOmsorgIntegrationMutationVariables
>;
export const EnableUmo2GIntegrationDocument = gql`
  mutation enableUmo2GIntegration($healthProviderName: ID!) {
    enableUmo2GIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableUmo2GIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableUmo2GIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableUmo2GIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableUmo2GIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableUmo2GIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableUmo2GIntegrationMutation, EnableUmo2GIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableUmo2GIntegrationMutation, EnableUmo2GIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableUmo2GIntegrationMutation, EnableUmo2GIntegrationMutationVariables>(
    EnableUmo2GIntegrationDocument,
    options,
  );
}
export type EnableUmo2GIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableUmo2GIntegrationMutation,
  EnableUmo2GIntegrationMutationVariables
>;
export const DisableUmo2GIntegrationDocument = gql`
  mutation disableUmo2GIntegration($healthProviderName: ID!) {
    disableUmo2GIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableUmo2GIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableUmo2GIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableUmo2GIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableUmo2GIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableUmo2GIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableUmo2GIntegrationMutation, DisableUmo2GIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableUmo2GIntegrationMutation,
          DisableUmo2GIntegrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableUmo2GIntegrationMutation, DisableUmo2GIntegrationMutationVariables>(
    DisableUmo2GIntegrationDocument,
    options,
  );
}
export type DisableUmo2GIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableUmo2GIntegrationMutation,
  DisableUmo2GIntegrationMutationVariables
>;
export const EnableBestIntegrationDocument = gql`
  mutation enableBestIntegration($healthProviderName: ID!) {
    enableBestIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableBestIntegrationMutation__
 *
 * To run a mutation, you first call `useEnableBestIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableBestIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableBestIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableBestIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableBestIntegrationMutation, EnableBestIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableBestIntegrationMutation, EnableBestIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableBestIntegrationMutation, EnableBestIntegrationMutationVariables>(
    EnableBestIntegrationDocument,
    options,
  );
}
export type EnableBestIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableBestIntegrationMutation,
  EnableBestIntegrationMutationVariables
>;
export const DisableBestIntegrationDocument = gql`
  mutation disableBestIntegration($healthProviderName: ID!) {
    disableBestIntegration(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableBestIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableBestIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableBestIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableBestIntegrationMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableBestIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableBestIntegrationMutation, DisableBestIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableBestIntegrationMutation, DisableBestIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableBestIntegrationMutation, DisableBestIntegrationMutationVariables>(
    DisableBestIntegrationDocument,
    options,
  );
}
export type DisableBestIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableBestIntegrationMutation,
  DisableBestIntegrationMutationVariables
>;
export const EnableCmpDocument = gql`
  mutation enableCmp($healthProviderName: ID!) {
    enableCmp(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableCmpMutation__
 *
 * To run a mutation, you first call `useEnableCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableCmpMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableCmpMutation, EnableCmpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnableCmpMutation, EnableCmpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<EnableCmpMutation, EnableCmpMutationVariables>(EnableCmpDocument, options);
}
export type EnableCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableCmpMutation,
  EnableCmpMutationVariables
>;
export const DisableCmpDocument = gql`
  mutation disableCmp($healthProviderName: ID!) {
    disableCmp(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableCmpMutation__
 *
 * To run a mutation, you first call `useDisableCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableCmpMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableCmpMutation, DisableCmpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisableCmpMutation, DisableCmpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DisableCmpMutation, DisableCmpMutationVariables>(DisableCmpDocument, options);
}
export type DisableCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableCmpMutation,
  DisableCmpMutationVariables
>;
export const EnableAlarmStreamingDocument = gql`
  mutation enableAlarmStreaming($healthProviderName: ID!) {
    enableAlarmStreaming(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useEnableAlarmStreamingMutation__
 *
 * To run a mutation, you first call `useEnableAlarmStreamingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableAlarmStreamingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableAlarmStreamingMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useEnableAlarmStreamingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableAlarmStreamingMutation, EnableAlarmStreamingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableAlarmStreamingMutation, EnableAlarmStreamingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableAlarmStreamingMutation, EnableAlarmStreamingMutationVariables>(
    EnableAlarmStreamingDocument,
    options,
  );
}
export type EnableAlarmStreamingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableAlarmStreamingMutation,
  EnableAlarmStreamingMutationVariables
>;
export const DisableAlarmStreamingDocument = gql`
  mutation disableAlarmStreaming($healthProviderName: ID!) {
    disableAlarmStreaming(healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useDisableAlarmStreamingMutation__
 *
 * To run a mutation, you first call `useDisableAlarmStreamingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableAlarmStreamingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableAlarmStreamingMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useDisableAlarmStreamingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableAlarmStreamingMutation, DisableAlarmStreamingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableAlarmStreamingMutation, DisableAlarmStreamingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableAlarmStreamingMutation, DisableAlarmStreamingMutationVariables>(
    DisableAlarmStreamingDocument,
    options,
  );
}
export type DisableAlarmStreamingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableAlarmStreamingMutation,
  DisableAlarmStreamingMutationVariables
>;
export const AddTcifAccountToHealthProviderDocument = gql`
  mutation addTcifAccountToHealthProvider($tcifAccountId: ID!, $healthProviderName: ID!) {
    addTcifAccountToHealthProvider(tcifAccountId: $tcifAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddTcifAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddTcifAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTcifAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTcifAccountToHealthProviderMutation({
 *   variables: {
 *     tcifAccountId: // value for 'tcifAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddTcifAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddTcifAccountToHealthProviderMutation,
        AddTcifAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddTcifAccountToHealthProviderMutation,
          AddTcifAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddTcifAccountToHealthProviderMutation,
    AddTcifAccountToHealthProviderMutationVariables
  >(AddTcifAccountToHealthProviderDocument, options);
}
export type AddTcifAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddTcifAccountToHealthProviderMutation,
  AddTcifAccountToHealthProviderMutationVariables
>;
export const RemoveTcifAccountFromHealthProviderDocument = gql`
  mutation removeTcifAccountFromHealthProvider($tcifAccountId: ID!, $healthProviderName: ID!) {
    removeTcifAccountFromHealthProvider(tcifAccountId: $tcifAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useRemoveTcifAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveTcifAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTcifAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTcifAccountFromHealthProviderMutation({
 *   variables: {
 *     tcifAccountId: // value for 'tcifAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveTcifAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveTcifAccountFromHealthProviderMutation,
        RemoveTcifAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveTcifAccountFromHealthProviderMutation,
          RemoveTcifAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveTcifAccountFromHealthProviderMutation,
    RemoveTcifAccountFromHealthProviderMutationVariables
  >(RemoveTcifAccountFromHealthProviderDocument, options);
}
export type RemoveTcifAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveTcifAccountFromHealthProviderMutation,
    RemoveTcifAccountFromHealthProviderMutationVariables
  >;
export const AddSafemateAccountToHealthProviderDocument = gql`
  mutation addSafemateAccountToHealthProvider($safemateAccountId: ID!, $healthProviderName: ID!) {
    addSafemateAccountToHealthProvider(safemateAccountId: $safemateAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddSafemateAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddSafemateAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSafemateAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSafemateAccountToHealthProviderMutation({
 *   variables: {
 *     safemateAccountId: // value for 'safemateAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddSafemateAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddSafemateAccountToHealthProviderMutation,
        AddSafemateAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddSafemateAccountToHealthProviderMutation,
          AddSafemateAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddSafemateAccountToHealthProviderMutation,
    AddSafemateAccountToHealthProviderMutationVariables
  >(AddSafemateAccountToHealthProviderDocument, options);
}
export type AddSafemateAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddSafemateAccountToHealthProviderMutation,
  AddSafemateAccountToHealthProviderMutationVariables
>;
export const RemoveSafemateAccountFromHealthProviderDocument = gql`
  mutation removeSafemateAccountFromHealthProvider($safemateAccountId: ID!, $healthProviderName: ID!) {
    removeSafemateAccountFromHealthProvider(
      safemateAccountId: $safemateAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useRemoveSafemateAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveSafemateAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSafemateAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSafemateAccountFromHealthProviderMutation({
 *   variables: {
 *     safemateAccountId: // value for 'safemateAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveSafemateAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveSafemateAccountFromHealthProviderMutation,
        RemoveSafemateAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveSafemateAccountFromHealthProviderMutation,
          RemoveSafemateAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveSafemateAccountFromHealthProviderMutation,
    RemoveSafemateAccountFromHealthProviderMutationVariables
  >(RemoveSafemateAccountFromHealthProviderDocument, options);
}
export type RemoveSafemateAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveSafemateAccountFromHealthProviderMutation,
    RemoveSafemateAccountFromHealthProviderMutationVariables
  >;
export const AddVideonorAccountToHealthProviderDocument = gql`
  mutation addVideonorAccountToHealthProvider($videonorAccountId: ID!, $healthProviderName: ID!) {
    addVideonorAccountToHealthProvider(videonorAccountId: $videonorAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddVideonorAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddVideonorAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddVideonorAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddVideonorAccountToHealthProviderMutation({
 *   variables: {
 *     videonorAccountId: // value for 'videonorAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddVideonorAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddVideonorAccountToHealthProviderMutation,
        AddVideonorAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddVideonorAccountToHealthProviderMutation,
          AddVideonorAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddVideonorAccountToHealthProviderMutation,
    AddVideonorAccountToHealthProviderMutationVariables
  >(AddVideonorAccountToHealthProviderDocument, options);
}
export type AddVideonorAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddVideonorAccountToHealthProviderMutation,
  AddVideonorAccountToHealthProviderMutationVariables
>;
export const RemoveVideonorAccountFromHealthProviderDocument = gql`
  mutation removeVideonorAccountFromHealthProvider($videonorAccountId: ID!, $healthProviderName: ID!) {
    removeVideonorAccountFromHealthProvider(
      videonorAccountId: $videonorAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useRemoveVideonorAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveVideonorAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVideonorAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveVideonorAccountFromHealthProviderMutation({
 *   variables: {
 *     videonorAccountId: // value for 'videonorAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveVideonorAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveVideonorAccountFromHealthProviderMutation,
        RemoveVideonorAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveVideonorAccountFromHealthProviderMutation,
          RemoveVideonorAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveVideonorAccountFromHealthProviderMutation,
    RemoveVideonorAccountFromHealthProviderMutationVariables
  >(RemoveVideonorAccountFromHealthProviderDocument, options);
}
export type RemoveVideonorAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveVideonorAccountFromHealthProviderMutation,
    RemoveVideonorAccountFromHealthProviderMutationVariables
  >;
export const AddMorpheanAccountToHealthProviderDocument = gql`
  mutation addMorpheanAccountToHealthProvider($morpheanAccountId: ID!, $healthProviderName: ID!) {
    addMorpheanAccountToHealthProvider(morpheanAccountId: $morpheanAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddMorpheanAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddMorpheanAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMorpheanAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMorpheanAccountToHealthProviderMutation({
 *   variables: {
 *     morpheanAccountId: // value for 'morpheanAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddMorpheanAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddMorpheanAccountToHealthProviderMutation,
        AddMorpheanAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddMorpheanAccountToHealthProviderMutation,
          AddMorpheanAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddMorpheanAccountToHealthProviderMutation,
    AddMorpheanAccountToHealthProviderMutationVariables
  >(AddMorpheanAccountToHealthProviderDocument, options);
}
export type AddMorpheanAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddMorpheanAccountToHealthProviderMutation,
  AddMorpheanAccountToHealthProviderMutationVariables
>;
export const RemoveMorpheanAccountFromHealthProviderDocument = gql`
  mutation removeMorpheanAccountFromHealthProvider($morpheanAccountId: ID!, $healthProviderName: ID!) {
    removeMorpheanAccountFromHealthProvider(
      morpheanAccountId: $morpheanAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useRemoveMorpheanAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveMorpheanAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMorpheanAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveMorpheanAccountFromHealthProviderMutation({
 *   variables: {
 *     morpheanAccountId: // value for 'morpheanAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveMorpheanAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveMorpheanAccountFromHealthProviderMutation,
        RemoveMorpheanAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveMorpheanAccountFromHealthProviderMutation,
          RemoveMorpheanAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveMorpheanAccountFromHealthProviderMutation,
    RemoveMorpheanAccountFromHealthProviderMutationVariables
  >(RemoveMorpheanAccountFromHealthProviderDocument, options);
}
export type RemoveMorpheanAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveMorpheanAccountFromHealthProviderMutation,
    RemoveMorpheanAccountFromHealthProviderMutationVariables
  >;
export const AddTwilioAccountToHealthProviderDocument = gql`
  mutation addTwilioAccountToHealthProvider($twilioAccountId: ID!, $healthProviderName: ID!) {
    addTwilioAccountToHealthProvider(twilioAccountId: $twilioAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddTwilioAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddTwilioAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTwilioAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTwilioAccountToHealthProviderMutation({
 *   variables: {
 *     twilioAccountId: // value for 'twilioAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddTwilioAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddTwilioAccountToHealthProviderMutation,
        AddTwilioAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddTwilioAccountToHealthProviderMutation,
          AddTwilioAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddTwilioAccountToHealthProviderMutation,
    AddTwilioAccountToHealthProviderMutationVariables
  >(AddTwilioAccountToHealthProviderDocument, options);
}
export type AddTwilioAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddTwilioAccountToHealthProviderMutation,
  AddTwilioAccountToHealthProviderMutationVariables
>;
export const RemoveTwilioAccountFromHealthProviderDocument = gql`
  mutation removeTwilioAccountFromHealthProvider($twilioAccountId: ID!, $healthProviderName: ID!) {
    removeTwilioAccountFromHealthProvider(twilioAccountId: $twilioAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useRemoveTwilioAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveTwilioAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTwilioAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTwilioAccountFromHealthProviderMutation({
 *   variables: {
 *     twilioAccountId: // value for 'twilioAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveTwilioAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveTwilioAccountFromHealthProviderMutation,
        RemoveTwilioAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveTwilioAccountFromHealthProviderMutation,
          RemoveTwilioAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveTwilioAccountFromHealthProviderMutation,
    RemoveTwilioAccountFromHealthProviderMutationVariables
  >(RemoveTwilioAccountFromHealthProviderDocument, options);
}
export type RemoveTwilioAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveTwilioAccountFromHealthProviderMutation,
    RemoveTwilioAccountFromHealthProviderMutationVariables
  >;
export const AddSendGridAccountToHealthProviderDocument = gql`
  mutation addSendGridAccountToHealthProvider($sendGridAccountId: ID!, $healthProviderName: ID!) {
    addSendGridAccountToHealthProvider(sendGridAccountId: $sendGridAccountId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useAddSendGridAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddSendGridAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSendGridAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSendGridAccountToHealthProviderMutation({
 *   variables: {
 *     sendGridAccountId: // value for 'sendGridAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddSendGridAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddSendGridAccountToHealthProviderMutation,
        AddSendGridAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddSendGridAccountToHealthProviderMutation,
          AddSendGridAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddSendGridAccountToHealthProviderMutation,
    AddSendGridAccountToHealthProviderMutationVariables
  >(AddSendGridAccountToHealthProviderDocument, options);
}
export type AddSendGridAccountToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddSendGridAccountToHealthProviderMutation,
  AddSendGridAccountToHealthProviderMutationVariables
>;
export const RemoveSendGridAccountFromHealthProviderDocument = gql`
  mutation removeSendGridAccountFromHealthProvider($sendGridAccountId: ID!, $healthProviderName: ID!) {
    removeSendGridAccountFromHealthProvider(
      sendGridAccountId: $sendGridAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useRemoveSendGridAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveSendGridAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSendGridAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSendGridAccountFromHealthProviderMutation({
 *   variables: {
 *     sendGridAccountId: // value for 'sendGridAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveSendGridAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveSendGridAccountFromHealthProviderMutation,
        RemoveSendGridAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveSendGridAccountFromHealthProviderMutation,
          RemoveSendGridAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveSendGridAccountFromHealthProviderMutation,
    RemoveSendGridAccountFromHealthProviderMutationVariables
  >(RemoveSendGridAccountFromHealthProviderDocument, options);
}
export type RemoveSendGridAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveSendGridAccountFromHealthProviderMutation,
    RemoveSendGridAccountFromHealthProviderMutationVariables
  >;
export const AddGooglemapsAccountToHealthProviderDocument = gql`
  mutation addGooglemapsAccountToHealthProvider($googlemapsAccountId: ID!, $healthProviderName: ID!) {
    addGooglemapsAccountToHealthProvider(
      googlemapsAccountId: $googlemapsAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useAddGooglemapsAccountToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddGooglemapsAccountToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddGooglemapsAccountToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddGooglemapsAccountToHealthProviderMutation({
 *   variables: {
 *     googlemapsAccountId: // value for 'googlemapsAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useAddGooglemapsAccountToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddGooglemapsAccountToHealthProviderMutation,
        AddGooglemapsAccountToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddGooglemapsAccountToHealthProviderMutation,
          AddGooglemapsAccountToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddGooglemapsAccountToHealthProviderMutation,
    AddGooglemapsAccountToHealthProviderMutationVariables
  >(AddGooglemapsAccountToHealthProviderDocument, options);
}
export type AddGooglemapsAccountToHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddGooglemapsAccountToHealthProviderMutation,
    AddGooglemapsAccountToHealthProviderMutationVariables
  >;
export const RemoveGooglemapsAccountFromHealthProviderDocument = gql`
  mutation removeGooglemapsAccountFromHealthProvider($googlemapsAccountId: ID!, $healthProviderName: ID!) {
    removeGooglemapsAccountFromHealthProvider(
      googlemapsAccountId: $googlemapsAccountId
      healthProviderName: $healthProviderName
    ) {
      success
      message
    }
  }
`;

/**
 * __useRemoveGooglemapsAccountFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveGooglemapsAccountFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGooglemapsAccountFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveGooglemapsAccountFromHealthProviderMutation({
 *   variables: {
 *     googlemapsAccountId: // value for 'googlemapsAccountId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useRemoveGooglemapsAccountFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveGooglemapsAccountFromHealthProviderMutation,
        RemoveGooglemapsAccountFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveGooglemapsAccountFromHealthProviderMutation,
          RemoveGooglemapsAccountFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveGooglemapsAccountFromHealthProviderMutation,
    RemoveGooglemapsAccountFromHealthProviderMutationVariables
  >(RemoveGooglemapsAccountFromHealthProviderDocument, options);
}
export type RemoveGooglemapsAccountFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveGooglemapsAccountFromHealthProviderMutation,
    RemoveGooglemapsAccountFromHealthProviderMutationVariables
  >;
export const ExecuteRegistryMigrationDocument = gql`
  mutation executeRegistryMigration($migrationId: ID!) {
    executeMigration(migrationId: $migrationId) {
      healthProviderName
      databaseName
      success
      report
      error
    }
  }
`;

/**
 * __useExecuteRegistryMigrationMutation__
 *
 * To run a mutation, you first call `useExecuteRegistryMigrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExecuteRegistryMigrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExecuteRegistryMigrationMutation({
 *   variables: {
 *     migrationId: // value for 'migrationId'
 *   },
 * });
 */
export function useExecuteRegistryMigrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ExecuteRegistryMigrationMutation,
        ExecuteRegistryMigrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ExecuteRegistryMigrationMutation,
          ExecuteRegistryMigrationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ExecuteRegistryMigrationMutation, ExecuteRegistryMigrationMutationVariables>(
    ExecuteRegistryMigrationDocument,
    options,
  );
}
export type ExecuteRegistryMigrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ExecuteRegistryMigrationMutation,
  ExecuteRegistryMigrationMutationVariables
>;
export const ExecuteMigrationDocument = gql`
  mutation executeMigration($migrationId: ID!, $healthProviderNames: [String!]!) {
    executeMigration(migrationId: $migrationId, healthProviderNames: $healthProviderNames) {
      healthProviderName
      databaseName
      success
      report
      error
    }
  }
`;

/**
 * __useExecuteMigrationMutation__
 *
 * To run a mutation, you first call `useExecuteMigrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExecuteMigrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExecuteMigrationMutation({
 *   variables: {
 *     migrationId: // value for 'migrationId'
 *     healthProviderNames: // value for 'healthProviderNames'
 *   },
 * });
 */
export function useExecuteMigrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ExecuteMigrationMutation, ExecuteMigrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ExecuteMigrationMutation, ExecuteMigrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ExecuteMigrationMutation, ExecuteMigrationMutationVariables>(
    ExecuteMigrationDocument,
    options,
  );
}
export type ExecuteMigrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ExecuteMigrationMutation,
  ExecuteMigrationMutationVariables
>;
export const CorrectValidationRulesDocument = gql`
  mutation correctValidationRules($healthProviderName: String!) {
    correctValidationRules(healthProviderName: $healthProviderName)
  }
`;

/**
 * __useCorrectValidationRulesMutation__
 *
 * To run a mutation, you first call `useCorrectValidationRulesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCorrectValidationRulesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCorrectValidationRulesMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useCorrectValidationRulesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CorrectValidationRulesMutation, CorrectValidationRulesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CorrectValidationRulesMutation, CorrectValidationRulesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CorrectValidationRulesMutation, CorrectValidationRulesMutationVariables>(
    CorrectValidationRulesDocument,
    options,
  );
}
export type CorrectValidationRulesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CorrectValidationRulesMutation,
  CorrectValidationRulesMutationVariables
>;
export const CreateMorpheanAccountDocument = gql`
  mutation createMorpheanAccount($input: MorpheanAccountCreateInput!) {
    createMorpheanAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateMorpheanAccountMutation__
 *
 * To run a mutation, you first call `useCreateMorpheanAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMorpheanAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMorpheanAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMorpheanAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateMorpheanAccountMutation, CreateMorpheanAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateMorpheanAccountMutation, CreateMorpheanAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateMorpheanAccountMutation, CreateMorpheanAccountMutationVariables>(
    CreateMorpheanAccountDocument,
    options,
  );
}
export type CreateMorpheanAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateMorpheanAccountMutation,
  CreateMorpheanAccountMutationVariables
>;
export const UpdateMorpheanAccountDocument = gql`
  mutation updateMorpheanAccount($id: ID!, $input: MorpheanAccountUpdateInput!) {
    updateMorpheanAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateMorpheanAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMorpheanAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMorpheanAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMorpheanAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMorpheanAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateMorpheanAccountMutation, UpdateMorpheanAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateMorpheanAccountMutation, UpdateMorpheanAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateMorpheanAccountMutation, UpdateMorpheanAccountMutationVariables>(
    UpdateMorpheanAccountDocument,
    options,
  );
}
export type UpdateMorpheanAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateMorpheanAccountMutation,
  UpdateMorpheanAccountMutationVariables
>;
export const DeleteMorpheanAccountDocument = gql`
  mutation deleteMorpheanAccount($id: ID!) {
    deleteMorpheanAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteMorpheanAccountMutation__
 *
 * To run a mutation, you first call `useDeleteMorpheanAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMorpheanAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMorpheanAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMorpheanAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteMorpheanAccountMutation, DeleteMorpheanAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteMorpheanAccountMutation, DeleteMorpheanAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteMorpheanAccountMutation, DeleteMorpheanAccountMutationVariables>(
    DeleteMorpheanAccountDocument,
    options,
  );
}
export type DeleteMorpheanAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteMorpheanAccountMutation,
  DeleteMorpheanAccountMutationVariables
>;
export const UpdateRegistryDeviceDocument = gql`
  mutation updateRegistryDevice($deviceId: ID!, $healthProviderName: ID) {
    updateRegistryDevice(deviceId: $deviceId, healthProviderName: $healthProviderName) {
      success
      message
    }
  }
`;

/**
 * __useUpdateRegistryDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRegistryDeviceMutation({
 *   variables: {
 *     deviceId: // value for 'deviceId'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useUpdateRegistryDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateRegistryDeviceMutation, UpdateRegistryDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateRegistryDeviceMutation, UpdateRegistryDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateRegistryDeviceMutation, UpdateRegistryDeviceMutationVariables>(
    UpdateRegistryDeviceDocument,
    options,
  );
}
export type UpdateRegistryDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateRegistryDeviceMutation,
  UpdateRegistryDeviceMutationVariables
>;
export const CreateRegistryDeviceDocument = gql`
  mutation createRegistryDevice($registryDeviceInput: RegistryDeviceInput!) {
    createRegistryDevice(registryDeviceInput: $registryDeviceInput) {
      success
      message
    }
  }
`;

/**
 * __useCreateRegistryDeviceMutation__
 *
 * To run a mutation, you first call `useCreateRegistryDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRegistryDeviceMutation({
 *   variables: {
 *     registryDeviceInput: // value for 'registryDeviceInput'
 *   },
 * });
 */
export function useCreateRegistryDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRegistryDeviceMutation, CreateRegistryDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateRegistryDeviceMutation, CreateRegistryDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateRegistryDeviceMutation, CreateRegistryDeviceMutationVariables>(
    CreateRegistryDeviceDocument,
    options,
  );
}
export type CreateRegistryDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRegistryDeviceMutation,
  CreateRegistryDeviceMutationVariables
>;
export const DeleteRegistryDeviceDocument = gql`
  mutation deleteRegistryDevice($deviceId: ID!) {
    deleteRegistryDevice(deviceId: $deviceId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteRegistryDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRegistryDeviceMutation({
 *   variables: {
 *     deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDeleteRegistryDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRegistryDeviceMutation, DeleteRegistryDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteRegistryDeviceMutation, DeleteRegistryDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteRegistryDeviceMutation, DeleteRegistryDeviceMutationVariables>(
    DeleteRegistryDeviceDocument,
    options,
  );
}
export type DeleteRegistryDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRegistryDeviceMutation,
  DeleteRegistryDeviceMutationVariables
>;
export const PreviewRegistrySchemaSyncDocument = gql`
  mutation previewRegistrySchemaSync {
    previewRegistrySchemaSync {
      databaseName
      output
      success
      isSynced
    }
  }
`;

/**
 * __usePreviewRegistrySchemaSyncMutation__
 *
 * To run a mutation, you first call `usePreviewRegistrySchemaSyncMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewRegistrySchemaSyncMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewRegistrySchemaSyncMutation();
 */
export function usePreviewRegistrySchemaSyncMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        PreviewRegistrySchemaSyncMutation,
        PreviewRegistrySchemaSyncMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          PreviewRegistrySchemaSyncMutation,
          PreviewRegistrySchemaSyncMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<PreviewRegistrySchemaSyncMutation, PreviewRegistrySchemaSyncMutationVariables>(
    PreviewRegistrySchemaSyncDocument,
    options,
  );
}
export type PreviewRegistrySchemaSyncMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PreviewRegistrySchemaSyncMutation,
  PreviewRegistrySchemaSyncMutationVariables
>;
export const ExecuteRegistrySchemaSyncDocument = gql`
  mutation executeRegistrySchemaSync {
    executeRegistrySchemaSync {
      databaseName
      output
      success
      isSynced
    }
  }
`;

/**
 * __useExecuteRegistrySchemaSyncMutation__
 *
 * To run a mutation, you first call `useExecuteRegistrySchemaSyncMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExecuteRegistrySchemaSyncMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExecuteRegistrySchemaSyncMutation();
 */
export function useExecuteRegistrySchemaSyncMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ExecuteRegistrySchemaSyncMutation,
        ExecuteRegistrySchemaSyncMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ExecuteRegistrySchemaSyncMutation,
          ExecuteRegistrySchemaSyncMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ExecuteRegistrySchemaSyncMutation, ExecuteRegistrySchemaSyncMutationVariables>(
    ExecuteRegistrySchemaSyncDocument,
    options,
  );
}
export type ExecuteRegistrySchemaSyncMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ExecuteRegistrySchemaSyncMutation,
  ExecuteRegistrySchemaSyncMutationVariables
>;
export const DeleteDefaultRoleDefinitionDocument = gql`
  mutation deleteDefaultRoleDefinition($id: ID!) {
    deleteDefaultRoleDefinition(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteDefaultRoleDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteDefaultRoleDefinitionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDefaultRoleDefinitionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDefaultRoleDefinitionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDefaultRoleDefinitionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteDefaultRoleDefinitionMutation,
        DeleteDefaultRoleDefinitionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteDefaultRoleDefinitionMutation,
          DeleteDefaultRoleDefinitionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteDefaultRoleDefinitionMutation,
    DeleteDefaultRoleDefinitionMutationVariables
  >(DeleteDefaultRoleDefinitionDocument, options);
}
export type DeleteDefaultRoleDefinitionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDefaultRoleDefinitionMutation,
  DeleteDefaultRoleDefinitionMutationVariables
>;
export const UpdateRoleDefinitionBasedOnDocument = gql`
  mutation updateRoleDefinitionBasedOn($id: ID!, $basedOn: ID!, $healthProviderName: ID!) {
    updateRoleDefinitionBasedOn(id: $id, basedOn: $basedOn, healthProviderName: $healthProviderName) {
      success
    }
  }
`;

/**
 * __useUpdateRoleDefinitionBasedOnMutation__
 *
 * To run a mutation, you first call `useUpdateRoleDefinitionBasedOnMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleDefinitionBasedOnMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRoleDefinitionBasedOnMutation({
 *   variables: {
 *     id: // value for 'id'
 *     basedOn: // value for 'basedOn'
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useUpdateRoleDefinitionBasedOnMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateRoleDefinitionBasedOnMutation,
        UpdateRoleDefinitionBasedOnMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateRoleDefinitionBasedOnMutation,
          UpdateRoleDefinitionBasedOnMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateRoleDefinitionBasedOnMutation,
    UpdateRoleDefinitionBasedOnMutationVariables
  >(UpdateRoleDefinitionBasedOnDocument, options);
}
export type UpdateRoleDefinitionBasedOnMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateRoleDefinitionBasedOnMutation,
  UpdateRoleDefinitionBasedOnMutationVariables
>;
export const UpdateHealthProviderRolesBasedOnDefaultRolesDocument = gql`
  mutation updateHealthProviderRolesBasedOnDefaultRoles($healthProviderName: ID!, $defaultRoleIds: [ID!]!) {
    updateHealthProviderRolesBasedOnDefaultRoles(
      healthProviderName: $healthProviderName
      defaultRoleIds: $defaultRoleIds
    ) {
      success
      message
    }
  }
`;

/**
 * __useUpdateHealthProviderRolesBasedOnDefaultRolesMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProviderRolesBasedOnDefaultRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProviderRolesBasedOnDefaultRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHealthProviderRolesBasedOnDefaultRolesMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     defaultRoleIds: // value for 'defaultRoleIds'
 *   },
 * });
 */
export function useUpdateHealthProviderRolesBasedOnDefaultRolesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateHealthProviderRolesBasedOnDefaultRolesMutation,
        UpdateHealthProviderRolesBasedOnDefaultRolesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateHealthProviderRolesBasedOnDefaultRolesMutation,
          UpdateHealthProviderRolesBasedOnDefaultRolesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateHealthProviderRolesBasedOnDefaultRolesMutation,
    UpdateHealthProviderRolesBasedOnDefaultRolesMutationVariables
  >(UpdateHealthProviderRolesBasedOnDefaultRolesDocument, options);
}
export type UpdateHealthProviderRolesBasedOnDefaultRolesMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateHealthProviderRolesBasedOnDefaultRolesMutation,
    UpdateHealthProviderRolesBasedOnDefaultRolesMutationVariables
  >;
export const SyncDefaultRoleDefinitionsDocument = gql`
  mutation syncDefaultRoleDefinitions {
    syncDefaultRoleDefinitions {
      success
    }
  }
`;

/**
 * __useSyncDefaultRoleDefinitionsMutation__
 *
 * To run a mutation, you first call `useSyncDefaultRoleDefinitionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncDefaultRoleDefinitionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncDefaultRoleDefinitionsMutation();
 */
export function useSyncDefaultRoleDefinitionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncDefaultRoleDefinitionsMutation,
        SyncDefaultRoleDefinitionsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncDefaultRoleDefinitionsMutation,
          SyncDefaultRoleDefinitionsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncDefaultRoleDefinitionsMutation,
    SyncDefaultRoleDefinitionsMutationVariables
  >(SyncDefaultRoleDefinitionsDocument, options);
}
export type SyncDefaultRoleDefinitionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SyncDefaultRoleDefinitionsMutation,
  SyncDefaultRoleDefinitionsMutationVariables
>;
export const AddDefaultRolesToHealthProviderDocument = gql`
  mutation addDefaultRolesToHealthProvider($healthProviderName: ID!, $roleIds: [ID!]!) {
    addDefaultRolesToHealthProvider(healthProviderName: $healthProviderName, roleIds: $roleIds) {
      success
    }
  }
`;

/**
 * __useAddDefaultRolesToHealthProviderMutation__
 *
 * To run a mutation, you first call `useAddDefaultRolesToHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddDefaultRolesToHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddDefaultRolesToHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useAddDefaultRolesToHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddDefaultRolesToHealthProviderMutation,
        AddDefaultRolesToHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddDefaultRolesToHealthProviderMutation,
          AddDefaultRolesToHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddDefaultRolesToHealthProviderMutation,
    AddDefaultRolesToHealthProviderMutationVariables
  >(AddDefaultRolesToHealthProviderDocument, options);
}
export type AddDefaultRolesToHealthProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddDefaultRolesToHealthProviderMutation,
  AddDefaultRolesToHealthProviderMutationVariables
>;
export const RemoveDefaultRolesFromHealthProviderDocument = gql`
  mutation removeDefaultRolesFromHealthProvider($healthProviderName: ID!, $roleIds: [ID!]!) {
    removeDefaultRolesFromHealthProvider(healthProviderName: $healthProviderName, roleIds: $roleIds) {
      success
    }
  }
`;

/**
 * __useRemoveDefaultRolesFromHealthProviderMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultRolesFromHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultRolesFromHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveDefaultRolesFromHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useRemoveDefaultRolesFromHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveDefaultRolesFromHealthProviderMutation,
        RemoveDefaultRolesFromHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveDefaultRolesFromHealthProviderMutation,
          RemoveDefaultRolesFromHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveDefaultRolesFromHealthProviderMutation,
    RemoveDefaultRolesFromHealthProviderMutationVariables
  >(RemoveDefaultRolesFromHealthProviderDocument, options);
}
export type RemoveDefaultRolesFromHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveDefaultRolesFromHealthProviderMutation,
    RemoveDefaultRolesFromHealthProviderMutationVariables
  >;
export const CreateTopLevelRolesForHealthProviderDocument = gql`
  mutation createTopLevelRolesForHealthProvider($healthProviderName: ID!, $roleIds: [ID!]!) {
    createTopLevelRolesForHealthProvider(healthProviderName: $healthProviderName, roleIds: $roleIds) {
      success
      message
    }
  }
`;

/**
 * __useCreateTopLevelRolesForHealthProviderMutation__
 *
 * To run a mutation, you first call `useCreateTopLevelRolesForHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopLevelRolesForHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTopLevelRolesForHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *     roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useCreateTopLevelRolesForHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateTopLevelRolesForHealthProviderMutation,
        CreateTopLevelRolesForHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateTopLevelRolesForHealthProviderMutation,
          CreateTopLevelRolesForHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateTopLevelRolesForHealthProviderMutation,
    CreateTopLevelRolesForHealthProviderMutationVariables
  >(CreateTopLevelRolesForHealthProviderDocument, options);
}
export type CreateTopLevelRolesForHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateTopLevelRolesForHealthProviderMutation,
    CreateTopLevelRolesForHealthProviderMutationVariables
  >;
export const CreateSafemateAccountDocument = gql`
  mutation createSafemateAccount($input: SafemateAccountCreateInput!) {
    createSafemateAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateSafemateAccountMutation__
 *
 * To run a mutation, you first call `useCreateSafemateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafemateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSafemateAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafemateAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateSafemateAccountMutation, CreateSafemateAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateSafemateAccountMutation, CreateSafemateAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateSafemateAccountMutation, CreateSafemateAccountMutationVariables>(
    CreateSafemateAccountDocument,
    options,
  );
}
export type CreateSafemateAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSafemateAccountMutation,
  CreateSafemateAccountMutationVariables
>;
export const UpdateSafemateAccountDocument = gql`
  mutation updateSafemateAccount($id: ID!, $input: SafemateAccountUpdateInput!) {
    updateSafemateAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSafemateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateSafemateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafemateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSafemateAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafemateAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSafemateAccountMutation, UpdateSafemateAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateSafemateAccountMutation, UpdateSafemateAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSafemateAccountMutation, UpdateSafemateAccountMutationVariables>(
    UpdateSafemateAccountDocument,
    options,
  );
}
export type UpdateSafemateAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSafemateAccountMutation,
  UpdateSafemateAccountMutationVariables
>;
export const DeleteSafemateAccountDocument = gql`
  mutation deleteSafemateAccount($id: ID!) {
    deleteSafemateAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteSafemateAccountMutation__
 *
 * To run a mutation, you first call `useDeleteSafemateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafemateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSafemateAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSafemateAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteSafemateAccountMutation, DeleteSafemateAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteSafemateAccountMutation, DeleteSafemateAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteSafemateAccountMutation, DeleteSafemateAccountMutationVariables>(
    DeleteSafemateAccountDocument,
    options,
  );
}
export type DeleteSafemateAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteSafemateAccountMutation,
  DeleteSafemateAccountMutationVariables
>;
export const CreateSendGridAccountDocument = gql`
  mutation createSendGridAccount($input: SendGridAccountCreateInput!) {
    createSendGridAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateSendGridAccountMutation__
 *
 * To run a mutation, you first call `useCreateSendGridAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSendGridAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSendGridAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSendGridAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateSendGridAccountMutation, CreateSendGridAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateSendGridAccountMutation, CreateSendGridAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateSendGridAccountMutation, CreateSendGridAccountMutationVariables>(
    CreateSendGridAccountDocument,
    options,
  );
}
export type CreateSendGridAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSendGridAccountMutation,
  CreateSendGridAccountMutationVariables
>;
export const UpdateSendGridAccountDocument = gql`
  mutation updateSendGridAccount($id: ID!, $input: SendGridAccountUpdateInput!) {
    updateSendGridAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSendGridAccountMutation__
 *
 * To run a mutation, you first call `useUpdateSendGridAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSendGridAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSendGridAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSendGridAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSendGridAccountMutation, UpdateSendGridAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateSendGridAccountMutation, UpdateSendGridAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSendGridAccountMutation, UpdateSendGridAccountMutationVariables>(
    UpdateSendGridAccountDocument,
    options,
  );
}
export type UpdateSendGridAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSendGridAccountMutation,
  UpdateSendGridAccountMutationVariables
>;
export const DeleteSendGridAccountDocument = gql`
  mutation deleteSendGridAccount($id: ID!) {
    deleteSendGridAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteSendGridAccountMutation__
 *
 * To run a mutation, you first call `useDeleteSendGridAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSendGridAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSendGridAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSendGridAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteSendGridAccountMutation, DeleteSendGridAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteSendGridAccountMutation, DeleteSendGridAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteSendGridAccountMutation, DeleteSendGridAccountMutationVariables>(
    DeleteSendGridAccountDocument,
    options,
  );
}
export type DeleteSendGridAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteSendGridAccountMutation,
  DeleteSendGridAccountMutationVariables
>;
export const CreateSkyresponseAccountDocument = gql`
  mutation createSkyresponseAccount($input: SkyresponseAccountCreateInput!) {
    createSkyresponseAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateSkyresponseAccountMutation__
 *
 * To run a mutation, you first call `useCreateSkyresponseAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkyresponseAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSkyresponseAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSkyresponseAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateSkyresponseAccountMutation,
        CreateSkyresponseAccountMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateSkyresponseAccountMutation,
          CreateSkyresponseAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateSkyresponseAccountMutation, CreateSkyresponseAccountMutationVariables>(
    CreateSkyresponseAccountDocument,
    options,
  );
}
export type CreateSkyresponseAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSkyresponseAccountMutation,
  CreateSkyresponseAccountMutationVariables
>;
export const UpdateSkyresponseAccountDocument = gql`
  mutation updateSkyresponseAccount($id: ID!, $input: SkyresponseAccountUpdateInput!) {
    updateSkyresponseAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSkyresponseAccountMutation__
 *
 * To run a mutation, you first call `useUpdateSkyresponseAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkyresponseAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSkyresponseAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSkyresponseAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateSkyresponseAccountMutation,
        UpdateSkyresponseAccountMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSkyresponseAccountMutation,
          UpdateSkyresponseAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSkyresponseAccountMutation, UpdateSkyresponseAccountMutationVariables>(
    UpdateSkyresponseAccountDocument,
    options,
  );
}
export type UpdateSkyresponseAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSkyresponseAccountMutation,
  UpdateSkyresponseAccountMutationVariables
>;
export const DeleteSkyresponseAccountDocument = gql`
  mutation deleteSkyresponseAccount($id: ID!) {
    deleteSkyresponseAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteSkyresponseAccountMutation__
 *
 * To run a mutation, you first call `useDeleteSkyresponseAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkyresponseAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSkyresponseAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSkyresponseAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteSkyresponseAccountMutation,
        DeleteSkyresponseAccountMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteSkyresponseAccountMutation,
          DeleteSkyresponseAccountMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteSkyresponseAccountMutation, DeleteSkyresponseAccountMutationVariables>(
    DeleteSkyresponseAccountDocument,
    options,
  );
}
export type DeleteSkyresponseAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteSkyresponseAccountMutation,
  DeleteSkyresponseAccountMutationVariables
>;
export const SyncDefaultDeviceTypesDocument = gql`
  mutation syncDefaultDeviceTypes {
    syncDefaultDeviceTypes {
      success
      message
    }
  }
`;

/**
 * __useSyncDefaultDeviceTypesMutation__
 *
 * To run a mutation, you first call `useSyncDefaultDeviceTypesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncDefaultDeviceTypesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncDefaultDeviceTypesMutation();
 */
export function useSyncDefaultDeviceTypesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SyncDefaultDeviceTypesMutation, SyncDefaultDeviceTypesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SyncDefaultDeviceTypesMutation, SyncDefaultDeviceTypesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SyncDefaultDeviceTypesMutation, SyncDefaultDeviceTypesMutationVariables>(
    SyncDefaultDeviceTypesDocument,
    options,
  );
}
export type SyncDefaultDeviceTypesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SyncDefaultDeviceTypesMutation,
  SyncDefaultDeviceTypesMutationVariables
>;
export const SyncDefaultExternalIdentityProvidersDocument = gql`
  mutation syncDefaultExternalIdentityProviders {
    syncDefaultExternalIdentityProviders {
      success
      message
    }
  }
`;

/**
 * __useSyncDefaultExternalIdentityProvidersMutation__
 *
 * To run a mutation, you first call `useSyncDefaultExternalIdentityProvidersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncDefaultExternalIdentityProvidersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncDefaultExternalIdentityProvidersMutation();
 */
export function useSyncDefaultExternalIdentityProvidersMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncDefaultExternalIdentityProvidersMutation,
        SyncDefaultExternalIdentityProvidersMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncDefaultExternalIdentityProvidersMutation,
          SyncDefaultExternalIdentityProvidersMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncDefaultExternalIdentityProvidersMutation,
    SyncDefaultExternalIdentityProvidersMutationVariables
  >(SyncDefaultExternalIdentityProvidersDocument, options);
}
export type SyncDefaultExternalIdentityProvidersMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SyncDefaultExternalIdentityProvidersMutation,
    SyncDefaultExternalIdentityProvidersMutationVariables
  >;
export const SyncExternalHumanIdTypesWithDefaultsDocument = gql`
  mutation syncExternalHumanIdTypesWithDefaults {
    syncExternalHumanIdTypesWithDefaults {
      success
      message
    }
  }
`;

/**
 * __useSyncExternalHumanIdTypesWithDefaultsMutation__
 *
 * To run a mutation, you first call `useSyncExternalHumanIdTypesWithDefaultsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncExternalHumanIdTypesWithDefaultsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncExternalHumanIdTypesWithDefaultsMutation();
 */
export function useSyncExternalHumanIdTypesWithDefaultsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncExternalHumanIdTypesWithDefaultsMutation,
        SyncExternalHumanIdTypesWithDefaultsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncExternalHumanIdTypesWithDefaultsMutation,
          SyncExternalHumanIdTypesWithDefaultsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncExternalHumanIdTypesWithDefaultsMutation,
    SyncExternalHumanIdTypesWithDefaultsMutationVariables
  >(SyncExternalHumanIdTypesWithDefaultsDocument, options);
}
export type SyncExternalHumanIdTypesWithDefaultsMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SyncExternalHumanIdTypesWithDefaultsMutation,
    SyncExternalHumanIdTypesWithDefaultsMutationVariables
  >;
export const CreateTcifAccountDocument = gql`
  mutation createTcifAccount($input: TcifAccountCreateInput!) {
    createTcifAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateTcifAccountMutation__
 *
 * To run a mutation, you first call `useCreateTcifAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTcifAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTcifAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTcifAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateTcifAccountMutation, CreateTcifAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateTcifAccountMutation, CreateTcifAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateTcifAccountMutation, CreateTcifAccountMutationVariables>(
    CreateTcifAccountDocument,
    options,
  );
}
export type CreateTcifAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateTcifAccountMutation,
  CreateTcifAccountMutationVariables
>;
export const DeleteTcifAccountDocument = gql`
  mutation deleteTcifAccount($id: ID!) {
    deleteTcifAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteTcifAccountMutation__
 *
 * To run a mutation, you first call `useDeleteTcifAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTcifAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTcifAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTcifAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteTcifAccountMutation, DeleteTcifAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteTcifAccountMutation, DeleteTcifAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteTcifAccountMutation, DeleteTcifAccountMutationVariables>(
    DeleteTcifAccountDocument,
    options,
  );
}
export type DeleteTcifAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteTcifAccountMutation,
  DeleteTcifAccountMutationVariables
>;
export const CreateTimeLimitedFhirCredentialsForHealthProviderDocument = gql`
  mutation createTimeLimitedFhirCredentialsForHealthProvider($healthProviderName: ID!) {
    createTimeLimitedFhirCredentialsForHealthProvider(healthProviderName: $healthProviderName)
  }
`;

/**
 * __useCreateTimeLimitedFhirCredentialsForHealthProviderMutation__
 *
 * To run a mutation, you first call `useCreateTimeLimitedFhirCredentialsForHealthProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeLimitedFhirCredentialsForHealthProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTimeLimitedFhirCredentialsForHealthProviderMutation({
 *   variables: {
 *     healthProviderName: // value for 'healthProviderName'
 *   },
 * });
 */
export function useCreateTimeLimitedFhirCredentialsForHealthProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateTimeLimitedFhirCredentialsForHealthProviderMutation,
        CreateTimeLimitedFhirCredentialsForHealthProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateTimeLimitedFhirCredentialsForHealthProviderMutation,
          CreateTimeLimitedFhirCredentialsForHealthProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateTimeLimitedFhirCredentialsForHealthProviderMutation,
    CreateTimeLimitedFhirCredentialsForHealthProviderMutationVariables
  >(CreateTimeLimitedFhirCredentialsForHealthProviderDocument, options);
}
export type CreateTimeLimitedFhirCredentialsForHealthProviderMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateTimeLimitedFhirCredentialsForHealthProviderMutation,
    CreateTimeLimitedFhirCredentialsForHealthProviderMutationVariables
  >;
export const CreateTwilioAccountDocument = gql`
  mutation createTwilioAccount($input: TwilioAccountCreateInput!) {
    createTwilioAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateTwilioAccountMutation__
 *
 * To run a mutation, you first call `useCreateTwilioAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTwilioAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTwilioAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateTwilioAccountMutation, CreateTwilioAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateTwilioAccountMutation, CreateTwilioAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateTwilioAccountMutation, CreateTwilioAccountMutationVariables>(
    CreateTwilioAccountDocument,
    options,
  );
}
export type CreateTwilioAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateTwilioAccountMutation,
  CreateTwilioAccountMutationVariables
>;
export const UpdateTwilioAccountDocument = gql`
  mutation updateTwilioAccount($id: ID!, $input: TwilioAccountUpdateInput!) {
    updateTwilioAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateTwilioAccountMutation__
 *
 * To run a mutation, you first call `useUpdateTwilioAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwilioAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTwilioAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTwilioAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateTwilioAccountMutation, UpdateTwilioAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateTwilioAccountMutation, UpdateTwilioAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateTwilioAccountMutation, UpdateTwilioAccountMutationVariables>(
    UpdateTwilioAccountDocument,
    options,
  );
}
export type UpdateTwilioAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTwilioAccountMutation,
  UpdateTwilioAccountMutationVariables
>;
export const DeleteTwilioAccountDocument = gql`
  mutation deleteTwilioAccount($id: ID!) {
    deleteTwilioAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteTwilioAccountMutation__
 *
 * To run a mutation, you first call `useDeleteTwilioAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTwilioAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTwilioAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTwilioAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteTwilioAccountMutation, DeleteTwilioAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteTwilioAccountMutation, DeleteTwilioAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteTwilioAccountMutation, DeleteTwilioAccountMutationVariables>(
    DeleteTwilioAccountDocument,
    options,
  );
}
export type DeleteTwilioAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteTwilioAccountMutation,
  DeleteTwilioAccountMutationVariables
>;
export const DeleteUserManualDocument = gql`
  mutation deleteUserManual($id: ID!) {
    deleteUserManual(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteUserManualMutation__
 *
 * To run a mutation, you first call `useDeleteUserManualMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserManualMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserManualMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserManualMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteUserManualMutation, DeleteUserManualMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteUserManualMutation, DeleteUserManualMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteUserManualMutation, DeleteUserManualMutationVariables>(
    DeleteUserManualDocument,
    options,
  );
}
export type DeleteUserManualMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteUserManualMutation,
  DeleteUserManualMutationVariables
>;
export const UpdateUserManualDocument = gql`
  mutation updateUserManual($id: ID!, $updateInput: UpdateUserManualInput!) {
    updateUserManual(id: $id, updateInput: $updateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateUserManualMutation__
 *
 * To run a mutation, you first call `useUpdateUserManualMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserManualMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserManualMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateUserManualMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserManualMutation, UpdateUserManualMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserManualMutation, UpdateUserManualMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserManualMutation, UpdateUserManualMutationVariables>(
    UpdateUserManualDocument,
    options,
  );
}
export type UpdateUserManualMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserManualMutation,
  UpdateUserManualMutationVariables
>;
export const CreateUserManualDocument = gql`
  mutation createUserManual($createInput: CreateUserManualInput!) {
    createUserManual(createInput: $createInput) {
      success
      message
    }
  }
`;

/**
 * __useCreateUserManualMutation__
 *
 * To run a mutation, you first call `useCreateUserManualMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserManualMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserManualMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateUserManualMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUserManualMutation, CreateUserManualMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateUserManualMutation, CreateUserManualMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateUserManualMutation, CreateUserManualMutationVariables>(
    CreateUserManualDocument,
    options,
  );
}
export type CreateUserManualMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserManualMutation,
  CreateUserManualMutationVariables
>;
export const CreateVideonorAccountDocument = gql`
  mutation createVideonorAccount($input: VideonorAccountCreateInput!) {
    createVideonorAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateVideonorAccountMutation__
 *
 * To run a mutation, you first call `useCreateVideonorAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideonorAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVideonorAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideonorAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateVideonorAccountMutation, CreateVideonorAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateVideonorAccountMutation, CreateVideonorAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateVideonorAccountMutation, CreateVideonorAccountMutationVariables>(
    CreateVideonorAccountDocument,
    options,
  );
}
export type CreateVideonorAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateVideonorAccountMutation,
  CreateVideonorAccountMutationVariables
>;
export const UpdateVideonorAccountDocument = gql`
  mutation updateVideonorAccount($id: ID!, $input: VideonorAccountUpdateInput!) {
    updateVideonorAccount(id: $id, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateVideonorAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVideonorAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideonorAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVideonorAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideonorAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateVideonorAccountMutation, UpdateVideonorAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateVideonorAccountMutation, UpdateVideonorAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateVideonorAccountMutation, UpdateVideonorAccountMutationVariables>(
    UpdateVideonorAccountDocument,
    options,
  );
}
export type UpdateVideonorAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateVideonorAccountMutation,
  UpdateVideonorAccountMutationVariables
>;
export const DeleteVideonorAccountDocument = gql`
  mutation deleteVideonorAccount($id: ID!) {
    deleteVideonorAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteVideonorAccountMutation__
 *
 * To run a mutation, you first call `useDeleteVideonorAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideonorAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVideonorAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVideonorAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteVideonorAccountMutation, DeleteVideonorAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteVideonorAccountMutation, DeleteVideonorAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteVideonorAccountMutation, DeleteVideonorAccountMutationVariables>(
    DeleteVideonorAccountDocument,
    options,
  );
}
export type DeleteVideonorAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteVideonorAccountMutation,
  DeleteVideonorAccountMutationVariables
>;
export const CustomersDocument = gql`
  query customers {
    customers {
      id
      name
      reference
      type
      accounts
    }
  }
`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a Vue component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCustomersQuery();
 */
export function useCustomersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, {}, options);
}
export function useCustomersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomersQuery, CustomersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, {}, options);
}
export type CustomersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CustomersQuery,
  CustomersQueryVariables
>;
export const UnmanagedAccountsDocument = gql`
  query unmanagedAccounts {
    unmanagedAccounts {
      name
      hasRpm
      hasSupervision
      usage
    }
  }
`;

/**
 * __useUnmanagedAccountsQuery__
 *
 * To run a query within a Vue component, call `useUnmanagedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnmanagedAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnmanagedAccountsQuery();
 */
export function useUnmanagedAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>(
    UnmanagedAccountsDocument,
    {},
    options,
  );
}
export function useUnmanagedAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UnmanagedAccountsQuery, UnmanagedAccountsQueryVariables>(
    UnmanagedAccountsDocument,
    {},
    options,
  );
}
export type UnmanagedAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UnmanagedAccountsQuery,
  UnmanagedAccountsQueryVariables
>;
export const DailyAuditLogStatsDocument = gql`
  query dailyAuditLogStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    dailyAuditLogStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        sessionStart
        sessionEnd
        userId
        userGroupName
        roleInstanceName
        roleDefinitionId
        defaultRoleDefinitionId
        numberOfOperations
      }
    }
  }
`;

/**
 * __useDailyAuditLogStatsQuery__
 *
 * To run a query within a Vue component, call `useDailyAuditLogStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyAuditLogStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDailyAuditLogStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useDailyAuditLogStatsQuery(
  variables:
    | DailyAuditLogStatsQueryVariables
    | VueCompositionApi.Ref<DailyAuditLogStatsQueryVariables>
    | ReactiveFunction<DailyAuditLogStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>(
    DailyAuditLogStatsDocument,
    variables,
    options,
  );
}
export function useDailyAuditLogStatsLazyQuery(
  variables?:
    | DailyAuditLogStatsQueryVariables
    | VueCompositionApi.Ref<DailyAuditLogStatsQueryVariables>
    | ReactiveFunction<DailyAuditLogStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DailyAuditLogStatsQuery, DailyAuditLogStatsQueryVariables>(
    DailyAuditLogStatsDocument,
    variables,
    options,
  );
}
export type DailyAuditLogStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DailyAuditLogStatsQuery,
  DailyAuditLogStatsQueryVariables
>;
export const DailyDeviceStatsDocument = gql`
  query dailyDeviceStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    dailyDeviceStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        timestamp
        startTimestamp
        endTimestamp
        deviceType
        devices
        online
        active
        technicalAlarms
        technicalAlarmEvents
      }
    }
  }
`;

/**
 * __useDailyDeviceStatsQuery__
 *
 * To run a query within a Vue component, call `useDailyDeviceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyDeviceStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDailyDeviceStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useDailyDeviceStatsQuery(
  variables:
    | DailyDeviceStatsQueryVariables
    | VueCompositionApi.Ref<DailyDeviceStatsQueryVariables>
    | ReactiveFunction<DailyDeviceStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>(
    DailyDeviceStatsDocument,
    variables,
    options,
  );
}
export function useDailyDeviceStatsLazyQuery(
  variables?:
    | DailyDeviceStatsQueryVariables
    | VueCompositionApi.Ref<DailyDeviceStatsQueryVariables>
    | ReactiveFunction<DailyDeviceStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DailyDeviceStatsQuery, DailyDeviceStatsQueryVariables>(
    DailyDeviceStatsDocument,
    variables,
    options,
  );
}
export type DailyDeviceStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DailyDeviceStatsQuery,
  DailyDeviceStatsQueryVariables
>;
export const DailyPatientStatsDocument = gql`
  query dailyPatientStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    dailyPatientStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        timestamp
        activePatients
        inactivePatients
        startTimestamp
        endTimestamp
        questionnaireResponses
        manualObservations
        deviceObservations
        alarms
        alarmEvents
      }
    }
  }
`;

/**
 * __useDailyPatientStatsQuery__
 *
 * To run a query within a Vue component, call `useDailyPatientStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyPatientStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDailyPatientStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useDailyPatientStatsQuery(
  variables:
    | DailyPatientStatsQueryVariables
    | VueCompositionApi.Ref<DailyPatientStatsQueryVariables>
    | ReactiveFunction<DailyPatientStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>(
    DailyPatientStatsDocument,
    variables,
    options,
  );
}
export function useDailyPatientStatsLazyQuery(
  variables?:
    | DailyPatientStatsQueryVariables
    | VueCompositionApi.Ref<DailyPatientStatsQueryVariables>
    | ReactiveFunction<DailyPatientStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DailyPatientStatsQuery, DailyPatientStatsQueryVariables>(
    DailyPatientStatsDocument,
    variables,
    options,
  );
}
export type DailyPatientStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DailyPatientStatsQuery,
  DailyPatientStatsQueryVariables
>;
export const DailyUserStatsDocument = gql`
  query dailyUserStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    dailyUserStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        timestamp
        startTimestamp
        endTimestamp
        healthPersonnelUsers
        healthPersonnelActive
        healthPersonnelLoginErrors
        healthPersonnelDefaultLogin
        healthPersonnelExternalLogin
        dialoggUsers
        dialoggUsersActive
        dialoggUsersLoginErrors
        dialoggUsersDefaultLogin
        dialoggUsersExternalLogin
      }
    }
  }
`;

/**
 * __useDailyUserStatsQuery__
 *
 * To run a query within a Vue component, call `useDailyUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyUserStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDailyUserStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useDailyUserStatsQuery(
  variables:
    | DailyUserStatsQueryVariables
    | VueCompositionApi.Ref<DailyUserStatsQueryVariables>
    | ReactiveFunction<DailyUserStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DailyUserStatsQuery, DailyUserStatsQueryVariables>(
    DailyUserStatsDocument,
    variables,
    options,
  );
}
export function useDailyUserStatsLazyQuery(
  variables?:
    | DailyUserStatsQueryVariables
    | VueCompositionApi.Ref<DailyUserStatsQueryVariables>
    | ReactiveFunction<DailyUserStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyUserStatsQuery, DailyUserStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DailyUserStatsQuery, DailyUserStatsQueryVariables>(
    DailyUserStatsDocument,
    variables,
    options,
  );
}
export type DailyUserStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DailyUserStatsQuery,
  DailyUserStatsQueryVariables
>;
export const AllExternalAccessDocument = gql`
  query allExternalAccess($healthProviderName: String) {
    allExternalAccess(healthProviderName: $healthProviderName) {
      id
      healthProviderName
      name
      ipRestrictions
      patientGroupIds
      allowedAccess
      forwarderId
    }
  }
`;

/**
 * __useAllExternalAccessQuery__
 *
 * To run a query within a Vue component, call `useAllExternalAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExternalAccessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllExternalAccessQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useAllExternalAccessQuery(
  variables:
    | AllExternalAccessQueryVariables
    | VueCompositionApi.Ref<AllExternalAccessQueryVariables>
    | ReactiveFunction<AllExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllExternalAccessQuery, AllExternalAccessQueryVariables>(
    AllExternalAccessDocument,
    variables,
    options,
  );
}
export function useAllExternalAccessLazyQuery(
  variables:
    | AllExternalAccessQueryVariables
    | VueCompositionApi.Ref<AllExternalAccessQueryVariables>
    | ReactiveFunction<AllExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllExternalAccessQuery, AllExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllExternalAccessQuery, AllExternalAccessQueryVariables>(
    AllExternalAccessDocument,
    variables,
    options,
  );
}
export type AllExternalAccessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllExternalAccessQuery,
  AllExternalAccessQueryVariables
>;
export const GetExternalAccessNamesDocument = gql`
  query getExternalAccessNames {
    getExternalAccessNames {
      externalAccessNameToShow
      externalAccessName
    }
  }
`;

/**
 * __useGetExternalAccessNamesQuery__
 *
 * To run a query within a Vue component, call `useGetExternalAccessNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalAccessNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExternalAccessNamesQuery();
 */
export function useGetExternalAccessNamesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>(
    GetExternalAccessNamesDocument,
    {},
    options,
  );
}
export function useGetExternalAccessNamesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetExternalAccessNamesQuery, GetExternalAccessNamesQueryVariables>(
    GetExternalAccessNamesDocument,
    {},
    options,
  );
}
export type GetExternalAccessNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetExternalAccessNamesQuery,
  GetExternalAccessNamesQueryVariables
>;
export const ExternalIdentityProvidersForHealthProviderDocument = gql`
  query externalIdentityProvidersForHealthProvider($healthProviderName: String!) {
    externalIdentityProvidersForHealthProvider(healthProviderName: $healthProviderName) {
      id
      externalIdentityProvider {
        provider
        display {
          localeId
          displayName
          description
        }
        client {
          localeId
          displayName
          description
        }
        tenant {
          localeId
          displayName
          description
        }
      }
      alias
      clientId
      displayName
      tenantId
      patientRealm
      prio
      support
    }
  }
`;

/**
 * __useExternalIdentityProvidersForHealthProviderQuery__
 *
 * To run a query within a Vue component, call `useExternalIdentityProvidersForHealthProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentityProvidersForHealthProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalIdentityProvidersForHealthProviderQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useExternalIdentityProvidersForHealthProviderQuery(
  variables:
    | ExternalIdentityProvidersForHealthProviderQueryVariables
    | VueCompositionApi.Ref<ExternalIdentityProvidersForHealthProviderQueryVariables>
    | ReactiveFunction<ExternalIdentityProvidersForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProvidersForHealthProviderQuery,
        ExternalIdentityProvidersForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForHealthProviderQuery,
          ExternalIdentityProvidersForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForHealthProviderQuery,
          ExternalIdentityProvidersForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    ExternalIdentityProvidersForHealthProviderQuery,
    ExternalIdentityProvidersForHealthProviderQueryVariables
  >(ExternalIdentityProvidersForHealthProviderDocument, variables, options);
}
export function useExternalIdentityProvidersForHealthProviderLazyQuery(
  variables?:
    | ExternalIdentityProvidersForHealthProviderQueryVariables
    | VueCompositionApi.Ref<ExternalIdentityProvidersForHealthProviderQueryVariables>
    | ReactiveFunction<ExternalIdentityProvidersForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProvidersForHealthProviderQuery,
        ExternalIdentityProvidersForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForHealthProviderQuery,
          ExternalIdentityProvidersForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForHealthProviderQuery,
          ExternalIdentityProvidersForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ExternalIdentityProvidersForHealthProviderQuery,
    ExternalIdentityProvidersForHealthProviderQueryVariables
  >(ExternalIdentityProvidersForHealthProviderDocument, variables, options);
}
export type ExternalIdentityProvidersForHealthProviderQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    ExternalIdentityProvidersForHealthProviderQuery,
    ExternalIdentityProvidersForHealthProviderQueryVariables
  >;
export const ExternalIdentityProviderRedirectorsForHealthProviderDocument = gql`
  query externalIdentityProviderRedirectorsForHealthProvider(
    $healthProviderName: String!
    $includePatientRealm: Boolean
  ) {
    externalIdentityProviderRedirectorsForHealthProvider(
      healthProviderName: $healthProviderName
      includePatientRealm: $includePatientRealm
    ) {
      id
      alias
      isPatientRealm
      config {
        defaultProvider
      }
    }
  }
`;

/**
 * __useExternalIdentityProviderRedirectorsForHealthProviderQuery__
 *
 * To run a query within a Vue component, call `useExternalIdentityProviderRedirectorsForHealthProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentityProviderRedirectorsForHealthProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalIdentityProviderRedirectorsForHealthProviderQuery({
 *   healthProviderName: // value for 'healthProviderName'
 *   includePatientRealm: // value for 'includePatientRealm'
 * });
 */
export function useExternalIdentityProviderRedirectorsForHealthProviderQuery(
  variables:
    | ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
    | VueCompositionApi.Ref<ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables>
    | ReactiveFunction<ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProviderRedirectorsForHealthProviderQuery,
        ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProviderRedirectorsForHealthProviderQuery,
          ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProviderRedirectorsForHealthProviderQuery,
          ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    ExternalIdentityProviderRedirectorsForHealthProviderQuery,
    ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
  >(ExternalIdentityProviderRedirectorsForHealthProviderDocument, variables, options);
}
export function useExternalIdentityProviderRedirectorsForHealthProviderLazyQuery(
  variables?:
    | ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
    | VueCompositionApi.Ref<ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables>
    | ReactiveFunction<ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProviderRedirectorsForHealthProviderQuery,
        ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProviderRedirectorsForHealthProviderQuery,
          ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProviderRedirectorsForHealthProviderQuery,
          ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ExternalIdentityProviderRedirectorsForHealthProviderQuery,
    ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
  >(ExternalIdentityProviderRedirectorsForHealthProviderDocument, variables, options);
}
export type ExternalIdentityProviderRedirectorsForHealthProviderQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    ExternalIdentityProviderRedirectorsForHealthProviderQuery,
    ExternalIdentityProviderRedirectorsForHealthProviderQueryVariables
  >;
export const ExternalIdentityProvidersDocument = gql`
  query externalIdentityProviders {
    externalIdentityProviders {
      provider
      display {
        localeId
        displayName
        description
      }
      client {
        localeId
        displayName
        description
      }
      tenant {
        localeId
        displayName
        description
      }
    }
  }
`;

/**
 * __useExternalIdentityProvidersQuery__
 *
 * To run a query within a Vue component, call `useExternalIdentityProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentityProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalIdentityProvidersQuery();
 */
export function useExternalIdentityProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>(
    ExternalIdentityProvidersDocument,
    {},
    options,
  );
}
export function useExternalIdentityProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ExternalIdentityProvidersQuery, ExternalIdentityProvidersQueryVariables>(
    ExternalIdentityProvidersDocument,
    {},
    options,
  );
}
export type ExternalIdentityProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ExternalIdentityProvidersQuery,
  ExternalIdentityProvidersQueryVariables
>;
export const ExternalIdentityProvidersForAllHealthProvidersDocument = gql`
  query externalIdentityProvidersForAllHealthProviders {
    externalIdentityProvidersForAllHealthProviders {
      id
      alias
      healthProviderName
      patientRealm
      support
      externalIdentityProvider {
        provider
      }
    }
  }
`;

/**
 * __useExternalIdentityProvidersForAllHealthProvidersQuery__
 *
 * To run a query within a Vue component, call `useExternalIdentityProvidersForAllHealthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentityProvidersForAllHealthProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalIdentityProvidersForAllHealthProvidersQuery();
 */
export function useExternalIdentityProvidersForAllHealthProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProvidersForAllHealthProvidersQuery,
        ExternalIdentityProvidersForAllHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForAllHealthProvidersQuery,
          ExternalIdentityProvidersForAllHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForAllHealthProvidersQuery,
          ExternalIdentityProvidersForAllHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    ExternalIdentityProvidersForAllHealthProvidersQuery,
    ExternalIdentityProvidersForAllHealthProvidersQueryVariables
  >(ExternalIdentityProvidersForAllHealthProvidersDocument, {}, options);
}
export function useExternalIdentityProvidersForAllHealthProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ExternalIdentityProvidersForAllHealthProvidersQuery,
        ExternalIdentityProvidersForAllHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForAllHealthProvidersQuery,
          ExternalIdentityProvidersForAllHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ExternalIdentityProvidersForAllHealthProvidersQuery,
          ExternalIdentityProvidersForAllHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ExternalIdentityProvidersForAllHealthProvidersQuery,
    ExternalIdentityProvidersForAllHealthProvidersQueryVariables
  >(ExternalIdentityProvidersForAllHealthProvidersDocument, {}, options);
}
export type ExternalIdentityProvidersForAllHealthProvidersQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    ExternalIdentityProvidersForAllHealthProvidersQuery,
    ExternalIdentityProvidersForAllHealthProvidersQueryVariables
  >;
export const GlobalStatsDocument = gql`
  query globalStats($date: date!) {
    globalStats(date: $date) {
      healthProvider
      allPatientStats {
        active
        inactive
      }
      personnel
      novo
      cameras
      notifyEnabledNextOfKins
    }
  }
`;

/**
 * __useGlobalStatsQuery__
 *
 * To run a query within a Vue component, call `useGlobalStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGlobalStatsQuery({
 *   date: // value for 'date'
 * });
 */
export function useGlobalStatsQuery(
  variables:
    | GlobalStatsQueryVariables
    | VueCompositionApi.Ref<GlobalStatsQueryVariables>
    | ReactiveFunction<GlobalStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GlobalStatsQuery, GlobalStatsQueryVariables>(
    GlobalStatsDocument,
    variables,
    options,
  );
}
export function useGlobalStatsLazyQuery(
  variables?:
    | GlobalStatsQueryVariables
    | VueCompositionApi.Ref<GlobalStatsQueryVariables>
    | ReactiveFunction<GlobalStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GlobalStatsQuery, GlobalStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GlobalStatsQuery, GlobalStatsQueryVariables>(
    GlobalStatsDocument,
    variables,
    options,
  );
}
export type GlobalStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GlobalStatsQuery,
  GlobalStatsQueryVariables
>;
export const GooglemapsAccountsDocument = gql`
  query googlemapsAccounts {
    googlemapsAccounts {
      id
      accountDisplayName
      apiUrl
    }
  }
`;

/**
 * __useGooglemapsAccountsQuery__
 *
 * To run a query within a Vue component, call `useGooglemapsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGooglemapsAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGooglemapsAccountsQuery();
 */
export function useGooglemapsAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>(
    GooglemapsAccountsDocument,
    {},
    options,
  );
}
export function useGooglemapsAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GooglemapsAccountsQuery, GooglemapsAccountsQueryVariables>(
    GooglemapsAccountsDocument,
    {},
    options,
  );
}
export type GooglemapsAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GooglemapsAccountsQuery,
  GooglemapsAccountsQueryVariables
>;
export const SupportTeamsForHealthProviderDocument = gql`
  query supportTeamsForHealthProvider($healthProviderName: ID!) {
    supportTeamsForHealthProvider(healthProviderName: $healthProviderName) {
      name
      displayName
      linked
    }
  }
`;

/**
 * __useSupportTeamsForHealthProviderQuery__
 *
 * To run a query within a Vue component, call `useSupportTeamsForHealthProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamsForHealthProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportTeamsForHealthProviderQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useSupportTeamsForHealthProviderQuery(
  variables:
    | SupportTeamsForHealthProviderQueryVariables
    | VueCompositionApi.Ref<SupportTeamsForHealthProviderQueryVariables>
    | ReactiveFunction<SupportTeamsForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamsForHealthProviderQuery,
        SupportTeamsForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsForHealthProviderQuery,
          SupportTeamsForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsForHealthProviderQuery,
          SupportTeamsForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<SupportTeamsForHealthProviderQuery, SupportTeamsForHealthProviderQueryVariables>(
    SupportTeamsForHealthProviderDocument,
    variables,
    options,
  );
}
export function useSupportTeamsForHealthProviderLazyQuery(
  variables?:
    | SupportTeamsForHealthProviderQueryVariables
    | VueCompositionApi.Ref<SupportTeamsForHealthProviderQueryVariables>
    | ReactiveFunction<SupportTeamsForHealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamsForHealthProviderQuery,
        SupportTeamsForHealthProviderQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsForHealthProviderQuery,
          SupportTeamsForHealthProviderQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsForHealthProviderQuery,
          SupportTeamsForHealthProviderQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    SupportTeamsForHealthProviderQuery,
    SupportTeamsForHealthProviderQueryVariables
  >(SupportTeamsForHealthProviderDocument, variables, options);
}
export type SupportTeamsForHealthProviderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportTeamsForHealthProviderQuery,
  SupportTeamsForHealthProviderQueryVariables
>;
export const HealthProvidersDocument = gql`
  query healthProviders {
    healthProviders {
      name
      displayName
      hasRpm
      hasSupervision
      hasSupportTeam
      hasDhv
      hasResponse
      features {
        continuousSupervision
      }
    }
  }
`;

/**
 * __useHealthProvidersQuery__
 *
 * To run a query within a Vue component, call `useHealthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProvidersQuery();
 */
export function useHealthProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<HealthProvidersQuery, HealthProvidersQueryVariables>(
    HealthProvidersDocument,
    {},
    options,
  );
}
export function useHealthProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HealthProvidersQuery, HealthProvidersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<HealthProvidersQuery, HealthProvidersQueryVariables>(
    HealthProvidersDocument,
    {},
    options,
  );
}
export type HealthProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProvidersQuery,
  HealthProvidersQueryVariables
>;
export const GetHealthProviderMarkedForDeletionFlowStatusDocument = gql`
  query getHealthProviderMarkedForDeletionFlowStatus($healthProviderName: ID!) {
    getHealthProviderMarkedForDeletionFlowStatus(healthProviderName: $healthProviderName) {
      ...AdminHealthProviderFlowStatus
    }
  }
  ${AdminHealthProviderFlowStatusFragmentDoc}
`;

/**
 * __useGetHealthProviderMarkedForDeletionFlowStatusQuery__
 *
 * To run a query within a Vue component, call `useGetHealthProviderMarkedForDeletionFlowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthProviderMarkedForDeletionFlowStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHealthProviderMarkedForDeletionFlowStatusQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useGetHealthProviderMarkedForDeletionFlowStatusQuery(
  variables:
    | GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetHealthProviderMarkedForDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetHealthProviderMarkedForDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProviderMarkedForDeletionFlowStatusQuery,
        GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderMarkedForDeletionFlowStatusQuery,
          GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderMarkedForDeletionFlowStatusQuery,
          GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetHealthProviderMarkedForDeletionFlowStatusQuery,
    GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >(GetHealthProviderMarkedForDeletionFlowStatusDocument, variables, options);
}
export function useGetHealthProviderMarkedForDeletionFlowStatusLazyQuery(
  variables?:
    | GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetHealthProviderMarkedForDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetHealthProviderMarkedForDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProviderMarkedForDeletionFlowStatusQuery,
        GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderMarkedForDeletionFlowStatusQuery,
          GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderMarkedForDeletionFlowStatusQuery,
          GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetHealthProviderMarkedForDeletionFlowStatusQuery,
    GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >(GetHealthProviderMarkedForDeletionFlowStatusDocument, variables, options);
}
export type GetHealthProviderMarkedForDeletionFlowStatusQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetHealthProviderMarkedForDeletionFlowStatusQuery,
    GetHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >;
export const GetRestoreHealthProviderMarkedForDeletionFlowStatusDocument = gql`
  query getRestoreHealthProviderMarkedForDeletionFlowStatus($healthProviderName: ID!) {
    getRestoreHealthProviderMarkedForDeletionFlowStatus(healthProviderName: $healthProviderName) {
      ...AdminHealthProviderFlowStatus
    }
  }
  ${AdminHealthProviderFlowStatusFragmentDoc}
`;

/**
 * __useGetRestoreHealthProviderMarkedForDeletionFlowStatusQuery__
 *
 * To run a query within a Vue component, call `useGetRestoreHealthProviderMarkedForDeletionFlowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestoreHealthProviderMarkedForDeletionFlowStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRestoreHealthProviderMarkedForDeletionFlowStatusQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useGetRestoreHealthProviderMarkedForDeletionFlowStatusQuery(
  variables:
    | GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
        GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >(GetRestoreHealthProviderMarkedForDeletionFlowStatusDocument, variables, options);
}
export function useGetRestoreHealthProviderMarkedForDeletionFlowStatusLazyQuery(
  variables?:
    | GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
        GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
          GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >(GetRestoreHealthProviderMarkedForDeletionFlowStatusDocument, variables, options);
}
export type GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQuery,
    GetRestoreHealthProviderMarkedForDeletionFlowStatusQueryVariables
  >;
export const GetHealthProviderDeletionFlowStatusDocument = gql`
  query getHealthProviderDeletionFlowStatus($healthProviderName: ID!) {
    getHealthProviderDeletionFlowStatus(healthProviderName: $healthProviderName) {
      ...AdminHealthProviderFlowStatus
    }
  }
  ${AdminHealthProviderFlowStatusFragmentDoc}
`;

/**
 * __useGetHealthProviderDeletionFlowStatusQuery__
 *
 * To run a query within a Vue component, call `useGetHealthProviderDeletionFlowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthProviderDeletionFlowStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHealthProviderDeletionFlowStatusQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useGetHealthProviderDeletionFlowStatusQuery(
  variables:
    | GetHealthProviderDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetHealthProviderDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetHealthProviderDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProviderDeletionFlowStatusQuery,
        GetHealthProviderDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderDeletionFlowStatusQuery,
          GetHealthProviderDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderDeletionFlowStatusQuery,
          GetHealthProviderDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetHealthProviderDeletionFlowStatusQuery,
    GetHealthProviderDeletionFlowStatusQueryVariables
  >(GetHealthProviderDeletionFlowStatusDocument, variables, options);
}
export function useGetHealthProviderDeletionFlowStatusLazyQuery(
  variables?:
    | GetHealthProviderDeletionFlowStatusQueryVariables
    | VueCompositionApi.Ref<GetHealthProviderDeletionFlowStatusQueryVariables>
    | ReactiveFunction<GetHealthProviderDeletionFlowStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProviderDeletionFlowStatusQuery,
        GetHealthProviderDeletionFlowStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderDeletionFlowStatusQuery,
          GetHealthProviderDeletionFlowStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProviderDeletionFlowStatusQuery,
          GetHealthProviderDeletionFlowStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetHealthProviderDeletionFlowStatusQuery,
    GetHealthProviderDeletionFlowStatusQueryVariables
  >(GetHealthProviderDeletionFlowStatusDocument, variables, options);
}
export type GetHealthProviderDeletionFlowStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetHealthProviderDeletionFlowStatusQuery,
  GetHealthProviderDeletionFlowStatusQueryVariables
>;
export const GetAllFinishedHealthProviderDeletionFlowStatusesDocument = gql`
  query getAllFinishedHealthProviderDeletionFlowStatuses {
    getAllFinishedHealthProviderDeletionFlowStatuses {
      healthProviderName
      willBeCleanedUpAt
      logs {
        timestamp
      }
    }
  }
`;

/**
 * __useGetAllFinishedHealthProviderDeletionFlowStatusesQuery__
 *
 * To run a query within a Vue component, call `useGetAllFinishedHealthProviderDeletionFlowStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFinishedHealthProviderDeletionFlowStatusesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllFinishedHealthProviderDeletionFlowStatusesQuery();
 */
export function useGetAllFinishedHealthProviderDeletionFlowStatusesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
        GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
          GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
          GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
    GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
  >(GetAllFinishedHealthProviderDeletionFlowStatusesDocument, {}, options);
}
export function useGetAllFinishedHealthProviderDeletionFlowStatusesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
        GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
          GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
          GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
    GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
  >(GetAllFinishedHealthProviderDeletionFlowStatusesDocument, {}, options);
}
export type GetAllFinishedHealthProviderDeletionFlowStatusesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetAllFinishedHealthProviderDeletionFlowStatusesQuery,
    GetAllFinishedHealthProviderDeletionFlowStatusesQueryVariables
  >;
export const GetAllHealthProviderDeletionFlowStatusesDocument = gql`
  query getAllHealthProviderDeletionFlowStatuses {
    getAllHealthProviderDeletionFlowStatuses {
      healthProviderName
      completed
      hasFailed
    }
  }
`;

/**
 * __useGetAllHealthProviderDeletionFlowStatusesQuery__
 *
 * To run a query within a Vue component, call `useGetAllHealthProviderDeletionFlowStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHealthProviderDeletionFlowStatusesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllHealthProviderDeletionFlowStatusesQuery();
 */
export function useGetAllHealthProviderDeletionFlowStatusesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllHealthProviderDeletionFlowStatusesQuery,
        GetAllHealthProviderDeletionFlowStatusesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllHealthProviderDeletionFlowStatusesQuery,
          GetAllHealthProviderDeletionFlowStatusesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllHealthProviderDeletionFlowStatusesQuery,
          GetAllHealthProviderDeletionFlowStatusesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllHealthProviderDeletionFlowStatusesQuery,
    GetAllHealthProviderDeletionFlowStatusesQueryVariables
  >(GetAllHealthProviderDeletionFlowStatusesDocument, {}, options);
}
export function useGetAllHealthProviderDeletionFlowStatusesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllHealthProviderDeletionFlowStatusesQuery,
        GetAllHealthProviderDeletionFlowStatusesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllHealthProviderDeletionFlowStatusesQuery,
          GetAllHealthProviderDeletionFlowStatusesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllHealthProviderDeletionFlowStatusesQuery,
          GetAllHealthProviderDeletionFlowStatusesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllHealthProviderDeletionFlowStatusesQuery,
    GetAllHealthProviderDeletionFlowStatusesQueryVariables
  >(GetAllHealthProviderDeletionFlowStatusesDocument, {}, options);
}
export type GetAllHealthProviderDeletionFlowStatusesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllHealthProviderDeletionFlowStatusesQuery,
  GetAllHealthProviderDeletionFlowStatusesQueryVariables
>;
export const GetHealthProvidersMarkedForDeletionDocument = gql`
  query getHealthProvidersMarkedForDeletion {
    getHealthProvidersMarkedForDeletion {
      name
      displayName
    }
  }
`;

/**
 * __useGetHealthProvidersMarkedForDeletionQuery__
 *
 * To run a query within a Vue component, call `useGetHealthProvidersMarkedForDeletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthProvidersMarkedForDeletionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHealthProvidersMarkedForDeletionQuery();
 */
export function useGetHealthProvidersMarkedForDeletionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProvidersMarkedForDeletionQuery,
        GetHealthProvidersMarkedForDeletionQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProvidersMarkedForDeletionQuery,
          GetHealthProvidersMarkedForDeletionQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProvidersMarkedForDeletionQuery,
          GetHealthProvidersMarkedForDeletionQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetHealthProvidersMarkedForDeletionQuery,
    GetHealthProvidersMarkedForDeletionQueryVariables
  >(GetHealthProvidersMarkedForDeletionDocument, {}, options);
}
export function useGetHealthProvidersMarkedForDeletionLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetHealthProvidersMarkedForDeletionQuery,
        GetHealthProvidersMarkedForDeletionQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetHealthProvidersMarkedForDeletionQuery,
          GetHealthProvidersMarkedForDeletionQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetHealthProvidersMarkedForDeletionQuery,
          GetHealthProvidersMarkedForDeletionQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetHealthProvidersMarkedForDeletionQuery,
    GetHealthProvidersMarkedForDeletionQueryVariables
  >(GetHealthProvidersMarkedForDeletionDocument, {}, options);
}
export type GetHealthProvidersMarkedForDeletionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetHealthProvidersMarkedForDeletionQuery,
  GetHealthProvidersMarkedForDeletionQueryVariables
>;
export const GetInconsistentHealthProviderReportsDocument = gql`
  query getInconsistentHealthProviderReports {
    getInconsistentHealthProviderReports {
      registryHealthProviderName
      healthProviderRealmName
      patientRealmName
    }
  }
`;

/**
 * __useGetInconsistentHealthProviderReportsQuery__
 *
 * To run a query within a Vue component, call `useGetInconsistentHealthProviderReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInconsistentHealthProviderReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInconsistentHealthProviderReportsQuery();
 */
export function useGetInconsistentHealthProviderReportsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetInconsistentHealthProviderReportsQuery,
        GetInconsistentHealthProviderReportsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetInconsistentHealthProviderReportsQuery,
          GetInconsistentHealthProviderReportsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetInconsistentHealthProviderReportsQuery,
          GetInconsistentHealthProviderReportsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetInconsistentHealthProviderReportsQuery,
    GetInconsistentHealthProviderReportsQueryVariables
  >(GetInconsistentHealthProviderReportsDocument, {}, options);
}
export function useGetInconsistentHealthProviderReportsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetInconsistentHealthProviderReportsQuery,
        GetInconsistentHealthProviderReportsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetInconsistentHealthProviderReportsQuery,
          GetInconsistentHealthProviderReportsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetInconsistentHealthProviderReportsQuery,
          GetInconsistentHealthProviderReportsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetInconsistentHealthProviderReportsQuery,
    GetInconsistentHealthProviderReportsQueryVariables
  >(GetInconsistentHealthProviderReportsDocument, {}, options);
}
export type GetInconsistentHealthProviderReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetInconsistentHealthProviderReportsQuery,
  GetInconsistentHealthProviderReportsQueryVariables
>;
export const HealthProviderDocument = gql`
  query healthProvider($healthProviderName: ID!) {
    healthProvider(healthProviderName: $healthProviderName) {
      name
      displayName
      customer {
        id
        name
      }
      usage
      externalHumanIdTypeIdForPatient
      externalHumanIdTypeIdForUser
      externalHumanIdTypeIdForDialoggUser
      userSessionLifespan
      patientSessionLifespan
      patientRealm
      timeZone
      url
      dialoggCode
      serviceId
      service {
        id
        roles {
          id
          userGroup {
            id
          }
        }
      }
      hasRpm
      hasDhv
      hasSupervision
      hasResponse
      hasSupportTeam
      features {
        continuousSupervision
        hasTrends
        newSupervisionUserTabs
        hasFurnitureDetection
        hasDemoAnonymization
        dataAnalytics
        joinNhnMeeting
        sendNotificationToNextOfKin
        hasCmp
        alarmStreaming
        beta
        selfTreatmentPlan
        hasEntraIdSso
        hasEntraIdProvisioning
        hasAlmaIntegration
        hasAscomIntegration
        hasPhoniroCloudIntegration
        hasSkyresponsePartnerIntegration
        hasSipIntegration
        hasCoordcomIntegration
        hasTietoLmoIntegration
        hasIpOmsorgIntegration
        hasUmo2GIntegration
        hasBestIntegration
      }
      defaultLocale
      settings {
        externalHumanIdTypes {
          id
          localeEntries {
            localeId
            displayName
          }
          use {
            patientUse {
              applicable
            }
            personnelUse {
              applicable
            }
          }
        }
        userAuth {
          twoFactorSms
          ipRestriction
          timeLimitedAccess
          resetPasswordAllowed
          externalIdP {
            alias
            displayName
            enabled
            usernamePolicy
            default
          }
        }
        patientAuth {
          twoFactorSms
          ipRestriction
          timeLimitedAccess
          resetPasswordAllowed
          externalIdP {
            alias
            displayName
            enabled
            usernamePolicy
            default
          }
        }
      }
      safemateAccount {
        id
        accountDisplayName
      }
      tcifAccount {
        id
        accountDisplayName
      }
      morpheanAccount {
        id
        accountDisplayName
      }
      twilioAccount {
        id
        accountDisplayName
      }
      videonorAccount {
        id
        accountDisplayName
      }
      sendGridAccount {
        id
        accountDisplayName
      }
      googlemapsAccount {
        id
        accountDisplayName
      }
      skyresponseAccount {
        id
        accountDisplayName
      }
    }
  }
`;

/**
 * __useHealthProviderQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useHealthProviderQuery(
  variables:
    | HealthProviderQueryVariables
    | VueCompositionApi.Ref<HealthProviderQueryVariables>
    | ReactiveFunction<HealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<HealthProviderQuery, HealthProviderQueryVariables>(
    HealthProviderDocument,
    variables,
    options,
  );
}
export function useHealthProviderLazyQuery(
  variables?:
    | HealthProviderQueryVariables
    | VueCompositionApi.Ref<HealthProviderQueryVariables>
    | ReactiveFunction<HealthProviderQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HealthProviderQuery, HealthProviderQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<HealthProviderQuery, HealthProviderQueryVariables>(
    HealthProviderDocument,
    variables,
    options,
  );
}
export type HealthProviderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderQuery,
  HealthProviderQueryVariables
>;
export const ExternalHumanIdTypesDocument = gql`
  query externalHumanIdTypes {
    externalHumanIdTypes {
      id
      localeEntries {
        localeId
        displayName
      }
      use {
        patientUse {
          applicable
        }
        personnelUse {
          applicable
        }
      }
    }
  }
`;

/**
 * __useExternalHumanIdTypesQuery__
 *
 * To run a query within a Vue component, call `useExternalHumanIdTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalHumanIdTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalHumanIdTypesQuery();
 */
export function useExternalHumanIdTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>(
    ExternalHumanIdTypesDocument,
    {},
    options,
  );
}
export function useExternalHumanIdTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ExternalHumanIdTypesQuery, ExternalHumanIdTypesQueryVariables>(
    ExternalHumanIdTypesDocument,
    {},
    options,
  );
}
export type ExternalHumanIdTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ExternalHumanIdTypesQuery,
  ExternalHumanIdTypesQueryVariables
>;
export const HealthProviderUsersDocument = gql`
  query healthProviderUsers($id: ID) {
    healthProviderUsers: users(id: $id) {
      id
      username
      email
      firstName
      lastName
      enabled
      roles {
        id
        roleDefinitionId
        display {
          key
          value
        }
      }
    }
  }
`;

/**
 * __useHealthProviderUsersQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderUsersQuery({
 *   id: // value for 'id'
 * });
 */
export function useHealthProviderUsersQuery(
  variables:
    | HealthProviderUsersQueryVariables
    | VueCompositionApi.Ref<HealthProviderUsersQueryVariables>
    | ReactiveFunction<HealthProviderUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>(
    HealthProviderUsersDocument,
    variables,
    options,
  );
}
export function useHealthProviderUsersLazyQuery(
  variables:
    | HealthProviderUsersQueryVariables
    | VueCompositionApi.Ref<HealthProviderUsersQueryVariables>
    | ReactiveFunction<HealthProviderUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<HealthProviderUsersQuery, HealthProviderUsersQueryVariables>(
    HealthProviderUsersDocument,
    variables,
    options,
  );
}
export type HealthProviderUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderUsersQuery,
  HealthProviderUsersQueryVariables
>;
export const HourlyPatientStatsDocument = gql`
  query hourlyPatientStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    hourlyPatientStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        timestamp
        startTimestamp
        endTimestamp
        questionnaireResponses
        manualObservations
        deviceObservations
        patientGroupName
        subscribedResponders
        openAlarms
        openTasks
      }
    }
  }
`;

/**
 * __useHourlyPatientStatsQuery__
 *
 * To run a query within a Vue component, call `useHourlyPatientStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHourlyPatientStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHourlyPatientStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useHourlyPatientStatsQuery(
  variables:
    | HourlyPatientStatsQueryVariables
    | VueCompositionApi.Ref<HourlyPatientStatsQueryVariables>
    | ReactiveFunction<HourlyPatientStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>(
    HourlyPatientStatsDocument,
    variables,
    options,
  );
}
export function useHourlyPatientStatsLazyQuery(
  variables?:
    | HourlyPatientStatsQueryVariables
    | VueCompositionApi.Ref<HourlyPatientStatsQueryVariables>
    | ReactiveFunction<HourlyPatientStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<HourlyPatientStatsQuery, HourlyPatientStatsQueryVariables>(
    HourlyPatientStatsDocument,
    variables,
    options,
  );
}
export type HourlyPatientStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HourlyPatientStatsQuery,
  HourlyPatientStatsQueryVariables
>;
export const HourlyUserStatsDocument = gql`
  query hourlyUserStats($healthProvider: String!, $limit: Int, $cursor: Int) {
    hourlyUserStats(healthProvider: $healthProvider, limit: $limit, cursor: $cursor) {
      count
      stats {
        timestamp
        startTimestamp
        endTimestamp
        loginCount
        loginErrorCount
        keycloakLoginCount
        externalLoginCount
        dialoggUsersLoginCount
        dialoggUsersLoginErrorCount
        dialoggUserskeycloakLoginCount
        dialoggUsersExternalLoginCount
      }
    }
  }
`;

/**
 * __useHourlyUserStatsQuery__
 *
 * To run a query within a Vue component, call `useHourlyUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHourlyUserStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHourlyUserStatsQuery({
 *   healthProvider: // value for 'healthProvider'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useHourlyUserStatsQuery(
  variables:
    | HourlyUserStatsQueryVariables
    | VueCompositionApi.Ref<HourlyUserStatsQueryVariables>
    | ReactiveFunction<HourlyUserStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>(
    HourlyUserStatsDocument,
    variables,
    options,
  );
}
export function useHourlyUserStatsLazyQuery(
  variables?:
    | HourlyUserStatsQueryVariables
    | VueCompositionApi.Ref<HourlyUserStatsQueryVariables>
    | ReactiveFunction<HourlyUserStatsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<HourlyUserStatsQuery, HourlyUserStatsQueryVariables>(
    HourlyUserStatsDocument,
    variables,
    options,
  );
}
export type HourlyUserStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HourlyUserStatsQuery,
  HourlyUserStatsQueryVariables
>;
export const GetMigrationsDocument = gql`
  query getMigrations {
    getMigrations {
      id
      displayName
      scope
    }
  }
`;

/**
 * __useGetMigrationsQuery__
 *
 * To run a query within a Vue component, call `useGetMigrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMigrationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMigrationsQuery();
 */
export function useGetMigrationsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetMigrationsQuery, GetMigrationsQueryVariables>(
    GetMigrationsDocument,
    {},
    options,
  );
}
export function useGetMigrationsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMigrationsQuery, GetMigrationsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetMigrationsQuery, GetMigrationsQueryVariables>(
    GetMigrationsDocument,
    {},
    options,
  );
}
export type GetMigrationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMigrationsQuery,
  GetMigrationsQueryVariables
>;
export const MorpheanAccountsDocument = gql`
  query morpheanAccounts {
    morpheanAccounts {
      id
      accountDisplayName
      customerId
      customerIds
    }
  }
`;

/**
 * __useMorpheanAccountsQuery__
 *
 * To run a query within a Vue component, call `useMorpheanAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMorpheanAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMorpheanAccountsQuery();
 */
export function useMorpheanAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>(
    MorpheanAccountsDocument,
    {},
    options,
  );
}
export function useMorpheanAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<MorpheanAccountsQuery, MorpheanAccountsQueryVariables>(
    MorpheanAccountsDocument,
    {},
    options,
  );
}
export type MorpheanAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  MorpheanAccountsQuery,
  MorpheanAccountsQueryVariables
>;
export const RegistryDevicesDocument = gql`
  query registryDevices($healthProviderName: ID) {
    registryDevices(healthProviderName: $healthProviderName) {
      id
      type
      healthProviderName
      lastHeartbeat
      lastBatteryStatus
      lastObservation
      lastStatus
      heartbeatCount
      observationCount
      online
      deviceName
      deviceGroup
      routerMac
      routerVendor
      modelName
      arch
    }
  }
`;

/**
 * __useRegistryDevicesQuery__
 *
 * To run a query within a Vue component, call `useRegistryDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegistryDevicesQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useRegistryDevicesQuery(
  variables:
    | RegistryDevicesQueryVariables
    | VueCompositionApi.Ref<RegistryDevicesQueryVariables>
    | ReactiveFunction<RegistryDevicesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RegistryDevicesQuery, RegistryDevicesQueryVariables>(
    RegistryDevicesDocument,
    variables,
    options,
  );
}
export function useRegistryDevicesLazyQuery(
  variables:
    | RegistryDevicesQueryVariables
    | VueCompositionApi.Ref<RegistryDevicesQueryVariables>
    | ReactiveFunction<RegistryDevicesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegistryDevicesQuery, RegistryDevicesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RegistryDevicesQuery, RegistryDevicesQueryVariables>(
    RegistryDevicesDocument,
    variables,
    options,
  );
}
export type RegistryDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RegistryDevicesQuery,
  RegistryDevicesQueryVariables
>;
export const RegistryDeviceTypesDocument = gql`
  query registryDeviceTypes {
    registryDeviceTypes {
      id
      name
    }
  }
`;

/**
 * __useRegistryDeviceTypesQuery__
 *
 * To run a query within a Vue component, call `useRegistryDeviceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryDeviceTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegistryDeviceTypesQuery();
 */
export function useRegistryDeviceTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>(
    RegistryDeviceTypesDocument,
    {},
    options,
  );
}
export function useRegistryDeviceTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RegistryDeviceTypesQuery, RegistryDeviceTypesQueryVariables>(
    RegistryDeviceTypesDocument,
    {},
    options,
  );
}
export type RegistryDeviceTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RegistryDeviceTypesQuery,
  RegistryDeviceTypesQueryVariables
>;
export const DefaultRoleDefinitionsDocument = gql`
  query defaultRoleDefinitions {
    defaultRoleDefinitions {
      id
      display {
        key
        value
      }
    }
  }
`;

/**
 * __useDefaultRoleDefinitionsQuery__
 *
 * To run a query within a Vue component, call `useDefaultRoleDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultRoleDefinitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDefaultRoleDefinitionsQuery();
 */
export function useDefaultRoleDefinitionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>(
    DefaultRoleDefinitionsDocument,
    {},
    options,
  );
}
export function useDefaultRoleDefinitionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DefaultRoleDefinitionsQuery, DefaultRoleDefinitionsQueryVariables>(
    DefaultRoleDefinitionsDocument,
    {},
    options,
  );
}
export type DefaultRoleDefinitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DefaultRoleDefinitionsQuery,
  DefaultRoleDefinitionsQueryVariables
>;
export const DefaultRoleDefinitionsWithAbilitiesDocument = gql`
  query defaultRoleDefinitionsWithAbilities {
    defaultRoleDefinitions {
      id
      display {
        key
        value
      }
      abilities {
        operation
        resource
      }
      accessScopes
      dashboardRouteName
      isDefaultType
    }
  }
`;

/**
 * __useDefaultRoleDefinitionsWithAbilitiesQuery__
 *
 * To run a query within a Vue component, call `useDefaultRoleDefinitionsWithAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultRoleDefinitionsWithAbilitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDefaultRoleDefinitionsWithAbilitiesQuery();
 */
export function useDefaultRoleDefinitionsWithAbilitiesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        DefaultRoleDefinitionsWithAbilitiesQuery,
        DefaultRoleDefinitionsWithAbilitiesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DefaultRoleDefinitionsWithAbilitiesQuery,
          DefaultRoleDefinitionsWithAbilitiesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DefaultRoleDefinitionsWithAbilitiesQuery,
          DefaultRoleDefinitionsWithAbilitiesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    DefaultRoleDefinitionsWithAbilitiesQuery,
    DefaultRoleDefinitionsWithAbilitiesQueryVariables
  >(DefaultRoleDefinitionsWithAbilitiesDocument, {}, options);
}
export function useDefaultRoleDefinitionsWithAbilitiesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        DefaultRoleDefinitionsWithAbilitiesQuery,
        DefaultRoleDefinitionsWithAbilitiesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DefaultRoleDefinitionsWithAbilitiesQuery,
          DefaultRoleDefinitionsWithAbilitiesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DefaultRoleDefinitionsWithAbilitiesQuery,
          DefaultRoleDefinitionsWithAbilitiesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    DefaultRoleDefinitionsWithAbilitiesQuery,
    DefaultRoleDefinitionsWithAbilitiesQueryVariables
  >(DefaultRoleDefinitionsWithAbilitiesDocument, {}, options);
}
export type DefaultRoleDefinitionsWithAbilitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DefaultRoleDefinitionsWithAbilitiesQuery,
  DefaultRoleDefinitionsWithAbilitiesQueryVariables
>;
export const RoleDefinitionsDocument = gql`
  query roleDefinitions($healthProviderName: ID!) {
    roleDefinitions(healthProviderName: $healthProviderName) {
      id
      basedOn
      display {
        key
        value
      }
      abilities {
        operation
        resource
      }
      accessScopes
      dashboardRouteName
    }
  }
`;

/**
 * __useRoleDefinitionsQuery__
 *
 * To run a query within a Vue component, call `useRoleDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDefinitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleDefinitionsQuery({
 *   healthProviderName: // value for 'healthProviderName'
 * });
 */
export function useRoleDefinitionsQuery(
  variables:
    | RoleDefinitionsQueryVariables
    | VueCompositionApi.Ref<RoleDefinitionsQueryVariables>
    | ReactiveFunction<RoleDefinitionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>(
    RoleDefinitionsDocument,
    variables,
    options,
  );
}
export function useRoleDefinitionsLazyQuery(
  variables?:
    | RoleDefinitionsQueryVariables
    | VueCompositionApi.Ref<RoleDefinitionsQueryVariables>
    | ReactiveFunction<RoleDefinitionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RoleDefinitionsQuery, RoleDefinitionsQueryVariables>(
    RoleDefinitionsDocument,
    variables,
    options,
  );
}
export type RoleDefinitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RoleDefinitionsQuery,
  RoleDefinitionsQueryVariables
>;
export const SafemateAccountsDocument = gql`
  query safemateAccounts {
    safemateAccounts {
      id
      accountDisplayName
      apiUsername
      observationUsername
      apiUrl
    }
  }
`;

/**
 * __useSafemateAccountsQuery__
 *
 * To run a query within a Vue component, call `useSafemateAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafemateAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSafemateAccountsQuery();
 */
export function useSafemateAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<SafemateAccountsQuery, SafemateAccountsQueryVariables>(
    SafemateAccountsDocument,
    {},
    options,
  );
}
export function useSafemateAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SafemateAccountsQuery, SafemateAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<SafemateAccountsQuery, SafemateAccountsQueryVariables>(
    SafemateAccountsDocument,
    {},
    options,
  );
}
export type SafemateAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SafemateAccountsQuery,
  SafemateAccountsQueryVariables
>;
export const SendGridAccountsDocument = gql`
  query sendGridAccounts {
    sendGridAccounts {
      id
      accountDisplayName
      emailAddress
    }
  }
`;

/**
 * __useSendGridAccountsQuery__
 *
 * To run a query within a Vue component, call `useSendGridAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendGridAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSendGridAccountsQuery();
 */
export function useSendGridAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<SendGridAccountsQuery, SendGridAccountsQueryVariables>(
    SendGridAccountsDocument,
    {},
    options,
  );
}
export function useSendGridAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SendGridAccountsQuery, SendGridAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<SendGridAccountsQuery, SendGridAccountsQueryVariables>(
    SendGridAccountsDocument,
    {},
    options,
  );
}
export type SendGridAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SendGridAccountsQuery,
  SendGridAccountsQueryVariables
>;
export const SkyresponseAccountsDocument = gql`
  query skyresponseAccounts {
    skyresponseAccounts {
      id
      accountDisplayName
      username
    }
  }
`;

/**
 * __useSkyresponseAccountsQuery__
 *
 * To run a query within a Vue component, call `useSkyresponseAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkyresponseAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSkyresponseAccountsQuery();
 */
export function useSkyresponseAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>(
    SkyresponseAccountsDocument,
    {},
    options,
  );
}
export function useSkyresponseAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<SkyresponseAccountsQuery, SkyresponseAccountsQueryVariables>(
    SkyresponseAccountsDocument,
    {},
    options,
  );
}
export type SkyresponseAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SkyresponseAccountsQuery,
  SkyresponseAccountsQueryVariables
>;
export const SupportTeamsWithLinkedHealthProvidersDocument = gql`
  query supportTeamsWithLinkedHealthProviders {
    supportTeamsWithLinkedHealthProviders {
      name
      displayName
      autoCreatedSupportUserRoleDefinitionId
      linkedHealthProviders
      unlinkedHealthProviders
    }
  }
`;

/**
 * __useSupportTeamsWithLinkedHealthProvidersQuery__
 *
 * To run a query within a Vue component, call `useSupportTeamsWithLinkedHealthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamsWithLinkedHealthProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportTeamsWithLinkedHealthProvidersQuery();
 */
export function useSupportTeamsWithLinkedHealthProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamsWithLinkedHealthProvidersQuery,
        SupportTeamsWithLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsWithLinkedHealthProvidersQuery,
          SupportTeamsWithLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsWithLinkedHealthProvidersQuery,
          SupportTeamsWithLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    SupportTeamsWithLinkedHealthProvidersQuery,
    SupportTeamsWithLinkedHealthProvidersQueryVariables
  >(SupportTeamsWithLinkedHealthProvidersDocument, {}, options);
}
export function useSupportTeamsWithLinkedHealthProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamsWithLinkedHealthProvidersQuery,
        SupportTeamsWithLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsWithLinkedHealthProvidersQuery,
          SupportTeamsWithLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamsWithLinkedHealthProvidersQuery,
          SupportTeamsWithLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    SupportTeamsWithLinkedHealthProvidersQuery,
    SupportTeamsWithLinkedHealthProvidersQueryVariables
  >(SupportTeamsWithLinkedHealthProvidersDocument, {}, options);
}
export type SupportTeamsWithLinkedHealthProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportTeamsWithLinkedHealthProvidersQuery,
  SupportTeamsWithLinkedHealthProvidersQueryVariables
>;
export const TcifAccountsDocument = gql`
  query tcifAccounts {
    tcifAccounts {
      id
      accountDisplayName
      prefixUrl
    }
  }
`;

/**
 * __useTcifAccountsQuery__
 *
 * To run a query within a Vue component, call `useTcifAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTcifAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTcifAccountsQuery();
 */
export function useTcifAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<TcifAccountsQuery, TcifAccountsQueryVariables>(TcifAccountsDocument, {}, options);
}
export function useTcifAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<TcifAccountsQuery, TcifAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<TcifAccountsQuery, TcifAccountsQueryVariables>(
    TcifAccountsDocument,
    {},
    options,
  );
}
export type TcifAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  TcifAccountsQuery,
  TcifAccountsQueryVariables
>;
export const TwilioAccountsDocument = gql`
  query twilioAccounts {
    twilioAccounts {
      id
      accountDisplayName
      phoneNumber
      accountSid
    }
  }
`;

/**
 * __useTwilioAccountsQuery__
 *
 * To run a query within a Vue component, call `useTwilioAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwilioAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTwilioAccountsQuery();
 */
export function useTwilioAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<TwilioAccountsQuery, TwilioAccountsQueryVariables>(
    TwilioAccountsDocument,
    {},
    options,
  );
}
export function useTwilioAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<TwilioAccountsQuery, TwilioAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<TwilioAccountsQuery, TwilioAccountsQueryVariables>(
    TwilioAccountsDocument,
    {},
    options,
  );
}
export type TwilioAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  TwilioAccountsQuery,
  TwilioAccountsQueryVariables
>;
export const UserManualsDocument = gql`
  query userManuals($id: String) {
    userManuals(id: $id) {
      id
      name
      icon
      priority
      applications {
        tilsyn
        dho
        dhv
      }
      localeEntries {
        localeId
        description
        displayName
        url
      }
      roleDefinitions {
        id
        display {
          key
          value
        }
      }
    }
  }
`;

/**
 * __useUserManualsQuery__
 *
 * To run a query within a Vue component, call `useUserManualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManualsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserManualsQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserManualsQuery(
  variables:
    | UserManualsQueryVariables
    | VueCompositionApi.Ref<UserManualsQueryVariables>
    | ReactiveFunction<UserManualsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserManualsQuery, UserManualsQueryVariables>(
    UserManualsDocument,
    variables,
    options,
  );
}
export function useUserManualsLazyQuery(
  variables:
    | UserManualsQueryVariables
    | VueCompositionApi.Ref<UserManualsQueryVariables>
    | ReactiveFunction<UserManualsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserManualsQuery, UserManualsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserManualsQuery, UserManualsQueryVariables>(
    UserManualsDocument,
    variables,
    options,
  );
}
export type UserManualsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserManualsQuery,
  UserManualsQueryVariables
>;
export const VideonorAccountsDocument = gql`
  query videonorAccounts {
    videonorAccounts {
      id
      accountDisplayName
      prefixUrl
      roomNamePrefix
    }
  }
`;

/**
 * __useVideonorAccountsQuery__
 *
 * To run a query within a Vue component, call `useVideonorAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideonorAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVideonorAccountsQuery();
 */
export function useVideonorAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<VideonorAccountsQuery, VideonorAccountsQueryVariables>(
    VideonorAccountsDocument,
    {},
    options,
  );
}
export function useVideonorAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideonorAccountsQuery, VideonorAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<VideonorAccountsQuery, VideonorAccountsQueryVariables>(
    VideonorAccountsDocument,
    {},
    options,
  );
}
export type VideonorAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VideonorAccountsQuery,
  VideonorAccountsQueryVariables
>;
export const ActivateCarePlanDocument = gql`
  mutation activateCarePlan($carePlanId: ID!) {
    activateCarePlan(carePlanId: $carePlanId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useActivateCarePlanMutation__
 *
 * To run a mutation, you first call `useActivateCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useActivateCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>(
    ActivateCarePlanDocument,
    options,
  );
}
export type ActivateCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateCarePlanMutation,
  ActivateCarePlanMutationVariables
>;
export const ActivateCarePlanTemplateDocument = gql`
  mutation activateCarePlanTemplate($id: ID!) {
    activateCarePlanTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useActivateCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useActivateCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateCarePlanTemplateMutation,
        ActivateCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateCarePlanTemplateMutation,
          ActivateCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateCarePlanTemplateMutation, ActivateCarePlanTemplateMutationVariables>(
    ActivateCarePlanTemplateDocument,
    options,
  );
}
export type ActivateCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateCarePlanTemplateMutation,
  ActivateCarePlanTemplateMutationVariables
>;
export const ActivateObservationTemplateDocument = gql`
  mutation activateObservationTemplate($id: ID!) {
    activateObservationTemplate(id: $id) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useActivateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useActivateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateObservationTemplateMutation,
        ActivateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateObservationTemplateMutation,
          ActivateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ActivateObservationTemplateMutation,
    ActivateObservationTemplateMutationVariables
  >(ActivateObservationTemplateDocument, options);
}
export type ActivateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateObservationTemplateMutation,
  ActivateObservationTemplateMutationVariables
>;
export const ActivateQuestionnaireTemplateDocument = gql`
  mutation activateQuestionnaireTemplate($id: ID!) {
    activateQuestionnaireTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useActivateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useActivateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateQuestionnaireTemplateMutation,
        ActivateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateQuestionnaireTemplateMutation,
          ActivateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ActivateQuestionnaireTemplateMutation,
    ActivateQuestionnaireTemplateMutationVariables
  >(ActivateQuestionnaireTemplateDocument, options);
}
export type ActivateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateQuestionnaireTemplateMutation,
  ActivateQuestionnaireTemplateMutationVariables
>;
export const CreateObservationForActivityInCarePlanTemplateDocument = gql`
  mutation createObservationForActivityInCarePlanTemplate($observationActivityInput: ObservationInput) {
    createObservationForActivityInCarePlanTemplate(observationActivityInput: $observationActivityInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      observation {
        id
        identifier {
          value
        }
        code {
          coding {
            code
          }
          text
        }
      }
    }
  }
`;

/**
 * __useCreateObservationForActivityInCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateObservationForActivityInCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationForActivityInCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationForActivityInCarePlanTemplateMutation({
 *   variables: {
 *     observationActivityInput: // value for 'observationActivityInput'
 *   },
 * });
 */
export function useCreateObservationForActivityInCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationForActivityInCarePlanTemplateMutation,
        CreateObservationForActivityInCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationForActivityInCarePlanTemplateMutation,
          CreateObservationForActivityInCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateObservationForActivityInCarePlanTemplateMutation,
    CreateObservationForActivityInCarePlanTemplateMutationVariables
  >(CreateObservationForActivityInCarePlanTemplateDocument, options);
}
export type CreateObservationForActivityInCarePlanTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateObservationForActivityInCarePlanTemplateMutation,
    CreateObservationForActivityInCarePlanTemplateMutationVariables
  >;
export const CreateObservationForActivityInCarePlanDocument = gql`
  mutation createObservationForActivityInCarePlan($observationActivityInput: ObservationInput) {
    createObservationForActivityInCarePlan(observationActivityInput: $observationActivityInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      observation {
        id
        identifier {
          value
        }
        code {
          coding {
            code
          }
          text
        }
      }
    }
  }
`;

/**
 * __useCreateObservationForActivityInCarePlanMutation__
 *
 * To run a mutation, you first call `useCreateObservationForActivityInCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationForActivityInCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationForActivityInCarePlanMutation({
 *   variables: {
 *     observationActivityInput: // value for 'observationActivityInput'
 *   },
 * });
 */
export function useCreateObservationForActivityInCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationForActivityInCarePlanMutation,
        CreateObservationForActivityInCarePlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationForActivityInCarePlanMutation,
          CreateObservationForActivityInCarePlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateObservationForActivityInCarePlanMutation,
    CreateObservationForActivityInCarePlanMutationVariables
  >(CreateObservationForActivityInCarePlanDocument, options);
}
export type CreateObservationForActivityInCarePlanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateObservationForActivityInCarePlanMutation,
    CreateObservationForActivityInCarePlanMutationVariables
  >;
export const CreateCarePlanBasedOnExistingDocument = gql`
  mutation createCarePlanBasedOnExisting($patientId: ID!, $newCarePlanTitle: String!, $existingCarePlanId: ID!) {
    createCarePlanBasedOnExisting(
      patientId: $patientId
      newCarePlanTitle: $newCarePlanTitle
      existingCarePlanId: $existingCarePlanId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanBasedOnExistingMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanBasedOnExistingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanBasedOnExistingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanBasedOnExistingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     newCarePlanTitle: // value for 'newCarePlanTitle'
 *     existingCarePlanId: // value for 'existingCarePlanId'
 *   },
 * });
 */
export function useCreateCarePlanBasedOnExistingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanBasedOnExistingMutation,
        CreateCarePlanBasedOnExistingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanBasedOnExistingMutation,
          CreateCarePlanBasedOnExistingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCarePlanBasedOnExistingMutation,
    CreateCarePlanBasedOnExistingMutationVariables
  >(CreateCarePlanBasedOnExistingDocument, options);
}
export type CreateCarePlanBasedOnExistingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanBasedOnExistingMutation,
  CreateCarePlanBasedOnExistingMutationVariables
>;
export const CreateCarePlanForPatientDocument = gql`
  mutation createCarePlanForPatient($createInput: CarePlanInput) {
    createCarePlanForPatient(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanForPatientMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanForPatientMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCarePlanForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanForPatientMutation,
        CreateCarePlanForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanForPatientMutation,
          CreateCarePlanForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCarePlanForPatientMutation, CreateCarePlanForPatientMutationVariables>(
    CreateCarePlanForPatientDocument,
    options,
  );
}
export type CreateCarePlanForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanForPatientMutation,
  CreateCarePlanForPatientMutationVariables
>;
export const CreateCarePlanTemplateDocument = gql`
  mutation createCarePlanTemplate($createInput: CarePlanTemplateInput!) {
    createCarePlanTemplate(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanTemplateMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>(
    CreateCarePlanTemplateDocument,
    options,
  );
}
export type CreateCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanTemplateMutation,
  CreateCarePlanTemplateMutationVariables
>;
export const CreateCarePlanTemplateBasedOnExistingDocument = gql`
  mutation createCarePlanTemplateBasedOnExisting($newTitle: String!, $basedOn: ID!) {
    createCarePlanTemplateBasedOnExisting(newTitle: $newTitle, basedOn: $basedOn) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanTemplateBasedOnExistingMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanTemplateBasedOnExistingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanTemplateBasedOnExistingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanTemplateBasedOnExistingMutation({
 *   variables: {
 *     newTitle: // value for 'newTitle'
 *     basedOn: // value for 'basedOn'
 *   },
 * });
 */
export function useCreateCarePlanTemplateBasedOnExistingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanTemplateBasedOnExistingMutation,
        CreateCarePlanTemplateBasedOnExistingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanTemplateBasedOnExistingMutation,
          CreateCarePlanTemplateBasedOnExistingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCarePlanTemplateBasedOnExistingMutation,
    CreateCarePlanTemplateBasedOnExistingMutationVariables
  >(CreateCarePlanTemplateBasedOnExistingDocument, options);
}
export type CreateCarePlanTemplateBasedOnExistingMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateCarePlanTemplateBasedOnExistingMutation,
    CreateCarePlanTemplateBasedOnExistingMutationVariables
  >;
export const CreateCommunicationToSeveralDocument = gql`
  mutation createCommunicationToSeveral($communication: PersonnelCommunicationToSeveralInput!) {
    createCommunicationToSeveral(communication: $communication) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useCreateCommunicationToSeveralMutation__
 *
 * To run a mutation, you first call `useCreateCommunicationToSeveralMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunicationToSeveralMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCommunicationToSeveralMutation({
 *   variables: {
 *     communication: // value for 'communication'
 *   },
 * });
 */
export function useCreateCommunicationToSeveralMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCommunicationToSeveralMutation,
        CreateCommunicationToSeveralMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCommunicationToSeveralMutation,
          CreateCommunicationToSeveralMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCommunicationToSeveralMutation,
    CreateCommunicationToSeveralMutationVariables
  >(CreateCommunicationToSeveralDocument, options);
}
export type CreateCommunicationToSeveralMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCommunicationToSeveralMutation,
  CreateCommunicationToSeveralMutationVariables
>;
export const CreateDocumentDocument = gql`
  mutation createDocument($createInput: DocumentReferenceInput!) {
    createDocument(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      documentReference {
        id
        content {
          attachment {
            url
          }
        }
      }
    }
  }
`;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(
    CreateDocumentDocument,
    options,
  );
}
export type CreateDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const CreateObservationTemplateDocument = gql`
  mutation createObservationTemplate($observationInput: ObservationInput!) {
    createObservationTemplate(observationInput: $observationInput) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationTemplateMutation({
 *   variables: {
 *     observationInput: // value for 'observationInput'
 *   },
 * });
 */
export function useCreateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationTemplateMutation,
        CreateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationTemplateMutation,
          CreateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateObservationTemplateMutation, CreateObservationTemplateMutationVariables>(
    CreateObservationTemplateDocument,
    options,
  );
}
export type CreateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateObservationTemplateMutation,
  CreateObservationTemplateMutationVariables
>;
export const CreateQuestionnaireForActivityInCarePlanDocument = gql`
  mutation createQuestionnaireForActivityInCarePlan($carePlanId: ID!, $questionnaireTemplateId: ID!) {
    createQuestionnaireForActivityInCarePlan(
      carePlanId: $carePlanId
      questionnaireTemplateId: $questionnaireTemplateId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      questionnaire {
        id
        title
        derivedFrom
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireForActivityInCarePlanMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireForActivityInCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireForActivityInCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireForActivityInCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     questionnaireTemplateId: // value for 'questionnaireTemplateId'
 *   },
 * });
 */
export function useCreateQuestionnaireForActivityInCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireForActivityInCarePlanMutation,
        CreateQuestionnaireForActivityInCarePlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireForActivityInCarePlanMutation,
          CreateQuestionnaireForActivityInCarePlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireForActivityInCarePlanMutation,
    CreateQuestionnaireForActivityInCarePlanMutationVariables
  >(CreateQuestionnaireForActivityInCarePlanDocument, options);
}
export type CreateQuestionnaireForActivityInCarePlanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateQuestionnaireForActivityInCarePlanMutation,
    CreateQuestionnaireForActivityInCarePlanMutationVariables
  >;
export const CreateQuestionnaireForActivityInCarePlanTemplateDocument = gql`
  mutation createQuestionnaireForActivityInCarePlanTemplate($carePlanTemplateId: ID!, $questionnaireTemplateId: ID!) {
    createQuestionnaireForActivityInCarePlanTemplate(
      carePlanTemplateId: $carePlanTemplateId
      questionnaireTemplateId: $questionnaireTemplateId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      questionnaire {
        id
        title
        derivedFrom
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireForActivityInCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireForActivityInCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireForActivityInCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireForActivityInCarePlanTemplateMutation({
 *   variables: {
 *     carePlanTemplateId: // value for 'carePlanTemplateId'
 *     questionnaireTemplateId: // value for 'questionnaireTemplateId'
 *   },
 * });
 */
export function useCreateQuestionnaireForActivityInCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireForActivityInCarePlanTemplateMutation,
        CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireForActivityInCarePlanTemplateMutation,
          CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireForActivityInCarePlanTemplateMutation,
    CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
  >(CreateQuestionnaireForActivityInCarePlanTemplateDocument, options);
}
export type CreateQuestionnaireForActivityInCarePlanTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateQuestionnaireForActivityInCarePlanTemplateMutation,
    CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
  >;
export const CreateQuestionnaireTemplateDocument = gql`
  mutation createQuestionnaireTemplate($questionnaireInput: QuestionnaireInput!) {
    createQuestionnaireTemplate(createInput: $questionnaireInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireTemplateMutation({
 *   variables: {
 *     questionnaireInput: // value for 'questionnaireInput'
 *   },
 * });
 */
export function useCreateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireTemplateMutation,
        CreateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireTemplateMutation,
          CreateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireTemplateMutation,
    CreateQuestionnaireTemplateMutationVariables
  >(CreateQuestionnaireTemplateDocument, options);
}
export type CreateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateQuestionnaireTemplateMutation,
  CreateQuestionnaireTemplateMutationVariables
>;
export const DeleteDocumentDocument = gql`
  mutation deleteDocument($documentId: ID!) {
    deleteDocument(documentId: $documentId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options,
  );
}
export type DeleteDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const DeleteDraftCarePlanDocument = gql`
  mutation deleteDraftCarePlan($carePlanId: ID!) {
    deleteDraftCarePlan(carePlanId: $carePlanId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDraftCarePlanMutation__
 *
 * To run a mutation, you first call `useDeleteDraftCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDraftCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useDeleteDraftCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>(
    DeleteDraftCarePlanDocument,
    options,
  );
}
export type DeleteDraftCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDraftCarePlanMutation,
  DeleteDraftCarePlanMutationVariables
>;
export const CompleteCarePlanDocument = gql`
  mutation completeCarePlan($carePlanId: ID!) {
    completeCarePlan(carePlanId: $carePlanId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useCompleteCarePlanMutation__
 *
 * To run a mutation, you first call `useCompleteCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useCompleteCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>(
    CompleteCarePlanDocument,
    options,
  );
}
export type CompleteCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCarePlanMutation,
  CompleteCarePlanMutationVariables
>;
export const CompleteCarePlanTemplateDocument = gql`
  mutation completeCarePlanTemplate($id: ID!) {
    completeCarePlanTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useCompleteCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCompleteCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCompleteCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CompleteCarePlanTemplateMutation,
        CompleteCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CompleteCarePlanTemplateMutation,
          CompleteCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCarePlanTemplateMutation, CompleteCarePlanTemplateMutationVariables>(
    CompleteCarePlanTemplateDocument,
    options,
  );
}
export type CompleteCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCarePlanTemplateMutation,
  CompleteCarePlanTemplateMutationVariables
>;
export const RetireObservationTemplateDocument = gql`
  mutation retireObservationTemplate($id: ID!) {
    retireObservationTemplate(id: $id) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRetireObservationTemplateMutation__
 *
 * To run a mutation, you first call `useRetireObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RetireObservationTemplateMutation,
        RetireObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RetireObservationTemplateMutation,
          RetireObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RetireObservationTemplateMutation, RetireObservationTemplateMutationVariables>(
    RetireObservationTemplateDocument,
    options,
  );
}
export type RetireObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireObservationTemplateMutation,
  RetireObservationTemplateMutationVariables
>;
export const RetireQuestionnaireTemplateDocument = gql`
  mutation retireQuestionnaireTemplate($id: ID!) {
    retireQuestionnaireTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useRetireQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useRetireQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RetireQuestionnaireTemplateMutation,
        RetireQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RetireQuestionnaireTemplateMutation,
          RetireQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RetireQuestionnaireTemplateMutation,
    RetireQuestionnaireTemplateMutationVariables
  >(RetireQuestionnaireTemplateDocument, options);
}
export type RetireQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireQuestionnaireTemplateMutation,
  RetireQuestionnaireTemplateMutationVariables
>;
export const StartCompositeTaskDocument = gql`
  mutation startCompositeTask($taskId: ID!) {
    startCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useStartCompositeTaskMutation__
 *
 * To run a mutation, you first call `useStartCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>(
    StartCompositeTaskDocument,
    options,
  );
}
export type StartCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartCompositeTaskMutation,
  StartCompositeTaskMutationVariables
>;
export const CompleteCompositeTaskDocument = gql`
  mutation completeCompositeTask($taskId: ID!, $journal: JournalInput) {
    completeCompositeTask(taskId: $taskId, journal: $journal) {
      success
      message
    }
  }
`;

/**
 * __useCompleteCompositeTaskMutation__
 *
 * To run a mutation, you first call `useCompleteCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     journal: // value for 'journal'
 *   },
 * });
 */
export function useCompleteCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>(
    CompleteCompositeTaskDocument,
    options,
  );
}
export type CompleteCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCompositeTaskMutation,
  CompleteCompositeTaskMutationVariables
>;
export const CompleteCompositeTaskAndItsSubTasksDocument = gql`
  mutation completeCompositeTaskAndItsSubTasks($taskId: ID!, $journal: JournalInput) {
    completeCompositeTaskAndItsSubTasks(taskId: $taskId, journal: $journal) {
      success
      message
    }
  }
`;

/**
 * __useCompleteCompositeTaskAndItsSubTasksMutation__
 *
 * To run a mutation, you first call `useCompleteCompositeTaskAndItsSubTasksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompositeTaskAndItsSubTasksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompositeTaskAndItsSubTasksMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     journal: // value for 'journal'
 *   },
 * });
 */
export function useCompleteCompositeTaskAndItsSubTasksMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CompleteCompositeTaskAndItsSubTasksMutation,
        CompleteCompositeTaskAndItsSubTasksMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CompleteCompositeTaskAndItsSubTasksMutation,
          CompleteCompositeTaskAndItsSubTasksMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CompleteCompositeTaskAndItsSubTasksMutation,
    CompleteCompositeTaskAndItsSubTasksMutationVariables
  >(CompleteCompositeTaskAndItsSubTasksDocument, options);
}
export type CompleteCompositeTaskAndItsSubTasksMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CompleteCompositeTaskAndItsSubTasksMutation,
    CompleteCompositeTaskAndItsSubTasksMutationVariables
  >;
export const RejectCompositeTaskDocument = gql`
  mutation rejectCompositeTask($taskId: ID!) {
    rejectCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRejectCompositeTaskMutation__
 *
 * To run a mutation, you first call `useRejectCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRejectCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>(
    RejectCompositeTaskDocument,
    options,
  );
}
export type RejectCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RejectCompositeTaskMutation,
  RejectCompositeTaskMutationVariables
>;
export const CompleteSubTaskDocument = gql`
  mutation completeSubTask($taskId: ID!) {
    completeSubTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useCompleteSubTaskMutation__
 *
 * To run a mutation, you first call `useCompleteSubTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSubTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteSubTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCompleteSubTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>(
    CompleteSubTaskDocument,
    options,
  );
}
export type CompleteSubTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteSubTaskMutation,
  CompleteSubTaskMutationVariables
>;
export const RejectSubTaskDocument = gql`
  mutation rejectSubTask($taskId: ID!) {
    rejectSubTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRejectSubTaskMutation__
 *
 * To run a mutation, you first call `useRejectSubTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectSubTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectSubTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRejectSubTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RejectSubTaskMutation, RejectSubTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RejectSubTaskMutation, RejectSubTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RejectSubTaskMutation, RejectSubTaskMutationVariables>(
    RejectSubTaskDocument,
    options,
  );
}
export type RejectSubTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RejectSubTaskMutation,
  RejectSubTaskMutationVariables
>;
export const UpdateSubTaskPriorityDocument = gql`
  mutation updateSubTaskPriority($taskId: ID!, $priority: String) {
    updateSubTaskPriority(taskId: $taskId, priority: $priority) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSubTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateSubTaskPriorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubTaskPriorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSubTaskPriorityMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     priority: // value for 'priority'
 *   },
 * });
 */
export function useUpdateSubTaskPriorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>(
    UpdateSubTaskPriorityDocument,
    options,
  );
}
export type UpdateSubTaskPriorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSubTaskPriorityMutation,
  UpdateSubTaskPriorityMutationVariables
>;
export const UpdateCompositeTaskPriorityDocument = gql`
  mutation updateCompositeTaskPriority($taskId: ID!, $priority: String) {
    updateCompositeTaskPriority(taskId: $taskId, priority: $priority) {
      success
      message
    }
  }
`;

/**
 * __useUpdateCompositeTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateCompositeTaskPriorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompositeTaskPriorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompositeTaskPriorityMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     priority: // value for 'priority'
 *   },
 * });
 */
export function useUpdateCompositeTaskPriorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateCompositeTaskPriorityMutation,
        UpdateCompositeTaskPriorityMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCompositeTaskPriorityMutation,
          UpdateCompositeTaskPriorityMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateCompositeTaskPriorityMutation,
    UpdateCompositeTaskPriorityMutationVariables
  >(UpdateCompositeTaskPriorityDocument, options);
}
export type UpdateCompositeTaskPriorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCompositeTaskPriorityMutation,
  UpdateCompositeTaskPriorityMutationVariables
>;
export const RetryTaskJournalingDocument = gql`
  mutation retryTaskJournaling($taskId: ID!) {
    retryTaskJournaling(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRetryTaskJournalingMutation__
 *
 * To run a mutation, you first call `useRetryTaskJournalingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryTaskJournalingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryTaskJournalingMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRetryTaskJournalingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>(
    RetryTaskJournalingDocument,
    options,
  );
}
export type RetryTaskJournalingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetryTaskJournalingMutation,
  RetryTaskJournalingMutationVariables
>;
export const UpdateCarePlanTemplateQuestionnaireDocument = gql`
  mutation updateCarePlanTemplateQuestionnaire(
    $carePlanTemplateId: ID!
    $questionnaireId: ID!
    $updateInput: QuestionnaireInput!
  ) {
    updateCarePlanTemplateQuestionnaire(
      carePlanTemplateId: $carePlanTemplateId
      questionnaireId: $questionnaireId
      updateInput: $updateInput
    ) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateCarePlanTemplateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateCarePlanTemplateQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarePlanTemplateQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCarePlanTemplateQuestionnaireMutation({
 *   variables: {
 *     carePlanTemplateId: // value for 'carePlanTemplateId'
 *     questionnaireId: // value for 'questionnaireId'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCarePlanTemplateQuestionnaireMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateCarePlanTemplateQuestionnaireMutation,
        UpdateCarePlanTemplateQuestionnaireMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCarePlanTemplateQuestionnaireMutation,
          UpdateCarePlanTemplateQuestionnaireMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateCarePlanTemplateQuestionnaireMutation,
    UpdateCarePlanTemplateQuestionnaireMutationVariables
  >(UpdateCarePlanTemplateQuestionnaireDocument, options);
}
export type UpdateCarePlanTemplateQuestionnaireMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateCarePlanTemplateQuestionnaireMutation,
    UpdateCarePlanTemplateQuestionnaireMutationVariables
  >;
export const UpdateDraftCarePlanDocument = gql`
  mutation updateDraftCarePlan($carePlanId: ID!, $updateInput: CarePlanInput) {
    updateDraftCarePlan(carePlanId: $carePlanId, updateInput: $updateInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateDraftCarePlanMutation__
 *
 * To run a mutation, you first call `useUpdateDraftCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDraftCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDraftCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>(
    UpdateDraftCarePlanDocument,
    options,
  );
}
export type UpdateDraftCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDraftCarePlanMutation,
  UpdateDraftCarePlanMutationVariables
>;
export const UpdateDraftCarePlanTemplateDocument = gql`
  mutation updateDraftCarePlanTemplate($id: ID!, $updateInput: CarePlanTemplateUpdateInput) {
    updateDraftCarePlanTemplate(id: $id, updateInput: $updateInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateDraftCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDraftCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDraftCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDraftCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDraftCarePlanTemplateMutation,
        UpdateDraftCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDraftCarePlanTemplateMutation,
          UpdateDraftCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDraftCarePlanTemplateMutation,
    UpdateDraftCarePlanTemplateMutationVariables
  >(UpdateDraftCarePlanTemplateDocument, options);
}
export type UpdateDraftCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDraftCarePlanTemplateMutation,
  UpdateDraftCarePlanTemplateMutationVariables
>;
export const UpdateObservationTemplateDocument = gql`
  mutation updateObservationTemplate($id: ID!, $updateInput: ObservationInput!) {
    updateObservationTemplate(id: $id, updateInput: $updateInput) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateObservationTemplateMutation,
        UpdateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateObservationTemplateMutation,
          UpdateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateObservationTemplateMutation, UpdateObservationTemplateMutationVariables>(
    UpdateObservationTemplateDocument,
    options,
  );
}
export type UpdateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateObservationTemplateMutation,
  UpdateObservationTemplateMutationVariables
>;
export const UpdateQuestionnaireDocument = gql`
  mutation updateQuestionnaire($carePlanId: ID!, $id: ID!, $updateInput: QuestionnaireInput) {
    updateCarePlanQuestionnaire(carePlanId: $carePlanId, questionnaireId: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateQuestionnaireMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(
    UpdateQuestionnaireDocument,
    options,
  );
}
export type UpdateQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateQuestionnaireMutation,
  UpdateQuestionnaireMutationVariables
>;
export const UpdateQuestionnaireTemplateDocument = gql`
  mutation updateQuestionnaireTemplate($id: ID!, $updateInput: QuestionnaireInput) {
    updateQuestionnaireTemplate(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateQuestionnaireTemplateMutation,
        UpdateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateQuestionnaireTemplateMutation,
          UpdateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateQuestionnaireTemplateMutation,
    UpdateQuestionnaireTemplateMutationVariables
  >(UpdateQuestionnaireTemplateDocument, options);
}
export type UpdateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateQuestionnaireTemplateMutation,
  UpdateQuestionnaireTemplateMutationVariables
>;
export const AcceptVideoMeetingTaskDocument = gql`
  mutation acceptVideoMeetingTask($taskId: ID!) {
    acceptVideoMeetingTask(taskId: $taskId) {
      success
    }
  }
`;

/**
 * __useAcceptVideoMeetingTaskMutation__
 *
 * To run a mutation, you first call `useAcceptVideoMeetingTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptVideoMeetingTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptVideoMeetingTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAcceptVideoMeetingTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>(
    AcceptVideoMeetingTaskDocument,
    options,
  );
}
export type AcceptVideoMeetingTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AcceptVideoMeetingTaskMutation,
  AcceptVideoMeetingTaskMutationVariables
>;
export const AddMyExternalIdDocument = gql`
  mutation addMyExternalId($externalUserId: ExternalHumanIdInput!) {
    addMyExternalId(externalUserId: $externalUserId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useAddMyExternalIdMutation__
 *
 * To run a mutation, you first call `useAddMyExternalIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMyExternalIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMyExternalIdMutation({
 *   variables: {
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddMyExternalIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>(
    AddMyExternalIdDocument,
    options,
  );
}
export type AddMyExternalIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddMyExternalIdMutation,
  AddMyExternalIdMutationVariables
>;
export const AddNotesToTaskDocument = gql`
  mutation addNotesToTask($taskId: ID!, $note: [AnnotationInput]) {
    addNotesToTask(taskId: $taskId, note: $note) {
      success
      message
    }
  }
`;

/**
 * __useAddNotesToTaskMutation__
 *
 * To run a mutation, you first call `useAddNotesToTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>(
    AddNotesToTaskDocument,
    options,
  );
}
export type AddNotesToTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToTaskMutation,
  AddNotesToTaskMutationVariables
>;
export const AddVideoMeetingTaskNotesDocument = gql`
  mutation addVideoMeetingTaskNotes($videoMeetingId: ID!, $note: [AnnotationInput]!) {
    addVideoMeetingTaskNotes(videoMeetingId: $videoMeetingId, note: $note) {
      success
      taskResponses {
        success
        message
      }
    }
  }
`;

/**
 * __useAddVideoMeetingTaskNotesMutation__
 *
 * To run a mutation, you first call `useAddVideoMeetingTaskNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoMeetingTaskNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddVideoMeetingTaskNotesMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddVideoMeetingTaskNotesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddVideoMeetingTaskNotesMutation,
        AddVideoMeetingTaskNotesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddVideoMeetingTaskNotesMutation,
          AddVideoMeetingTaskNotesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddVideoMeetingTaskNotesMutation, AddVideoMeetingTaskNotesMutationVariables>(
    AddVideoMeetingTaskNotesDocument,
    options,
  );
}
export type AddVideoMeetingTaskNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddVideoMeetingTaskNotesMutation,
  AddVideoMeetingTaskNotesMutationVariables
>;
export const AddRpmMedicalDeviceToPatientDocument = gql`
  mutation addRpmMedicalDeviceToPatient($patientId: ID!, $rpmMedicalDeviceId: ID!) {
    addRpmMedicalDeviceToPatient(patientId: $patientId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmMedicalDevice {
        modelName
        id
      }
    }
  }
`;

/**
 * __useAddRpmMedicalDeviceToPatientMutation__
 *
 * To run a mutation, you first call `useAddRpmMedicalDeviceToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRpmMedicalDeviceToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRpmMedicalDeviceToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useAddRpmMedicalDeviceToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddRpmMedicalDeviceToPatientMutation,
        AddRpmMedicalDeviceToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddRpmMedicalDeviceToPatientMutation,
          AddRpmMedicalDeviceToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddRpmMedicalDeviceToPatientMutation,
    AddRpmMedicalDeviceToPatientMutationVariables
  >(AddRpmMedicalDeviceToPatientDocument, options);
}
export type AddRpmMedicalDeviceToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddRpmMedicalDeviceToPatientMutation,
  AddRpmMedicalDeviceToPatientMutationVariables
>;
export const CancelVideoMeetingDocument = gql`
  mutation cancelVideoMeeting($id: ID!) {
    cancelVideoMeeting(videoMeetingId: $id) {
      success
      message
    }
  }
`;

/**
 * __useCancelVideoMeetingMutation__
 *
 * To run a mutation, you first call `useCancelVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelVideoMeetingMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCancelVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>(
    CancelVideoMeetingDocument,
    options,
  );
}
export type CancelVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelVideoMeetingMutation,
  CancelVideoMeetingMutationVariables
>;
export const CreateCommunicationDocument = gql`
  mutation createCommunication($communication: PersonnelCommunicationInput!) {
    createCommunication(communication: $communication) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useCreateCommunicationMutation__
 *
 * To run a mutation, you first call `useCreateCommunicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCommunicationMutation({
 *   variables: {
 *     communication: // value for 'communication'
 *   },
 * });
 */
export function useCreateCommunicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCommunicationMutation, CreateCommunicationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCommunicationMutation, CreateCommunicationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCommunicationMutation, CreateCommunicationMutationVariables>(
    CreateCommunicationDocument,
    options,
  );
}
export type CreateCommunicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCommunicationMutation,
  CreateCommunicationMutationVariables
>;
export const CreateRpmMedicalDeviceDocument = gql`
  mutation createRpmMedicalDevice($createInput: RpmMedicalDeviceCreateInput!) {
    createRpmMedicalDevice(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmMedicalDevice {
        id
        manufacturer
        serialNumber
        modelNumber
        btAddress
      }
    }
  }
`;

/**
 * __useCreateRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useCreateRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRpmMedicalDeviceMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>(
    CreateRpmMedicalDeviceDocument,
    options,
  );
}
export type CreateRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRpmMedicalDeviceMutation,
  CreateRpmMedicalDeviceMutationVariables
>;
export const DeleteAppDeviceForPatientDocument = gql`
  mutation deleteAppDeviceForPatient($patientId: ID!, $appDeviceId: ID!) {
    deleteAppDeviceForPatient(patientId: $patientId, appDeviceId: $appDeviceId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAppDeviceForPatientMutation__
 *
 * To run a mutation, you first call `useDeleteAppDeviceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppDeviceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAppDeviceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *   },
 * });
 */
export function useDeleteAppDeviceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteAppDeviceForPatientMutation,
        DeleteAppDeviceForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteAppDeviceForPatientMutation,
          DeleteAppDeviceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAppDeviceForPatientMutation, DeleteAppDeviceForPatientMutationVariables>(
    DeleteAppDeviceForPatientDocument,
    options,
  );
}
export type DeleteAppDeviceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAppDeviceForPatientMutation,
  DeleteAppDeviceForPatientMutationVariables
>;
export const DeleteRpmMedicalDeviceDocument = gql`
  mutation deleteRpmMedicalDevice($id: ID!) {
    deleteRpmMedicalDevice(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRpmMedicalDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>(
    DeleteRpmMedicalDeviceDocument,
    options,
  );
}
export type DeleteRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRpmMedicalDeviceMutation,
  DeleteRpmMedicalDeviceMutationVariables
>;
export const ChangePicturePermissionDocument = gql`
  mutation changePicturePermission($username: ID!, $enabled: Boolean!) {
    changePicturePermission(username: $username, enabled: $enabled) {
      success
    }
  }
`;

/**
 * __useChangePicturePermissionMutation__
 *
 * To run a mutation, you first call `useChangePicturePermissionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePicturePermissionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePicturePermissionMutation({
 *   variables: {
 *     username: // value for 'username'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useChangePicturePermissionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ChangePicturePermissionMutation, ChangePicturePermissionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ChangePicturePermissionMutation,
          ChangePicturePermissionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ChangePicturePermissionMutation, ChangePicturePermissionMutationVariables>(
    ChangePicturePermissionDocument,
    options,
  );
}
export type ChangePicturePermissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ChangePicturePermissionMutation,
  ChangePicturePermissionMutationVariables
>;
export const RemovePatientFromDialoggUserDocument = gql`
  mutation removePatientFromDialoggUser($username: ID!, $patientId: ID!) {
    removePatientFromDialoggUser(username: $username, patientId: $patientId) {
      success
      dialoggUser {
        username
      }
    }
  }
`;

/**
 * __useRemovePatientFromDialoggUserMutation__
 *
 * To run a mutation, you first call `useRemovePatientFromDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientFromDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientFromDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useRemovePatientFromDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientFromDialoggUserMutation,
        RemovePatientFromDialoggUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientFromDialoggUserMutation,
          RemovePatientFromDialoggUserMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientFromDialoggUserMutation,
    RemovePatientFromDialoggUserMutationVariables
  >(RemovePatientFromDialoggUserDocument, options);
}
export type RemovePatientFromDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientFromDialoggUserMutation,
  RemovePatientFromDialoggUserMutationVariables
>;
export const DisableServiceForPatientDocument = gql`
  mutation disableServiceForPatient($patientId: ID!, $service: String!) {
    disableServiceForPatient(patientId: $patientId, service: $service) {
      success
      message
      subscription {
        service
      }
    }
  }
`;

/**
 * __useDisableServiceForPatientMutation__
 *
 * To run a mutation, you first call `useDisableServiceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableServiceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableServiceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     service: // value for 'service'
 *   },
 * });
 */
export function useDisableServiceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DisableServiceForPatientMutation,
        DisableServiceForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DisableServiceForPatientMutation,
          DisableServiceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DisableServiceForPatientMutation, DisableServiceForPatientMutationVariables>(
    DisableServiceForPatientDocument,
    options,
  );
}
export type DisableServiceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableServiceForPatientMutation,
  DisableServiceForPatientMutationVariables
>;
export const EnableServiceForPatientDocument = gql`
  mutation enableServiceForPatient($patientId: ID!, $service: String!) {
    enableServiceForPatient(patientId: $patientId, service: $service) {
      success
      message
      subscription {
        service
      }
    }
  }
`;

/**
 * __useEnableServiceForPatientMutation__
 *
 * To run a mutation, you first call `useEnableServiceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableServiceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableServiceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     service: // value for 'service'
 *   },
 * });
 */
export function useEnableServiceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableServiceForPatientMutation, EnableServiceForPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          EnableServiceForPatientMutation,
          EnableServiceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<EnableServiceForPatientMutation, EnableServiceForPatientMutationVariables>(
    EnableServiceForPatientDocument,
    options,
  );
}
export type EnableServiceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableServiceForPatientMutation,
  EnableServiceForPatientMutationVariables
>;
export const EndJoinVideoMeetingDocument = gql`
  mutation endJoinVideoMeeting($videoMeetingId: ID!) {
    endVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useEndJoinVideoMeetingMutation__
 *
 * To run a mutation, you first call `useEndJoinVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndJoinVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndJoinVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useEndJoinVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>(
    EndJoinVideoMeetingDocument,
    options,
  );
}
export type EndJoinVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EndJoinVideoMeetingMutation,
  EndJoinVideoMeetingMutationVariables
>;
export const EndVideoMeetingDocument = gql`
  mutation endVideoMeeting($videoMeetingId: ID!) {
    endVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useEndVideoMeetingMutation__
 *
 * To run a mutation, you first call `useEndVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useEndVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>(
    EndVideoMeetingDocument,
    options,
  );
}
export type EndVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EndVideoMeetingMutation,
  EndVideoMeetingMutationVariables
>;
export const MarkCommunicationAsReadDocument = gql`
  mutation markCommunicationAsRead($communicationId: ID!) {
    markCommunicationAsRead(communicationId: $communicationId) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useMarkCommunicationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommunicationAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommunicationAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkCommunicationAsReadMutation({
 *   variables: {
 *     communicationId: // value for 'communicationId'
 *   },
 * });
 */
export function useMarkCommunicationAsReadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkCommunicationAsReadMutation, MarkCommunicationAsReadMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          MarkCommunicationAsReadMutation,
          MarkCommunicationAsReadMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<MarkCommunicationAsReadMutation, MarkCommunicationAsReadMutationVariables>(
    MarkCommunicationAsReadDocument,
    options,
  );
}
export type MarkCommunicationAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkCommunicationAsReadMutation,
  MarkCommunicationAsReadMutationVariables
>;
export const CreatePatientGoalsDocument = gql`
  mutation createPatientGoals($patientId: ID!, $goalInput: GoalInput!) {
    createPatientGoals(patientId: $patientId, goalInput: $goalInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientGoalsMutation__
 *
 * To run a mutation, you first call `useCreatePatientGoalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientGoalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientGoalsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     goalInput: // value for 'goalInput'
 *   },
 * });
 */
export function useCreatePatientGoalsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>(
    CreatePatientGoalsDocument,
    options,
  );
}
export type CreatePatientGoalsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientGoalsMutation,
  CreatePatientGoalsMutationVariables
>;
export const CreatePatientMedicalStatesDocument = gql`
  mutation createPatientMedicalStates($patientId: ID!, $medicalStateInput: MedicalStatesInput!) {
    createPatientMedicalStates(patientId: $patientId, medicalStateInput: $medicalStateInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientMedicalStatesMutation__
 *
 * To run a mutation, you first call `useCreatePatientMedicalStatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMedicalStatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientMedicalStatesMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     medicalStateInput: // value for 'medicalStateInput'
 *   },
 * });
 */
export function useCreatePatientMedicalStatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreatePatientMedicalStatesMutation,
        CreatePatientMedicalStatesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreatePatientMedicalStatesMutation,
          CreatePatientMedicalStatesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreatePatientMedicalStatesMutation,
    CreatePatientMedicalStatesMutationVariables
  >(CreatePatientMedicalStatesDocument, options);
}
export type CreatePatientMedicalStatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientMedicalStatesMutation,
  CreatePatientMedicalStatesMutationVariables
>;
export const ActivateSelfTreatmentPlanDocument = gql`
  mutation activateSelfTreatmentPlan($selfTreatmentPlanId: ID!) {
    activateSelfTreatmentPlan(selfTreatmentPlanId: $selfTreatmentPlanId) {
      success
      message
    }
  }
`;

/**
 * __useActivateSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useActivateSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateSelfTreatmentPlanMutation({
 *   variables: {
 *     selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 *   },
 * });
 */
export function useActivateSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateSelfTreatmentPlanMutation,
        ActivateSelfTreatmentPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateSelfTreatmentPlanMutation,
          ActivateSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateSelfTreatmentPlanMutation, ActivateSelfTreatmentPlanMutationVariables>(
    ActivateSelfTreatmentPlanDocument,
    options,
  );
}
export type ActivateSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateSelfTreatmentPlanMutation,
  ActivateSelfTreatmentPlanMutationVariables
>;
export const DeactivateSelfTreatmentPlanDocument = gql`
  mutation deactivateSelfTreatmentPlan($selfTreatmentPlanId: ID!) {
    deactivateSelfTreatmentPlan(selfTreatmentPlanId: $selfTreatmentPlanId) {
      success
      message
    }
  }
`;

/**
 * __useDeactivateSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useDeactivateSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateSelfTreatmentPlanMutation({
 *   variables: {
 *     selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 *   },
 * });
 */
export function useDeactivateSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeactivateSelfTreatmentPlanMutation,
        DeactivateSelfTreatmentPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeactivateSelfTreatmentPlanMutation,
          DeactivateSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeactivateSelfTreatmentPlanMutation,
    DeactivateSelfTreatmentPlanMutationVariables
  >(DeactivateSelfTreatmentPlanDocument, options);
}
export type DeactivateSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateSelfTreatmentPlanMutation,
  DeactivateSelfTreatmentPlanMutationVariables
>;
export const UpdatePatientGoalsDocument = gql`
  mutation updatePatientGoals($patientId: ID!, $goalInput: UpdateGoalInput!) {
    updatePatientGoals(patientId: $patientId, goalInput: $goalInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientGoalsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGoalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGoalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGoalsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     goalInput: // value for 'goalInput'
 *   },
 * });
 */
export function useUpdatePatientGoalsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>(
    UpdatePatientGoalsDocument,
    options,
  );
}
export type UpdatePatientGoalsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGoalsMutation,
  UpdatePatientGoalsMutationVariables
>;
export const UpdatePatientMedicalStatesDocument = gql`
  mutation updatePatientMedicalStates($patientId: ID!, $medicalStateInput: MedicalStatesInput!) {
    updatePatientMedicalStates(patientId: $patientId, medicalStateInput: $medicalStateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientMedicalStatesMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMedicalStatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMedicalStatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientMedicalStatesMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     medicalStateInput: // value for 'medicalStateInput'
 *   },
 * });
 */
export function useUpdatePatientMedicalStatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientMedicalStatesMutation,
        UpdatePatientMedicalStatesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientMedicalStatesMutation,
          UpdatePatientMedicalStatesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientMedicalStatesMutation,
    UpdatePatientMedicalStatesMutationVariables
  >(UpdatePatientMedicalStatesDocument, options);
}
export type UpdatePatientMedicalStatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientMedicalStatesMutation,
  UpdatePatientMedicalStatesMutationVariables
>;
export const UpdatePatientReferenceRangeDocument = gql`
  mutation updatePatientReferenceRange(
    $patientId: ID!
    $referenceRangeId: ID!
    $referenceRange: [ObservationComponentInput]!
  ) {
    updatePatientReferenceRange(
      patientId: $patientId
      referenceRangeId: $referenceRangeId
      referenceRange: $referenceRange
    ) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientReferenceRangeMutation__
 *
 * To run a mutation, you first call `useUpdatePatientReferenceRangeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientReferenceRangeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientReferenceRangeMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRangeId: // value for 'referenceRangeId'
 *     referenceRange: // value for 'referenceRange'
 *   },
 * });
 */
export function useUpdatePatientReferenceRangeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientReferenceRangeMutation,
        UpdatePatientReferenceRangeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientReferenceRangeMutation,
          UpdatePatientReferenceRangeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientReferenceRangeMutation,
    UpdatePatientReferenceRangeMutationVariables
  >(UpdatePatientReferenceRangeDocument, options);
}
export type UpdatePatientReferenceRangeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientReferenceRangeMutation,
  UpdatePatientReferenceRangeMutationVariables
>;
export const AddReferenceRangeToPatientDocument = gql`
  mutation addReferenceRangeToPatient($patientId: ID!, $referenceRange: PatientReferenceRangeInput!) {
    addReferenceRangeToPatient(patientId: $patientId, referenceRange: $referenceRange) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useAddReferenceRangeToPatientMutation__
 *
 * To run a mutation, you first call `useAddReferenceRangeToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddReferenceRangeToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddReferenceRangeToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRange: // value for 'referenceRange'
 *   },
 * });
 */
export function useAddReferenceRangeToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddReferenceRangeToPatientMutation,
        AddReferenceRangeToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddReferenceRangeToPatientMutation,
          AddReferenceRangeToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddReferenceRangeToPatientMutation,
    AddReferenceRangeToPatientMutationVariables
  >(AddReferenceRangeToPatientDocument, options);
}
export type AddReferenceRangeToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddReferenceRangeToPatientMutation,
  AddReferenceRangeToPatientMutationVariables
>;
export const RemoveReferenceRangeFromPatientDocument = gql`
  mutation removeReferenceRangeFromPatient($patientId: ID!, $referenceRangeId: ID!) {
    removeReferenceRangeFromPatient(patientId: $patientId, referenceRangeId: $referenceRangeId) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useRemoveReferenceRangeFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveReferenceRangeFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReferenceRangeFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveReferenceRangeFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRangeId: // value for 'referenceRangeId'
 *   },
 * });
 */
export function useRemoveReferenceRangeFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveReferenceRangeFromPatientMutation,
        RemoveReferenceRangeFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveReferenceRangeFromPatientMutation,
          RemoveReferenceRangeFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveReferenceRangeFromPatientMutation,
    RemoveReferenceRangeFromPatientMutationVariables
  >(RemoveReferenceRangeFromPatientDocument, options);
}
export type RemoveReferenceRangeFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveReferenceRangeFromPatientMutation,
  RemoveReferenceRangeFromPatientMutationVariables
>;
export const ReleaseVideoMeetingTaskDocument = gql`
  mutation releaseVideoMeetingTask($taskId: ID!) {
    releaseVideoMeetingTask(taskId: $taskId) {
      success
    }
  }
`;

/**
 * __useReleaseVideoMeetingTaskMutation__
 *
 * To run a mutation, you first call `useReleaseVideoMeetingTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReleaseVideoMeetingTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReleaseVideoMeetingTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useReleaseVideoMeetingTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ReleaseVideoMeetingTaskMutation, ReleaseVideoMeetingTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ReleaseVideoMeetingTaskMutation,
          ReleaseVideoMeetingTaskMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ReleaseVideoMeetingTaskMutation, ReleaseVideoMeetingTaskMutationVariables>(
    ReleaseVideoMeetingTaskDocument,
    options,
  );
}
export type ReleaseVideoMeetingTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ReleaseVideoMeetingTaskMutation,
  ReleaseVideoMeetingTaskMutationVariables
>;
export const RemovePatientFromDialoggUserInPatientDocument = gql`
  mutation removePatientFromDialoggUserInPatient($username: ID!, $patientId: ID!) {
    removePatientFromDialoggUser(username: $username, patientId: $patientId) {
      success
      dialoggUser {
        username
        onBehalf {
          accessiblePatients
          otherPatientIds
        }
      }
    }
  }
`;

/**
 * __useRemovePatientFromDialoggUserInPatientMutation__
 *
 * To run a mutation, you first call `useRemovePatientFromDialoggUserInPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientFromDialoggUserInPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientFromDialoggUserInPatientMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useRemovePatientFromDialoggUserInPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientFromDialoggUserInPatientMutation,
        RemovePatientFromDialoggUserInPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientFromDialoggUserInPatientMutation,
          RemovePatientFromDialoggUserInPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientFromDialoggUserInPatientMutation,
    RemovePatientFromDialoggUserInPatientMutationVariables
  >(RemovePatientFromDialoggUserInPatientDocument, options);
}
export type RemovePatientFromDialoggUserInPatientMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemovePatientFromDialoggUserInPatientMutation,
    RemovePatientFromDialoggUserInPatientMutationVariables
  >;
export const RemoveRpmMedicalDeviceFromPatientDocument = gql`
  mutation removeRpmMedicalDeviceFromPatient($patientId: ID!, $rpmMedicalDeviceId: ID!) {
    removeRpmMedicalDeviceFromPatient(patientId: $patientId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRemoveRpmMedicalDeviceFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveRpmMedicalDeviceFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRpmMedicalDeviceFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveRpmMedicalDeviceFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useRemoveRpmMedicalDeviceFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveRpmMedicalDeviceFromPatientMutation,
        RemoveRpmMedicalDeviceFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveRpmMedicalDeviceFromPatientMutation,
          RemoveRpmMedicalDeviceFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveRpmMedicalDeviceFromPatientMutation,
    RemoveRpmMedicalDeviceFromPatientMutationVariables
  >(RemoveRpmMedicalDeviceFromPatientDocument, options);
}
export type RemoveRpmMedicalDeviceFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveRpmMedicalDeviceFromPatientMutation,
  RemoveRpmMedicalDeviceFromPatientMutationVariables
>;
export const SendVideoMeetingInvitationSmsDocument = gql`
  mutation sendVideoMeetingInvitationSms($videoMeetingId: ID!, $phoneNumber: String!, $displayName: String) {
    sendVideoMeetingInvitationSms(
      videoMeetingId: $videoMeetingId
      phoneNumber: $phoneNumber
      displayName: $displayName
    ) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      videoMeeting {
        id
      }
    }
  }
`;

/**
 * __useSendVideoMeetingInvitationSmsMutation__
 *
 * To run a mutation, you first call `useSendVideoMeetingInvitationSmsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendVideoMeetingInvitationSmsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendVideoMeetingInvitationSmsMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *     phoneNumber: // value for 'phoneNumber'
 *     displayName: // value for 'displayName'
 *   },
 * });
 */
export function useSendVideoMeetingInvitationSmsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SendVideoMeetingInvitationSmsMutation,
        SendVideoMeetingInvitationSmsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SendVideoMeetingInvitationSmsMutation,
          SendVideoMeetingInvitationSmsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SendVideoMeetingInvitationSmsMutation,
    SendVideoMeetingInvitationSmsMutationVariables
  >(SendVideoMeetingInvitationSmsDocument, options);
}
export type SendVideoMeetingInvitationSmsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SendVideoMeetingInvitationSmsMutation,
  SendVideoMeetingInvitationSmsMutationVariables
>;
export const StartJoinVideoMeetingDocument = gql`
  mutation startJoinVideoMeeting($videoMeetingId: ID!, $videoMeetingURL: String) {
    startJoinVideoMeeting(videoMeetingId: $videoMeetingId, videoMeetingURL: $videoMeetingURL) {
      success
      message
    }
  }
`;

/**
 * __useStartJoinVideoMeetingMutation__
 *
 * To run a mutation, you first call `useStartJoinVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartJoinVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartJoinVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *     videoMeetingURL: // value for 'videoMeetingURL'
 *   },
 * });
 */
export function useStartJoinVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>(
    StartJoinVideoMeetingDocument,
    options,
  );
}
export type StartJoinVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartJoinVideoMeetingMutation,
  StartJoinVideoMeetingMutationVariables
>;
export const StartVideoMeetingDocument = gql`
  mutation startVideoMeeting($videoMeetingId: ID!) {
    startVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useStartVideoMeetingMutation__
 *
 * To run a mutation, you first call `useStartVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useStartVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>(
    StartVideoMeetingDocument,
    options,
  );
}
export type StartVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartVideoMeetingMutation,
  StartVideoMeetingMutationVariables
>;
export const UpdateGroupVideoMeetingParticipantsDocument = gql`
  mutation updateGroupVideoMeetingParticipants($videoMeetingGroupId: ID!, $patientIds: [ID!]) {
    updateGroupVideoMeetingParticipants(videoMeetingGroupId: $videoMeetingGroupId, patientIds: $patientIds) {
      success
      message
    }
  }
`;

/**
 * __useUpdateGroupVideoMeetingParticipantsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupVideoMeetingParticipantsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupVideoMeetingParticipantsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGroupVideoMeetingParticipantsMutation({
 *   variables: {
 *     videoMeetingGroupId: // value for 'videoMeetingGroupId'
 *     patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useUpdateGroupVideoMeetingParticipantsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateGroupVideoMeetingParticipantsMutation,
        UpdateGroupVideoMeetingParticipantsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateGroupVideoMeetingParticipantsMutation,
          UpdateGroupVideoMeetingParticipantsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateGroupVideoMeetingParticipantsMutation,
    UpdateGroupVideoMeetingParticipantsMutationVariables
  >(UpdateGroupVideoMeetingParticipantsDocument, options);
}
export type UpdateGroupVideoMeetingParticipantsMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateGroupVideoMeetingParticipantsMutation,
    UpdateGroupVideoMeetingParticipantsMutationVariables
  >;
export const TestPushNotificationDocument = gql`
  mutation testPushNotification($patientId: ID!, $appDeviceId: ID!) {
    testPushNotification(patientId: $patientId, appDeviceId: $appDeviceId) {
      objectReference {
        reference
      }
      success
      date
    }
  }
`;

/**
 * __useTestPushNotificationMutation__
 *
 * To run a mutation, you first call `useTestPushNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestPushNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestPushNotificationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *   },
 * });
 */
export function useTestPushNotificationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TestPushNotificationMutation, TestPushNotificationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TestPushNotificationMutation, TestPushNotificationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TestPushNotificationMutation, TestPushNotificationMutationVariables>(
    TestPushNotificationDocument,
    options,
  );
}
export type TestPushNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TestPushNotificationMutation,
  TestPushNotificationMutationVariables
>;
export const UpdateAppDeviceForPatientDocument = gql`
  mutation updateAppDeviceForPatient($patientId: ID!, $appDeviceId: ID!, $input: AppDeviceForPatientUpdateInput!) {
    updateAppDeviceForPatient(patientId: $patientId, appDeviceId: $appDeviceId, input: $input) {
      success
    }
  }
`;

/**
 * __useUpdateAppDeviceForPatientMutation__
 *
 * To run a mutation, you first call `useUpdateAppDeviceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppDeviceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAppDeviceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppDeviceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateAppDeviceForPatientMutation,
        UpdateAppDeviceForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateAppDeviceForPatientMutation,
          UpdateAppDeviceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAppDeviceForPatientMutation, UpdateAppDeviceForPatientMutationVariables>(
    UpdateAppDeviceForPatientDocument,
    options,
  );
}
export type UpdateAppDeviceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAppDeviceForPatientMutation,
  UpdateAppDeviceForPatientMutationVariables
>;
export const UpdateDigitalHomeVisitsSettingsForPatientDocument = gql`
  mutation updateDigitalHomeVisitsSettingsForPatient($patientId: ID!, $settings: DigitalHomeVisitsSettingsInput!) {
    updateDigitalHomeVisitsSettingsForPatient(patientId: $patientId, settings: $settings) {
      success
      message
      subscription {
        service
        settings {
          playRingtoneOnStart
          autoStart {
            enabled
            afterSeconds
          }
          requestVideoMeetings
          showParticipantVideoMeetingToolbar
        }
      }
    }
  }
`;

/**
 * __useUpdateDigitalHomeVisitsSettingsForPatientMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalHomeVisitsSettingsForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalHomeVisitsSettingsForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDigitalHomeVisitsSettingsForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateDigitalHomeVisitsSettingsForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDigitalHomeVisitsSettingsForPatientMutation,
        UpdateDigitalHomeVisitsSettingsForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDigitalHomeVisitsSettingsForPatientMutation,
          UpdateDigitalHomeVisitsSettingsForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDigitalHomeVisitsSettingsForPatientMutation,
    UpdateDigitalHomeVisitsSettingsForPatientMutationVariables
  >(UpdateDigitalHomeVisitsSettingsForPatientDocument, options);
}
export type UpdateDigitalHomeVisitsSettingsForPatientMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateDigitalHomeVisitsSettingsForPatientMutation,
    UpdateDigitalHomeVisitsSettingsForPatientMutationVariables
  >;
export const UpdateObservationStatusDocument = gql`
  mutation updateObservationStatus($id: ID!, $status: String!) {
    updateObservationStatus(id: $id, status: $status) {
      success
    }
  }
`;

/**
 * __useUpdateObservationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateObservationStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateObservationStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateObservationStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateObservationStatusMutation, UpdateObservationStatusMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateObservationStatusMutation,
          UpdateObservationStatusMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateObservationStatusMutation, UpdateObservationStatusMutationVariables>(
    UpdateObservationStatusDocument,
    options,
  );
}
export type UpdateObservationStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateObservationStatusMutation,
  UpdateObservationStatusMutationVariables
>;
export const UpdateRpmMedicalDeviceDocument = gql`
  mutation updateRpmMedicalDevice($id: ID!, $updateInput: RpmMedicalDeviceUpdateInput!) {
    updateRpmMedicalDevice(id: $id, updateInput: $updateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRpmMedicalDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>(
    UpdateRpmMedicalDeviceDocument,
    options,
  );
}
export type UpdateRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateRpmMedicalDeviceMutation,
  UpdateRpmMedicalDeviceMutationVariables
>;
export const ConcreteObservationDocument = gql`
  query concreteObservation($observationId: ID!) {
    concreteObservation(observationId: $observationId) {
      id
      manual
      gateway {
        display
      }
      identifier {
        value
      }
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      device {
        reference
        display
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      received
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useConcreteObservationQuery__
 *
 * To run a query within a Vue component, call `useConcreteObservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteObservationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConcreteObservationQuery({
 *   observationId: // value for 'observationId'
 * });
 */
export function useConcreteObservationQuery(
  variables:
    | ConcreteObservationQueryVariables
    | VueCompositionApi.Ref<ConcreteObservationQueryVariables>
    | ReactiveFunction<ConcreteObservationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ConcreteObservationQuery, ConcreteObservationQueryVariables>(
    ConcreteObservationDocument,
    variables,
    options,
  );
}
export function useConcreteObservationLazyQuery(
  variables?:
    | ConcreteObservationQueryVariables
    | VueCompositionApi.Ref<ConcreteObservationQueryVariables>
    | ReactiveFunction<ConcreteObservationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ConcreteObservationQuery, ConcreteObservationQueryVariables>(
    ConcreteObservationDocument,
    variables,
    options,
  );
}
export type ConcreteObservationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ConcreteObservationQuery,
  ConcreteObservationQueryVariables
>;
export const GetCarePlanByIdDocument = gql`
  query getCarePlanByID($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      id
      status
      subject {
        reference
      }
      title
      description
      created
      period {
        start
        end
      }
      activity {
        outcomeReference {
          reference
          identifier {
            value
          }
          display
          type
        }
        observations {
          id
          identifier {
            value
          }
          text
          basedOn {
            reference
          }
          status
          note {
            text
          }
          fromTemplate {
            reference
          }
          code {
            coding {
              system
              version
              code
              display
            }
            text
          }
          component {
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            valueQuantity {
              value
              unit
            }
            referenceRange {
              low {
                value
                unit
              }
              high {
                value
                unit
              }
              text
              type {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
            }
          }
        }
        detail {
          instantiatesCanonical
          questionnaires {
            id
            title
            derivedFrom
          }
          status
          scheduledTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
        }
      }
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanByIdQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanByIdQuery(
  variables:
    | GetCarePlanByIdQueryVariables
    | VueCompositionApi.Ref<GetCarePlanByIdQueryVariables>
    | ReactiveFunction<GetCarePlanByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>(
    GetCarePlanByIdDocument,
    variables,
    options,
  );
}
export function useGetCarePlanByIdLazyQuery(
  variables?:
    | GetCarePlanByIdQueryVariables
    | VueCompositionApi.Ref<GetCarePlanByIdQueryVariables>
    | ReactiveFunction<GetCarePlanByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>(
    GetCarePlanByIdDocument,
    variables,
    options,
  );
}
export type GetCarePlanByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanByIdQuery,
  GetCarePlanByIdQueryVariables
>;
export const GetCarePlanTitleQueryDocument = gql`
  query getCarePlanTitleQuery($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      title
    }
  }
`;

/**
 * __useGetCarePlanTitleQueryQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTitleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTitleQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTitleQueryQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanTitleQueryQuery(
  variables:
    | GetCarePlanTitleQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTitleQueryQueryVariables>
    | ReactiveFunction<GetCarePlanTitleQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>(
    GetCarePlanTitleQueryDocument,
    variables,
    options,
  );
}
export function useGetCarePlanTitleQueryLazyQuery(
  variables?:
    | GetCarePlanTitleQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTitleQueryQueryVariables>
    | ReactiveFunction<GetCarePlanTitleQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>(
    GetCarePlanTitleQueryDocument,
    variables,
    options,
  );
}
export type GetCarePlanTitleQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTitleQueryQuery,
  GetCarePlanTitleQueryQueryVariables
>;
export const GetCarePlanDocumentsQueryDocument = gql`
  query getCarePlanDocumentsQuery($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanDocumentsQueryQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanDocumentsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanDocumentsQueryQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanDocumentsQueryQuery(
  variables:
    | GetCarePlanDocumentsQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanDocumentsQueryQueryVariables>
    | ReactiveFunction<GetCarePlanDocumentsQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>(
    GetCarePlanDocumentsQueryDocument,
    variables,
    options,
  );
}
export function useGetCarePlanDocumentsQueryLazyQuery(
  variables?:
    | GetCarePlanDocumentsQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanDocumentsQueryQueryVariables>
    | ReactiveFunction<GetCarePlanDocumentsQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>(
    GetCarePlanDocumentsQueryDocument,
    variables,
    options,
  );
}
export type GetCarePlanDocumentsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanDocumentsQueryQuery,
  GetCarePlanDocumentsQueryQueryVariables
>;
export const GetCarePlanTemplateDocument = gql`
  query getCarePlanTemplate($id: ID!) {
    getCarePlanTemplate(id: $id) {
      id
      status
      title
      description
      created
      carePlanType
      period {
        start
        end
      }
      activity {
        outcomeReference {
          reference
          identifier {
            value
          }
          display
          type
        }
        observations {
          id
          identifier {
            value
          }
          text
          basedOn {
            reference
          }
          status
          note {
            text
          }
          fromTemplate {
            reference
          }
          code {
            coding {
              system
              version
              code
              display
            }
            text
          }
          component {
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            valueQuantity {
              value
              unit
            }
            referenceRange {
              low {
                value
                unit
              }
              high {
                value
                unit
              }
              text
              type {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
            }
          }
        }
        detail {
          instantiatesCanonical
          questionnaires {
            id
            title
            derivedFrom
          }
          status
          scheduledTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
        }
      }
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCarePlanTemplateQuery(
  variables:
    | GetCarePlanTemplateQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>(
    GetCarePlanTemplateDocument,
    variables,
    options,
  );
}
export function useGetCarePlanTemplateLazyQuery(
  variables?:
    | GetCarePlanTemplateQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>(
    GetCarePlanTemplateDocument,
    variables,
    options,
  );
}
export type GetCarePlanTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTemplateQuery,
  GetCarePlanTemplateQueryVariables
>;
export const GetObservationTemplateDocument = gql`
  query getObservationTemplate($id: ID!) {
    getObservationTemplate(id: $id) {
      id
      systemDefined
      identifier {
        value
      }
      status
      code {
        coding {
          system
          display
          code
        }
        text
      }
      component {
        valueQuantity {
          unit
        }
        code {
          coding {
            system
            display
            code
          }
          text
        }
        referenceRange {
          low {
            value
          }
          high {
            value
          }
          text
          type {
            text
            coding {
              code
              display
            }
          }
        }
        dataAbsentReason {
          text
        }
      }
    }
  }
`;

/**
 * __useGetObservationTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetObservationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObservationTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetObservationTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetObservationTemplateQuery(
  variables:
    | GetObservationTemplateQueryVariables
    | VueCompositionApi.Ref<GetObservationTemplateQueryVariables>
    | ReactiveFunction<GetObservationTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>(
    GetObservationTemplateDocument,
    variables,
    options,
  );
}
export function useGetObservationTemplateLazyQuery(
  variables?:
    | GetObservationTemplateQueryVariables
    | VueCompositionApi.Ref<GetObservationTemplateQueryVariables>
    | ReactiveFunction<GetObservationTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>(
    GetObservationTemplateDocument,
    variables,
    options,
  );
}
export type GetObservationTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetObservationTemplateQuery,
  GetObservationTemplateQueryVariables
>;
export const GetPatientTasksNotCompletedDocument = gql`
  query getPatientTasksNotCompleted($tasks: [String!]!) {
    getPatientTasksNotCompleted(tasks: $tasks) {
      task {
        id
        authoredOn
      }
      patientTasks {
        id
        code {
          text
        }
        restriction {
          period {
            start
            end
          }
        }
      }
    }
  }
`;

/**
 * __useGetPatientTasksNotCompletedQuery__
 *
 * To run a query within a Vue component, call `useGetPatientTasksNotCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientTasksNotCompletedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientTasksNotCompletedQuery({
 *   tasks: // value for 'tasks'
 * });
 */
export function useGetPatientTasksNotCompletedQuery(
  variables:
    | GetPatientTasksNotCompletedQueryVariables
    | VueCompositionApi.Ref<GetPatientTasksNotCompletedQueryVariables>
    | ReactiveFunction<GetPatientTasksNotCompletedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>(
    GetPatientTasksNotCompletedDocument,
    variables,
    options,
  );
}
export function useGetPatientTasksNotCompletedLazyQuery(
  variables?:
    | GetPatientTasksNotCompletedQueryVariables
    | VueCompositionApi.Ref<GetPatientTasksNotCompletedQueryVariables>
    | ReactiveFunction<GetPatientTasksNotCompletedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>(
    GetPatientTasksNotCompletedDocument,
    variables,
    options,
  );
}
export type GetPatientTasksNotCompletedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientTasksNotCompletedQuery,
  GetPatientTasksNotCompletedQueryVariables
>;
export const GetTasksForPatientDocument = gql`
  query getTasksForPatient($patientId: ID!, $from: dateTime, $to: dateTime) {
    getTasksForPatient(patientId: $patientId, from: $from, to: $to) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      lastModified
      missedSubmissions {
        kind
        name
      }
      note {
        authorString
        time
        text
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        id
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
    }
  }
`;

/**
 * __useGetTasksForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetTasksForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTasksForPatientQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetTasksForPatientQuery(
  variables:
    | GetTasksForPatientQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientQueryVariables>
    | ReactiveFunction<GetTasksForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>(
    GetTasksForPatientDocument,
    variables,
    options,
  );
}
export function useGetTasksForPatientLazyQuery(
  variables?:
    | GetTasksForPatientQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientQueryVariables>
    | ReactiveFunction<GetTasksForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>(
    GetTasksForPatientDocument,
    variables,
    options,
  );
}
export type GetTasksForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTasksForPatientQuery,
  GetTasksForPatientQueryVariables
>;
export const GetTasksForPatientByDateRangeDocument = gql`
  query getTasksForPatientByDateRange($id: ID, $fromDate: dateTime, $toDate: dateTime) {
    getTasksForPatientByDateRange(id: $id, fromDate: $fromDate, toDate: $toDate) {
      task {
        id
        status
        code {
          text
        }
        description
        priority
        authoredOn
        lastModified
        restriction {
          period {
            start
            end
          }
        }
        reminderDate
        reminderSent
        carePlan {
          id
          title
        }
      }
      hpTasks
    }
  }
`;

/**
 * __useGetTasksForPatientByDateRangeQuery__
 *
 * To run a query within a Vue component, call `useGetTasksForPatientByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForPatientByDateRangeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTasksForPatientByDateRangeQuery({
 *   id: // value for 'id'
 *   fromDate: // value for 'fromDate'
 *   toDate: // value for 'toDate'
 * });
 */
export function useGetTasksForPatientByDateRangeQuery(
  variables:
    | GetTasksForPatientByDateRangeQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientByDateRangeQueryVariables>
    | ReactiveFunction<GetTasksForPatientByDateRangeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetTasksForPatientByDateRangeQuery,
        GetTasksForPatientByDateRangeQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetTasksForPatientByDateRangeQuery, GetTasksForPatientByDateRangeQueryVariables>(
    GetTasksForPatientByDateRangeDocument,
    variables,
    options,
  );
}
export function useGetTasksForPatientByDateRangeLazyQuery(
  variables:
    | GetTasksForPatientByDateRangeQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientByDateRangeQueryVariables>
    | ReactiveFunction<GetTasksForPatientByDateRangeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetTasksForPatientByDateRangeQuery,
        GetTasksForPatientByDateRangeQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetTasksForPatientByDateRangeQuery,
    GetTasksForPatientByDateRangeQueryVariables
  >(GetTasksForPatientByDateRangeDocument, variables, options);
}
export type GetTasksForPatientByDateRangeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTasksForPatientByDateRangeQuery,
  GetTasksForPatientByDateRangeQueryVariables
>;
export const LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument = gql`
  query lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient(
    $patientId: ID!
    $carePlanId: ID
    $loincCode: String
  ) {
    lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient(
      patientId: $patientId
      carePlanId: $carePlanId
      loincCode: $loincCode
    ) {
      manual
      id
      identifier {
        value
      }
      text
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      note {
        authorString
        authorReference {
          reference
          identifier {
            system
            use
            value
            type {
              coding {
                system
                version
                code
                display
                userSelected
              }
              text
            }
          }
          type
          display
        }
        time
        text
      }
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery__
 *
 * To run a query within a Vue component, call `useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery({
 *   patientId: // value for 'patientId'
 *   carePlanId: // value for 'carePlanId'
 *   loincCode: // value for 'loincCode'
 * });
 */
export function useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery(
  variables:
    | LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
    | VueCompositionApi.Ref<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>
    | ReactiveFunction<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >(LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument, variables, options);
}
export function useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientLazyQuery(
  variables?:
    | LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
    | VueCompositionApi.Ref<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>
    | ReactiveFunction<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >(LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument, variables, options);
}
export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >;
export const GetAllObservationTemplatesDocument = gql`
  query getAllObservationTemplates {
    getAllObservationTemplates {
      id
      systemDefined
      identifier {
        value
      }
      status
      code {
        coding {
          system
          display
          code
        }
        text
      }
      component {
        valueQuantity {
          unit
        }
        code {
          coding {
            system
            display
            code
          }
          text
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            text
            coding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAllObservationTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllObservationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllObservationTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllObservationTemplatesQuery();
 */
export function useGetAllObservationTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>(
    GetAllObservationTemplatesDocument,
    {},
    options,
  );
}
export function useGetAllObservationTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>(
    GetAllObservationTemplatesDocument,
    {},
    options,
  );
}
export type GetAllObservationTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllObservationTemplatesQuery,
  GetAllObservationTemplatesQueryVariables
>;
export const GetConcreteObservationsForPatientDocument = gql`
  query getConcreteObservationsForPatient($patientId: ID!, $carePlan: ID, $from: dateTime, $to: dateTime) {
    getConcreteObservationsForPatient(patientId: $patientId, carePlan: $carePlan, from: $from, to: $to) {
      manual
      id
      identifier {
        value
      }
      text
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      note {
        authorString
        authorReference {
          reference
          identifier {
            system
            use
            value
            type {
              coding {
                system
                version
                code
                display
                userSelected
              }
              text
            }
          }
          type
          display
        }
        time
        text
      }
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useGetConcreteObservationsForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetConcreteObservationsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteObservationsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConcreteObservationsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   carePlan: // value for 'carePlan'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetConcreteObservationsForPatientQuery(
  variables:
    | GetConcreteObservationsForPatientQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientQuery,
        GetConcreteObservationsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetConcreteObservationsForPatientQuery,
    GetConcreteObservationsForPatientQueryVariables
  >(GetConcreteObservationsForPatientDocument, variables, options);
}
export function useGetConcreteObservationsForPatientLazyQuery(
  variables?:
    | GetConcreteObservationsForPatientQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientQuery,
        GetConcreteObservationsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetConcreteObservationsForPatientQuery,
    GetConcreteObservationsForPatientQueryVariables
  >(GetConcreteObservationsForPatientDocument, variables, options);
}
export type GetConcreteObservationsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetConcreteObservationsForPatientQuery,
  GetConcreteObservationsForPatientQueryVariables
>;
export const GetConcreteObservationsForPatientAsCsvDocument = gql`
  query getConcreteObservationsForPatientAsCsv($patientIds: [ID]!) {
    getConcreteObservationsForPatientAsCsv(patientIds: $patientIds) {
      csv
    }
  }
`;

/**
 * __useGetConcreteObservationsForPatientAsCsvQuery__
 *
 * To run a query within a Vue component, call `useGetConcreteObservationsForPatientAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteObservationsForPatientAsCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConcreteObservationsForPatientAsCsvQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function useGetConcreteObservationsForPatientAsCsvQuery(
  variables:
    | GetConcreteObservationsForPatientAsCsvQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientAsCsvQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientAsCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientAsCsvQuery,
        GetConcreteObservationsForPatientAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetConcreteObservationsForPatientAsCsvQuery,
    GetConcreteObservationsForPatientAsCsvQueryVariables
  >(GetConcreteObservationsForPatientAsCsvDocument, variables, options);
}
export function useGetConcreteObservationsForPatientAsCsvLazyQuery(
  variables?:
    | GetConcreteObservationsForPatientAsCsvQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientAsCsvQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientAsCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientAsCsvQuery,
        GetConcreteObservationsForPatientAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetConcreteObservationsForPatientAsCsvQuery,
    GetConcreteObservationsForPatientAsCsvQueryVariables
  >(GetConcreteObservationsForPatientAsCsvDocument, variables, options);
}
export type GetConcreteObservationsForPatientAsCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetConcreteObservationsForPatientAsCsvQuery,
  GetConcreteObservationsForPatientAsCsvQueryVariables
>;
export const GetQuestionnaireTemplateDocument = gql`
  query getQuestionnaireTemplate($id: ID!) {
    getQuestionnaireTemplate(id: $id) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionnaireTemplateQuery(
  variables:
    | GetQuestionnaireTemplateQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireTemplateQueryVariables>
    | ReactiveFunction<GetQuestionnaireTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>(
    GetQuestionnaireTemplateDocument,
    variables,
    options,
  );
}
export function useGetQuestionnaireTemplateLazyQuery(
  variables?:
    | GetQuestionnaireTemplateQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireTemplateQueryVariables>
    | ReactiveFunction<GetQuestionnaireTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>(
    GetQuestionnaireTemplateDocument,
    variables,
    options,
  );
}
export type GetQuestionnaireTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireTemplateQuery,
  GetQuestionnaireTemplateQueryVariables
>;
export const GetCarePlanQuestionnaireDocument = gql`
  query getCarePlanQuestionnaire($carePlanId: ID!, $questionnaireId: ID!) {
    getCarePlanQuestionnaire(carePlanId: $carePlanId, questionnaireId: $questionnaireId) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanQuestionnaireQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanQuestionnaireQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanQuestionnaireQuery({
 *   carePlanId: // value for 'carePlanId'
 *   questionnaireId: // value for 'questionnaireId'
 * });
 */
export function useGetCarePlanQuestionnaireQuery(
  variables:
    | GetCarePlanQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>(
    GetCarePlanQuestionnaireDocument,
    variables,
    options,
  );
}
export function useGetCarePlanQuestionnaireLazyQuery(
  variables?:
    | GetCarePlanQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>(
    GetCarePlanQuestionnaireDocument,
    variables,
    options,
  );
}
export type GetCarePlanQuestionnaireQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanQuestionnaireQuery,
  GetCarePlanQuestionnaireQueryVariables
>;
export const GetCarePlanTemplateQuestionnaireDocument = gql`
  query getCarePlanTemplateQuestionnaire($carePlanTemplateId: ID!, $questionnaireId: ID!) {
    getCarePlanTemplateQuestionnaire(carePlanTemplateId: $carePlanTemplateId, questionnaireId: $questionnaireId) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanTemplateQuestionnaireQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTemplateQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTemplateQuestionnaireQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTemplateQuestionnaireQuery({
 *   carePlanTemplateId: // value for 'carePlanTemplateId'
 *   questionnaireId: // value for 'questionnaireId'
 * });
 */
export function useGetCarePlanTemplateQuestionnaireQuery(
  variables:
    | GetCarePlanTemplateQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCarePlanTemplateQuestionnaireQuery,
        GetCarePlanTemplateQuestionnaireQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetCarePlanTemplateQuestionnaireQuery,
    GetCarePlanTemplateQuestionnaireQueryVariables
  >(GetCarePlanTemplateQuestionnaireDocument, variables, options);
}
export function useGetCarePlanTemplateQuestionnaireLazyQuery(
  variables?:
    | GetCarePlanTemplateQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCarePlanTemplateQuestionnaireQuery,
        GetCarePlanTemplateQuestionnaireQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetCarePlanTemplateQuestionnaireQuery,
    GetCarePlanTemplateQuestionnaireQueryVariables
  >(GetCarePlanTemplateQuestionnaireDocument, variables, options);
}
export type GetCarePlanTemplateQuestionnaireQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTemplateQuestionnaireQuery,
  GetCarePlanTemplateQuestionnaireQueryVariables
>;
export const BookedMeetingsForPatientDocument = gql`
  query bookedMeetingsForPatient($patientId: ID!, $startAtMost: dateTime!, $startAtLeast: dateTime!) {
    bookedMeetingsForPatient: videoMeetingTasksForPatient(
      patientId: $patientId
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
      status: booked
    ) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          appointmentGroupId
          description
          status
          start
          end
          patients {
            id
            name {
              text
            }
          }
          supportingInformation {
            reference
          }
        }
        carePlan {
          id
        }
      }
    }
  }
`;

/**
 * __useBookedMeetingsForPatientQuery__
 *
 * To run a query within a Vue component, call `useBookedMeetingsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedMeetingsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookedMeetingsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useBookedMeetingsForPatientQuery(
  variables:
    | BookedMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForPatientQueryVariables>
    | ReactiveFunction<BookedMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>(
    BookedMeetingsForPatientDocument,
    variables,
    options,
  );
}
export function useBookedMeetingsForPatientLazyQuery(
  variables?:
    | BookedMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForPatientQueryVariables>
    | ReactiveFunction<BookedMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>(
    BookedMeetingsForPatientDocument,
    variables,
    options,
  );
}
export type BookedMeetingsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BookedMeetingsForPatientQuery,
  BookedMeetingsForPatientQueryVariables
>;
export const BookedMeetingsForEveryoneDocument = gql`
  query bookedMeetingsForEveryone($startAtMost: dateTime!, $startAtLeast: dateTime!) {
    bookedMeetingsForEveryone: videoMeetingTasks(
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
      status: booked
    ) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          appointmentGroupId
          patients {
            id
            name {
              text
            }
          }
          start
          end
          meetingEndTime
          meetingStartTime
          supportingInformation {
            reference
          }
        }
        carePlan {
          id
        }
      }
    }
  }
`;

/**
 * __useBookedMeetingsForEveryoneQuery__
 *
 * To run a query within a Vue component, call `useBookedMeetingsForEveryoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedMeetingsForEveryoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookedMeetingsForEveryoneQuery({
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useBookedMeetingsForEveryoneQuery(
  variables:
    | BookedMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<BookedMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>(
    BookedMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export function useBookedMeetingsForEveryoneLazyQuery(
  variables?:
    | BookedMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<BookedMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>(
    BookedMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export type BookedMeetingsForEveryoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BookedMeetingsForEveryoneQuery,
  BookedMeetingsForEveryoneQueryVariables
>;
export const AllMeetingsForPatientDocument = gql`
  query allMeetingsForPatient($patientId: ID!, $startAtMost: dateTime!, $startAtLeast: dateTime!) {
    allMeetingsForPatient: videoMeetingTasksForPatient(
      patientId: $patientId
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
    ) {
      id
      status
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          description
          appointmentGroupId
          patients {
            id
            name {
              text
            }
          }
          status
          start
          end
          supportingInformation {
            reference
          }
        }
        carePlan {
          id
        }
      }
    }
  }
`;

/**
 * __useAllMeetingsForPatientQuery__
 *
 * To run a query within a Vue component, call `useAllMeetingsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMeetingsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllMeetingsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useAllMeetingsForPatientQuery(
  variables:
    | AllMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForPatientQueryVariables>
    | ReactiveFunction<AllMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>(
    AllMeetingsForPatientDocument,
    variables,
    options,
  );
}
export function useAllMeetingsForPatientLazyQuery(
  variables?:
    | AllMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForPatientQueryVariables>
    | ReactiveFunction<AllMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>(
    AllMeetingsForPatientDocument,
    variables,
    options,
  );
}
export type AllMeetingsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllMeetingsForPatientQuery,
  AllMeetingsForPatientQueryVariables
>;
export const AllMeetingsForEveryoneDocument = gql`
  query allMeetingsForEveryone($startAtMost: dateTime!, $startAtLeast: dateTime!) {
    allMeetingsForEveryone: videoMeetingTasks(startAtMost: $startAtMost, startAtLeast: $startAtLeast) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          description
          appointmentGroupId
          patients {
            id
            name {
              text
            }
          }
          status
          start
          end
          meetingEndTime
          meetingStartTime
          supportingInformation {
            reference
          }
        }
        carePlan {
          id
        }
      }
    }
  }
`;

/**
 * __useAllMeetingsForEveryoneQuery__
 *
 * To run a query within a Vue component, call `useAllMeetingsForEveryoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMeetingsForEveryoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllMeetingsForEveryoneQuery({
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useAllMeetingsForEveryoneQuery(
  variables:
    | AllMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<AllMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>(
    AllMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export function useAllMeetingsForEveryoneLazyQuery(
  variables?:
    | AllMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<AllMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>(
    AllMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export type AllMeetingsForEveryoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllMeetingsForEveryoneQuery,
  AllMeetingsForEveryoneQueryVariables
>;
export const PatientRequestDocument = gql`
  query patientRequest($taskId: ID!) {
    patientRequest: getTaskById(taskId: $taskId) {
      id
      status
      priority
      note {
        time
        text
        authorString
        authorReference {
          display
          reference
        }
      }
      description
      authoredOn
    }
  }
`;

/**
 * __usePatientRequestQuery__
 *
 * To run a query within a Vue component, call `usePatientRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientRequestQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function usePatientRequestQuery(
  variables:
    | PatientRequestQueryVariables
    | VueCompositionApi.Ref<PatientRequestQueryVariables>
    | ReactiveFunction<PatientRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientRequestQuery, PatientRequestQueryVariables>(
    PatientRequestDocument,
    variables,
    options,
  );
}
export function usePatientRequestLazyQuery(
  variables?:
    | PatientRequestQueryVariables
    | VueCompositionApi.Ref<PatientRequestQueryVariables>
    | ReactiveFunction<PatientRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientRequestQuery, PatientRequestQueryVariables>(
    PatientRequestDocument,
    variables,
    options,
  );
}
export type PatientRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientRequestQuery,
  PatientRequestQueryVariables
>;
export const GetVideoMeetingCarePlanDocument = gql`
  query getVideoMeetingCarePlan($patientId: ID!) {
    getVideoMeetingCarePlan(patientId: $patientId) {
      activity {
        id
        description
        status
        identifier {
          system
          value
        }
        code {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      scheduledTiming {
        repeat {
          boundsPeriod {
            start
            end
          }
          dayOfWeek
          timeOfDay
          periodUnit
          period
        }
      }
      durationInMinutes
    }
  }
`;

/**
 * __useGetVideoMeetingCarePlanQuery__
 *
 * To run a query within a Vue component, call `useGetVideoMeetingCarePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoMeetingCarePlanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetVideoMeetingCarePlanQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetVideoMeetingCarePlanQuery(
  variables:
    | GetVideoMeetingCarePlanQueryVariables
    | VueCompositionApi.Ref<GetVideoMeetingCarePlanQueryVariables>
    | ReactiveFunction<GetVideoMeetingCarePlanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>(
    GetVideoMeetingCarePlanDocument,
    variables,
    options,
  );
}
export function useGetVideoMeetingCarePlanLazyQuery(
  variables?:
    | GetVideoMeetingCarePlanQueryVariables
    | VueCompositionApi.Ref<GetVideoMeetingCarePlanQueryVariables>
    | ReactiveFunction<GetVideoMeetingCarePlanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetVideoMeetingCarePlanQuery, GetVideoMeetingCarePlanQueryVariables>(
    GetVideoMeetingCarePlanDocument,
    variables,
    options,
  );
}
export type GetVideoMeetingCarePlanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetVideoMeetingCarePlanQuery,
  GetVideoMeetingCarePlanQueryVariables
>;
export const AddPlannedVideoMeetingDocument = gql`
  mutation addPlannedVideoMeeting($patientId: ID!, $input: PlannedVideoMeetingCreateInput!) {
    addPlannedVideoMeeting(patientId: $patientId, input: $input) {
      plannedVideoMeeting {
        scheduledTiming {
          repeat {
            boundsPeriod {
              start
              end
            }
            dayOfWeek
            timeOfDay
            periodUnit
            period
          }
        }
        durationInMinutes
      }
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useAddPlannedVideoMeetingMutation__
 *
 * To run a mutation, you first call `useAddPlannedVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPlannedVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPlannedVideoMeetingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddPlannedVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPlannedVideoMeetingMutation, AddPlannedVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPlannedVideoMeetingMutation, AddPlannedVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPlannedVideoMeetingMutation, AddPlannedVideoMeetingMutationVariables>(
    AddPlannedVideoMeetingDocument,
    options,
  );
}
export type AddPlannedVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPlannedVideoMeetingMutation,
  AddPlannedVideoMeetingMutationVariables
>;
export const UpdatePlannedVideoMeetingDocument = gql`
  mutation updatePlannedVideoMeeting(
    $patientId: ID!
    $plannedVideoMeetingId: ID!
    $input: PlannedVideoMeetingUpdateInput!
  ) {
    updatePlannedVideoMeeting(patientId: $patientId, plannedVideoMeetingId: $plannedVideoMeetingId, input: $input) {
      plannedVideoMeeting {
        scheduledTiming {
          repeat {
            boundsPeriod {
              start
              end
            }
            dayOfWeek
            timeOfDay
            periodUnit
            period
          }
        }
        durationInMinutes
      }
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdatePlannedVideoMeetingMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePlannedVideoMeetingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     plannedVideoMeetingId: // value for 'plannedVideoMeetingId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePlannedVideoMeetingMutation,
        UpdatePlannedVideoMeetingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePlannedVideoMeetingMutation,
          UpdatePlannedVideoMeetingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePlannedVideoMeetingMutation, UpdatePlannedVideoMeetingMutationVariables>(
    UpdatePlannedVideoMeetingDocument,
    options,
  );
}
export type UpdatePlannedVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePlannedVideoMeetingMutation,
  UpdatePlannedVideoMeetingMutationVariables
>;
export const RescheduleVideoMeetingDocument = gql`
  mutation rescheduleVideoMeeting(
    $id: ID!
    $start: dateTime!
    $end: dateTime!
    $description: String
    $patientIds: [ID!]
  ) {
    rescheduleVideoMeeting(
      videoMeetingId: $id
      start: $start
      end: $end
      description: $description
      patientIds: $patientIds
    ) {
      success
      calendarInvitation
    }
  }
`;

/**
 * __useRescheduleVideoMeetingMutation__
 *
 * To run a mutation, you first call `useRescheduleVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRescheduleVideoMeetingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     start: // value for 'start'
 *     end: // value for 'end'
 *     description: // value for 'description'
 *     patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useRescheduleVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>(
    RescheduleVideoMeetingDocument,
    options,
  );
}
export type RescheduleVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RescheduleVideoMeetingMutation,
  RescheduleVideoMeetingMutationVariables
>;
export const RemovePlannedVideoMeetingDocument = gql`
  mutation removePlannedVideoMeeting($patientId: ID!, $plannedVideoMeetingId: ID!) {
    removePlannedVideoMeeting(patientId: $patientId, plannedVideoMeetingId: $plannedVideoMeetingId) {
      plannedVideoMeeting {
        activity {
          id
          status
          fromTemplate {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          identifier {
            system
            use
            value
          }
          code {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
          effectiveTiming {
            event
            repeat {
              dayOfWeek
              timeOfDay
              periodUnit
              period
              boundsPeriod {
                start
                end
              }
            }
          }
          interpretation {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
          component {
            code {
              text
            }
            valueQuantity {
              value
              unit
            }
            valueString
            referenceRange {
              low {
                value
                unit
              }
              high {
                value
                unit
              }
              text
              type {
                text
              }
            }
            interpretation {
              text
            }
            dataAbsentReason {
              coding {
                system
                version
                code
                display
                userSelected
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
              extension {
                url
                valueBoolean
                valueInteger
                valueString
                ValueId
              }
            }
          }
          note {
            authorString
            authorReference {
              reference
              identifier {
                system
                use
                value
              }
              type
              display
            }
            time
            text
          }
          alarmIcon
          callbackMinutes
          debounceDelay
          noCarePlanRequired
          technical
          generatesAlarm
          locationTraceOnly
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          resolveAction
          description
        }
        scheduledTiming {
          event
          repeat {
            dayOfWeek
            timeOfDay
            periodUnit
            period
          }
        }
        durationInMinutes
      }
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useRemovePlannedVideoMeetingMutation__
 *
 * To run a mutation, you first call `useRemovePlannedVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlannedVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePlannedVideoMeetingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     plannedVideoMeetingId: // value for 'plannedVideoMeetingId'
 *   },
 * });
 */
export function useRemovePlannedVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePlannedVideoMeetingMutation,
        RemovePlannedVideoMeetingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePlannedVideoMeetingMutation,
          RemovePlannedVideoMeetingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemovePlannedVideoMeetingMutation, RemovePlannedVideoMeetingMutationVariables>(
    RemovePlannedVideoMeetingDocument,
    options,
  );
}
export type RemovePlannedVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePlannedVideoMeetingMutation,
  RemovePlannedVideoMeetingMutationVariables
>;
export const PlanVideoMeetingDocument = gql`
  mutation planVideoMeeting($patientIds: [ID!]!, $createInput: VideoMeetingInput!) {
    planVideoMeeting(patientIds: $patientIds, createInput: $createInput) {
      success
      videoMeeting {
        id
      }
      calendarInvitation
    }
  }
`;

/**
 * __usePlanVideoMeetingMutation__
 *
 * To run a mutation, you first call `usePlanVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePlanVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePlanVideoMeetingMutation({
 *   variables: {
 *     patientIds: // value for 'patientIds'
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function usePlanVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>(
    PlanVideoMeetingDocument,
    options,
  );
}
export type PlanVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PlanVideoMeetingMutation,
  PlanVideoMeetingMutationVariables
>;
export const ReadySubTasksDocument = gql`
  query readySubTasks($from: dateTime, $to: dateTime, $status: String) {
    readySubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useReadySubTasksQuery__
 *
 * To run a query within a Vue component, call `useReadySubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadySubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReadySubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useReadySubTasksQuery(
  variables:
    | ReadySubTasksQueryVariables
    | VueCompositionApi.Ref<ReadySubTasksQueryVariables>
    | ReactiveFunction<ReadySubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReadySubTasksQuery, ReadySubTasksQueryVariables>(
    ReadySubTasksDocument,
    variables,
    options,
  );
}
export function useReadySubTasksLazyQuery(
  variables:
    | ReadySubTasksQueryVariables
    | VueCompositionApi.Ref<ReadySubTasksQueryVariables>
    | ReactiveFunction<ReadySubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReadySubTasksQuery, ReadySubTasksQueryVariables>(
    ReadySubTasksDocument,
    variables,
    options,
  );
}
export type ReadySubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReadySubTasksQuery,
  ReadySubTasksQueryVariables
>;
export const ReadyTasksDocument = gql`
  query readyTasks($from: dateTime, $to: dateTime, $status: String) {
    readyTasks: getTasks(from: $from, to: $to, status: $status) {
      ...taskListTask
    }
  }
  ${TaskListTaskFragmentDoc}
`;

/**
 * __useReadyTasksQuery__
 *
 * To run a query within a Vue component, call `useReadyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReadyTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useReadyTasksQuery(
  variables:
    | ReadyTasksQueryVariables
    | VueCompositionApi.Ref<ReadyTasksQueryVariables>
    | ReactiveFunction<ReadyTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReadyTasksQuery, ReadyTasksQueryVariables>(
    ReadyTasksDocument,
    variables,
    options,
  );
}
export function useReadyTasksLazyQuery(
  variables:
    | ReadyTasksQueryVariables
    | VueCompositionApi.Ref<ReadyTasksQueryVariables>
    | ReactiveFunction<ReadyTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReadyTasksQuery, ReadyTasksQueryVariables>(
    ReadyTasksDocument,
    variables,
    options,
  );
}
export type ReadyTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReadyTasksQuery,
  ReadyTasksQueryVariables
>;
export const InProgressSubTasksDocument = gql`
  query inProgressSubTasks($from: dateTime, $to: dateTime, $status: String) {
    inProgressSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useInProgressSubTasksQuery__
 *
 * To run a query within a Vue component, call `useInProgressSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProgressSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInProgressSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useInProgressSubTasksQuery(
  variables:
    | InProgressSubTasksQueryVariables
    | VueCompositionApi.Ref<InProgressSubTasksQueryVariables>
    | ReactiveFunction<InProgressSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>(
    InProgressSubTasksDocument,
    variables,
    options,
  );
}
export function useInProgressSubTasksLazyQuery(
  variables:
    | InProgressSubTasksQueryVariables
    | VueCompositionApi.Ref<InProgressSubTasksQueryVariables>
    | ReactiveFunction<InProgressSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>(
    InProgressSubTasksDocument,
    variables,
    options,
  );
}
export type InProgressSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InProgressSubTasksQuery,
  InProgressSubTasksQueryVariables
>;
export const InProgressTasksDocument = gql`
  query inProgressTasks($from: dateTime, $to: dateTime, $status: String) {
    inProgressTasks: getTasks(from: $from, to: $to, status: $status) {
      ...taskListTask
    }
  }
  ${TaskListTaskFragmentDoc}
`;

/**
 * __useInProgressTasksQuery__
 *
 * To run a query within a Vue component, call `useInProgressTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProgressTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInProgressTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useInProgressTasksQuery(
  variables:
    | InProgressTasksQueryVariables
    | VueCompositionApi.Ref<InProgressTasksQueryVariables>
    | ReactiveFunction<InProgressTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<InProgressTasksQuery, InProgressTasksQueryVariables>(
    InProgressTasksDocument,
    variables,
    options,
  );
}
export function useInProgressTasksLazyQuery(
  variables:
    | InProgressTasksQueryVariables
    | VueCompositionApi.Ref<InProgressTasksQueryVariables>
    | ReactiveFunction<InProgressTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<InProgressTasksQuery, InProgressTasksQueryVariables>(
    InProgressTasksDocument,
    variables,
    options,
  );
}
export type InProgressTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InProgressTasksQuery,
  InProgressTasksQueryVariables
>;
export const RejectedSubTasksDocument = gql`
  query rejectedSubTasks($from: dateTime, $to: dateTime, $status: String) {
    rejectedSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useRejectedSubTasksQuery__
 *
 * To run a query within a Vue component, call `useRejectedSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectedSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRejectedSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useRejectedSubTasksQuery(
  variables:
    | RejectedSubTasksQueryVariables
    | VueCompositionApi.Ref<RejectedSubTasksQueryVariables>
    | ReactiveFunction<RejectedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>(
    RejectedSubTasksDocument,
    variables,
    options,
  );
}
export function useRejectedSubTasksLazyQuery(
  variables:
    | RejectedSubTasksQueryVariables
    | VueCompositionApi.Ref<RejectedSubTasksQueryVariables>
    | ReactiveFunction<RejectedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>(
    RejectedSubTasksDocument,
    variables,
    options,
  );
}
export type RejectedSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RejectedSubTasksQuery,
  RejectedSubTasksQueryVariables
>;
export const RejectedTasksDocument = gql`
  query rejectedTasks($from: dateTime, $to: dateTime, $status: String) {
    rejectedTasks: getTasks(from: $from, to: $to, status: $status) {
      ...taskListTask
    }
  }
  ${TaskListTaskFragmentDoc}
`;

/**
 * __useRejectedTasksQuery__
 *
 * To run a query within a Vue component, call `useRejectedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectedTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRejectedTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useRejectedTasksQuery(
  variables:
    | RejectedTasksQueryVariables
    | VueCompositionApi.Ref<RejectedTasksQueryVariables>
    | ReactiveFunction<RejectedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RejectedTasksQuery, RejectedTasksQueryVariables>(
    RejectedTasksDocument,
    variables,
    options,
  );
}
export function useRejectedTasksLazyQuery(
  variables:
    | RejectedTasksQueryVariables
    | VueCompositionApi.Ref<RejectedTasksQueryVariables>
    | ReactiveFunction<RejectedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RejectedTasksQuery, RejectedTasksQueryVariables>(
    RejectedTasksDocument,
    variables,
    options,
  );
}
export type RejectedTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RejectedTasksQuery,
  RejectedTasksQueryVariables
>;
export const CompletedSubTasksDocument = gql`
  query completedSubTasks($from: dateTime, $to: dateTime, $status: String) {
    completedSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useCompletedSubTasksQuery__
 *
 * To run a query within a Vue component, call `useCompletedSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompletedSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useCompletedSubTasksQuery(
  variables:
    | CompletedSubTasksQueryVariables
    | VueCompositionApi.Ref<CompletedSubTasksQueryVariables>
    | ReactiveFunction<CompletedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>(
    CompletedSubTasksDocument,
    variables,
    options,
  );
}
export function useCompletedSubTasksLazyQuery(
  variables:
    | CompletedSubTasksQueryVariables
    | VueCompositionApi.Ref<CompletedSubTasksQueryVariables>
    | ReactiveFunction<CompletedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>(
    CompletedSubTasksDocument,
    variables,
    options,
  );
}
export type CompletedSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CompletedSubTasksQuery,
  CompletedSubTasksQueryVariables
>;
export const CompletedTasksDocument = gql`
  query completedTasks($from: dateTime, $to: dateTime, $status: String) {
    completedTasks: getTasks(from: $from, to: $to, status: $status) {
      ...taskListTask
    }
  }
  ${TaskListTaskFragmentDoc}
`;

/**
 * __useCompletedTasksQuery__
 *
 * To run a query within a Vue component, call `useCompletedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompletedTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useCompletedTasksQuery(
  variables:
    | CompletedTasksQueryVariables
    | VueCompositionApi.Ref<CompletedTasksQueryVariables>
    | ReactiveFunction<CompletedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CompletedTasksQuery, CompletedTasksQueryVariables>(
    CompletedTasksDocument,
    variables,
    options,
  );
}
export function useCompletedTasksLazyQuery(
  variables:
    | CompletedTasksQueryVariables
    | VueCompositionApi.Ref<CompletedTasksQueryVariables>
    | ReactiveFunction<CompletedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CompletedTasksQuery, CompletedTasksQueryVariables>(
    CompletedTasksDocument,
    variables,
    options,
  );
}
export type CompletedTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CompletedTasksQuery,
  CompletedTasksQueryVariables
>;
export const DialoggUsersListDocument = gql`
  query dialoggUsersList {
    dialoggUsers {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      externalUserIds {
        externalHumanIdType {
          id
        }
        externalId
      }
    }
  }
`;

/**
 * __useDialoggUsersListQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersListQuery();
 */
export function useDialoggUsersListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersListQuery, DialoggUsersListQueryVariables>(
    DialoggUsersListDocument,
    {},
    options,
  );
}
export function useDialoggUsersListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersListQuery, DialoggUsersListQueryVariables>(
    DialoggUsersListDocument,
    {},
    options,
  );
}
export type DialoggUsersListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersListQuery,
  DialoggUsersListQueryVariables
>;
export const DialoggUsersDocument = gql`
  query dialoggUsers($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      picturePermission
      externalUserIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      onBehalf {
        accessiblePatients
        otherPatientIds
      }
      otpStatus
      ipRestrictions
      timeLimitedAccess {
        start
        end
      }
      smsOtpStatus
      smsOtpPhoneNumber
      passwordStatus
      email
      externalIdentities {
        provider
      }
    }
  }
`;

/**
 * __useDialoggUsersQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersQuery(
  variables:
    | DialoggUsersQueryVariables
    | VueCompositionApi.Ref<DialoggUsersQueryVariables>
    | ReactiveFunction<DialoggUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersQuery, DialoggUsersQueryVariables>(
    DialoggUsersDocument,
    variables,
    options,
  );
}
export function useDialoggUsersLazyQuery(
  variables:
    | DialoggUsersQueryVariables
    | VueCompositionApi.Ref<DialoggUsersQueryVariables>
    | ReactiveFunction<DialoggUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersQuery, DialoggUsersQueryVariables>(
    DialoggUsersDocument,
    variables,
    options,
  );
}
export type DialoggUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersQuery,
  DialoggUsersQueryVariables
>;
export const DialoggUsersDeleteDocument = gql`
  query dialoggUsersDelete($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      onBehalf {
        accessiblePatients
        otherPatientIds
      }
    }
  }
`;

/**
 * __useDialoggUsersDeleteQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersDeleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersDeleteQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersDeleteQuery(
  variables:
    | DialoggUsersDeleteQueryVariables
    | VueCompositionApi.Ref<DialoggUsersDeleteQueryVariables>
    | ReactiveFunction<DialoggUsersDeleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>(
    DialoggUsersDeleteDocument,
    variables,
    options,
  );
}
export function useDialoggUsersDeleteLazyQuery(
  variables:
    | DialoggUsersDeleteQueryVariables
    | VueCompositionApi.Ref<DialoggUsersDeleteQueryVariables>
    | ReactiveFunction<DialoggUsersDeleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>(
    DialoggUsersDeleteDocument,
    variables,
    options,
  );
}
export type DialoggUsersDeleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersDeleteQuery,
  DialoggUsersDeleteQueryVariables
>;
export const DialoggUsersForCreateDialogDocument = gql`
  query dialoggUsersForCreateDialog($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      externalIdentities {
        provider
      }
    }
  }
`;

/**
 * __useDialoggUsersForCreateDialogQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersForCreateDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersForCreateDialogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersForCreateDialogQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersForCreateDialogQuery(
  variables:
    | DialoggUsersForCreateDialogQueryVariables
    | VueCompositionApi.Ref<DialoggUsersForCreateDialogQueryVariables>
    | ReactiveFunction<DialoggUsersForCreateDialogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>(
    DialoggUsersForCreateDialogDocument,
    variables,
    options,
  );
}
export function useDialoggUsersForCreateDialogLazyQuery(
  variables:
    | DialoggUsersForCreateDialogQueryVariables
    | VueCompositionApi.Ref<DialoggUsersForCreateDialogQueryVariables>
    | ReactiveFunction<DialoggUsersForCreateDialogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>(
    DialoggUsersForCreateDialogDocument,
    variables,
    options,
  );
}
export type DialoggUsersForCreateDialogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersForCreateDialogQuery,
  DialoggUsersForCreateDialogQueryVariables
>;
export const DialoggUsersWithAccessToPatientDocument = gql`
  query dialoggUsersWithAccessToPatient($patientId: ID!) {
    dialoggUsersWithAccessToPatient(patientId: $patientId) {
      username
      firstName
      lastName
      lastActive
      role
    }
  }
`;

/**
 * __useDialoggUsersWithAccessToPatientQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersWithAccessToPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersWithAccessToPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersWithAccessToPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useDialoggUsersWithAccessToPatientQuery(
  variables:
    | DialoggUsersWithAccessToPatientQueryVariables
    | VueCompositionApi.Ref<DialoggUsersWithAccessToPatientQueryVariables>
    | ReactiveFunction<DialoggUsersWithAccessToPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        DialoggUsersWithAccessToPatientQuery,
        DialoggUsersWithAccessToPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    DialoggUsersWithAccessToPatientQuery,
    DialoggUsersWithAccessToPatientQueryVariables
  >(DialoggUsersWithAccessToPatientDocument, variables, options);
}
export function useDialoggUsersWithAccessToPatientLazyQuery(
  variables?:
    | DialoggUsersWithAccessToPatientQueryVariables
    | VueCompositionApi.Ref<DialoggUsersWithAccessToPatientQueryVariables>
    | ReactiveFunction<DialoggUsersWithAccessToPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        DialoggUsersWithAccessToPatientQuery,
        DialoggUsersWithAccessToPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    DialoggUsersWithAccessToPatientQuery,
    DialoggUsersWithAccessToPatientQueryVariables
  >(DialoggUsersWithAccessToPatientDocument, variables, options);
}
export type DialoggUsersWithAccessToPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersWithAccessToPatientQuery,
  DialoggUsersWithAccessToPatientQueryVariables
>;
export const GetAllCarePlanTemplatesDocument = gql`
  query getAllCarePlanTemplates($withStatus: String) {
    getAllCarePlanTemplates(withStatus: $withStatus) {
      id
      title
      status
      carePlanType
    }
  }
`;

/**
 * __useGetAllCarePlanTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllCarePlanTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarePlanTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCarePlanTemplatesQuery({
 *   withStatus: // value for 'withStatus'
 * });
 */
export function useGetAllCarePlanTemplatesQuery(
  variables:
    | GetAllCarePlanTemplatesQueryVariables
    | VueCompositionApi.Ref<GetAllCarePlanTemplatesQueryVariables>
    | ReactiveFunction<GetAllCarePlanTemplatesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>(
    GetAllCarePlanTemplatesDocument,
    variables,
    options,
  );
}
export function useGetAllCarePlanTemplatesLazyQuery(
  variables:
    | GetAllCarePlanTemplatesQueryVariables
    | VueCompositionApi.Ref<GetAllCarePlanTemplatesQueryVariables>
    | ReactiveFunction<GetAllCarePlanTemplatesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>(
    GetAllCarePlanTemplatesDocument,
    variables,
    options,
  );
}
export type GetAllCarePlanTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllCarePlanTemplatesQuery,
  GetAllCarePlanTemplatesQueryVariables
>;
export const GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument = gql`
  query getAllQuestionnaireTemplatesToCreateBasedOnExisting {
    getAllQuestionnaireTemplates {
      id
      title
      version
      status
    }
  }
`;

/**
 * __useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery__
 *
 * To run a query within a Vue component, call `useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery();
 */
export function useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >(GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument, {}, options);
}
export function useGetAllQuestionnaireTemplatesToCreateBasedOnExistingLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >(GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument, {}, options);
}
export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >;
export const GetAllRpmMedicalDevicesDocument = gql`
  query getAllRpmMedicalDevices {
    getAllRpmMedicalDevices {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      tags
      manufacturer
      serialNumber
      imei
      simNumber
      modelNumber
      modelName
      parent {
        reference
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetAllRpmMedicalDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetAllRpmMedicalDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRpmMedicalDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllRpmMedicalDevicesQuery();
 */
export function useGetAllRpmMedicalDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>(
    GetAllRpmMedicalDevicesDocument,
    {},
    options,
  );
}
export function useGetAllRpmMedicalDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>(
    GetAllRpmMedicalDevicesDocument,
    {},
    options,
  );
}
export type GetAllRpmMedicalDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllRpmMedicalDevicesQuery,
  GetAllRpmMedicalDevicesQueryVariables
>;
export const GetAppDevicesForPatientDocument = gql`
  query getAppDevicesForPatient($patientId: ID!) {
    getAppDevicesForPatient(patientId: $patientId) {
      id
      username
      deviceName
      os
      lastActive
      appSettings {
        appLocale
        appName
        pushId
      }
      notificationSettings {
        message
        deviation
        measurement
        reviewed
        reminder
        videoMeetingReminder
      }
      remindedTasks {
        objectReference {
          reference
        }
        success
        date
      }
    }
  }
`;

/**
 * __useGetAppDevicesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAppDevicesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppDevicesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppDevicesForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAppDevicesForPatientQuery(
  variables:
    | GetAppDevicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetAppDevicesForPatientQueryVariables>
    | ReactiveFunction<GetAppDevicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>(
    GetAppDevicesForPatientDocument,
    variables,
    options,
  );
}
export function useGetAppDevicesForPatientLazyQuery(
  variables?:
    | GetAppDevicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetAppDevicesForPatientQueryVariables>
    | ReactiveFunction<GetAppDevicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>(
    GetAppDevicesForPatientDocument,
    variables,
    options,
  );
}
export type GetAppDevicesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAppDevicesForPatientQuery,
  GetAppDevicesForPatientQueryVariables
>;
export const GetAvailablePatientServiceSubscriptionsDocument = gql`
  query getAvailablePatientServiceSubscriptions {
    getAvailablePatientServiceSubscriptions
  }
`;

/**
 * __useGetAvailablePatientServiceSubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAvailablePatientServiceSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePatientServiceSubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailablePatientServiceSubscriptionsQuery();
 */
export function useGetAvailablePatientServiceSubscriptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailablePatientServiceSubscriptionsQuery,
        GetAvailablePatientServiceSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailablePatientServiceSubscriptionsQuery,
          GetAvailablePatientServiceSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailablePatientServiceSubscriptionsQuery,
          GetAvailablePatientServiceSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailablePatientServiceSubscriptionsQuery,
    GetAvailablePatientServiceSubscriptionsQueryVariables
  >(GetAvailablePatientServiceSubscriptionsDocument, {}, options);
}
export function useGetAvailablePatientServiceSubscriptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailablePatientServiceSubscriptionsQuery,
        GetAvailablePatientServiceSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailablePatientServiceSubscriptionsQuery,
          GetAvailablePatientServiceSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailablePatientServiceSubscriptionsQuery,
          GetAvailablePatientServiceSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailablePatientServiceSubscriptionsQuery,
    GetAvailablePatientServiceSubscriptionsQueryVariables
  >(GetAvailablePatientServiceSubscriptionsDocument, {}, options);
}
export type GetAvailablePatientServiceSubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailablePatientServiceSubscriptionsQuery,
  GetAvailablePatientServiceSubscriptionsQueryVariables
>;
export const GetEnabledServicesForPatientDocument = gql`
  query getEnabledServicesForPatient($patientId: ID!) {
    getEnabledServicesForPatient(patientId: $patientId) {
      __typename
      service
      ... on DhvSubscription {
        settings {
          playRingtoneOnStart
          autoStart {
            enabled
            afterSeconds
          }
          requestVideoMeetings
          showParticipantVideoMeetingToolbar
        }
      }
    }
  }
`;

/**
 * __useGetEnabledServicesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetEnabledServicesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledServicesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEnabledServicesForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetEnabledServicesForPatientQuery(
  variables:
    | GetEnabledServicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetEnabledServicesForPatientQueryVariables>
    | ReactiveFunction<GetEnabledServicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetEnabledServicesForPatientQuery, GetEnabledServicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetEnabledServicesForPatientQuery,
          GetEnabledServicesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetEnabledServicesForPatientQuery,
          GetEnabledServicesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetEnabledServicesForPatientQuery, GetEnabledServicesForPatientQueryVariables>(
    GetEnabledServicesForPatientDocument,
    variables,
    options,
  );
}
export function useGetEnabledServicesForPatientLazyQuery(
  variables?:
    | GetEnabledServicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetEnabledServicesForPatientQueryVariables>
    | ReactiveFunction<GetEnabledServicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetEnabledServicesForPatientQuery, GetEnabledServicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetEnabledServicesForPatientQuery,
          GetEnabledServicesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetEnabledServicesForPatientQuery,
          GetEnabledServicesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetEnabledServicesForPatientQuery,
    GetEnabledServicesForPatientQueryVariables
  >(GetEnabledServicesForPatientDocument, variables, options);
}
export type GetEnabledServicesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetEnabledServicesForPatientQuery,
  GetEnabledServicesForPatientQueryVariables
>;
export const GetNotesForVideoMeetingDocument = gql`
  query getNotesForVideoMeeting($videoMeetingId: ID!) {
    getHealthPersonnelTaskForVideoMeeting(videoMeetingId: $videoMeetingId) {
      id
      note {
        authorString
        time
        text
      }
    }
  }
`;

/**
 * __useGetNotesForVideoMeetingQuery__
 *
 * To run a query within a Vue component, call `useGetNotesForVideoMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForVideoMeetingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNotesForVideoMeetingQuery({
 *   videoMeetingId: // value for 'videoMeetingId'
 * });
 */
export function useGetNotesForVideoMeetingQuery(
  variables:
    | GetNotesForVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetNotesForVideoMeetingQueryVariables>
    | ReactiveFunction<GetNotesForVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>(
    GetNotesForVideoMeetingDocument,
    variables,
    options,
  );
}
export function useGetNotesForVideoMeetingLazyQuery(
  variables?:
    | GetNotesForVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetNotesForVideoMeetingQueryVariables>
    | ReactiveFunction<GetNotesForVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetNotesForVideoMeetingQuery, GetNotesForVideoMeetingQueryVariables>(
    GetNotesForVideoMeetingDocument,
    variables,
    options,
  );
}
export type GetNotesForVideoMeetingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNotesForVideoMeetingQuery,
  GetNotesForVideoMeetingQueryVariables
>;
export const GetTaskAndVideoMeetingDocument = gql`
  query getTaskAndVideoMeeting($videoMeetingId: ID!) {
    getHealthPersonnelTaskForVideoMeeting(videoMeetingId: $videoMeetingId) {
      id
      status
      owner {
        display
      }
      videoMeeting {
        id
        appointment {
          id
          status
          start
          end
          meetingStartTime
          meetingEndTime
          description
          patients {
            id
            name {
              text
            }
          }
          appointmentType
          appointmentGroupId
          supportingInformation {
            reference
            identifier {
              system
              use
              value
            }
            type
            display
          }
          participant {
            actor {
              reference
              identifier {
                value
              }
              type
              display
            }
          }
          patient {
            id
            name {
              text
            }
          }
        }
        carePlan {
          id
          title
        }
        videonor {
          meetingId
          participantRoomUrl
          hostRoomUrl
          startDate
          endDate
        }
      }
    }
  }
`;

/**
 * __useGetTaskAndVideoMeetingQuery__
 *
 * To run a query within a Vue component, call `useGetTaskAndVideoMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskAndVideoMeetingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTaskAndVideoMeetingQuery({
 *   videoMeetingId: // value for 'videoMeetingId'
 * });
 */
export function useGetTaskAndVideoMeetingQuery(
  variables:
    | GetTaskAndVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetTaskAndVideoMeetingQueryVariables>
    | ReactiveFunction<GetTaskAndVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>(
    GetTaskAndVideoMeetingDocument,
    variables,
    options,
  );
}
export function useGetTaskAndVideoMeetingLazyQuery(
  variables?:
    | GetTaskAndVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetTaskAndVideoMeetingQueryVariables>
    | ReactiveFunction<GetTaskAndVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTaskAndVideoMeetingQuery, GetTaskAndVideoMeetingQueryVariables>(
    GetTaskAndVideoMeetingDocument,
    variables,
    options,
  );
}
export type GetTaskAndVideoMeetingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTaskAndVideoMeetingQuery,
  GetTaskAndVideoMeetingQueryVariables
>;
export const GetListOfUnallocatedRpmMedicalDevicesDocument = gql`
  query getListOfUnallocatedRpmMedicalDevices {
    getListOfUnallocatedRpmMedicalDevices {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      manufacturer
      serialNumber
      modelNumber
      modelName
      parent {
        reference
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetListOfUnallocatedRpmMedicalDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedRpmMedicalDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedRpmMedicalDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedRpmMedicalDevicesQuery();
 */
export function useGetListOfUnallocatedRpmMedicalDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmMedicalDevicesQuery,
        GetListOfUnallocatedRpmMedicalDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedRpmMedicalDevicesQuery,
    GetListOfUnallocatedRpmMedicalDevicesQueryVariables
  >(GetListOfUnallocatedRpmMedicalDevicesDocument, {}, options);
}
export function useGetListOfUnallocatedRpmMedicalDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmMedicalDevicesQuery,
        GetListOfUnallocatedRpmMedicalDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedRpmMedicalDevicesQuery,
    GetListOfUnallocatedRpmMedicalDevicesQueryVariables
  >(GetListOfUnallocatedRpmMedicalDevicesDocument, {}, options);
}
export type GetListOfUnallocatedRpmMedicalDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedRpmMedicalDevicesQuery,
  GetListOfUnallocatedRpmMedicalDevicesQueryVariables
>;
export const GetMedicalDeviceForMeasurementDocument = gql`
  query getMedicalDeviceForMeasurement($measurementId: ID!, $medicalDeviceId: ID!) {
    getMedicalDeviceForMeasurement(measurementId: $measurementId, medicalDeviceId: $medicalDeviceId) {
      id
      serialNumber
      modelNumber
      manufacturer
    }
  }
`;

/**
 * __useGetMedicalDeviceForMeasurementQuery__
 *
 * To run a query within a Vue component, call `useGetMedicalDeviceForMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalDeviceForMeasurementQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMedicalDeviceForMeasurementQuery({
 *   measurementId: // value for 'measurementId'
 *   medicalDeviceId: // value for 'medicalDeviceId'
 * });
 */
export function useGetMedicalDeviceForMeasurementQuery(
  variables:
    | GetMedicalDeviceForMeasurementQueryVariables
    | VueCompositionApi.Ref<GetMedicalDeviceForMeasurementQueryVariables>
    | ReactiveFunction<GetMedicalDeviceForMeasurementQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMedicalDeviceForMeasurementQuery,
        GetMedicalDeviceForMeasurementQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetMedicalDeviceForMeasurementQuery,
    GetMedicalDeviceForMeasurementQueryVariables
  >(GetMedicalDeviceForMeasurementDocument, variables, options);
}
export function useGetMedicalDeviceForMeasurementLazyQuery(
  variables?:
    | GetMedicalDeviceForMeasurementQueryVariables
    | VueCompositionApi.Ref<GetMedicalDeviceForMeasurementQueryVariables>
    | ReactiveFunction<GetMedicalDeviceForMeasurementQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMedicalDeviceForMeasurementQuery,
        GetMedicalDeviceForMeasurementQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetMedicalDeviceForMeasurementQuery,
    GetMedicalDeviceForMeasurementQueryVariables
  >(GetMedicalDeviceForMeasurementDocument, variables, options);
}
export type GetMedicalDeviceForMeasurementQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMedicalDeviceForMeasurementQuery,
  GetMedicalDeviceForMeasurementQueryVariables
>;
export const GetPatientNameDocument = gql`
  query getPatientName($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
    }
  }
`;

/**
 * __useGetPatientNameQuery__
 *
 * To run a query within a Vue component, call `useGetPatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientNameQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientNameQuery(
  variables:
    | GetPatientNameQueryVariables
    | VueCompositionApi.Ref<GetPatientNameQueryVariables>
    | ReactiveFunction<GetPatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(
    GetPatientNameDocument,
    variables,
    options,
  );
}
export function useGetPatientNameLazyQuery(
  variables?:
    | GetPatientNameQueryVariables
    | VueCompositionApi.Ref<GetPatientNameQueryVariables>
    | ReactiveFunction<GetPatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(
    GetPatientNameDocument,
    variables,
    options,
  );
}
export type GetPatientNameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientNameQuery,
  GetPatientNameQueryVariables
>;
export const GetPatientSelfTreatmentPlansDocument = gql`
  query getPatientSelfTreatmentPlans($patientId: ID!) {
    getPatientSelfTreatmentPlans(patientId: $patientId) {
      id
      status
      lastUpdated
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetPatientSelfTreatmentPlansQuery__
 *
 * To run a query within a Vue component, call `useGetPatientSelfTreatmentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientSelfTreatmentPlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientSelfTreatmentPlansQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientSelfTreatmentPlansQuery(
  variables:
    | GetPatientSelfTreatmentPlansQueryVariables
    | VueCompositionApi.Ref<GetPatientSelfTreatmentPlansQueryVariables>
    | ReactiveFunction<GetPatientSelfTreatmentPlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>(
    GetPatientSelfTreatmentPlansDocument,
    variables,
    options,
  );
}
export function useGetPatientSelfTreatmentPlansLazyQuery(
  variables?:
    | GetPatientSelfTreatmentPlansQueryVariables
    | VueCompositionApi.Ref<GetPatientSelfTreatmentPlansQueryVariables>
    | ReactiveFunction<GetPatientSelfTreatmentPlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientSelfTreatmentPlansQuery,
    GetPatientSelfTreatmentPlansQueryVariables
  >(GetPatientSelfTreatmentPlansDocument, variables, options);
}
export type GetPatientSelfTreatmentPlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientSelfTreatmentPlansQuery,
  GetPatientSelfTreatmentPlansQueryVariables
>;
export const GetReadyTaskCountDocument = gql`
  query getReadyTaskCount($from: dateTime, $to: dateTime, $code: TaskCode, $onlyUpcomingVideoMeetings: Boolean) {
    getReadyTaskCount(from: $from, to: $to, code: $code, onlyUpcomingVideoMeetings: $onlyUpcomingVideoMeetings) {
      routine
      urgent
      asap
      stat
      video
      upcomingVideo
      pendingReminders
    }
  }
`;

/**
 * __useGetReadyTaskCountQuery__
 *
 * To run a query within a Vue component, call `useGetReadyTaskCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadyTaskCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReadyTaskCountQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   code: // value for 'code'
 *   onlyUpcomingVideoMeetings: // value for 'onlyUpcomingVideoMeetings'
 * });
 */
export function useGetReadyTaskCountQuery(
  variables:
    | GetReadyTaskCountQueryVariables
    | VueCompositionApi.Ref<GetReadyTaskCountQueryVariables>
    | ReactiveFunction<GetReadyTaskCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>(
    GetReadyTaskCountDocument,
    variables,
    options,
  );
}
export function useGetReadyTaskCountLazyQuery(
  variables:
    | GetReadyTaskCountQueryVariables
    | VueCompositionApi.Ref<GetReadyTaskCountQueryVariables>
    | ReactiveFunction<GetReadyTaskCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>(
    GetReadyTaskCountDocument,
    variables,
    options,
  );
}
export type GetReadyTaskCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetReadyTaskCountQuery,
  GetReadyTaskCountQueryVariables
>;
export const GetRpmMedicalDeviceDocument = gql`
  query getRpmMedicalDevice($id: ID!) {
    getRpmMedicalDevice(id: $id) {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      manufacturer
      serialNumber
      modelNumber
      modelName
      parent {
        reference
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetRpmMedicalDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetRpmMedicalDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRpmMedicalDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRpmMedicalDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRpmMedicalDeviceQuery(
  variables:
    | GetRpmMedicalDeviceQueryVariables
    | VueCompositionApi.Ref<GetRpmMedicalDeviceQueryVariables>
    | ReactiveFunction<GetRpmMedicalDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>(
    GetRpmMedicalDeviceDocument,
    variables,
    options,
  );
}
export function useGetRpmMedicalDeviceLazyQuery(
  variables?:
    | GetRpmMedicalDeviceQueryVariables
    | VueCompositionApi.Ref<GetRpmMedicalDeviceQueryVariables>
    | ReactiveFunction<GetRpmMedicalDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>(
    GetRpmMedicalDeviceDocument,
    variables,
    options,
  );
}
export type GetRpmMedicalDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRpmMedicalDeviceQuery,
  GetRpmMedicalDeviceQueryVariables
>;
export const GetTaskByIdDocument = gql`
  query getTaskById($taskId: ID!) {
    getTaskById(taskId: $taskId) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      description
      missedSubmissions {
        ...missedSubmissionDetails
      }
      journalWorkflow {
        status
      }
      executionPeriod {
        start
        end
      }
      carePlan {
        id
        title
      }
      note {
        authorString
        time
        text
        authorReference {
          display
          reference
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
        }
        videonor {
          meetingId
        }
      }
    }
  }
  ${MissedSubmissionDetailsFragmentDoc}
`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a Vue component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTaskByIdQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetTaskByIdQuery(
  variables:
    | GetTaskByIdQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdQueryVariables>
    | ReactiveFunction<GetTaskByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    variables,
    options,
  );
}
export function useGetTaskByIdLazyQuery(
  variables?:
    | GetTaskByIdQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdQueryVariables>
    | ReactiveFunction<GetTaskByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    variables,
    options,
  );
}
export type GetTaskByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTaskByIdQuery,
  GetTaskByIdQueryVariables
>;
export const GetTaskByIdWithJournalRetryDocument = gql`
  query getTaskByIdWithJournalRetry($taskId: ID!) {
    getTaskById(taskId: $taskId) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      description
      missedSubmissions {
        ...missedSubmissionDetails
      }
      journalWorkflow {
        type
        status
        userGroupId
        retriedAt
        nextRetry
        completedAt
        freeTextNote
        completionOptions
        debugDetails
      }
      executionPeriod {
        start
        end
      }
      carePlan {
        id
        title
      }
      note {
        authorString
        time
        text
        authorReference {
          display
          reference
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
        }
        videonor {
          meetingId
        }
      }
      canRetryJournaling
      isJournalNoteRequired
    }
  }
  ${MissedSubmissionDetailsFragmentDoc}
`;

/**
 * __useGetTaskByIdWithJournalRetryQuery__
 *
 * To run a query within a Vue component, call `useGetTaskByIdWithJournalRetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdWithJournalRetryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTaskByIdWithJournalRetryQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetTaskByIdWithJournalRetryQuery(
  variables:
    | GetTaskByIdWithJournalRetryQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdWithJournalRetryQueryVariables>
    | ReactiveFunction<GetTaskByIdWithJournalRetryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>(
    GetTaskByIdWithJournalRetryDocument,
    variables,
    options,
  );
}
export function useGetTaskByIdWithJournalRetryLazyQuery(
  variables?:
    | GetTaskByIdWithJournalRetryQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdWithJournalRetryQueryVariables>
    | ReactiveFunction<GetTaskByIdWithJournalRetryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>(
    GetTaskByIdWithJournalRetryDocument,
    variables,
    options,
  );
}
export type GetTaskByIdWithJournalRetryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTaskByIdWithJournalRetryQuery,
  GetTaskByIdWithJournalRetryQueryVariables
>;
export const PatientCommunicationsPaginatedDocument = gql`
  query patientCommunicationsPaginated($patientId: ID!, $to: dateTime, $limit: Int, $cursor: cursor) {
    patientCommunicationsPaginated(patientId: $patientId, to: $to, limit: $limit, cursor: $cursor) {
      cursor
      events {
        id
        status
        payload {
          contentString
          picture {
            id
            deleted
            deletedAt
            deletedBy {
              display
              reference
            }
            content {
              attachment {
                title
                contentType
                url
                size
                creation
              }
            }
          }
        }
        sender {
          reference
          display
        }
        subject {
          reference
        }
        sent
        received
      }
    }
  }
`;

/**
 * __usePatientCommunicationsPaginatedQuery__
 *
 * To run a query within a Vue component, call `usePatientCommunicationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientCommunicationsPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientCommunicationsPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function usePatientCommunicationsPaginatedQuery(
  variables:
    | PatientCommunicationsPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientCommunicationsPaginatedQueryVariables>
    | ReactiveFunction<PatientCommunicationsPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientCommunicationsPaginatedQuery,
        PatientCommunicationsPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    PatientCommunicationsPaginatedQuery,
    PatientCommunicationsPaginatedQueryVariables
  >(PatientCommunicationsPaginatedDocument, variables, options);
}
export function usePatientCommunicationsPaginatedLazyQuery(
  variables?:
    | PatientCommunicationsPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientCommunicationsPaginatedQueryVariables>
    | ReactiveFunction<PatientCommunicationsPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientCommunicationsPaginatedQuery,
        PatientCommunicationsPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    PatientCommunicationsPaginatedQuery,
    PatientCommunicationsPaginatedQueryVariables
  >(PatientCommunicationsPaginatedDocument, variables, options);
}
export type PatientCommunicationsPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientCommunicationsPaginatedQuery,
  PatientCommunicationsPaginatedQueryVariables
>;
export const PatientWithJournalConfigDocument = gql`
  query patientWithJournalConfig($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        text
      }
      journalConfigForPatient {
        remotePatientMonitoring {
          enabled
          taskCodesForJournaling
        }
      }
    }
  }
`;

/**
 * __usePatientWithJournalConfigQuery__
 *
 * To run a query within a Vue component, call `usePatientWithJournalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithJournalConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithJournalConfigQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function usePatientWithJournalConfigQuery(
  variables:
    | PatientWithJournalConfigQueryVariables
    | VueCompositionApi.Ref<PatientWithJournalConfigQueryVariables>
    | ReactiveFunction<PatientWithJournalConfigQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>(
    PatientWithJournalConfigDocument,
    variables,
    options,
  );
}
export function usePatientWithJournalConfigLazyQuery(
  variables?:
    | PatientWithJournalConfigQueryVariables
    | VueCompositionApi.Ref<PatientWithJournalConfigQueryVariables>
    | ReactiveFunction<PatientWithJournalConfigQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>(
    PatientWithJournalConfigDocument,
    variables,
    options,
  );
}
export type PatientWithJournalConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithJournalConfigQuery,
  PatientWithJournalConfigQueryVariables
>;
export const QuestionnaireTemplatesDocument = gql`
  query questionnaireTemplates {
    getAllQuestionnaireTemplates {
      id
      title
      purpose
      experimental
      version
      effectivePeriod {
        start
        end
      }
      status
    }
  }
`;

/**
 * __useQuestionnaireTemplatesQuery__
 *
 * To run a query within a Vue component, call `useQuestionnaireTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionnaireTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuestionnaireTemplatesQuery();
 */
export function useQuestionnaireTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>(
    QuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export function useQuestionnaireTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>(
    QuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export type QuestionnaireTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  QuestionnaireTemplatesQuery,
  QuestionnaireTemplatesQueryVariables
>;
export const SetOfPatientsDocument = gql`
  query setOfPatients($ids: [ID]!) {
    setOfPatients(ids: $ids) {
      id
      identifier {
        use
        value
      }
      name {
        given
        family
      }
    }
  }
`;

/**
 * __useSetOfPatientsQuery__
 *
 * To run a query within a Vue component, call `useSetOfPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetOfPatientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSetOfPatientsQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useSetOfPatientsQuery(
  variables:
    | SetOfPatientsQueryVariables
    | VueCompositionApi.Ref<SetOfPatientsQueryVariables>
    | ReactiveFunction<SetOfPatientsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<SetOfPatientsQuery, SetOfPatientsQueryVariables>(
    SetOfPatientsDocument,
    variables,
    options,
  );
}
export function useSetOfPatientsLazyQuery(
  variables?:
    | SetOfPatientsQueryVariables
    | VueCompositionApi.Ref<SetOfPatientsQueryVariables>
    | ReactiveFunction<SetOfPatientsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<SetOfPatientsQuery, SetOfPatientsQueryVariables>(
    SetOfPatientsDocument,
    variables,
    options,
  );
}
export type SetOfPatientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SetOfPatientsQuery,
  SetOfPatientsQueryVariables
>;
export const FetchTranscareUserActivityDocument = gql`
  query fetchTranscareUserActivity($userId: ID!) {
    fetchTranscareUserActivity(userId: $userId) {
      name
      startTime
      endTime
    }
  }
`;

/**
 * __useFetchTranscareUserActivityQuery__
 *
 * To run a query within a Vue component, call `useFetchTranscareUserActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTranscareUserActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchTranscareUserActivityQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useFetchTranscareUserActivityQuery(
  variables:
    | FetchTranscareUserActivityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserActivityQueryVariables>
    | ReactiveFunction<FetchTranscareUserActivityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>(
    FetchTranscareUserActivityDocument,
    variables,
    options,
  );
}
export function useFetchTranscareUserActivityLazyQuery(
  variables?:
    | FetchTranscareUserActivityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserActivityQueryVariables>
    | ReactiveFunction<FetchTranscareUserActivityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<FetchTranscareUserActivityQuery, FetchTranscareUserActivityQueryVariables>(
    FetchTranscareUserActivityDocument,
    variables,
    options,
  );
}
export type FetchTranscareUserActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FetchTranscareUserActivityQuery,
  FetchTranscareUserActivityQueryVariables
>;
export const FetchTranscareUserPredictionActivityDocument = gql`
  query fetchTranscareUserPredictionActivity($userId: ID!, $fromDate: dateTime!, $toDate: dateTime!) {
    fetchTranscareUserPredictionActivity(userId: $userId, fromDate: $fromDate, toDate: $toDate) {
      userId
      dateTime
      activity
      predictedValue
      realValue
    }
  }
`;

/**
 * __useFetchTranscareUserPredictionActivityQuery__
 *
 * To run a query within a Vue component, call `useFetchTranscareUserPredictionActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTranscareUserPredictionActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchTranscareUserPredictionActivityQuery({
 *   userId: // value for 'userId'
 *   fromDate: // value for 'fromDate'
 *   toDate: // value for 'toDate'
 * });
 */
export function useFetchTranscareUserPredictionActivityQuery(
  variables:
    | FetchTranscareUserPredictionActivityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserPredictionActivityQueryVariables>
    | ReactiveFunction<FetchTranscareUserPredictionActivityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        FetchTranscareUserPredictionActivityQuery,
        FetchTranscareUserPredictionActivityQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          FetchTranscareUserPredictionActivityQuery,
          FetchTranscareUserPredictionActivityQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          FetchTranscareUserPredictionActivityQuery,
          FetchTranscareUserPredictionActivityQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    FetchTranscareUserPredictionActivityQuery,
    FetchTranscareUserPredictionActivityQueryVariables
  >(FetchTranscareUserPredictionActivityDocument, variables, options);
}
export function useFetchTranscareUserPredictionActivityLazyQuery(
  variables?:
    | FetchTranscareUserPredictionActivityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserPredictionActivityQueryVariables>
    | ReactiveFunction<FetchTranscareUserPredictionActivityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        FetchTranscareUserPredictionActivityQuery,
        FetchTranscareUserPredictionActivityQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          FetchTranscareUserPredictionActivityQuery,
          FetchTranscareUserPredictionActivityQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          FetchTranscareUserPredictionActivityQuery,
          FetchTranscareUserPredictionActivityQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    FetchTranscareUserPredictionActivityQuery,
    FetchTranscareUserPredictionActivityQueryVariables
  >(FetchTranscareUserPredictionActivityDocument, variables, options);
}
export type FetchTranscareUserPredictionActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FetchTranscareUserPredictionActivityQuery,
  FetchTranscareUserPredictionActivityQueryVariables
>;
export const FetchTranscareUserIntensityDocument = gql`
  query fetchTranscareUserIntensity($userId: ID!, $fromDate: dateTime!, $toDate: dateTime!) {
    fetchTranscareUserIntensity(userId: $userId, fromDate: $fromDate, toDate: $toDate) {
      time
      intensity
    }
  }
`;

/**
 * __useFetchTranscareUserIntensityQuery__
 *
 * To run a query within a Vue component, call `useFetchTranscareUserIntensityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTranscareUserIntensityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchTranscareUserIntensityQuery({
 *   userId: // value for 'userId'
 *   fromDate: // value for 'fromDate'
 *   toDate: // value for 'toDate'
 * });
 */
export function useFetchTranscareUserIntensityQuery(
  variables:
    | FetchTranscareUserIntensityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserIntensityQueryVariables>
    | ReactiveFunction<FetchTranscareUserIntensityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>(
    FetchTranscareUserIntensityDocument,
    variables,
    options,
  );
}
export function useFetchTranscareUserIntensityLazyQuery(
  variables?:
    | FetchTranscareUserIntensityQueryVariables
    | VueCompositionApi.Ref<FetchTranscareUserIntensityQueryVariables>
    | ReactiveFunction<FetchTranscareUserIntensityQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<FetchTranscareUserIntensityQuery, FetchTranscareUserIntensityQueryVariables>(
    FetchTranscareUserIntensityDocument,
    variables,
    options,
  );
}
export type FetchTranscareUserIntensityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FetchTranscareUserIntensityQuery,
  FetchTranscareUserIntensityQueryVariables
>;
export const ListAllTranscareUsersDocument = gql`
  query listAllTranscareUsers {
    listAllTranscareUsers {
      id
    }
  }
`;

/**
 * __useListAllTranscareUsersQuery__
 *
 * To run a query within a Vue component, call `useListAllTranscareUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllTranscareUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListAllTranscareUsersQuery();
 */
export function useListAllTranscareUsersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>(
    ListAllTranscareUsersDocument,
    {},
    options,
  );
}
export function useListAllTranscareUsersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ListAllTranscareUsersQuery, ListAllTranscareUsersQueryVariables>(
    ListAllTranscareUsersDocument,
    {},
    options,
  );
}
export type ListAllTranscareUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ListAllTranscareUsersQuery,
  ListAllTranscareUsersQueryVariables
>;
export const CreateTranscareUserDocument = gql`
  mutation createTranscareUser($userId: ID!) {
    createTranscareUser(userId: $userId) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useCreateTranscareUserMutation__
 *
 * To run a mutation, you first call `useCreateTranscareUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscareUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTranscareUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateTranscareUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateTranscareUserMutation, CreateTranscareUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateTranscareUserMutation, CreateTranscareUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateTranscareUserMutation, CreateTranscareUserMutationVariables>(
    CreateTranscareUserDocument,
    options,
  );
}
export type CreateTranscareUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateTranscareUserMutation,
  CreateTranscareUserMutationVariables
>;
export const UnreadCommunicationsDocument = gql`
  query unreadCommunications($patientId: ID) {
    unreadCommunications(patientId: $patientId) {
      id
      patient {
        id
        name {
          given
          family
        }
      }
      payload {
        contentString
      }
      sent
    }
  }
`;

/**
 * __useUnreadCommunicationsQuery__
 *
 * To run a query within a Vue component, call `useUnreadCommunicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommunicationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnreadCommunicationsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useUnreadCommunicationsQuery(
  variables:
    | UnreadCommunicationsQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsQueryVariables>
    | ReactiveFunction<UnreadCommunicationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>(
    UnreadCommunicationsDocument,
    variables,
    options,
  );
}
export function useUnreadCommunicationsLazyQuery(
  variables:
    | UnreadCommunicationsQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsQueryVariables>
    | ReactiveFunction<UnreadCommunicationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>(
    UnreadCommunicationsDocument,
    variables,
    options,
  );
}
export type UnreadCommunicationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UnreadCommunicationsQuery,
  UnreadCommunicationsQueryVariables
>;
export const UnreadCommunicationsCountDocument = gql`
  query unreadCommunicationsCount($patientId: ID) {
    unreadCommunicationsCount(patientId: $patientId)
  }
`;

/**
 * __useUnreadCommunicationsCountQuery__
 *
 * To run a query within a Vue component, call `useUnreadCommunicationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommunicationsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnreadCommunicationsCountQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useUnreadCommunicationsCountQuery(
  variables:
    | UnreadCommunicationsCountQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsCountQueryVariables>
    | ReactiveFunction<UnreadCommunicationsCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>(
    UnreadCommunicationsCountDocument,
    variables,
    options,
  );
}
export function useUnreadCommunicationsCountLazyQuery(
  variables:
    | UnreadCommunicationsCountQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsCountQueryVariables>
    | ReactiveFunction<UnreadCommunicationsCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>(
    UnreadCommunicationsCountDocument,
    variables,
    options,
  );
}
export type UnreadCommunicationsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UnreadCommunicationsCountQuery,
  UnreadCommunicationsCountQueryVariables
>;
export const VideoMeetingDocument = gql`
  query videoMeeting($videoMeetingId: ID!) {
    videoMeeting: getVideoMeetingById(videoMeetingId: $videoMeetingId) {
      id
      appointment {
        id
        status
        start
        end
        description
        patients {
          id
          name {
            text
          }
        }
        appointmentType
        appointmentGroupId
        supportingInformation {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        participant {
          actor {
            reference
            identifier {
              value
            }
            type
            display
          }
        }
        patient {
          id
          name {
            text
          }
        }
      }
      carePlan {
        id
        title
      }
      videonor {
        meetingId
        participantRoomUrl
        hostRoomUrl
        startDate
        endDate
      }
    }
  }
`;

/**
 * __useVideoMeetingQuery__
 *
 * To run a query within a Vue component, call `useVideoMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoMeetingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVideoMeetingQuery({
 *   videoMeetingId: // value for 'videoMeetingId'
 * });
 */
export function useVideoMeetingQuery(
  variables:
    | VideoMeetingQueryVariables
    | VueCompositionApi.Ref<VideoMeetingQueryVariables>
    | ReactiveFunction<VideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<VideoMeetingQuery, VideoMeetingQueryVariables>(
    VideoMeetingDocument,
    variables,
    options,
  );
}
export function useVideoMeetingLazyQuery(
  variables?:
    | VideoMeetingQueryVariables
    | VueCompositionApi.Ref<VideoMeetingQueryVariables>
    | ReactiveFunction<VideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<VideoMeetingQuery, VideoMeetingQueryVariables>(
    VideoMeetingDocument,
    variables,
    options,
  );
}
export type VideoMeetingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VideoMeetingQuery,
  VideoMeetingQueryVariables
>;
export const SimulateCarePlanObservationResponseDocument = gql`
  mutation simulateCarePlanObservationResponse($patientId: ID!, $activityId: ID!, $observation: ObservationInput!) {
    simulateCarePlanObservationResponse(patientId: $patientId, activityId: $activityId, observation: $observation) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useSimulateCarePlanObservationResponseMutation__
 *
 * To run a mutation, you first call `useSimulateCarePlanObservationResponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateCarePlanObservationResponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateCarePlanObservationResponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     activityId: // value for 'activityId'
 *     observation: // value for 'observation'
 *   },
 * });
 */
export function useSimulateCarePlanObservationResponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateCarePlanObservationResponseMutation,
        SimulateCarePlanObservationResponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateCarePlanObservationResponseMutation,
          SimulateCarePlanObservationResponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SimulateCarePlanObservationResponseMutation,
    SimulateCarePlanObservationResponseMutationVariables
  >(SimulateCarePlanObservationResponseDocument, options);
}
export type SimulateCarePlanObservationResponseMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SimulateCarePlanObservationResponseMutation,
    SimulateCarePlanObservationResponseMutationVariables
  >;
export const SimulateCarePlanQuestionnaireResponseDocument = gql`
  mutation simulateCarePlanQuestionnaireResponse(
    $patientId: ID!
    $questionnaireResponseInput: QuestionnaireResponseSimulatorInput!
  ) {
    simulateCarePlanQuestionnaireResponse(
      patientId: $patientId
      questionnaireResponseInput: $questionnaireResponseInput
    ) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useSimulateCarePlanQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useSimulateCarePlanQuestionnaireResponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateCarePlanQuestionnaireResponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateCarePlanQuestionnaireResponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     questionnaireResponseInput: // value for 'questionnaireResponseInput'
 *   },
 * });
 */
export function useSimulateCarePlanQuestionnaireResponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateCarePlanQuestionnaireResponseMutation,
        SimulateCarePlanQuestionnaireResponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateCarePlanQuestionnaireResponseMutation,
          SimulateCarePlanQuestionnaireResponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SimulateCarePlanQuestionnaireResponseMutation,
    SimulateCarePlanQuestionnaireResponseMutationVariables
  >(SimulateCarePlanQuestionnaireResponseDocument, options);
}
export type SimulateCarePlanQuestionnaireResponseMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SimulateCarePlanQuestionnaireResponseMutation,
    SimulateCarePlanQuestionnaireResponseMutationVariables
  >;
export const CreateDialoggUserDocument = gql`
  mutation createDialoggUser($dialoggUser: CreateDialoggUserInput!) {
    createDialoggUser(dialoggUser: $dialoggUser) {
      success
      message
    }
  }
`;

/**
 * __useCreateDialoggUserMutation__
 *
 * To run a mutation, you first call `useCreateDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDialoggUserMutation({
 *   variables: {
 *     dialoggUser: // value for 'dialoggUser'
 *   },
 * });
 */
export function useCreateDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>(
    CreateDialoggUserDocument,
    options,
  );
}
export type CreateDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDialoggUserMutation,
  CreateDialoggUserMutationVariables
>;
export const UpdateDialoggUserDocument = gql`
  mutation updateDialoggUser($username: ID!, $dialoggUser: UpdateDialoggUser!) {
    updateDialoggUser(username: $username, dialoggUser: $dialoggUser) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDialoggUserMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     dialoggUser: // value for 'dialoggUser'
 *   },
 * });
 */
export function useUpdateDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>(
    UpdateDialoggUserDocument,
    options,
  );
}
export type UpdateDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserMutation,
  UpdateDialoggUserMutationVariables
>;
export const ForceDeleteDialoggUserDocument = gql`
  mutation forceDeleteDialoggUser($username: ID!) {
    forceDeleteDialoggUser(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useForceDeleteDialoggUserMutation__
 *
 * To run a mutation, you first call `useForceDeleteDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForceDeleteDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useForceDeleteDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>(
    ForceDeleteDialoggUserDocument,
    options,
  );
}
export type ForceDeleteDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ForceDeleteDialoggUserMutation,
  ForceDeleteDialoggUserMutationVariables
>;
export const DeleteDialoggUserDocument = gql`
  mutation deleteDialoggUser($username: ID!) {
    deleteDialoggUser(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDialoggUserMutation__
 *
 * To run a mutation, you first call `useDeleteDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeleteDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>(
    DeleteDialoggUserDocument,
    options,
  );
}
export type DeleteDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDialoggUserMutation,
  DeleteDialoggUserMutationVariables
>;
export const UpdateDialoggUserPasswordDocument = gql`
  mutation updateDialoggUserPassword($username: ID!, $password: String!) {
    updateDialoggUserPassword(username: $username, password: $password) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDialoggUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserPasswordMutation({
 *   variables: {
 *     username: // value for 'username'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useUpdateDialoggUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialoggUserPasswordMutation,
        UpdateDialoggUserPasswordMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialoggUserPasswordMutation,
          UpdateDialoggUserPasswordMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDialoggUserPasswordMutation, UpdateDialoggUserPasswordMutationVariables>(
    UpdateDialoggUserPasswordDocument,
    options,
  );
}
export type UpdateDialoggUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserPasswordMutation,
  UpdateDialoggUserPasswordMutationVariables
>;
export const RemoveDialoggUserPasswordDocument = gql`
  mutation removeDialoggUserPassword($username: ID!) {
    removeDialoggUserPassword(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useRemoveDialoggUserPasswordMutation__
 *
 * To run a mutation, you first call `useRemoveDialoggUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDialoggUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveDialoggUserPasswordMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useRemoveDialoggUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveDialoggUserPasswordMutation,
        RemoveDialoggUserPasswordMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveDialoggUserPasswordMutation,
          RemoveDialoggUserPasswordMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveDialoggUserPasswordMutation, RemoveDialoggUserPasswordMutationVariables>(
    RemoveDialoggUserPasswordDocument,
    options,
  );
}
export type RemoveDialoggUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveDialoggUserPasswordMutation,
  RemoveDialoggUserPasswordMutationVariables
>;
export const AssignPatientToDialoggUserDocument = gql`
  mutation assignPatientToDialoggUser($username: ID!, $patientId: ID!) {
    assignPatientToDialoggUser(username: $username, patientId: $patientId) {
      success
      message
    }
  }
`;

/**
 * __useAssignPatientToDialoggUserMutation__
 *
 * To run a mutation, you first call `useAssignPatientToDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignPatientToDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignPatientToDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAssignPatientToDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignPatientToDialoggUserMutation,
        AssignPatientToDialoggUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignPatientToDialoggUserMutation,
          AssignPatientToDialoggUserMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AssignPatientToDialoggUserMutation,
    AssignPatientToDialoggUserMutationVariables
  >(AssignPatientToDialoggUserDocument, options);
}
export type AssignPatientToDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AssignPatientToDialoggUserMutation,
  AssignPatientToDialoggUserMutationVariables
>;
export const ActivateDialoggUserSmsOtpDocument = gql`
  mutation activateDialoggUserSmsOtp($username: ID!, $phoneNumber: String!) {
    activateDialoggUserSmsOtp(username: $username, phoneNumber: $phoneNumber)
  }
`;

/**
 * __useActivateDialoggUserSmsOtpMutation__
 *
 * To run a mutation, you first call `useActivateDialoggUserSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateDialoggUserSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateDialoggUserSmsOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *     phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useActivateDialoggUserSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateDialoggUserSmsOtpMutation,
        ActivateDialoggUserSmsOtpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateDialoggUserSmsOtpMutation,
          ActivateDialoggUserSmsOtpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateDialoggUserSmsOtpMutation, ActivateDialoggUserSmsOtpMutationVariables>(
    ActivateDialoggUserSmsOtpDocument,
    options,
  );
}
export type ActivateDialoggUserSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateDialoggUserSmsOtpMutation,
  ActivateDialoggUserSmsOtpMutationVariables
>;
export const DeactivateDialoggUserSmsOtpDocument = gql`
  mutation deactivateDialoggUserSmsOtp($username: ID!) {
    deactivateDialoggUserSmsOtp(username: $username)
  }
`;

/**
 * __useDeactivateDialoggUserSmsOtpMutation__
 *
 * To run a mutation, you first call `useDeactivateDialoggUserSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDialoggUserSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateDialoggUserSmsOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeactivateDialoggUserSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeactivateDialoggUserSmsOtpMutation,
        DeactivateDialoggUserSmsOtpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeactivateDialoggUserSmsOtpMutation,
          DeactivateDialoggUserSmsOtpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeactivateDialoggUserSmsOtpMutation,
    DeactivateDialoggUserSmsOtpMutationVariables
  >(DeactivateDialoggUserSmsOtpDocument, options);
}
export type DeactivateDialoggUserSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateDialoggUserSmsOtpMutation,
  DeactivateDialoggUserSmsOtpMutationVariables
>;
export const ActivateDialoggUserOtpDocument = gql`
  mutation activateDialoggUserOtp($username: ID!) {
    activateDialoggUserOtp(username: $username)
  }
`;

/**
 * __useActivateDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useActivateDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useActivateDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>(
    ActivateDialoggUserOtpDocument,
    options,
  );
}
export type ActivateDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateDialoggUserOtpMutation,
  ActivateDialoggUserOtpMutationVariables
>;
export const DeleteDialoggUserOtpDocument = gql`
  mutation deleteDialoggUserOtp($username: ID!) {
    deleteDialoggUserOtp(username: $username)
  }
`;

/**
 * __useDeleteDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useDeleteDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeleteDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>(
    DeleteDialoggUserOtpDocument,
    options,
  );
}
export type DeleteDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDialoggUserOtpMutation,
  DeleteDialoggUserOtpMutationVariables
>;
export const CancelDialoggUserOtpDocument = gql`
  mutation cancelDialoggUserOtp($username: ID!) {
    cancelDialoggUserOtp(username: $username)
  }
`;

/**
 * __useCancelDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useCancelDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useCancelDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>(
    CancelDialoggUserOtpDocument,
    options,
  );
}
export type CancelDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelDialoggUserOtpMutation,
  CancelDialoggUserOtpMutationVariables
>;
export const UpdateDialoggUserIpRestrictionsDocument = gql`
  mutation updateDialoggUserIPRestrictions($username: ID!, $ipRestrictions: [String]) {
    updateDialoggUserIPRestrictions(username: $username, ipRestrictions: $ipRestrictions) {
      success
      inputValidation {
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateDialoggUserIpRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserIpRestrictionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserIpRestrictionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserIpRestrictionsMutation({
 *   variables: {
 *     username: // value for 'username'
 *     ipRestrictions: // value for 'ipRestrictions'
 *   },
 * });
 */
export function useUpdateDialoggUserIpRestrictionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialoggUserIpRestrictionsMutation,
        UpdateDialoggUserIpRestrictionsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialoggUserIpRestrictionsMutation,
          UpdateDialoggUserIpRestrictionsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDialoggUserIpRestrictionsMutation,
    UpdateDialoggUserIpRestrictionsMutationVariables
  >(UpdateDialoggUserIpRestrictionsDocument, options);
}
export type UpdateDialoggUserIpRestrictionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserIpRestrictionsMutation,
  UpdateDialoggUserIpRestrictionsMutationVariables
>;
export const UpdateDialggUserTimeLimitedAccessDocument = gql`
  mutation updateDialggUserTimeLimitedAccess($username: ID!, $timeLimitedAccess: PeriodInput) {
    updateDialoggUserTimeLimitedAccess(username: $username, timeLimitedAccess: $timeLimitedAccess) {
      success
      inputValidation {
        message
      }
    }
  }
`;

/**
 * __useUpdateDialggUserTimeLimitedAccessMutation__
 *
 * To run a mutation, you first call `useUpdateDialggUserTimeLimitedAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialggUserTimeLimitedAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialggUserTimeLimitedAccessMutation({
 *   variables: {
 *     username: // value for 'username'
 *     timeLimitedAccess: // value for 'timeLimitedAccess'
 *   },
 * });
 */
export function useUpdateDialggUserTimeLimitedAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialggUserTimeLimitedAccessMutation,
        UpdateDialggUserTimeLimitedAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialggUserTimeLimitedAccessMutation,
          UpdateDialggUserTimeLimitedAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDialggUserTimeLimitedAccessMutation,
    UpdateDialggUserTimeLimitedAccessMutationVariables
  >(UpdateDialggUserTimeLimitedAccessDocument, options);
}
export type UpdateDialggUserTimeLimitedAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialggUserTimeLimitedAccessMutation,
  UpdateDialggUserTimeLimitedAccessMutationVariables
>;
export const SetDialoggUserExternalIdPDocument = gql`
  mutation setDialoggUserExternalIdP($username: ID!, $identities: [ExternalIdentityInput]) {
    setDialoggUserExternalIdP(username: $username, identities: $identities)
  }
`;

/**
 * __useSetDialoggUserExternalIdPMutation__
 *
 * To run a mutation, you first call `useSetDialoggUserExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDialoggUserExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDialoggUserExternalIdPMutation({
 *   variables: {
 *     username: // value for 'username'
 *     identities: // value for 'identities'
 *   },
 * });
 */
export function useSetDialoggUserExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetDialoggUserExternalIdPMutation,
        SetDialoggUserExternalIdPMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetDialoggUserExternalIdPMutation,
          SetDialoggUserExternalIdPMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetDialoggUserExternalIdPMutation, SetDialoggUserExternalIdPMutationVariables>(
    SetDialoggUserExternalIdPDocument,
    options,
  );
}
export type SetDialoggUserExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetDialoggUserExternalIdPMutation,
  SetDialoggUserExternalIdPMutationVariables
>;
export const RejectVideoMeetingRequestDocument = gql`
  mutation rejectVideoMeetingRequest($taskId: ID!) {
    rejectVideoMeetingRequest: rejectCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRejectVideoMeetingRequestMutation__
 *
 * To run a mutation, you first call `useRejectVideoMeetingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectVideoMeetingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectVideoMeetingRequestMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRejectVideoMeetingRequestMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RejectVideoMeetingRequestMutation,
        RejectVideoMeetingRequestMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RejectVideoMeetingRequestMutation,
          RejectVideoMeetingRequestMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RejectVideoMeetingRequestMutation, RejectVideoMeetingRequestMutationVariables>(
    RejectVideoMeetingRequestDocument,
    options,
  );
}
export type RejectVideoMeetingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RejectVideoMeetingRequestMutation,
  RejectVideoMeetingRequestMutationVariables
>;
export const StartVideoMeetingRequestDocument = gql`
  mutation startVideoMeetingRequest($taskId: ID!) {
    startVideoMeetingRequest: startCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useStartVideoMeetingRequestMutation__
 *
 * To run a mutation, you first call `useStartVideoMeetingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartVideoMeetingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartVideoMeetingRequestMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartVideoMeetingRequestMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        StartVideoMeetingRequestMutation,
        StartVideoMeetingRequestMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          StartVideoMeetingRequestMutation,
          StartVideoMeetingRequestMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<StartVideoMeetingRequestMutation, StartVideoMeetingRequestMutationVariables>(
    StartVideoMeetingRequestDocument,
    options,
  );
}
export type StartVideoMeetingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartVideoMeetingRequestMutation,
  StartVideoMeetingRequestMutationVariables
>;
export const GetPatientRemindersForPatientDocument = gql`
  query getPatientRemindersForPatient(
    $patientId: ID!
    $status: AppointmentStatus
    $startAtLeast: dateTime
    $startAtMost: dateTime
  ) {
    remindersForPatient: getPatientRemindersForPatient(
      patientId: $patientId
      status: $status
      startAtLeast: $startAtLeast
      startAtMost: $startAtMost
    ) {
      id
      status
      appointmentType
      description
      minutesBeforeReminder
      action
      requiresAcknowledgement
      allDay
      allDayDate
      acknowledgedAt
      start
      end
      patient {
        id
        name {
          given
          family
          text
        }
      }
      participant {
        actor {
          reference
          display
        }
        task {
          reference
          display
        }
      }
    }
  }
`;

/**
 * __useGetPatientRemindersForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetPatientRemindersForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientRemindersForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientRemindersForPatientQuery({
 *   patientId: // value for 'patientId'
 *   status: // value for 'status'
 *   startAtLeast: // value for 'startAtLeast'
 *   startAtMost: // value for 'startAtMost'
 * });
 */
export function useGetPatientRemindersForPatientQuery(
  variables:
    | GetPatientRemindersForPatientQueryVariables
    | VueCompositionApi.Ref<GetPatientRemindersForPatientQueryVariables>
    | ReactiveFunction<GetPatientRemindersForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientRemindersForPatientQuery,
        GetPatientRemindersForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientRemindersForPatientQuery,
          GetPatientRemindersForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientRemindersForPatientQuery,
          GetPatientRemindersForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientRemindersForPatientQuery, GetPatientRemindersForPatientQueryVariables>(
    GetPatientRemindersForPatientDocument,
    variables,
    options,
  );
}
export function useGetPatientRemindersForPatientLazyQuery(
  variables?:
    | GetPatientRemindersForPatientQueryVariables
    | VueCompositionApi.Ref<GetPatientRemindersForPatientQueryVariables>
    | ReactiveFunction<GetPatientRemindersForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientRemindersForPatientQuery,
        GetPatientRemindersForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientRemindersForPatientQuery,
          GetPatientRemindersForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientRemindersForPatientQuery,
          GetPatientRemindersForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientRemindersForPatientQuery,
    GetPatientRemindersForPatientQueryVariables
  >(GetPatientRemindersForPatientDocument, variables, options);
}
export type GetPatientRemindersForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientRemindersForPatientQuery,
  GetPatientRemindersForPatientQueryVariables
>;
export const GetPlannedRemindersForPatientDocument = gql`
  query getPlannedRemindersForPatient($patientId: ID!) {
    getPlannedRemindersForPatient(patientId: $patientId) {
      id
      description
      minutesBeforeReminder
      action
      requiresAcknowledgement
      allDay
      scheduledTiming {
        repeat {
          timeOfDay
          dayOfWeek
          period
          periodUnit
          boundsPeriod {
            start
            end
          }
        }
      }
    }
  }
`;

/**
 * __useGetPlannedRemindersForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetPlannedRemindersForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedRemindersForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlannedRemindersForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPlannedRemindersForPatientQuery(
  variables:
    | GetPlannedRemindersForPatientQueryVariables
    | VueCompositionApi.Ref<GetPlannedRemindersForPatientQueryVariables>
    | ReactiveFunction<GetPlannedRemindersForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPlannedRemindersForPatientQuery,
        GetPlannedRemindersForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPlannedRemindersForPatientQuery,
          GetPlannedRemindersForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPlannedRemindersForPatientQuery,
          GetPlannedRemindersForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPlannedRemindersForPatientQuery, GetPlannedRemindersForPatientQueryVariables>(
    GetPlannedRemindersForPatientDocument,
    variables,
    options,
  );
}
export function useGetPlannedRemindersForPatientLazyQuery(
  variables?:
    | GetPlannedRemindersForPatientQueryVariables
    | VueCompositionApi.Ref<GetPlannedRemindersForPatientQueryVariables>
    | ReactiveFunction<GetPlannedRemindersForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPlannedRemindersForPatientQuery,
        GetPlannedRemindersForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPlannedRemindersForPatientQuery,
          GetPlannedRemindersForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPlannedRemindersForPatientQuery,
          GetPlannedRemindersForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPlannedRemindersForPatientQuery,
    GetPlannedRemindersForPatientQueryVariables
  >(GetPlannedRemindersForPatientDocument, variables, options);
}
export type GetPlannedRemindersForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPlannedRemindersForPatientQuery,
  GetPlannedRemindersForPatientQueryVariables
>;
export const PatientRemindersPaginatedDocument = gql`
  query patientRemindersPaginated(
    $status: AppointmentStatus
    $startAtLeast: dateTime
    $startAtMost: dateTime
    $limit: Int
    $cursor: cursor
  ) {
    remindersForEveryone: patientRemindersPaginated(
      status: $status
      startAtLeast: $startAtLeast
      startAtMost: $startAtMost
      limit: $limit
      cursor: $cursor
    ) {
      reminders {
        id
        status
        appointmentType
        description
        minutesBeforeReminder
        requiresAcknowledgement
        allDay
        allDayDate
        acknowledgedAt
        start
        end
        patient {
          id
          name {
            given
            family
            text
          }
        }
        participant {
          actor {
            reference
            display
          }
          task {
            reference
            display
          }
        }
      }
      cursor
      hasMore
    }
  }
`;

/**
 * __usePatientRemindersPaginatedQuery__
 *
 * To run a query within a Vue component, call `usePatientRemindersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientRemindersPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientRemindersPaginatedQuery({
 *   status: // value for 'status'
 *   startAtLeast: // value for 'startAtLeast'
 *   startAtMost: // value for 'startAtMost'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function usePatientRemindersPaginatedQuery(
  variables:
    | PatientRemindersPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientRemindersPaginatedQueryVariables>
    | ReactiveFunction<PatientRemindersPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>(
    PatientRemindersPaginatedDocument,
    variables,
    options,
  );
}
export function usePatientRemindersPaginatedLazyQuery(
  variables:
    | PatientRemindersPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientRemindersPaginatedQueryVariables>
    | ReactiveFunction<PatientRemindersPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientRemindersPaginatedQuery, PatientRemindersPaginatedQueryVariables>(
    PatientRemindersPaginatedDocument,
    variables,
    options,
  );
}
export type PatientRemindersPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientRemindersPaginatedQuery,
  PatientRemindersPaginatedQueryVariables
>;
export const GetPatientReminderByIdDocument = gql`
  query getPatientReminderById($reminderId: ID!) {
    getReminderById: getPatientReminderById(reminderId: $reminderId) {
      id
      reminder {
        id
        status
        appointmentType
        start
        end
        meetingStartTime
        meetingEndTime
        description
        minutesBeforeReminder
        action
        requiresAcknowledgement
        allDay
        allDayDate
        acknowledgedAt
        participant {
          actor {
            reference
            display
          }
          task {
            reference
          }
        }
        supportingInformation {
          reference
          display
        }
        carePlan {
          id
          title
          status
        }
        patient {
          id
          name {
            text
            given
            family
          }
        }
      }
    }
  }
`;

/**
 * __useGetPatientReminderByIdQuery__
 *
 * To run a query within a Vue component, call `useGetPatientReminderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientReminderByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientReminderByIdQuery({
 *   reminderId: // value for 'reminderId'
 * });
 */
export function useGetPatientReminderByIdQuery(
  variables:
    | GetPatientReminderByIdQueryVariables
    | VueCompositionApi.Ref<GetPatientReminderByIdQueryVariables>
    | ReactiveFunction<GetPatientReminderByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>(
    GetPatientReminderByIdDocument,
    variables,
    options,
  );
}
export function useGetPatientReminderByIdLazyQuery(
  variables?:
    | GetPatientReminderByIdQueryVariables
    | VueCompositionApi.Ref<GetPatientReminderByIdQueryVariables>
    | ReactiveFunction<GetPatientReminderByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientReminderByIdQuery, GetPatientReminderByIdQueryVariables>(
    GetPatientReminderByIdDocument,
    variables,
    options,
  );
}
export type GetPatientReminderByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientReminderByIdQuery,
  GetPatientReminderByIdQueryVariables
>;
export const UpdatePlannedReminderDocument = gql`
  mutation updatePlannedReminder($patientId: ID!, $plannedReminderId: ID!, $input: PlannedReminderUpdateInput!) {
    updatePlannedReminder(patientId: $patientId, plannedReminderId: $plannedReminderId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      plannedReminder {
        id
        description
        minutesBeforeReminder
        action
        requiresAcknowledgement
        allDay
        scheduledTiming {
          repeat {
            timeOfDay
            dayOfWeek
            periodUnit
            period
          }
        }
      }
    }
  }
`;

/**
 * __useUpdatePlannedReminderMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePlannedReminderMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     plannedReminderId: // value for 'plannedReminderId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePlannedReminderMutation, UpdatePlannedReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePlannedReminderMutation, UpdatePlannedReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePlannedReminderMutation, UpdatePlannedReminderMutationVariables>(
    UpdatePlannedReminderDocument,
    options,
  );
}
export type UpdatePlannedReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePlannedReminderMutation,
  UpdatePlannedReminderMutationVariables
>;
export const PlanPatientReminderDocument = gql`
  mutation planPatientReminder($patientId: ID!, $input: PatientReminderCreateInput!) {
    planPatientReminder(patientId: $patientId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      reminder {
        id
        status
        appointmentType
        description
        minutesBeforeReminder
        action
        requiresAcknowledgement
        allDay
        acknowledgedAt
        start
        end
        participant {
          actor {
            reference
            display
          }
          task {
            reference
            display
          }
        }
        patient {
          id
          name {
            text
          }
        }
      }
    }
  }
`;

/**
 * __usePlanPatientReminderMutation__
 *
 * To run a mutation, you first call `usePlanPatientReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePlanPatientReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePlanPatientReminderMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePlanPatientReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<PlanPatientReminderMutation, PlanPatientReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<PlanPatientReminderMutation, PlanPatientReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<PlanPatientReminderMutation, PlanPatientReminderMutationVariables>(
    PlanPatientReminderDocument,
    options,
  );
}
export type PlanPatientReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PlanPatientReminderMutation,
  PlanPatientReminderMutationVariables
>;
export const CancelPatientReminderDocument = gql`
  mutation cancelPatientReminder($reminderId: ID!) {
    cancelReminder: cancelPatientReminder(reminderId: $reminderId) {
      success
      message
      reminder {
        id
        status
        appointmentType
        description
        start
        end
      }
    }
  }
`;

/**
 * __useCancelPatientReminderMutation__
 *
 * To run a mutation, you first call `useCancelPatientReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelPatientReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelPatientReminderMutation({
 *   variables: {
 *     reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useCancelPatientReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelPatientReminderMutation, CancelPatientReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CancelPatientReminderMutation, CancelPatientReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CancelPatientReminderMutation, CancelPatientReminderMutationVariables>(
    CancelPatientReminderDocument,
    options,
  );
}
export type CancelPatientReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelPatientReminderMutation,
  CancelPatientReminderMutationVariables
>;
export const RemovePlannedReminderDocument = gql`
  mutation removePlannedReminder($patientId: ID!, $plannedReminderId: ID!) {
    removePlannedReminder(patientId: $patientId, plannedReminderId: $plannedReminderId) {
      success
      message
    }
  }
`;

/**
 * __useRemovePlannedReminderMutation__
 *
 * To run a mutation, you first call `useRemovePlannedReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlannedReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePlannedReminderMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     plannedReminderId: // value for 'plannedReminderId'
 *   },
 * });
 */
export function useRemovePlannedReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemovePlannedReminderMutation, RemovePlannedReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemovePlannedReminderMutation, RemovePlannedReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemovePlannedReminderMutation, RemovePlannedReminderMutationVariables>(
    RemovePlannedReminderDocument,
    options,
  );
}
export type RemovePlannedReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePlannedReminderMutation,
  RemovePlannedReminderMutationVariables
>;
export const AddPlannedReminderDocument = gql`
  mutation addPlannedReminder($patientId: ID!, $input: PlannedReminderCreateInput!) {
    addPlannedReminder(patientId: $patientId, input: $input) {
      success
      message
      plannedReminder {
        id
        description
        minutesBeforeReminder
        action
        requiresAcknowledgement
        allDay
        scheduledTiming {
          repeat {
            timeOfDay
            dayOfWeek
            periodUnit
            period
          }
        }
      }
    }
  }
`;

/**
 * __useAddPlannedReminderMutation__
 *
 * To run a mutation, you first call `useAddPlannedReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPlannedReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPlannedReminderMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddPlannedReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPlannedReminderMutation, AddPlannedReminderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPlannedReminderMutation, AddPlannedReminderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPlannedReminderMutation, AddPlannedReminderMutationVariables>(
    AddPlannedReminderDocument,
    options,
  );
}
export type AddPlannedReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPlannedReminderMutation,
  AddPlannedReminderMutationVariables
>;
export const ReschedulePatientReminderDocument = gql`
  mutation reschedulePatientReminder($reminderId: ID!, $input: PatientReminderRescheduleInput!) {
    reschedulePatientReminder(reminderId: $reminderId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      reminder {
        id
        status
        start
        end
        description
        minutesBeforeReminder
        action
        requiresAcknowledgement
        allDay
        acknowledgedAt
      }
    }
  }
`;

/**
 * __useReschedulePatientReminderMutation__
 *
 * To run a mutation, you first call `useReschedulePatientReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReschedulePatientReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReschedulePatientReminderMutation({
 *   variables: {
 *     reminderId: // value for 'reminderId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReschedulePatientReminderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ReschedulePatientReminderMutation,
        ReschedulePatientReminderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ReschedulePatientReminderMutation,
          ReschedulePatientReminderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ReschedulePatientReminderMutation, ReschedulePatientReminderMutationVariables>(
    ReschedulePatientReminderDocument,
    options,
  );
}
export type ReschedulePatientReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ReschedulePatientReminderMutation,
  ReschedulePatientReminderMutationVariables
>;
export const GetRequestDocument = gql`
  query getRequest($requestId: ID!) {
    getTaskById(taskId: $requestId) {
      id
      status
      description
      authoredOn
      owner {
        display
      }
      patient {
        id
        name {
          family
          given
        }
      }
      videoMeeting {
        id
        appointment {
          status
          start
          end
          description
        }
      }
      note {
        text
        time
        authorString
        authorReference {
          display
          reference
        }
      }
    }
  }
`;

/**
 * __useGetRequestQuery__
 *
 * To run a query within a Vue component, call `useGetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRequestQuery({
 *   requestId: // value for 'requestId'
 * });
 */
export function useGetRequestQuery(
  variables:
    | GetRequestQueryVariables
    | VueCompositionApi.Ref<GetRequestQueryVariables>
    | ReactiveFunction<GetRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetRequestQuery, GetRequestQueryVariables>(
    GetRequestDocument,
    variables,
    options,
  );
}
export function useGetRequestLazyQuery(
  variables?:
    | GetRequestQueryVariables
    | VueCompositionApi.Ref<GetRequestQueryVariables>
    | ReactiveFunction<GetRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRequestQuery, GetRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetRequestQuery, GetRequestQueryVariables>(
    GetRequestDocument,
    variables,
    options,
  );
}
export type GetRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRequestQuery,
  GetRequestQueryVariables
>;
export const GetRequestsDocument = gql`
  query getRequests($from: dateTime, $to: dateTime) {
    requests: getTasks(from: $from, to: $to, code: HP_PATIENT_VIDEO_MEETING_REQUEST) {
      id
      status
      authoredOn
      description
      owner {
        display
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        appointment {
          id
          status
        }
      }
    }
  }
`;

/**
 * __useGetRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRequestsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetRequestsQuery(
  variables:
    | GetRequestsQueryVariables
    | VueCompositionApi.Ref<GetRequestsQueryVariables>
    | ReactiveFunction<GetRequestsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetRequestsQuery, GetRequestsQueryVariables>(
    GetRequestsDocument,
    variables,
    options,
  );
}
export function useGetRequestsLazyQuery(
  variables:
    | GetRequestsQueryVariables
    | VueCompositionApi.Ref<GetRequestsQueryVariables>
    | ReactiveFunction<GetRequestsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRequestsQuery, GetRequestsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetRequestsQuery, GetRequestsQueryVariables>(
    GetRequestsDocument,
    variables,
    options,
  );
}
export type GetRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRequestsQuery,
  GetRequestsQueryVariables
>;
export const EmbeddedPatientDocument = gql`
  query embeddedPatient($id: ID!) {
    patient(id: $id) {
      id
      name {
        text
      }
      cameras {
        id
        name
        macAddress
      }
      welfareDevices {
        id
        uniqueIdentifier
        deviceName {
          name
        }
        modelNumber
      }
    }
  }
`;

/**
 * __useEmbeddedPatientQuery__
 *
 * To run a query within a Vue component, call `useEmbeddedPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmbeddedPatientQuery({
 *   id: // value for 'id'
 * });
 */
export function useEmbeddedPatientQuery(
  variables:
    | EmbeddedPatientQueryVariables
    | VueCompositionApi.Ref<EmbeddedPatientQueryVariables>
    | ReactiveFunction<EmbeddedPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>(
    EmbeddedPatientDocument,
    variables,
    options,
  );
}
export function useEmbeddedPatientLazyQuery(
  variables?:
    | EmbeddedPatientQueryVariables
    | VueCompositionApi.Ref<EmbeddedPatientQueryVariables>
    | ReactiveFunction<EmbeddedPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<EmbeddedPatientQuery, EmbeddedPatientQueryVariables>(
    EmbeddedPatientDocument,
    variables,
    options,
  );
}
export type EmbeddedPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  EmbeddedPatientQuery,
  EmbeddedPatientQueryVariables
>;
export const SetPendingExternalIdentityProviderDocument = gql`
  mutation setPendingExternalIdentityProvider($userId: ID!, $externalIdentityProvider: String!, $pending: Boolean!) {
    setPendingExternalIdentityProvider(
      userId: $userId
      externalIdentityProvider: $externalIdentityProvider
      pending: $pending
    )
  }
`;

/**
 * __useSetPendingExternalIdentityProviderMutation__
 *
 * To run a mutation, you first call `useSetPendingExternalIdentityProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPendingExternalIdentityProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPendingExternalIdentityProviderMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalIdentityProvider: // value for 'externalIdentityProvider'
 *     pending: // value for 'pending'
 *   },
 * });
 */
export function useSetPendingExternalIdentityProviderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetPendingExternalIdentityProviderMutation,
        SetPendingExternalIdentityProviderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetPendingExternalIdentityProviderMutation,
          SetPendingExternalIdentityProviderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetPendingExternalIdentityProviderMutation,
    SetPendingExternalIdentityProviderMutationVariables
  >(SetPendingExternalIdentityProviderDocument, options);
}
export type SetPendingExternalIdentityProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetPendingExternalIdentityProviderMutation,
  SetPendingExternalIdentityProviderMutationVariables
>;
export const SetExternalIdRequestDocument = gql`
  mutation setExternalIdRequest($userId: ID!, $externalHumanIdType: String!, $requested: Boolean!) {
    setExternalIdRequest(userId: $userId, externalHumanIdType: $externalHumanIdType, requested: $requested)
  }
`;

/**
 * __useSetExternalIdRequestMutation__
 *
 * To run a mutation, you first call `useSetExternalIdRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdRequestMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalHumanIdType: // value for 'externalHumanIdType'
 *     requested: // value for 'requested'
 *   },
 * });
 */
export function useSetExternalIdRequestMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>(
    SetExternalIdRequestDocument,
    options,
  );
}
export type SetExternalIdRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdRequestMutation,
  SetExternalIdRequestMutationVariables
>;
export const RemoveExternalDialoggUserIdDocument = gql`
  mutation removeExternalDialoggUserId($username: ID!, $externalUserId: ExternalHumanIdInput!) {
    removeExternalDialoggUserId(username: $username, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalDialoggUserIdMutation__
 *
 * To run a mutation, you first call `useRemoveExternalDialoggUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalDialoggUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalDialoggUserIdMutation({
 *   variables: {
 *     username: // value for 'username'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useRemoveExternalDialoggUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveExternalDialoggUserIdMutation,
        RemoveExternalDialoggUserIdMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveExternalDialoggUserIdMutation,
          RemoveExternalDialoggUserIdMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveExternalDialoggUserIdMutation,
    RemoveExternalDialoggUserIdMutationVariables
  >(RemoveExternalDialoggUserIdDocument, options);
}
export type RemoveExternalDialoggUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalDialoggUserIdMutation,
  RemoveExternalDialoggUserIdMutationVariables
>;
export const RemoveExternalUserIdDocument = gql`
  mutation removeExternalUserId($userId: ID!, $externalUserId: ExternalHumanIdInput!) {
    removeExternalUserId(userId: $userId, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalUserIdMutation__
 *
 * To run a mutation, you first call `useRemoveExternalUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalUserIdMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useRemoveExternalUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>(
    RemoveExternalUserIdDocument,
    options,
  );
}
export type RemoveExternalUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalUserIdMutation,
  RemoveExternalUserIdMutationVariables
>;
export const RemoveExternalPatientIdFromPatientDocument = gql`
  mutation removeExternalPatientIdFromPatient($patientId: ID!, $externalPatientId: ExternalHumanIdInput!) {
    removeExternalPatientIdFromPatient(patientId: $patientId, externalPatientId: $externalPatientId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalPatientIdFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveExternalPatientIdFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalPatientIdFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalPatientIdFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalPatientId: // value for 'externalPatientId'
 *   },
 * });
 */
export function useRemoveExternalPatientIdFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveExternalPatientIdFromPatientMutation,
        RemoveExternalPatientIdFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveExternalPatientIdFromPatientMutation,
          RemoveExternalPatientIdFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveExternalPatientIdFromPatientMutation,
    RemoveExternalPatientIdFromPatientMutationVariables
  >(RemoveExternalPatientIdFromPatientDocument, options);
}
export type RemoveExternalPatientIdFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalPatientIdFromPatientMutation,
  RemoveExternalPatientIdFromPatientMutationVariables
>;
export const AddExternalDialoggUserIdDocument = gql`
  mutation addExternalDialoggUserId($username: ID!, $externalUserId: ExternalHumanIdInput!) {
    addExternalDialoggUserId(username: $username, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useAddExternalDialoggUserIdMutation__
 *
 * To run a mutation, you first call `useAddExternalDialoggUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalDialoggUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalDialoggUserIdMutation({
 *   variables: {
 *     username: // value for 'username'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddExternalDialoggUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalDialoggUserIdMutation,
        AddExternalDialoggUserIdMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalDialoggUserIdMutation,
          AddExternalDialoggUserIdMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddExternalDialoggUserIdMutation, AddExternalDialoggUserIdMutationVariables>(
    AddExternalDialoggUserIdDocument,
    options,
  );
}
export type AddExternalDialoggUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalDialoggUserIdMutation,
  AddExternalDialoggUserIdMutationVariables
>;
export const AddExternalUserIdDocument = gql`
  mutation addExternalUserId($userId: ID!, $externalUserId: ExternalHumanIdInput!) {
    addExternalUserId(userId: $userId, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useAddExternalUserIdMutation__
 *
 * To run a mutation, you first call `useAddExternalUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalUserIdMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddExternalUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>(
    AddExternalUserIdDocument,
    options,
  );
}
export type AddExternalUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalUserIdMutation,
  AddExternalUserIdMutationVariables
>;
export const AddExternalPatientIdToPatientDocument = gql`
  mutation addExternalPatientIdToPatient($patientId: ID!, $externalPatientId: ExternalHumanIdInput!) {
    addExternalPatientIdToPatient(patientId: $patientId, externalPatientId: $externalPatientId) {
      success
    }
  }
`;

/**
 * __useAddExternalPatientIdToPatientMutation__
 *
 * To run a mutation, you first call `useAddExternalPatientIdToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalPatientIdToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalPatientIdToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalPatientId: // value for 'externalPatientId'
 *   },
 * });
 */
export function useAddExternalPatientIdToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalPatientIdToPatientMutation,
        AddExternalPatientIdToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalPatientIdToPatientMutation,
          AddExternalPatientIdToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddExternalPatientIdToPatientMutation,
    AddExternalPatientIdToPatientMutationVariables
  >(AddExternalPatientIdToPatientDocument, options);
}
export type AddExternalPatientIdToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalPatientIdToPatientMutation,
  AddExternalPatientIdToPatientMutationVariables
>;
export const RemoveUserReservationDocument = gql`
  mutation removeUserReservation($patientId: ID!, $userId: ID!) {
    removeUserReservation(patientId: $patientId, userId: $userId)
  }
`;

/**
 * __useRemoveUserReservationMutation__
 *
 * To run a mutation, you first call `useRemoveUserReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserReservationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserReservationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>(
    RemoveUserReservationDocument,
    options,
  );
}
export type RemoveUserReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserReservationMutation,
  RemoveUserReservationMutationVariables
>;
export const AddUserReservationDocument = gql`
  mutation addUserReservation($patientId: ID!, $userId: ID!) {
    addUserReservation(patientId: $patientId, userId: $userId)
  }
`;

/**
 * __useAddUserReservationMutation__
 *
 * To run a mutation, you first call `useAddUserReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserReservationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserReservationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserReservationMutation, AddUserReservationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserReservationMutation, AddUserReservationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserReservationMutation, AddUserReservationMutationVariables>(
    AddUserReservationDocument,
    options,
  );
}
export type AddUserReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserReservationMutation,
  AddUserReservationMutationVariables
>;
export const PatientWithUserReservationsDocument = gql`
  query patientWithUserReservations($id: ID!) {
    patient(id: $id) {
      id
      userReservations {
        userId
        firstName
        lastName
      }
    }
  }
`;

/**
 * __usePatientWithUserReservationsQuery__
 *
 * To run a query within a Vue component, call `usePatientWithUserReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithUserReservationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithUserReservationsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithUserReservationsQuery(
  variables:
    | PatientWithUserReservationsQueryVariables
    | VueCompositionApi.Ref<PatientWithUserReservationsQueryVariables>
    | ReactiveFunction<PatientWithUserReservationsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>(
    PatientWithUserReservationsDocument,
    variables,
    options,
  );
}
export function usePatientWithUserReservationsLazyQuery(
  variables?:
    | PatientWithUserReservationsQueryVariables
    | VueCompositionApi.Ref<PatientWithUserReservationsQueryVariables>
    | ReactiveFunction<PatientWithUserReservationsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>(
    PatientWithUserReservationsDocument,
    variables,
    options,
  );
}
export type PatientWithUserReservationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithUserReservationsQuery,
  PatientWithUserReservationsQueryVariables
>;
export const RoleTypesForAuditEventAgentDocument = gql`
  query roleTypesForAuditEventAgent {
    roleTypes {
      id
      display {
        key
        value
      }
    }
  }
`;

/**
 * __useRoleTypesForAuditEventAgentQuery__
 *
 * To run a query within a Vue component, call `useRoleTypesForAuditEventAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleTypesForAuditEventAgentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleTypesForAuditEventAgentQuery();
 */
export function useRoleTypesForAuditEventAgentQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>(
    RoleTypesForAuditEventAgentDocument,
    {},
    options,
  );
}
export function useRoleTypesForAuditEventAgentLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>(
    RoleTypesForAuditEventAgentDocument,
    {},
    options,
  );
}
export type RoleTypesForAuditEventAgentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RoleTypesForAuditEventAgentQuery,
  RoleTypesForAuditEventAgentQueryVariables
>;
export const DeleteUserGroupDocument = gql`
  mutation deleteUserGroup($userGroupId: ID!, $forceDelete: Boolean) {
    deleteUserGroup(userGroupId: $userGroupId, forceDelete: $forceDelete) {
      success
      message
    }
  }
`;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     forceDelete: // value for 'forceDelete'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(
    DeleteUserGroupDocument,
    options,
  );
}
export type DeleteUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteUserGroupMutation,
  DeleteUserGroupMutationVariables
>;
export const UpdateUserGroupDocument = gql`
  mutation updateUserGroup($userGroup: UpdateUserGroupInput!, $userGroupId: ID!) {
    updateUserGroup(userGroupId: $userGroupId, userGroup: $userGroup) {
      success
      message
    }
  }
`;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupMutation({
 *   variables: {
 *     userGroup: // value for 'userGroup'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(
    UpdateUserGroupDocument,
    options,
  );
}
export type UpdateUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupMutation,
  UpdateUserGroupMutationVariables
>;
export const CreateUserGroupDocument = gql`
  mutation createUserGroup($newUserGroup: CreateUserGroupInput!, $parentUserGroupId: ID!) {
    createUserGroup(parentId: $parentUserGroupId, userGroup: $newUserGroup) {
      success
      message
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserGroupMutation({
 *   variables: {
 *     newUserGroup: // value for 'newUserGroup'
 *     parentUserGroupId: // value for 'parentUserGroupId'
 *   },
 * });
 */
export function useCreateUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(
    CreateUserGroupDocument,
    options,
  );
}
export type CreateUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserGroupMutation,
  CreateUserGroupMutationVariables
>;
export const PatientGroupForAlarmForwardingDocument = gql`
  query patientGroupForAlarmForwarding($id: ID!) {
    patientGroup(id: $id) {
      id
      name
      alarmRoutes {
        configName
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          icon
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          icon
        }
        idMappingStrategy
      }
    }
  }
`;

/**
 * __usePatientGroupForAlarmForwardingQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupForAlarmForwardingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupForAlarmForwardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupForAlarmForwardingQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientGroupForAlarmForwardingQuery(
  variables:
    | PatientGroupForAlarmForwardingQueryVariables
    | VueCompositionApi.Ref<PatientGroupForAlarmForwardingQueryVariables>
    | ReactiveFunction<PatientGroupForAlarmForwardingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientGroupForAlarmForwardingQuery,
        PatientGroupForAlarmForwardingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    PatientGroupForAlarmForwardingQuery,
    PatientGroupForAlarmForwardingQueryVariables
  >(PatientGroupForAlarmForwardingDocument, variables, options);
}
export function usePatientGroupForAlarmForwardingLazyQuery(
  variables?:
    | PatientGroupForAlarmForwardingQueryVariables
    | VueCompositionApi.Ref<PatientGroupForAlarmForwardingQueryVariables>
    | ReactiveFunction<PatientGroupForAlarmForwardingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientGroupForAlarmForwardingQuery,
        PatientGroupForAlarmForwardingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    PatientGroupForAlarmForwardingQuery,
    PatientGroupForAlarmForwardingQueryVariables
  >(PatientGroupForAlarmForwardingDocument, variables, options);
}
export type PatientGroupForAlarmForwardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupForAlarmForwardingQuery,
  PatientGroupForAlarmForwardingQueryVariables
>;
export const GetSkyresponseSyncJobsCountDocument = gql`
  query getSkyresponseSyncJobsCount {
    getSkyresponseSyncJobsCount
  }
`;

/**
 * __useGetSkyresponseSyncJobsCountQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseSyncJobsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseSyncJobsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseSyncJobsCountQuery();
 */
export function useGetSkyresponseSyncJobsCountQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>(
    GetSkyresponseSyncJobsCountDocument,
    {},
    options,
  );
}
export function useGetSkyresponseSyncJobsCountLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>(
    GetSkyresponseSyncJobsCountDocument,
    {},
    options,
  );
}
export type GetSkyresponseSyncJobsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseSyncJobsCountQuery,
  GetSkyresponseSyncJobsCountQueryVariables
>;
export const SyncPatientInfoWithSkyresponseForSyncModalDocument = gql`
  mutation syncPatientInfoWithSkyresponseForSyncModal(
    $userGroupId: ID!
    $skip: Int
    $take: Int
    $syncScenario: String
  ) {
    syncPatientInfoWithSkyresponse(userGroupId: $userGroupId, skip: $skip, take: $take, syncScenario: $syncScenario) {
      success
      message
      total
      take
      skip
      next {
        skip
        take
      }
    }
  }
`;

/**
 * __useSyncPatientInfoWithSkyresponseForSyncModalMutation__
 *
 * To run a mutation, you first call `useSyncPatientInfoWithSkyresponseForSyncModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncPatientInfoWithSkyresponseForSyncModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncPatientInfoWithSkyresponseForSyncModalMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     skip: // value for 'skip'
 *     take: // value for 'take'
 *     syncScenario: // value for 'syncScenario'
 *   },
 * });
 */
export function useSyncPatientInfoWithSkyresponseForSyncModalMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncPatientInfoWithSkyresponseForSyncModalMutation,
        SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncPatientInfoWithSkyresponseForSyncModalMutation,
          SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncPatientInfoWithSkyresponseForSyncModalMutation,
    SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
  >(SyncPatientInfoWithSkyresponseForSyncModalDocument, options);
}
export type SyncPatientInfoWithSkyresponseForSyncModalMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SyncPatientInfoWithSkyresponseForSyncModalMutation,
    SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
  >;
export const UserGroupPatientAccessListDocument = gql`
  query userGroupPatientAccessList($userGroupId: ID!) {
    userGroupPatientAccessList(userGroupId: $userGroupId) {
      id
      username
      firstName
      lastName
      roles {
        id
        userGroupName
        display {
          key
          value
        }
      }
    }
  }
`;

/**
 * __useUserGroupPatientAccessListQuery__
 *
 * To run a query within a Vue component, call `useUserGroupPatientAccessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupPatientAccessListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupPatientAccessListQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupPatientAccessListQuery(
  variables:
    | UserGroupPatientAccessListQueryVariables
    | VueCompositionApi.Ref<UserGroupPatientAccessListQueryVariables>
    | ReactiveFunction<UserGroupPatientAccessListQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>(
    UserGroupPatientAccessListDocument,
    variables,
    options,
  );
}
export function useUserGroupPatientAccessListLazyQuery(
  variables?:
    | UserGroupPatientAccessListQueryVariables
    | VueCompositionApi.Ref<UserGroupPatientAccessListQueryVariables>
    | ReactiveFunction<UserGroupPatientAccessListQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>(
    UserGroupPatientAccessListDocument,
    variables,
    options,
  );
}
export type UserGroupPatientAccessListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupPatientAccessListQuery,
  UserGroupPatientAccessListQueryVariables
>;
export const RoleTypesDocument = gql`
  query roleTypes {
    roleTypes {
      id
      display {
        key
        value
      }
      basedOn_fk
    }
  }
`;

/**
 * __useRoleTypesQuery__
 *
 * To run a query within a Vue component, call `useRoleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleTypesQuery();
 */
export function useRoleTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RoleTypesQuery, RoleTypesQueryVariables>(RoleTypesDocument, {}, options);
}
export function useRoleTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RoleTypesQuery, RoleTypesQueryVariables>(RoleTypesDocument, {}, options);
}
export type RoleTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RoleTypesQuery,
  RoleTypesQueryVariables
>;
export const GetAlarmHandlingRulesForUserGroupDocument = gql`
  query getAlarmHandlingRulesForUserGroup($userGroupId: ID!) {
    getAlarmHandlingRulesForUserGroup(userGroupId: $userGroupId) {
      id
      name
    }
  }
`;

/**
 * __useGetAlarmHandlingRulesForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHandlingRulesForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHandlingRulesForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHandlingRulesForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAlarmHandlingRulesForUserGroupQuery(
  variables:
    | GetAlarmHandlingRulesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingRulesForUserGroupQueryVariables>
    | ReactiveFunction<GetAlarmHandlingRulesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHandlingRulesForUserGroupQuery,
        GetAlarmHandlingRulesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmHandlingRulesForUserGroupQuery,
    GetAlarmHandlingRulesForUserGroupQueryVariables
  >(GetAlarmHandlingRulesForUserGroupDocument, variables, options);
}
export function useGetAlarmHandlingRulesForUserGroupLazyQuery(
  variables?:
    | GetAlarmHandlingRulesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingRulesForUserGroupQueryVariables>
    | ReactiveFunction<GetAlarmHandlingRulesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHandlingRulesForUserGroupQuery,
        GetAlarmHandlingRulesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmHandlingRulesForUserGroupQuery,
    GetAlarmHandlingRulesForUserGroupQueryVariables
  >(GetAlarmHandlingRulesForUserGroupDocument, variables, options);
}
export type GetAlarmHandlingRulesForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHandlingRulesForUserGroupQuery,
  GetAlarmHandlingRulesForUserGroupQueryVariables
>;
export const CreatePatientGroupDocument = gql`
  mutation createPatientGroup($createInput: PatientGroupInput!, $userGroupId: ID!) {
    createPatientGroup(userGroupId: $userGroupId, createInput: $createInput) {
      success
      message
    }
  }
`;

/**
 * __useCreatePatientGroupMutation__
 *
 * To run a mutation, you first call `useCreatePatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientGroupMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreatePatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>(
    CreatePatientGroupDocument,
    options,
  );
}
export type CreatePatientGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientGroupMutation,
  CreatePatientGroupMutationVariables
>;
export const UpdatePatientGroupDocument = gql`
  mutation updatePatientGroup($patientGroupId: ID!, $patientGroup: PatientGroupInput!) {
    updatePatientGroup(id: $patientGroupId, updateInput: $patientGroup) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     patientGroup: // value for 'patientGroup'
 *   },
 * });
 */
export function useUpdatePatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>(
    UpdatePatientGroupDocument,
    options,
  );
}
export type UpdatePatientGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGroupMutation,
  UpdatePatientGroupMutationVariables
>;
export const HideTechnicalAlarmNotificationsForPatientGroupDocument = gql`
  mutation hideTechnicalAlarmNotificationsForPatientGroup(
    $patientGroupId: ID!
    $hideTechnicalAlarmNotifications: Boolean!
  ) {
    hideTechnicalAlarmNotificationsForPatientGroup(
      id: $patientGroupId
      hideTechnicalAlarmNotifications: $hideTechnicalAlarmNotifications
    ) {
      success
      message
    }
  }
`;

/**
 * __useHideTechnicalAlarmNotificationsForPatientGroupMutation__
 *
 * To run a mutation, you first call `useHideTechnicalAlarmNotificationsForPatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useHideTechnicalAlarmNotificationsForPatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useHideTechnicalAlarmNotificationsForPatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     hideTechnicalAlarmNotifications: // value for 'hideTechnicalAlarmNotifications'
 *   },
 * });
 */
export function useHideTechnicalAlarmNotificationsForPatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        HideTechnicalAlarmNotificationsForPatientGroupMutation,
        HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          HideTechnicalAlarmNotificationsForPatientGroupMutation,
          HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    HideTechnicalAlarmNotificationsForPatientGroupMutation,
    HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
  >(HideTechnicalAlarmNotificationsForPatientGroupDocument, options);
}
export type HideTechnicalAlarmNotificationsForPatientGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    HideTechnicalAlarmNotificationsForPatientGroupMutation,
    HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
  >;
export const RemovePatientGroupFromUserGroupDocument = gql`
  mutation removePatientGroupFromUserGroup($patientGroupId: ID!, $userGroupId: ID!) {
    removePatientGroupFromUserGroup(patientGroupId: $patientGroupId, userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useRemovePatientGroupFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemovePatientGroupFromUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientGroupFromUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientGroupFromUserGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useRemovePatientGroupFromUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientGroupFromUserGroupMutation,
        RemovePatientGroupFromUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientGroupFromUserGroupMutation,
          RemovePatientGroupFromUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientGroupFromUserGroupMutation,
    RemovePatientGroupFromUserGroupMutationVariables
  >(RemovePatientGroupFromUserGroupDocument, options);
}
export type RemovePatientGroupFromUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientGroupFromUserGroupMutation,
  RemovePatientGroupFromUserGroupMutationVariables
>;
export const CreateRoleDocument = gql`
  mutation createRole($id: ID!, $userGroupId: ID!) {
    createRole(userGroupId: $userGroupId, id: $id) {
      success
      message
    }
  }
`;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRoleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreateRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
}
export type CreateRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation deleteRole($roleId: ID!) {
    deleteRole(roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRoleMutation({
 *   variables: {
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
}
export type DeleteRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const UpdateSkyresponseConfigDocument = gql`
  mutation updateSkyresponseConfig($userGroupId: ID!, $skyresponseConfig: SkyresponseConfigInput!) {
    updateSkyresponseConfig(userGroupId: $userGroupId, skyresponseConfig: $skyresponseConfig) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSkyresponseConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSkyresponseConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkyresponseConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSkyresponseConfigMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     skyresponseConfig: // value for 'skyresponseConfig'
 *   },
 * });
 */
export function useUpdateSkyresponseConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSkyresponseConfigMutation, UpdateSkyresponseConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSkyresponseConfigMutation,
          UpdateSkyresponseConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSkyresponseConfigMutation, UpdateSkyresponseConfigMutationVariables>(
    UpdateSkyresponseConfigDocument,
    options,
  );
}
export type UpdateSkyresponseConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSkyresponseConfigMutation,
  UpdateSkyresponseConfigMutationVariables
>;
export const UpdateEscalationDelayDocument = gql`
  mutation updateEscalationDelay($userGroupId: ID!, $escalationDelay: Int!) {
    updateEscalationDelay(userGroupId: $userGroupId, escalationDelay: $escalationDelay) {
      success
      message
    }
  }
`;

/**
 * __useUpdateEscalationDelayMutation__
 *
 * To run a mutation, you first call `useUpdateEscalationDelayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEscalationDelayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEscalationDelayMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     escalationDelay: // value for 'escalationDelay'
 *   },
 * });
 */
export function useUpdateEscalationDelayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>(
    UpdateEscalationDelayDocument,
    options,
  );
}
export type UpdateEscalationDelayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateEscalationDelayMutation,
  UpdateEscalationDelayMutationVariables
>;
export const DeleteEscalationDelayDocument = gql`
  mutation deleteEscalationDelay($userGroupId: ID!) {
    deleteEscalationDelay(userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteEscalationDelayMutation__
 *
 * To run a mutation, you first call `useDeleteEscalationDelayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEscalationDelayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEscalationDelayMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteEscalationDelayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>(
    DeleteEscalationDelayDocument,
    options,
  );
}
export type DeleteEscalationDelayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteEscalationDelayMutation,
  DeleteEscalationDelayMutationVariables
>;
export const UpdateCareTeamDocument = gql`
  mutation updateCareTeam($userGroupId: ID!, $careTeam: UpdateCareTeamInput!) {
    updateCareTeam(userGroupId: $userGroupId, careTeam: $careTeam) {
      success
      message
    }
  }
`;

/**
 * __useUpdateCareTeamMutation__
 *
 * To run a mutation, you first call `useUpdateCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeam: // value for 'careTeam'
 *   },
 * });
 */
export function useUpdateCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>(
    UpdateCareTeamDocument,
    options,
  );
}
export type UpdateCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCareTeamMutation,
  UpdateCareTeamMutationVariables
>;
export const AddCareTeamDocument = gql`
  mutation addCareTeam($userGroupId: ID!, $careTeam: CreateCareTeamInput!) {
    addCareTeam(userGroupId: $userGroupId, careTeam: $careTeam) {
      success
      message
    }
  }
`;

/**
 * __useAddCareTeamMutation__
 *
 * To run a mutation, you first call `useAddCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeam: // value for 'careTeam'
 *   },
 * });
 */
export function useAddCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddCareTeamMutation, AddCareTeamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCareTeamMutation, AddCareTeamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<AddCareTeamMutation, AddCareTeamMutationVariables>(
    AddCareTeamDocument,
    options,
  );
}
export type AddCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCareTeamMutation,
  AddCareTeamMutationVariables
>;
export const RemoveCareTeamDocument = gql`
  mutation removeCareTeam($userGroupId: ID!, $careTeamId: ID!) {
    removeCareTeam(userGroupId: $userGroupId, careTeamId: $careTeamId) {
      success
      message
    }
  }
`;

/**
 * __useRemoveCareTeamMutation__
 *
 * To run a mutation, you first call `useRemoveCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeamId: // value for 'careTeamId'
 *   },
 * });
 */
export function useRemoveCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>(
    RemoveCareTeamDocument,
    options,
  );
}
export type RemoveCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveCareTeamMutation,
  RemoveCareTeamMutationVariables
>;
export const CreateHelseIdAccountDocument = gql`
  mutation createHelseIdAccount($input: HelseIdAccountCreateInput!) {
    createHelseIdAccount(input: $input) {
      success
      message
      helseIdAccount {
        id
      }
    }
  }
`;

/**
 * __useCreateHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useCreateHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHelseIdAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>(
    CreateHelseIdAccountDocument,
    options,
  );
}
export type CreateHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateHelseIdAccountMutation,
  CreateHelseIdAccountMutationVariables
>;
export const UpdateHelseIdAccountDocument = gql`
  mutation updateHelseIdAccount($helseIdAccountId: ID!, $input: HelseIdAccountUpdateInput!) {
    updateHelseIdAccount(input: $input, helseIdAccountId: $helseIdAccountId) {
      success
      message
    }
  }
`;

/**
 * __useUpdateHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useUpdateHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHelseIdAccountMutation({
 *   variables: {
 *     helseIdAccountId: // value for 'helseIdAccountId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>(
    UpdateHelseIdAccountDocument,
    options,
  );
}
export type UpdateHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateHelseIdAccountMutation,
  UpdateHelseIdAccountMutationVariables
>;
export const CreateVkpAccountDocument = gql`
  mutation createVkpAccount($input: VkpAccountInput!) {
    createVkpAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateVkpAccountMutation__
 *
 * To run a mutation, you first call `useCreateVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVkpAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>(
    CreateVkpAccountDocument,
    options,
  );
}
export type CreateVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateVkpAccountMutation,
  CreateVkpAccountMutationVariables
>;
export const UpdateVkpAccountDocument = gql`
  mutation updateVkpAccount($vkpAccountId: ID!, $input: VkpAccountInput!) {
    updateVkpAccount(vkpAccountId: $vkpAccountId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateVkpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVkpAccountMutation({
 *   variables: {
 *     vkpAccountId: // value for 'vkpAccountId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>(
    UpdateVkpAccountDocument,
    options,
  );
}
export type UpdateVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateVkpAccountMutation,
  UpdateVkpAccountMutationVariables
>;
export const DeleteVkpAccountDocument = gql`
  mutation deleteVkpAccount($vkpAccountId: ID!) {
    deleteVkpAccount(vkpAccountId: $vkpAccountId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteVkpAccountMutation__
 *
 * To run a mutation, you first call `useDeleteVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVkpAccountMutation({
 *   variables: {
 *     vkpAccountId: // value for 'vkpAccountId'
 *   },
 * });
 */
export function useDeleteVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>(
    DeleteVkpAccountDocument,
    options,
  );
}
export type DeleteVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteVkpAccountMutation,
  DeleteVkpAccountMutationVariables
>;
export const DeleteHelseIdAccountDocument = gql`
  mutation deleteHelseIdAccount($id: ID!) {
    deleteHelseIdAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useDeleteHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteHelseIdAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>(
    DeleteHelseIdAccountDocument,
    options,
  );
}
export type DeleteHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteHelseIdAccountMutation,
  DeleteHelseIdAccountMutationVariables
>;
export const TestHelseIdCredentialsDocument = gql`
  mutation testHelseIdCredentials($helseIdAccountId: ID!) {
    testHelseIdCredentials(helseIdAccountId: $helseIdAccountId)
  }
`;

/**
 * __useTestHelseIdCredentialsMutation__
 *
 * To run a mutation, you first call `useTestHelseIdCredentialsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestHelseIdCredentialsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestHelseIdCredentialsMutation({
 *   variables: {
 *     helseIdAccountId: // value for 'helseIdAccountId'
 *   },
 * });
 */
export function useTestHelseIdCredentialsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>(
    TestHelseIdCredentialsDocument,
    options,
  );
}
export type TestHelseIdCredentialsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TestHelseIdCredentialsMutation,
  TestHelseIdCredentialsMutationVariables
>;
export const HelseIdAccountsDocument = gql`
  query helseIdAccounts {
    helseIdAccounts {
      id
      accountDisplayName
      organizationNumber
      credentials {
        authority
        clientId
        grantTypes
        maskedPrivateJwk
        rsaKeyExpiryDate
        rsaKeySizeBits
        maskedRsaPrivateKey
        scopes
        secretType
      }
    }
  }
`;

/**
 * __useHelseIdAccountsQuery__
 *
 * To run a query within a Vue component, call `useHelseIdAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelseIdAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHelseIdAccountsQuery();
 */
export function useHelseIdAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>(
    HelseIdAccountsDocument,
    {},
    options,
  );
}
export function useHelseIdAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>(
    HelseIdAccountsDocument,
    {},
    options,
  );
}
export type HelseIdAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HelseIdAccountsQuery,
  HelseIdAccountsQueryVariables
>;
export const VkpAccountsDocument = gql`
  query vkpAccounts {
    vkpAccounts {
      id
      accountDisplayName
      helseIdAccountId
      helseIdAccount {
        credentials {
          scopes
        }
      }
    }
  }
`;

/**
 * __useVkpAccountsQuery__
 *
 * To run a query within a Vue component, call `useVkpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpAccountsQuery();
 */
export function useVkpAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<VkpAccountsQuery, VkpAccountsQueryVariables>(VkpAccountsDocument, {}, options);
}
export function useVkpAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<VkpAccountsQuery, VkpAccountsQueryVariables>(
    VkpAccountsDocument,
    {},
    options,
  );
}
export type VkpAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpAccountsQuery,
  VkpAccountsQueryVariables
>;
export const CreateJournalConfigForUserGroupDocument = gql`
  mutation createJournalConfigForUserGroup($userGroupId: ID!, $input: JournalConfigForUserGroupInput!) {
    createJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateJournalConfigForUserGroupMutation,
        CreateJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateJournalConfigForUserGroupMutation,
          CreateJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateJournalConfigForUserGroupMutation,
    CreateJournalConfigForUserGroupMutationVariables
  >(CreateJournalConfigForUserGroupDocument, options);
}
export type CreateJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateJournalConfigForUserGroupMutation,
  CreateJournalConfigForUserGroupMutationVariables
>;
export const UpdateJournalConfigForUserGroupDocument = gql`
  mutation updateJournalConfigForUserGroup($userGroupId: ID!, $input: JournalConfigForUserGroupInput!) {
    updateJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateJournalConfigForUserGroupMutation,
        UpdateJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateJournalConfigForUserGroupMutation,
          UpdateJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateJournalConfigForUserGroupMutation,
    UpdateJournalConfigForUserGroupMutationVariables
  >(UpdateJournalConfigForUserGroupDocument, options);
}
export type UpdateJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateJournalConfigForUserGroupMutation,
  UpdateJournalConfigForUserGroupMutationVariables
>;
export const UpdateInheritedJournalConfigForUserGroupDocument = gql`
  mutation updateInheritedJournalConfigForUserGroup(
    $userGroupId: ID!
    $input: inheritedJournalConfigForUserGroupInput!
  ) {
    updateInheritedJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateInheritedJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateInheritedJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInheritedJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateInheritedJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInheritedJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateInheritedJournalConfigForUserGroupMutation,
        UpdateInheritedJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateInheritedJournalConfigForUserGroupMutation,
          UpdateInheritedJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateInheritedJournalConfigForUserGroupMutation,
    UpdateInheritedJournalConfigForUserGroupMutationVariables
  >(UpdateInheritedJournalConfigForUserGroupDocument, options);
}
export type UpdateInheritedJournalConfigForUserGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateInheritedJournalConfigForUserGroupMutation,
    UpdateInheritedJournalConfigForUserGroupMutationVariables
  >;
export const DeleteJournalConfigForUserGroupDocument = gql`
  mutation deleteJournalConfigForUserGroup($userGroupId: ID!) {
    deleteJournalConfigForUserGroup(userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteJournalConfigForUserGroupMutation,
        DeleteJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteJournalConfigForUserGroupMutation,
          DeleteJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteJournalConfigForUserGroupMutation,
    DeleteJournalConfigForUserGroupMutationVariables
  >(DeleteJournalConfigForUserGroupDocument, options);
}
export type DeleteJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteJournalConfigForUserGroupMutation,
  DeleteJournalConfigForUserGroupMutationVariables
>;
export const GetJournalConfigForUserGroupDocument = gql`
  query getJournalConfigForUserGroup($userGroupId: ID!) {
    getJournalConfigForUserGroup(userGroupId: $userGroupId) {
      vkpAccountId
      forUserGroupId
      monitoringEmailAddresses
      remotePatientMonitoring {
        enabled
        apiUrl
        journalingDisabledForPatientGroupIds
        isLabModuleEnabled
        taskCodesForJournaling
      }
      remoteSupervision {
        enabled
        apiUrl
        journalingDisabledForPatientGroupIds
      }
      read {
        enabled
        apiUrl
        features {
          hasCreatePatientFromVkp
          responseCenter {
            hasCarePlanRead
            hasEpisodesOfCareRead
            hasPatientRead
          }
        }
      }
      inheritedFromUserGroup
    }
  }
`;

/**
 * __useGetJournalConfigForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetJournalConfigForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJournalConfigForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetJournalConfigForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetJournalConfigForUserGroupQuery(
  variables:
    | GetJournalConfigForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetJournalConfigForUserGroupQueryVariables>
    | ReactiveFunction<GetJournalConfigForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>(
    GetJournalConfigForUserGroupDocument,
    variables,
    options,
  );
}
export function useGetJournalConfigForUserGroupLazyQuery(
  variables?:
    | GetJournalConfigForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetJournalConfigForUserGroupQueryVariables>
    | ReactiveFunction<GetJournalConfigForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetJournalConfigForUserGroupQuery,
    GetJournalConfigForUserGroupQueryVariables
  >(GetJournalConfigForUserGroupDocument, variables, options);
}
export type GetJournalConfigForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetJournalConfigForUserGroupQuery,
  GetJournalConfigForUserGroupQueryVariables
>;
export const GetPatientFromVkpDocument = gql`
  query getPatientFromVkp($norwegianId: String!) {
    getPatientFromVkp(norwegianId: $norwegianId) {
      success
      patient {
        name {
          given
          family
          text
        }
        birthDate
        gender
        telecom {
          value
          system
          use
        }
        address {
          use
          line
          city
          postalCode
          country
          text
        }
        externalPatientIds {
          externalHumanIdType {
            id
          }
          externalId
        }
        hasSecretAddress
      }
    }
  }
`;

/**
 * __useGetPatientFromVkpQuery__
 *
 * To run a query within a Vue component, call `useGetPatientFromVkpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientFromVkpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientFromVkpQuery({
 *   norwegianId: // value for 'norwegianId'
 * });
 */
export function useGetPatientFromVkpQuery(
  variables:
    | GetPatientFromVkpQueryVariables
    | VueCompositionApi.Ref<GetPatientFromVkpQueryVariables>
    | ReactiveFunction<GetPatientFromVkpQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>(
    GetPatientFromVkpDocument,
    variables,
    options,
  );
}
export function useGetPatientFromVkpLazyQuery(
  variables?:
    | GetPatientFromVkpQueryVariables
    | VueCompositionApi.Ref<GetPatientFromVkpQueryVariables>
    | ReactiveFunction<GetPatientFromVkpQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>(
    GetPatientFromVkpDocument,
    variables,
    options,
  );
}
export type GetPatientFromVkpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientFromVkpQuery,
  GetPatientFromVkpQueryVariables
>;
export const UpdateIpRestrictionsModalDocument = gql`
  mutation updateIPRestrictionsModal($userId: ID!, $ipRestrictions: [String]) {
    updateIPRestrictions(userId: $userId, ipRestrictions: $ipRestrictions) {
      success
      inputValidation {
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateIpRestrictionsModalMutation__
 *
 * To run a mutation, you first call `useUpdateIpRestrictionsModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIpRestrictionsModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIpRestrictionsModalMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     ipRestrictions: // value for 'ipRestrictions'
 *   },
 * });
 */
export function useUpdateIpRestrictionsModalMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateIpRestrictionsModalMutation,
        UpdateIpRestrictionsModalMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateIpRestrictionsModalMutation,
          UpdateIpRestrictionsModalMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateIpRestrictionsModalMutation, UpdateIpRestrictionsModalMutationVariables>(
    UpdateIpRestrictionsModalDocument,
    options,
  );
}
export type UpdateIpRestrictionsModalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateIpRestrictionsModalMutation,
  UpdateIpRestrictionsModalMutationVariables
>;
export const AddCameraToSetupBatchTelluSupportDocument = gql`
  mutation addCameraToSetupBatchTelluSupport($cameraSetupInput: CameraSetupInput!) {
    addCameraToSetupBatchTelluSupport(cameraSetupInput: $cameraSetupInput)
  }
`;

/**
 * __useAddCameraToSetupBatchTelluSupportMutation__
 *
 * To run a mutation, you first call `useAddCameraToSetupBatchTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCameraToSetupBatchTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCameraToSetupBatchTelluSupportMutation({
 *   variables: {
 *     cameraSetupInput: // value for 'cameraSetupInput'
 *   },
 * });
 */
export function useAddCameraToSetupBatchTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddCameraToSetupBatchTelluSupportMutation,
        AddCameraToSetupBatchTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddCameraToSetupBatchTelluSupportMutation,
          AddCameraToSetupBatchTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddCameraToSetupBatchTelluSupportMutation,
    AddCameraToSetupBatchTelluSupportMutationVariables
  >(AddCameraToSetupBatchTelluSupportDocument, options);
}
export type AddCameraToSetupBatchTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCameraToSetupBatchTelluSupportMutation,
  AddCameraToSetupBatchTelluSupportMutationVariables
>;
export const RedoCameraSetupTelluSupportDocument = gql`
  mutation redoCameraSetupTelluSupport($serial: String!) {
    redoCameraSetupTelluSupport(serial: $serial)
  }
`;

/**
 * __useRedoCameraSetupTelluSupportMutation__
 *
 * To run a mutation, you first call `useRedoCameraSetupTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRedoCameraSetupTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRedoCameraSetupTelluSupportMutation({
 *   variables: {
 *     serial: // value for 'serial'
 *   },
 * });
 */
export function useRedoCameraSetupTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RedoCameraSetupTelluSupportMutation,
        RedoCameraSetupTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RedoCameraSetupTelluSupportMutation,
          RedoCameraSetupTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RedoCameraSetupTelluSupportMutation,
    RedoCameraSetupTelluSupportMutationVariables
  >(RedoCameraSetupTelluSupportDocument, options);
}
export type RedoCameraSetupTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RedoCameraSetupTelluSupportMutation,
  RedoCameraSetupTelluSupportMutationVariables
>;
export const ResetCameraSetupTelluSupportDocument = gql`
  mutation resetCameraSetupTelluSupport($serial: String!) {
    resetCameraSetupTelluSupport(serial: $serial)
  }
`;

/**
 * __useResetCameraSetupTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetCameraSetupTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetCameraSetupTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetCameraSetupTelluSupportMutation({
 *   variables: {
 *     serial: // value for 'serial'
 *   },
 * });
 */
export function useResetCameraSetupTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetCameraSetupTelluSupportMutation,
        ResetCameraSetupTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetCameraSetupTelluSupportMutation,
          ResetCameraSetupTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetCameraSetupTelluSupportMutation,
    ResetCameraSetupTelluSupportMutationVariables
  >(ResetCameraSetupTelluSupportDocument, options);
}
export type ResetCameraSetupTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetCameraSetupTelluSupportMutation,
  ResetCameraSetupTelluSupportMutationVariables
>;
export const ResetCameraSetupBatchTelluSupportDocument = gql`
  mutation resetCameraSetupBatchTelluSupport {
    resetCameraSetupBatchTelluSupport
  }
`;

/**
 * __useResetCameraSetupBatchTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetCameraSetupBatchTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetCameraSetupBatchTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetCameraSetupBatchTelluSupportMutation();
 */
export function useResetCameraSetupBatchTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetCameraSetupBatchTelluSupportMutation,
        ResetCameraSetupBatchTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetCameraSetupBatchTelluSupportMutation,
          ResetCameraSetupBatchTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetCameraSetupBatchTelluSupportMutation,
    ResetCameraSetupBatchTelluSupportMutationVariables
  >(ResetCameraSetupBatchTelluSupportDocument, options);
}
export type ResetCameraSetupBatchTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetCameraSetupBatchTelluSupportMutation,
  ResetCameraSetupBatchTelluSupportMutationVariables
>;
export const ResetMorpheanCacheTelluSupportDocument = gql`
  mutation resetMorpheanCacheTelluSupport {
    resetMorpheanCacheTelluSupport
  }
`;

/**
 * __useResetMorpheanCacheTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetMorpheanCacheTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetMorpheanCacheTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetMorpheanCacheTelluSupportMutation();
 */
export function useResetMorpheanCacheTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetMorpheanCacheTelluSupportMutation,
        ResetMorpheanCacheTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetMorpheanCacheTelluSupportMutation,
          ResetMorpheanCacheTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetMorpheanCacheTelluSupportMutation,
    ResetMorpheanCacheTelluSupportMutationVariables
  >(ResetMorpheanCacheTelluSupportDocument, options);
}
export type ResetMorpheanCacheTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetMorpheanCacheTelluSupportMutation,
  ResetMorpheanCacheTelluSupportMutationVariables
>;
export const CameraAppBulkUpdateDocument = gql`
  mutation cameraAppBulkUpdate($cameras: [CameraManagementInput!]!, $appUpdates: [CameraAppUpdateInput!]!) {
    cameraAppBulkUpdate(cameras: $cameras, appUpdates: $appUpdates)
  }
`;

/**
 * __useCameraAppBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraAppBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraAppBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraAppBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     appUpdates: // value for 'appUpdates'
 *   },
 * });
 */
export function useCameraAppBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>(
    CameraAppBulkUpdateDocument,
    options,
  );
}
export type CameraAppBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraAppBulkUpdateMutation,
  CameraAppBulkUpdateMutationVariables
>;
export const CameraAudioSettingsBulkUpdateDocument = gql`
  mutation cameraAudioSettingsBulkUpdate($cameras: [CameraManagementInput!]!, $settings: CameraAudioSettingsInput!) {
    cameraAudioSettingsBulkUpdate(cameras: $cameras, settings: $settings)
  }
`;

/**
 * __useCameraAudioSettingsBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraAudioSettingsBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraAudioSettingsBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraAudioSettingsBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     settings: // value for 'settings'
 *   },
 * });
 */
export function useCameraAudioSettingsBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraAudioSettingsBulkUpdateMutation,
        CameraAudioSettingsBulkUpdateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraAudioSettingsBulkUpdateMutation,
          CameraAudioSettingsBulkUpdateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CameraAudioSettingsBulkUpdateMutation,
    CameraAudioSettingsBulkUpdateMutationVariables
  >(CameraAudioSettingsBulkUpdateDocument, options);
}
export type CameraAudioSettingsBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraAudioSettingsBulkUpdateMutation,
  CameraAudioSettingsBulkUpdateMutationVariables
>;
export const CameraRotationBulkUpdateDocument = gql`
  mutation cameraRotationBulkUpdate($cameras: [CameraManagementInput!]!, $settings: CameraRotationSettingsInput!) {
    cameraRotationBulkUpdate(cameras: $cameras, settings: $settings)
  }
`;

/**
 * __useCameraRotationBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraRotationBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraRotationBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraRotationBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     settings: // value for 'settings'
 *   },
 * });
 */
export function useCameraRotationBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraRotationBulkUpdateMutation,
        CameraRotationBulkUpdateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraRotationBulkUpdateMutation,
          CameraRotationBulkUpdateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CameraRotationBulkUpdateMutation, CameraRotationBulkUpdateMutationVariables>(
    CameraRotationBulkUpdateDocument,
    options,
  );
}
export type CameraRotationBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraRotationBulkUpdateMutation,
  CameraRotationBulkUpdateMutationVariables
>;
export const CameraRebootBulkUpdateDocument = gql`
  mutation cameraRebootBulkUpdate($cameras: [CameraManagementInput!]!) {
    cameraRebootBulkUpdate(cameras: $cameras)
  }
`;

/**
 * __useCameraRebootBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraRebootBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraRebootBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraRebootBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useCameraRebootBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CameraRebootBulkUpdateMutation, CameraRebootBulkUpdateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CameraRebootBulkUpdateMutation, CameraRebootBulkUpdateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CameraRebootBulkUpdateMutation, CameraRebootBulkUpdateMutationVariables>(
    CameraRebootBulkUpdateDocument,
    options,
  );
}
export type CameraRebootBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraRebootBulkUpdateMutation,
  CameraRebootBulkUpdateMutationVariables
>;
export const CameraFirmwareBulkUpgradeDocument = gql`
  mutation cameraFirmwareBulkUpgrade(
    $cameras: [CameraManagementInput!]!
    $firmwareUpgradeOptions: CameraFirmwareUpgradeInput!
  ) {
    cameraFirmwareBulkUpgrade(cameras: $cameras, firmwareUpgradeOptions: $firmwareUpgradeOptions)
  }
`;

/**
 * __useCameraFirmwareBulkUpgradeMutation__
 *
 * To run a mutation, you first call `useCameraFirmwareBulkUpgradeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraFirmwareBulkUpgradeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraFirmwareBulkUpgradeMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     firmwareUpgradeOptions: // value for 'firmwareUpgradeOptions'
 *   },
 * });
 */
export function useCameraFirmwareBulkUpgradeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraFirmwareBulkUpgradeMutation,
        CameraFirmwareBulkUpgradeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraFirmwareBulkUpgradeMutation,
          CameraFirmwareBulkUpgradeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CameraFirmwareBulkUpgradeMutation, CameraFirmwareBulkUpgradeMutationVariables>(
    CameraFirmwareBulkUpgradeDocument,
    options,
  );
}
export type CameraFirmwareBulkUpgradeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraFirmwareBulkUpgradeMutation,
  CameraFirmwareBulkUpgradeMutationVariables
>;
export const DecommissionCamerasDocument = gql`
  mutation decommissionCameras($cameras: [CameraManagementInputWithOptionalId!]!) {
    decommissionCameras(cameras: $cameras)
  }
`;

/**
 * __useDecommissionCamerasMutation__
 *
 * To run a mutation, you first call `useDecommissionCamerasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDecommissionCamerasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDecommissionCamerasMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useDecommissionCamerasMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>(
    DecommissionCamerasDocument,
    options,
  );
}
export type DecommissionCamerasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DecommissionCamerasMutation,
  DecommissionCamerasMutationVariables
>;
export const CameraNetworkingBulkUpdateDocument = gql`
  mutation cameraNetworkingBulkUpdate($cameras: [CameraManagementInput!]!) {
    cameraNetworkingBulkUpdate(cameras: $cameras)
  }
`;

/**
 * __useCameraNetworkingBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraNetworkingBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraNetworkingBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraNetworkingBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useCameraNetworkingBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraNetworkingBulkUpdateMutation,
        CameraNetworkingBulkUpdateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraNetworkingBulkUpdateMutation,
          CameraNetworkingBulkUpdateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CameraNetworkingBulkUpdateMutation,
    CameraNetworkingBulkUpdateMutationVariables
  >(CameraNetworkingBulkUpdateDocument, options);
}
export type CameraNetworkingBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraNetworkingBulkUpdateMutation,
  CameraNetworkingBulkUpdateMutationVariables
>;
export const CameraIoPortConfigurationBulkUpdateDocument = gql`
  mutation cameraIoPortConfigurationBulkUpdate(
    $cameras: [CameraManagementInput!]!
    $settings: CameraIoPortConfigurationSettingsInput!
  ) {
    cameraIoPortConfigurationBulkUpdate(cameras: $cameras, settings: $settings)
  }
`;

/**
 * __useCameraIoPortConfigurationBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraIoPortConfigurationBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraIoPortConfigurationBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraIoPortConfigurationBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     settings: // value for 'settings'
 *   },
 * });
 */
export function useCameraIoPortConfigurationBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraIoPortConfigurationBulkUpdateMutation,
        CameraIoPortConfigurationBulkUpdateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraIoPortConfigurationBulkUpdateMutation,
          CameraIoPortConfigurationBulkUpdateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CameraIoPortConfigurationBulkUpdateMutation,
    CameraIoPortConfigurationBulkUpdateMutationVariables
  >(CameraIoPortConfigurationBulkUpdateDocument, options);
}
export type CameraIoPortConfigurationBulkUpdateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CameraIoPortConfigurationBulkUpdateMutation,
    CameraIoPortConfigurationBulkUpdateMutationVariables
  >;
export const TakeCameraSnapshotWithDetectionsDocument = gql`
  mutation takeCameraSnapshotWithDetections($cameraId: ID!) {
    takeCameraSnapshotWithDetections(cameraId: $cameraId) {
      snapshotToken
      detectedObjects {
        score
        type
        boundingBox {
          ...completeBoundingBox
        }
      }
    }
  }
  ${CompleteBoundingBoxFragmentDoc}
`;

/**
 * __useTakeCameraSnapshotWithDetectionsMutation__
 *
 * To run a mutation, you first call `useTakeCameraSnapshotWithDetectionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTakeCameraSnapshotWithDetectionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTakeCameraSnapshotWithDetectionsMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useTakeCameraSnapshotWithDetectionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TakeCameraSnapshotWithDetectionsMutation,
        TakeCameraSnapshotWithDetectionsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TakeCameraSnapshotWithDetectionsMutation,
          TakeCameraSnapshotWithDetectionsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TakeCameraSnapshotWithDetectionsMutation,
    TakeCameraSnapshotWithDetectionsMutationVariables
  >(TakeCameraSnapshotWithDetectionsDocument, options);
}
export type TakeCameraSnapshotWithDetectionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TakeCameraSnapshotWithDetectionsMutation,
  TakeCameraSnapshotWithDetectionsMutationVariables
>;
export const SetReferenceObjectsForCameraDocument = gql`
  mutation setReferenceObjectsForCamera($cameraId: ID!, $referenceObjects: [ReferenceObjectInput!]!) {
    setReferenceObjectsForCamera(cameraId: $cameraId, referenceObjects: $referenceObjects) {
      referenceObjects {
        type
        sensitivity
        boundingBox {
          ...completeBoundingBox
        }
      }
    }
  }
  ${CompleteBoundingBoxFragmentDoc}
`;

/**
 * __useSetReferenceObjectsForCameraMutation__
 *
 * To run a mutation, you first call `useSetReferenceObjectsForCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetReferenceObjectsForCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetReferenceObjectsForCameraMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     referenceObjects: // value for 'referenceObjects'
 *   },
 * });
 */
export function useSetReferenceObjectsForCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetReferenceObjectsForCameraMutation,
        SetReferenceObjectsForCameraMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetReferenceObjectsForCameraMutation,
          SetReferenceObjectsForCameraMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetReferenceObjectsForCameraMutation,
    SetReferenceObjectsForCameraMutationVariables
  >(SetReferenceObjectsForCameraDocument, options);
}
export type SetReferenceObjectsForCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetReferenceObjectsForCameraMutation,
  SetReferenceObjectsForCameraMutationVariables
>;
export const UpdateFurnitureDetectionAlarmSnapshotDocument = gql`
  mutation updateFurnitureDetectionAlarmSnapshot($taskId: ID!) {
    updateFurnitureDetectionAlarmSnapshot(taskId: $taskId)
  }
`;

/**
 * __useUpdateFurnitureDetectionAlarmSnapshotMutation__
 *
 * To run a mutation, you first call `useUpdateFurnitureDetectionAlarmSnapshotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFurnitureDetectionAlarmSnapshotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFurnitureDetectionAlarmSnapshotMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useUpdateFurnitureDetectionAlarmSnapshotMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateFurnitureDetectionAlarmSnapshotMutation,
        UpdateFurnitureDetectionAlarmSnapshotMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateFurnitureDetectionAlarmSnapshotMutation,
          UpdateFurnitureDetectionAlarmSnapshotMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateFurnitureDetectionAlarmSnapshotMutation,
    UpdateFurnitureDetectionAlarmSnapshotMutationVariables
  >(UpdateFurnitureDetectionAlarmSnapshotDocument, options);
}
export type UpdateFurnitureDetectionAlarmSnapshotMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateFurnitureDetectionAlarmSnapshotMutation,
    UpdateFurnitureDetectionAlarmSnapshotMutationVariables
  >;
export const TerminateShiftSessionOnDeviceDocument = gql`
  mutation terminateShiftSessionOnDevice($device: String!) {
    terminateShiftSessionOnDevice(device: $device) {
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useTerminateShiftSessionOnDeviceMutation__
 *
 * To run a mutation, you first call `useTerminateShiftSessionOnDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTerminateShiftSessionOnDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTerminateShiftSessionOnDeviceMutation({
 *   variables: {
 *     device: // value for 'device'
 *   },
 * });
 */
export function useTerminateShiftSessionOnDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TerminateShiftSessionOnDeviceMutation,
        TerminateShiftSessionOnDeviceMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TerminateShiftSessionOnDeviceMutation,
          TerminateShiftSessionOnDeviceMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TerminateShiftSessionOnDeviceMutation,
    TerminateShiftSessionOnDeviceMutationVariables
  >(TerminateShiftSessionOnDeviceDocument, options);
}
export type TerminateShiftSessionOnDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TerminateShiftSessionOnDeviceMutation,
  TerminateShiftSessionOnDeviceMutationVariables
>;
export const TerminateShiftSessionOnAllDevicesDocument = gql`
  mutation terminateShiftSessionOnAllDevices {
    terminateShiftSessionOnAllDevices
  }
`;

/**
 * __useTerminateShiftSessionOnAllDevicesMutation__
 *
 * To run a mutation, you first call `useTerminateShiftSessionOnAllDevicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTerminateShiftSessionOnAllDevicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTerminateShiftSessionOnAllDevicesMutation();
 */
export function useTerminateShiftSessionOnAllDevicesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TerminateShiftSessionOnAllDevicesMutation,
        TerminateShiftSessionOnAllDevicesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TerminateShiftSessionOnAllDevicesMutation,
          TerminateShiftSessionOnAllDevicesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TerminateShiftSessionOnAllDevicesMutation,
    TerminateShiftSessionOnAllDevicesMutationVariables
  >(TerminateShiftSessionOnAllDevicesDocument, options);
}
export type TerminateShiftSessionOnAllDevicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TerminateShiftSessionOnAllDevicesMutation,
  TerminateShiftSessionOnAllDevicesMutationVariables
>;
export const TerminateShiftSessionOnAllDevicesForUserDocument = gql`
  mutation terminateShiftSessionOnAllDevicesForUser($userId: ID!) {
    terminateShiftSessionOnAllDevicesForUser(userId: $userId)
  }
`;

/**
 * __useTerminateShiftSessionOnAllDevicesForUserMutation__
 *
 * To run a mutation, you first call `useTerminateShiftSessionOnAllDevicesForUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTerminateShiftSessionOnAllDevicesForUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTerminateShiftSessionOnAllDevicesForUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useTerminateShiftSessionOnAllDevicesForUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TerminateShiftSessionOnAllDevicesForUserMutation,
        TerminateShiftSessionOnAllDevicesForUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TerminateShiftSessionOnAllDevicesForUserMutation,
          TerminateShiftSessionOnAllDevicesForUserMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TerminateShiftSessionOnAllDevicesForUserMutation,
    TerminateShiftSessionOnAllDevicesForUserMutationVariables
  >(TerminateShiftSessionOnAllDevicesForUserDocument, options);
}
export type TerminateShiftSessionOnAllDevicesForUserMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    TerminateShiftSessionOnAllDevicesForUserMutation,
    TerminateShiftSessionOnAllDevicesForUserMutationVariables
  >;
export const UpdateShiftSessionPhoneNumberDocument = gql`
  mutation updateShiftSessionPhoneNumber($shiftSessionPhoneNumber: String!) {
    updateShiftSessionPhoneNumber(shiftSessionPhoneNumber: $shiftSessionPhoneNumber) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateShiftSessionPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateShiftSessionPhoneNumberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftSessionPhoneNumberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShiftSessionPhoneNumberMutation({
 *   variables: {
 *     shiftSessionPhoneNumber: // value for 'shiftSessionPhoneNumber'
 *   },
 * });
 */
export function useUpdateShiftSessionPhoneNumberMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateShiftSessionPhoneNumberMutation,
        UpdateShiftSessionPhoneNumberMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateShiftSessionPhoneNumberMutation,
          UpdateShiftSessionPhoneNumberMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateShiftSessionPhoneNumberMutation,
    UpdateShiftSessionPhoneNumberMutationVariables
  >(UpdateShiftSessionPhoneNumberDocument, options);
}
export type UpdateShiftSessionPhoneNumberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateShiftSessionPhoneNumberMutation,
  UpdateShiftSessionPhoneNumberMutationVariables
>;
export const TakeCallDocument = gql`
  mutation takeCall($taskId: ID!, $takeCallInput: TakeCallInput) {
    takeCall(taskId: $taskId, takeCallInput: $takeCallInput) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useTakeCallMutation__
 *
 * To run a mutation, you first call `useTakeCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTakeCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTakeCallMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     takeCallInput: // value for 'takeCallInput'
 *   },
 * });
 */
export function useTakeCallMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TakeCallMutation, TakeCallMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<TakeCallMutation, TakeCallMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<TakeCallMutation, TakeCallMutationVariables>(TakeCallDocument, options);
}
export type TakeCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TakeCallMutation,
  TakeCallMutationVariables
>;
export const UpdateAccountSettingsDocument = gql`
  mutation updateAccountSettings($input: UpdateAccountSettingsInput!) {
    updateAccountSettings(input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      accountSettings {
        ...AccountDetails
        userSessionLifespan
      }
    }
  }
  ${AccountDetailsFragmentDoc}
`;

/**
 * __useUpdateAccountSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSettingsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>(
    UpdateAccountSettingsDocument,
    options,
  );
}
export type UpdateAccountSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAccountSettingsMutation,
  UpdateAccountSettingsMutationVariables
>;
export const EnableApplicationDocument = gql`
  mutation enableApplication($application: Application!) {
    enableApplication(application: $application) {
      success
      message
      isEnabled
      applications {
        ...AccountProductApplications
      }
    }
  }
  ${AccountProductApplicationsFragmentDoc}
`;

/**
 * __useEnableApplicationMutation__
 *
 * To run a mutation, you first call `useEnableApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableApplicationMutation({
 *   variables: {
 *     application: // value for 'application'
 *   },
 * });
 */
export function useEnableApplicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableApplicationMutation, EnableApplicationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableApplicationMutation, EnableApplicationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableApplicationMutation, EnableApplicationMutationVariables>(
    EnableApplicationDocument,
    options,
  );
}
export type EnableApplicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableApplicationMutation,
  EnableApplicationMutationVariables
>;
export const DisableApplicationDocument = gql`
  mutation disableApplication($application: Application!) {
    disableApplication(application: $application) {
      success
      message
      isEnabled
      applications {
        ...AccountProductApplications
      }
    }
  }
  ${AccountProductApplicationsFragmentDoc}
`;

/**
 * __useDisableApplicationMutation__
 *
 * To run a mutation, you first call `useDisableApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableApplicationMutation({
 *   variables: {
 *     application: // value for 'application'
 *   },
 * });
 */
export function useDisableApplicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableApplicationMutation, DisableApplicationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableApplicationMutation, DisableApplicationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableApplicationMutation, DisableApplicationMutationVariables>(
    DisableApplicationDocument,
    options,
  );
}
export type DisableApplicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableApplicationMutation,
  DisableApplicationMutationVariables
>;
export const EnableFeatureFlagDocument = gql`
  mutation enableFeatureFlag($flag: FeatureFlag!) {
    enableFeatureFlag(flag: $flag) {
      success
      message
      isEnabled
      features {
        ...AccountProductFeatures
        ...AccountSecurityFeatures
      }
    }
  }
  ${AccountProductFeaturesFragmentDoc}
  ${AccountSecurityFeaturesFragmentDoc}
`;

/**
 * __useEnableFeatureFlagMutation__
 *
 * To run a mutation, you first call `useEnableFeatureFlagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableFeatureFlagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableFeatureFlagMutation({
 *   variables: {
 *     flag: // value for 'flag'
 *   },
 * });
 */
export function useEnableFeatureFlagMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableFeatureFlagMutation, EnableFeatureFlagMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableFeatureFlagMutation, EnableFeatureFlagMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableFeatureFlagMutation, EnableFeatureFlagMutationVariables>(
    EnableFeatureFlagDocument,
    options,
  );
}
export type EnableFeatureFlagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableFeatureFlagMutation,
  EnableFeatureFlagMutationVariables
>;
export const DisableFeatureFlagDocument = gql`
  mutation disableFeatureFlag($flag: FeatureFlag!) {
    disableFeatureFlag(flag: $flag) {
      success
      message
      isEnabled
      blockingCameraProfiles {
        id
        name
        template
      }
      features {
        ...AccountProductFeatures
        ...AccountSecurityFeatures
      }
    }
  }
  ${AccountProductFeaturesFragmentDoc}
  ${AccountSecurityFeaturesFragmentDoc}
`;

/**
 * __useDisableFeatureFlagMutation__
 *
 * To run a mutation, you first call `useDisableFeatureFlagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableFeatureFlagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableFeatureFlagMutation({
 *   variables: {
 *     flag: // value for 'flag'
 *   },
 * });
 */
export function useDisableFeatureFlagMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableFeatureFlagMutation, DisableFeatureFlagMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableFeatureFlagMutation, DisableFeatureFlagMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableFeatureFlagMutation, DisableFeatureFlagMutationVariables>(
    DisableFeatureFlagDocument,
    options,
  );
}
export type DisableFeatureFlagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableFeatureFlagMutation,
  DisableFeatureFlagMutationVariables
>;
export const EnableUserAuthSettingDocument = gql`
  mutation enableUserAuthSetting($setting: UserAuthSetting!) {
    enableUserAuthSetting(setting: $setting) {
      success
      message
      isEnabled
      userAuth {
        ...AccountUserAuth
      }
    }
  }
  ${AccountUserAuthFragmentDoc}
`;

/**
 * __useEnableUserAuthSettingMutation__
 *
 * To run a mutation, you first call `useEnableUserAuthSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserAuthSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableUserAuthSettingMutation({
 *   variables: {
 *     setting: // value for 'setting'
 *   },
 * });
 */
export function useEnableUserAuthSettingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableUserAuthSettingMutation, EnableUserAuthSettingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableUserAuthSettingMutation, EnableUserAuthSettingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableUserAuthSettingMutation, EnableUserAuthSettingMutationVariables>(
    EnableUserAuthSettingDocument,
    options,
  );
}
export type EnableUserAuthSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableUserAuthSettingMutation,
  EnableUserAuthSettingMutationVariables
>;
export const DisableUserAuthSettingDocument = gql`
  mutation disableUserAuthSetting($setting: UserAuthSetting!) {
    disableUserAuthSetting(setting: $setting) {
      success
      message
      isEnabled
      userAuth {
        ...AccountUserAuth
      }
    }
  }
  ${AccountUserAuthFragmentDoc}
`;

/**
 * __useDisableUserAuthSettingMutation__
 *
 * To run a mutation, you first call `useDisableUserAuthSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserAuthSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableUserAuthSettingMutation({
 *   variables: {
 *     setting: // value for 'setting'
 *   },
 * });
 */
export function useDisableUserAuthSettingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableUserAuthSettingMutation, DisableUserAuthSettingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableUserAuthSettingMutation, DisableUserAuthSettingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableUserAuthSettingMutation, DisableUserAuthSettingMutationVariables>(
    DisableUserAuthSettingDocument,
    options,
  );
}
export type DisableUserAuthSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableUserAuthSettingMutation,
  DisableUserAuthSettingMutationVariables
>;
export const ActivateAzureProvisioningDocument = gql`
  mutation activateAzureProvisioning($azureAccountId: ID!) {
    activateAzureProvisioning(azureAccountId: $azureAccountId) {
      success
      message
      azureProvisioningCredentials {
        tenantUrl
        secretToken
      }
    }
  }
`;

/**
 * __useActivateAzureProvisioningMutation__
 *
 * To run a mutation, you first call `useActivateAzureProvisioningMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateAzureProvisioningMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateAzureProvisioningMutation({
 *   variables: {
 *     azureAccountId: // value for 'azureAccountId'
 *   },
 * });
 */
export function useActivateAzureProvisioningMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateAzureProvisioningMutation,
        ActivateAzureProvisioningMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateAzureProvisioningMutation,
          ActivateAzureProvisioningMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateAzureProvisioningMutation, ActivateAzureProvisioningMutationVariables>(
    ActivateAzureProvisioningDocument,
    options,
  );
}
export type ActivateAzureProvisioningMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateAzureProvisioningMutation,
  ActivateAzureProvisioningMutationVariables
>;
export const AddExternalIdPDocument = gql`
  mutation addExternalIdP($userId: ID!, $idP: String!) {
    addExternalIdP(userId: $userId, idP: $idP)
  }
`;

/**
 * __useAddExternalIdPMutation__
 *
 * To run a mutation, you first call `useAddExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalIdPMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     idP: // value for 'idP'
 *   },
 * });
 */
export function useAddExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddExternalIdPMutation, AddExternalIdPMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddExternalIdPMutation, AddExternalIdPMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddExternalIdPMutation, AddExternalIdPMutationVariables>(
    AddExternalIdPDocument,
    options,
  );
}
export type AddExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalIdPMutation,
  AddExternalIdPMutationVariables
>;
export const AddMqttDeviceToPatientDocument = gql`
  mutation addMqttDeviceToPatient($patientId: ID!, $mqttDeviceId: ID!) {
    addMqttDeviceToPatient(patientId: $patientId, mqttDeviceId: $mqttDeviceId) {
      success
    }
  }
`;

/**
 * __useAddMqttDeviceToPatientMutation__
 *
 * To run a mutation, you first call `useAddMqttDeviceToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMqttDeviceToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMqttDeviceToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     mqttDeviceId: // value for 'mqttDeviceId'
 *   },
 * });
 */
export function useAddMqttDeviceToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddMqttDeviceToPatientMutation, AddMqttDeviceToPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddMqttDeviceToPatientMutation, AddMqttDeviceToPatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddMqttDeviceToPatientMutation, AddMqttDeviceToPatientMutationVariables>(
    AddMqttDeviceToPatientDocument,
    options,
  );
}
export type AddMqttDeviceToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddMqttDeviceToPatientMutation,
  AddMqttDeviceToPatientMutationVariables
>;
export const AddWelfareDeviceToPatientDocument = gql`
  mutation addWelfareDeviceToPatient($patientId: ID!, $welfareDeviceId: ID!) {
    addWelfareDeviceToPatient(patientId: $patientId, welfareDeviceId: $welfareDeviceId) {
      success
    }
  }
`;

/**
 * __useAddWelfareDeviceToPatientMutation__
 *
 * To run a mutation, you first call `useAddWelfareDeviceToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddWelfareDeviceToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddWelfareDeviceToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     welfareDeviceId: // value for 'welfareDeviceId'
 *   },
 * });
 */
export function useAddWelfareDeviceToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddWelfareDeviceToPatientMutation,
        AddWelfareDeviceToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddWelfareDeviceToPatientMutation,
          AddWelfareDeviceToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddWelfareDeviceToPatientMutation, AddWelfareDeviceToPatientMutationVariables>(
    AddWelfareDeviceToPatientDocument,
    options,
  );
}
export type AddWelfareDeviceToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddWelfareDeviceToPatientMutation,
  AddWelfareDeviceToPatientMutationVariables
>;
export const RemoveWelfareDeviceFromPatientDocument = gql`
  mutation removeWelfareDeviceFromPatient($patientId: ID!, $welfareDeviceId: ID!) {
    removeWelfareDeviceFromPatient(patientId: $patientId, welfareDeviceId: $welfareDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRemoveWelfareDeviceFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveWelfareDeviceFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWelfareDeviceFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveWelfareDeviceFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     welfareDeviceId: // value for 'welfareDeviceId'
 *   },
 * });
 */
export function useRemoveWelfareDeviceFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveWelfareDeviceFromPatientMutation,
        RemoveWelfareDeviceFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveWelfareDeviceFromPatientMutation,
          RemoveWelfareDeviceFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveWelfareDeviceFromPatientMutation,
    RemoveWelfareDeviceFromPatientMutationVariables
  >(RemoveWelfareDeviceFromPatientDocument, options);
}
export type RemoveWelfareDeviceFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveWelfareDeviceFromPatientMutation,
  RemoveWelfareDeviceFromPatientMutationVariables
>;
export const StartAudioStreamDocument = gql`
  mutation startAudioStream($cameraId: ID!) {
    stream: startAudioStream(cameraId: $cameraId) {
      id
      url
      type
      expires
      ttl
    }
  }
`;

/**
 * __useStartAudioStreamMutation__
 *
 * To run a mutation, you first call `useStartAudioStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartAudioStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartAudioStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useStartAudioStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartAudioStreamMutation, StartAudioStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartAudioStreamMutation, StartAudioStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartAudioStreamMutation, StartAudioStreamMutationVariables>(
    StartAudioStreamDocument,
    options,
  );
}
export type StartAudioStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartAudioStreamMutation,
  StartAudioStreamMutationVariables
>;
export const StopAudioStreamDocument = gql`
  mutation stopAudioStream($cameraId: ID!, $streamId: ID!) {
    stream: stopAudioStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopAudioStreamMutation__
 *
 * To run a mutation, you first call `useStopAudioStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopAudioStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopAudioStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopAudioStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopAudioStreamMutation, StopAudioStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StopAudioStreamMutation, StopAudioStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StopAudioStreamMutation, StopAudioStreamMutationVariables>(
    StopAudioStreamDocument,
    options,
  );
}
export type StopAudioStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopAudioStreamMutation,
  StopAudioStreamMutationVariables
>;
export const KeepAudioStreamAliveDocument = gql`
  mutation keepAudioStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepAudioStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
    }
  }
`;

/**
 * __useKeepAudioStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepAudioStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepAudioStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepAudioStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepAudioStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<KeepAudioStreamAliveMutation, KeepAudioStreamAliveMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<KeepAudioStreamAliveMutation, KeepAudioStreamAliveMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<KeepAudioStreamAliveMutation, KeepAudioStreamAliveMutationVariables>(
    KeepAudioStreamAliveDocument,
    options,
  );
}
export type KeepAudioStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepAudioStreamAliveMutation,
  KeepAudioStreamAliveMutationVariables
>;
export const StartBoundingBoxStreamDocument = gql`
  mutation startBoundingBoxStream($cameraId: ID!, $streamId: ID) {
    stream: startBoundingBoxStream(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useStartBoundingBoxStreamMutation__
 *
 * To run a mutation, you first call `useStartBoundingBoxStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartBoundingBoxStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartBoundingBoxStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStartBoundingBoxStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartBoundingBoxStreamMutation, StartBoundingBoxStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartBoundingBoxStreamMutation, StartBoundingBoxStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartBoundingBoxStreamMutation, StartBoundingBoxStreamMutationVariables>(
    StartBoundingBoxStreamDocument,
    options,
  );
}
export type StartBoundingBoxStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartBoundingBoxStreamMutation,
  StartBoundingBoxStreamMutationVariables
>;
export const StopBoundingBoxStreamDocument = gql`
  mutation stopBoundingBoxStream($cameraId: ID!, $streamId: ID!) {
    stream: stopBoundingBoxStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopBoundingBoxStreamMutation__
 *
 * To run a mutation, you first call `useStopBoundingBoxStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopBoundingBoxStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopBoundingBoxStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopBoundingBoxStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopBoundingBoxStreamMutation, StopBoundingBoxStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StopBoundingBoxStreamMutation, StopBoundingBoxStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StopBoundingBoxStreamMutation, StopBoundingBoxStreamMutationVariables>(
    StopBoundingBoxStreamDocument,
    options,
  );
}
export type StopBoundingBoxStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopBoundingBoxStreamMutation,
  StopBoundingBoxStreamMutationVariables
>;
export const KeepBoundingBoxStreamAliveDocument = gql`
  mutation keepBoundingBoxStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepBoundingBoxStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useKeepBoundingBoxStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepBoundingBoxStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepBoundingBoxStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepBoundingBoxStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepBoundingBoxStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        KeepBoundingBoxStreamAliveMutation,
        KeepBoundingBoxStreamAliveMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          KeepBoundingBoxStreamAliveMutation,
          KeepBoundingBoxStreamAliveMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    KeepBoundingBoxStreamAliveMutation,
    KeepBoundingBoxStreamAliveMutationVariables
  >(KeepBoundingBoxStreamAliveDocument, options);
}
export type KeepBoundingBoxStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepBoundingBoxStreamAliveMutation,
  KeepBoundingBoxStreamAliveMutationVariables
>;
export const ConfigureCameraEventsDocument = gql`
  mutation configureCameraEvents($cameraId: ID!) {
    configureCameraEvents(cameraId: $cameraId) {
      success
    }
  }
`;

/**
 * __useConfigureCameraEventsMutation__
 *
 * To run a mutation, you first call `useConfigureCameraEventsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigureCameraEventsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigureCameraEventsMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useConfigureCameraEventsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>(
    ConfigureCameraEventsDocument,
    options,
  );
}
export type ConfigureCameraEventsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ConfigureCameraEventsMutation,
  ConfigureCameraEventsMutationVariables
>;
export const StartAppDocument = gql`
  mutation startApp($cameraId: ID!, $appId: String!) {
    startApp(cameraId: $cameraId, appId: $appId)
  }
`;

/**
 * __useStartAppMutation__
 *
 * To run a mutation, you first call `useStartAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartAppMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     appId: // value for 'appId'
 *   },
 * });
 */
export function useStartAppMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartAppMutation, StartAppMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartAppMutation, StartAppMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StartAppMutation, StartAppMutationVariables>(StartAppDocument, options);
}
export type StartAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartAppMutation,
  StartAppMutationVariables
>;
export const StopAppDocument = gql`
  mutation stopApp($cameraId: ID!, $appId: String!) {
    stopApp(cameraId: $cameraId, appId: $appId)
  }
`;

/**
 * __useStopAppMutation__
 *
 * To run a mutation, you first call `useStopAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopAppMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     appId: // value for 'appId'
 *   },
 * });
 */
export function useStopAppMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopAppMutation, StopAppMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopAppMutation, StopAppMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StopAppMutation, StopAppMutationVariables>(StopAppDocument, options);
}
export type StopAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopAppMutation,
  StopAppMutationVariables
>;
export const RebootDocument = gql`
  mutation reboot($cameraId: ID!) {
    reboot(cameraId: $cameraId)
  }
`;

/**
 * __useRebootMutation__
 *
 * To run a mutation, you first call `useRebootMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRebootMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRebootMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useRebootMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RebootMutation, RebootMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<RebootMutation, RebootMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<RebootMutation, RebootMutationVariables>(RebootDocument, options);
}
export type RebootMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RebootMutation,
  RebootMutationVariables
>;
export const SetCameraLandmarksDocument = gql`
  mutation setCameraLandmarks($cameraId: ID!, $input: CameraLandmarksInput!) {
    setCameraLandmarks(cameraId: $cameraId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      configuration {
        zones {
          ...cameraZonesResult
        }
      }
    }
  }
  ${CameraZonesResultFragmentDoc}
`;

/**
 * __useSetCameraLandmarksMutation__
 *
 * To run a mutation, you first call `useSetCameraLandmarksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraLandmarksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraLandmarksMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetCameraLandmarksMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraLandmarksMutation, SetCameraLandmarksMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetCameraLandmarksMutation, SetCameraLandmarksMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraLandmarksMutation, SetCameraLandmarksMutationVariables>(
    SetCameraLandmarksDocument,
    options,
  );
}
export type SetCameraLandmarksMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraLandmarksMutation,
  SetCameraLandmarksMutationVariables
>;
export const SetCameraDetectionSettingsDocument = gql`
  mutation setCameraDetectionSettings($cameraId: ID!, $input: CameraDetectionSettingsInput!) {
    setCameraDetectionSettings(cameraId: $cameraId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      configuration {
        detectionSettings {
          ...cameraDetectionSettingsResult
        }
        zones {
          ...cameraZonesResult
        }
      }
    }
  }
  ${CameraDetectionSettingsResultFragmentDoc}
  ${CameraZonesResultFragmentDoc}
`;

/**
 * __useSetCameraDetectionSettingsMutation__
 *
 * To run a mutation, you first call `useSetCameraDetectionSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraDetectionSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraDetectionSettingsMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetCameraDetectionSettingsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetCameraDetectionSettingsMutation,
        SetCameraDetectionSettingsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetCameraDetectionSettingsMutation,
          SetCameraDetectionSettingsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetCameraDetectionSettingsMutation,
    SetCameraDetectionSettingsMutationVariables
  >(SetCameraDetectionSettingsDocument, options);
}
export type SetCameraDetectionSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraDetectionSettingsMutation,
  SetCameraDetectionSettingsMutationVariables
>;
export const CreateCameraProfileDocument = gql`
  mutation createCameraProfile($input: CameraProfileInput!) {
    createCameraProfile(input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      cameraProfile {
        ...CameraProfileFields
      }
    }
  }
  ${CameraProfileFieldsFragmentDoc}
`;

/**
 * __useCreateCameraProfileMutation__
 *
 * To run a mutation, you first call `useCreateCameraProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCameraProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraProfileMutation, CreateCameraProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraProfileMutation, CreateCameraProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraProfileMutation, CreateCameraProfileMutationVariables>(
    CreateCameraProfileDocument,
    options,
  );
}
export type CreateCameraProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraProfileMutation,
  CreateCameraProfileMutationVariables
>;
export const UpdateCameraProfileDocument = gql`
  mutation updateCameraProfile($id: ID!, $input: CameraProfileInput!) {
    updateCameraProfile(id: $id, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      cameraProfile {
        ...CameraProfileFields
      }
    }
  }
  ${CameraProfileFieldsFragmentDoc}
`;

/**
 * __useUpdateCameraProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCameraProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCameraProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraProfileMutation, UpdateCameraProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCameraProfileMutation, UpdateCameraProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraProfileMutation, UpdateCameraProfileMutationVariables>(
    UpdateCameraProfileDocument,
    options,
  );
}
export type UpdateCameraProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraProfileMutation,
  UpdateCameraProfileMutationVariables
>;
export const DeleteCameraProfileDocument = gql`
  mutation deleteCameraProfile($id: ID!, $replacementCameraProfileId: ID) {
    deleteCameraProfile(id: $id, replacementCameraProfileId: $replacementCameraProfileId) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useDeleteCameraProfileMutation__
 *
 * To run a mutation, you first call `useDeleteCameraProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCameraProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *     replacementCameraProfileId: // value for 'replacementCameraProfileId'
 *   },
 * });
 */
export function useDeleteCameraProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCameraProfileMutation, DeleteCameraProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCameraProfileMutation, DeleteCameraProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCameraProfileMutation, DeleteCameraProfileMutationVariables>(
    DeleteCameraProfileDocument,
    options,
  );
}
export type DeleteCameraProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCameraProfileMutation,
  DeleteCameraProfileMutationVariables
>;
export const SetDefaultCameraProfileDocument = gql`
  mutation setDefaultCameraProfile($id: ID!) {
    setDefaultCameraProfile(id: $id) {
      success
      message
      cameraProfile {
        id
        isDefault
      }
    }
  }
`;

/**
 * __useSetDefaultCameraProfileMutation__
 *
 * To run a mutation, you first call `useSetDefaultCameraProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCameraProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDefaultCameraProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultCameraProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetDefaultCameraProfileMutation, SetDefaultCameraProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetDefaultCameraProfileMutation,
          SetDefaultCameraProfileMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetDefaultCameraProfileMutation, SetDefaultCameraProfileMutationVariables>(
    SetDefaultCameraProfileDocument,
    options,
  );
}
export type SetDefaultCameraProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetDefaultCameraProfileMutation,
  SetDefaultCameraProfileMutationVariables
>;
export const SetCameraProfileDocument = gql`
  mutation setCameraProfile($cameraIds: [ID!]!, $cameraProfileId: ID!) {
    setCameraProfile(cameraIds: $cameraIds, cameraProfileId: $cameraProfileId) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useSetCameraProfileMutation__
 *
 * To run a mutation, you first call `useSetCameraProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraProfileMutation({
 *   variables: {
 *     cameraIds: // value for 'cameraIds'
 *     cameraProfileId: // value for 'cameraProfileId'
 *   },
 * });
 */
export function useSetCameraProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraProfileMutation, SetCameraProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetCameraProfileMutation, SetCameraProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraProfileMutation, SetCameraProfileMutationVariables>(
    SetCameraProfileDocument,
    options,
  );
}
export type SetCameraProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraProfileMutation,
  SetCameraProfileMutationVariables
>;
export const UpdateCameraSettingsDocument = gql`
  mutation updateCameraSettings($cameraId: ID!, $input: CameraSettingsInput!) {
    updateCameraSettings(cameraId: $cameraId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      settings {
        soundThreshold
      }
    }
  }
`;

/**
 * __useUpdateCameraSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCameraSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraSettingsMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCameraSettingsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraSettingsMutation, UpdateCameraSettingsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCameraSettingsMutation, UpdateCameraSettingsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraSettingsMutation, UpdateCameraSettingsMutationVariables>(
    UpdateCameraSettingsDocument,
    options,
  );
}
export type UpdateCameraSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraSettingsMutation,
  UpdateCameraSettingsMutationVariables
>;
export const CameraConfigureTwoWayAudioDocument = gql`
  mutation cameraConfigureTwoWayAudio($cameras: [CameraManagementInput!]!, $revert: Boolean) {
    cameraConfigureTwoWayAudio(cameras: $cameras, revert: $revert)
  }
`;

/**
 * __useCameraConfigureTwoWayAudioMutation__
 *
 * To run a mutation, you first call `useCameraConfigureTwoWayAudioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraConfigureTwoWayAudioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraConfigureTwoWayAudioMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     revert: // value for 'revert'
 *   },
 * });
 */
export function useCameraConfigureTwoWayAudioMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraConfigureTwoWayAudioMutation,
        CameraConfigureTwoWayAudioMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraConfigureTwoWayAudioMutation,
          CameraConfigureTwoWayAudioMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CameraConfigureTwoWayAudioMutation,
    CameraConfigureTwoWayAudioMutationVariables
  >(CameraConfigureTwoWayAudioDocument, options);
}
export type CameraConfigureTwoWayAudioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraConfigureTwoWayAudioMutation,
  CameraConfigureTwoWayAudioMutationVariables
>;
export const CreateAzureAccountDocument = gql`
  mutation createAzureAccount($input: ExternalIdentityProviderAzureForHealthProviderCreateInput!) {
    createAzureAccount(input: $input) {
      success
      message
      azureAccount {
        id
      }
    }
  }
`;

/**
 * __useCreateAzureAccountMutation__
 *
 * To run a mutation, you first call `useCreateAzureAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAzureAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAzureAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAzureAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAzureAccountMutation, CreateAzureAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAzureAccountMutation, CreateAzureAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAzureAccountMutation, CreateAzureAccountMutationVariables>(
    CreateAzureAccountDocument,
    options,
  );
}
export type CreateAzureAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAzureAccountMutation,
  CreateAzureAccountMutationVariables
>;
export const CreateCameraDocument = gql`
  mutation createCamera($createInput: CreateCameraInput!) {
    createCamera(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateCameraMutation__
 *
 * To run a mutation, you first call `useCreateCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraMutation, CreateCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraMutation, CreateCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraMutation, CreateCameraMutationVariables>(
    CreateCameraDocument,
    options,
  );
}
export type CreateCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraMutation,
  CreateCameraMutationVariables
>;
export const CreateMqttDeviceDocument = gql`
  mutation createMqttDevice($createInput: MqttDeviceCreateInput!) {
    createMqttDevice(createInput: $createInput) {
      success
      message
      mqttDevice {
        id
        name
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateMqttDeviceMutation__
 *
 * To run a mutation, you first call `useCreateMqttDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMqttDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMqttDeviceMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateMqttDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateMqttDeviceMutation, CreateMqttDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateMqttDeviceMutation, CreateMqttDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateMqttDeviceMutation, CreateMqttDeviceMutationVariables>(
    CreateMqttDeviceDocument,
    options,
  );
}
export type CreateMqttDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateMqttDeviceMutation,
  CreateMqttDeviceMutationVariables
>;
export const CreateTemplateVkpCodesDocument = gql`
  mutation createTemplateVkpCodes($templateId: ID!, $input: TemplateVkpCodesInput!) {
    createTemplateVkpCodes(templateId: $templateId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateTemplateVkpCodesMutation__
 *
 * To run a mutation, you first call `useCreateTemplateVkpCodesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateVkpCodesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTemplateVkpCodesMutation({
 *   variables: {
 *     templateId: // value for 'templateId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateVkpCodesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateTemplateVkpCodesMutation, CreateTemplateVkpCodesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateTemplateVkpCodesMutation, CreateTemplateVkpCodesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateTemplateVkpCodesMutation, CreateTemplateVkpCodesMutationVariables>(
    CreateTemplateVkpCodesDocument,
    options,
  );
}
export type CreateTemplateVkpCodesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateTemplateVkpCodesMutation,
  CreateTemplateVkpCodesMutationVariables
>;
export const CreateWelfareDeviceDocument = gql`
  mutation createWelfareDevice($createInput: WelfareDeviceCreateInput!) {
    createWelfareDevice(createInput: $createInput) {
      success
      message
      welfareDevice {
        id
        uniqueIdentifier
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useCreateWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWelfareDeviceMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>(
    CreateWelfareDeviceDocument,
    options,
  );
}
export type CreateWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateWelfareDeviceMutation,
  CreateWelfareDeviceMutationVariables
>;
export const DeleteExternalIdPDocument = gql`
  mutation deleteExternalIdP($userId: ID!, $idP: String!) {
    deleteExternalIdP(userId: $userId, idP: $idP)
  }
`;

/**
 * __useDeleteExternalIdPMutation__
 *
 * To run a mutation, you first call `useDeleteExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExternalIdPMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     idP: // value for 'idP'
 *   },
 * });
 */
export function useDeleteExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteExternalIdPMutation, DeleteExternalIdPMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteExternalIdPMutation, DeleteExternalIdPMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteExternalIdPMutation, DeleteExternalIdPMutationVariables>(
    DeleteExternalIdPDocument,
    options,
  );
}
export type DeleteExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteExternalIdPMutation,
  DeleteExternalIdPMutationVariables
>;
export const DeleteMqttDeviceDocument = gql`
  mutation deleteMqttDevice($id: ID!) {
    deleteMqttDevice(id: $id) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
    }
  }
`;

/**
 * __useDeleteMqttDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteMqttDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMqttDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMqttDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMqttDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteMqttDeviceMutation, DeleteMqttDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteMqttDeviceMutation, DeleteMqttDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteMqttDeviceMutation, DeleteMqttDeviceMutationVariables>(
    DeleteMqttDeviceDocument,
    options,
  );
}
export type DeleteMqttDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteMqttDeviceMutation,
  DeleteMqttDeviceMutationVariables
>;
export const DeleteObservationTemplateDocument = gql`
  mutation deleteObservationTemplate($id: ID!) {
    deleteObservationTemplate(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteObservationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteObservationTemplateMutation,
        DeleteObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteObservationTemplateMutation,
          DeleteObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteObservationTemplateMutation, DeleteObservationTemplateMutationVariables>(
    DeleteObservationTemplateDocument,
    options,
  );
}
export type DeleteObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteObservationTemplateMutation,
  DeleteObservationTemplateMutationVariables
>;
export const DeletePatientDocument = gql`
  mutation deletePatient($patientId: ID!) {
    deletePatient(patientId: $patientId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDeletePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(
    DeletePatientDocument,
    options,
  );
}
export type DeletePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeletePatientMutation,
  DeletePatientMutationVariables
>;
export const DeleteWelfareDeviceDocument = gql`
  mutation deleteWelfareDevice($id: ID!) {
    deleteWelfareDevice(id: $id) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
    }
  }
`;

/**
 * __useDeleteWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWelfareDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>(
    DeleteWelfareDeviceDocument,
    options,
  );
}
export type DeleteWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteWelfareDeviceMutation,
  DeleteWelfareDeviceMutationVariables
>;
export const CreateDeviceGroupDocument = gql`
  mutation createDeviceGroup($createInput: DeviceGroupCreateInput!, $userGroupId: ID!) {
    createDeviceGroup(userGroupId: $userGroupId, createInput: $createInput) {
      success
      message
      deviceGroup {
        id
      }
    }
  }
`;

/**
 * __useCreateDeviceGroupMutation__
 *
 * To run a mutation, you first call `useCreateDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDeviceGroupMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreateDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>(
    CreateDeviceGroupDocument,
    options,
  );
}
export type CreateDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDeviceGroupMutation,
  CreateDeviceGroupMutationVariables
>;
export const UpdateDeviceGroupDocument = gql`
  mutation updateDeviceGroup($deviceGroupId: ID!, $deviceGroup: DeviceGroupUpdateInput!) {
    updateDeviceGroup(id: $deviceGroupId, updateInput: $deviceGroup) {
      success
      message
      deviceGroup {
        id
      }
    }
  }
`;

/**
 * __useUpdateDeviceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDeviceGroupMutation({
 *   variables: {
 *     deviceGroupId: // value for 'deviceGroupId'
 *     deviceGroup: // value for 'deviceGroup'
 *   },
 * });
 */
export function useUpdateDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>(
    UpdateDeviceGroupDocument,
    options,
  );
}
export type UpdateDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDeviceGroupMutation,
  UpdateDeviceGroupMutationVariables
>;
export const UpdateDeviceGroupCmpDocument = gql`
  mutation updateDeviceGroupCmp($deviceGroupId: ID!, $cmpCredentials: CmpCredentialsInput!) {
    updateDeviceGroupCmp(deviceGroupId: $deviceGroupId, cmpCredentials: $cmpCredentials) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDeviceGroupCmpMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceGroupCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceGroupCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDeviceGroupCmpMutation({
 *   variables: {
 *     deviceGroupId: // value for 'deviceGroupId'
 *     cmpCredentials: // value for 'cmpCredentials'
 *   },
 * });
 */
export function useUpdateDeviceGroupCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDeviceGroupCmpMutation, UpdateDeviceGroupCmpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDeviceGroupCmpMutation, UpdateDeviceGroupCmpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDeviceGroupCmpMutation, UpdateDeviceGroupCmpMutationVariables>(
    UpdateDeviceGroupCmpDocument,
    options,
  );
}
export type UpdateDeviceGroupCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDeviceGroupCmpMutation,
  UpdateDeviceGroupCmpMutationVariables
>;
export const DeleteDeviceGroupDocument = gql`
  mutation deleteDeviceGroup($deviceGroupId: ID!) {
    deleteDeviceGroup(deviceGroupId: $deviceGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDeviceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDeviceGroupMutation({
 *   variables: {
 *     deviceGroupId: // value for 'deviceGroupId'
 *   },
 * });
 */
export function useDeleteDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>(
    DeleteDeviceGroupDocument,
    options,
  );
}
export type DeleteDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDeviceGroupMutation,
  DeleteDeviceGroupMutationVariables
>;
export const GetDevicesByGroupDocument = gql`
  query getDevicesByGroup($deviceGroupId: ID!) {
    getDevicesByGroup(deviceGroupId: $deviceGroupId) {
      id
      deviceName {
        name
        type
      }
      modelNumber
      manufacturer
      patientId
      registeredInInventory
      childDeviceIds
    }
  }
`;

/**
 * __useGetDevicesByGroupQuery__
 *
 * To run a query within a Vue component, call `useGetDevicesByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesByGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDevicesByGroupQuery({
 *   deviceGroupId: // value for 'deviceGroupId'
 * });
 */
export function useGetDevicesByGroupQuery(
  variables:
    | GetDevicesByGroupQueryVariables
    | VueCompositionApi.Ref<GetDevicesByGroupQueryVariables>
    | ReactiveFunction<GetDevicesByGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>(
    GetDevicesByGroupDocument,
    variables,
    options,
  );
}
export function useGetDevicesByGroupLazyQuery(
  variables?:
    | GetDevicesByGroupQueryVariables
    | VueCompositionApi.Ref<GetDevicesByGroupQueryVariables>
    | ReactiveFunction<GetDevicesByGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>(
    GetDevicesByGroupDocument,
    variables,
    options,
  );
}
export type GetDevicesByGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDevicesByGroupQuery,
  GetDevicesByGroupQueryVariables
>;
export const SetCameraViewWithPresetDocument = gql`
  mutation setCameraViewWithPreset($cameraId: ID!, $preset: String!) {
    setCameraViewWithPreset(cameraId: $cameraId, name: $preset)
  }
`;

/**
 * __useSetCameraViewWithPresetMutation__
 *
 * To run a mutation, you first call `useSetCameraViewWithPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraViewWithPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraViewWithPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     preset: // value for 'preset'
 *   },
 * });
 */
export function useSetCameraViewWithPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraViewWithPresetMutation, SetCameraViewWithPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetCameraViewWithPresetMutation,
          SetCameraViewWithPresetMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraViewWithPresetMutation, SetCameraViewWithPresetMutationVariables>(
    SetCameraViewWithPresetDocument,
    options,
  );
}
export type SetCameraViewWithPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraViewWithPresetMutation,
  SetCameraViewWithPresetMutationVariables
>;
export const SetCameraViewWithAnglesDocument = gql`
  mutation setCameraViewWithAngles($cameraId: ID!, $pan: Float!, $tilt: Float!, $zoom: Float!) {
    setCameraViewWithAngles(cameraId: $cameraId, pan: $pan, tilt: $tilt, zoom: $zoom)
  }
`;

/**
 * __useSetCameraViewWithAnglesMutation__
 *
 * To run a mutation, you first call `useSetCameraViewWithAnglesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraViewWithAnglesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraViewWithAnglesMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     pan: // value for 'pan'
 *     tilt: // value for 'tilt'
 *     zoom: // value for 'zoom'
 *   },
 * });
 */
export function useSetCameraViewWithAnglesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraViewWithAnglesMutation, SetCameraViewWithAnglesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetCameraViewWithAnglesMutation,
          SetCameraViewWithAnglesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraViewWithAnglesMutation, SetCameraViewWithAnglesMutationVariables>(
    SetCameraViewWithAnglesDocument,
    options,
  );
}
export type SetCameraViewWithAnglesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraViewWithAnglesMutation,
  SetCameraViewWithAnglesMutationVariables
>;
export const CreateCameraViewPresetDocument = gql`
  mutation createCameraViewPreset($cameraId: ID!, $name: String!) {
    createCameraViewPreset(cameraId: $cameraId, name: $name)
  }
`;

/**
 * __useCreateCameraViewPresetMutation__
 *
 * To run a mutation, you first call `useCreateCameraViewPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraViewPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraViewPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateCameraViewPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>(
    CreateCameraViewPresetDocument,
    options,
  );
}
export type CreateCameraViewPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraViewPresetMutation,
  CreateCameraViewPresetMutationVariables
>;
export const DeleteCameraViewPresetDocument = gql`
  mutation deleteCameraViewPreset($cameraId: ID!, $preset: String!) {
    deleteCameraViewPreset(cameraId: $cameraId, name: $preset)
  }
`;

/**
 * __useDeleteCameraViewPresetMutation__
 *
 * To run a mutation, you first call `useDeleteCameraViewPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraViewPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCameraViewPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     preset: // value for 'preset'
 *   },
 * });
 */
export function useDeleteCameraViewPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>(
    DeleteCameraViewPresetDocument,
    options,
  );
}
export type DeleteCameraViewPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCameraViewPresetMutation,
  DeleteCameraViewPresetMutationVariables
>;
export const StartStreamDocument = gql`
  mutation startStream($cameraId: ID!, $overrideReason: String) {
    stream: startStream(cameraId: $cameraId, overrideReason: $overrideReason) {
      id
      url
      type
      ttl
    }
  }
`;

/**
 * __useStartStreamMutation__
 *
 * To run a mutation, you first call `useStartStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     overrideReason: // value for 'overrideReason'
 *   },
 * });
 */
export function useStartStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartStreamMutation, StartStreamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartStreamMutation, StartStreamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StartStreamMutation, StartStreamMutationVariables>(
    StartStreamDocument,
    options,
  );
}
export type StartStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartStreamMutation,
  StartStreamMutationVariables
>;
export const KeepStreamAliveDocument = gql`
  mutation keepStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
    }
  }
`;

/**
 * __useKeepStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>(
    KeepStreamAliveDocument,
    options,
  );
}
export type KeepStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepStreamAliveMutation,
  KeepStreamAliveMutationVariables
>;
export const StopStreamDocument = gql`
  mutation stopStream($cameraId: ID!, $streamId: ID!) {
    stream: stopStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopStreamMutation__
 *
 * To run a mutation, you first call `useStopStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopStreamMutation, StopStreamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopStreamMutation, StopStreamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StopStreamMutation, StopStreamMutationVariables>(StopStreamDocument, options);
}
export type StopStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopStreamMutation,
  StopStreamMutationVariables
>;
export const DeleteEventConfigDocument = gql`
  mutation deleteEventConfig($id: ID!) {
    deleteEventConfig(id: $id) {
      success
      message
      id
    }
  }
`;

/**
 * __useDeleteEventConfigMutation__
 *
 * To run a mutation, you first call `useDeleteEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEventConfigMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteEventConfigMutation, DeleteEventConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteEventConfigMutation, DeleteEventConfigMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteEventConfigMutation, DeleteEventConfigMutationVariables>(
    DeleteEventConfigDocument,
    options,
  );
}
export type DeleteEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteEventConfigMutation,
  DeleteEventConfigMutationVariables
>;
export const CreateCameraEventConfigDocument = gql`
  mutation createCameraEventConfig($patientId: ID!, $cameraId: ID!, $input: CameraEventConfigInput!) {
    createCameraEventConfig(patientId: $patientId, cameraId: $cameraId, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        cameraId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        toCode
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useCreateCameraEventConfigMutation__
 *
 * To run a mutation, you first call `useCreateCameraEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraEventConfigMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCameraEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraEventConfigMutation, CreateCameraEventConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCameraEventConfigMutation,
          CreateCameraEventConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraEventConfigMutation, CreateCameraEventConfigMutationVariables>(
    CreateCameraEventConfigDocument,
    options,
  );
}
export type CreateCameraEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraEventConfigMutation,
  CreateCameraEventConfigMutationVariables
>;
export const UpdateCameraEventConfigDocument = gql`
  mutation updateCameraEventConfig($id: ID!, $input: CameraEventConfigInput!) {
    updateCameraEventConfig(id: $id, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        cameraId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        toCode
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useUpdateCameraEventConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCameraEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraEventConfigMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCameraEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraEventConfigMutation, UpdateCameraEventConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCameraEventConfigMutation,
          UpdateCameraEventConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraEventConfigMutation, UpdateCameraEventConfigMutationVariables>(
    UpdateCameraEventConfigDocument,
    options,
  );
}
export type UpdateCameraEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraEventConfigMutation,
  UpdateCameraEventConfigMutationVariables
>;
export const CreateCepEventConfigDocument = gql`
  mutation createCepEventConfig($patientId: ID!, $input: CepEventConfigInput!) {
    createCepEventConfig(patientId: $patientId, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        toCode
        cep {
          ...CepConfigFields
        }
        timedCep {
          ...TimedCepConfigFields
        }
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
  ${CepConfigFieldsFragmentDoc}
  ${TimedCepConfigFieldsFragmentDoc}
`;

/**
 * __useCreateCepEventConfigMutation__
 *
 * To run a mutation, you first call `useCreateCepEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCepEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCepEventConfigMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCepEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCepEventConfigMutation, CreateCepEventConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCepEventConfigMutation, CreateCepEventConfigMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCepEventConfigMutation, CreateCepEventConfigMutationVariables>(
    CreateCepEventConfigDocument,
    options,
  );
}
export type CreateCepEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCepEventConfigMutation,
  CreateCepEventConfigMutationVariables
>;
export const UpdateCepEventConfigDocument = gql`
  mutation updateCepEventConfig($id: ID!, $input: CepEventConfigInput!) {
    updateCepEventConfig(id: $id, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        toCode
        cep {
          ...CepConfigFields
        }
        timedCep {
          ...TimedCepConfigFields
        }
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
  ${CepConfigFieldsFragmentDoc}
  ${TimedCepConfigFieldsFragmentDoc}
`;

/**
 * __useUpdateCepEventConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCepEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCepEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCepEventConfigMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCepEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCepEventConfigMutation, UpdateCepEventConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCepEventConfigMutation, UpdateCepEventConfigMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCepEventConfigMutation, UpdateCepEventConfigMutationVariables>(
    UpdateCepEventConfigDocument,
    options,
  );
}
export type UpdateCepEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCepEventConfigMutation,
  UpdateCepEventConfigMutationVariables
>;
export const CreatePatientEventConfigDocument = gql`
  mutation createPatientEventConfig($patientId: ID!, $input: PatientEventConfigInput!) {
    createPatientEventConfig(patientId: $patientId, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useCreatePatientEventConfigMutation__
 *
 * To run a mutation, you first call `useCreatePatientEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientEventConfigMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreatePatientEventConfigMutation,
        CreatePatientEventConfigMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreatePatientEventConfigMutation,
          CreatePatientEventConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientEventConfigMutation, CreatePatientEventConfigMutationVariables>(
    CreatePatientEventConfigDocument,
    options,
  );
}
export type CreatePatientEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientEventConfigMutation,
  CreatePatientEventConfigMutationVariables
>;
export const UpdatePatientEventConfigDocument = gql`
  mutation updatePatientEventConfig($id: ID!, $input: PatientEventConfigInput!) {
    updatePatientEventConfig(id: $id, input: $input) {
      success
      message
      id
      eventConfig {
        id
        patientId
        type
        code
        displayText
        icon
        priority
        schedule {
          ...EventConfigScheduleFields
        }
        workflow
        generatesAlarm
        createdAt
        updatedAt
      }
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useUpdatePatientEventConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePatientEventConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientEventConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientEventConfigMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientEventConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientEventConfigMutation,
        UpdatePatientEventConfigMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientEventConfigMutation,
          UpdatePatientEventConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientEventConfigMutation, UpdatePatientEventConfigMutationVariables>(
    UpdatePatientEventConfigDocument,
    options,
  );
}
export type UpdatePatientEventConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientEventConfigMutation,
  UpdatePatientEventConfigMutationVariables
>;
export const DeleteExternalAccessByIdDocument = gql`
  mutation deleteExternalAccessById($id: ID!) {
    deleteExternalAccessById(id: $id)
  }
`;

/**
 * __useDeleteExternalAccessByIdMutation__
 *
 * To run a mutation, you first call `useDeleteExternalAccessByIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalAccessByIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExternalAccessByIdMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalAccessByIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteExternalAccessByIdMutation,
        DeleteExternalAccessByIdMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteExternalAccessByIdMutation,
          DeleteExternalAccessByIdMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteExternalAccessByIdMutation, DeleteExternalAccessByIdMutationVariables>(
    DeleteExternalAccessByIdDocument,
    options,
  );
}
export type DeleteExternalAccessByIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteExternalAccessByIdMutation,
  DeleteExternalAccessByIdMutationVariables
>;
export const ResetExternalAccessSecretDocument = gql`
  mutation resetExternalAccessSecret($id: ID!) {
    resetExternalAccessSecret(id: $id) {
      id
      message
      success
      secret
    }
  }
`;

/**
 * __useResetExternalAccessSecretMutation__
 *
 * To run a mutation, you first call `useResetExternalAccessSecretMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetExternalAccessSecretMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetExternalAccessSecretMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResetExternalAccessSecretMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetExternalAccessSecretMutation,
        ResetExternalAccessSecretMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetExternalAccessSecretMutation,
          ResetExternalAccessSecretMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ResetExternalAccessSecretMutation, ResetExternalAccessSecretMutationVariables>(
    ResetExternalAccessSecretDocument,
    options,
  );
}
export type ResetExternalAccessSecretMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetExternalAccessSecretMutation,
  ResetExternalAccessSecretMutationVariables
>;
export const UpdateExternalAccessDocument = gql`
  mutation updateExternalAccess($input: UpdateNameOrIpRestrictionForExternalAccessInput!) {
    updateExternalAccess(input: $input) {
      id
      message
      success
    }
  }
`;

/**
 * __useUpdateExternalAccessMutation__
 *
 * To run a mutation, you first call `useUpdateExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateExternalAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateExternalAccessMutation, UpdateExternalAccessMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateExternalAccessMutation, UpdateExternalAccessMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateExternalAccessMutation, UpdateExternalAccessMutationVariables>(
    UpdateExternalAccessDocument,
    options,
  );
}
export type UpdateExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateExternalAccessMutation,
  UpdateExternalAccessMutationVariables
>;
export const CreateExternalAccessDocument = gql`
  mutation createExternalAccess($input: CreateExternalAccessInput!) {
    createExternalAccess(input: $input) {
      id
      message
      secret
      success
    }
  }
`;

/**
 * __useCreateExternalAccessMutation__
 *
 * To run a mutation, you first call `useCreateExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateExternalAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateExternalAccessMutation, CreateExternalAccessMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateExternalAccessMutation, CreateExternalAccessMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateExternalAccessMutation, CreateExternalAccessMutationVariables>(
    CreateExternalAccessDocument,
    options,
  );
}
export type CreateExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateExternalAccessMutation,
  CreateExternalAccessMutationVariables
>;
export const CreateForwarderAlarmRoutesDocument = gql`
  mutation createForwarderAlarmRoutes($forwarderConfigId: String!, $forwarderRoutes: [ForwarderRouteInput!]!) {
    createForwarderAlarmRoutes(forwarderConfigId: $forwarderConfigId, forwarderRoutes: $forwarderRoutes) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateForwarderAlarmRoutesMutation__
 *
 * To run a mutation, you first call `useCreateForwarderAlarmRoutesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateForwarderAlarmRoutesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateForwarderAlarmRoutesMutation({
 *   variables: {
 *     forwarderConfigId: // value for 'forwarderConfigId'
 *     forwarderRoutes: // value for 'forwarderRoutes'
 *   },
 * });
 */
export function useCreateForwarderAlarmRoutesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateForwarderAlarmRoutesMutation,
        CreateForwarderAlarmRoutesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateForwarderAlarmRoutesMutation,
          CreateForwarderAlarmRoutesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateForwarderAlarmRoutesMutation,
    CreateForwarderAlarmRoutesMutationVariables
  >(CreateForwarderAlarmRoutesDocument, options);
}
export type CreateForwarderAlarmRoutesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateForwarderAlarmRoutesMutation,
  CreateForwarderAlarmRoutesMutationVariables
>;
export const UpdateForwarderAlarmRouteDocument = gql`
  mutation updateForwarderAlarmRoute($id: String!, $input: ForwarderRouteInput!) {
    updateForwarderAlarmRoute(id: $id, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateForwarderAlarmRouteMutation__
 *
 * To run a mutation, you first call `useUpdateForwarderAlarmRouteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForwarderAlarmRouteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateForwarderAlarmRouteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateForwarderAlarmRouteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateForwarderAlarmRouteMutation,
        UpdateForwarderAlarmRouteMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateForwarderAlarmRouteMutation,
          UpdateForwarderAlarmRouteMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateForwarderAlarmRouteMutation, UpdateForwarderAlarmRouteMutationVariables>(
    UpdateForwarderAlarmRouteDocument,
    options,
  );
}
export type UpdateForwarderAlarmRouteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateForwarderAlarmRouteMutation,
  UpdateForwarderAlarmRouteMutationVariables
>;
export const DeleteForwarderAlarmRouteDocument = gql`
  mutation deleteForwarderAlarmRoute($id: String!) {
    deleteForwarderAlarmRoute(id: $id) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useDeleteForwarderAlarmRouteMutation__
 *
 * To run a mutation, you first call `useDeleteForwarderAlarmRouteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForwarderAlarmRouteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteForwarderAlarmRouteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForwarderAlarmRouteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteForwarderAlarmRouteMutation,
        DeleteForwarderAlarmRouteMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteForwarderAlarmRouteMutation,
          DeleteForwarderAlarmRouteMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteForwarderAlarmRouteMutation, DeleteForwarderAlarmRouteMutationVariables>(
    DeleteForwarderAlarmRouteDocument,
    options,
  );
}
export type DeleteForwarderAlarmRouteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteForwarderAlarmRouteMutation,
  DeleteForwarderAlarmRouteMutationVariables
>;
export const UpdateIpRestrictionsDocument = gql`
  mutation updateIPRestrictions($userId: ID!, $ipRestrictions: [String]) {
    updateIPRestrictions(userId: $userId, ipRestrictions: $ipRestrictions) {
      success
      inputValidation {
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateIpRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateIpRestrictionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIpRestrictionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIpRestrictionsMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     ipRestrictions: // value for 'ipRestrictions'
 *   },
 * });
 */
export function useUpdateIpRestrictionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>(
    UpdateIpRestrictionsDocument,
    options,
  );
}
export type UpdateIpRestrictionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateIpRestrictionsMutation,
  UpdateIpRestrictionsMutationVariables
>;
export const LogLocalExportDocument = gql`
  mutation logLocalExport($resourceType: String!, $count: Int!) {
    logLocalExport(resourceType: $resourceType, count: $count) {
      success
    }
  }
`;

/**
 * __useLogLocalExportMutation__
 *
 * To run a mutation, you first call `useLogLocalExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogLocalExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogLocalExportMutation({
 *   variables: {
 *     resourceType: // value for 'resourceType'
 *     count: // value for 'count'
 *   },
 * });
 */
export function useLogLocalExportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<LogLocalExportMutation, LogLocalExportMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<LogLocalExportMutation, LogLocalExportMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<LogLocalExportMutation, LogLocalExportMutationVariables>(
    LogLocalExportDocument,
    options,
  );
}
export type LogLocalExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  LogLocalExportMutation,
  LogLocalExportMutationVariables
>;
export const MoveAccessGroupDocument = gql`
  mutation moveAccessGroup($attachToUserGroup: String!, $userGroupToMove: String!) {
    moveAccessGroup(attachToUserGroup: $attachToUserGroup, userGroupToMove: $userGroupToMove) {
      success
      message
    }
  }
`;

/**
 * __useMoveAccessGroupMutation__
 *
 * To run a mutation, you first call `useMoveAccessGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMoveAccessGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMoveAccessGroupMutation({
 *   variables: {
 *     attachToUserGroup: // value for 'attachToUserGroup'
 *     userGroupToMove: // value for 'userGroupToMove'
 *   },
 * });
 */
export function useMoveAccessGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>(
    MoveAccessGroupDocument,
    options,
  );
}
export type MoveAccessGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MoveAccessGroupMutation,
  MoveAccessGroupMutationVariables
>;
export const DeleteNextOfKinDocument = gql`
  mutation deleteNextOfKin($nokId: ID!) {
    deleteNextOfKin(nokId: $nokId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteNextOfKinMutation__
 *
 * To run a mutation, you first call `useDeleteNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNextOfKinMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *   },
 * });
 */
export function useDeleteNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>(
    DeleteNextOfKinDocument,
    options,
  );
}
export type DeleteNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteNextOfKinMutation,
  DeleteNextOfKinMutationVariables
>;
export const AddNextOfKinDocument = gql`
  mutation addNextOfKin($patientId: ID!, $nextOfKinInput: CreateNextOfKinInput!) {
    addNextOfKin(patientId: $patientId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useAddNextOfKinMutation__
 *
 * To run a mutation, you first call `useAddNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNextOfKinMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useAddNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNextOfKinMutation, AddNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNextOfKinMutation, AddNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNextOfKinMutation, AddNextOfKinMutationVariables>(
    AddNextOfKinDocument,
    options,
  );
}
export type AddNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNextOfKinMutation,
  AddNextOfKinMutationVariables
>;
export const MarkNextOfKinAsMainDocument = gql`
  mutation markNextOfKinAsMain($nokId: ID!) {
    markNextOfKinAsMain(nokId: $nokId) {
      success
      message
    }
  }
`;

/**
 * __useMarkNextOfKinAsMainMutation__
 *
 * To run a mutation, you first call `useMarkNextOfKinAsMainMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNextOfKinAsMainMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNextOfKinAsMainMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *   },
 * });
 */
export function useMarkNextOfKinAsMainMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>(
    MarkNextOfKinAsMainDocument,
    options,
  );
}
export type MarkNextOfKinAsMainMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkNextOfKinAsMainMutation,
  MarkNextOfKinAsMainMutationVariables
>;
export const UpdateNextOfKinDocument = gql`
  mutation updateNextOfKin($nokId: ID!, $nextOfKinInput: UpdateNextOfKinInput!) {
    updateNextOfKin(nokId: $nokId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useUpdateNextOfKinMutation__
 *
 * To run a mutation, you first call `useUpdateNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNextOfKinMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useUpdateNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>(
    UpdateNextOfKinDocument,
    options,
  );
}
export type UpdateNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateNextOfKinMutation,
  UpdateNextOfKinMutationVariables
>;
export const NotifyNextOfKinsDocument = gql`
  mutation notifyNextOfKins($patientId: ID!, $message: String!) {
    notifyNextOfKins(patientId: $patientId, message: $message) {
      phoneNumber
      messageStatus
    }
  }
`;

/**
 * __useNotifyNextOfKinsMutation__
 *
 * To run a mutation, you first call `useNotifyNextOfKinsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNotifyNextOfKinsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNotifyNextOfKinsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     message: // value for 'message'
 *   },
 * });
 */
export function useNotifyNextOfKinsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>(
    NotifyNextOfKinsDocument,
    options,
  );
}
export type NotifyNextOfKinsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  NotifyNextOfKinsMutation,
  NotifyNextOfKinsMutationVariables
>;
export const OpenPatientGroupsForExternalAccessDocument = gql`
  mutation openPatientGroupsForExternalAccess($input: UpdateExternalAccessInput!) {
    openPatientGroupsForExternalAccess(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useOpenPatientGroupsForExternalAccessMutation__
 *
 * To run a mutation, you first call `useOpenPatientGroupsForExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOpenPatientGroupsForExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOpenPatientGroupsForExternalAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOpenPatientGroupsForExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        OpenPatientGroupsForExternalAccessMutation,
        OpenPatientGroupsForExternalAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          OpenPatientGroupsForExternalAccessMutation,
          OpenPatientGroupsForExternalAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    OpenPatientGroupsForExternalAccessMutation,
    OpenPatientGroupsForExternalAccessMutationVariables
  >(OpenPatientGroupsForExternalAccessDocument, options);
}
export type OpenPatientGroupsForExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OpenPatientGroupsForExternalAccessMutation,
  OpenPatientGroupsForExternalAccessMutationVariables
>;
export const AddPatientByExternalIdDocument = gql`
  mutation addPatientByExternalId(
    $patientGroupId: ID!
    $externalPatientId: ExternalHumanIdInput!
    $active: Boolean
    $createDialoggAccount: Boolean
  ) {
    addPatientByExternalId(
      patientGroupId: $patientGroupId
      externalPatientId: $externalPatientId
      active: $active
      createDialoggAccount: $createDialoggAccount
    ) {
      success
      message
      patient {
        id
      }
    }
  }
`;

/**
 * __useAddPatientByExternalIdMutation__
 *
 * To run a mutation, you first call `useAddPatientByExternalIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientByExternalIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientByExternalIdMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     externalPatientId: // value for 'externalPatientId'
 *     active: // value for 'active'
 *     createDialoggAccount: // value for 'createDialoggAccount'
 *   },
 * });
 */
export function useAddPatientByExternalIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>(
    AddPatientByExternalIdDocument,
    options,
  );
}
export type AddPatientByExternalIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPatientByExternalIdMutation,
  AddPatientByExternalIdMutationVariables
>;
export const CreatePatientDocument = gql`
  mutation createPatient($patientGroupIds: [ID!]!, $patientInput: CreatePatientInput!) {
    createPatient(patientGroupIds: $patientGroupIds, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      patient {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientMutation({
 *   variables: {
 *     patientGroupIds: // value for 'patientGroupIds'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useCreatePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(
    CreatePatientDocument,
    options,
  );
}
export type CreatePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientMutation,
  CreatePatientMutationVariables
>;
export const AddCameraToPatientDocument = gql`
  mutation addCameraToPatient($patientId: ID!, $cameraId: ID!, $cameraProfileId: ID) {
    addCameraToPatient(patientId: $patientId, cameraId: $cameraId, cameraProfileId: $cameraProfileId) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useAddCameraToPatientMutation__
 *
 * To run a mutation, you first call `useAddCameraToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCameraToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCameraToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *     cameraProfileId: // value for 'cameraProfileId'
 *   },
 * });
 */
export function useAddCameraToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>(
    AddCameraToPatientDocument,
    options,
  );
}
export type AddCameraToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCameraToPatientMutation,
  AddCameraToPatientMutationVariables
>;
export const UpdateAvailableHoursForCameraDocument = gql`
  mutation updateAvailableHoursForCamera($patientId: ID!, $cameraId: ID!, $availableHours: String!) {
    updateAvailableHours(patientId: $patientId, cameraId: $cameraId, availableHours: $availableHours) {
      success
    }
  }
`;

/**
 * __useUpdateAvailableHoursForCameraMutation__
 *
 * To run a mutation, you first call `useUpdateAvailableHoursForCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailableHoursForCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAvailableHoursForCameraMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *     availableHours: // value for 'availableHours'
 *   },
 * });
 */
export function useUpdateAvailableHoursForCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateAvailableHoursForCameraMutation,
        UpdateAvailableHoursForCameraMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateAvailableHoursForCameraMutation,
          UpdateAvailableHoursForCameraMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateAvailableHoursForCameraMutation,
    UpdateAvailableHoursForCameraMutationVariables
  >(UpdateAvailableHoursForCameraDocument, options);
}
export type UpdateAvailableHoursForCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAvailableHoursForCameraMutation,
  UpdateAvailableHoursForCameraMutationVariables
>;
export const UpdateCameraDeviceGroupDocument = gql`
  mutation updateCameraDeviceGroup($cameraId: ID!, $deviceGroupId: ID!) {
    updateCameraDeviceGroup(cameraId: $cameraId, deviceGroupId: $deviceGroupId) {
      success
    }
  }
`;

/**
 * __useUpdateCameraDeviceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCameraDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraDeviceGroupMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     deviceGroupId: // value for 'deviceGroupId'
 *   },
 * });
 */
export function useUpdateCameraDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraDeviceGroupMutation, UpdateCameraDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCameraDeviceGroupMutation,
          UpdateCameraDeviceGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraDeviceGroupMutation, UpdateCameraDeviceGroupMutationVariables>(
    UpdateCameraDeviceGroupDocument,
    options,
  );
}
export type UpdateCameraDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraDeviceGroupMutation,
  UpdateCameraDeviceGroupMutationVariables
>;
export const AddPatientContactDocument = gql`
  mutation addPatientContact($patientId: ID!, $contact: CreateContactInput!) {
    addPatientContact(patientId: $patientId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useAddPatientContactMutation__
 *
 * To run a mutation, you first call `useAddPatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useAddPatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPatientContactMutation, AddPatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPatientContactMutation, AddPatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPatientContactMutation, AddPatientContactMutationVariables>(
    AddPatientContactDocument,
    options,
  );
}
export type AddPatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPatientContactMutation,
  AddPatientContactMutationVariables
>;
export const UpdatePatientContactDocument = gql`
  mutation updatePatientContact($patientId: ID!, $contact: UpdateContactInput!) {
    updatePatientContact(patientId: $patientId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useUpdatePatientContactMutation__
 *
 * To run a mutation, you first call `useUpdatePatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdatePatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>(
    UpdatePatientContactDocument,
    options,
  );
}
export type UpdatePatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientContactMutation,
  UpdatePatientContactMutationVariables
>;
export const RemovePatientContactDocument = gql`
  mutation removePatientContact($patientId: ID!, $contactId: ID!) {
    removePatientContact(patientId: $patientId, contactId: $contactId) {
      success
    }
  }
`;

/**
 * __useRemovePatientContactMutation__
 *
 * To run a mutation, you first call `useRemovePatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRemovePatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemovePatientContactMutation, RemovePatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemovePatientContactMutation, RemovePatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemovePatientContactMutation, RemovePatientContactMutationVariables>(
    RemovePatientContactDocument,
    options,
  );
}
export type RemovePatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientContactMutation,
  RemovePatientContactMutationVariables
>;
export const OrderPatientContactsDocument = gql`
  mutation orderPatientContacts($patientId: ID!, $orderedContactIds: [ID!]!) {
    orderPatientContacts(patientId: $patientId, orderedContactIds: $orderedContactIds) {
      success
    }
  }
`;

/**
 * __useOrderPatientContactsMutation__
 *
 * To run a mutation, you first call `useOrderPatientContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOrderPatientContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOrderPatientContactsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     orderedContactIds: // value for 'orderedContactIds'
 *   },
 * });
 */
export function useOrderPatientContactsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>(
    OrderPatientContactsDocument,
    options,
  );
}
export type OrderPatientContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OrderPatientContactsMutation,
  OrderPatientContactsMutationVariables
>;
export const StartRawDataStreamDocument = gql`
  mutation startRawDataStream($cameraId: ID!, $streamId: ID) {
    stream: startRawDataStream(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useStartRawDataStreamMutation__
 *
 * To run a mutation, you first call `useStartRawDataStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartRawDataStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartRawDataStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStartRawDataStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartRawDataStreamMutation, StartRawDataStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartRawDataStreamMutation, StartRawDataStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartRawDataStreamMutation, StartRawDataStreamMutationVariables>(
    StartRawDataStreamDocument,
    options,
  );
}
export type StartRawDataStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartRawDataStreamMutation,
  StartRawDataStreamMutationVariables
>;
export const StopRawDataStreamDocument = gql`
  mutation stopRawDataStream($cameraId: ID!, $streamId: ID!) {
    stream: stopRawDataStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopRawDataStreamMutation__
 *
 * To run a mutation, you first call `useStopRawDataStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopRawDataStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopRawDataStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopRawDataStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopRawDataStreamMutation, StopRawDataStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StopRawDataStreamMutation, StopRawDataStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StopRawDataStreamMutation, StopRawDataStreamMutationVariables>(
    StopRawDataStreamDocument,
    options,
  );
}
export type StopRawDataStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopRawDataStreamMutation,
  StopRawDataStreamMutationVariables
>;
export const KeepRawDataStreamAliveDocument = gql`
  mutation keepRawDataStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepRawDataStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useKeepRawDataStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepRawDataStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepRawDataStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepRawDataStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepRawDataStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<KeepRawDataStreamAliveMutation, KeepRawDataStreamAliveMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<KeepRawDataStreamAliveMutation, KeepRawDataStreamAliveMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<KeepRawDataStreamAliveMutation, KeepRawDataStreamAliveMutationVariables>(
    KeepRawDataStreamAliveDocument,
    options,
  );
}
export type KeepRawDataStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepRawDataStreamAliveMutation,
  KeepRawDataStreamAliveMutationVariables
>;
export const RefreshAzureProvisioningSecretDocument = gql`
  mutation refreshAzureProvisioningSecret($azureAccountId: ID!) {
    refreshAzureProvisioningSecret(azureAccountId: $azureAccountId) {
      message
      success
      azureProvisioningCredentials {
        tenantUrl
        secretToken
      }
    }
  }
`;

/**
 * __useRefreshAzureProvisioningSecretMutation__
 *
 * To run a mutation, you first call `useRefreshAzureProvisioningSecretMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAzureProvisioningSecretMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshAzureProvisioningSecretMutation({
 *   variables: {
 *     azureAccountId: // value for 'azureAccountId'
 *   },
 * });
 */
export function useRefreshAzureProvisioningSecretMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RefreshAzureProvisioningSecretMutation,
        RefreshAzureProvisioningSecretMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RefreshAzureProvisioningSecretMutation,
          RefreshAzureProvisioningSecretMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RefreshAzureProvisioningSecretMutation,
    RefreshAzureProvisioningSecretMutationVariables
  >(RefreshAzureProvisioningSecretDocument, options);
}
export type RefreshAzureProvisioningSecretMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RefreshAzureProvisioningSecretMutation,
  RefreshAzureProvisioningSecretMutationVariables
>;
export const RemoveMqttDeviceFromPatientDocument = gql`
  mutation removeMqttDeviceFromPatient($patientId: ID!, $mqttDeviceId: ID!) {
    removeMqttDeviceFromPatient(patientId: $patientId, mqttDeviceId: $mqttDeviceId) {
      success
    }
  }
`;

/**
 * __useRemoveMqttDeviceFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveMqttDeviceFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMqttDeviceFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveMqttDeviceFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     mqttDeviceId: // value for 'mqttDeviceId'
 *   },
 * });
 */
export function useRemoveMqttDeviceFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveMqttDeviceFromPatientMutation,
        RemoveMqttDeviceFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveMqttDeviceFromPatientMutation,
          RemoveMqttDeviceFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveMqttDeviceFromPatientMutation,
    RemoveMqttDeviceFromPatientMutationVariables
  >(RemoveMqttDeviceFromPatientDocument, options);
}
export type RemoveMqttDeviceFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveMqttDeviceFromPatientMutation,
  RemoveMqttDeviceFromPatientMutationVariables
>;
export const RemoveTemplateVkpCodesFromTemplateDocument = gql`
  mutation removeTemplateVkpCodesFromTemplate($templateId: ID!) {
    removeTemplateVkpCodesFromTemplate(templateId: $templateId) {
      success
      message
    }
  }
`;

/**
 * __useRemoveTemplateVkpCodesFromTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveTemplateVkpCodesFromTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTemplateVkpCodesFromTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTemplateVkpCodesFromTemplateMutation({
 *   variables: {
 *     templateId: // value for 'templateId'
 *   },
 * });
 */
export function useRemoveTemplateVkpCodesFromTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveTemplateVkpCodesFromTemplateMutation,
        RemoveTemplateVkpCodesFromTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveTemplateVkpCodesFromTemplateMutation,
          RemoveTemplateVkpCodesFromTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveTemplateVkpCodesFromTemplateMutation,
    RemoveTemplateVkpCodesFromTemplateMutationVariables
  >(RemoveTemplateVkpCodesFromTemplateDocument, options);
}
export type RemoveTemplateVkpCodesFromTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveTemplateVkpCodesFromTemplateMutation,
  RemoveTemplateVkpCodesFromTemplateMutationVariables
>;
export const CreateSelfTreatmentPlanTemplateDocument = gql`
  mutation createSelfTreatmentPlanTemplate($selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput!) {
    createSelfTreatmentPlanTemplate(selfTreatmentPlanTemplateInput: $selfTreatmentPlanTemplateInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreateSelfTreatmentPlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSelfTreatmentPlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfTreatmentPlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSelfTreatmentPlanTemplateMutation({
 *   variables: {
 *     selfTreatmentPlanTemplateInput: // value for 'selfTreatmentPlanTemplateInput'
 *   },
 * });
 */
export function useCreateSelfTreatmentPlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateSelfTreatmentPlanTemplateMutation,
        CreateSelfTreatmentPlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateSelfTreatmentPlanTemplateMutation,
          CreateSelfTreatmentPlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateSelfTreatmentPlanTemplateMutation,
    CreateSelfTreatmentPlanTemplateMutationVariables
  >(CreateSelfTreatmentPlanTemplateDocument, options);
}
export type CreateSelfTreatmentPlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSelfTreatmentPlanTemplateMutation,
  CreateSelfTreatmentPlanTemplateMutationVariables
>;
export const UpdateSelfTreatmentPlanTemplateDocument = gql`
  mutation updateSelfTreatmentPlanTemplate(
    $selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput!
    $selfTreatmentPlanTemplateId: ID!
  ) {
    updateSelfTreatmentPlanTemplate(
      selfTreatmentPlanTemplateUpdateInput: $selfTreatmentPlanTemplateUpdateInput
      selfTreatmentPlanTemplateId: $selfTreatmentPlanTemplateId
    ) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useUpdateSelfTreatmentPlanTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSelfTreatmentPlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfTreatmentPlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSelfTreatmentPlanTemplateMutation({
 *   variables: {
 *     selfTreatmentPlanTemplateUpdateInput: // value for 'selfTreatmentPlanTemplateUpdateInput'
 *     selfTreatmentPlanTemplateId: // value for 'selfTreatmentPlanTemplateId'
 *   },
 * });
 */
export function useUpdateSelfTreatmentPlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateSelfTreatmentPlanTemplateMutation,
        UpdateSelfTreatmentPlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSelfTreatmentPlanTemplateMutation,
          UpdateSelfTreatmentPlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateSelfTreatmentPlanTemplateMutation,
    UpdateSelfTreatmentPlanTemplateMutationVariables
  >(UpdateSelfTreatmentPlanTemplateDocument, options);
}
export type UpdateSelfTreatmentPlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSelfTreatmentPlanTemplateMutation,
  UpdateSelfTreatmentPlanTemplateMutationVariables
>;
export const CreateCameraPtzProfileDocument = gql`
  mutation createCameraPtzProfile($cameraId: ID!, $input: CreateCameraPtzProfileInput!, $setActive: Boolean) {
    createCameraPtzProfile(cameraId: $cameraId, input: $input, setActive: $setActive) {
      activeProfileId
      profiles {
        id
        name
        pan
        tilt
        zoom
      }
    }
  }
`;

/**
 * __useCreateCameraPtzProfileMutation__
 *
 * To run a mutation, you first call `useCreateCameraPtzProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraPtzProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraPtzProfileMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     input: // value for 'input'
 *     setActive: // value for 'setActive'
 *   },
 * });
 */
export function useCreateCameraPtzProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraPtzProfileMutation, CreateCameraPtzProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraPtzProfileMutation, CreateCameraPtzProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraPtzProfileMutation, CreateCameraPtzProfileMutationVariables>(
    CreateCameraPtzProfileDocument,
    options,
  );
}
export type CreateCameraPtzProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraPtzProfileMutation,
  CreateCameraPtzProfileMutationVariables
>;
export const SetActiveCameraPtzProfileDocument = gql`
  mutation setActiveCameraPtzProfile($cameraId: ID!, $profileId: ID) {
    setActiveCameraPtzProfile(cameraId: $cameraId, profileId: $profileId) {
      activeProfileId
      profiles {
        id
        name
        pan
        tilt
        zoom
      }
    }
  }
`;

/**
 * __useSetActiveCameraPtzProfileMutation__
 *
 * To run a mutation, you first call `useSetActiveCameraPtzProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveCameraPtzProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetActiveCameraPtzProfileMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     profileId: // value for 'profileId'
 *   },
 * });
 */
export function useSetActiveCameraPtzProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetActiveCameraPtzProfileMutation,
        SetActiveCameraPtzProfileMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetActiveCameraPtzProfileMutation,
          SetActiveCameraPtzProfileMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetActiveCameraPtzProfileMutation, SetActiveCameraPtzProfileMutationVariables>(
    SetActiveCameraPtzProfileDocument,
    options,
  );
}
export type SetActiveCameraPtzProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetActiveCameraPtzProfileMutation,
  SetActiveCameraPtzProfileMutationVariables
>;
export const DeleteCameraPtzProfileDocument = gql`
  mutation deleteCameraPtzProfile($cameraId: ID!, $profileId: ID!) {
    deleteCameraPtzProfile(cameraId: $cameraId, profileId: $profileId) {
      activeProfileId
      profiles {
        id
        name
        pan
        tilt
        zoom
      }
    }
  }
`;

/**
 * __useDeleteCameraPtzProfileMutation__
 *
 * To run a mutation, you first call `useDeleteCameraPtzProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraPtzProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCameraPtzProfileMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteCameraPtzProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCameraPtzProfileMutation, DeleteCameraPtzProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCameraPtzProfileMutation, DeleteCameraPtzProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCameraPtzProfileMutation, DeleteCameraPtzProfileMutationVariables>(
    DeleteCameraPtzProfileDocument,
    options,
  );
}
export type DeleteCameraPtzProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCameraPtzProfileMutation,
  DeleteCameraPtzProfileMutationVariables
>;
export const SimulateNovoEventDocument = gql`
  mutation simulateNovoEvent($event: NovoEventInput!) {
    simulateNovoEvent(event: $event) {
      success
      message
    }
  }
`;

/**
 * __useSimulateNovoEventMutation__
 *
 * To run a mutation, you first call `useSimulateNovoEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateNovoEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateNovoEventMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateNovoEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>(
    SimulateNovoEventDocument,
    options,
  );
}
export type SimulateNovoEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateNovoEventMutation,
  SimulateNovoEventMutationVariables
>;
export const SimulateSafemateEventDocument = gql`
  mutation simulateSafemateEvent($event: SafemateEventInput!) {
    simulateSafemateEvent(event: $event) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSafemateEventMutation__
 *
 * To run a mutation, you first call `useSimulateSafemateEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSafemateEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSafemateEventMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateSafemateEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>(
    SimulateSafemateEventDocument,
    options,
  );
}
export type SimulateSafemateEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSafemateEventMutation,
  SimulateSafemateEventMutationVariables
>;
export const SimulateSkyResponseEventDocument = gql`
  mutation simulateSkyResponseEvent(
    $patientId: ID!
    $externalAccessId: ID!
    $templateId: ID!
    $event: SkyresponseEventInput!
  ) {
    simulateSkyResponseEvent(
      patientId: $patientId
      externalAccessId: $externalAccessId
      templateId: $templateId
      event: $event
    ) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSkyResponseEventMutation__
 *
 * To run a mutation, you first call `useSimulateSkyResponseEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSkyResponseEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSkyResponseEventMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalAccessId: // value for 'externalAccessId'
 *     templateId: // value for 'templateId'
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateSkyResponseEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateSkyResponseEventMutation,
        SimulateSkyResponseEventMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateSkyResponseEventMutation,
          SimulateSkyResponseEventMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSkyResponseEventMutation, SimulateSkyResponseEventMutationVariables>(
    SimulateSkyResponseEventDocument,
    options,
  );
}
export type SimulateSkyResponseEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSkyResponseEventMutation,
  SimulateSkyResponseEventMutationVariables
>;
export const SortTreeDocument = gql`
  mutation sortTree($userGroupToSort: String!, $previousSiblingId: String, $nextSiblingId: String) {
    sortTree(userGroupToSort: $userGroupToSort, previousSiblingId: $previousSiblingId, nextSiblingId: $nextSiblingId) {
      success
      message
    }
  }
`;

/**
 * __useSortTreeMutation__
 *
 * To run a mutation, you first call `useSortTreeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSortTreeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSortTreeMutation({
 *   variables: {
 *     userGroupToSort: // value for 'userGroupToSort'
 *     previousSiblingId: // value for 'previousSiblingId'
 *     nextSiblingId: // value for 'nextSiblingId'
 *   },
 * });
 */
export function useSortTreeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SortTreeMutation, SortTreeMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<SortTreeMutation, SortTreeMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<SortTreeMutation, SortTreeMutationVariables>(SortTreeDocument, options);
}
export type SortTreeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SortTreeMutation,
  SortTreeMutationVariables
>;
export const SyncSpecificPatientWithSkyresponseDocument = gql`
  mutation syncSpecificPatientWithSkyresponse($patientId: ID!) {
    syncSpecificPatientWithSkyresponse(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __useSyncSpecificPatientWithSkyresponseMutation__
 *
 * To run a mutation, you first call `useSyncSpecificPatientWithSkyresponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncSpecificPatientWithSkyresponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncSpecificPatientWithSkyresponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useSyncSpecificPatientWithSkyresponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncSpecificPatientWithSkyresponseMutation,
        SyncSpecificPatientWithSkyresponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncSpecificPatientWithSkyresponseMutation,
          SyncSpecificPatientWithSkyresponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncSpecificPatientWithSkyresponseMutation,
    SyncSpecificPatientWithSkyresponseMutationVariables
  >(SyncSpecificPatientWithSkyresponseDocument, options);
}
export type SyncSpecificPatientWithSkyresponseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SyncSpecificPatientWithSkyresponseMutation,
  SyncSpecificPatientWithSkyresponseMutationVariables
>;
export const UpdateAzureAccountDocument = gql`
  mutation updateAzureAccount($input: ExternalIdentityProviderForHealthProviderUpdateInput!) {
    updateAzureAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateAzureAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAzureAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAzureAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAzureAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>(
    UpdateAzureAccountDocument,
    options,
  );
}
export type UpdateAzureAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAzureAccountMutation,
  UpdateAzureAccountMutationVariables
>;
export const UpdateCameraDocument = gql`
  mutation updateCamera($id: ID!, $updateInput: UpdateCameraInput!) {
    updateCamera(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateCameraMutation__
 *
 * To run a mutation, you first call `useUpdateCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraMutation, UpdateCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCameraMutation, UpdateCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraMutation, UpdateCameraMutationVariables>(
    UpdateCameraDocument,
    options,
  );
}
export type UpdateCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraMutation,
  UpdateCameraMutationVariables
>;
export const UpdateDeviceGroupForMqttDeviceDocument = gql`
  mutation updateDeviceGroupForMqttDevice($id: ID!, $deviceGroupId: ID!) {
    updateDeviceGroupForMqttDevice(id: $id, deviceGroupId: $deviceGroupId) {
      success
      message
      mqttDevice {
        id
        deviceGroupId
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateDeviceGroupForMqttDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceGroupForMqttDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceGroupForMqttDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDeviceGroupForMqttDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     deviceGroupId: // value for 'deviceGroupId'
 *   },
 * });
 */
export function useUpdateDeviceGroupForMqttDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDeviceGroupForMqttDeviceMutation,
        UpdateDeviceGroupForMqttDeviceMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDeviceGroupForMqttDeviceMutation,
          UpdateDeviceGroupForMqttDeviceMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDeviceGroupForMqttDeviceMutation,
    UpdateDeviceGroupForMqttDeviceMutationVariables
  >(UpdateDeviceGroupForMqttDeviceDocument, options);
}
export type UpdateDeviceGroupForMqttDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDeviceGroupForMqttDeviceMutation,
  UpdateDeviceGroupForMqttDeviceMutationVariables
>;
export const UpdateExternalIdRequestsOnAzureGroupDocument = gql`
  mutation updateExternalIdRequestsOnAzureGroup($id: ID!, $requestedExternalIdTypeIds: [String!]!) {
    updateExternalIdRequestsOnAzureGroup(id: $id, requestedExternalIdTypeIds: $requestedExternalIdTypeIds) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateExternalIdRequestsOnAzureGroupMutation__
 *
 * To run a mutation, you first call `useUpdateExternalIdRequestsOnAzureGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalIdRequestsOnAzureGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateExternalIdRequestsOnAzureGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *     requestedExternalIdTypeIds: // value for 'requestedExternalIdTypeIds'
 *   },
 * });
 */
export function useUpdateExternalIdRequestsOnAzureGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateExternalIdRequestsOnAzureGroupMutation,
        UpdateExternalIdRequestsOnAzureGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateExternalIdRequestsOnAzureGroupMutation,
          UpdateExternalIdRequestsOnAzureGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateExternalIdRequestsOnAzureGroupMutation,
    UpdateExternalIdRequestsOnAzureGroupMutationVariables
  >(UpdateExternalIdRequestsOnAzureGroupDocument, options);
}
export type UpdateExternalIdRequestsOnAzureGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateExternalIdRequestsOnAzureGroupMutation,
    UpdateExternalIdRequestsOnAzureGroupMutationVariables
  >;
export const UpdateLinkedPatientGroupsDocument = gql`
  mutation updateLinkedPatientGroups(
    $userGroupId: ID!
    $addPatientGroups: [String!]!
    $removePatientGroups: [String!]!
  ) {
    updateLinkedPatientGroups(
      userGroupId: $userGroupId
      addPatientGroups: $addPatientGroups
      removePatientGroups: $removePatientGroups
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateLinkedPatientGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateLinkedPatientGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkedPatientGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLinkedPatientGroupsMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     addPatientGroups: // value for 'addPatientGroups'
 *     removePatientGroups: // value for 'removePatientGroups'
 *   },
 * });
 */
export function useUpdateLinkedPatientGroupsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateLinkedPatientGroupsMutation,
        UpdateLinkedPatientGroupsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateLinkedPatientGroupsMutation,
          UpdateLinkedPatientGroupsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateLinkedPatientGroupsMutation, UpdateLinkedPatientGroupsMutationVariables>(
    UpdateLinkedPatientGroupsDocument,
    options,
  );
}
export type UpdateLinkedPatientGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateLinkedPatientGroupsMutation,
  UpdateLinkedPatientGroupsMutationVariables
>;
export const UpdateMqttDeviceDocument = gql`
  mutation updateMqttDevice($id: ID!, $updateInput: MqttDeviceUpdateInput!) {
    updateMqttDevice(id: $id, updateInput: $updateInput) {
      success
      message
      mqttDevice {
        id
        name
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateMqttDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateMqttDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMqttDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMqttDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateMqttDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateMqttDeviceMutation, UpdateMqttDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateMqttDeviceMutation, UpdateMqttDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateMqttDeviceMutation, UpdateMqttDeviceMutationVariables>(
    UpdateMqttDeviceDocument,
    options,
  );
}
export type UpdateMqttDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateMqttDeviceMutation,
  UpdateMqttDeviceMutationVariables
>;
export const UpdatePatientDocument = gql`
  mutation updatePatient($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(
    UpdatePatientDocument,
    options,
  );
}
export type UpdatePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientMutation,
  UpdatePatientMutationVariables
>;
export const UpdatePatientNoteDocument = gql`
  mutation updatePatientNote($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
    }
  }
`;

/**
 * __useUpdatePatientNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePatientNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientNoteMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>(
    UpdatePatientNoteDocument,
    options,
  );
}
export type UpdatePatientNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientNoteMutation,
  UpdatePatientNoteMutationVariables
>;
export const UpdatePendingExternalIdentityProvidersOnAzureGroupDocument = gql`
  mutation updatePendingExternalIdentityProvidersOnAzureGroup($id: ID!, $pendingExternalIdentityProviders: [String!]!) {
    updatePendingExternalIdentityProvidersOnAzureGroup(
      id: $id
      pendingExternalIdentityProviders: $pendingExternalIdentityProviders
    ) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdatePendingExternalIdentityProvidersOnAzureGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePendingExternalIdentityProvidersOnAzureGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingExternalIdentityProvidersOnAzureGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePendingExternalIdentityProvidersOnAzureGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *     pendingExternalIdentityProviders: // value for 'pendingExternalIdentityProviders'
 *   },
 * });
 */
export function useUpdatePendingExternalIdentityProvidersOnAzureGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePendingExternalIdentityProvidersOnAzureGroupMutation,
        UpdatePendingExternalIdentityProvidersOnAzureGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePendingExternalIdentityProvidersOnAzureGroupMutation,
          UpdatePendingExternalIdentityProvidersOnAzureGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePendingExternalIdentityProvidersOnAzureGroupMutation,
    UpdatePendingExternalIdentityProvidersOnAzureGroupMutationVariables
  >(UpdatePendingExternalIdentityProvidersOnAzureGroupDocument, options);
}
export type UpdatePendingExternalIdentityProvidersOnAzureGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdatePendingExternalIdentityProvidersOnAzureGroupMutation,
    UpdatePendingExternalIdentityProvidersOnAzureGroupMutationVariables
  >;
export const UpdateTemplateVkpCodesDocument = gql`
  mutation updateTemplateVkpCodes($templateId: ID!, $input: TemplateVkpCodesInput!) {
    updateTemplateVkpCodes(templateId: $templateId, input: $input) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateTemplateVkpCodesMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateVkpCodesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateVkpCodesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTemplateVkpCodesMutation({
 *   variables: {
 *     templateId: // value for 'templateId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateVkpCodesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateTemplateVkpCodesMutation, UpdateTemplateVkpCodesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateTemplateVkpCodesMutation, UpdateTemplateVkpCodesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateTemplateVkpCodesMutation, UpdateTemplateVkpCodesMutationVariables>(
    UpdateTemplateVkpCodesDocument,
    options,
  );
}
export type UpdateTemplateVkpCodesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTemplateVkpCodesMutation,
  UpdateTemplateVkpCodesMutationVariables
>;
export const UpdateWelfareDeviceDocument = gql`
  mutation updateWelfareDevice($id: ID!, $updateInput: WelfareDeviceUpdateInput!) {
    updateWelfareDevice(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWelfareDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>(
    UpdateWelfareDeviceDocument,
    options,
  );
}
export type UpdateWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateWelfareDeviceMutation,
  UpdateWelfareDeviceMutationVariables
>;
export const AddUserGroupContactDocument = gql`
  mutation addUserGroupContact($userGroupId: ID!, $contact: CreateContactInput!) {
    addUserGroupContact(userGroupId: $userGroupId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useAddUserGroupContactMutation__
 *
 * To run a mutation, you first call `useAddUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useAddUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>(
    AddUserGroupContactDocument,
    options,
  );
}
export type AddUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserGroupContactMutation,
  AddUserGroupContactMutationVariables
>;
export const UpdateUserGroupContactDocument = gql`
  mutation updateUserGroupContact($userGroupId: ID!, $contact: UpdateContactInput!) {
    updateUserGroupContact(userGroupId: $userGroupId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useUpdateUserGroupContactMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdateUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>(
    UpdateUserGroupContactDocument,
    options,
  );
}
export type UpdateUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupContactMutation,
  UpdateUserGroupContactMutationVariables
>;
export const RemoveUserGroupContactDocument = gql`
  mutation removeUserGroupContact($userGroupId: ID!, $contactId: ID!) {
    removeUserGroupContact(userGroupId: $userGroupId, contactId: $contactId) {
      success
    }
  }
`;

/**
 * __useRemoveUserGroupContactMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRemoveUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>(
    RemoveUserGroupContactDocument,
    options,
  );
}
export type RemoveUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserGroupContactMutation,
  RemoveUserGroupContactMutationVariables
>;
export const OrderUserGroupContactsDocument = gql`
  mutation orderUserGroupContacts($userGroupId: ID!, $orderedContactIds: [ID!]!) {
    orderUserGroupContacts(userGroupId: $userGroupId, orderedContactIds: $orderedContactIds) {
      success
    }
  }
`;

/**
 * __useOrderUserGroupContactsMutation__
 *
 * To run a mutation, you first call `useOrderUserGroupContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOrderUserGroupContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOrderUserGroupContactsMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     orderedContactIds: // value for 'orderedContactIds'
 *   },
 * });
 */
export function useOrderUserGroupContactsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>(
    OrderUserGroupContactsDocument,
    options,
  );
}
export type OrderUserGroupContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OrderUserGroupContactsMutation,
  OrderUserGroupContactsMutationVariables
>;
export const AddUserToRoleDocument = gql`
  mutation addUserToRole($userId: ID!, $roleId: ID!) {
    addUserToRole(userId: $userId, roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useAddUserToRoleMutation__
 *
 * To run a mutation, you first call `useAddUserToRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserToRoleMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAddUserToRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserToRoleMutation, AddUserToRoleMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserToRoleMutation, AddUserToRoleMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserToRoleMutation, AddUserToRoleMutationVariables>(
    AddUserToRoleDocument,
    options,
  );
}
export type AddUserToRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserToRoleMutation,
  AddUserToRoleMutationVariables
>;
export const RemoveUserFromRoleDocument = gql`
  mutation removeUserFromRole($userId: ID!, $roleId: ID!) {
    removeUserFromRole(userId: $userId, roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useRemoveUserFromRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserFromRoleMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemoveUserFromRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>(
    RemoveUserFromRoleDocument,
    options,
  );
}
export type RemoveUserFromRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserFromRoleMutation,
  RemoveUserFromRoleMutationVariables
>;
export const UpdateUserTimeLimitedAccessDocument = gql`
  mutation updateUserTimeLimitedAccess($userId: ID!, $timeLimitedAccess: PeriodInput) {
    updateUserTimeLimitedAccess(userId: $userId, timeLimitedAccess: $timeLimitedAccess) {
      success
      inputValidation {
        message
      }
    }
  }
`;

/**
 * __useUpdateUserTimeLimitedAccessMutation__
 *
 * To run a mutation, you first call `useUpdateUserTimeLimitedAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTimeLimitedAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserTimeLimitedAccessMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     timeLimitedAccess: // value for 'timeLimitedAccess'
 *   },
 * });
 */
export function useUpdateUserTimeLimitedAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserTimeLimitedAccessMutation,
        UpdateUserTimeLimitedAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserTimeLimitedAccessMutation,
          UpdateUserTimeLimitedAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateUserTimeLimitedAccessMutation,
    UpdateUserTimeLimitedAccessMutationVariables
  >(UpdateUserTimeLimitedAccessDocument, options);
}
export type UpdateUserTimeLimitedAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserTimeLimitedAccessMutation,
  UpdateUserTimeLimitedAccessMutationVariables
>;
export const StartZoneStateStreamDocument = gql`
  mutation startZoneStateStream($cameraId: ID!, $streamId: ID) {
    stream: startZoneStateStream(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useStartZoneStateStreamMutation__
 *
 * To run a mutation, you first call `useStartZoneStateStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartZoneStateStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartZoneStateStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStartZoneStateStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartZoneStateStreamMutation, StartZoneStateStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartZoneStateStreamMutation, StartZoneStateStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartZoneStateStreamMutation, StartZoneStateStreamMutationVariables>(
    StartZoneStateStreamDocument,
    options,
  );
}
export type StartZoneStateStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartZoneStateStreamMutation,
  StartZoneStateStreamMutationVariables
>;
export const StopZoneStateStreamDocument = gql`
  mutation stopZoneStateStream($cameraId: ID!, $streamId: ID!) {
    stream: stopZoneStateStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopZoneStateStreamMutation__
 *
 * To run a mutation, you first call `useStopZoneStateStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopZoneStateStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopZoneStateStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopZoneStateStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopZoneStateStreamMutation, StopZoneStateStreamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StopZoneStateStreamMutation, StopZoneStateStreamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StopZoneStateStreamMutation, StopZoneStateStreamMutationVariables>(
    StopZoneStateStreamDocument,
    options,
  );
}
export type StopZoneStateStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopZoneStateStreamMutation,
  StopZoneStateStreamMutationVariables
>;
export const KeepZoneStateStreamAliveDocument = gql`
  mutation keepZoneStateStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepZoneStateStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
      renewAfterSec
    }
  }
`;

/**
 * __useKeepZoneStateStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepZoneStateStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepZoneStateStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepZoneStateStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepZoneStateStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        KeepZoneStateStreamAliveMutation,
        KeepZoneStateStreamAliveMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          KeepZoneStateStreamAliveMutation,
          KeepZoneStateStreamAliveMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<KeepZoneStateStreamAliveMutation, KeepZoneStateStreamAliveMutationVariables>(
    KeepZoneStateStreamAliveDocument,
    options,
  );
}
export type KeepZoneStateStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepZoneStateStreamAliveMutation,
  KeepZoneStateStreamAliveMutationVariables
>;
export const CameraProvisioningBatchTelluSupportDocument = gql`
  query cameraProvisioningBatchTelluSupport {
    cameraProvisioningBatchTelluSupport {
      type
      serial
      cameraName
      cameraSetup {
        model
        serial
        oak
        cameraName
        customerId
        siteId
        deviceGroupId
        installVMD
        installFG
        installPS
        installOA
        enableAudio
        firmwareUpgrade
        installApps
      }
      apps {
        id
        install
        activate
        deactivate
        uninstall
      }
      status {
        step
        status
        timestamp
      }
      logs
    }
  }
`;

/**
 * __useCameraProvisioningBatchTelluSupportQuery__
 *
 * To run a query within a Vue component, call `useCameraProvisioningBatchTelluSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraProvisioningBatchTelluSupportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraProvisioningBatchTelluSupportQuery();
 */
export function useCameraProvisioningBatchTelluSupportQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        CameraProvisioningBatchTelluSupportQuery,
        CameraProvisioningBatchTelluSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    CameraProvisioningBatchTelluSupportQuery,
    CameraProvisioningBatchTelluSupportQueryVariables
  >(CameraProvisioningBatchTelluSupportDocument, {}, options);
}
export function useCameraProvisioningBatchTelluSupportLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        CameraProvisioningBatchTelluSupportQuery,
        CameraProvisioningBatchTelluSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    CameraProvisioningBatchTelluSupportQuery,
    CameraProvisioningBatchTelluSupportQueryVariables
  >(CameraProvisioningBatchTelluSupportDocument, {}, options);
}
export type CameraProvisioningBatchTelluSupportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraProvisioningBatchTelluSupportQuery,
  CameraProvisioningBatchTelluSupportQueryVariables
>;
export const CameraManagementLogsBySerialDocument = gql`
  query cameraManagementLogsBySerial($serial: String!, $from: dateTime, $to: dateTime) {
    cameraManagementLogsBySerial(serial: $serial, from: $from, to: $to) {
      type
      serial
      cameraName
      user
      createdAt
      updatedAt
      logs
    }
  }
`;

/**
 * __useCameraManagementLogsBySerialQuery__
 *
 * To run a query within a Vue component, call `useCameraManagementLogsBySerialQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraManagementLogsBySerialQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraManagementLogsBySerialQuery({
 *   serial: // value for 'serial'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useCameraManagementLogsBySerialQuery(
  variables:
    | CameraManagementLogsBySerialQueryVariables
    | VueCompositionApi.Ref<CameraManagementLogsBySerialQueryVariables>
    | ReactiveFunction<CameraManagementLogsBySerialQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraManagementLogsBySerialQuery, CameraManagementLogsBySerialQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraManagementLogsBySerialQuery,
          CameraManagementLogsBySerialQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraManagementLogsBySerialQuery,
          CameraManagementLogsBySerialQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<CameraManagementLogsBySerialQuery, CameraManagementLogsBySerialQueryVariables>(
    CameraManagementLogsBySerialDocument,
    variables,
    options,
  );
}
export function useCameraManagementLogsBySerialLazyQuery(
  variables?:
    | CameraManagementLogsBySerialQueryVariables
    | VueCompositionApi.Ref<CameraManagementLogsBySerialQueryVariables>
    | ReactiveFunction<CameraManagementLogsBySerialQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraManagementLogsBySerialQuery, CameraManagementLogsBySerialQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraManagementLogsBySerialQuery,
          CameraManagementLogsBySerialQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraManagementLogsBySerialQuery,
          CameraManagementLogsBySerialQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    CameraManagementLogsBySerialQuery,
    CameraManagementLogsBySerialQueryVariables
  >(CameraManagementLogsBySerialDocument, variables, options);
}
export type CameraManagementLogsBySerialQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraManagementLogsBySerialQuery,
  CameraManagementLogsBySerialQueryVariables
>;
export const CameraSupportReportDocument = gql`
  query cameraSupportReport($serial: String!) {
    cameraSupportReport(serial: $serial)
  }
`;

/**
 * __useCameraSupportReportQuery__
 *
 * To run a query within a Vue component, call `useCameraSupportReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraSupportReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraSupportReportQuery({
 *   serial: // value for 'serial'
 * });
 */
export function useCameraSupportReportQuery(
  variables:
    | CameraSupportReportQueryVariables
    | VueCompositionApi.Ref<CameraSupportReportQueryVariables>
    | ReactiveFunction<CameraSupportReportQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<CameraSupportReportQuery, CameraSupportReportQueryVariables>(
    CameraSupportReportDocument,
    variables,
    options,
  );
}
export function useCameraSupportReportLazyQuery(
  variables?:
    | CameraSupportReportQueryVariables
    | VueCompositionApi.Ref<CameraSupportReportQueryVariables>
    | ReactiveFunction<CameraSupportReportQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraSupportReportQuery, CameraSupportReportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<CameraSupportReportQuery, CameraSupportReportQueryVariables>(
    CameraSupportReportDocument,
    variables,
    options,
  );
}
export type CameraSupportReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraSupportReportQuery,
  CameraSupportReportQueryVariables
>;
export const CameraSetupDocument = gql`
  query cameraSetup {
    deviceGroups {
      id
      name
    }
    morpheanSitesPerMorpheanCustomerTelluSupport {
      customerId
      customerName
      morpheanSites {
        siteId
        siteName
      }
    }
    supportedCameraModelsTelluSupport {
      model
      availability
      apps {
        id
        name
        version
        supportedModels
        default
      }
    }
  }
`;

/**
 * __useCameraSetupQuery__
 *
 * To run a query within a Vue component, call `useCameraSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraSetupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraSetupQuery();
 */
export function useCameraSetupQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CameraSetupQuery, CameraSetupQueryVariables>(CameraSetupDocument, {}, options);
}
export function useCameraSetupLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CameraSetupQuery, CameraSetupQueryVariables>(
    CameraSetupDocument,
    {},
    options,
  );
}
export type CameraSetupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraSetupQuery,
  CameraSetupQueryVariables
>;
export const SupportedCameraAppsDocument = gql`
  query supportedCameraApps {
    supportedCameraApps {
      id
      name
      version
      supportedModels
      default
      experimental
    }
  }
`;

/**
 * __useSupportedCameraAppsQuery__
 *
 * To run a query within a Vue component, call `useSupportedCameraAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCameraAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportedCameraAppsQuery();
 */
export function useSupportedCameraAppsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>(
    SupportedCameraAppsDocument,
    {},
    options,
  );
}
export function useSupportedCameraAppsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>(
    SupportedCameraAppsDocument,
    {},
    options,
  );
}
export type SupportedCameraAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportedCameraAppsQuery,
  SupportedCameraAppsQueryVariables
>;
export const GetCameraManagementListDocument = gql`
  query getCameraManagementList {
    getCameraManagementList {
      id
      name
      macAddress
      model
      arch
      soc
      firmware
      latestFirmware
      deviceGroupId
      deviceGroup
      inRegistry
      inAccount
      isAttachedToPatient
      inMorphean
      connectedToMorphean
      lastSeen
      routerVendor
      routerMac
      mqttConfig {
        url
        state
        connectionStatus
      }
      time {
        timezone
        obtainFromDHCP
      }
      apps {
        id
        name
        version
        latestVersion
        status
        profileCount
      }
      network {
        bonjour
        dot1x
        ftp
        ssh
        upnp
        zeroConf
        allowOldTLS
        https
        bandwidthLimit
        isHardened
      }
      audio {
        enabled
        audioSupported
        inputGain
        inputType
        microphonePowerType
        microphonePowered
      }
      ptz {
        enabled
        locked
        returnToOverviewawait
      }
      video {
        enabled
        rtsp
        compression
        mirrored
        resolution
        rotation
        iCount
        pCount
        rateControlPriority
        targetBitRate
        fps
        captureFrequency
        exposureMode
        whiteBalanceMode
        dayNight {
          cutFilterMode
          shiftLevel
          manualIrOverriden
        }
      }
    }
  }
`;

/**
 * __useGetCameraManagementListQuery__
 *
 * To run a query within a Vue component, call `useGetCameraManagementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraManagementListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraManagementListQuery();
 */
export function useGetCameraManagementListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>(
    GetCameraManagementListDocument,
    {},
    options,
  );
}
export function useGetCameraManagementListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>(
    GetCameraManagementListDocument,
    {},
    options,
  );
}
export type GetCameraManagementListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraManagementListQuery,
  GetCameraManagementListQueryVariables
>;
export const HealthProviderSettingsDocument = gql`
  query healthProviderSettings {
    healthProviderSettings {
      patientAuth {
        twoFactorSms
        ipRestriction
        timeLimitedAccess
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
          support
        }
      }
      userAuth {
        twoFactorSms
        twoFactorAppRequired
        ipRestriction
        timeLimitedAccess
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
          support
          provider
        }
      }
      externalHumanIdTypes {
        id
        use {
          patientUse {
            applicable
            immutable
          }
          personnelUse {
            applicable
          }
        }
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsQuery();
 */
export function useHealthProviderSettingsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>(
    HealthProviderSettingsDocument,
    {},
    options,
  );
}
export function useHealthProviderSettingsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>(
    HealthProviderSettingsDocument,
    {},
    options,
  );
}
export type HealthProviderSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderSettingsQuery,
  HealthProviderSettingsQueryVariables
>;
export const GetListOfUnallocatedCamerasDocument = gql`
  query getListOfUnallocatedCameras {
    getListOfUnallocatedCameras {
      id
      name
      macAddress
      active
      modelName
      cameraProfile {
        id
      }
    }
  }
`;

/**
 * __useGetListOfUnallocatedCamerasQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedCamerasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedCamerasQuery();
 */
export function useGetListOfUnallocatedCamerasQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>(
    GetListOfUnallocatedCamerasDocument,
    {},
    options,
  );
}
export function useGetListOfUnallocatedCamerasLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>(
    GetListOfUnallocatedCamerasDocument,
    {},
    options,
  );
}
export type GetListOfUnallocatedCamerasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedCamerasQuery,
  GetListOfUnallocatedCamerasQueryVariables
>;
export const PatientForCameraSupervisionDocument = gql`
  query patientForCameraSupervision($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      alarmRoutes {
        configId
        configName
        configType
        idMappingStrategy
        incomingTemplate {
          isPresentInAccount
          code
          technical
          title
          system
          displayText
          icon
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          technical
          system
          displayText
          icon
        }
        patientGroupId
        routeId
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
          privacyModeUntil
        }
        deviceGroup {
          name
          id
          enableFurnitureDetection
        }
        cameraProfile {
          ...CameraProfileSettings
        }
        effectiveSettings {
          ...CameraEffectiveSettingsFields
        }
        patientReference {
          reference
        }
        userHasAccessToPatient
      }
    }
  }
  ${CameraProfileSettingsFragmentDoc}
  ${CameraEffectiveSettingsFieldsFragmentDoc}
`;

/**
 * __usePatientForCameraSupervisionQuery__
 *
 * To run a query within a Vue component, call `usePatientForCameraSupervisionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForCameraSupervisionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForCameraSupervisionQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientForCameraSupervisionQuery(
  variables:
    | PatientForCameraSupervisionQueryVariables
    | VueCompositionApi.Ref<PatientForCameraSupervisionQueryVariables>
    | ReactiveFunction<PatientForCameraSupervisionQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>(
    PatientForCameraSupervisionDocument,
    variables,
    options,
  );
}
export function usePatientForCameraSupervisionLazyQuery(
  variables?:
    | PatientForCameraSupervisionQueryVariables
    | VueCompositionApi.Ref<PatientForCameraSupervisionQueryVariables>
    | ReactiveFunction<PatientForCameraSupervisionQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForCameraSupervisionQuery, PatientForCameraSupervisionQueryVariables>(
    PatientForCameraSupervisionDocument,
    variables,
    options,
  );
}
export type PatientForCameraSupervisionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForCameraSupervisionQuery,
  PatientForCameraSupervisionQueryVariables
>;
export const GetAlarmTemplatesDocument = gql`
  query getAlarmTemplates {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      description
      status
      code {
        coding {
          display
          code
          system
        }
        text
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
      }
      alarmIcon
      callbackMinutes
      technical
      tagAction {
        target
        type
        label
      }
      generatesAlarm
      noCarePlanRequired
      resolveAction
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      cep {
        trigger
        after
        cancelledBy
      }
      timedCep {
        events
        cancelledBy
        mode
      }
    }
  }
`;

/**
 * __useGetAlarmTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesQuery();
 */
export function useGetAlarmTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>(
    GetAlarmTemplatesDocument,
    {},
    options,
  );
}
export function useGetAlarmTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmTemplatesQuery, GetAlarmTemplatesQueryVariables>(
    GetAlarmTemplatesDocument,
    {},
    options,
  );
}
export type GetAlarmTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesQuery,
  GetAlarmTemplatesQueryVariables
>;
export const GetCameraAdminAppsDocument = gql`
  query getCameraAdminApps($cameraId: ID!) {
    getCameraAdmin(cameraId: $cameraId) {
      id
      adminApps {
        id
        status
        profiles {
          id
          name
          cameraTopic
        }
      }
    }
  }
`;

/**
 * __useGetCameraAdminAppsQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminAppsQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraAdminAppsQuery(
  variables:
    | GetCameraAdminAppsQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminAppsQueryVariables>
    | ReactiveFunction<GetCameraAdminAppsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>(
    GetCameraAdminAppsDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminAppsLazyQuery(
  variables?:
    | GetCameraAdminAppsQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminAppsQueryVariables>
    | ReactiveFunction<GetCameraAdminAppsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>(
    GetCameraAdminAppsDocument,
    variables,
    options,
  );
}
export type GetCameraAdminAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminAppsQuery,
  GetCameraAdminAppsQueryVariables
>;
export const GetCameraAdminDocument = gql`
  query getCameraAdmin($cameraId: ID!, $overrideReason: String) {
    getCameraAdmin(cameraId: $cameraId, overrideReason: $overrideReason) {
      id
      online
      firmware
      adminApps {
        id
        name
        status
      }
      router {
        mac
        vendor
      }
    }
  }
`;

/**
 * __useGetCameraAdminQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminQuery({
 *   cameraId: // value for 'cameraId'
 *   overrideReason: // value for 'overrideReason'
 * });
 */
export function useGetCameraAdminQuery(
  variables:
    | GetCameraAdminQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminQueryVariables>
    | ReactiveFunction<GetCameraAdminQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminQuery, GetCameraAdminQueryVariables>(
    GetCameraAdminDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminLazyQuery(
  variables?:
    | GetCameraAdminQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminQueryVariables>
    | ReactiveFunction<GetCameraAdminQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminQuery, GetCameraAdminQueryVariables>(
    GetCameraAdminDocument,
    variables,
    options,
  );
}
export type GetCameraAdminQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminQuery,
  GetCameraAdminQueryVariables
>;
export const GetCameraAdminUrlDocument = gql`
  query getCameraAdminUrl($cameraId: ID!, $appId: String, $overrideReason: String) {
    getCameraAdminUrl(cameraId: $cameraId, appId: $appId, overrideReason: $overrideReason)
  }
`;

/**
 * __useGetCameraAdminUrlQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminUrlQuery({
 *   cameraId: // value for 'cameraId'
 *   appId: // value for 'appId'
 *   overrideReason: // value for 'overrideReason'
 * });
 */
export function useGetCameraAdminUrlQuery(
  variables:
    | GetCameraAdminUrlQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminUrlQueryVariables>
    | ReactiveFunction<GetCameraAdminUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>(
    GetCameraAdminUrlDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminUrlLazyQuery(
  variables?:
    | GetCameraAdminUrlQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminUrlQueryVariables>
    | ReactiveFunction<GetCameraAdminUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>(
    GetCameraAdminUrlDocument,
    variables,
    options,
  );
}
export type GetCameraAdminUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminUrlQuery,
  GetCameraAdminUrlQueryVariables
>;
export const GetAuditEntitySummaryDocument = gql`
  query getAuditEntitySummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditEntitySummary(from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditEntitySummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditEntitySummaryQuery(
  variables:
    | GetAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>(
    GetAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditEntitySummaryLazyQuery(
  variables:
    | GetAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>(
    GetAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditEntitySummaryQuery,
  GetAuditEntitySummaryQueryVariables
>;
export const GetAuditLogPaginatedDocument = gql`
  query getAuditLogPaginated(
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogPaginated(
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogPaginatedQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogPaginatedQuery(
  variables:
    | GetAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>(
    GetAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export function useGetAuditLogPaginatedLazyQuery(
  variables:
    | GetAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>(
    GetAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export type GetAuditLogPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogPaginatedQuery,
  GetAuditLogPaginatedQueryVariables
>;
export const GetAuditLogEventForPatientByIdDocument = gql`
  query getAuditLogEventForPatientById($id: ID!, $patientId: ID!) {
    getAuditLogEventForPatientById(id: $id, patientId: $patientId) {
      id
      action
      recorded
      outcome
      outcomeDesc
      agent {
        name
      }
      entity {
        what {
          reference
          identifier {
            value
          }
          type
          display
        }
        role {
          system
          version
          code
          display
          userSelected
        }
        name
        detail {
          type
          valueString
        }
      }
      session
      operation
      patientName
      userName
    }
  }
`;

/**
 * __useGetAuditLogEventForPatientByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogEventForPatientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEventForPatientByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogEventForPatientByIdQuery({
 *   id: // value for 'id'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAuditLogEventForPatientByIdQuery(
  variables:
    | GetAuditLogEventForPatientByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForPatientByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForPatientByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForPatientByIdQuery,
        GetAuditLogEventForPatientByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogEventForPatientByIdQuery,
    GetAuditLogEventForPatientByIdQueryVariables
  >(GetAuditLogEventForPatientByIdDocument, variables, options);
}
export function useGetAuditLogEventForPatientByIdLazyQuery(
  variables?:
    | GetAuditLogEventForPatientByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForPatientByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForPatientByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForPatientByIdQuery,
        GetAuditLogEventForPatientByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogEventForPatientByIdQuery,
    GetAuditLogEventForPatientByIdQueryVariables
  >(GetAuditLogEventForPatientByIdDocument, variables, options);
}
export type GetAuditLogEventForPatientByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogEventForPatientByIdQuery,
  GetAuditLogEventForPatientByIdQueryVariables
>;
export const GetAuditLogEventForUserGroupByIdDocument = gql`
  query getAuditLogEventForUserGroupById($id: ID!, $userGroupId: ID!) {
    getAuditLogEventForUserGroupById(id: $id, userGroupId: $userGroupId) {
      id
      action
      recorded
      outcome
      outcomeDesc
      agent {
        name
      }
      entity {
        what {
          reference
          identifier {
            value
          }
          type
          display
        }
        type {
          system
          version
          code
          display
          userSelected
        }
        role {
          system
          version
          code
          display
          userSelected
        }
        name
        detail {
          type
          valueString
        }
      }
      session
      operation
      patientName
      userName
    }
  }
`;

/**
 * __useGetAuditLogEventForUserGroupByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogEventForUserGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEventForUserGroupByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogEventForUserGroupByIdQuery({
 *   id: // value for 'id'
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAuditLogEventForUserGroupByIdQuery(
  variables:
    | GetAuditLogEventForUserGroupByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForUserGroupByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForUserGroupByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForUserGroupByIdQuery,
        GetAuditLogEventForUserGroupByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogEventForUserGroupByIdQuery,
    GetAuditLogEventForUserGroupByIdQueryVariables
  >(GetAuditLogEventForUserGroupByIdDocument, variables, options);
}
export function useGetAuditLogEventForUserGroupByIdLazyQuery(
  variables?:
    | GetAuditLogEventForUserGroupByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForUserGroupByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForUserGroupByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForUserGroupByIdQuery,
        GetAuditLogEventForUserGroupByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogEventForUserGroupByIdQuery,
    GetAuditLogEventForUserGroupByIdQueryVariables
  >(GetAuditLogEventForUserGroupByIdDocument, variables, options);
}
export type GetAuditLogEventForUserGroupByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogEventForUserGroupByIdQuery,
  GetAuditLogEventForUserGroupByIdQueryVariables
>;
export const GetAuditLogForPatientPaginatedDocument = gql`
  query getAuditLogForPatientPaginated(
    $patientId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogForPatientPaginated(
      patientId: $patientId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogForPatientPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogForPatientPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogForPatientPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogForPatientPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogForPatientPaginatedQuery(
  variables:
    | GetAuditLogForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogForPatientPaginatedQuery,
        GetAuditLogForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogForPatientPaginatedQuery,
    GetAuditLogForPatientPaginatedQueryVariables
  >(GetAuditLogForPatientPaginatedDocument, variables, options);
}
export function useGetAuditLogForPatientPaginatedLazyQuery(
  variables?:
    | GetAuditLogForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogForPatientPaginatedQuery,
        GetAuditLogForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogForPatientPaginatedQuery,
    GetAuditLogForPatientPaginatedQueryVariables
  >(GetAuditLogForPatientPaginatedDocument, variables, options);
}
export type GetAuditLogForPatientPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogForPatientPaginatedQuery,
  GetAuditLogForPatientPaginatedQueryVariables
>;
export const GetAuditLogForUserPaginatedDocument = gql`
  query getAuditLogForUserPaginated(
    $userId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogForUserPaginated(
      userId: $userId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogForUserPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogForUserPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogForUserPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogForUserPaginatedQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogForUserPaginatedQuery(
  variables:
    | GetAuditLogForUserPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForUserPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForUserPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>(
    GetAuditLogForUserPaginatedDocument,
    variables,
    options,
  );
}
export function useGetAuditLogForUserPaginatedLazyQuery(
  variables?:
    | GetAuditLogForUserPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForUserPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForUserPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>(
    GetAuditLogForUserPaginatedDocument,
    variables,
    options,
  );
}
export type GetAuditLogForUserPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogForUserPaginatedQuery,
  GetAuditLogForUserPaginatedQueryVariables
>;
export const GetAuditLogSummaryDocument = gql`
  query getAuditLogSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditLogSummary(from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditLogSummaryQuery(
  variables:
    | GetAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>(
    GetAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditLogSummaryLazyQuery(
  variables:
    | GetAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>(
    GetAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogSummaryQuery,
  GetAuditLogSummaryQueryVariables
>;
export const GetAuditRoleSummaryDocument = gql`
  query getAuditRoleSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditRoleSummary(from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditRoleSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditRoleSummaryQuery(
  variables:
    | GetAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>(
    GetAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditRoleSummaryLazyQuery(
  variables:
    | GetAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>(
    GetAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditRoleSummaryQuery,
  GetAuditRoleSummaryQueryVariables
>;
export const AuthEventsDocument = gql`
  query authEvents($filter: AuthEventFilter) {
    authEvents(filter: $filter) {
      time
      type
      userId
      sessionId
      ipAddress
      error
      details {
        key
        value
      }
    }
  }
`;

/**
 * __useAuthEventsQuery__
 *
 * To run a query within a Vue component, call `useAuthEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAuthEventsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useAuthEventsQuery(
  variables:
    | AuthEventsQueryVariables
    | VueCompositionApi.Ref<AuthEventsQueryVariables>
    | ReactiveFunction<AuthEventsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AuthEventsQuery, AuthEventsQueryVariables>(
    AuthEventsDocument,
    variables,
    options,
  );
}
export function useAuthEventsLazyQuery(
  variables:
    | AuthEventsQueryVariables
    | VueCompositionApi.Ref<AuthEventsQueryVariables>
    | ReactiveFunction<AuthEventsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthEventsQuery, AuthEventsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AuthEventsQuery, AuthEventsQueryVariables>(
    AuthEventsDocument,
    variables,
    options,
  );
}
export type AuthEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AuthEventsQuery,
  AuthEventsQueryVariables
>;
export const GetReferenceObjectsForCameraDocument = gql`
  query getReferenceObjectsForCamera($cameraId: ID!) {
    getReferenceObjectsForCamera(cameraId: $cameraId) {
      type
      sensitivity
      boundingBox {
        topLeftX
        topLeftY
        bottomRightX
        bottomRightY
      }
    }
  }
`;

/**
 * __useGetReferenceObjectsForCameraQuery__
 *
 * To run a query within a Vue component, call `useGetReferenceObjectsForCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceObjectsForCameraQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReferenceObjectsForCameraQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetReferenceObjectsForCameraQuery(
  variables:
    | GetReferenceObjectsForCameraQueryVariables
    | VueCompositionApi.Ref<GetReferenceObjectsForCameraQueryVariables>
    | ReactiveFunction<GetReferenceObjectsForCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetReferenceObjectsForCameraQuery, GetReferenceObjectsForCameraQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetReferenceObjectsForCameraQuery,
          GetReferenceObjectsForCameraQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetReferenceObjectsForCameraQuery,
          GetReferenceObjectsForCameraQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetReferenceObjectsForCameraQuery, GetReferenceObjectsForCameraQueryVariables>(
    GetReferenceObjectsForCameraDocument,
    variables,
    options,
  );
}
export function useGetReferenceObjectsForCameraLazyQuery(
  variables?:
    | GetReferenceObjectsForCameraQueryVariables
    | VueCompositionApi.Ref<GetReferenceObjectsForCameraQueryVariables>
    | ReactiveFunction<GetReferenceObjectsForCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetReferenceObjectsForCameraQuery, GetReferenceObjectsForCameraQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetReferenceObjectsForCameraQuery,
          GetReferenceObjectsForCameraQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetReferenceObjectsForCameraQuery,
          GetReferenceObjectsForCameraQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetReferenceObjectsForCameraQuery,
    GetReferenceObjectsForCameraQueryVariables
  >(GetReferenceObjectsForCameraDocument, variables, options);
}
export type GetReferenceObjectsForCameraQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetReferenceObjectsForCameraQuery,
  GetReferenceObjectsForCameraQueryVariables
>;
export const GetOwnerAuditEntitySummaryDocument = gql`
  query getOwnerAuditEntitySummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditEntitySummary(from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetOwnerAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditEntitySummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditEntitySummaryQuery(
  variables:
    | GetOwnerAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>(
    GetOwnerAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditEntitySummaryLazyQuery(
  variables:
    | GetOwnerAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>(
    GetOwnerAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditEntitySummaryQuery,
  GetOwnerAuditEntitySummaryQueryVariables
>;
export const GetOwnerAuditLogPaginatedDocument = gql`
  query getOwnerAuditLogPaginated(
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getOwnerAuditLogPaginated(
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        type {
          code
        }
        action
        period {
          start
          end
        }
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetOwnerAuditLogPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogPaginatedQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetOwnerAuditLogPaginatedQuery(
  variables:
    | GetOwnerAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>(
    GetOwnerAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogPaginatedLazyQuery(
  variables:
    | GetOwnerAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>(
    GetOwnerAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogPaginatedQuery,
  GetOwnerAuditLogPaginatedQueryVariables
>;
export const GetOwnerAuditLogSummaryDocument = gql`
  query getOwnerAuditLogSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditLogSummary(from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetOwnerAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditLogSummaryQuery(
  variables:
    | GetOwnerAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>(
    GetOwnerAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogSummaryLazyQuery(
  variables:
    | GetOwnerAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>(
    GetOwnerAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogSummaryQuery,
  GetOwnerAuditLogSummaryQueryVariables
>;
export const GetOwnerAuditRoleSummaryDocument = gql`
  query getOwnerAuditRoleSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditRoleSummary(from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetOwnerAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditRoleSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditRoleSummaryQuery(
  variables:
    | GetOwnerAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>(
    GetOwnerAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditRoleSummaryLazyQuery(
  variables:
    | GetOwnerAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>(
    GetOwnerAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditRoleSummaryQuery,
  GetOwnerAuditRoleSummaryQueryVariables
>;
export const GetPatientAuditEntitySummaryDocument = gql`
  query getPatientAuditEntitySummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditEntitySummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetPatientAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditEntitySummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditEntitySummaryQuery(
  variables:
    | GetPatientAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>(
    GetPatientAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditEntitySummaryLazyQuery(
  variables?:
    | GetPatientAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientAuditEntitySummaryQuery,
    GetPatientAuditEntitySummaryQueryVariables
  >(GetPatientAuditEntitySummaryDocument, variables, options);
}
export type GetPatientAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditEntitySummaryQuery,
  GetPatientAuditEntitySummaryQueryVariables
>;
export const GetPatientAuditLogSummaryDocument = gql`
  query getPatientAuditLogSummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditLogSummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetPatientAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditLogSummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditLogSummaryQuery(
  variables:
    | GetPatientAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>(
    GetPatientAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditLogSummaryLazyQuery(
  variables?:
    | GetPatientAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>(
    GetPatientAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetPatientAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditLogSummaryQuery,
  GetPatientAuditLogSummaryQueryVariables
>;
export const GetPatientAuditRoleSummaryDocument = gql`
  query getPatientAuditRoleSummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditRoleSummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetPatientAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditRoleSummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditRoleSummaryQuery(
  variables:
    | GetPatientAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>(
    GetPatientAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditRoleSummaryLazyQuery(
  variables?:
    | GetPatientAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>(
    GetPatientAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetPatientAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditRoleSummaryQuery,
  GetPatientAuditRoleSummaryQueryVariables
>;
export const GetUserAuditEntitySummaryDocument = gql`
  query getUserAuditEntitySummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditEntitySummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetUserAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditEntitySummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditEntitySummaryQuery(
  variables:
    | GetUserAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetUserAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>(
    GetUserAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditEntitySummaryLazyQuery(
  variables?:
    | GetUserAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetUserAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>(
    GetUserAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditEntitySummaryQuery,
  GetUserAuditEntitySummaryQueryVariables
>;
export const GetUserAuditLogSummaryDocument = gql`
  query getUserAuditLogSummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditLogSummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetUserAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditLogSummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditLogSummaryQuery(
  variables:
    | GetUserAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>(
    GetUserAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditLogSummaryLazyQuery(
  variables?:
    | GetUserAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>(
    GetUserAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditLogSummaryQuery,
  GetUserAuditLogSummaryQueryVariables
>;
export const GetUserAuditRoleSummaryDocument = gql`
  query getUserAuditRoleSummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditRoleSummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetUserAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditRoleSummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditRoleSummaryQuery(
  variables:
    | GetUserAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>(
    GetUserAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditRoleSummaryLazyQuery(
  variables?:
    | GetUserAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>(
    GetUserAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditRoleSummaryQuery,
  GetUserAuditRoleSummaryQueryVariables
>;
export const AccountSettingsDocument = gql`
  query accountSettings {
    accountSettings {
      ...AccountDetails
      userSessionLifespan
      userAuth {
        ...AccountUserAuth
      }
      applications {
        ...AccountProductApplications
      }
      features {
        ...AccountProductFeatures
        ...AccountSecurityFeatures
      }
    }
  }
  ${AccountDetailsFragmentDoc}
  ${AccountUserAuthFragmentDoc}
  ${AccountProductApplicationsFragmentDoc}
  ${AccountProductFeaturesFragmentDoc}
  ${AccountSecurityFeaturesFragmentDoc}
`;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a Vue component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAccountSettingsQuery();
 */
export function useAccountSettingsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(
    AccountSettingsDocument,
    {},
    options,
  );
}
export function useAccountSettingsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AccountSettingsQuery, AccountSettingsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(
    AccountSettingsDocument,
    {},
    options,
  );
}
export type AccountSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AccountSettingsQuery,
  AccountSettingsQueryVariables
>;
export const AllShiftSessionsDocument = gql`
  query allShiftSessions {
    allShiftSessions {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
        createdAt
      }
      notificationSettings {
        shiftSessionPhoneNumber
        name
        username
        userId
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useAllShiftSessionsQuery__
 *
 * To run a query within a Vue component, call `useAllShiftSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShiftSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllShiftSessionsQuery();
 */
export function useAllShiftSessionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>(
    AllShiftSessionsDocument,
    {},
    options,
  );
}
export function useAllShiftSessionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>(
    AllShiftSessionsDocument,
    {},
    options,
  );
}
export type AllShiftSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllShiftSessionsQuery,
  AllShiftSessionsQueryVariables
>;
export const AllUsersExportPaginatedDocument = gql`
  query allUsersExportPaginated($paging: UsersPagingInput!) {
    allUsersExportPaginated(paging: $paging) {
      users {
        firstName
        lastName
        username
        email
        lastActive
        ipRestrictions
        otpStatus
        smsOtpStatus
        created
        passwordStatus
        enabled
        externalIdentities {
          provider
        }
        externalUserIds {
          externalId
          externalHumanIdType {
            id
          }
        }
        roles {
          role {
            display {
              key
              value
            }
          }
          userGroup {
            name
          }
        }
      }
      cursor
      hasMore
      totalCount
    }
  }
`;

/**
 * __useAllUsersExportPaginatedQuery__
 *
 * To run a query within a Vue component, call `useAllUsersExportPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersExportPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllUsersExportPaginatedQuery({
 *   paging: // value for 'paging'
 * });
 */
export function useAllUsersExportPaginatedQuery(
  variables:
    | AllUsersExportPaginatedQueryVariables
    | VueCompositionApi.Ref<AllUsersExportPaginatedQueryVariables>
    | ReactiveFunction<AllUsersExportPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>(
    AllUsersExportPaginatedDocument,
    variables,
    options,
  );
}
export function useAllUsersExportPaginatedLazyQuery(
  variables?:
    | AllUsersExportPaginatedQueryVariables
    | VueCompositionApi.Ref<AllUsersExportPaginatedQueryVariables>
    | ReactiveFunction<AllUsersExportPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllUsersExportPaginatedQuery, AllUsersExportPaginatedQueryVariables>(
    AllUsersExportPaginatedDocument,
    variables,
    options,
  );
}
export type AllUsersExportPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllUsersExportPaginatedQuery,
  AllUsersExportPaginatedQueryVariables
>;
export const AzureAccountsDocument = gql`
  query azureAccounts {
    azureAccounts {
      id
      alias
      clientId
      displayName
      tenantId
      support
      patientRealm
    }
  }
`;

/**
 * __useAzureAccountsQuery__
 *
 * To run a query within a Vue component, call `useAzureAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAzureAccountsQuery();
 */
export function useAzureAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AzureAccountsQuery, AzureAccountsQueryVariables>(
    AzureAccountsDocument,
    {},
    options,
  );
}
export function useAzureAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AzureAccountsQuery, AzureAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AzureAccountsQuery, AzureAccountsQueryVariables>(
    AzureAccountsDocument,
    {},
    options,
  );
}
export type AzureAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AzureAccountsQuery,
  AzureAccountsQueryVariables
>;
export const AzureAccountsDetailsDocument = gql`
  query azureAccountsDetails($id: ID!) {
    azureAccounts(id: $id) {
      id
      alias
      clientId
      displayName
      tenantId
    }
  }
`;

/**
 * __useAzureAccountsDetailsQuery__
 *
 * To run a query within a Vue component, call `useAzureAccountsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureAccountsDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAzureAccountsDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useAzureAccountsDetailsQuery(
  variables:
    | AzureAccountsDetailsQueryVariables
    | VueCompositionApi.Ref<AzureAccountsDetailsQueryVariables>
    | ReactiveFunction<AzureAccountsDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>(
    AzureAccountsDetailsDocument,
    variables,
    options,
  );
}
export function useAzureAccountsDetailsLazyQuery(
  variables?:
    | AzureAccountsDetailsQueryVariables
    | VueCompositionApi.Ref<AzureAccountsDetailsQueryVariables>
    | ReactiveFunction<AzureAccountsDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AzureAccountsDetailsQuery, AzureAccountsDetailsQueryVariables>(
    AzureAccountsDetailsDocument,
    variables,
    options,
  );
}
export type AzureAccountsDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AzureAccountsDetailsQuery,
  AzureAccountsDetailsQueryVariables
>;
export const AzureAccountsProvisioningCredentialsDocument = gql`
  query azureAccountsProvisioningCredentials($id: ID!) {
    azureAccounts(id: $id) {
      id
      tenantId
      azureProvisioningCredentials {
        tenantUrl
        secretToken
      }
    }
  }
`;

/**
 * __useAzureAccountsProvisioningCredentialsQuery__
 *
 * To run a query within a Vue component, call `useAzureAccountsProvisioningCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureAccountsProvisioningCredentialsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAzureAccountsProvisioningCredentialsQuery({
 *   id: // value for 'id'
 * });
 */
export function useAzureAccountsProvisioningCredentialsQuery(
  variables:
    | AzureAccountsProvisioningCredentialsQueryVariables
    | VueCompositionApi.Ref<AzureAccountsProvisioningCredentialsQueryVariables>
    | ReactiveFunction<AzureAccountsProvisioningCredentialsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        AzureAccountsProvisioningCredentialsQuery,
        AzureAccountsProvisioningCredentialsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          AzureAccountsProvisioningCredentialsQuery,
          AzureAccountsProvisioningCredentialsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          AzureAccountsProvisioningCredentialsQuery,
          AzureAccountsProvisioningCredentialsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    AzureAccountsProvisioningCredentialsQuery,
    AzureAccountsProvisioningCredentialsQueryVariables
  >(AzureAccountsProvisioningCredentialsDocument, variables, options);
}
export function useAzureAccountsProvisioningCredentialsLazyQuery(
  variables?:
    | AzureAccountsProvisioningCredentialsQueryVariables
    | VueCompositionApi.Ref<AzureAccountsProvisioningCredentialsQueryVariables>
    | ReactiveFunction<AzureAccountsProvisioningCredentialsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        AzureAccountsProvisioningCredentialsQuery,
        AzureAccountsProvisioningCredentialsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          AzureAccountsProvisioningCredentialsQuery,
          AzureAccountsProvisioningCredentialsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          AzureAccountsProvisioningCredentialsQuery,
          AzureAccountsProvisioningCredentialsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    AzureAccountsProvisioningCredentialsQuery,
    AzureAccountsProvisioningCredentialsQueryVariables
  >(AzureAccountsProvisioningCredentialsDocument, variables, options);
}
export type AzureAccountsProvisioningCredentialsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AzureAccountsProvisioningCredentialsQuery,
  AzureAccountsProvisioningCredentialsQueryVariables
>;
export const CameraConfigurationDocument = gql`
  query cameraConfiguration($cameraId: ID!) {
    cameraConfiguration(cameraId: $cameraId) {
      cameraId
      zones {
        ...cameraZonesResult
      }
      detectionSettings {
        ...cameraDetectionSettingsResult
      }
    }
  }
  ${CameraZonesResultFragmentDoc}
  ${CameraDetectionSettingsResultFragmentDoc}
`;

/**
 * __useCameraConfigurationQuery__
 *
 * To run a query within a Vue component, call `useCameraConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraConfigurationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraConfigurationQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useCameraConfigurationQuery(
  variables:
    | CameraConfigurationQueryVariables
    | VueCompositionApi.Ref<CameraConfigurationQueryVariables>
    | ReactiveFunction<CameraConfigurationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<CameraConfigurationQuery, CameraConfigurationQueryVariables>(
    CameraConfigurationDocument,
    variables,
    options,
  );
}
export function useCameraConfigurationLazyQuery(
  variables?:
    | CameraConfigurationQueryVariables
    | VueCompositionApi.Ref<CameraConfigurationQueryVariables>
    | ReactiveFunction<CameraConfigurationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraConfigurationQuery, CameraConfigurationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<CameraConfigurationQuery, CameraConfigurationQueryVariables>(
    CameraConfigurationDocument,
    variables,
    options,
  );
}
export type CameraConfigurationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraConfigurationQuery,
  CameraConfigurationQueryVariables
>;
export const CameraProfilesDocument = gql`
  query cameraProfiles {
    cameraProfiles {
      ...CameraProfileFields
    }
  }
  ${CameraProfileFieldsFragmentDoc}
`;

/**
 * __useCameraProfilesQuery__
 *
 * To run a query within a Vue component, call `useCameraProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraProfilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraProfilesQuery();
 */
export function useCameraProfilesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CameraProfilesQuery, CameraProfilesQueryVariables>(
    CameraProfilesDocument,
    {},
    options,
  );
}
export function useCameraProfilesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraProfilesQuery, CameraProfilesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CameraProfilesQuery, CameraProfilesQueryVariables>(
    CameraProfilesDocument,
    {},
    options,
  );
}
export type CameraProfilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraProfilesQuery,
  CameraProfilesQueryVariables
>;
export const CameraProfileCameraCountDocument = gql`
  query cameraProfileCameraCount($id: ID!) {
    cameraProfile(id: $id) {
      id
      cameraCount
    }
  }
`;

/**
 * __useCameraProfileCameraCountQuery__
 *
 * To run a query within a Vue component, call `useCameraProfileCameraCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraProfileCameraCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraProfileCameraCountQuery({
 *   id: // value for 'id'
 * });
 */
export function useCameraProfileCameraCountQuery(
  variables:
    | CameraProfileCameraCountQueryVariables
    | VueCompositionApi.Ref<CameraProfileCameraCountQueryVariables>
    | ReactiveFunction<CameraProfileCameraCountQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>(
    CameraProfileCameraCountDocument,
    variables,
    options,
  );
}
export function useCameraProfileCameraCountLazyQuery(
  variables?:
    | CameraProfileCameraCountQueryVariables
    | VueCompositionApi.Ref<CameraProfileCameraCountQueryVariables>
    | ReactiveFunction<CameraProfileCameraCountQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<CameraProfileCameraCountQuery, CameraProfileCameraCountQueryVariables>(
    CameraProfileCameraCountDocument,
    variables,
    options,
  );
}
export type CameraProfileCameraCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraProfileCameraCountQuery,
  CameraProfileCameraCountQueryVariables
>;
export const GetPatientForCarePlanSimulatorDocument = gql`
  query getPatientForCarePlanSimulator($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      carePlans {
        id
        status
        subject {
          reference
        }
        title
        description
        created
        period {
          start
          end
        }
        activity {
          detail {
            scheduledTiming {
              event
              repeat {
                dayOfWeek
                timeOfDay
                periodUnit
                period
                boundsPeriod {
                  start
                  end
                }
              }
            }
            scheduledPeriod {
              start
              end
            }
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            questionnaires {
              id
              name
              title
              purpose
              status
              publisher
              description
              effectivePeriod {
                end
                start
              }
              item {
                linkId
                text
                type
                answerOption {
                  valueBoolean
                  valueInteger
                  valueString
                  valueDecimal
                  valueCoding {
                    code
                    display
                  }
                }
                required
              }
            }
          }
          outcomeReference {
            reference
            identifier {
              value
            }
            display
            type
          }
          observations {
            id
            identifier {
              value
            }
            text
            basedOn {
              reference
            }
            status
            note {
              text
            }
            fromTemplate {
              reference
            }
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            component {
              code {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
              valueQuantity {
                value
                unit
              }
              referenceRange {
                low {
                  value
                  unit
                }
                high {
                  value
                  unit
                }
                text
                type {
                  coding {
                    system
                    version
                    code
                    display
                  }
                  text
                }
              }
            }
          }
        }
      }
      referenceRange {
        id
        identifier {
          value
        }
        code {
          text
          coding {
            code
            display
          }
        }
        component {
          code {
            text
            coding {
              code
              display
            }
          }
          referenceRange {
            low {
              unit
              value
            }
            high {
              unit
              value
            }
            type {
              text
              coding {
                code
                display
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPatientForCarePlanSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetPatientForCarePlanSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientForCarePlanSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientForCarePlanSimulatorQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientForCarePlanSimulatorQuery(
  variables:
    | GetPatientForCarePlanSimulatorQueryVariables
    | VueCompositionApi.Ref<GetPatientForCarePlanSimulatorQueryVariables>
    | ReactiveFunction<GetPatientForCarePlanSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientForCarePlanSimulatorQuery,
        GetPatientForCarePlanSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetPatientForCarePlanSimulatorQuery,
    GetPatientForCarePlanSimulatorQueryVariables
  >(GetPatientForCarePlanSimulatorDocument, variables, options);
}
export function useGetPatientForCarePlanSimulatorLazyQuery(
  variables?:
    | GetPatientForCarePlanSimulatorQueryVariables
    | VueCompositionApi.Ref<GetPatientForCarePlanSimulatorQueryVariables>
    | ReactiveFunction<GetPatientForCarePlanSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientForCarePlanSimulatorQuery,
        GetPatientForCarePlanSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientForCarePlanSimulatorQuery,
    GetPatientForCarePlanSimulatorQueryVariables
  >(GetPatientForCarePlanSimulatorDocument, variables, options);
}
export type GetPatientForCarePlanSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientForCarePlanSimulatorQuery,
  GetPatientForCarePlanSimulatorQueryVariables
>;
export const ContinuousSupervisionCandidatesDocument = gql`
  query continuousSupervisionCandidates {
    getContinuousSupervisionCandidates {
      id
      firstName
      lastName
      cameras {
        id
        name
        macAddress
        deviceGroupName
      }
    }
  }
`;

/**
 * __useContinuousSupervisionCandidatesQuery__
 *
 * To run a query within a Vue component, call `useContinuousSupervisionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContinuousSupervisionCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContinuousSupervisionCandidatesQuery();
 */
export function useContinuousSupervisionCandidatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ContinuousSupervisionCandidatesQuery,
        ContinuousSupervisionCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    ContinuousSupervisionCandidatesQuery,
    ContinuousSupervisionCandidatesQueryVariables
  >(ContinuousSupervisionCandidatesDocument, {}, options);
}
export function useContinuousSupervisionCandidatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ContinuousSupervisionCandidatesQuery,
        ContinuousSupervisionCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ContinuousSupervisionCandidatesQuery,
    ContinuousSupervisionCandidatesQueryVariables
  >(ContinuousSupervisionCandidatesDocument, {}, options);
}
export type ContinuousSupervisionCandidatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ContinuousSupervisionCandidatesQuery,
  ContinuousSupervisionCandidatesQueryVariables
>;
export const DefaultTemplatesDocument = gql`
  query defaultTemplates {
    defaultTemplates {
      novo {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      camera {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      safemate {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      forwarding {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      delegation {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      videoMeeting {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        technical
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      measurement {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
        defaultTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
      accountTemplates {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        accountTemplate {
          id
          status
          alarmIcon
          callbackMinutes
          debounceDelay
          cep {
            trigger
            after
            cancelledBy
          }
          timedCep {
            events
            mode
            cancelledBy
          }
          technical
          tagAction {
            target
            type
            label
          }
          vkpEncounter {
            type
            reason
          }
          generatesAlarm
          locationTraceOnly
          noCarePlanRequired
          resolveAction
          identifier {
            value
          }
          description
          code {
            coding {
              display
              code
              system
            }
            text
          }
          effectiveTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
          interpretation {
            text
            coding {
              code
              display
            }
          }
          component {
            code {
              coding {
                system
                display
                code
              }
              text
            }
            extension {
              url
              valueBoolean
              valueInteger
              valueString
              ValueId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useDefaultTemplatesQuery__
 *
 * To run a query within a Vue component, call `useDefaultTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDefaultTemplatesQuery();
 */
export function useDefaultTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>(
    DefaultTemplatesDocument,
    {},
    options,
  );
}
export function useDefaultTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DefaultTemplatesQuery, DefaultTemplatesQueryVariables>(
    DefaultTemplatesDocument,
    {},
    options,
  );
}
export type DefaultTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DefaultTemplatesQuery,
  DefaultTemplatesQueryVariables
>;
export const FhirObservationTemplatesDocument = gql`
  query fhirObservationTemplates {
    fhirObservationTemplates
  }
`;

/**
 * __useFhirObservationTemplatesQuery__
 *
 * To run a query within a Vue component, call `useFhirObservationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirObservationTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFhirObservationTemplatesQuery();
 */
export function useFhirObservationTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>(
    FhirObservationTemplatesDocument,
    {},
    options,
  );
}
export function useFhirObservationTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<FhirObservationTemplatesQuery, FhirObservationTemplatesQueryVariables>(
    FhirObservationTemplatesDocument,
    {},
    options,
  );
}
export type FhirObservationTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FhirObservationTemplatesQuery,
  FhirObservationTemplatesQueryVariables
>;
export const FhirAlarmTemplatesDocument = gql`
  query fhirAlarmTemplates {
    fhirAlarmTemplates
  }
`;

/**
 * __useFhirAlarmTemplatesQuery__
 *
 * To run a query within a Vue component, call `useFhirAlarmTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirAlarmTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFhirAlarmTemplatesQuery();
 */
export function useFhirAlarmTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>(
    FhirAlarmTemplatesDocument,
    {},
    options,
  );
}
export function useFhirAlarmTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<FhirAlarmTemplatesQuery, FhirAlarmTemplatesQueryVariables>(
    FhirAlarmTemplatesDocument,
    {},
    options,
  );
}
export type FhirAlarmTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FhirAlarmTemplatesQuery,
  FhirAlarmTemplatesQueryVariables
>;
export const DeviceGroupsDocument = gql`
  query deviceGroups {
    deviceGroups {
      id
      name
    }
  }
`;

/**
 * __useDeviceGroupsQuery__
 *
 * To run a query within a Vue component, call `useDeviceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDeviceGroupsQuery();
 */
export function useDeviceGroupsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DeviceGroupsQuery, DeviceGroupsQueryVariables>(DeviceGroupsDocument, {}, options);
}
export function useDeviceGroupsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DeviceGroupsQuery, DeviceGroupsQueryVariables>(
    DeviceGroupsDocument,
    {},
    options,
  );
}
export type DeviceGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DeviceGroupsQuery,
  DeviceGroupsQueryVariables
>;
export const DeviceStatsDocument = gql`
  query deviceStats($from: dateTime, $to: dateTime) {
    deviceStats(from: $from, to: $to) {
      stats {
        timestamp
        technicalAlarms
        technicalAlarmEvents
        deviceType
      }
    }
  }
`;

/**
 * __useDeviceStatsQuery__
 *
 * To run a query within a Vue component, call `useDeviceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDeviceStatsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useDeviceStatsQuery(
  variables:
    | DeviceStatsQueryVariables
    | VueCompositionApi.Ref<DeviceStatsQueryVariables>
    | ReactiveFunction<DeviceStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DeviceStatsQuery, DeviceStatsQueryVariables>(
    DeviceStatsDocument,
    variables,
    options,
  );
}
export function useDeviceStatsLazyQuery(
  variables:
    | DeviceStatsQueryVariables
    | VueCompositionApi.Ref<DeviceStatsQueryVariables>
    | ReactiveFunction<DeviceStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DeviceStatsQuery, DeviceStatsQueryVariables>(
    DeviceStatsDocument,
    variables,
    options,
  );
}
export type DeviceStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DeviceStatsQuery,
  DeviceStatsQueryVariables
>;
export const CheckCameraTwoWayAudioSupportDocument = gql`
  query checkCameraTwoWayAudioSupport($cameraId: ID!) {
    checkCameraTwoWayAudioSupport(cameraId: $cameraId)
  }
`;

/**
 * __useCheckCameraTwoWayAudioSupportQuery__
 *
 * To run a query within a Vue component, call `useCheckCameraTwoWayAudioSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCameraTwoWayAudioSupportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckCameraTwoWayAudioSupportQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useCheckCameraTwoWayAudioSupportQuery(
  variables:
    | CheckCameraTwoWayAudioSupportQueryVariables
    | VueCompositionApi.Ref<CheckCameraTwoWayAudioSupportQueryVariables>
    | ReactiveFunction<CheckCameraTwoWayAudioSupportQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        CheckCameraTwoWayAudioSupportQuery,
        CheckCameraTwoWayAudioSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CheckCameraTwoWayAudioSupportQuery,
          CheckCameraTwoWayAudioSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CheckCameraTwoWayAudioSupportQuery,
          CheckCameraTwoWayAudioSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<CheckCameraTwoWayAudioSupportQuery, CheckCameraTwoWayAudioSupportQueryVariables>(
    CheckCameraTwoWayAudioSupportDocument,
    variables,
    options,
  );
}
export function useCheckCameraTwoWayAudioSupportLazyQuery(
  variables?:
    | CheckCameraTwoWayAudioSupportQueryVariables
    | VueCompositionApi.Ref<CheckCameraTwoWayAudioSupportQueryVariables>
    | ReactiveFunction<CheckCameraTwoWayAudioSupportQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        CheckCameraTwoWayAudioSupportQuery,
        CheckCameraTwoWayAudioSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CheckCameraTwoWayAudioSupportQuery,
          CheckCameraTwoWayAudioSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CheckCameraTwoWayAudioSupportQuery,
          CheckCameraTwoWayAudioSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    CheckCameraTwoWayAudioSupportQuery,
    CheckCameraTwoWayAudioSupportQueryVariables
  >(CheckCameraTwoWayAudioSupportDocument, variables, options);
}
export type CheckCameraTwoWayAudioSupportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CheckCameraTwoWayAudioSupportQuery,
  CheckCameraTwoWayAudioSupportQueryVariables
>;
export const GetAllPatientEventConfigsDocument = gql`
  query getAllPatientEventConfigs($patientId: ID!) {
    patientEventConfigs: getPatientEventConfigs(patientId: $patientId) {
      id
      patientId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      createdAt
      updatedAt
    }
    patientEventConfigsBySystem: getPatientEventConfigEnabledByDefault(patientId: $patientId) {
      id
      patientId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      createdAt
      updatedAt
    }
    cepEventConfigs: getCepEventConfigs(patientId: $patientId) {
      id
      patientId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      toCode
      cep {
        ...CepConfigFields
      }
      timedCep {
        ...TimedCepConfigFields
      }
      createdAt
      updatedAt
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
  ${CepConfigFieldsFragmentDoc}
  ${TimedCepConfigFieldsFragmentDoc}
`;

/**
 * __useGetAllPatientEventConfigsQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientEventConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientEventConfigsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllPatientEventConfigsQuery(
  variables:
    | GetAllPatientEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientEventConfigsQueryVariables>
    | ReactiveFunction<GetAllPatientEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>(
    GetAllPatientEventConfigsDocument,
    variables,
    options,
  );
}
export function useGetAllPatientEventConfigsLazyQuery(
  variables?:
    | GetAllPatientEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientEventConfigsQueryVariables>
    | ReactiveFunction<GetAllPatientEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllPatientEventConfigsQuery, GetAllPatientEventConfigsQueryVariables>(
    GetAllPatientEventConfigsDocument,
    variables,
    options,
  );
}
export type GetAllPatientEventConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientEventConfigsQuery,
  GetAllPatientEventConfigsQueryVariables
>;
export const GetCepEventConfigsDocument = gql`
  query getCepEventConfigs($patientId: ID!) {
    getCepEventConfigs(patientId: $patientId) {
      id
      patientId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      toCode
      cep {
        ...CepConfigFields
      }
      timedCep {
        ...TimedCepConfigFields
      }
      createdAt
      updatedAt
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
  ${CepConfigFieldsFragmentDoc}
  ${TimedCepConfigFieldsFragmentDoc}
`;

/**
 * __useGetCepEventConfigsQuery__
 *
 * To run a query within a Vue component, call `useGetCepEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCepEventConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCepEventConfigsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetCepEventConfigsQuery(
  variables:
    | GetCepEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetCepEventConfigsQueryVariables>
    | ReactiveFunction<GetCepEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>(
    GetCepEventConfigsDocument,
    variables,
    options,
  );
}
export function useGetCepEventConfigsLazyQuery(
  variables?:
    | GetCepEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetCepEventConfigsQueryVariables>
    | ReactiveFunction<GetCepEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCepEventConfigsQuery, GetCepEventConfigsQueryVariables>(
    GetCepEventConfigsDocument,
    variables,
    options,
  );
}
export type GetCepEventConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCepEventConfigsQuery,
  GetCepEventConfigsQueryVariables
>;
export const GetAllCameraEventConfigsDocument = gql`
  query getAllCameraEventConfigs($patientId: ID!) {
    getAllCameraEventConfigs(patientId: $patientId) {
      id
      patientId
      cameraId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      toCode
      createdAt
      updatedAt
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useGetAllCameraEventConfigsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCameraEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCameraEventConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCameraEventConfigsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllCameraEventConfigsQuery(
  variables:
    | GetAllCameraEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetAllCameraEventConfigsQueryVariables>
    | ReactiveFunction<GetAllCameraEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>(
    GetAllCameraEventConfigsDocument,
    variables,
    options,
  );
}
export function useGetAllCameraEventConfigsLazyQuery(
  variables?:
    | GetAllCameraEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetAllCameraEventConfigsQueryVariables>
    | ReactiveFunction<GetAllCameraEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllCameraEventConfigsQuery, GetAllCameraEventConfigsQueryVariables>(
    GetAllCameraEventConfigsDocument,
    variables,
    options,
  );
}
export type GetAllCameraEventConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllCameraEventConfigsQuery,
  GetAllCameraEventConfigsQueryVariables
>;
export const GetCameraEventConfigsDocument = gql`
  query getCameraEventConfigs($patientId: ID!, $cameraId: ID!) {
    getCameraEventConfigs(patientId: $patientId, cameraId: $cameraId) {
      id
      patientId
      cameraId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      toCode
      createdAt
      updatedAt
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useGetCameraEventConfigsQuery__
 *
 * To run a query within a Vue component, call `useGetCameraEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraEventConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraEventConfigsQuery({
 *   patientId: // value for 'patientId'
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraEventConfigsQuery(
  variables:
    | GetCameraEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetCameraEventConfigsQueryVariables>
    | ReactiveFunction<GetCameraEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>(
    GetCameraEventConfigsDocument,
    variables,
    options,
  );
}
export function useGetCameraEventConfigsLazyQuery(
  variables?:
    | GetCameraEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetCameraEventConfigsQueryVariables>
    | ReactiveFunction<GetCameraEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraEventConfigsQuery, GetCameraEventConfigsQueryVariables>(
    GetCameraEventConfigsDocument,
    variables,
    options,
  );
}
export type GetCameraEventConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraEventConfigsQuery,
  GetCameraEventConfigsQueryVariables
>;
export const GetPatientEventConfigsDocument = gql`
  query getPatientEventConfigs($patientId: ID!) {
    getPatientEventConfigs(patientId: $patientId) {
      id
      patientId
      type
      code
      displayText
      icon
      priority
      schedule {
        ...EventConfigScheduleFields
      }
      workflow
      generatesAlarm
      createdAt
      updatedAt
    }
  }
  ${EventConfigScheduleFieldsFragmentDoc}
`;

/**
 * __useGetPatientEventConfigsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientEventConfigsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientEventConfigsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientEventConfigsQuery(
  variables:
    | GetPatientEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetPatientEventConfigsQueryVariables>
    | ReactiveFunction<GetPatientEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>(
    GetPatientEventConfigsDocument,
    variables,
    options,
  );
}
export function useGetPatientEventConfigsLazyQuery(
  variables?:
    | GetPatientEventConfigsQueryVariables
    | VueCompositionApi.Ref<GetPatientEventConfigsQueryVariables>
    | ReactiveFunction<GetPatientEventConfigsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientEventConfigsQuery, GetPatientEventConfigsQueryVariables>(
    GetPatientEventConfigsDocument,
    variables,
    options,
  );
}
export type GetPatientEventConfigsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientEventConfigsQuery,
  GetPatientEventConfigsQueryVariables
>;
export const AllExternalAccessesDocument = gql`
  query allExternalAccesses {
    allExternalAccesses {
      id
      name
      ipRestrictions
      allowedAccess
      patientGroups {
        id
        name
      }
      forwarderId
    }
  }
`;

/**
 * __useAllExternalAccessesQuery__
 *
 * To run a query within a Vue component, call `useAllExternalAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExternalAccessesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllExternalAccessesQuery();
 */
export function useAllExternalAccessesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>(
    AllExternalAccessesDocument,
    {},
    options,
  );
}
export function useAllExternalAccessesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllExternalAccessesQuery, AllExternalAccessesQueryVariables>(
    AllExternalAccessesDocument,
    {},
    options,
  );
}
export type AllExternalAccessesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllExternalAccessesQuery,
  AllExternalAccessesQueryVariables
>;
export const GetExternalAccessEndpointsDocument = gql`
  query getExternalAccessEndpoints {
    getExternalAccessEndpoints {
      externalAccessNameToShow
      externalAccessName
    }
  }
`;

/**
 * __useGetExternalAccessEndpointsQuery__
 *
 * To run a query within a Vue component, call `useGetExternalAccessEndpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalAccessEndpointsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExternalAccessEndpointsQuery();
 */
export function useGetExternalAccessEndpointsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>(
    GetExternalAccessEndpointsDocument,
    {},
    options,
  );
}
export function useGetExternalAccessEndpointsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetExternalAccessEndpointsQuery, GetExternalAccessEndpointsQueryVariables>(
    GetExternalAccessEndpointsDocument,
    {},
    options,
  );
}
export type GetExternalAccessEndpointsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetExternalAccessEndpointsQuery,
  GetExternalAccessEndpointsQueryVariables
>;
export const GetForwarderAlarmRoutesDocument = gql`
  query getForwarderAlarmRoutes($forwarderConfigId: String!) {
    forwarderAlarmRoutes: getForwarderAlarmRoutes(forwarderConfigId: $forwarderConfigId) {
      id
      forwarderConfigId
      incomingTemplate {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        technical
      }
      outgoingTemplate {
        code
        title
        system
        displayText
        icon
        isPresentInAccount
        technical
      }
    }
  }
`;

/**
 * __useGetForwarderAlarmRoutesQuery__
 *
 * To run a query within a Vue component, call `useGetForwarderAlarmRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForwarderAlarmRoutesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetForwarderAlarmRoutesQuery({
 *   forwarderConfigId: // value for 'forwarderConfigId'
 * });
 */
export function useGetForwarderAlarmRoutesQuery(
  variables:
    | GetForwarderAlarmRoutesQueryVariables
    | VueCompositionApi.Ref<GetForwarderAlarmRoutesQueryVariables>
    | ReactiveFunction<GetForwarderAlarmRoutesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>(
    GetForwarderAlarmRoutesDocument,
    variables,
    options,
  );
}
export function useGetForwarderAlarmRoutesLazyQuery(
  variables?:
    | GetForwarderAlarmRoutesQueryVariables
    | VueCompositionApi.Ref<GetForwarderAlarmRoutesQueryVariables>
    | ReactiveFunction<GetForwarderAlarmRoutesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetForwarderAlarmRoutesQuery, GetForwarderAlarmRoutesQueryVariables>(
    GetForwarderAlarmRoutesDocument,
    variables,
    options,
  );
}
export type GetForwarderAlarmRoutesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetForwarderAlarmRoutesQuery,
  GetForwarderAlarmRoutesQueryVariables
>;
export const GetAlarmTemplateWithVkpCodesDocument = gql`
  query getAlarmTemplateWithVkpCodes {
    getAlarmTemplateWithVkpCodes {
      id
      code
      title
      system
      technical
      status
      displayText
      icon
      templateVkpCodes {
        id
        enabled
        resourceType
        deviceType
        alertCode {
          code
          display
          system
        }
        reasonCode {
          code
          display
          system
        }
        mode {
          code
          display
          system
        }
      }
    }
  }
`;

/**
 * __useGetAlarmTemplateWithVkpCodesQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplateWithVkpCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplateWithVkpCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplateWithVkpCodesQuery();
 */
export function useGetAlarmTemplateWithVkpCodesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateWithVkpCodesQuery, GetAlarmTemplateWithVkpCodesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplateWithVkpCodesQuery,
          GetAlarmTemplateWithVkpCodesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplateWithVkpCodesQuery,
          GetAlarmTemplateWithVkpCodesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmTemplateWithVkpCodesQuery, GetAlarmTemplateWithVkpCodesQueryVariables>(
    GetAlarmTemplateWithVkpCodesDocument,
    {},
    options,
  );
}
export function useGetAlarmTemplateWithVkpCodesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateWithVkpCodesQuery, GetAlarmTemplateWithVkpCodesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplateWithVkpCodesQuery,
          GetAlarmTemplateWithVkpCodesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplateWithVkpCodesQuery,
          GetAlarmTemplateWithVkpCodesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplateWithVkpCodesQuery,
    GetAlarmTemplateWithVkpCodesQueryVariables
  >(GetAlarmTemplateWithVkpCodesDocument, {}, options);
}
export type GetAlarmTemplateWithVkpCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplateWithVkpCodesQuery,
  GetAlarmTemplateWithVkpCodesQueryVariables
>;
export const GetAlarmTemplatesForSyncAlarmSimulatorDocument = gql`
  query getAlarmTemplatesForSyncAlarmSimulator {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      status
      code {
        coding {
          display
          code
          system
        }
      }
      alarmIcon
      interpretation {
        text
        coding {
          code
          display
        }
      }
      description
    }
  }
`;

/**
 * __useGetAlarmTemplatesForSyncAlarmSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForSyncAlarmSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForSyncAlarmSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForSyncAlarmSimulatorQuery();
 */
export function useGetAlarmTemplatesForSyncAlarmSimulatorQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForSyncAlarmSimulatorQuery,
        GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForSyncAlarmSimulatorQuery,
    GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
  >(GetAlarmTemplatesForSyncAlarmSimulatorDocument, {}, options);
}
export function useGetAlarmTemplatesForSyncAlarmSimulatorLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForSyncAlarmSimulatorQuery,
        GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForSyncAlarmSimulatorQuery,
    GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
  >(GetAlarmTemplatesForSyncAlarmSimulatorDocument, {}, options);
}
export type GetAlarmTemplatesForSyncAlarmSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForSyncAlarmSimulatorQuery,
  GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
>;
export const GetAlarmTemplatesForTemplateCepDocument = gql`
  query getAlarmTemplatesForTemplateCep {
    getAlarmTemplates {
      id
      technical
      alarmIcon
      identifier {
        value
      }
      status
      code {
        coding {
          display
          code
          system
        }
        text
      }
    }
  }
`;

/**
 * __useGetAlarmTemplatesForTemplateCepQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForTemplateCepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForTemplateCepQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForTemplateCepQuery();
 */
export function useGetAlarmTemplatesForTemplateCepQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForTemplateCepQuery,
        GetAlarmTemplatesForTemplateCepQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForTemplateCepQuery,
    GetAlarmTemplatesForTemplateCepQueryVariables
  >(GetAlarmTemplatesForTemplateCepDocument, {}, options);
}
export function useGetAlarmTemplatesForTemplateCepLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForTemplateCepQuery,
        GetAlarmTemplatesForTemplateCepQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForTemplateCepQuery,
    GetAlarmTemplatesForTemplateCepQueryVariables
  >(GetAlarmTemplatesForTemplateCepDocument, {}, options);
}
export type GetAlarmTemplatesForTemplateCepQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForTemplateCepQuery,
  GetAlarmTemplatesForTemplateCepQueryVariables
>;
export const GetEquipmentListDocument = gql`
  query getEquipmentList {
    getEquipmentList {
      id
      createdAt
      identifier
      type
      deviceGroup
      name
      patientId
      patientName
      tags
      topPriorityAlarm {
        priority
      }
      userHasAccessToPatient
      registeredInInventory
      lastSeen
      hasExternalUrl
      lastBatteryStatus
    }
  }
`;

/**
 * __useGetEquipmentListQuery__
 *
 * To run a query within a Vue component, call `useGetEquipmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEquipmentListQuery();
 */
export function useGetEquipmentListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetEquipmentListQuery, GetEquipmentListQueryVariables>(
    GetEquipmentListDocument,
    {},
    options,
  );
}
export function useGetEquipmentListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetEquipmentListQuery, GetEquipmentListQueryVariables>(
    GetEquipmentListDocument,
    {},
    options,
  );
}
export type GetEquipmentListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetEquipmentListQuery,
  GetEquipmentListQueryVariables
>;
export const GetAllExternalAccessForPatientDocument = gql`
  query GetAllExternalAccessForPatient($patientId: ID!) {
    getAllExternalAccessForPatient(patientId: $patientId) {
      id
      name
    }
  }
`;

/**
 * __useGetAllExternalAccessForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAllExternalAccessForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExternalAccessForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllExternalAccessForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllExternalAccessForPatientQuery(
  variables:
    | GetAllExternalAccessForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllExternalAccessForPatientQueryVariables>
    | ReactiveFunction<GetAllExternalAccessForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllExternalAccessForPatientQuery,
        GetAllExternalAccessForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllExternalAccessForPatientQuery,
    GetAllExternalAccessForPatientQueryVariables
  >(GetAllExternalAccessForPatientDocument, variables, options);
}
export function useGetAllExternalAccessForPatientLazyQuery(
  variables?:
    | GetAllExternalAccessForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllExternalAccessForPatientQueryVariables>
    | ReactiveFunction<GetAllExternalAccessForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllExternalAccessForPatientQuery,
        GetAllExternalAccessForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllExternalAccessForPatientQuery,
    GetAllExternalAccessForPatientQueryVariables
  >(GetAllExternalAccessForPatientDocument, variables, options);
}
export type GetAllExternalAccessForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllExternalAccessForPatientQuery,
  GetAllExternalAccessForPatientQueryVariables
>;
export const GetAllQuestionnaireTemplatesDocument = gql`
  query getAllQuestionnaireTemplates {
    getAllQuestionnaireTemplates {
      id
      title
      purpose
      experimental
      version
      effectivePeriod {
        start
        end
      }
      status
    }
  }
`;

/**
 * __useGetAllQuestionnaireTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllQuestionnaireTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionnaireTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllQuestionnaireTemplatesQuery();
 */
export function useGetAllQuestionnaireTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>(
    GetAllQuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export function useGetAllQuestionnaireTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllQuestionnaireTemplatesQuery,
    GetAllQuestionnaireTemplatesQueryVariables
  >(GetAllQuestionnaireTemplatesDocument, {}, options);
}
export type GetAllQuestionnaireTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllQuestionnaireTemplatesQuery,
  GetAllQuestionnaireTemplatesQueryVariables
>;
export const GetAllTechnicalAlarmEventsForDevicePaginatedDocument = gql`
  query getAllTechnicalAlarmEventsForDevicePaginated(
    $deviceId: String!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor = ""
  ) {
    getAllTechnicalAlarmEventsForDevicePaginated(
      deviceId: $deviceId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
    ) {
      cursor
      events {
        id
        code {
          coding {
            code
            display
            system
          }
        }
        effectiveDateTime
        status
        handlingStatuses {
          handler
          initiatedAt
          attempts {
            startedAt
            doneAt
            status
            handledBy
            payload
            rawResponse
            rawStatus
            details
          }
        }
      }
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmEventsForDevicePaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmEventsForDevicePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmEventsForDevicePaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmEventsForDevicePaginatedQuery({
 *   deviceId: // value for 'deviceId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useGetAllTechnicalAlarmEventsForDevicePaginatedQuery(
  variables:
    | GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
        GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >(GetAllTechnicalAlarmEventsForDevicePaginatedDocument, variables, options);
}
export function useGetAllTechnicalAlarmEventsForDevicePaginatedLazyQuery(
  variables?:
    | GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
        GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >(GetAllTechnicalAlarmEventsForDevicePaginatedDocument, variables, options);
}
export type GetAllTechnicalAlarmEventsForDevicePaginatedQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >;
export const GetAuditLogSummariesDocument = gql`
  query getAuditLogSummaries(
    $from: dateTime
    $to: dateTime
    $actions: [AuditEventAction!]
    $patientId: ID
    $userId: ID
  ) {
    getAuditLogSummaries(from: $from, to: $to, actions: $actions, patientId: $patientId, userId: $userId) {
      auditLogSummary {
        operation
        outcome
        count
      }
      auditEntitySummary {
        entityType
        count
      }
      auditRoleSummary {
        operation
        role
        count
      }
    }
  }
`;

/**
 * __useGetAuditLogSummariesQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogSummariesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogSummariesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 *   patientId: // value for 'patientId'
 *   userId: // value for 'userId'
 * });
 */
export function useGetAuditLogSummariesQuery(
  variables:
    | GetAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>(
    GetAuditLogSummariesDocument,
    variables,
    options,
  );
}
export function useGetAuditLogSummariesLazyQuery(
  variables:
    | GetAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>(
    GetAuditLogSummariesDocument,
    variables,
    options,
  );
}
export type GetAuditLogSummariesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogSummariesQuery,
  GetAuditLogSummariesQueryVariables
>;
export const GetAvailableWelfareDevicesInInventoryDocument = gql`
  query getAvailableWelfareDevicesInInventory {
    getAvailableWelfareDevicesInInventory {
      uniqueIdentifier
      modelNumber
    }
  }
`;

/**
 * __useGetAvailableWelfareDevicesInInventoryQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableWelfareDevicesInInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableWelfareDevicesInInventoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableWelfareDevicesInInventoryQuery();
 */
export function useGetAvailableWelfareDevicesInInventoryQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableWelfareDevicesInInventoryQuery,
        GetAvailableWelfareDevicesInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableWelfareDevicesInInventoryQuery,
    GetAvailableWelfareDevicesInInventoryQueryVariables
  >(GetAvailableWelfareDevicesInInventoryDocument, {}, options);
}
export function useGetAvailableWelfareDevicesInInventoryLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableWelfareDevicesInInventoryQuery,
        GetAvailableWelfareDevicesInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableWelfareDevicesInInventoryQuery,
    GetAvailableWelfareDevicesInInventoryQueryVariables
  >(GetAvailableWelfareDevicesInInventoryDocument, {}, options);
}
export type GetAvailableWelfareDevicesInInventoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableWelfareDevicesInInventoryQuery,
  GetAvailableWelfareDevicesInInventoryQueryVariables
>;
export const GetCameraDocument = gql`
  query getCamera($cameraId: ID!) {
    getCamera(cameraId: $cameraId) {
      id
      name
      macAddress
      description
      presets
      ptzEnabled
      cameraProfile {
        ...CameraProfileSettings
      }
      effectiveSettings {
        ...CameraEffectiveSettingsFields
      }
      settings {
        soundThreshold
      }
    }
  }
  ${CameraProfileSettingsFragmentDoc}
  ${CameraEffectiveSettingsFieldsFragmentDoc}
`;

/**
 * __useGetCameraQuery__
 *
 * To run a query within a Vue component, call `useGetCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraQuery(
  variables:
    | GetCameraQueryVariables
    | VueCompositionApi.Ref<GetCameraQueryVariables>
    | ReactiveFunction<GetCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraQuery, GetCameraQueryVariables>(GetCameraDocument, variables, options);
}
export function useGetCameraLazyQuery(
  variables?:
    | GetCameraQueryVariables
    | VueCompositionApi.Ref<GetCameraQueryVariables>
    | ReactiveFunction<GetCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraQuery, GetCameraQueryVariables>(
    GetCameraDocument,
    variables,
    options,
  );
}
export type GetCameraQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraQuery,
  GetCameraQueryVariables
>;
export const LoadDocument = gql`
  query load($cameraId: ID!) {
    camera: getCamera(cameraId: $cameraId) {
      ptzEnabled
      view {
        pan
        minPan
        maxPan
        tilt
        minTilt
        maxTilt
        zoom
        minZoom
        maxZoom
      }
    }
  }
`;

/**
 * __useLoadQuery__
 *
 * To run a query within a Vue component, call `useLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoadQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useLoadQuery(
  variables: LoadQueryVariables | VueCompositionApi.Ref<LoadQueryVariables> | ReactiveFunction<LoadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<LoadQuery, LoadQueryVariables>(LoadDocument, variables, options);
}
export function useLoadLazyQuery(
  variables?: LoadQueryVariables | VueCompositionApi.Ref<LoadQueryVariables> | ReactiveFunction<LoadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<LoadQuery, LoadQueryVariables>(LoadDocument, variables, options);
}
export type LoadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoadQuery, LoadQueryVariables>;
export const GetCameraPtzProfilesDocument = gql`
  query getCameraPtzProfiles($cameraId: ID!) {
    getCameraPtzProfiles(cameraId: $cameraId) {
      activeProfileId
      profiles {
        id
        name
        pan
        tilt
        zoom
      }
    }
  }
`;

/**
 * __useGetCameraPtzProfilesQuery__
 *
 * To run a query within a Vue component, call `useGetCameraPtzProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraPtzProfilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraPtzProfilesQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraPtzProfilesQuery(
  variables:
    | GetCameraPtzProfilesQueryVariables
    | VueCompositionApi.Ref<GetCameraPtzProfilesQueryVariables>
    | ReactiveFunction<GetCameraPtzProfilesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>(
    GetCameraPtzProfilesDocument,
    variables,
    options,
  );
}
export function useGetCameraPtzProfilesLazyQuery(
  variables?:
    | GetCameraPtzProfilesQueryVariables
    | VueCompositionApi.Ref<GetCameraPtzProfilesQueryVariables>
    | ReactiveFunction<GetCameraPtzProfilesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraPtzProfilesQuery, GetCameraPtzProfilesQueryVariables>(
    GetCameraPtzProfilesDocument,
    variables,
    options,
  );
}
export type GetCameraPtzProfilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraPtzProfilesQuery,
  GetCameraPtzProfilesQueryVariables
>;
export const GetCameraListDocument = gql`
  query getCameraList {
    getCameraList {
      id
      name
      model
      serialNumber
      patientId
      patientName
      userHasAccessToPatient
      registeredInInventory
      deviceGroup
      cameraProfile {
        id
        name
        template
      }
      effectiveSettings {
        allowUnplannedSupervision
        enableExtendingCameraAvailability
      }
      enableExtendingCameraAvailability
      lastSeen
      ttl
      privacyMode
      privacyModeUntil
      topPriorityAlarm {
        priority
      }
    }
  }
`;

/**
 * __useGetCameraListQuery__
 *
 * To run a query within a Vue component, call `useGetCameraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraListQuery();
 */
export function useGetCameraListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    {},
    options,
  );
}
export function useGetCameraListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    {},
    options,
  );
}
export type GetCameraListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraListQuery,
  GetCameraListQueryVariables
>;
export const GetDeviceByIdForSimulatorDocument = gql`
  query getDeviceByIdForSimulator($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      modelNumber
      deviceName {
        name
      }
      deviceGroup {
        name
        id
      }
      tags
    }
  }
`;

/**
 * __useGetDeviceByIdForSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdForSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdForSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdForSimulatorQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdForSimulatorQuery(
  variables:
    | GetDeviceByIdForSimulatorQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForSimulatorQueryVariables>
    | ReactiveFunction<GetDeviceByIdForSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>(
    GetDeviceByIdForSimulatorDocument,
    variables,
    options,
  );
}
export function useGetDeviceByIdForSimulatorLazyQuery(
  variables?:
    | GetDeviceByIdForSimulatorQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForSimulatorQueryVariables>
    | ReactiveFunction<GetDeviceByIdForSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>(
    GetDeviceByIdForSimulatorDocument,
    variables,
    options,
  );
}
export type GetDeviceByIdForSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdForSimulatorQuery,
  GetDeviceByIdForSimulatorQueryVariables
>;
export const GetDeviceGroupExternalUrlDocument = gql`
  query getDeviceGroupExternalUrl($id: ID!) {
    getDeviceGroupExternalUrl(id: $id)
  }
`;

/**
 * __useGetDeviceGroupExternalUrlQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceGroupExternalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceGroupExternalUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceGroupExternalUrlQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceGroupExternalUrlQuery(
  variables:
    | GetDeviceGroupExternalUrlQueryVariables
    | VueCompositionApi.Ref<GetDeviceGroupExternalUrlQueryVariables>
    | ReactiveFunction<GetDeviceGroupExternalUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>(
    GetDeviceGroupExternalUrlDocument,
    variables,
    options,
  );
}
export function useGetDeviceGroupExternalUrlLazyQuery(
  variables?:
    | GetDeviceGroupExternalUrlQueryVariables
    | VueCompositionApi.Ref<GetDeviceGroupExternalUrlQueryVariables>
    | ReactiveFunction<GetDeviceGroupExternalUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>(
    GetDeviceGroupExternalUrlDocument,
    variables,
    options,
  );
}
export type GetDeviceGroupExternalUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceGroupExternalUrlQuery,
  GetDeviceGroupExternalUrlQueryVariables
>;
export const GetDeviceModelNumberByIdDocument = gql`
  query GetDeviceModelNumberById($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      modelNumber
    }
  }
`;

/**
 * __useGetDeviceModelNumberByIdQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceModelNumberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceModelNumberByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceModelNumberByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceModelNumberByIdQuery(
  variables:
    | GetDeviceModelNumberByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceModelNumberByIdQueryVariables>
    | ReactiveFunction<GetDeviceModelNumberByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>(
    GetDeviceModelNumberByIdDocument,
    variables,
    options,
  );
}
export function useGetDeviceModelNumberByIdLazyQuery(
  variables?:
    | GetDeviceModelNumberByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceModelNumberByIdQueryVariables>
    | ReactiveFunction<GetDeviceModelNumberByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>(
    GetDeviceModelNumberByIdDocument,
    variables,
    options,
  );
}
export type GetDeviceModelNumberByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceModelNumberByIdQuery,
  GetDeviceModelNumberByIdQueryVariables
>;
export const GetDeviceNameByIdDocument = gql`
  query getDeviceNameById($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      deviceName {
        name
      }
    }
  }
`;

/**
 * __useGetDeviceNameByIdQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceNameByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceNameByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceNameByIdQuery(
  variables:
    | GetDeviceNameByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceNameByIdQueryVariables>
    | ReactiveFunction<GetDeviceNameByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>(
    GetDeviceNameByIdDocument,
    variables,
    options,
  );
}
export function useGetDeviceNameByIdLazyQuery(
  variables?:
    | GetDeviceNameByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceNameByIdQueryVariables>
    | ReactiveFunction<GetDeviceNameByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>(
    GetDeviceNameByIdDocument,
    variables,
    options,
  );
}
export type GetDeviceNameByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceNameByIdQuery,
  GetDeviceNameByIdQueryVariables
>;
export const GetListOfUnallocatedMqttDevicesDocument = gql`
  query getListOfUnallocatedMqttDevices {
    getListOfUnallocatedMqttDevices {
      id
      name
      identifier
      deviceGroupId
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetListOfUnallocatedMqttDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedMqttDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedMqttDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedMqttDevicesQuery();
 */
export function useGetListOfUnallocatedMqttDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedMqttDevicesQuery,
        GetListOfUnallocatedMqttDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedMqttDevicesQuery,
          GetListOfUnallocatedMqttDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedMqttDevicesQuery,
          GetListOfUnallocatedMqttDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedMqttDevicesQuery,
    GetListOfUnallocatedMqttDevicesQueryVariables
  >(GetListOfUnallocatedMqttDevicesDocument, {}, options);
}
export function useGetListOfUnallocatedMqttDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedMqttDevicesQuery,
        GetListOfUnallocatedMqttDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedMqttDevicesQuery,
          GetListOfUnallocatedMqttDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedMqttDevicesQuery,
          GetListOfUnallocatedMqttDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedMqttDevicesQuery,
    GetListOfUnallocatedMqttDevicesQueryVariables
  >(GetListOfUnallocatedMqttDevicesDocument, {}, options);
}
export type GetListOfUnallocatedMqttDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedMqttDevicesQuery,
  GetListOfUnallocatedMqttDevicesQueryVariables
>;
export const GetListOfUnallocatedWelfareDevicesDocument = gql`
  query getListOfUnallocatedWelfareDevices {
    getListOfUnallocatedWelfareDevices {
      id
      uniqueIdentifier
      modelNumber
      userFriendlyName
    }
  }
`;

/**
 * __useGetListOfUnallocatedWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedWelfareDevicesQuery();
 */
export function useGetListOfUnallocatedWelfareDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedWelfareDevicesQuery,
        GetListOfUnallocatedWelfareDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedWelfareDevicesQuery,
    GetListOfUnallocatedWelfareDevicesQueryVariables
  >(GetListOfUnallocatedWelfareDevicesDocument, {}, options);
}
export function useGetListOfUnallocatedWelfareDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedWelfareDevicesQuery,
        GetListOfUnallocatedWelfareDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedWelfareDevicesQuery,
    GetListOfUnallocatedWelfareDevicesQueryVariables
  >(GetListOfUnallocatedWelfareDevicesDocument, {}, options);
}
export type GetListOfUnallocatedWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedWelfareDevicesQuery,
  GetListOfUnallocatedWelfareDevicesQueryVariables
>;
export const GetMqttDeviceDocument = gql`
  query getMqttDevice($id: ID!) {
    getMqttDevice(id: $id) {
      id
      name
      password
      identifier
      deviceGroupId
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetMqttDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetMqttDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMqttDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMqttDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMqttDeviceQuery(
  variables:
    | GetMqttDeviceQueryVariables
    | VueCompositionApi.Ref<GetMqttDeviceQueryVariables>
    | ReactiveFunction<GetMqttDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>(
    GetMqttDeviceDocument,
    variables,
    options,
  );
}
export function useGetMqttDeviceLazyQuery(
  variables?:
    | GetMqttDeviceQueryVariables
    | VueCompositionApi.Ref<GetMqttDeviceQueryVariables>
    | ReactiveFunction<GetMqttDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetMqttDeviceQuery, GetMqttDeviceQueryVariables>(
    GetMqttDeviceDocument,
    variables,
    options,
  );
}
export type GetMqttDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMqttDeviceQuery,
  GetMqttDeviceQueryVariables
>;
export const GetMqttDeviceListDocument = gql`
  query getMqttDeviceList {
    getMqttDeviceList {
      id
      identifier
      name
      patientId
      patientName
      createdAt
      updatedAt
      deviceGroupId
      userHasAccessToPatient
    }
  }
`;

/**
 * __useGetMqttDeviceListQuery__
 *
 * To run a query within a Vue component, call `useGetMqttDeviceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMqttDeviceListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMqttDeviceListQuery();
 */
export function useGetMqttDeviceListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>(
    GetMqttDeviceListDocument,
    {},
    options,
  );
}
export function useGetMqttDeviceListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetMqttDeviceListQuery, GetMqttDeviceListQueryVariables>(
    GetMqttDeviceListDocument,
    {},
    options,
  );
}
export type GetMqttDeviceListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMqttDeviceListQuery,
  GetMqttDeviceListQueryVariables
>;
export const GetMyPersonalProfileDocument = gql`
  query getMyPersonalProfile {
    getMyPersonalProfile {
      id
      firstName
      lastName
      email
      username
      mobileNumber
      requestedExternalIds {
        externalHumanIdType
        requested
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
          localeEntries {
            localeId
            displayName
            description
          }
        }
      }
      lastActive
    }
  }
`;

/**
 * __useGetMyPersonalProfileQuery__
 *
 * To run a query within a Vue component, call `useGetMyPersonalProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPersonalProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyPersonalProfileQuery();
 */
export function useGetMyPersonalProfileQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>(
    GetMyPersonalProfileDocument,
    {},
    options,
  );
}
export function useGetMyPersonalProfileLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>(
    GetMyPersonalProfileDocument,
    {},
    options,
  );
}
export type GetMyPersonalProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMyPersonalProfileQuery,
  GetMyPersonalProfileQueryVariables
>;
export const GetMyPersonalProfileForUserDetailsDocument = gql`
  query getMyPersonalProfileForUserDetails {
    getMyPersonalProfile {
      id
      username
      externalUserIds {
        externalId
        externalHumanIdType {
          id
          localeEntries {
            localeId
            displayName
            description
          }
        }
      }
      requestedExternalIds {
        externalHumanIdType
        requested
      }
    }
  }
`;

/**
 * __useGetMyPersonalProfileForUserDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetMyPersonalProfileForUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPersonalProfileForUserDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyPersonalProfileForUserDetailsQuery();
 */
export function useGetMyPersonalProfileForUserDetailsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMyPersonalProfileForUserDetailsQuery,
        GetMyPersonalProfileForUserDetailsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetMyPersonalProfileForUserDetailsQuery,
    GetMyPersonalProfileForUserDetailsQueryVariables
  >(GetMyPersonalProfileForUserDetailsDocument, {}, options);
}
export function useGetMyPersonalProfileForUserDetailsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMyPersonalProfileForUserDetailsQuery,
        GetMyPersonalProfileForUserDetailsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetMyPersonalProfileForUserDetailsQuery,
    GetMyPersonalProfileForUserDetailsQueryVariables
  >(GetMyPersonalProfileForUserDetailsDocument, {}, options);
}
export type GetMyPersonalProfileForUserDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMyPersonalProfileForUserDetailsQuery,
  GetMyPersonalProfileForUserDetailsQueryVariables
>;
export const GetNextOfKinByIdDocument = gql`
  query getNextOfKinById($patientId: ID!, $nokId: ID!) {
    getNextOfKinById(patientId: $patientId, nokId: $nokId) {
      id
      patient {
        reference
      }
      name {
        given
        family
        text
      }
      notifyNextOfKin
      active
      isMain
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      relationship
    }
  }
`;

/**
 * __useGetNextOfKinByIdQuery__
 *
 * To run a query within a Vue component, call `useGetNextOfKinByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextOfKinByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextOfKinByIdQuery({
 *   patientId: // value for 'patientId'
 *   nokId: // value for 'nokId'
 * });
 */
export function useGetNextOfKinByIdQuery(
  variables:
    | GetNextOfKinByIdQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinByIdQueryVariables>
    | ReactiveFunction<GetNextOfKinByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>(
    GetNextOfKinByIdDocument,
    variables,
    options,
  );
}
export function useGetNextOfKinByIdLazyQuery(
  variables?:
    | GetNextOfKinByIdQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinByIdQueryVariables>
    | ReactiveFunction<GetNextOfKinByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>(
    GetNextOfKinByIdDocument,
    variables,
    options,
  );
}
export type GetNextOfKinByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNextOfKinByIdQuery,
  GetNextOfKinByIdQueryVariables
>;
export const GetOpenPatientAlarmsForPatientDocument = gql`
  query getOpenPatientAlarmsForPatient($patientId: ID!) {
    getOpenPatientAlarmsForPatient(patientId: $patientId) {
      id
      status
      priority
      for {
        reference
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
    }
  }
`;

/**
 * __useGetOpenPatientAlarmsForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetOpenPatientAlarmsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPatientAlarmsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenPatientAlarmsForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetOpenPatientAlarmsForPatientQuery(
  variables:
    | GetOpenPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenPatientAlarmsForPatientQuery,
        GetOpenPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetOpenPatientAlarmsForPatientQuery,
    GetOpenPatientAlarmsForPatientQueryVariables
  >(GetOpenPatientAlarmsForPatientDocument, variables, options);
}
export function useGetOpenPatientAlarmsForPatientLazyQuery(
  variables?:
    | GetOpenPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenPatientAlarmsForPatientQuery,
        GetOpenPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetOpenPatientAlarmsForPatientQuery,
    GetOpenPatientAlarmsForPatientQueryVariables
  >(GetOpenPatientAlarmsForPatientDocument, variables, options);
}
export type GetOpenPatientAlarmsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenPatientAlarmsForPatientQuery,
  GetOpenPatientAlarmsForPatientQueryVariables
>;
export const GetOpenTechnicalAlarmsDocument = gql`
  query getOpenTechnicalAlarms($type: String, $hasPatientLink: Boolean) {
    getOpenTechnicalAlarms(type: $type, hasPatientLink: $hasPatientLink) {
      id
      status
      intent
      priority
      authoredOn
      deviceGroupName
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
      syncAlarmDetails {
        userGroupId
      }
      patientLink {
        patientId
        patientName
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __useGetOpenTechnicalAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenTechnicalAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTechnicalAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenTechnicalAlarmsQuery({
 *   type: // value for 'type'
 *   hasPatientLink: // value for 'hasPatientLink'
 * });
 */
export function useGetOpenTechnicalAlarmsQuery(
  variables:
    | GetOpenTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>(
    GetOpenTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenTechnicalAlarmsLazyQuery(
  variables:
    | GetOpenTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>(
    GetOpenTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenTechnicalAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenTechnicalAlarmsQuery,
  GetOpenTechnicalAlarmsQueryVariables
>;
export const GetOpenTechnicalAlarmsForDeviceDocument = gql`
  query getOpenTechnicalAlarmsForDevice($deviceId: ID!, $deviceType: String) {
    getOpenTechnicalAlarmsForDevice(deviceId: $deviceId, deviceType: $deviceType) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetOpenTechnicalAlarmsForDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetOpenTechnicalAlarmsForDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTechnicalAlarmsForDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenTechnicalAlarmsForDeviceQuery({
 *   deviceId: // value for 'deviceId'
 *   deviceType: // value for 'deviceType'
 * });
 */
export function useGetOpenTechnicalAlarmsForDeviceQuery(
  variables:
    | GetOpenTechnicalAlarmsForDeviceQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsForDeviceQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsForDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenTechnicalAlarmsForDeviceQuery,
        GetOpenTechnicalAlarmsForDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDeviceQuery,
          GetOpenTechnicalAlarmsForDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDeviceQuery,
          GetOpenTechnicalAlarmsForDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetOpenTechnicalAlarmsForDeviceQuery,
    GetOpenTechnicalAlarmsForDeviceQueryVariables
  >(GetOpenTechnicalAlarmsForDeviceDocument, variables, options);
}
export function useGetOpenTechnicalAlarmsForDeviceLazyQuery(
  variables?:
    | GetOpenTechnicalAlarmsForDeviceQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsForDeviceQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsForDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenTechnicalAlarmsForDeviceQuery,
        GetOpenTechnicalAlarmsForDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDeviceQuery,
          GetOpenTechnicalAlarmsForDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDeviceQuery,
          GetOpenTechnicalAlarmsForDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetOpenTechnicalAlarmsForDeviceQuery,
    GetOpenTechnicalAlarmsForDeviceQueryVariables
  >(GetOpenTechnicalAlarmsForDeviceDocument, variables, options);
}
export type GetOpenTechnicalAlarmsForDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenTechnicalAlarmsForDeviceQuery,
  GetOpenTechnicalAlarmsForDeviceQueryVariables
>;
export const GetOwnerAuditLogSummariesDocument = gql`
  query getOwnerAuditLogSummaries($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditLogSummaries(from: $from, to: $to, actions: $actions) {
      auditLogSummary {
        operation
        outcome
        count
      }
      auditEntitySummary {
        entityType
        count
      }
      auditRoleSummary {
        operation
        role
        count
      }
    }
  }
`;

/**
 * __useGetOwnerAuditLogSummariesQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogSummariesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogSummariesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditLogSummariesQuery(
  variables:
    | GetOwnerAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>(
    GetOwnerAuditLogSummariesDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogSummariesLazyQuery(
  variables:
    | GetOwnerAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>(
    GetOwnerAuditLogSummariesDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogSummariesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogSummariesQuery,
  GetOwnerAuditLogSummariesQueryVariables
>;
export const GetPatientNextOfKinDocument = gql`
  query getPatientNextOfKin($patientId: ID!) {
    getNextOfKin(patientId: $patientId) {
      id
      notifyNextOfKin
      name {
        given
        family
        text
      }
      active
      isMain
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      relationship
    }
  }
`;

/**
 * __useGetPatientNextOfKinQuery__
 *
 * To run a query within a Vue component, call `useGetPatientNextOfKinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNextOfKinQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientNextOfKinQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientNextOfKinQuery(
  variables:
    | GetPatientNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetPatientNextOfKinQueryVariables>
    | ReactiveFunction<GetPatientNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>(
    GetPatientNextOfKinDocument,
    variables,
    options,
  );
}
export function useGetPatientNextOfKinLazyQuery(
  variables?:
    | GetPatientNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetPatientNextOfKinQueryVariables>
    | ReactiveFunction<GetPatientNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>(
    GetPatientNextOfKinDocument,
    variables,
    options,
  );
}
export type GetPatientNextOfKinQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientNextOfKinQuery,
  GetPatientNextOfKinQueryVariables
>;
export const GetQuestionnaireResponseByIdDocument = gql`
  query getQuestionnaireResponseById($questionnaireResponseId: ID!) {
    getQuestionnaireResponseById(questionnaireResponseId: $questionnaireResponseId) {
      id
      authored
      received
      subject {
        reference
      }
      source {
        reference
        display
      }
      displayItem {
        linkId
        type
        questionText
        answerText
        code
        score
      }
      displaySummary {
        priorities {
          mode
          thresholds {
            code
            value
          }
          points {
            code
            value
          }
        }
        score
        computedTaskPriority {
          code
          value
        }
      }
      questionnaireObject {
        id
        title
        carePlanObject {
          title
        }
        patientObject {
          name {
            given
            family
          }
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireResponseByIdQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireResponseByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireResponseByIdQuery({
 *   questionnaireResponseId: // value for 'questionnaireResponseId'
 * });
 */
export function useGetQuestionnaireResponseByIdQuery(
  variables:
    | GetQuestionnaireResponseByIdQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponseByIdQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponseByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>(
    GetQuestionnaireResponseByIdDocument,
    variables,
    options,
  );
}
export function useGetQuestionnaireResponseByIdLazyQuery(
  variables?:
    | GetQuestionnaireResponseByIdQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponseByIdQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponseByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetQuestionnaireResponseByIdQuery,
    GetQuestionnaireResponseByIdQueryVariables
  >(GetQuestionnaireResponseByIdDocument, variables, options);
}
export type GetQuestionnaireResponseByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireResponseByIdQuery,
  GetQuestionnaireResponseByIdQueryVariables
>;
export const GetQuestionnaireResponsesForPatientDocument = gql`
  query getQuestionnaireResponsesForPatient($patientId: ID!, $from: dateTime, $to: dateTime) {
    getQuestionnaireResponsesForPatient(patientId: $patientId, from: $from, to: $to) {
      id
      authored
      displayItem {
        answerText
        code
        linkId
        questionText
        score
        type
      }
      questionnaireObject {
        id
        title
        carePlanObject {
          title
        }
        patientObject {
          id
          name {
            given
            family
          }
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireResponsesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireResponsesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireResponsesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireResponsesForPatientQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetQuestionnaireResponsesForPatientQuery(
  variables:
    | GetQuestionnaireResponsesForPatientQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponsesForPatientQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponsesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetQuestionnaireResponsesForPatientQuery,
        GetQuestionnaireResponsesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetQuestionnaireResponsesForPatientQuery,
    GetQuestionnaireResponsesForPatientQueryVariables
  >(GetQuestionnaireResponsesForPatientDocument, variables, options);
}
export function useGetQuestionnaireResponsesForPatientLazyQuery(
  variables?:
    | GetQuestionnaireResponsesForPatientQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponsesForPatientQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponsesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetQuestionnaireResponsesForPatientQuery,
        GetQuestionnaireResponsesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetQuestionnaireResponsesForPatientQuery,
    GetQuestionnaireResponsesForPatientQueryVariables
  >(GetQuestionnaireResponsesForPatientDocument, variables, options);
}
export type GetQuestionnaireResponsesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireResponsesForPatientQuery,
  GetQuestionnaireResponsesForPatientQueryVariables
>;
export const GetSkyresponseStatusesForPatientDocument = gql`
  query getSkyresponseStatusesForPatient($patientId: ID!) {
    getSkyresponseStatusesForPatient(patientId: $patientId) {
      patientId
      flowName
      status
      timestamp
      logs {
        timestamp
        details
        auditLogReferences {
          auditEventId
          description
        }
      }
    }
  }
`;

/**
 * __useGetSkyresponseStatusesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseStatusesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseStatusesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseStatusesForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetSkyresponseStatusesForPatientQuery(
  variables:
    | GetSkyresponseStatusesForPatientQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForPatientQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForPatientQuery,
        GetSkyresponseStatusesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSkyresponseStatusesForPatientQuery,
    GetSkyresponseStatusesForPatientQueryVariables
  >(GetSkyresponseStatusesForPatientDocument, variables, options);
}
export function useGetSkyresponseStatusesForPatientLazyQuery(
  variables?:
    | GetSkyresponseStatusesForPatientQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForPatientQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForPatientQuery,
        GetSkyresponseStatusesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSkyresponseStatusesForPatientQuery,
    GetSkyresponseStatusesForPatientQueryVariables
  >(GetSkyresponseStatusesForPatientDocument, variables, options);
}
export type GetSkyresponseStatusesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseStatusesForPatientQuery,
  GetSkyresponseStatusesForPatientQueryVariables
>;
export const GetSkyresponseStatusesForUserGroupDocument = gql`
  query getSkyresponseStatusesForUserGroup($userGroupId: ID!) {
    getSkyresponseStatusesForUserGroup(userGroupId: $userGroupId) {
      flowName
      status
      timestamp
      logs {
        timestamp
        details
        auditLogReferences {
          auditEventId
          description
        }
      }
    }
  }
`;

/**
 * __useGetSkyresponseStatusesForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseStatusesForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseStatusesForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseStatusesForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetSkyresponseStatusesForUserGroupQuery(
  variables:
    | GetSkyresponseStatusesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForUserGroupQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForUserGroupQuery,
        GetSkyresponseStatusesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSkyresponseStatusesForUserGroupQuery,
    GetSkyresponseStatusesForUserGroupQueryVariables
  >(GetSkyresponseStatusesForUserGroupDocument, variables, options);
}
export function useGetSkyresponseStatusesForUserGroupLazyQuery(
  variables?:
    | GetSkyresponseStatusesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForUserGroupQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForUserGroupQuery,
        GetSkyresponseStatusesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSkyresponseStatusesForUserGroupQuery,
    GetSkyresponseStatusesForUserGroupQueryVariables
  >(GetSkyresponseStatusesForUserGroupDocument, variables, options);
}
export type GetSkyresponseStatusesForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseStatusesForUserGroupQuery,
  GetSkyresponseStatusesForUserGroupQueryVariables
>;
export const GetDeviceByIdFullDocument = gql`
  query getDeviceByIdFull($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      deviceName {
        name
        type
      }
      deviceGroup {
        id
      }
      manufacturer
      serialNumber
      modelNumber
      identifier {
        value
      }
      status {
        connected
        lastSeen
      }
      patient {
        reference
      }
    }
  }
`;

/**
 * __useGetDeviceByIdFullQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdFullQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdFullQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdFullQuery(
  variables:
    | GetDeviceByIdFullQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdFullQueryVariables>
    | ReactiveFunction<GetDeviceByIdFullQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>(
    GetDeviceByIdFullDocument,
    variables,
    options,
  );
}
export function useGetDeviceByIdFullLazyQuery(
  variables?:
    | GetDeviceByIdFullQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdFullQueryVariables>
    | ReactiveFunction<GetDeviceByIdFullQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>(
    GetDeviceByIdFullDocument,
    variables,
    options,
  );
}
export type GetDeviceByIdFullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdFullQuery,
  GetDeviceByIdFullQueryVariables
>;
export const GetWelfareDeviceForEditDocument = gql`
  query GetWelfareDeviceForEdit($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      modelNumber
      property {
        callbackPhoneNumber
        pin
      }
      deviceName {
        name
      }
      deviceGroup {
        name
        id
      }
      tags
    }
  }
`;

/**
 * __useGetWelfareDeviceForEditQuery__
 *
 * To run a query within a Vue component, call `useGetWelfareDeviceForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelfareDeviceForEditQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWelfareDeviceForEditQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetWelfareDeviceForEditQuery(
  variables:
    | GetWelfareDeviceForEditQueryVariables
    | VueCompositionApi.Ref<GetWelfareDeviceForEditQueryVariables>
    | ReactiveFunction<GetWelfareDeviceForEditQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>(
    GetWelfareDeviceForEditDocument,
    variables,
    options,
  );
}
export function useGetWelfareDeviceForEditLazyQuery(
  variables?:
    | GetWelfareDeviceForEditQueryVariables
    | VueCompositionApi.Ref<GetWelfareDeviceForEditQueryVariables>
    | ReactiveFunction<GetWelfareDeviceForEditQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetWelfareDeviceForEditQuery, GetWelfareDeviceForEditQueryVariables>(
    GetWelfareDeviceForEditDocument,
    variables,
    options,
  );
}
export type GetWelfareDeviceForEditQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetWelfareDeviceForEditQuery,
  GetWelfareDeviceForEditQueryVariables
>;
export const HealthProviderSettingsForUserTableDocument = gql`
  query healthProviderSettingsForUserTable {
    healthProviderSettings {
      externalHumanIdTypes {
        id
      }
      userAuth {
        twoFactorAppRequired
        externalIdP {
          alias
          displayName
        }
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForUserTableQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForUserTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForUserTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForUserTableQuery();
 */
export function useHealthProviderSettingsForUserTableQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForUserTableQuery,
        HealthProviderSettingsForUserTableQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForUserTableQuery,
    HealthProviderSettingsForUserTableQueryVariables
  >(HealthProviderSettingsForUserTableDocument, {}, options);
}
export function useHealthProviderSettingsForUserTableLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForUserTableQuery,
        HealthProviderSettingsForUserTableQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForUserTableQuery,
    HealthProviderSettingsForUserTableQueryVariables
  >(HealthProviderSettingsForUserTableDocument, {}, options);
}
export type HealthProviderSettingsForUserTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderSettingsForUserTableQuery,
  HealthProviderSettingsForUserTableQueryVariables
>;
export const HealthProviderSettingsForPatientRegistrationDocument = gql`
  query healthProviderSettingsForPatientRegistration {
    healthProviderSettings {
      patientAuth {
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
        }
      }
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForPatientRegistrationQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForPatientRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForPatientRegistrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForPatientRegistrationQuery();
 */
export function useHealthProviderSettingsForPatientRegistrationQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientRegistrationQuery,
        HealthProviderSettingsForPatientRegistrationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >(HealthProviderSettingsForPatientRegistrationDocument, {}, options);
}
export function useHealthProviderSettingsForPatientRegistrationLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientRegistrationQuery,
        HealthProviderSettingsForPatientRegistrationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >(HealthProviderSettingsForPatientRegistrationDocument, {}, options);
}
export type HealthProviderSettingsForPatientRegistrationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >;
export const PatientContactsDocument = gql`
  query patientContacts($id: ID!) {
    patient(id: $id) {
      id
      contacts {
        patientContacts {
          id
          name
          telecom {
            system
            value
          }
          availableHours
          skyresponseConfig {
            callMethod
          }
          priority
        }
        groupContacts {
          id
          name
          telecom {
            system
            value
          }
          availableHours
          skyresponseConfig {
            callMethod
          }
          priority
        }
      }
    }
  }
`;

/**
 * __usePatientContactsQuery__
 *
 * To run a query within a Vue component, call `usePatientContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientContactsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientContactsQuery(
  variables:
    | PatientContactsQueryVariables
    | VueCompositionApi.Ref<PatientContactsQueryVariables>
    | ReactiveFunction<PatientContactsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientContactsQuery, PatientContactsQueryVariables>(
    PatientContactsDocument,
    variables,
    options,
  );
}
export function usePatientContactsLazyQuery(
  variables?:
    | PatientContactsQueryVariables
    | VueCompositionApi.Ref<PatientContactsQueryVariables>
    | ReactiveFunction<PatientContactsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientContactsQuery, PatientContactsQueryVariables>(
    PatientContactsDocument,
    variables,
    options,
  );
}
export type PatientContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientContactsQuery,
  PatientContactsQueryVariables
>;
export const RpmPatientExportDataDocument = gql`
  query rpmPatientExportData($patientIds: [ID!]!) {
    rpmPatientExportData(patientIds: $patientIds) {
      active
      birthDate
      createdAt
      externalIds {
        id
        type
      }
      firstName
      gender
      lastActive
      lastName
      patientGroupName
      updatedAt
    }
  }
`;

/**
 * __useRpmPatientExportDataQuery__
 *
 * To run a query within a Vue component, call `useRpmPatientExportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRpmPatientExportDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRpmPatientExportDataQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function useRpmPatientExportDataQuery(
  variables:
    | RpmPatientExportDataQueryVariables
    | VueCompositionApi.Ref<RpmPatientExportDataQueryVariables>
    | ReactiveFunction<RpmPatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>(
    RpmPatientExportDataDocument,
    variables,
    options,
  );
}
export function useRpmPatientExportDataLazyQuery(
  variables?:
    | RpmPatientExportDataQueryVariables
    | VueCompositionApi.Ref<RpmPatientExportDataQueryVariables>
    | ReactiveFunction<RpmPatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>(
    RpmPatientExportDataDocument,
    variables,
    options,
  );
}
export type RpmPatientExportDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RpmPatientExportDataQuery,
  RpmPatientExportDataQueryVariables
>;
export const GetAllConcreteObservationsAsCsvDocument = gql`
  query getAllConcreteObservationsAsCsv {
    getAllConcreteObservationsAsCsv {
      csv
    }
  }
`;

/**
 * __useGetAllConcreteObservationsAsCsvQuery__
 *
 * To run a query within a Vue component, call `useGetAllConcreteObservationsAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllConcreteObservationsAsCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllConcreteObservationsAsCsvQuery();
 */
export function useGetAllConcreteObservationsAsCsvQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllConcreteObservationsAsCsvQuery,
        GetAllConcreteObservationsAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllConcreteObservationsAsCsvQuery,
    GetAllConcreteObservationsAsCsvQueryVariables
  >(GetAllConcreteObservationsAsCsvDocument, {}, options);
}
export function useGetAllConcreteObservationsAsCsvLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllConcreteObservationsAsCsvQuery,
        GetAllConcreteObservationsAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllConcreteObservationsAsCsvQuery,
    GetAllConcreteObservationsAsCsvQueryVariables
  >(GetAllConcreteObservationsAsCsvDocument, {}, options);
}
export type GetAllConcreteObservationsAsCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllConcreteObservationsAsCsvQuery,
  GetAllConcreteObservationsAsCsvQueryVariables
>;
export const PatientExportDataDocument = gql`
  query patientExportData($patientIds: [ID!]!) {
    patientExportData(patientIds: $patientIds) {
      firstName
      lastName
      createdAt
      updatedAt
      tags
      patientNote
      fhirId
      externalIds {
        id
        type
      }
      devices {
        identifier
        modelNumber
      }
      areCamerasEnabled
      active
      birthDate
      gender
      telecom {
        system
        value
      }
      patientGroupName
      address {
        line
        postalCode
        city
        country
        text
      }
      nextOfKins {
        name
        telecom {
          system
          value
        }
        relationship
        main
        smsNotification
      }
      contacts {
        name
        telecom {
          system
          value
        }
      }
      addressNote
      keyCode
    }
  }
`;

/**
 * __usePatientExportDataQuery__
 *
 * To run a query within a Vue component, call `usePatientExportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientExportDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientExportDataQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function usePatientExportDataQuery(
  variables:
    | PatientExportDataQueryVariables
    | VueCompositionApi.Ref<PatientExportDataQueryVariables>
    | ReactiveFunction<PatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientExportDataQuery, PatientExportDataQueryVariables>(
    PatientExportDataDocument,
    variables,
    options,
  );
}
export function usePatientExportDataLazyQuery(
  variables?:
    | PatientExportDataQueryVariables
    | VueCompositionApi.Ref<PatientExportDataQueryVariables>
    | ReactiveFunction<PatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientExportDataQuery, PatientExportDataQueryVariables>(
    PatientExportDataDocument,
    variables,
    options,
  );
}
export type PatientExportDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientExportDataQuery,
  PatientExportDataQueryVariables
>;
export const PatientForPatientDashboardDocument = gql`
  query patientForPatientDashboard($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        given
        family
        text
      }
      externalPatientIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      identifier {
        value
        use
      }
      active
      birthDate
      addressNote
      keyCode
      gender
      note
      areCamerasEnabled
      camerasDisabledAt
      camerasStateOrigin
      responderIsPresent
      camerasReactivateAt
      languages {
        language
        preferred
      }
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      patientGroups {
        id
        name
      }
      alarmRoutes {
        configName
        configType
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
        }
        idMappingStrategy
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
          privacyModeUntil
        }
      }
    }
  }
`;

/**
 * __usePatientForPatientDashboardQuery__
 *
 * To run a query within a Vue component, call `usePatientForPatientDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForPatientDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForPatientDashboardQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function usePatientForPatientDashboardQuery(
  variables:
    | PatientForPatientDashboardQueryVariables
    | VueCompositionApi.Ref<PatientForPatientDashboardQueryVariables>
    | ReactiveFunction<PatientForPatientDashboardQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>(
    PatientForPatientDashboardDocument,
    variables,
    options,
  );
}
export function usePatientForPatientDashboardLazyQuery(
  variables?:
    | PatientForPatientDashboardQueryVariables
    | VueCompositionApi.Ref<PatientForPatientDashboardQueryVariables>
    | ReactiveFunction<PatientForPatientDashboardQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>(
    PatientForPatientDashboardDocument,
    variables,
    options,
  );
}
export type PatientForPatientDashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForPatientDashboardQuery,
  PatientForPatientDashboardQueryVariables
>;
export const PatientGroupDocument = gql`
  query patientGroup($id: ID!) {
    patientGroup(id: $id) {
      id
      name
      patientsCount
      hideTechnicalAlarmNotifications
      alarmRoutes {
        routeId
        configId
        configType
        configName
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
          technical
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
          technical
        }
        idMappingStrategy
      }
    }
  }
`;

/**
 * __usePatientGroupQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientGroupQuery(
  variables:
    | PatientGroupQueryVariables
    | VueCompositionApi.Ref<PatientGroupQueryVariables>
    | ReactiveFunction<PatientGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientGroupQuery, PatientGroupQueryVariables>(
    PatientGroupDocument,
    variables,
    options,
  );
}
export function usePatientGroupLazyQuery(
  variables?:
    | PatientGroupQueryVariables
    | VueCompositionApi.Ref<PatientGroupQueryVariables>
    | ReactiveFunction<PatientGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientGroupQuery, PatientGroupQueryVariables>(
    PatientGroupDocument,
    variables,
    options,
  );
}
export type PatientGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupQuery,
  PatientGroupQueryVariables
>;
export const PatientGroupsDocument = gql`
  query patientGroups {
    patientGroups {
      id
      name
    }
  }
`;

/**
 * __usePatientGroupsQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupsQuery();
 */
export function usePatientGroupsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientGroupsQuery, PatientGroupsQueryVariables>(
    PatientGroupsDocument,
    {},
    options,
  );
}
export function usePatientGroupsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientGroupsQuery, PatientGroupsQueryVariables>(
    PatientGroupsDocument,
    {},
    options,
  );
}
export type PatientGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupsQuery,
  PatientGroupsQueryVariables
>;
export const PatientListNamesDocument = gql`
  query patientListNames($onlyActive: Boolean, $withAnyEnabledServices: [String!]) {
    patientList(onlyActive: $onlyActive, withAnyEnabledServices: $withAnyEnabledServices) {
      id
      firstName
      lastName
    }
  }
`;

/**
 * __usePatientListNamesQuery__
 *
 * To run a query within a Vue component, call `usePatientListNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientListNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientListNamesQuery({
 *   onlyActive: // value for 'onlyActive'
 *   withAnyEnabledServices: // value for 'withAnyEnabledServices'
 * });
 */
export function usePatientListNamesQuery(
  variables:
    | PatientListNamesQueryVariables
    | VueCompositionApi.Ref<PatientListNamesQueryVariables>
    | ReactiveFunction<PatientListNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientListNamesQuery, PatientListNamesQueryVariables>(
    PatientListNamesDocument,
    variables,
    options,
  );
}
export function usePatientListNamesLazyQuery(
  variables:
    | PatientListNamesQueryVariables
    | VueCompositionApi.Ref<PatientListNamesQueryVariables>
    | ReactiveFunction<PatientListNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListNamesQuery, PatientListNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientListNamesQuery, PatientListNamesQueryVariables>(
    PatientListNamesDocument,
    variables,
    options,
  );
}
export type PatientListNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientListNamesQuery,
  PatientListNamesQueryVariables
>;
export const PatientNamesDocument = gql`
  query patientNames($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
      }
    }
  }
`;

/**
 * __usePatientNamesQuery__
 *
 * To run a query within a Vue component, call `usePatientNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNamesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNamesQuery(
  variables:
    | PatientNamesQueryVariables
    | VueCompositionApi.Ref<PatientNamesQueryVariables>
    | ReactiveFunction<PatientNamesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientNamesQuery, PatientNamesQueryVariables>(
    PatientNamesDocument,
    variables,
    options,
  );
}
export function usePatientNamesLazyQuery(
  variables?:
    | PatientNamesQueryVariables
    | VueCompositionApi.Ref<PatientNamesQueryVariables>
    | ReactiveFunction<PatientNamesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNamesQuery, PatientNamesQueryVariables>(
    PatientNamesDocument,
    variables,
    options,
  );
}
export type PatientNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNamesQuery,
  PatientNamesQueryVariables
>;
export const PatientNamesWithCarePlansDocument = gql`
  query patientNamesWithCarePlans($id: ID!) {
    patient(id: $id) {
      id
      carePlans {
        id
        title
        status
      }
      name {
        given
        family
      }
    }
  }
`;

/**
 * __usePatientNamesWithCarePlansQuery__
 *
 * To run a query within a Vue component, call `usePatientNamesWithCarePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNamesWithCarePlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNamesWithCarePlansQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNamesWithCarePlansQuery(
  variables:
    | PatientNamesWithCarePlansQueryVariables
    | VueCompositionApi.Ref<PatientNamesWithCarePlansQueryVariables>
    | ReactiveFunction<PatientNamesWithCarePlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>(
    PatientNamesWithCarePlansDocument,
    variables,
    options,
  );
}
export function usePatientNamesWithCarePlansLazyQuery(
  variables?:
    | PatientNamesWithCarePlansQueryVariables
    | VueCompositionApi.Ref<PatientNamesWithCarePlansQueryVariables>
    | ReactiveFunction<PatientNamesWithCarePlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>(
    PatientNamesWithCarePlansDocument,
    variables,
    options,
  );
}
export type PatientNamesWithCarePlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNamesWithCarePlansQuery,
  PatientNamesWithCarePlansQueryVariables
>;
export const PatientSyncStatusDocument = gql`
  query patientSyncStatus($id: ID!) {
    patient(id: $id) {
      id
      skyresponseSyncStatus
      skyresponseSyncOpenAlarms {
        id
        timestamp
      }
    }
  }
`;

/**
 * __usePatientSyncStatusQuery__
 *
 * To run a query within a Vue component, call `usePatientSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientSyncStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientSyncStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientSyncStatusQuery(
  variables:
    | PatientSyncStatusQueryVariables
    | VueCompositionApi.Ref<PatientSyncStatusQueryVariables>
    | ReactiveFunction<PatientSyncStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>(
    PatientSyncStatusDocument,
    variables,
    options,
  );
}
export function usePatientSyncStatusLazyQuery(
  variables?:
    | PatientSyncStatusQueryVariables
    | VueCompositionApi.Ref<PatientSyncStatusQueryVariables>
    | ReactiveFunction<PatientSyncStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>(
    PatientSyncStatusDocument,
    variables,
    options,
  );
}
export type PatientSyncStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientSyncStatusQuery,
  PatientSyncStatusQueryVariables
>;
export const PatientReferenceQueryDocument = gql`
  query patientReferenceQuery($cameraId: ID!) {
    patientReferenceQuery: getCamera(cameraId: $cameraId) {
      patientReference {
        reference
      }
    }
  }
`;

/**
 * __usePatientReferenceQueryQuery__
 *
 * To run a query within a Vue component, call `usePatientReferenceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientReferenceQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientReferenceQueryQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function usePatientReferenceQueryQuery(
  variables:
    | PatientReferenceQueryQueryVariables
    | VueCompositionApi.Ref<PatientReferenceQueryQueryVariables>
    | ReactiveFunction<PatientReferenceQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>(
    PatientReferenceQueryDocument,
    variables,
    options,
  );
}
export function usePatientReferenceQueryLazyQuery(
  variables?:
    | PatientReferenceQueryQueryVariables
    | VueCompositionApi.Ref<PatientReferenceQueryQueryVariables>
    | ReactiveFunction<PatientReferenceQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>(
    PatientReferenceQueryDocument,
    variables,
    options,
  );
}
export type PatientReferenceQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientReferenceQueryQuery,
  PatientReferenceQueryQueryVariables
>;
export const PatientWelfareDevicesDocument = gql`
  query patientWelfareDevices($id: ID!) {
    patientWelfareDevices: patient(id: $id) {
      welfareDevices {
        id
        uniqueIdentifier
        deviceName {
          name
        }
        modelNumber
      }
    }
  }
`;

/**
 * __usePatientWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `usePatientWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWelfareDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWelfareDevicesQuery(
  variables:
    | PatientWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>(
    PatientWelfareDevicesDocument,
    variables,
    options,
  );
}
export function usePatientWelfareDevicesLazyQuery(
  variables?:
    | PatientWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>(
    PatientWelfareDevicesDocument,
    variables,
    options,
  );
}
export type PatientWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWelfareDevicesQuery,
  PatientWelfareDevicesQueryVariables
>;
export const RequestSinglePatientUrlDocument = gql`
  query requestSinglePatientUrl($patientId: ID!, $externalAccessId: ID!) {
    requestSinglePatientUrl(patientId: $patientId, externalAccessId: $externalAccessId)
  }
`;

/**
 * __useRequestSinglePatientUrlQuery__
 *
 * To run a query within a Vue component, call `useRequestSinglePatientUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestSinglePatientUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRequestSinglePatientUrlQuery({
 *   patientId: // value for 'patientId'
 *   externalAccessId: // value for 'externalAccessId'
 * });
 */
export function useRequestSinglePatientUrlQuery(
  variables:
    | RequestSinglePatientUrlQueryVariables
    | VueCompositionApi.Ref<RequestSinglePatientUrlQueryVariables>
    | ReactiveFunction<RequestSinglePatientUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>(
    RequestSinglePatientUrlDocument,
    variables,
    options,
  );
}
export function useRequestSinglePatientUrlLazyQuery(
  variables?:
    | RequestSinglePatientUrlQueryVariables
    | VueCompositionApi.Ref<RequestSinglePatientUrlQueryVariables>
    | ReactiveFunction<RequestSinglePatientUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>(
    RequestSinglePatientUrlDocument,
    variables,
    options,
  );
}
export type RequestSinglePatientUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RequestSinglePatientUrlQuery,
  RequestSinglePatientUrlQueryVariables
>;
export const GetAllSelfTreatmentPlanTemplatesDocument = gql`
  query getAllSelfTreatmentPlanTemplates {
    getAllSelfTreatmentPlanTemplates {
      id
      status
      lastUpdated
      title
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetAllSelfTreatmentPlanTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllSelfTreatmentPlanTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSelfTreatmentPlanTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSelfTreatmentPlanTemplatesQuery();
 */
export function useGetAllSelfTreatmentPlanTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllSelfTreatmentPlanTemplatesQuery,
        GetAllSelfTreatmentPlanTemplatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllSelfTreatmentPlanTemplatesQuery,
    GetAllSelfTreatmentPlanTemplatesQueryVariables
  >(GetAllSelfTreatmentPlanTemplatesDocument, {}, options);
}
export function useGetAllSelfTreatmentPlanTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllSelfTreatmentPlanTemplatesQuery,
        GetAllSelfTreatmentPlanTemplatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllSelfTreatmentPlanTemplatesQuery,
    GetAllSelfTreatmentPlanTemplatesQueryVariables
  >(GetAllSelfTreatmentPlanTemplatesDocument, {}, options);
}
export type GetAllSelfTreatmentPlanTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllSelfTreatmentPlanTemplatesQuery,
  GetAllSelfTreatmentPlanTemplatesQueryVariables
>;
export const GetSelfTreatmentPlanTemplateByIdDocument = gql`
  query getSelfTreatmentPlanTemplateById($selfTreatmentPlanId: ID!) {
    getSelfTreatmentPlanTemplateById(selfTreatmentPlanId: $selfTreatmentPlanId) {
      id
      status
      lastUpdated
      title
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetSelfTreatmentPlanTemplateByIdQuery__
 *
 * To run a query within a Vue component, call `useGetSelfTreatmentPlanTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfTreatmentPlanTemplateByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSelfTreatmentPlanTemplateByIdQuery({
 *   selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 * });
 */
export function useGetSelfTreatmentPlanTemplateByIdQuery(
  variables:
    | GetSelfTreatmentPlanTemplateByIdQueryVariables
    | VueCompositionApi.Ref<GetSelfTreatmentPlanTemplateByIdQueryVariables>
    | ReactiveFunction<GetSelfTreatmentPlanTemplateByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSelfTreatmentPlanTemplateByIdQuery,
        GetSelfTreatmentPlanTemplateByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSelfTreatmentPlanTemplateByIdQuery,
    GetSelfTreatmentPlanTemplateByIdQueryVariables
  >(GetSelfTreatmentPlanTemplateByIdDocument, variables, options);
}
export function useGetSelfTreatmentPlanTemplateByIdLazyQuery(
  variables?:
    | GetSelfTreatmentPlanTemplateByIdQueryVariables
    | VueCompositionApi.Ref<GetSelfTreatmentPlanTemplateByIdQueryVariables>
    | ReactiveFunction<GetSelfTreatmentPlanTemplateByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSelfTreatmentPlanTemplateByIdQuery,
        GetSelfTreatmentPlanTemplateByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSelfTreatmentPlanTemplateByIdQuery,
    GetSelfTreatmentPlanTemplateByIdQueryVariables
  >(GetSelfTreatmentPlanTemplateByIdDocument, variables, options);
}
export type GetSelfTreatmentPlanTemplateByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSelfTreatmentPlanTemplateByIdQuery,
  GetSelfTreatmentPlanTemplateByIdQueryVariables
>;
export const SupportTeamLinkedHealthProvidersDocument = gql`
  query supportTeamLinkedHealthProviders {
    supportTeamLinkedHealthProviders {
      name
      displayName
      url
    }
  }
`;

/**
 * __useSupportTeamLinkedHealthProvidersQuery__
 *
 * To run a query within a Vue component, call `useSupportTeamLinkedHealthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamLinkedHealthProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportTeamLinkedHealthProvidersQuery();
 */
export function useSupportTeamLinkedHealthProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamLinkedHealthProvidersQuery,
        SupportTeamLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    SupportTeamLinkedHealthProvidersQuery,
    SupportTeamLinkedHealthProvidersQueryVariables
  >(SupportTeamLinkedHealthProvidersDocument, {}, options);
}
export function useSupportTeamLinkedHealthProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamLinkedHealthProvidersQuery,
        SupportTeamLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    SupportTeamLinkedHealthProvidersQuery,
    SupportTeamLinkedHealthProvidersQueryVariables
  >(SupportTeamLinkedHealthProvidersDocument, {}, options);
}
export type SupportTeamLinkedHealthProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportTeamLinkedHealthProvidersQuery,
  SupportTeamLinkedHealthProvidersQueryVariables
>;
export const UserGroupForMoveButtonDocument = gql`
  query userGroupForMoveButton($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      rules
      parentId
      lexoRankIndex
      subTree {
        id
        name
        parentId
        subGroups {
          id
          name
          type
          rules
        }
        roles {
          id
        }
      }
      subGroups {
        id
        name
      }
      roles {
        ...Role
      }
    }
  }
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupForMoveButtonQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForMoveButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForMoveButtonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForMoveButtonQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForMoveButtonQuery(
  variables:
    | UserGroupForMoveButtonQueryVariables
    | VueCompositionApi.Ref<UserGroupForMoveButtonQueryVariables>
    | ReactiveFunction<UserGroupForMoveButtonQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>(
    UserGroupForMoveButtonDocument,
    variables,
    options,
  );
}
export function useUserGroupForMoveButtonLazyQuery(
  variables:
    | UserGroupForMoveButtonQueryVariables
    | VueCompositionApi.Ref<UserGroupForMoveButtonQueryVariables>
    | ReactiveFunction<UserGroupForMoveButtonQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>(
    UserGroupForMoveButtonDocument,
    variables,
    options,
  );
}
export type UserGroupForMoveButtonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForMoveButtonQuery,
  UserGroupForMoveButtonQueryVariables
>;
export const UserGroupDocument = gql`
  query userGroup($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      subTree {
        id
        name
        roles {
          id
        }
      }
      roles {
        ...Role
      }
    }
  }
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupQuery__
 *
 * To run a query within a Vue component, call `useUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupQuery(
  variables:
    | UserGroupQueryVariables
    | VueCompositionApi.Ref<UserGroupQueryVariables>
    | ReactiveFunction<UserGroupQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, variables, options);
}
export function useUserGroupLazyQuery(
  variables:
    | UserGroupQueryVariables
    | VueCompositionApi.Ref<UserGroupQueryVariables>
    | ReactiveFunction<UserGroupQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupQuery, UserGroupQueryVariables>(
    UserGroupDocument,
    variables,
    options,
  );
}
export type UserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupQuery,
  UserGroupQueryVariables
>;
export const UserGroupCompleteDocument = gql`
  query userGroupComplete($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      id
      name
      type
      rules
      parentId
      protected
      escalationDelay
      allowedRoleDefinitionIds
      lexoRankIndex
      skyresponse {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
        skyresponseAlarmHandlingRuleId
        allowedAlarmHandlingRuleIds
        publicArcObjectId
        privateArcObjectId
        webviewIntegrationConfig {
          id
          displayName
        }
      }
      careTeams {
        id
        name
        telecom {
          value
          system
          use
        }
      }
      subGroups {
        ...subGroups
      }
      roles {
        ...Role
        protected
      }
      contacts {
        id
        name
        telecom {
          system
          value
        }
        availableHours
        skyresponseConfig {
          callMethod
        }
      }
      linkedPatientGroups {
        id
        name
        patientsCount
        hideTechnicalAlarmNotifications
      }
      patientGroups {
        id
        name
        patientsCount
        hideTechnicalAlarmNotifications
      }
      deviceGroups {
        id
        name
        hasCmpCredentials
        enableFurnitureDetection
        furnitureDetectionPeriodSec
      }
    }
  }
  ${SubGroupsFragmentDoc}
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupCompleteQuery__
 *
 * To run a query within a Vue component, call `useUserGroupCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCompleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupCompleteQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupCompleteQuery(
  variables:
    | UserGroupCompleteQueryVariables
    | VueCompositionApi.Ref<UserGroupCompleteQueryVariables>
    | ReactiveFunction<UserGroupCompleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>(
    UserGroupCompleteDocument,
    variables,
    options,
  );
}
export function useUserGroupCompleteLazyQuery(
  variables:
    | UserGroupCompleteQueryVariables
    | VueCompositionApi.Ref<UserGroupCompleteQueryVariables>
    | ReactiveFunction<UserGroupCompleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>(
    UserGroupCompleteDocument,
    variables,
    options,
  );
}
export type UserGroupCompleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupCompleteQuery,
  UserGroupCompleteQueryVariables
>;
export const GetAllUserGroupChildrenDocument = gql`
  query getAllUserGroupChildren($userGroupId: ID!) {
    getAllUserGroupChildren(userGroupId: $userGroupId) {
      id
      name
    }
  }
`;

/**
 * __useGetAllUserGroupChildrenQuery__
 *
 * To run a query within a Vue component, call `useGetAllUserGroupChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserGroupChildrenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUserGroupChildrenQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAllUserGroupChildrenQuery(
  variables:
    | GetAllUserGroupChildrenQueryVariables
    | VueCompositionApi.Ref<GetAllUserGroupChildrenQueryVariables>
    | ReactiveFunction<GetAllUserGroupChildrenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>(
    GetAllUserGroupChildrenDocument,
    variables,
    options,
  );
}
export function useGetAllUserGroupChildrenLazyQuery(
  variables?:
    | GetAllUserGroupChildrenQueryVariables
    | VueCompositionApi.Ref<GetAllUserGroupChildrenQueryVariables>
    | ReactiveFunction<GetAllUserGroupChildrenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>(
    GetAllUserGroupChildrenDocument,
    variables,
    options,
  );
}
export type GetAllUserGroupChildrenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllUserGroupChildrenQuery,
  GetAllUserGroupChildrenQueryVariables
>;
export const UserGroupContactsAndSkyresponseSyncStatusDocument = gql`
  query userGroupContactsAndSkyresponseSyncStatus($id: ID) {
    userGroup(userGroupId: $id) {
      id
      contacts {
        id
        name
        telecom {
          system
          value
        }
        availableHours
        skyresponseConfig {
          callMethod
        }
        priority
      }
      skyresponseSyncStatus {
        status
        openAlarms {
          id
          authoredOn
        }
      }
    }
  }
`;

/**
 * __useUserGroupContactsAndSkyresponseSyncStatusQuery__
 *
 * To run a query within a Vue component, call `useUserGroupContactsAndSkyresponseSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupContactsAndSkyresponseSyncStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupContactsAndSkyresponseSyncStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupContactsAndSkyresponseSyncStatusQuery(
  variables:
    | UserGroupContactsAndSkyresponseSyncStatusQueryVariables
    | VueCompositionApi.Ref<UserGroupContactsAndSkyresponseSyncStatusQueryVariables>
    | ReactiveFunction<UserGroupContactsAndSkyresponseSyncStatusQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserGroupContactsAndSkyresponseSyncStatusQuery,
        UserGroupContactsAndSkyresponseSyncStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >(UserGroupContactsAndSkyresponseSyncStatusDocument, variables, options);
}
export function useUserGroupContactsAndSkyresponseSyncStatusLazyQuery(
  variables:
    | UserGroupContactsAndSkyresponseSyncStatusQueryVariables
    | VueCompositionApi.Ref<UserGroupContactsAndSkyresponseSyncStatusQueryVariables>
    | ReactiveFunction<UserGroupContactsAndSkyresponseSyncStatusQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserGroupContactsAndSkyresponseSyncStatusQuery,
        UserGroupContactsAndSkyresponseSyncStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >(UserGroupContactsAndSkyresponseSyncStatusDocument, variables, options);
}
export type UserGroupContactsAndSkyresponseSyncStatusQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >;
export const UserGroupDynamicDocument = gql`
  query userGroupDynamic(
    $id: ID
    $includeRoles: Boolean = false
    $includePatientGroups: Boolean = false
    $includeDeviceGroups: Boolean = false
    $includeLinkedPatientGroups: Boolean = false
    $includeAlarmRoutes: Boolean = false
    $includeMetadata: Boolean = false
  ) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      parentId
      rules @include(if: $includeMetadata)
      protected @include(if: $includeMetadata)
      lexoRankIndex @include(if: $includeMetadata)
      subTree {
        ...subTreeDynamic
      }
      roles @include(if: $includeRoles) {
        basedOn
        protected
        ...Role
      }
      linkedPatientGroups @include(if: $includeLinkedPatientGroups) {
        ...PatientGroupDynamic
      }
      patientGroups @include(if: $includePatientGroups) {
        ...PatientGroupDynamic
      }
      deviceGroups @include(if: $includeDeviceGroups) {
        id
        name
      }
      skyresponse @include(if: $includePatientGroups) {
        skyresponseAlarmHandlingRuleId
      }
    }
  }
  ${SubTreeDynamicFragmentDoc}
  ${RoleFragmentDoc}
  ${PatientGroupDynamicFragmentDoc}
`;

/**
 * __useUserGroupDynamicQuery__
 *
 * To run a query within a Vue component, call `useUserGroupDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDynamicQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupDynamicQuery({
 *   id: // value for 'id'
 *   includeRoles: // value for 'includeRoles'
 *   includePatientGroups: // value for 'includePatientGroups'
 *   includeDeviceGroups: // value for 'includeDeviceGroups'
 *   includeLinkedPatientGroups: // value for 'includeLinkedPatientGroups'
 *   includeAlarmRoutes: // value for 'includeAlarmRoutes'
 *   includeMetadata: // value for 'includeMetadata'
 * });
 */
export function useUserGroupDynamicQuery(
  variables:
    | UserGroupDynamicQueryVariables
    | VueCompositionApi.Ref<UserGroupDynamicQueryVariables>
    | ReactiveFunction<UserGroupDynamicQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>(
    UserGroupDynamicDocument,
    variables,
    options,
  );
}
export function useUserGroupDynamicLazyQuery(
  variables:
    | UserGroupDynamicQueryVariables
    | VueCompositionApi.Ref<UserGroupDynamicQueryVariables>
    | ReactiveFunction<UserGroupDynamicQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupDynamicQuery, UserGroupDynamicQueryVariables>(
    UserGroupDynamicDocument,
    variables,
    options,
  );
}
export type UserGroupDynamicQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupDynamicQuery,
  UserGroupDynamicQueryVariables
>;
export const UserGroupForCmpDocument = gql`
  query userGroupForCmp($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      name
      deviceGroups {
        id
        name
      }
      subTree {
        name
        deviceGroups {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useUserGroupForCmpQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForCmpQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForCmpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForCmpQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupForCmpQuery(
  variables:
    | UserGroupForCmpQueryVariables
    | VueCompositionApi.Ref<UserGroupForCmpQueryVariables>
    | ReactiveFunction<UserGroupForCmpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>(
    UserGroupForCmpDocument,
    variables,
    options,
  );
}
export function useUserGroupForCmpLazyQuery(
  variables:
    | UserGroupForCmpQueryVariables
    | VueCompositionApi.Ref<UserGroupForCmpQueryVariables>
    | ReactiveFunction<UserGroupForCmpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>(
    UserGroupForCmpDocument,
    variables,
    options,
  );
}
export type UserGroupForCmpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForCmpQuery,
  UserGroupForCmpQueryVariables
>;
export const UserGroupForDashboardDocument = gql`
  query userGroupForDashboard($id: ID) {
    userGroup(userGroupId: $id) {
      id
      subTree {
        patientGroups {
          id
          name
        }
      }
      linkedPatientGroups {
        id
        name
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useUserGroupForDashboardQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForDashboardQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForDashboardQuery(
  variables:
    | UserGroupForDashboardQueryVariables
    | VueCompositionApi.Ref<UserGroupForDashboardQueryVariables>
    | ReactiveFunction<UserGroupForDashboardQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>(
    UserGroupForDashboardDocument,
    variables,
    options,
  );
}
export function useUserGroupForDashboardLazyQuery(
  variables:
    | UserGroupForDashboardQueryVariables
    | VueCompositionApi.Ref<UserGroupForDashboardQueryVariables>
    | ReactiveFunction<UserGroupForDashboardQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>(
    UserGroupForDashboardDocument,
    variables,
    options,
  );
}
export type UserGroupForDashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForDashboardQuery,
  UserGroupForDashboardQueryVariables
>;
export const UserGroupForExternalAccessDocument = gql`
  query userGroupForExternalAccess($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      parentId
      protected
      subTree {
        id
        name
        parentId
        patientGroups {
          id
          name
        }
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useUserGroupForExternalAccessQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForExternalAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForExternalAccessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForExternalAccessQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForExternalAccessQuery(
  variables:
    | UserGroupForExternalAccessQueryVariables
    | VueCompositionApi.Ref<UserGroupForExternalAccessQueryVariables>
    | ReactiveFunction<UserGroupForExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>(
    UserGroupForExternalAccessDocument,
    variables,
    options,
  );
}
export function useUserGroupForExternalAccessLazyQuery(
  variables:
    | UserGroupForExternalAccessQueryVariables
    | VueCompositionApi.Ref<UserGroupForExternalAccessQueryVariables>
    | ReactiveFunction<UserGroupForExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>(
    UserGroupForExternalAccessDocument,
    variables,
    options,
  );
}
export type UserGroupForExternalAccessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForExternalAccessQuery,
  UserGroupForExternalAccessQueryVariables
>;
export const UserGroupTypeDocument = gql`
  query userGroupType($userGroupId: ID!) {
    userGroup(userGroupId: $userGroupId) {
      id
      type
    }
  }
`;

/**
 * __useUserGroupTypeQuery__
 *
 * To run a query within a Vue component, call `useUserGroupTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupTypeQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupTypeQuery(
  variables:
    | UserGroupTypeQueryVariables
    | VueCompositionApi.Ref<UserGroupTypeQueryVariables>
    | ReactiveFunction<UserGroupTypeQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupTypeQuery, UserGroupTypeQueryVariables>(
    UserGroupTypeDocument,
    variables,
    options,
  );
}
export function useUserGroupTypeLazyQuery(
  variables?:
    | UserGroupTypeQueryVariables
    | VueCompositionApi.Ref<UserGroupTypeQueryVariables>
    | ReactiveFunction<UserGroupTypeQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupTypeQuery, UserGroupTypeQueryVariables>(
    UserGroupTypeDocument,
    variables,
    options,
  );
}
export type UserGroupTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupTypeQuery,
  UserGroupTypeQueryVariables
>;
export const UserNotificationsDataDocument = gql`
  query userNotificationsData {
    getMyUserProfile {
      id
      email
      mobileNumber
    }
  }
`;

/**
 * __useUserNotificationsDataQuery__
 *
 * To run a query within a Vue component, call `useUserNotificationsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserNotificationsDataQuery();
 */
export function useUserNotificationsDataQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>(
    UserNotificationsDataDocument,
    {},
    options,
  );
}
export function useUserNotificationsDataLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>(
    UserNotificationsDataDocument,
    {},
    options,
  );
}
export type UserNotificationsDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserNotificationsDataQuery,
  UserNotificationsDataQueryVariables
>;
export const UserForEditFormDocument = gql`
  query userForEditForm($id: ID) {
    users(id: $id) {
      id
      firstName
      lastName
      email
      enabled
      username
      mobileNumber
      otpStatus
      pendingEmailInvitation
      ipRestrictions
      externalIdentities {
        provider
      }
      requestedExternalIds {
        externalHumanIdType
        requested
      }
      pendingExternalIdentityProviders {
        provider
        pending
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
        }
      }
      roles {
        id
        roleDefinitionId
        display {
          key
          value
        }
      }
      timeLimitedAccess {
        start
        end
      }
      smsOtpStatus
      smsOtpPhoneNumber
      externalIdP
      passwordStatus
    }
  }
`;

/**
 * __useUserForEditFormQuery__
 *
 * To run a query within a Vue component, call `useUserForEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserForEditFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserForEditFormQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserForEditFormQuery(
  variables:
    | UserForEditFormQueryVariables
    | VueCompositionApi.Ref<UserForEditFormQueryVariables>
    | ReactiveFunction<UserForEditFormQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserForEditFormQuery, UserForEditFormQueryVariables>(
    UserForEditFormDocument,
    variables,
    options,
  );
}
export function useUserForEditFormLazyQuery(
  variables:
    | UserForEditFormQueryVariables
    | VueCompositionApi.Ref<UserForEditFormQueryVariables>
    | ReactiveFunction<UserForEditFormQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserForEditFormQuery, UserForEditFormQueryVariables>(
    UserForEditFormDocument,
    variables,
    options,
  );
}
export type UserForEditFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserForEditFormQuery,
  UserForEditFormQueryVariables
>;
export const UsersNamesDocument = gql`
  query usersNames($id: ID) {
    users(id: $id) {
      pendingEmailInvitation
      id
      username
      firstName
      lastName
      email
      enabled
    }
  }
`;

/**
 * __useUsersNamesQuery__
 *
 * To run a query within a Vue component, call `useUsersNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersNamesQuery({
 *   id: // value for 'id'
 * });
 */
export function useUsersNamesQuery(
  variables:
    | UsersNamesQueryVariables
    | VueCompositionApi.Ref<UsersNamesQueryVariables>
    | ReactiveFunction<UsersNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersNamesQuery, UsersNamesQueryVariables>(
    UsersNamesDocument,
    variables,
    options,
  );
}
export function useUsersNamesLazyQuery(
  variables:
    | UsersNamesQueryVariables
    | VueCompositionApi.Ref<UsersNamesQueryVariables>
    | ReactiveFunction<UsersNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersNamesQuery, UsersNamesQueryVariables>(
    UsersNamesDocument,
    variables,
    options,
  );
}
export type UsersNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersNamesQuery,
  UsersNamesQueryVariables
>;
export const UsersForUserViewDocument = gql`
  query usersForUserView($id: ID) {
    users(id: $id) {
      pendingEmailInvitation
      id
      username
      firstName
      lastName
      email
      enabled
      roles {
        basedOn
      }
    }
  }
`;

/**
 * __useUsersForUserViewQuery__
 *
 * To run a query within a Vue component, call `useUsersForUserViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForUserViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersForUserViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useUsersForUserViewQuery(
  variables:
    | UsersForUserViewQueryVariables
    | VueCompositionApi.Ref<UsersForUserViewQueryVariables>
    | ReactiveFunction<UsersForUserViewQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersForUserViewQuery, UsersForUserViewQueryVariables>(
    UsersForUserViewDocument,
    variables,
    options,
  );
}
export function useUsersForUserViewLazyQuery(
  variables:
    | UsersForUserViewQueryVariables
    | VueCompositionApi.Ref<UsersForUserViewQueryVariables>
    | ReactiveFunction<UsersForUserViewQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersForUserViewQuery, UsersForUserViewQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersForUserViewQuery, UsersForUserViewQueryVariables>(
    UsersForUserViewDocument,
    variables,
    options,
  );
}
export type UsersForUserViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersForUserViewQuery,
  UsersForUserViewQueryVariables
>;
export const UsersForSupervisionDocument = gql`
  query usersForSupervision {
    users {
      id
      firstName
      lastName
    }
  }
`;

/**
 * __useUsersForSupervisionQuery__
 *
 * To run a query within a Vue component, call `useUsersForSupervisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForSupervisionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersForSupervisionQuery();
 */
export function useUsersForSupervisionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>(
    UsersForSupervisionDocument,
    {},
    options,
  );
}
export function useUsersForSupervisionLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UsersForSupervisionQuery, UsersForSupervisionQueryVariables>(
    UsersForSupervisionDocument,
    {},
    options,
  );
}
export type UsersForSupervisionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersForSupervisionQuery,
  UsersForSupervisionQueryVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($userInput: UserCreateInput!) {
    createUser(userInput: $userInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      user {
        id
      }
    }
  }
`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserBeforeDeletionDocument = gql`
  mutation updateUserBeforeDeletion($userId: ID!, $userInput: UserUpdateInput!) {
    updateUser(userId: $userId, userInput: $userInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateUserBeforeDeletionMutation__
 *
 * To run a mutation, you first call `useUpdateUserBeforeDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBeforeDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserBeforeDeletionMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserBeforeDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserBeforeDeletionMutation,
        UpdateUserBeforeDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserBeforeDeletionMutation,
          UpdateUserBeforeDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserBeforeDeletionMutation, UpdateUserBeforeDeletionMutationVariables>(
    UpdateUserBeforeDeletionDocument,
    options,
  );
}
export type UpdateUserBeforeDeletionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserBeforeDeletionMutation,
  UpdateUserBeforeDeletionMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($userId: ID!, $userInput: UserUpdateInput!) {
    updateUser(userId: $userId, userInput: $userInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const ResetUserPasswordDocument = gql`
  mutation resetUserPassword($userId: ID!) {
    resetUserPassword(userId: $userId)
  }
`;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
    ResetUserPasswordDocument,
    options,
  );
}
export type ResetUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const DisableUserPasswordDocument = gql`
  mutation disableUserPassword($userId: ID!) {
    disableUserPassword(userId: $userId)
  }
`;

/**
 * __useDisableUserPasswordMutation__
 *
 * To run a mutation, you first call `useDisableUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDisableUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>(
    DisableUserPasswordDocument,
    options,
  );
}
export type DisableUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableUserPasswordMutation,
  DisableUserPasswordMutationVariables
>;
export const UpdateUserPasswordDocument = gql`
  mutation updateUserPassword($userId: ID!, $password: String!) {
    updateUserPassword(userId: $userId, password: $password)
  }
`;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(
    UpdateUserPasswordDocument,
    options,
  );
}
export type UpdateUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables
>;
export const ActivateOtpDocument = gql`
  mutation activateOtp($userId: ID!) {
    activateOtp(userId: $userId)
  }
`;

/**
 * __useActivateOtpMutation__
 *
 * To run a mutation, you first call `useActivateOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useActivateOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateOtpMutation, ActivateOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActivateOtpMutation, ActivateOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<ActivateOtpMutation, ActivateOtpMutationVariables>(
    ActivateOtpDocument,
    options,
  );
}
export type ActivateOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateOtpMutation,
  ActivateOtpMutationVariables
>;
export const DeleteOtpDocument = gql`
  mutation deleteOtp($userId: ID!) {
    deleteOtp(userId: $userId)
  }
`;

/**
 * __useDeleteOtpMutation__
 *
 * To run a mutation, you first call `useDeleteOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteOtpMutation, DeleteOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOtpMutation, DeleteOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteOtpMutation, DeleteOtpMutationVariables>(DeleteOtpDocument, options);
}
export type DeleteOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteOtpMutation,
  DeleteOtpMutationVariables
>;
export const CancelOtpDocument = gql`
  mutation cancelOtp($userId: ID!) {
    cancelOtp(userId: $userId)
  }
`;

/**
 * __useCancelOtpMutation__
 *
 * To run a mutation, you first call `useCancelOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useCancelOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelOtpMutation, CancelOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelOtpMutation, CancelOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CancelOtpMutation, CancelOtpMutationVariables>(CancelOtpDocument, options);
}
export type CancelOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelOtpMutation,
  CancelOtpMutationVariables
>;
export const ActivateSmsOtpDocument = gql`
  mutation activateSmsOtp($userId: ID!, $phoneNumber: String!) {
    activateSmsOtp(userId: $userId, phoneNumber: $phoneNumber)
  }
`;

/**
 * __useActivateSmsOtpMutation__
 *
 * To run a mutation, you first call `useActivateSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateSmsOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useActivateSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>(
    ActivateSmsOtpDocument,
    options,
  );
}
export type ActivateSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateSmsOtpMutation,
  ActivateSmsOtpMutationVariables
>;
export const DeactivateSmsOtpDocument = gql`
  mutation deactivateSmsOtp($userId: ID!) {
    deactivateSmsOtp(userId: $userId)
  }
`;

/**
 * __useDeactivateSmsOtpMutation__
 *
 * To run a mutation, you first call `useDeactivateSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateSmsOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeactivateSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>(
    DeactivateSmsOtpDocument,
    options,
  );
}
export type DeactivateSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateSmsOtpMutation,
  DeactivateSmsOtpMutationVariables
>;
export const SetExternalIdentitiesDocument = gql`
  mutation setExternalIdentities($userId: ID!, $identities: [ExternalIdentityInput]) {
    setExternalIdentities(userId: $userId, identities: $identities)
  }
`;

/**
 * __useSetExternalIdentitiesMutation__
 *
 * To run a mutation, you first call `useSetExternalIdentitiesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdentitiesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdentitiesMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     identities: // value for 'identities'
 *   },
 * });
 */
export function useSetExternalIdentitiesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>(
    SetExternalIdentitiesDocument,
    options,
  );
}
export type SetExternalIdentitiesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdentitiesMutation,
  SetExternalIdentitiesMutationVariables
>;
export const SetExternalIdPDocument = gql`
  mutation setExternalIdP($userId: ID!, $idP: String!) {
    setExternalIdP(userId: $userId, idP: $idP)
  }
`;

/**
 * __useSetExternalIdPMutation__
 *
 * To run a mutation, you first call `useSetExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdPMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     idP: // value for 'idP'
 *   },
 * });
 */
export function useSetExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdPMutation, SetExternalIdPMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdPMutation, SetExternalIdPMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdPMutation, SetExternalIdPMutationVariables>(
    SetExternalIdPDocument,
    options,
  );
}
export type SetExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdPMutation,
  SetExternalIdPMutationVariables
>;
export const EnableUserPasswordDocument = gql`
  mutation enableUserPassword($userId: ID!) {
    enableUserPassword(userId: $userId)
  }
`;

/**
 * __useEnableUserPasswordMutation__
 *
 * To run a mutation, you first call `useEnableUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useEnableUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>(
    EnableUserPasswordDocument,
    options,
  );
}
export type EnableUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableUserPasswordMutation,
  EnableUserPasswordMutationVariables
>;
export const GetUserByUsernameDocument = gql`
  query getUserByUsername($username: String!) {
    getUserByUsername(username: $username) {
      id
      firstName
      lastName
      roles {
        id
        roleDefinitionId
        display {
          key
          value
        }
      }
    }
  }
`;

/**
 * __useGetUserByUsernameQuery__
 *
 * To run a query within a Vue component, call `useGetUserByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByUsernameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserByUsernameQuery({
 *   username: // value for 'username'
 * });
 */
export function useGetUserByUsernameQuery(
  variables:
    | GetUserByUsernameQueryVariables
    | VueCompositionApi.Ref<GetUserByUsernameQueryVariables>
    | ReactiveFunction<GetUserByUsernameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(
    GetUserByUsernameDocument,
    variables,
    options,
  );
}
export function useGetUserByUsernameLazyQuery(
  variables?:
    | GetUserByUsernameQueryVariables
    | VueCompositionApi.Ref<GetUserByUsernameQueryVariables>
    | ReactiveFunction<GetUserByUsernameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(
    GetUserByUsernameDocument,
    variables,
    options,
  );
}
export type GetUserByUsernameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserByUsernameQuery,
  GetUserByUsernameQueryVariables
>;
export const UsersDynamicDocument = gql`
  query usersDynamic($id: ID, $includeExternalIdentities: Boolean = false) {
    users(id: $id) {
      id
      firstName
      lastName
      enabled
      email
      username
      ipRestrictions
      otpStatus
      smsOtpStatus
      passwordStatus
      created
      roles {
        id
        display {
          key
          value
        }
        roleDefinitionId
        userGroup {
          id
          name
        }
      }
      externalIdentities @include(if: $includeExternalIdentities) {
        provider
      }
      externalIdP @include(if: $includeExternalIdentities)
      externalUserIds {
        externalId
        externalHumanIdType {
          id
        }
      }
      lastActive
    }
  }
`;

/**
 * __useUsersDynamicQuery__
 *
 * To run a query within a Vue component, call `useUsersDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersDynamicQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersDynamicQuery({
 *   id: // value for 'id'
 *   includeExternalIdentities: // value for 'includeExternalIdentities'
 * });
 */
export function useUsersDynamicQuery(
  variables:
    | UsersDynamicQueryVariables
    | VueCompositionApi.Ref<UsersDynamicQueryVariables>
    | ReactiveFunction<UsersDynamicQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersDynamicQuery, UsersDynamicQueryVariables>(
    UsersDynamicDocument,
    variables,
    options,
  );
}
export function useUsersDynamicLazyQuery(
  variables:
    | UsersDynamicQueryVariables
    | VueCompositionApi.Ref<UsersDynamicQueryVariables>
    | ReactiveFunction<UsersDynamicQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersDynamicQuery, UsersDynamicQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersDynamicQuery, UsersDynamicQueryVariables>(
    UsersDynamicDocument,
    variables,
    options,
  );
}
export type UsersDynamicQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersDynamicQuery,
  UsersDynamicQueryVariables
>;
export const UsersPaginatedDocument = gql`
  query usersPaginated($paging: UsersPagingInput, $filter: UsersFilterInput) {
    usersPaginated(paging: $paging, filter: $filter) {
      users {
        id
        firstName
        lastName
        enabled
        email
        username
        ipRestrictions
        otpStatus
        smsOtpStatus
        passwordStatus
        created
        roles {
          id
          display {
            key
            value
          }
          roleDefinitionId
          userGroup {
            id
            name
          }
        }
        externalIdentities {
          provider
        }
        externalIdP
        externalUserIds {
          externalId
          externalHumanIdType {
            id
          }
        }
        lastActive
      }
      cursor
      hasMore
      totalCount
    }
  }
`;

/**
 * __useUsersPaginatedQuery__
 *
 * To run a query within a Vue component, call `useUsersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersPaginatedQuery({
 *   paging: // value for 'paging'
 *   filter: // value for 'filter'
 * });
 */
export function useUsersPaginatedQuery(
  variables:
    | UsersPaginatedQueryVariables
    | VueCompositionApi.Ref<UsersPaginatedQueryVariables>
    | ReactiveFunction<UsersPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersPaginatedQuery, UsersPaginatedQueryVariables>(
    UsersPaginatedDocument,
    variables,
    options,
  );
}
export function useUsersPaginatedLazyQuery(
  variables:
    | UsersPaginatedQueryVariables
    | VueCompositionApi.Ref<UsersPaginatedQueryVariables>
    | ReactiveFunction<UsersPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersPaginatedQuery, UsersPaginatedQueryVariables>(
    UsersPaginatedDocument,
    variables,
    options,
  );
}
export type UsersPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersPaginatedQuery,
  UsersPaginatedQueryVariables
>;
export const VkpPatientCareplanDocument = gql`
  query vkpPatientCareplan($id: ID!) {
    vkpPatientCareplan(id: $id) {
      fnr
      responseAsJson
    }
  }
`;

/**
 * __useVkpPatientCareplanQuery__
 *
 * To run a query within a Vue component, call `useVkpPatientCareplanQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpPatientCareplanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpPatientCareplanQuery({
 *   id: // value for 'id'
 * });
 */
export function useVkpPatientCareplanQuery(
  variables:
    | VkpPatientCareplanQueryVariables
    | VueCompositionApi.Ref<VkpPatientCareplanQueryVariables>
    | ReactiveFunction<VkpPatientCareplanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>(
    VkpPatientCareplanDocument,
    variables,
    options,
  );
}
export function useVkpPatientCareplanLazyQuery(
  variables?:
    | VkpPatientCareplanQueryVariables
    | VueCompositionApi.Ref<VkpPatientCareplanQueryVariables>
    | ReactiveFunction<VkpPatientCareplanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>(
    VkpPatientCareplanDocument,
    variables,
    options,
  );
}
export type VkpPatientCareplanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpPatientCareplanQuery,
  VkpPatientCareplanQueryVariables
>;
export const VkpPatientEpisodesOfCareDocument = gql`
  query vkpPatientEpisodesOfCare($id: ID!) {
    vkpPatientEpisodesOfCare(id: $id) {
      fnr
      responseAsJson
    }
  }
`;

/**
 * __useVkpPatientEpisodesOfCareQuery__
 *
 * To run a query within a Vue component, call `useVkpPatientEpisodesOfCareQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpPatientEpisodesOfCareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpPatientEpisodesOfCareQuery({
 *   id: // value for 'id'
 * });
 */
export function useVkpPatientEpisodesOfCareQuery(
  variables:
    | VkpPatientEpisodesOfCareQueryVariables
    | VueCompositionApi.Ref<VkpPatientEpisodesOfCareQueryVariables>
    | ReactiveFunction<VkpPatientEpisodesOfCareQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>(
    VkpPatientEpisodesOfCareDocument,
    variables,
    options,
  );
}
export function useVkpPatientEpisodesOfCareLazyQuery(
  variables?:
    | VkpPatientEpisodesOfCareQueryVariables
    | VueCompositionApi.Ref<VkpPatientEpisodesOfCareQueryVariables>
    | ReactiveFunction<VkpPatientEpisodesOfCareQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>(
    VkpPatientEpisodesOfCareDocument,
    variables,
    options,
  );
}
export type VkpPatientEpisodesOfCareQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpPatientEpisodesOfCareQuery,
  VkpPatientEpisodesOfCareQueryVariables
>;
export const ServicesDocument = gql`
  query services {
    services {
      id
      name
      roles {
        userGroup {
          isTopLevel
        }
        basedOn
        userManuals {
          id
          name
          icon
          applications {
            tilsyn
            dho
            dhv
          }
          localeEntries {
            localeId
            description
            displayName
            url
          }
          roleDefinitions {
            id
          }
        }
        id
        roleDefinitionId
        display {
          key
          value
        }
        abilities {
          operation
          resource
        }
        dashboardRouteName
        userGroup {
          id
          name
        }
        canAssignRoles
      }
      applications {
        dialogg
        supervision
        rpm
        dhv
        supportTeam
        response
      }
      features {
        externalHumanIdTypeIdForPatient
        externalHumanIdTypeIdForUser
        externalHumanIdTypeIdForDialoggUser
        videoMeetings
        defaultLocale
        axisCameras
        disablePasswordForDialoggUsers
        smsNotifications
        emailNotifications
        continuousSupervision
        vkpSearchEnabled
        dataAnalytics
        joinNhnMeeting
        hasTrends
        newSupervisionUserTabs
        hasFurnitureDetection
        hasDemoAnonymization
        hasEntraIdSso
        hasEntraIdProvisioning
        sendNotificationToNextOfKin
        selfTreatmentPlan
        hasJournalConfig
        hasSkyresponseCustomerGroup
        hasCmpAccount
        hasCmp
        safemateIntegration
        tcifIntegration
        skyresponse
        hasAlmaIntegration
        hasAscomIntegration
        hasPhoniroCloudIntegration
        hasSkyresponsePartnerIntegration
        hasSipIntegration
        hasCoordcomIntegration
        hasTietoLmoIntegration
        hasIpOmsorgIntegration
        hasUmo2GIntegration
        hasBestIntegration
      }
      configuration {
        alarmAckTemplates {
          template
          status
        }
      }
      whiteLabelingTemplate {
        id
        name
        title
        icon {
          id
          url
        }
        logo {
          id
          url
        }
        titleLogo {
          id
          url
        }
        primaryColor
        accentColor
        menuBackgroundGradient {
          direction
          colorStops {
            color
            stopPosition
          }
        }
        primaryButtonGradient {
          direction
          colorStops {
            color
            stopPosition
          }
        }
        secondaryButtonGradient {
          direction
          colorStops {
            color
            stopPosition
          }
        }
      }
    }
  }
`;

/**
 * __useServicesQuery__
 *
 * To run a query within a Vue component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useServicesQuery();
 */
export function useServicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, {}, options);
}
export function useServicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, {}, options);
}
export type ServicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ServicesQuery,
  ServicesQueryVariables
>;
export const RegisterPushIdForShiftSessionDocument = gql`
  mutation registerPushIdForShiftSession($pushNotificationSettings: PushNotificationSettingsInput!) {
    registerPushIdForShiftSession(pushNotificationSettings: $pushNotificationSettings) {
      success
      message
    }
  }
`;

/**
 * __useRegisterPushIdForShiftSessionMutation__
 *
 * To run a mutation, you first call `useRegisterPushIdForShiftSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushIdForShiftSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterPushIdForShiftSessionMutation({
 *   variables: {
 *     pushNotificationSettings: // value for 'pushNotificationSettings'
 *   },
 * });
 */
export function useRegisterPushIdForShiftSessionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RegisterPushIdForShiftSessionMutation,
        RegisterPushIdForShiftSessionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RegisterPushIdForShiftSessionMutation,
          RegisterPushIdForShiftSessionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RegisterPushIdForShiftSessionMutation,
    RegisterPushIdForShiftSessionMutationVariables
  >(RegisterPushIdForShiftSessionDocument, options);
}
export type RegisterPushIdForShiftSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RegisterPushIdForShiftSessionMutation,
  RegisterPushIdForShiftSessionMutationVariables
>;
export const CreateShiftSessionForPatientGroupsDocument = gql`
  mutation createShiftSessionForPatientGroups($patientGroupIds: [ID!]!) {
    createShiftSessionForPatientGroups(patientGroupIds: $patientGroupIds) {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
      }
      notificationSettings {
        sendEmail
        sendSms
        locale
        mobileNumber
        email
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useCreateShiftSessionForPatientGroupsMutation__
 *
 * To run a mutation, you first call `useCreateShiftSessionForPatientGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftSessionForPatientGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShiftSessionForPatientGroupsMutation({
 *   variables: {
 *     patientGroupIds: // value for 'patientGroupIds'
 *   },
 * });
 */
export function useCreateShiftSessionForPatientGroupsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateShiftSessionForPatientGroupsMutation,
        CreateShiftSessionForPatientGroupsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateShiftSessionForPatientGroupsMutation,
          CreateShiftSessionForPatientGroupsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateShiftSessionForPatientGroupsMutation,
    CreateShiftSessionForPatientGroupsMutationVariables
  >(CreateShiftSessionForPatientGroupsDocument, options);
}
export type CreateShiftSessionForPatientGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateShiftSessionForPatientGroupsMutation,
  CreateShiftSessionForPatientGroupsMutationVariables
>;
export const SetEmailAndSmsNotificationSettingsForShiftSessionDocument = gql`
  mutation setEmailAndSmsNotificationSettingsForShiftSession($notificationSettings: SessionNotificationSettingsInput!) {
    setEmailAndSmsNotificationSettingsForShiftSession(notificationSettings: $notificationSettings) {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
      }
      notificationSettings {
        sendEmail
        sendSms
        locale
        mobileNumber
        email
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useSetEmailAndSmsNotificationSettingsForShiftSessionMutation__
 *
 * To run a mutation, you first call `useSetEmailAndSmsNotificationSettingsForShiftSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailAndSmsNotificationSettingsForShiftSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetEmailAndSmsNotificationSettingsForShiftSessionMutation({
 *   variables: {
 *     notificationSettings: // value for 'notificationSettings'
 *   },
 * });
 */
export function useSetEmailAndSmsNotificationSettingsForShiftSessionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
        SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
          SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
    SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
  >(SetEmailAndSmsNotificationSettingsForShiftSessionDocument, options);
}
export type SetEmailAndSmsNotificationSettingsForShiftSessionMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
    SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
  >;
export const ShiftSessionDocument = gql`
  query shiftSession {
    shiftSession {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
        createdAt
      }
      notificationSettings {
        sendEmail
        sendSms
        mobileNumber
        email
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useShiftSessionQuery__
 *
 * To run a query within a Vue component, call `useShiftSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftSessionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShiftSessionQuery();
 */
export function useShiftSessionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ShiftSessionQuery, ShiftSessionQueryVariables>(ShiftSessionDocument, {}, options);
}
export function useShiftSessionLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ShiftSessionQuery, ShiftSessionQueryVariables>(
    ShiftSessionDocument,
    {},
    options,
  );
}
export type ShiftSessionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ShiftSessionQuery,
  ShiftSessionQueryVariables
>;
export const AddNextOfKinInImportComponentDocument = gql`
  mutation addNextOfKinInImportComponent($patientId: ID!, $nextOfKinInput: CreateNextOfKinInput!) {
    addNextOfKin(patientId: $patientId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useAddNextOfKinInImportComponentMutation__
 *
 * To run a mutation, you first call `useAddNextOfKinInImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNextOfKinInImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNextOfKinInImportComponentMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useAddNextOfKinInImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddNextOfKinInImportComponentMutation,
        AddNextOfKinInImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddNextOfKinInImportComponentMutation,
          AddNextOfKinInImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddNextOfKinInImportComponentMutation,
    AddNextOfKinInImportComponentMutationVariables
  >(AddNextOfKinInImportComponentDocument, options);
}
export type AddNextOfKinInImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNextOfKinInImportComponentMutation,
  AddNextOfKinInImportComponentMutationVariables
>;
export const UpdateNextOfKinInImportComponentDocument = gql`
  mutation updateNextOfKinInImportComponent($nokId: ID!, $nextOfKinInput: UpdateNextOfKinInput!) {
    updateNextOfKin(nokId: $nokId, nextOfKinInput: $nextOfKinInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateNextOfKinInImportComponentMutation__
 *
 * To run a mutation, you first call `useUpdateNextOfKinInImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNextOfKinInImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNextOfKinInImportComponentMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useUpdateNextOfKinInImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateNextOfKinInImportComponentMutation,
        UpdateNextOfKinInImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateNextOfKinInImportComponentMutation,
          UpdateNextOfKinInImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateNextOfKinInImportComponentMutation,
    UpdateNextOfKinInImportComponentMutationVariables
  >(UpdateNextOfKinInImportComponentDocument, options);
}
export type UpdateNextOfKinInImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateNextOfKinInImportComponentMutation,
  UpdateNextOfKinInImportComponentMutationVariables
>;
export const CreateUserGroupForImportComponentDocument = gql`
  mutation createUserGroupForImportComponent($newUserGroup: CreateUserGroupInput!, $parentUserGroupId: ID!) {
    createUserGroup(parentId: $parentUserGroupId, userGroup: $newUserGroup) {
      success
      message
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useCreateUserGroupForImportComponentMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupForImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupForImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserGroupForImportComponentMutation({
 *   variables: {
 *     newUserGroup: // value for 'newUserGroup'
 *     parentUserGroupId: // value for 'parentUserGroupId'
 *   },
 * });
 */
export function useCreateUserGroupForImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateUserGroupForImportComponentMutation,
        CreateUserGroupForImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateUserGroupForImportComponentMutation,
          CreateUserGroupForImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateUserGroupForImportComponentMutation,
    CreateUserGroupForImportComponentMutationVariables
  >(CreateUserGroupForImportComponentDocument, options);
}
export type CreateUserGroupForImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserGroupForImportComponentMutation,
  CreateUserGroupForImportComponentMutationVariables
>;
export const UpdateUserGroupForImportComponentDocument = gql`
  mutation updateUserGroupForImportComponent($userGroup: UpdateUserGroupInput!, $userGroupId: ID!) {
    updateUserGroup(userGroupId: $userGroupId, userGroup: $userGroup) {
      success
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useUpdateUserGroupForImportComponentMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupForImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupForImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupForImportComponentMutation({
 *   variables: {
 *     userGroup: // value for 'userGroup'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useUpdateUserGroupForImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserGroupForImportComponentMutation,
        UpdateUserGroupForImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserGroupForImportComponentMutation,
          UpdateUserGroupForImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateUserGroupForImportComponentMutation,
    UpdateUserGroupForImportComponentMutationVariables
  >(UpdateUserGroupForImportComponentDocument, options);
}
export type UpdateUserGroupForImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupForImportComponentMutation,
  UpdateUserGroupForImportComponentMutationVariables
>;
export const UpdatePatientGroupsOfPatientDocument = gql`
  mutation updatePatientGroupsOfPatient(
    $addPatientGroups: [String!]
    $removePatientGroups: [String!]
    $patientId: ID!
  ) {
    updatePatientGroupsOfPatient(
      addPatientGroups: $addPatientGroups
      removePatientGroups: $removePatientGroups
      patientId: $patientId
    ) {
      success
    }
  }
`;

/**
 * __useUpdatePatientGroupsOfPatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGroupsOfPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGroupsOfPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGroupsOfPatientMutation({
 *   variables: {
 *     addPatientGroups: // value for 'addPatientGroups'
 *     removePatientGroups: // value for 'removePatientGroups'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useUpdatePatientGroupsOfPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientGroupsOfPatientMutation,
        UpdatePatientGroupsOfPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientGroupsOfPatientMutation,
          UpdatePatientGroupsOfPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientGroupsOfPatientMutation,
    UpdatePatientGroupsOfPatientMutationVariables
  >(UpdatePatientGroupsOfPatientDocument, options);
}
export type UpdatePatientGroupsOfPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGroupsOfPatientMutation,
  UpdatePatientGroupsOfPatientMutationVariables
>;
export const GetSupportedLanguagesDocument = gql`
  query getSupportedLanguages {
    getSupportedLanguages {
      code
    }
  }
`;

/**
 * __useGetSupportedLanguagesQuery__
 *
 * To run a query within a Vue component, call `useGetSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedLanguagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSupportedLanguagesQuery();
 */
export function useGetSupportedLanguagesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
    GetSupportedLanguagesDocument,
    {},
    options,
  );
}
export function useGetSupportedLanguagesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
    GetSupportedLanguagesDocument,
    {},
    options,
  );
}
export type GetSupportedLanguagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSupportedLanguagesQuery,
  GetSupportedLanguagesQueryVariables
>;
export const PatientsForImportDocument = gql`
  query patientsForImport {
    patientsForImport {
      id
      externalIds {
        type
        id
      }
      contacts {
        id
        name
      }
      nextOfKins {
        id
        name {
          given
          family
          text
        }
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __usePatientsForImportQuery__
 *
 * To run a query within a Vue component, call `usePatientsForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsForImportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientsForImportQuery();
 */
export function usePatientsForImportQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientsForImportQuery, PatientsForImportQueryVariables>(
    PatientsForImportDocument,
    {},
    options,
  );
}
export function usePatientsForImportLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientsForImportQuery, PatientsForImportQueryVariables>(
    PatientsForImportDocument,
    {},
    options,
  );
}
export type PatientsForImportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientsForImportQuery,
  PatientsForImportQueryVariables
>;
export const UserGroupForImportComponentDocument = gql`
  query userGroupForImportComponent($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      patientGroups {
        id
        name
        patientsCount
      }
      subTree {
        id
        name
        type
        rules
        parentId
        roles {
          id
          roleDefinitionId
          display {
            key
            value
          }
          protected
        }
        patientGroups {
          id
          name
          patientsCount
        }
        contacts {
          id
          name
          telecom {
            system
            value
          }
        }
      }
      contacts {
        id
        name
        telecom {
          system
          value
        }
      }
    }
  }
`;

/**
 * __useUserGroupForImportComponentQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForImportComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForImportComponentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForImportComponentQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForImportComponentQuery(
  variables:
    | UserGroupForImportComponentQueryVariables
    | VueCompositionApi.Ref<UserGroupForImportComponentQueryVariables>
    | ReactiveFunction<UserGroupForImportComponentQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>(
    UserGroupForImportComponentDocument,
    variables,
    options,
  );
}
export function useUserGroupForImportComponentLazyQuery(
  variables:
    | UserGroupForImportComponentQueryVariables
    | VueCompositionApi.Ref<UserGroupForImportComponentQueryVariables>
    | ReactiveFunction<UserGroupForImportComponentQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>(
    UserGroupForImportComponentDocument,
    variables,
    options,
  );
}
export type UserGroupForImportComponentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForImportComponentQuery,
  UserGroupForImportComponentQueryVariables
>;
export const GetOpenPatientAlarmsDocument = gql`
  query getOpenPatientAlarms($sessionFilter: Boolean, $hideAssignedToOtherUsers: Boolean) {
    getOpenPatientAlarms(sessionFilter: $sessionFilter, hideAssignedToOtherUsers: $hideAssignedToOtherUsers) {
      id
      status
      handlingMode
      code {
        text
      }
      priority
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      authoredOn
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        valueReference {
          reference
        }
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        type {
          text
          coding {
            code
          }
        }
        timestamp
        priority
        icon
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
      patient {
        id
        name {
          given
          family
        }
        patientGroups {
          id
          name
        }
        address {
          line
          postalCode
          city
          country
          text
          position {
            latitude
            longitude
          }
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
    }
  }
`;

/**
 * __useGetOpenPatientAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenPatientAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPatientAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenPatientAlarmsQuery({
 *   sessionFilter: // value for 'sessionFilter'
 *   hideAssignedToOtherUsers: // value for 'hideAssignedToOtherUsers'
 * });
 */
export function useGetOpenPatientAlarmsQuery(
  variables:
    | GetOpenPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>(
    GetOpenPatientAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenPatientAlarmsLazyQuery(
  variables:
    | GetOpenPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>(
    GetOpenPatientAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenPatientAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenPatientAlarmsQuery,
  GetOpenPatientAlarmsQueryVariables
>;
export const GetPatientWithAlarmsDocument = gql`
  query getPatientWithAlarms($id: ID!) {
    getPatientWithAlarms(id: $id) {
      patient {
        id
        active
      }
      openTechnicalAlarms {
        forDeviceType
        forDeviceName
        id
        status
        code {
          text
        }
        for {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        basedOn {
          reference
          type
          display
        }
        focus {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        acceptedAt
        presentAt
        completedAt
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        partOf {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        description
        intent
        priority
        authoredOn
        firstEventTimestamp
        executionPeriod {
          start
          end
        }
        lastModified
        note {
          authorString
          time
          text
        }
        restriction {
          period {
            start
            end
          }
          recipient {
            reference
            identifier {
              system
              use
              value
            }
            type
            display
          }
        }
      }
      openPatientAlarms {
        forDeviceType
        forDeviceName
        id
        status
        code {
          text
        }
        for {
          reference
          type
          display
        }
        basedOn {
          reference
          type
          display
        }
        focus {
          reference
          type
          display
        }
        partOf {
          reference
          type
          display
        }
        description
        intent
        priority
        authoredOn
        firstEventTimestamp
        executionPeriod {
          start
          end
        }
        lastModified
        note {
          authorString
          time
          text
        }
        acceptedAt
        presentAt
        completedAt
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        owner {
          reference
          type
          display
        }
      }
    }
  }
`;

/**
 * __useGetPatientWithAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientWithAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientWithAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientWithAlarmsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientWithAlarmsQuery(
  variables:
    | GetPatientWithAlarmsQueryVariables
    | VueCompositionApi.Ref<GetPatientWithAlarmsQueryVariables>
    | ReactiveFunction<GetPatientWithAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>(
    GetPatientWithAlarmsDocument,
    variables,
    options,
  );
}
export function useGetPatientWithAlarmsLazyQuery(
  variables?:
    | GetPatientWithAlarmsQueryVariables
    | VueCompositionApi.Ref<GetPatientWithAlarmsQueryVariables>
    | ReactiveFunction<GetPatientWithAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>(
    GetPatientWithAlarmsDocument,
    variables,
    options,
  );
}
export type GetPatientWithAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientWithAlarmsQuery,
  GetPatientWithAlarmsQueryVariables
>;
export const GetAlarmStatusDocument = gql`
  query getAlarmStatus($taskId: ID!) {
    getAlarmStatus(taskId: $taskId) {
      id
      status
      handlingMode
      deadlineAt
      extendByMinutes
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        valueReference {
          reference
        }
        type {
          text
          coding {
            system
            code
          }
        }
        icon
        priority
        timestamp
      }
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
    }
  }
`;

/**
 * __useGetAlarmStatusQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmStatusQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetAlarmStatusQuery(
  variables:
    | GetAlarmStatusQueryVariables
    | VueCompositionApi.Ref<GetAlarmStatusQueryVariables>
    | ReactiveFunction<GetAlarmStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>(
    GetAlarmStatusDocument,
    variables,
    options,
  );
}
export function useGetAlarmStatusLazyQuery(
  variables?:
    | GetAlarmStatusQueryVariables
    | VueCompositionApi.Ref<GetAlarmStatusQueryVariables>
    | ReactiveFunction<GetAlarmStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>(
    GetAlarmStatusDocument,
    variables,
    options,
  );
}
export type GetAlarmStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmStatusQuery,
  GetAlarmStatusQueryVariables
>;
export const GetAlarmByIdDocument = gql`
  query getAlarmById($taskId: ID!) {
    getAlarmById(taskId: $taskId) {
      id
      status
      handlingMode
      holdsCamera
      deadlineAt
      extendByMinutes
      code {
        text
      }
      intent
      acceptedAt
      presentAt
      completedAt
      lastModified
      priority
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      subTasks {
        id
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        valueReference {
          reference
        }
        type {
          text
          coding {
            system
            code
          }
        }
        icon
        priority
        timestamp
      }
      note {
        authorString
        time
        text
      }
      completionOptions
      vkpConfiguration {
        enabled
      }
      isSupervisionAlarmWithAnOpenedCameraStream
      isSupervisionAlarm
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
      patient {
        id
        keyCode
        addressNote
        areCamerasEnabled
        camerasStateOrigin
        name {
          given
          family
        }
        note
        telecom {
          value
          system
          use
        }
        photo {
          url
        }
        secretAddress
        journalConfigForPatient {
          remoteSupervision {
            enabled
          }
        }
        address {
          line
          postalCode
          city
          country
          text
          position {
            latitude
            longitude
          }
        }
        cameras {
          id
          name
          macAddress
          serialNumber
          availableHours
          isConfiguredInRegistry
          hasOfflineAlarm
          userHasAccessToPatient
          isAttachedToPatient
          detailedStatus {
            lastSeen
            heartbeatCount
            isAssociatedToPatient
            ttl
            privacyMode
          }
        }
        welfareDevices {
          id
          uniqueIdentifier
          deviceName {
            name
          }
          modelNumber
          configuration {
            registeredInInventory
          }
        }
        patientGroups {
          id
          name
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
    }
  }
`;

/**
 * __useGetAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetAlarmByIdQuery(
  variables:
    | GetAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmByIdQueryVariables>
    | ReactiveFunction<GetAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>(
    GetAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetAlarmByIdLazyQuery(
  variables?:
    | GetAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmByIdQueryVariables>
    | ReactiveFunction<GetAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>(
    GetAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmByIdQuery,
  GetAlarmByIdQueryVariables
>;
export const GetAllTechnicalAlarmsDocument = gql`
  query getAllTechnicalAlarms($from: dateTime, $to: dateTime, $type: String) {
    getAllTechnicalAlarms(from: $from, to: $to, type: $type) {
      id
      status
      intent
      priority
      authoredOn
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
      deviceGroupName
      syncAlarmDetails {
        userGroupId
        entityName
      }
      patientLink {
        patientId
        patientName
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   type: // value for 'type'
 * });
 */
export function useGetAllTechnicalAlarmsQuery(
  variables:
    | GetAllTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>(
    GetAllTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export function useGetAllTechnicalAlarmsLazyQuery(
  variables:
    | GetAllTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>(
    GetAllTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export type GetAllTechnicalAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllTechnicalAlarmsQuery,
  GetAllTechnicalAlarmsQueryVariables
>;
export const GetAllTechnicalAlarmsForDeviceDocument = gql`
  query getAllTechnicalAlarmsForDevice($deviceId: ID!, $from: dateTime, $to: dateTime, $deviceType: String) {
    getAllTechnicalAlarmsForDevice(deviceId: $deviceId, from: $from, to: $to, deviceType: $deviceType) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmsForDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmsForDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmsForDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmsForDeviceQuery({
 *   deviceId: // value for 'deviceId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   deviceType: // value for 'deviceType'
 * });
 */
export function useGetAllTechnicalAlarmsForDeviceQuery(
  variables:
    | GetAllTechnicalAlarmsForDeviceQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsForDeviceQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsForDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmsForDeviceQuery,
        GetAllTechnicalAlarmsForDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDeviceQuery,
          GetAllTechnicalAlarmsForDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDeviceQuery,
          GetAllTechnicalAlarmsForDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllTechnicalAlarmsForDeviceQuery,
    GetAllTechnicalAlarmsForDeviceQueryVariables
  >(GetAllTechnicalAlarmsForDeviceDocument, variables, options);
}
export function useGetAllTechnicalAlarmsForDeviceLazyQuery(
  variables?:
    | GetAllTechnicalAlarmsForDeviceQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsForDeviceQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsForDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmsForDeviceQuery,
        GetAllTechnicalAlarmsForDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDeviceQuery,
          GetAllTechnicalAlarmsForDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDeviceQuery,
          GetAllTechnicalAlarmsForDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllTechnicalAlarmsForDeviceQuery,
    GetAllTechnicalAlarmsForDeviceQueryVariables
  >(GetAllTechnicalAlarmsForDeviceDocument, variables, options);
}
export type GetAllTechnicalAlarmsForDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllTechnicalAlarmsForDeviceQuery,
  GetAllTechnicalAlarmsForDeviceQueryVariables
>;
export const GetOpenSyncAlarmsDocument = gql`
  query getOpenSyncAlarms($type: String) {
    getOpenTechnicalAlarms(type: $type) {
      id
      status
      intent
      priority
      authoredOn
      for {
        reference
      }
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      syncAlarmDetails {
        userGroupId
        entityName
      }
      syncPending
    }
  }
`;

/**
 * __useGetOpenSyncAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenSyncAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenSyncAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenSyncAlarmsQuery({
 *   type: // value for 'type'
 * });
 */
export function useGetOpenSyncAlarmsQuery(
  variables:
    | GetOpenSyncAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenSyncAlarmsQueryVariables>
    | ReactiveFunction<GetOpenSyncAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>(
    GetOpenSyncAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenSyncAlarmsLazyQuery(
  variables:
    | GetOpenSyncAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenSyncAlarmsQueryVariables>
    | ReactiveFunction<GetOpenSyncAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>(
    GetOpenSyncAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenSyncAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenSyncAlarmsQuery,
  GetOpenSyncAlarmsQueryVariables
>;
export const GetTechnicalAlarmByIdDocument = gql`
  query getTechnicalAlarmById($taskId: ID!, $type: String) {
    getTechnicalAlarmById(taskId: $taskId, type: $type) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
          coding {
            system
            code
          }
        }
        valueString
        templateDisplayName
        valueReference {
          reference
          display
          type
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetTechnicalAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetTechnicalAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnicalAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTechnicalAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 *   type: // value for 'type'
 * });
 */
export function useGetTechnicalAlarmByIdQuery(
  variables:
    | GetTechnicalAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetTechnicalAlarmByIdQueryVariables>
    | ReactiveFunction<GetTechnicalAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>(
    GetTechnicalAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetTechnicalAlarmByIdLazyQuery(
  variables?:
    | GetTechnicalAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetTechnicalAlarmByIdQueryVariables>
    | ReactiveFunction<GetTechnicalAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>(
    GetTechnicalAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetTechnicalAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTechnicalAlarmByIdQuery,
  GetTechnicalAlarmByIdQueryVariables
>;
export const GetSyncAlarmByIdDocument = gql`
  query getSyncAlarmById($taskId: ID!, $type: String) {
    getTechnicalAlarmById(taskId: $taskId, type: $type) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
          coding {
            system
            code
          }
        }
        valueString
        templateDisplayName
        valueReference {
          reference
          display
          type
        }
        timestamp
        icon
        priority
        syncEventDetails {
          flowName
          stepName
          flowLogs {
            timestamp
            details
            auditLogReferences {
              auditEventId
              description
            }
          }
        }
      }
      syncAlarmDetails {
        userGroupId
        entityName
      }
      syncPending
    }
  }
`;

/**
 * __useGetSyncAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetSyncAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSyncAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 *   type: // value for 'type'
 * });
 */
export function useGetSyncAlarmByIdQuery(
  variables:
    | GetSyncAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetSyncAlarmByIdQueryVariables>
    | ReactiveFunction<GetSyncAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>(
    GetSyncAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetSyncAlarmByIdLazyQuery(
  variables?:
    | GetSyncAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetSyncAlarmByIdQueryVariables>
    | ReactiveFunction<GetSyncAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>(
    GetSyncAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetSyncAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSyncAlarmByIdQuery,
  GetSyncAlarmByIdQueryVariables
>;
export const CompleteAlarmDocument = gql`
  mutation completeAlarm($taskId: ID!, $completionInput: CompleteAlarmInput!, $force: Boolean) {
    completeAlarm(taskId: $taskId, completionInput: $completionInput, force: $force) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCompleteAlarmMutation__
 *
 * To run a mutation, you first call `useCompleteAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     completionInput: // value for 'completionInput'
 *     force: // value for 'force'
 *   },
 * });
 */
export function useCompleteAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteAlarmMutation, CompleteAlarmMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteAlarmMutation, CompleteAlarmMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteAlarmMutation, CompleteAlarmMutationVariables>(
    CompleteAlarmDocument,
    options,
  );
}
export type CompleteAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteAlarmMutation,
  CompleteAlarmMutationVariables
>;
export const UpdateTechnicalAlarmStatusDocument = gql`
  mutation updateTechnicalAlarmStatus($taskId: ID!, $status: String!, $force: Boolean) {
    updateTechnicalAlarmStatus(taskId: $taskId, status: $status, force: $force) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateTechnicalAlarmStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTechnicalAlarmStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechnicalAlarmStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTechnicalAlarmStatusMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     status: // value for 'status'
 *     force: // value for 'force'
 *   },
 * });
 */
export function useUpdateTechnicalAlarmStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateTechnicalAlarmStatusMutation,
        UpdateTechnicalAlarmStatusMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateTechnicalAlarmStatusMutation,
          UpdateTechnicalAlarmStatusMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateTechnicalAlarmStatusMutation,
    UpdateTechnicalAlarmStatusMutationVariables
  >(UpdateTechnicalAlarmStatusDocument, options);
}
export type UpdateTechnicalAlarmStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTechnicalAlarmStatusMutation,
  UpdateTechnicalAlarmStatusMutationVariables
>;
export const AddNotesToAlarmDocument = gql`
  mutation addNotesToAlarm($taskId: ID!, $note: [AnnotationInput]) {
    addNotesToAlarm(taskId: $taskId, note: $note) {
      success
      message
    }
  }
`;

/**
 * __useAddNotesToAlarmMutation__
 *
 * To run a mutation, you first call `useAddNotesToAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>(
    AddNotesToAlarmDocument,
    options,
  );
}
export type AddNotesToAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToAlarmMutation,
  AddNotesToAlarmMutationVariables
>;
export const AddNotesToTechnicalAlarmDocument = gql`
  mutation addNotesToTechnicalAlarm($taskId: ID!, $note: [AnnotationInput]) {
    addNotesToTechnicalAlarm(taskId: $taskId, note: $note) {
      success
      message
    }
  }
`;

/**
 * __useAddNotesToTechnicalAlarmMutation__
 *
 * To run a mutation, you first call `useAddNotesToTechnicalAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToTechnicalAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToTechnicalAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToTechnicalAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddNotesToTechnicalAlarmMutation,
        AddNotesToTechnicalAlarmMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddNotesToTechnicalAlarmMutation,
          AddNotesToTechnicalAlarmMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToTechnicalAlarmMutation, AddNotesToTechnicalAlarmMutationVariables>(
    AddNotesToTechnicalAlarmDocument,
    options,
  );
}
export type AddNotesToTechnicalAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToTechnicalAlarmMutation,
  AddNotesToTechnicalAlarmMutationVariables
>;
export const TriggerResolveActionsForSyncAlarmsDocument = gql`
  mutation triggerResolveActionsForSyncAlarms($alarmIds: [ID!]!) {
    triggerResolveActionsForSyncAlarms(alarmIds: $alarmIds) {
      success
      message
    }
  }
`;

/**
 * __useTriggerResolveActionsForSyncAlarmsMutation__
 *
 * To run a mutation, you first call `useTriggerResolveActionsForSyncAlarmsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerResolveActionsForSyncAlarmsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerResolveActionsForSyncAlarmsMutation({
 *   variables: {
 *     alarmIds: // value for 'alarmIds'
 *   },
 * });
 */
export function useTriggerResolveActionsForSyncAlarmsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TriggerResolveActionsForSyncAlarmsMutation,
        TriggerResolveActionsForSyncAlarmsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TriggerResolveActionsForSyncAlarmsMutation,
          TriggerResolveActionsForSyncAlarmsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TriggerResolveActionsForSyncAlarmsMutation,
    TriggerResolveActionsForSyncAlarmsMutationVariables
  >(TriggerResolveActionsForSyncAlarmsDocument, options);
}
export type TriggerResolveActionsForSyncAlarmsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TriggerResolveActionsForSyncAlarmsMutation,
  TriggerResolveActionsForSyncAlarmsMutationVariables
>;
export const CancelSkyresponseSyncAlarmDocument = gql`
  mutation cancelSkyresponseSyncAlarm($taskId: ID!) {
    cancelSkyresponseSyncAlarm(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useCancelSkyresponseSyncAlarmMutation__
 *
 * To run a mutation, you first call `useCancelSkyresponseSyncAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelSkyresponseSyncAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelSkyresponseSyncAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelSkyresponseSyncAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CancelSkyresponseSyncAlarmMutation,
        CancelSkyresponseSyncAlarmMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CancelSkyresponseSyncAlarmMutation,
          CancelSkyresponseSyncAlarmMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CancelSkyresponseSyncAlarmMutation,
    CancelSkyresponseSyncAlarmMutationVariables
  >(CancelSkyresponseSyncAlarmDocument, options);
}
export type CancelSkyresponseSyncAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelSkyresponseSyncAlarmMutation,
  CancelSkyresponseSyncAlarmMutationVariables
>;
export const SimulateSyncEventDocument = gql`
  mutation simulateSyncEvent(
    $patientId: ID
    $contactId: ID
    $userGroupId: ID
    $eventCode: String!
    $payload: SimulateSyncEventPayloadInput
  ) {
    simulateSyncEvent(
      patientId: $patientId
      contactId: $contactId
      userGroupId: $userGroupId
      eventCode: $eventCode
      payload: $payload
    ) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSyncEventMutation__
 *
 * To run a mutation, you first call `useSimulateSyncEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSyncEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSyncEventMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contactId: // value for 'contactId'
 *     userGroupId: // value for 'userGroupId'
 *     eventCode: // value for 'eventCode'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useSimulateSyncEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>(
    SimulateSyncEventDocument,
    options,
  );
}
export type SimulateSyncEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSyncEventMutation,
  SimulateSyncEventMutationVariables
>;
export const GetAlarmSnapshotTokenDocument = gql`
  query getAlarmSnapshotToken($taskId: ID!) {
    getAlarmSnapshotToken(taskId: $taskId)
  }
`;

/**
 * __useGetAlarmSnapshotTokenQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmSnapshotTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmSnapshotTokenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmSnapshotTokenQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetAlarmSnapshotTokenQuery(
  variables:
    | GetAlarmSnapshotTokenQueryVariables
    | VueCompositionApi.Ref<GetAlarmSnapshotTokenQueryVariables>
    | ReactiveFunction<GetAlarmSnapshotTokenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>(
    GetAlarmSnapshotTokenDocument,
    variables,
    options,
  );
}
export function useGetAlarmSnapshotTokenLazyQuery(
  variables?:
    | GetAlarmSnapshotTokenQueryVariables
    | VueCompositionApi.Ref<GetAlarmSnapshotTokenQueryVariables>
    | ReactiveFunction<GetAlarmSnapshotTokenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmSnapshotTokenQuery, GetAlarmSnapshotTokenQueryVariables>(
    GetAlarmSnapshotTokenDocument,
    variables,
    options,
  );
}
export type GetAlarmSnapshotTokenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmSnapshotTokenQuery,
  GetAlarmSnapshotTokenQueryVariables
>;
export const ActivateAlarmTemplateDocument = gql`
  mutation activateAlarmTemplate($id: ID!) {
    activateAlarmTemplate(id: $id) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useActivateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useActivateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>(
    ActivateAlarmTemplateDocument,
    options,
  );
}
export type ActivateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateAlarmTemplateMutation,
  ActivateAlarmTemplateMutationVariables
>;
export const CreatePatientInGroupDocument = gql`
  mutation createPatientInGroup($patientGroup: ID!, $patientInput: CreatePatientInput!) {
    createPatientInGroup(patientGroup: $patientGroup, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      patient {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientInGroupMutation__
 *
 * To run a mutation, you first call `useCreatePatientInGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientInGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientInGroupMutation({
 *   variables: {
 *     patientGroup: // value for 'patientGroup'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useCreatePatientInGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>(
    CreatePatientInGroupDocument,
    options,
  );
}
export type CreatePatientInGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientInGroupMutation,
  CreatePatientInGroupMutationVariables
>;
export const AddShareSkyresponseAlarmWithPatientDocument = gql`
  mutation addShareSkyresponseAlarmWithPatient($patientId: ID!, $shareWithPatientIds: [ID]!) {
    addShareSkyresponseAlarmWithPatient(patientId: $patientId, shareWithPatientIds: $shareWithPatientIds) {
      success
      message
    }
  }
`;

/**
 * __useAddShareSkyresponseAlarmWithPatientMutation__
 *
 * To run a mutation, you first call `useAddShareSkyresponseAlarmWithPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddShareSkyresponseAlarmWithPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddShareSkyresponseAlarmWithPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     shareWithPatientIds: // value for 'shareWithPatientIds'
 *   },
 * });
 */
export function useAddShareSkyresponseAlarmWithPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddShareSkyresponseAlarmWithPatientMutation,
        AddShareSkyresponseAlarmWithPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddShareSkyresponseAlarmWithPatientMutation,
          AddShareSkyresponseAlarmWithPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddShareSkyresponseAlarmWithPatientMutation,
    AddShareSkyresponseAlarmWithPatientMutationVariables
  >(AddShareSkyresponseAlarmWithPatientDocument, options);
}
export type AddShareSkyresponseAlarmWithPatientMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddShareSkyresponseAlarmWithPatientMutation,
    AddShareSkyresponseAlarmWithPatientMutationVariables
  >;
export const RetireAlarmTemplateDocument = gql`
  mutation retireAlarmTemplate($id: ID!) {
    retireAlarmTemplate(id: $id) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRetireAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useRetireAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>(
    RetireAlarmTemplateDocument,
    options,
  );
}
export type RetireAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireAlarmTemplateMutation,
  RetireAlarmTemplateMutationVariables
>;
export const UpdateAlarmStatusDocument = gql`
  mutation updateAlarmStatus($taskId: ID!, $status: String!, $handlingMode: String) {
    updateAlarmStatus(taskId: $taskId, status: $status, handlingMode: $handlingMode) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateAlarmStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmStatusMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     status: // value for 'status'
 *     handlingMode: // value for 'handlingMode'
 *   },
 * });
 */
export function useUpdateAlarmStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>(
    UpdateAlarmStatusDocument,
    options,
  );
}
export type UpdateAlarmStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmStatusMutation,
  UpdateAlarmStatusMutationVariables
>;
export const ExtendAlarmTimerDocument = gql`
  mutation extendAlarmTimer($taskId: ID!) {
    extendAlarmTimer(taskId: $taskId) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useExtendAlarmTimerMutation__
 *
 * To run a mutation, you first call `useExtendAlarmTimerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExtendAlarmTimerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExtendAlarmTimerMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useExtendAlarmTimerMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ExtendAlarmTimerMutation, ExtendAlarmTimerMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ExtendAlarmTimerMutation, ExtendAlarmTimerMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ExtendAlarmTimerMutation, ExtendAlarmTimerMutationVariables>(
    ExtendAlarmTimerDocument,
    options,
  );
}
export type ExtendAlarmTimerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ExtendAlarmTimerMutation,
  ExtendAlarmTimerMutationVariables
>;
export const CreateAlarmSubscriptionDocument = gql`
  mutation createAlarmSubscription($createInput: AlarmSubscriptionCreateInput!) {
    createAlarmSubscription(createInput: $createInput) {
      success
      inputValidation {
        valid
        errors {
          message
        }
      }
      message
      alarmSubscription {
        id
      }
    }
  }
`;

/**
 * __useCreateAlarmSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAlarmSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmSubscriptionMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateAlarmSubscriptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmSubscriptionMutation, CreateAlarmSubscriptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateAlarmSubscriptionMutation,
          CreateAlarmSubscriptionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmSubscriptionMutation, CreateAlarmSubscriptionMutationVariables>(
    CreateAlarmSubscriptionDocument,
    options,
  );
}
export type CreateAlarmSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmSubscriptionMutation,
  CreateAlarmSubscriptionMutationVariables
>;
export const CreateAlarmTemplateDocument = gql`
  mutation createAlarmTemplate($input: AlarmTemplateCreateInput!) {
    createAlarmTemplate(input: $input) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>(
    CreateAlarmTemplateDocument,
    options,
  );
}
export type CreateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmTemplateMutation,
  CreateAlarmTemplateMutationVariables
>;
export const CreateUnplannedSupervisionDocument = gql`
  mutation createUnplannedSupervision($patientId: ID!) {
    createUnplannedSupervision(patientId: $patientId) {
      success
      message
      task {
        id
      }
    }
  }
`;

/**
 * __useCreateUnplannedSupervisionMutation__
 *
 * To run a mutation, you first call `useCreateUnplannedSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnplannedSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUnplannedSupervisionMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateUnplannedSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateUnplannedSupervisionMutation,
        CreateUnplannedSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateUnplannedSupervisionMutation,
          CreateUnplannedSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateUnplannedSupervisionMutation,
    CreateUnplannedSupervisionMutationVariables
  >(CreateUnplannedSupervisionDocument, options);
}
export type CreateUnplannedSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUnplannedSupervisionMutation,
  CreateUnplannedSupervisionMutationVariables
>;
export const DeleteAlarmSubscriptionDocument = gql`
  mutation deleteAlarmSubscription($id: String!) {
    deleteAlarmSubscription(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAlarmSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlarmSubscriptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmSubscriptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlarmSubscriptionMutation, DeleteAlarmSubscriptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteAlarmSubscriptionMutation,
          DeleteAlarmSubscriptionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlarmSubscriptionMutation, DeleteAlarmSubscriptionMutationVariables>(
    DeleteAlarmSubscriptionDocument,
    options,
  );
}
export type DeleteAlarmSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlarmSubscriptionMutation,
  DeleteAlarmSubscriptionMutationVariables
>;
export const DeleteAlarmTemplateDocument = gql`
  mutation deleteAlarmTemplate($id: ID!) {
    deleteAlarmTemplate(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>(
    DeleteAlarmTemplateDocument,
    options,
  );
}
export type DeleteAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlarmTemplateMutation,
  DeleteAlarmTemplateMutationVariables
>;
export const DisablePatientCamerasDocument = gql`
  mutation disablePatientCameras($patientId: ID!, $camerasReactivateAt: dateTime!) {
    disablePatientCameras(patientId: $patientId, camerasReactivateAt: $camerasReactivateAt) {
      success
    }
  }
`;

/**
 * __useDisablePatientCamerasMutation__
 *
 * To run a mutation, you first call `useDisablePatientCamerasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisablePatientCamerasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisablePatientCamerasMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     camerasReactivateAt: // value for 'camerasReactivateAt'
 *   },
 * });
 */
export function useDisablePatientCamerasMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisablePatientCamerasMutation, DisablePatientCamerasMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisablePatientCamerasMutation, DisablePatientCamerasMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisablePatientCamerasMutation, DisablePatientCamerasMutationVariables>(
    DisablePatientCamerasDocument,
    options,
  );
}
export type DisablePatientCamerasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisablePatientCamerasMutation,
  DisablePatientCamerasMutationVariables
>;
export const EnablePatientCamerasDocument = gql`
  mutation enablePatientCameras($patientId: ID!) {
    enablePatientCameras(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __useEnablePatientCamerasMutation__
 *
 * To run a mutation, you first call `useEnablePatientCamerasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnablePatientCamerasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnablePatientCamerasMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useEnablePatientCamerasMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnablePatientCamerasMutation, EnablePatientCamerasMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnablePatientCamerasMutation, EnablePatientCamerasMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnablePatientCamerasMutation, EnablePatientCamerasMutationVariables>(
    EnablePatientCamerasDocument,
    options,
  );
}
export type EnablePatientCamerasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnablePatientCamerasMutation,
  EnablePatientCamerasMutationVariables
>;
export const ImportAlarmTemplatesFromDefaultDocument = gql`
  mutation importAlarmTemplatesFromDefault($alarmTemplateCodes: [String!]!) {
    importAlarmTemplatesFromDefault(alarmTemplateCodes: $alarmTemplateCodes) {
      success
      importedTemplates {
        code
        success
        message
      }
    }
  }
`;

/**
 * __useImportAlarmTemplatesFromDefaultMutation__
 *
 * To run a mutation, you first call `useImportAlarmTemplatesFromDefaultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportAlarmTemplatesFromDefaultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportAlarmTemplatesFromDefaultMutation({
 *   variables: {
 *     alarmTemplateCodes: // value for 'alarmTemplateCodes'
 *   },
 * });
 */
export function useImportAlarmTemplatesFromDefaultMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportAlarmTemplatesFromDefaultMutation,
        ImportAlarmTemplatesFromDefaultMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportAlarmTemplatesFromDefaultMutation,
          ImportAlarmTemplatesFromDefaultMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ImportAlarmTemplatesFromDefaultMutation,
    ImportAlarmTemplatesFromDefaultMutationVariables
  >(ImportAlarmTemplatesFromDefaultDocument, options);
}
export type ImportAlarmTemplatesFromDefaultMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportAlarmTemplatesFromDefaultMutation,
  ImportAlarmTemplatesFromDefaultMutationVariables
>;
export const ImportAlarmTemplatesDocument = gql`
  mutation importAlarmTemplates($fhirAlarmTemplates: [String!], $keepTemplateIds: Boolean, $dropAllExisting: Boolean) {
    importAlarmTemplates(
      fhirAlarmTemplates: $fhirAlarmTemplates
      keepTemplateIds: $keepTemplateIds
      dropAllExisting: $dropAllExisting
    ) {
      success
    }
  }
`;

/**
 * __useImportAlarmTemplatesMutation__
 *
 * To run a mutation, you first call `useImportAlarmTemplatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportAlarmTemplatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportAlarmTemplatesMutation({
 *   variables: {
 *     fhirAlarmTemplates: // value for 'fhirAlarmTemplates'
 *     keepTemplateIds: // value for 'keepTemplateIds'
 *     dropAllExisting: // value for 'dropAllExisting'
 *   },
 * });
 */
export function useImportAlarmTemplatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ImportAlarmTemplatesMutation, ImportAlarmTemplatesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ImportAlarmTemplatesMutation, ImportAlarmTemplatesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ImportAlarmTemplatesMutation, ImportAlarmTemplatesMutationVariables>(
    ImportAlarmTemplatesDocument,
    options,
  );
}
export type ImportAlarmTemplatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportAlarmTemplatesMutation,
  ImportAlarmTemplatesMutationVariables
>;
export const SyncAlarmTemplatesDocument = gql`
  mutation SyncAlarmTemplates($alarmTemplateCodes: [String!]!) {
    syncAlarmTemplates(alarmTemplateCodes: $alarmTemplateCodes) {
      success
      importedTemplates {
        code
        success
        message
      }
    }
  }
`;

/**
 * __useSyncAlarmTemplatesMutation__
 *
 * To run a mutation, you first call `useSyncAlarmTemplatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncAlarmTemplatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncAlarmTemplatesMutation({
 *   variables: {
 *     alarmTemplateCodes: // value for 'alarmTemplateCodes'
 *   },
 * });
 */
export function useSyncAlarmTemplatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SyncAlarmTemplatesMutation, SyncAlarmTemplatesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SyncAlarmTemplatesMutation, SyncAlarmTemplatesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SyncAlarmTemplatesMutation, SyncAlarmTemplatesMutationVariables>(
    SyncAlarmTemplatesDocument,
    options,
  );
}
export type SyncAlarmTemplatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SyncAlarmTemplatesMutation,
  SyncAlarmTemplatesMutationVariables
>;
export const ImportDevicesFromSafemateProDocument = gql`
  mutation importDevicesFromSafematePro($createInput: ImportDevicesInput!) {
    importDevicesFromSafematePro(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      devices {
        id
      }
    }
  }
`;

/**
 * __useImportDevicesFromSafemateProMutation__
 *
 * To run a mutation, you first call `useImportDevicesFromSafemateProMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportDevicesFromSafemateProMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportDevicesFromSafemateProMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useImportDevicesFromSafemateProMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportDevicesFromSafemateProMutation,
        ImportDevicesFromSafemateProMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportDevicesFromSafemateProMutation,
          ImportDevicesFromSafemateProMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ImportDevicesFromSafemateProMutation,
    ImportDevicesFromSafemateProMutationVariables
  >(ImportDevicesFromSafemateProDocument, options);
}
export type ImportDevicesFromSafemateProMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportDevicesFromSafemateProMutation,
  ImportDevicesFromSafemateProMutationVariables
>;
export const ImportEventForPatientRawDocument = gql`
  mutation importEventForPatientRaw($patientId: ID!, $input: PatientEventRaw!) {
    importEventForPatientRaw(patientId: $patientId, input: $input) {
      success
    }
  }
`;

/**
 * __useImportEventForPatientRawMutation__
 *
 * To run a mutation, you first call `useImportEventForPatientRawMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportEventForPatientRawMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportEventForPatientRawMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useImportEventForPatientRawMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportEventForPatientRawMutation,
        ImportEventForPatientRawMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportEventForPatientRawMutation,
          ImportEventForPatientRawMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ImportEventForPatientRawMutation, ImportEventForPatientRawMutationVariables>(
    ImportEventForPatientRawDocument,
    options,
  );
}
export type ImportEventForPatientRawMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportEventForPatientRawMutation,
  ImportEventForPatientRawMutationVariables
>;
export const ImportMeasurementTemplatesFromDefaultDocument = gql`
  mutation importMeasurementTemplatesFromDefault($measurementTemplateCodes: [String!]!) {
    importMeasurementTemplatesFromDefault(measurementTemplateCodes: $measurementTemplateCodes) {
      success
      message
      code
    }
  }
`;

/**
 * __useImportMeasurementTemplatesFromDefaultMutation__
 *
 * To run a mutation, you first call `useImportMeasurementTemplatesFromDefaultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportMeasurementTemplatesFromDefaultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportMeasurementTemplatesFromDefaultMutation({
 *   variables: {
 *     measurementTemplateCodes: // value for 'measurementTemplateCodes'
 *   },
 * });
 */
export function useImportMeasurementTemplatesFromDefaultMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportMeasurementTemplatesFromDefaultMutation,
        ImportMeasurementTemplatesFromDefaultMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportMeasurementTemplatesFromDefaultMutation,
          ImportMeasurementTemplatesFromDefaultMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ImportMeasurementTemplatesFromDefaultMutation,
    ImportMeasurementTemplatesFromDefaultMutationVariables
  >(ImportMeasurementTemplatesFromDefaultDocument, options);
}
export type ImportMeasurementTemplatesFromDefaultMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ImportMeasurementTemplatesFromDefaultMutation,
    ImportMeasurementTemplatesFromDefaultMutationVariables
  >;
export const ImportObservationTemplatesDocument = gql`
  mutation importObservationTemplates($fhirTemplates: [String!], $keepTemplateIds: Boolean, $dropAllExisting: Boolean) {
    importObservationTemplates(
      fhirTemplates: $fhirTemplates
      keepTemplateIds: $keepTemplateIds
      dropAllExisting: $dropAllExisting
    ) {
      success
    }
  }
`;

/**
 * __useImportObservationTemplatesMutation__
 *
 * To run a mutation, you first call `useImportObservationTemplatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportObservationTemplatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportObservationTemplatesMutation({
 *   variables: {
 *     fhirTemplates: // value for 'fhirTemplates'
 *     keepTemplateIds: // value for 'keepTemplateIds'
 *     dropAllExisting: // value for 'dropAllExisting'
 *   },
 * });
 */
export function useImportObservationTemplatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportObservationTemplatesMutation,
        ImportObservationTemplatesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportObservationTemplatesMutation,
          ImportObservationTemplatesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ImportObservationTemplatesMutation,
    ImportObservationTemplatesMutationVariables
  >(ImportObservationTemplatesDocument, options);
}
export type ImportObservationTemplatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportObservationTemplatesMutation,
  ImportObservationTemplatesMutationVariables
>;
export const ValidateForwarderDocument = gql`
  mutation validateForwarder($id: String!) {
    validateForwarder(id: $id) {
      success
      message
      details
    }
  }
`;

/**
 * __useValidateForwarderMutation__
 *
 * To run a mutation, you first call `useValidateForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useValidateForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ValidateForwarderMutation, ValidateForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ValidateForwarderMutation, ValidateForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ValidateForwarderMutation, ValidateForwarderMutationVariables>(
    ValidateForwarderDocument,
    options,
  );
}
export type ValidateForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ValidateForwarderMutation,
  ValidateForwarderMutationVariables
>;
export const CreateIntegrationDocument = gql`
  mutation createIntegration($input: IntegrationCreateInput!) {
    createIntegration(input: $input) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
      id
    }
  }
`;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateIntegrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(
    CreateIntegrationDocument,
    options,
  );
}
export type CreateIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
>;
export const UpdateIntegrationDocument = gql`
  mutation updateIntegration($id: ID!, $input: IntegrationUpdateInput!) {
    updateIntegration(id: $id, input: $input) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
      id
    }
  }
`;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIntegrationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(
    UpdateIntegrationDocument,
    options,
  );
}
export type UpdateIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateIntegrationMutation,
  UpdateIntegrationMutationVariables
>;
export const CreateAlarmForwarderDocument = gql`
  mutation createAlarmForwarder($id: ID!, $forwarderInput: ForwarderCreateInput!) {
    createAlarmForwarder(id: $id, forwarderInput: $forwarderInput) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
      id
    }
  }
`;

/**
 * __useCreateAlarmForwarderMutation__
 *
 * To run a mutation, you first call `useCreateAlarmForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     forwarderInput: // value for 'forwarderInput'
 *   },
 * });
 */
export function useCreateAlarmForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmForwarderMutation, CreateAlarmForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAlarmForwarderMutation, CreateAlarmForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmForwarderMutation, CreateAlarmForwarderMutationVariables>(
    CreateAlarmForwarderDocument,
    options,
  );
}
export type CreateAlarmForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmForwarderMutation,
  CreateAlarmForwarderMutationVariables
>;
export const UpdateAlarmForwarderDocument = gql`
  mutation updateAlarmForwarder($id: String!, $forwarderInput: ForwarderUpdateInput!) {
    updateAlarmForwarder(id: $id, forwarderInput: $forwarderInput) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
      id
    }
  }
`;

/**
 * __useUpdateAlarmForwarderMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     forwarderInput: // value for 'forwarderInput'
 *   },
 * });
 */
export function useUpdateAlarmForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmForwarderMutation, UpdateAlarmForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmForwarderMutation, UpdateAlarmForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmForwarderMutation, UpdateAlarmForwarderMutationVariables>(
    UpdateAlarmForwarderDocument,
    options,
  );
}
export type UpdateAlarmForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmForwarderMutation,
  UpdateAlarmForwarderMutationVariables
>;
export const UpdateForwarderErrorHandlingDocument = gql`
  mutation updateForwarderErrorHandling($forwarderConfigId: ID!, $errorHandling: ForwarderErrorHandlingInput!) {
    updateForwarderErrorHandling(forwarderConfigId: $forwarderConfigId, errorHandling: $errorHandling) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
      id
    }
  }
`;

/**
 * __useUpdateForwarderErrorHandlingMutation__
 *
 * To run a mutation, you first call `useUpdateForwarderErrorHandlingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForwarderErrorHandlingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateForwarderErrorHandlingMutation({
 *   variables: {
 *     forwarderConfigId: // value for 'forwarderConfigId'
 *     errorHandling: // value for 'errorHandling'
 *   },
 * });
 */
export function useUpdateForwarderErrorHandlingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateForwarderErrorHandlingMutation,
        UpdateForwarderErrorHandlingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateForwarderErrorHandlingMutation,
          UpdateForwarderErrorHandlingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateForwarderErrorHandlingMutation,
    UpdateForwarderErrorHandlingMutationVariables
  >(UpdateForwarderErrorHandlingDocument, options);
}
export type UpdateForwarderErrorHandlingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateForwarderErrorHandlingMutation,
  UpdateForwarderErrorHandlingMutationVariables
>;
export const AssignForwarderToPatientGroupsDocument = gql`
  mutation assignForwarderToPatientGroups($forwarderConfigId: ID!, $patientGroupIds: [ID!]!) {
    assignForwarderToPatientGroups(forwarderConfigId: $forwarderConfigId, patientGroupIds: $patientGroupIds) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useAssignForwarderToPatientGroupsMutation__
 *
 * To run a mutation, you first call `useAssignForwarderToPatientGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignForwarderToPatientGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignForwarderToPatientGroupsMutation({
 *   variables: {
 *     forwarderConfigId: // value for 'forwarderConfigId'
 *     patientGroupIds: // value for 'patientGroupIds'
 *   },
 * });
 */
export function useAssignForwarderToPatientGroupsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignForwarderToPatientGroupsMutation,
        AssignForwarderToPatientGroupsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignForwarderToPatientGroupsMutation,
          AssignForwarderToPatientGroupsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AssignForwarderToPatientGroupsMutation,
    AssignForwarderToPatientGroupsMutationVariables
  >(AssignForwarderToPatientGroupsDocument, options);
}
export type AssignForwarderToPatientGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AssignForwarderToPatientGroupsMutation,
  AssignForwarderToPatientGroupsMutationVariables
>;
export const DeleteIntegrationDocument = gql`
  mutation deleteIntegration($id: String!) {
    deleteIntegration(id: $id) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteIntegrationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(
    DeleteIntegrationDocument,
    options,
  );
}
export type DeleteIntegrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteIntegrationMutation,
  DeleteIntegrationMutationVariables
>;
export const DeleteForwarderDocument = gql`
  mutation deleteForwarder($id: String!) {
    deleteForwarder(id: $id) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useDeleteForwarderMutation__
 *
 * To run a mutation, you first call `useDeleteForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteForwarderMutation, DeleteForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteForwarderMutation, DeleteForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteForwarderMutation, DeleteForwarderMutationVariables>(
    DeleteForwarderDocument,
    options,
  );
}
export type DeleteForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteForwarderMutation,
  DeleteForwarderMutationVariables
>;
export const AssignExternalAccessToForwarderDocument = gql`
  mutation assignExternalAccessToForwarder($forwarderConfigId: ID!, $externalAccessId: ID!) {
    assignExternalAccessToForwarder(forwarderConfigId: $forwarderConfigId, externalAccessId: $externalAccessId) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useAssignExternalAccessToForwarderMutation__
 *
 * To run a mutation, you first call `useAssignExternalAccessToForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignExternalAccessToForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignExternalAccessToForwarderMutation({
 *   variables: {
 *     forwarderConfigId: // value for 'forwarderConfigId'
 *     externalAccessId: // value for 'externalAccessId'
 *   },
 * });
 */
export function useAssignExternalAccessToForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignExternalAccessToForwarderMutation,
        AssignExternalAccessToForwarderMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignExternalAccessToForwarderMutation,
          AssignExternalAccessToForwarderMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AssignExternalAccessToForwarderMutation,
    AssignExternalAccessToForwarderMutationVariables
  >(AssignExternalAccessToForwarderDocument, options);
}
export type AssignExternalAccessToForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AssignExternalAccessToForwarderMutation,
  AssignExternalAccessToForwarderMutationVariables
>;
export const AssignIntegrationToSkyresponseConfigDocument = gql`
  mutation assignIntegrationToSkyresponseConfig($userGroupId: ID!, $integrationId: ID!) {
    assignIntegrationToSkyresponseConfig(userGroupId: $userGroupId, integrationId: $integrationId) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useAssignIntegrationToSkyresponseConfigMutation__
 *
 * To run a mutation, you first call `useAssignIntegrationToSkyresponseConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignIntegrationToSkyresponseConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignIntegrationToSkyresponseConfigMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useAssignIntegrationToSkyresponseConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignIntegrationToSkyresponseConfigMutation,
        AssignIntegrationToSkyresponseConfigMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignIntegrationToSkyresponseConfigMutation,
          AssignIntegrationToSkyresponseConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AssignIntegrationToSkyresponseConfigMutation,
    AssignIntegrationToSkyresponseConfigMutationVariables
  >(AssignIntegrationToSkyresponseConfigDocument, options);
}
export type AssignIntegrationToSkyresponseConfigMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AssignIntegrationToSkyresponseConfigMutation,
    AssignIntegrationToSkyresponseConfigMutationVariables
  >;
export const RemoveIntegrationFromSkyresponseConfigDocument = gql`
  mutation removeIntegrationFromSkyresponseConfig($userGroupId: ID!) {
    removeIntegrationFromSkyresponseConfig(userGroupId: $userGroupId) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useRemoveIntegrationFromSkyresponseConfigMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationFromSkyresponseConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationFromSkyresponseConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveIntegrationFromSkyresponseConfigMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useRemoveIntegrationFromSkyresponseConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveIntegrationFromSkyresponseConfigMutation,
        RemoveIntegrationFromSkyresponseConfigMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveIntegrationFromSkyresponseConfigMutation,
          RemoveIntegrationFromSkyresponseConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveIntegrationFromSkyresponseConfigMutation,
    RemoveIntegrationFromSkyresponseConfigMutationVariables
  >(RemoveIntegrationFromSkyresponseConfigDocument, options);
}
export type RemoveIntegrationFromSkyresponseConfigMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveIntegrationFromSkyresponseConfigMutation,
    RemoveIntegrationFromSkyresponseConfigMutationVariables
  >;
export const RemoveCameraFromPatientDocument = gql`
  mutation removeCameraFromPatient($patientId: ID!, $cameraId: ID!) {
    removeCameraFromPatient(patientId: $patientId, cameraId: $cameraId) {
      success
    }
  }
`;

/**
 * __useRemoveCameraFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveCameraFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCameraFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCameraFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useRemoveCameraFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveCameraFromPatientMutation, RemoveCameraFromPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveCameraFromPatientMutation,
          RemoveCameraFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveCameraFromPatientMutation, RemoveCameraFromPatientMutationVariables>(
    RemoveCameraFromPatientDocument,
    options,
  );
}
export type RemoveCameraFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveCameraFromPatientMutation,
  RemoveCameraFromPatientMutationVariables
>;
export const StartPhoneCallDocument = gql`
  mutation startPhoneCall($type: PhoneCallTargetType!, $id: ID!, $phoneNumber: String) {
    startPhoneCall(type: $type, id: $id, phoneNumber: $phoneNumber)
  }
`;

/**
 * __useStartPhoneCallMutation__
 *
 * To run a mutation, you first call `useStartPhoneCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartPhoneCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartPhoneCallMutation({
 *   variables: {
 *     type: // value for 'type'
 *     id: // value for 'id'
 *     phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useStartPhoneCallMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartPhoneCallMutation, StartPhoneCallMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartPhoneCallMutation, StartPhoneCallMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartPhoneCallMutation, StartPhoneCallMutationVariables>(
    StartPhoneCallDocument,
    options,
  );
}
export type StartPhoneCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartPhoneCallMutation,
  StartPhoneCallMutationVariables
>;
export const AddPlannedSupervisionDocument = gql`
  mutation addPlannedSupervision($patientId: ID!, $input: PlannedSupervisionCreateInput!) {
    addPlannedSupervision(patientId: $patientId, input: $input) {
      success
      plannedSupervision {
        alarmActivity {
          id
        }
      }
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useAddPlannedSupervisionMutation__
 *
 * To run a mutation, you first call `useAddPlannedSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPlannedSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPlannedSupervisionMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddPlannedSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPlannedSupervisionMutation, AddPlannedSupervisionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPlannedSupervisionMutation, AddPlannedSupervisionMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPlannedSupervisionMutation, AddPlannedSupervisionMutationVariables>(
    AddPlannedSupervisionDocument,
    options,
  );
}
export type AddPlannedSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPlannedSupervisionMutation,
  AddPlannedSupervisionMutationVariables
>;
export const UpdatePlannedSupervisionDocument = gql`
  mutation updatePlannedSupervision($patientId: ID!, $alarmActivityId: ID!, $input: PlannedSupervisionUpdateInput!) {
    updatePlannedSupervision(patientId: $patientId, alarmActivityId: $alarmActivityId, input: $input) {
      success
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePlannedSupervisionMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePlannedSupervisionMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     alarmActivityId: // value for 'alarmActivityId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePlannedSupervisionMutation,
        UpdatePlannedSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePlannedSupervisionMutation,
          UpdatePlannedSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePlannedSupervisionMutation, UpdatePlannedSupervisionMutationVariables>(
    UpdatePlannedSupervisionDocument,
    options,
  );
}
export type UpdatePlannedSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePlannedSupervisionMutation,
  UpdatePlannedSupervisionMutationVariables
>;
export const RemovePlannedSupervisionDocument = gql`
  mutation removePlannedSupervision($patientId: ID!, $alarmActivityId: ID!) {
    removePlannedSupervision(patientId: $patientId, alarmActivityId: $alarmActivityId) {
      success
      message
    }
  }
`;

/**
 * __useRemovePlannedSupervisionMutation__
 *
 * To run a mutation, you first call `useRemovePlannedSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlannedSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePlannedSupervisionMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     alarmActivityId: // value for 'alarmActivityId'
 *   },
 * });
 */
export function useRemovePlannedSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePlannedSupervisionMutation,
        RemovePlannedSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePlannedSupervisionMutation,
          RemovePlannedSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemovePlannedSupervisionMutation, RemovePlannedSupervisionMutationVariables>(
    RemovePlannedSupervisionDocument,
    options,
  );
}
export type RemovePlannedSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePlannedSupervisionMutation,
  RemovePlannedSupervisionMutationVariables
>;
export const TriggerEventInCameraDocument = gql`
  mutation triggerEventInCamera($cameraId: ID!, $profileId: Int!, $appName: String!) {
    triggerEventInCamera(cameraId: $cameraId, profileId: $profileId, appName: $appName)
  }
`;

/**
 * __useTriggerEventInCameraMutation__
 *
 * To run a mutation, you first call `useTriggerEventInCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEventInCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerEventInCameraMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     profileId: // value for 'profileId'
 *     appName: // value for 'appName'
 *   },
 * });
 */
export function useTriggerEventInCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>(
    TriggerEventInCameraDocument,
    options,
  );
}
export type TriggerEventInCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TriggerEventInCameraMutation,
  TriggerEventInCameraMutationVariables
>;
export const UpdateAlarmTemplateDocument = gql`
  mutation updateAlarmTemplate($id: ID!, $input: AlarmTemplateUpdateInput!) {
    updateAlarmTemplate(id: $id, input: $input) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>(
    UpdateAlarmTemplateDocument,
    options,
  );
}
export type UpdateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmTemplateMutation,
  UpdateAlarmTemplateMutationVariables
>;
export const UpdateAnonymizationDocument = gql`
  mutation updateAnonymization($cameraId: ID!, $anonymization: Boolean!, $reason: String) {
    updateAnonymization(cameraId: $cameraId, anonymization: $anonymization, reason: $reason)
  }
`;

/**
 * __useUpdateAnonymizationMutation__
 *
 * To run a mutation, you first call `useUpdateAnonymizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnonymizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAnonymizationMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     anonymization: // value for 'anonymization'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateAnonymizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAnonymizationMutation, UpdateAnonymizationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAnonymizationMutation, UpdateAnonymizationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAnonymizationMutation, UpdateAnonymizationMutationVariables>(
    UpdateAnonymizationDocument,
    options,
  );
}
export type UpdateAnonymizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAnonymizationMutation,
  UpdateAnonymizationMutationVariables
>;
export const UpdatePatientProfileDocument = gql`
  mutation updatePatientProfile($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePatientProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientProfileMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>(
    UpdatePatientProfileDocument,
    options,
  );
}
export type UpdatePatientProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientProfileMutation,
  UpdatePatientProfileMutationVariables
>;
export const GetAlarmTemplateDocument = gql`
  query getAlarmTemplate($id: ID!) {
    getAlarmTemplate(id: $id) {
      id
      status
      alarmIcon
      callbackMinutes
      debounceDelay
      cep {
        trigger
        after
        cancelledBy
      }
      timedCep {
        events
        cancelledBy
        mode
      }
      technical
      tagAction {
        target
        type
        label
      }
      vkpEncounter {
        type
        reason
      }
      generatesAlarm
      locationTraceOnly
      noCarePlanRequired
      resolveAction
      identifier {
        value
      }
      description
      code {
        coding {
          display
          code
          system
        }
        text
      }
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
        extension {
          url
          valueBoolean
          valueInteger
          valueString
          ValueId
        }
      }
    }
  }
`;

/**
 * __useGetAlarmTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAlarmTemplateQuery(
  variables:
    | GetAlarmTemplateQueryVariables
    | VueCompositionApi.Ref<GetAlarmTemplateQueryVariables>
    | ReactiveFunction<GetAlarmTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>(
    GetAlarmTemplateDocument,
    variables,
    options,
  );
}
export function useGetAlarmTemplateLazyQuery(
  variables?:
    | GetAlarmTemplateQueryVariables
    | VueCompositionApi.Ref<GetAlarmTemplateQueryVariables>
    | ReactiveFunction<GetAlarmTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>(
    GetAlarmTemplateDocument,
    variables,
    options,
  );
}
export type GetAlarmTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplateQuery,
  GetAlarmTemplateQueryVariables
>;
export const HealthProviderSettingsForExternalIdHumanInputDocument = gql`
  query healthProviderSettingsForExternalIdHumanInput {
    healthProviderSettings {
      userAuth {
        twoFactorSms
        externalIdP {
          alias
          default
          displayName
          enabled
          support
        }
      }
      patientAuth {
        twoFactorSms
      }
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForExternalIdHumanInputQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForExternalIdHumanInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForExternalIdHumanInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForExternalIdHumanInputQuery();
 */
export function useHealthProviderSettingsForExternalIdHumanInputQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForExternalIdHumanInputQuery,
        HealthProviderSettingsForExternalIdHumanInputQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >(HealthProviderSettingsForExternalIdHumanInputDocument, {}, options);
}
export function useHealthProviderSettingsForExternalIdHumanInputLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForExternalIdHumanInputQuery,
        HealthProviderSettingsForExternalIdHumanInputQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >(HealthProviderSettingsForExternalIdHumanInputDocument, {}, options);
}
export type HealthProviderSettingsForExternalIdHumanInputQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >;
export const GetAllAlarmHistoryDocument = gql`
  query getAllAlarmHistory(
    $from: dateTime!
    $to: dateTime!
    $patientGroupIds: [ID!]
    $includeSupervision: Boolean = false
  ) {
    getAllAlarmHistory(
      from: $from
      to: $to
      patientGroupIds: $patientGroupIds
      includeSupervision: $includeSupervision
    ) {
      telluAlarmId
      responseCenterAlarmId
      tag
      name {
        display
      }
      owner {
        display
      }
      alarmEvent
      routingType
      serverAlarmTime
      deactivationTimeInApp
      deactivationTimeInRs
      acceptedAtInApp
      acceptedAtInRs
      alarmForwardedAt
      alarmStartedInApp
      handlingMode
      camerasOpened
      camerasOpenedBy {
        name
        count
      }
      autoReleasedAt
      patientId
      alarmHandling
      journalWorkflowStatus
      alarmCode
      priority
      organization
      group
      responseCenter
      textMessage
      globalAlarmId
      identifier
      patientName {
        given
        family
        text
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      operatorForRs
      operatorForApp
      alarmActionOne
      alarmActionLast
      alarmReasonOne
      alarmReasonLast
      completionOptionNote
      freeTextNote
    }
  }
`;

/**
 * __useGetAllAlarmHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmHistoryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   patientGroupIds: // value for 'patientGroupIds'
 *   includeSupervision: // value for 'includeSupervision'
 * });
 */
export function useGetAllAlarmHistoryQuery(
  variables:
    | GetAllAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmHistoryQueryVariables>
    | ReactiveFunction<GetAllAlarmHistoryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>(
    GetAllAlarmHistoryDocument,
    variables,
    options,
  );
}
export function useGetAllAlarmHistoryLazyQuery(
  variables?:
    | GetAllAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmHistoryQueryVariables>
    | ReactiveFunction<GetAllAlarmHistoryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>(
    GetAllAlarmHistoryDocument,
    variables,
    options,
  );
}
export type GetAllAlarmHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmHistoryQuery,
  GetAllAlarmHistoryQueryVariables
>;
export const GetAlarmHistoryForPatientDocument = gql`
  query getAlarmHistoryForPatient(
    $from: dateTime!
    $to: dateTime!
    $patientId: ID!
    $includeSupervision: Boolean = false
  ) {
    getAlarmHistoryForPatient(from: $from, to: $to, patientId: $patientId, includeSupervision: $includeSupervision) {
      telluAlarmId
      responseCenterAlarmId
      tag
      name {
        display
      }
      owner {
        display
      }
      alarmEvent
      serverAlarmTime
      routingType
      deactivationTimeInApp
      deactivationTimeInRs
      acceptedAtInApp
      acceptedAtInRs
      alarmForwardedAt
      alarmStartedInApp
      handlingMode
      camerasOpened
      camerasOpenedBy {
        name
        count
      }
      autoReleasedAt
      patientId
      alarmHandling
      journalWorkflowStatus
      alarmCode
      priority
      organization
      group
      responseCenter
      textMessage
      identifier
      globalAlarmId
      patientName {
        given
        family
        text
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      operatorForRs
      operatorForApp
      alarmActionOne
      alarmActionLast
      alarmReasonOne
      alarmReasonLast
      completionOptionNote
      freeTextNote
    }
  }
`;

/**
 * __useGetAlarmHistoryForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryForPatientQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   patientId: // value for 'patientId'
 *   includeSupervision: // value for 'includeSupervision'
 * });
 */
export function useGetAlarmHistoryForPatientQuery(
  variables:
    | GetAlarmHistoryForPatientQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForPatientQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>(
    GetAlarmHistoryForPatientDocument,
    variables,
    options,
  );
}
export function useGetAlarmHistoryForPatientLazyQuery(
  variables?:
    | GetAlarmHistoryForPatientQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForPatientQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>(
    GetAlarmHistoryForPatientDocument,
    variables,
    options,
  );
}
export type GetAlarmHistoryForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryForPatientQuery,
  GetAlarmHistoryForPatientQueryVariables
>;
export const UserGroupForAlarmHistoryDocument = gql`
  query userGroupForAlarmHistory($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      id
      name
      skyresponse {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
    }
  }
`;

/**
 * __useUserGroupForAlarmHistoryQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForAlarmHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForAlarmHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForAlarmHistoryQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupForAlarmHistoryQuery(
  variables:
    | UserGroupForAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<UserGroupForAlarmHistoryQueryVariables>
    | ReactiveFunction<UserGroupForAlarmHistoryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>(
    UserGroupForAlarmHistoryDocument,
    variables,
    options,
  );
}
export function useUserGroupForAlarmHistoryLazyQuery(
  variables:
    | UserGroupForAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<UserGroupForAlarmHistoryQueryVariables>
    | ReactiveFunction<UserGroupForAlarmHistoryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>(
    UserGroupForAlarmHistoryDocument,
    variables,
    options,
  );
}
export type UserGroupForAlarmHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForAlarmHistoryQuery,
  UserGroupForAlarmHistoryQueryVariables
>;
export const GetAlarmHistoryDetailByIdDocument = gql`
  query getAlarmHistoryDetailById($telluAlarmId: ID, $skyresponseAlarmId: ID) {
    getAlarmHistoryDetailById(telluAlarmId: $telluAlarmId, skyresponseAlarmId: $skyresponseAlarmId) {
      cameraViews {
        cameraId
        cameraName
        watchedBy
        streamId
        startedAt
        endedAt
      }
      skyresponseAlarmDetail {
        id
        userId
        name
        messages
        serverAlarmTime
        deactivationTime
        responseCenter
        globalAlarmId
        reason
        identifier
        action
        acceptedAt
        logs {
          created
          type
          subType
          text
          name
        }
        textMessage
        alarmCode
      }
      telluAlarmDetail {
        input {
          values {
            name
            valueString
            valueBoolean
            valueNumber
          }
          valueReference {
            reference
          }
          type {
            text
            coding {
              system
              code
            }
          }
          icon
          priority
          timestamp
        }
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        patient {
          id
          name {
            given
            family
            text
          }
          patientGroups {
            id
            name
          }
        }
        id
        for {
          display
        }
        description
        priority
        authoredOn
        note {
          authorString
          authorReference {
            display
          }
          time
          text
        }
        acceptedAt
        presentAt
        completedAt
        journalWorkflow {
          type
          status
          userGroupId
          retriedAt
          nextRetry
          completedAt
          freeTextNote
          completionOptions
          debugDetails
        }
        completionOptionNote
        freeTextNote
      }
    }
  }
`;

/**
 * __useGetAlarmHistoryDetailByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryDetailByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryDetailByIdQuery({
 *   telluAlarmId: // value for 'telluAlarmId'
 *   skyresponseAlarmId: // value for 'skyresponseAlarmId'
 * });
 */
export function useGetAlarmHistoryDetailByIdQuery(
  variables:
    | GetAlarmHistoryDetailByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryDetailByIdQueryVariables>
    | ReactiveFunction<GetAlarmHistoryDetailByIdQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>(
    GetAlarmHistoryDetailByIdDocument,
    variables,
    options,
  );
}
export function useGetAlarmHistoryDetailByIdLazyQuery(
  variables:
    | GetAlarmHistoryDetailByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryDetailByIdQueryVariables>
    | ReactiveFunction<GetAlarmHistoryDetailByIdQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>(
    GetAlarmHistoryDetailByIdDocument,
    variables,
    options,
  );
}
export type GetAlarmHistoryDetailByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryDetailByIdQuery,
  GetAlarmHistoryDetailByIdQueryVariables
>;
export const GetAlarmHistoryForResponderDocument = gql`
  query getAlarmHistoryForResponder(
    $sessionFilter: Boolean
    $from: dateTime
    $to: dateTime
    $onlyClosedByResponder: Boolean
  ) {
    getAlarmHistoryForResponder(
      sessionFilter: $sessionFilter
      from: $from
      to: $to
      onlyClosedByResponder: $onlyClosedByResponder
    ) {
      id
      status
      handlingMode
      code {
        text
      }
      intent
      priority
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        valueReference {
          reference
        }
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        type {
          text
          coding {
            code
          }
        }
        timestamp
        priority
        icon
      }
      note {
        authorString
        time
        text
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
      journalWorkflow {
        type
        status
        userGroupId
        retriedAt
        nextRetry
        completedAt
        freeTextNote
        completionOptions
        debugDetails
      }
      patient {
        id
        name {
          given
          family
        }
        patientGroups {
          id
          name
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        photo {
          url
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
    }
  }
`;

/**
 * __useGetAlarmHistoryForResponderQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryForResponderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryForResponderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryForResponderQuery({
 *   sessionFilter: // value for 'sessionFilter'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   onlyClosedByResponder: // value for 'onlyClosedByResponder'
 * });
 */
export function useGetAlarmHistoryForResponderQuery(
  variables:
    | GetAlarmHistoryForResponderQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForResponderQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForResponderQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>(
    GetAlarmHistoryForResponderDocument,
    variables,
    options,
  );
}
export function useGetAlarmHistoryForResponderLazyQuery(
  variables:
    | GetAlarmHistoryForResponderQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForResponderQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForResponderQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHistoryForResponderQuery, GetAlarmHistoryForResponderQueryVariables>(
    GetAlarmHistoryForResponderDocument,
    variables,
    options,
  );
}
export type GetAlarmHistoryForResponderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryForResponderQuery,
  GetAlarmHistoryForResponderQueryVariables
>;
export const AvailableResourcesToContactDocument = gql`
  query availableResourcesToContact {
    availableResourcesToContact {
      topLevelContacts {
        id
        name
        telecom {
          value
          system
          use
        }
        availableHours
        priority
      }
      lowerLevelContacts {
        id
        name
        telecom {
          value
          system
          use
        }
        availableHours
        priority
      }
    }
  }
`;

/**
 * __useAvailableResourcesToContactQuery__
 *
 * To run a query within a Vue component, call `useAvailableResourcesToContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableResourcesToContactQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableResourcesToContactQuery();
 */
export function useAvailableResourcesToContactQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>(
    AvailableResourcesToContactDocument,
    {},
    options,
  );
}
export function useAvailableResourcesToContactLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AvailableResourcesToContactQuery, AvailableResourcesToContactQueryVariables>(
    AvailableResourcesToContactDocument,
    {},
    options,
  );
}
export type AvailableResourcesToContactQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AvailableResourcesToContactQuery,
  AvailableResourcesToContactQueryVariables
>;
export const GetAvailableCamerasInInventoryDocument = gql`
  query getAvailableCamerasInInventory {
    getAvailableCamerasInInventory {
      macAddress
      modelNumber
    }
  }
`;

/**
 * __useGetAvailableCamerasInInventoryQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableCamerasInInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCamerasInInventoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableCamerasInInventoryQuery();
 */
export function useGetAvailableCamerasInInventoryQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableCamerasInInventoryQuery,
        GetAvailableCamerasInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableCamerasInInventoryQuery,
    GetAvailableCamerasInInventoryQueryVariables
  >(GetAvailableCamerasInInventoryDocument, {}, options);
}
export function useGetAvailableCamerasInInventoryLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableCamerasInInventoryQuery,
        GetAvailableCamerasInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableCamerasInInventoryQuery,
    GetAvailableCamerasInInventoryQueryVariables
  >(GetAvailableCamerasInInventoryDocument, {}, options);
}
export type GetAvailableCamerasInInventoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableCamerasInInventoryQuery,
  GetAvailableCamerasInInventoryQueryVariables
>;
export const GetCameraForFormDocument = gql`
  query getCameraForForm($cameraId: ID!) {
    getCamera(cameraId: $cameraId) {
      id
      isConfiguredInRegistry
      deviceGroup {
        id
        name
      }
      cameraProfile {
        ...CameraProfileSettings
      }
      effectiveSettings {
        ...CameraEffectiveSettingsFields
      }
      availableHours
      isAttachedToPatient
      settings {
        soundThreshold
      }
      name
      macAddress
      modelName
      manufacturer
    }
  }
  ${CameraProfileSettingsFragmentDoc}
  ${CameraEffectiveSettingsFieldsFragmentDoc}
`;

/**
 * __useGetCameraForFormQuery__
 *
 * To run a query within a Vue component, call `useGetCameraForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraForFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraForFormQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraForFormQuery(
  variables:
    | GetCameraForFormQueryVariables
    | VueCompositionApi.Ref<GetCameraForFormQueryVariables>
    | ReactiveFunction<GetCameraForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraForFormQuery, GetCameraForFormQueryVariables>(
    GetCameraForFormDocument,
    variables,
    options,
  );
}
export function useGetCameraForFormLazyQuery(
  variables?:
    | GetCameraForFormQueryVariables
    | VueCompositionApi.Ref<GetCameraForFormQueryVariables>
    | ReactiveFunction<GetCameraForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraForFormQuery, GetCameraForFormQueryVariables>(
    GetCameraForFormDocument,
    variables,
    options,
  );
}
export type GetCameraForFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraForFormQuery,
  GetCameraForFormQueryVariables
>;
export const CmpAccountsDocument = gql`
  query cmpAccounts {
    cmpAccounts {
      id
      clientId
      clientSecret
      customerGroup
    }
  }
`;

/**
 * __useCmpAccountsQuery__
 *
 * To run a query within a Vue component, call `useCmpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCmpAccountsQuery();
 */
export function useCmpAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CmpAccountsQuery, CmpAccountsQueryVariables>(CmpAccountsDocument, {}, options);
}
export function useCmpAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CmpAccountsQuery, CmpAccountsQueryVariables>(
    CmpAccountsDocument,
    {},
    options,
  );
}
export type CmpAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CmpAccountsQuery,
  CmpAccountsQueryVariables
>;
export const ValidateCustomerGroupTowardsCmpDocument = gql`
  mutation validateCustomerGroupTowardsCmp($id: String!) {
    validateCustomerGroupTowardsCmp(id: $id) {
      success
      message
      device
      totalDevices
    }
  }
`;

/**
 * __useValidateCustomerGroupTowardsCmpMutation__
 *
 * To run a mutation, you first call `useValidateCustomerGroupTowardsCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateCustomerGroupTowardsCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateCustomerGroupTowardsCmpMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useValidateCustomerGroupTowardsCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ValidateCustomerGroupTowardsCmpMutation,
        ValidateCustomerGroupTowardsCmpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ValidateCustomerGroupTowardsCmpMutation,
          ValidateCustomerGroupTowardsCmpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ValidateCustomerGroupTowardsCmpMutation,
    ValidateCustomerGroupTowardsCmpMutationVariables
  >(ValidateCustomerGroupTowardsCmpDocument, options);
}
export type ValidateCustomerGroupTowardsCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ValidateCustomerGroupTowardsCmpMutation,
  ValidateCustomerGroupTowardsCmpMutationVariables
>;
export const DeleteCmpAccountDocument = gql`
  mutation deleteCmpAccount($id: String!) {
    deleteCmpAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteCmpAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCmpAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>(
    DeleteCmpAccountDocument,
    options,
  );
}
export type DeleteCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCmpAccountMutation,
  DeleteCmpAccountMutationVariables
>;
export const ValidateCmpAccountTowardsCmpDocument = gql`
  mutation validateCmpAccountTowardsCmp($id: String!) {
    validateCmpAccountTowardsCmp(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useValidateCmpAccountTowardsCmpMutation__
 *
 * To run a mutation, you first call `useValidateCmpAccountTowardsCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateCmpAccountTowardsCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateCmpAccountTowardsCmpMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useValidateCmpAccountTowardsCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ValidateCmpAccountTowardsCmpMutation,
        ValidateCmpAccountTowardsCmpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ValidateCmpAccountTowardsCmpMutation,
          ValidateCmpAccountTowardsCmpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ValidateCmpAccountTowardsCmpMutation,
    ValidateCmpAccountTowardsCmpMutationVariables
  >(ValidateCmpAccountTowardsCmpDocument, options);
}
export type ValidateCmpAccountTowardsCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ValidateCmpAccountTowardsCmpMutation,
  ValidateCmpAccountTowardsCmpMutationVariables
>;
export const CreateCmpAccountDocument = gql`
  mutation createCmpAccount($input: CmpAccountCreateInput!) {
    createCmpAccount(input: $input) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useCreateCmpAccountMutation__
 *
 * To run a mutation, you first call `useCreateCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCmpAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>(
    CreateCmpAccountDocument,
    options,
  );
}
export type CreateCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCmpAccountMutation,
  CreateCmpAccountMutationVariables
>;
export const UpdateCmpAccountDocument = gql`
  mutation updateCmpAccount($id: String!, $input: CmpAccountUpdateInput!) {
    updateCmpAccount(id: $id, input: $input) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateCmpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCmpAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>(
    UpdateCmpAccountDocument,
    options,
  );
}
export type UpdateCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCmpAccountMutation,
  UpdateCmpAccountMutationVariables
>;
export const GetPatientCmpDevicesDocument = gql`
  query getPatientCmpDevices($id: ID!) {
    getPatientCmpDevices(id: $id) {
      id
      portalConnection {
        name
        value
        time
      }
      batteryStatus {
        name
        value
        time
      }
      powerSupply {
        name
        value
        time
      }
      alarmCode
      operationalStatus {
        name
        value
      }
      groupName
      url
      children {
        radioIdCode
        activeTimeSpan {
          hasTimeSpan
          timeSpan
        }
        equipmentType {
          name
          value
        }
        locationCode {
          name
          value
        }
        batteryStatus {
          name
          value
        }
        supervisionStatus {
          name
          value
          time
        }
      }
    }
  }
`;

/**
 * __useGetPatientCmpDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetPatientCmpDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientCmpDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientCmpDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientCmpDevicesQuery(
  variables:
    | GetPatientCmpDevicesQueryVariables
    | VueCompositionApi.Ref<GetPatientCmpDevicesQueryVariables>
    | ReactiveFunction<GetPatientCmpDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>(
    GetPatientCmpDevicesDocument,
    variables,
    options,
  );
}
export function useGetPatientCmpDevicesLazyQuery(
  variables?:
    | GetPatientCmpDevicesQueryVariables
    | VueCompositionApi.Ref<GetPatientCmpDevicesQueryVariables>
    | ReactiveFunction<GetPatientCmpDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>(
    GetPatientCmpDevicesDocument,
    variables,
    options,
  );
}
export type GetPatientCmpDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientCmpDevicesQuery,
  GetPatientCmpDevicesQueryVariables
>;
export const FetchCmpDeviceForFormDocument = gql`
  query fetchCmpDeviceForForm($serialNumber: String!) {
    fetchCmpDeviceForForm(serialNumber: $serialNumber) {
      uniqueIdentifier
      modelNumber
    }
  }
`;

/**
 * __useFetchCmpDeviceForFormQuery__
 *
 * To run a query within a Vue component, call `useFetchCmpDeviceForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCmpDeviceForFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCmpDeviceForFormQuery({
 *   serialNumber: // value for 'serialNumber'
 * });
 */
export function useFetchCmpDeviceForFormQuery(
  variables:
    | FetchCmpDeviceForFormQueryVariables
    | VueCompositionApi.Ref<FetchCmpDeviceForFormQueryVariables>
    | ReactiveFunction<FetchCmpDeviceForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>(
    FetchCmpDeviceForFormDocument,
    variables,
    options,
  );
}
export function useFetchCmpDeviceForFormLazyQuery(
  variables?:
    | FetchCmpDeviceForFormQueryVariables
    | VueCompositionApi.Ref<FetchCmpDeviceForFormQueryVariables>
    | ReactiveFunction<FetchCmpDeviceForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<FetchCmpDeviceForFormQuery, FetchCmpDeviceForFormQueryVariables>(
    FetchCmpDeviceForFormDocument,
    variables,
    options,
  );
}
export type FetchCmpDeviceForFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  FetchCmpDeviceForFormQuery,
  FetchCmpDeviceForFormQueryVariables
>;
export const GetCmpDeviceByIdDocument = gql`
  query getCmpDeviceById($id: ID!) {
    getCmpDeviceById(id: $id) {
      id
      portalConnection {
        name
        value
        time
      }
      batteryStatus {
        name
        value
        time
      }
      powerSupply {
        name
        value
        time
      }
      alarmCode
      operationalStatus {
        name
        value
      }
      groupName
      url
      children {
        radioIdCode
        activeTimeSpan {
          hasTimeSpan
          timeSpan
        }
        equipmentType {
          name
          value
        }
        locationCode {
          name
          value
        }
        batteryStatus {
          name
          value
        }
        supervisionStatus {
          name
          value
          time
        }
      }
    }
  }
`;

/**
 * __useGetCmpDeviceByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCmpDeviceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmpDeviceByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCmpDeviceByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCmpDeviceByIdQuery(
  variables:
    | GetCmpDeviceByIdQueryVariables
    | VueCompositionApi.Ref<GetCmpDeviceByIdQueryVariables>
    | ReactiveFunction<GetCmpDeviceByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>(
    GetCmpDeviceByIdDocument,
    variables,
    options,
  );
}
export function useGetCmpDeviceByIdLazyQuery(
  variables?:
    | GetCmpDeviceByIdQueryVariables
    | VueCompositionApi.Ref<GetCmpDeviceByIdQueryVariables>
    | ReactiveFunction<GetCmpDeviceByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCmpDeviceByIdQuery, GetCmpDeviceByIdQueryVariables>(
    GetCmpDeviceByIdDocument,
    variables,
    options,
  );
}
export type GetCmpDeviceByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCmpDeviceByIdQuery,
  GetCmpDeviceByIdQueryVariables
>;
export const GetAllAlarmSubscriptionsDocument = gql`
  query getAllAlarmSubscriptions {
    getAllAlarmSubscriptions {
      id
      userId
      type
      targetEmails
      targetPhoneNumbers
      deviceGroupIds
      patientGroupIds
    }
  }
`;

/**
 * __useGetAllAlarmSubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmSubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmSubscriptionsQuery();
 */
export function useGetAllAlarmSubscriptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>(
    GetAllAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export function useGetAllAlarmSubscriptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>(
    GetAllAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export type GetAllAlarmSubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmSubscriptionsQuery,
  GetAllAlarmSubscriptionsQueryVariables
>;
export const GetAllAlarmEventsForTrendsDocument = gql`
  query getAllAlarmEventsForTrends(
    $patientIds: [ID]
    $from: dateTime
    $to: dateTime
    $sessionFilter: Boolean
    $patientGroupIds: [ID!]
    $eventCodes: [String]
  ) {
    getAllAlarmEvents(
      patientIds: $patientIds
      from: $from
      to: $to
      sessionFilter: $sessionFilter
      patientGroupIds: $patientGroupIds
      eventCodes: $eventCodes
    ) {
      id
      effectiveDateTime
      status
      code {
        coding {
          code
          display
        }
      }
      component {
        code {
          coding {
            code
            display
          }
        }
        valueString
      }
      subject {
        reference
      }
    }
  }
`;

/**
 * __useGetAllAlarmEventsForTrendsQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmEventsForTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmEventsForTrendsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmEventsForTrendsQuery({
 *   patientIds: // value for 'patientIds'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   sessionFilter: // value for 'sessionFilter'
 *   patientGroupIds: // value for 'patientGroupIds'
 *   eventCodes: // value for 'eventCodes'
 * });
 */
export function useGetAllAlarmEventsForTrendsQuery(
  variables:
    | GetAllAlarmEventsForTrendsQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForTrendsQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForTrendsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>(
    GetAllAlarmEventsForTrendsDocument,
    variables,
    options,
  );
}
export function useGetAllAlarmEventsForTrendsLazyQuery(
  variables:
    | GetAllAlarmEventsForTrendsQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForTrendsQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForTrendsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmEventsForTrendsQuery, GetAllAlarmEventsForTrendsQueryVariables>(
    GetAllAlarmEventsForTrendsDocument,
    variables,
    options,
  );
}
export type GetAllAlarmEventsForTrendsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmEventsForTrendsQuery,
  GetAllAlarmEventsForTrendsQueryVariables
>;
export const GetAllPatientWithAllDevicesAndAlarmsDocument = gql`
  query getAllPatientWithAllDevicesAndAlarms($sessionFilter: Boolean, $patientGroupIds: [ID], $onlyActive: Boolean) {
    getAllPatientWithAllDevicesAndAlarms(
      sessionFilter: $sessionFilter
      patientGroupIds: $patientGroupIds
      onlyActive: $onlyActive
    ) {
      patient {
        id
        address {
          line
          postalCode
          city
          country
          text
        }
        areCamerasEnabled
        camerasStateOrigin
        responderIsPresent
        camerasDisabledAt
        camerasReactivateAt
        telecom {
          value
          system
          use
        }
        name {
          family
          given
          text
        }
        lastSupervisionTimestamp
        lastSupervisionPerformedByUserId
      }
      patientGroups
      openDeviceTechnicalAlarms {
        id
        status
        priority
        authoredOn
        for {
          reference
        }
        lastModified
        owner {
          reference
          display
          identifier {
            value
          }
        }
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        forDeviceName
        forDeviceType
      }
      openCameraTechnicalAlarms {
        id
        status
        priority
        authoredOn
        for {
          reference
        }
        lastModified
        owner {
          reference
          display
          identifier {
            value
          }
        }
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        forDeviceName
        forDeviceType
      }
      openPatientAlarms {
        id
        status
        code {
          text
        }
        for {
          reference
          type
          display
        }
        priority
        authoredOn
        firstEventTimestamp
        lastModified
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        owner {
          reference
          type
          display
        }
      }
      cameras {
        identifier
        name
        model
        lastSeen
        privacyMode
        privacyModeUntil
        userHasAccessToPatient
        availableHours
        online
        deviceGroup {
          id
          name
          enableFurnitureDetection
          furnitureDetectionPeriodSec
        }
        cameraProfile {
          ...CameraProfileSettings
        }
      }
      devices {
        id
        uniqueIdentifier
        deviceName {
          name
        }
        modelNumber
      }
    }
  }
  ${CameraProfileSettingsFragmentDoc}
`;

/**
 * __useGetAllPatientWithAllDevicesAndAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientWithAllDevicesAndAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientWithAllDevicesAndAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientWithAllDevicesAndAlarmsQuery({
 *   sessionFilter: // value for 'sessionFilter'
 *   patientGroupIds: // value for 'patientGroupIds'
 *   onlyActive: // value for 'onlyActive'
 * });
 */
export function useGetAllPatientWithAllDevicesAndAlarmsQuery(
  variables:
    | GetAllPatientWithAllDevicesAndAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientWithAllDevicesAndAlarmsQueryVariables>
    | ReactiveFunction<GetAllPatientWithAllDevicesAndAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientWithAllDevicesAndAlarmsQuery,
        GetAllPatientWithAllDevicesAndAlarmsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientWithAllDevicesAndAlarmsQuery,
          GetAllPatientWithAllDevicesAndAlarmsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientWithAllDevicesAndAlarmsQuery,
          GetAllPatientWithAllDevicesAndAlarmsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllPatientWithAllDevicesAndAlarmsQuery,
    GetAllPatientWithAllDevicesAndAlarmsQueryVariables
  >(GetAllPatientWithAllDevicesAndAlarmsDocument, variables, options);
}
export function useGetAllPatientWithAllDevicesAndAlarmsLazyQuery(
  variables:
    | GetAllPatientWithAllDevicesAndAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientWithAllDevicesAndAlarmsQueryVariables>
    | ReactiveFunction<GetAllPatientWithAllDevicesAndAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientWithAllDevicesAndAlarmsQuery,
        GetAllPatientWithAllDevicesAndAlarmsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientWithAllDevicesAndAlarmsQuery,
          GetAllPatientWithAllDevicesAndAlarmsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientWithAllDevicesAndAlarmsQuery,
          GetAllPatientWithAllDevicesAndAlarmsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllPatientWithAllDevicesAndAlarmsQuery,
    GetAllPatientWithAllDevicesAndAlarmsQueryVariables
  >(GetAllPatientWithAllDevicesAndAlarmsDocument, variables, options);
}
export type GetAllPatientWithAllDevicesAndAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientWithAllDevicesAndAlarmsQuery,
  GetAllPatientWithAllDevicesAndAlarmsQueryVariables
>;
export const GetAllUsersAlarmSubscriptionsDocument = gql`
  query getAllUsersAlarmSubscriptions {
    getAllUsersAlarmSubscriptions {
      id
      userId
      type
      targetEmails
      targetPhoneNumbers
      deviceGroupIds
      patientGroupIds
    }
  }
`;

/**
 * __useGetAllUsersAlarmSubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAllUsersAlarmSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersAlarmSubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUsersAlarmSubscriptionsQuery();
 */
export function useGetAllUsersAlarmSubscriptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllUsersAlarmSubscriptionsQuery,
        GetAllUsersAlarmSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllUsersAlarmSubscriptionsQuery, GetAllUsersAlarmSubscriptionsQueryVariables>(
    GetAllUsersAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export function useGetAllUsersAlarmSubscriptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllUsersAlarmSubscriptionsQuery,
        GetAllUsersAlarmSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllUsersAlarmSubscriptionsQuery,
    GetAllUsersAlarmSubscriptionsQueryVariables
  >(GetAllUsersAlarmSubscriptionsDocument, {}, options);
}
export type GetAllUsersAlarmSubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllUsersAlarmSubscriptionsQuery,
  GetAllUsersAlarmSubscriptionsQueryVariables
>;
export const GetDeviceByIdForTechnicalAlarmDocument = gql`
  query getDeviceByIdForTechnicalAlarm($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      modelNumber
      uniqueIdentifier
      deviceName {
        name
        type
      }
    }
  }
`;

/**
 * __useGetDeviceByIdForTechnicalAlarmQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdForTechnicalAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdForTechnicalAlarmQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdForTechnicalAlarmQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdForTechnicalAlarmQuery(
  variables:
    | GetDeviceByIdForTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForTechnicalAlarmQuery,
        GetDeviceByIdForTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetDeviceByIdForTechnicalAlarmQuery,
    GetDeviceByIdForTechnicalAlarmQueryVariables
  >(GetDeviceByIdForTechnicalAlarmDocument, variables, options);
}
export function useGetDeviceByIdForTechnicalAlarmLazyQuery(
  variables?:
    | GetDeviceByIdForTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForTechnicalAlarmQuery,
        GetDeviceByIdForTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetDeviceByIdForTechnicalAlarmQuery,
    GetDeviceByIdForTechnicalAlarmQueryVariables
  >(GetDeviceByIdForTechnicalAlarmDocument, variables, options);
}
export type GetDeviceByIdForTechnicalAlarmQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdForTechnicalAlarmQuery,
  GetDeviceByIdForTechnicalAlarmQueryVariables
>;
export const GetExternalUrlForWelfareDeviceDocument = gql`
  query getExternalUrlForWelfareDevice($id: ID!) {
    getExternalUrlForWelfareDevice(id: $id)
  }
`;

/**
 * __useGetExternalUrlForWelfareDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetExternalUrlForWelfareDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalUrlForWelfareDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExternalUrlForWelfareDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetExternalUrlForWelfareDeviceQuery(
  variables:
    | GetExternalUrlForWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetExternalUrlForWelfareDeviceQueryVariables>
    | ReactiveFunction<GetExternalUrlForWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetExternalUrlForWelfareDeviceQuery,
        GetExternalUrlForWelfareDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetExternalUrlForWelfareDeviceQuery,
    GetExternalUrlForWelfareDeviceQueryVariables
  >(GetExternalUrlForWelfareDeviceDocument, variables, options);
}
export function useGetExternalUrlForWelfareDeviceLazyQuery(
  variables?:
    | GetExternalUrlForWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetExternalUrlForWelfareDeviceQueryVariables>
    | ReactiveFunction<GetExternalUrlForWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetExternalUrlForWelfareDeviceQuery,
        GetExternalUrlForWelfareDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetExternalUrlForWelfareDeviceQuery,
    GetExternalUrlForWelfareDeviceQueryVariables
  >(GetExternalUrlForWelfareDeviceDocument, variables, options);
}
export type GetExternalUrlForWelfareDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetExternalUrlForWelfareDeviceQuery,
  GetExternalUrlForWelfareDeviceQueryVariables
>;
export const GetLatestEventSnapshotTokenForPatientDocument = gql`
  query getLatestEventSnapshotTokenForPatient($patientId: ID!) {
    getLatestEventSnapshotTokenForPatient(patientId: $patientId)
  }
`;

/**
 * __useGetLatestEventSnapshotTokenForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetLatestEventSnapshotTokenForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestEventSnapshotTokenForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestEventSnapshotTokenForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetLatestEventSnapshotTokenForPatientQuery(
  variables:
    | GetLatestEventSnapshotTokenForPatientQueryVariables
    | VueCompositionApi.Ref<GetLatestEventSnapshotTokenForPatientQueryVariables>
    | ReactiveFunction<GetLatestEventSnapshotTokenForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetLatestEventSnapshotTokenForPatientQuery,
        GetLatestEventSnapshotTokenForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetLatestEventSnapshotTokenForPatientQuery,
          GetLatestEventSnapshotTokenForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetLatestEventSnapshotTokenForPatientQuery,
          GetLatestEventSnapshotTokenForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetLatestEventSnapshotTokenForPatientQuery,
    GetLatestEventSnapshotTokenForPatientQueryVariables
  >(GetLatestEventSnapshotTokenForPatientDocument, variables, options);
}
export function useGetLatestEventSnapshotTokenForPatientLazyQuery(
  variables?:
    | GetLatestEventSnapshotTokenForPatientQueryVariables
    | VueCompositionApi.Ref<GetLatestEventSnapshotTokenForPatientQueryVariables>
    | ReactiveFunction<GetLatestEventSnapshotTokenForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetLatestEventSnapshotTokenForPatientQuery,
        GetLatestEventSnapshotTokenForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetLatestEventSnapshotTokenForPatientQuery,
          GetLatestEventSnapshotTokenForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetLatestEventSnapshotTokenForPatientQuery,
          GetLatestEventSnapshotTokenForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetLatestEventSnapshotTokenForPatientQuery,
    GetLatestEventSnapshotTokenForPatientQueryVariables
  >(GetLatestEventSnapshotTokenForPatientDocument, variables, options);
}
export type GetLatestEventSnapshotTokenForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetLatestEventSnapshotTokenForPatientQuery,
  GetLatestEventSnapshotTokenForPatientQueryVariables
>;
export const GetAllPatientAlarmsForAlarmCleanUpDocument = gql`
  query getAllPatientAlarmsForAlarmCleanUp($from: dateTime, $to: dateTime) {
    getAllPatientAlarms(from: $from, to: $to) {
      id
      status
      intent
      priority
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
      }
      note {
        authorString
        time
        text
      }
      patient {
        id
        name {
          given
          family
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        telecom {
          system
          value
        }
        photo {
          url
        }
      }
    }
  }
`;

/**
 * __useGetAllPatientAlarmsForAlarmCleanUpQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientAlarmsForAlarmCleanUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientAlarmsForAlarmCleanUpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientAlarmsForAlarmCleanUpQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAllPatientAlarmsForAlarmCleanUpQuery(
  variables:
    | GetAllPatientAlarmsForAlarmCleanUpQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForAlarmCleanUpQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForAlarmCleanUpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForAlarmCleanUpQuery,
        GetAllPatientAlarmsForAlarmCleanUpQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForAlarmCleanUpQuery,
          GetAllPatientAlarmsForAlarmCleanUpQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForAlarmCleanUpQuery,
          GetAllPatientAlarmsForAlarmCleanUpQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllPatientAlarmsForAlarmCleanUpQuery,
    GetAllPatientAlarmsForAlarmCleanUpQueryVariables
  >(GetAllPatientAlarmsForAlarmCleanUpDocument, variables, options);
}
export function useGetAllPatientAlarmsForAlarmCleanUpLazyQuery(
  variables:
    | GetAllPatientAlarmsForAlarmCleanUpQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForAlarmCleanUpQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForAlarmCleanUpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForAlarmCleanUpQuery,
        GetAllPatientAlarmsForAlarmCleanUpQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForAlarmCleanUpQuery,
          GetAllPatientAlarmsForAlarmCleanUpQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForAlarmCleanUpQuery,
          GetAllPatientAlarmsForAlarmCleanUpQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllPatientAlarmsForAlarmCleanUpQuery,
    GetAllPatientAlarmsForAlarmCleanUpQueryVariables
  >(GetAllPatientAlarmsForAlarmCleanUpDocument, variables, options);
}
export type GetAllPatientAlarmsForAlarmCleanUpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientAlarmsForAlarmCleanUpQuery,
  GetAllPatientAlarmsForAlarmCleanUpQueryVariables
>;
export const IntegrationsDocument = gql`
  query integrations {
    getIntegrations {
      id
      type
      displayName
    }
  }
`;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a Vue component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationsQuery();
 */
export function useIntegrationsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, {}, options);
}
export function useIntegrationsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<IntegrationsQuery, IntegrationsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(
    IntegrationsDocument,
    {},
    options,
  );
}
export type IntegrationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  IntegrationsQuery,
  IntegrationsQueryVariables
>;
export const IntegrationDetailsDocument = gql`
  query integrationDetails($id: String!, $type: String!) {
    getIntegrationDetails(id: $id, type: $type) {
      id
      type
      displayName
      idMappingStrategy
      almaConfig {
        primaryUrl
        username
        password
      }
      ascomConfig {
        primaryUrl
        apiKey
        ascomIntegrationId
        heartbeatRate
        active
        connectionStatus {
          httpStatus
          details
          timestamp
        }
      }
      phoniroConfig {
        primaryUrl
        clientId
        clientSecret
        escalationTimeoutMinutes
        tenantId
        organizationId
        alarmServerId
        isCloudPlas
      }
      umo2gConfig {
        endpointUrl
        username
        password
        sender
      }
      bestConfig {
        primaryUrl
        clientId
        secret
      }
      skyresponseConfig {
        primaryUrl
      }
      skyresponsePartnerConfig {
        primaryUrl
        pin
      }
      sipConfig {
        primaryUrl
        secondaryUrl
      }
      coordcomConfig {
        targetHost
        targetPort
        localSipUser
        userAgent
        outboundSipOkTimeoutMs
        inboundMrsTimeoutMs
        tlsServerNameOverride
        customCaCertificate
        relaxCertificateValidation
      }
      errorHandling {
        createPatientAlarmOnFail
        sendSmsOnFail
        sendEmailOnFail
        escalationPhoneNumbers
        escalationEmailAddresses
      }
      patientGroups {
        id
        name
      }
      externalAccess {
        id
        name
        allowedAccess
        ipRestrictions
        patientGroups {
          id
          name
        }
      }
      availableExternalAccessEndpoints {
        endpoint
        default
      }
    }
  }
`;

/**
 * __useIntegrationDetailsQuery__
 *
 * To run a query within a Vue component, call `useIntegrationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIntegrationDetailsQuery({
 *   id: // value for 'id'
 *   type: // value for 'type'
 * });
 */
export function useIntegrationDetailsQuery(
  variables:
    | IntegrationDetailsQueryVariables
    | VueCompositionApi.Ref<IntegrationDetailsQueryVariables>
    | ReactiveFunction<IntegrationDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>(
    IntegrationDetailsDocument,
    variables,
    options,
  );
}
export function useIntegrationDetailsLazyQuery(
  variables?:
    | IntegrationDetailsQueryVariables
    | VueCompositionApi.Ref<IntegrationDetailsQueryVariables>
    | ReactiveFunction<IntegrationDetailsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>(
    IntegrationDetailsDocument,
    variables,
    options,
  );
}
export type IntegrationDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  IntegrationDetailsQuery,
  IntegrationDetailsQueryVariables
>;
export const GetEventForwardingLogsDocument = gql`
  query getEventForwardingLogs(
    $integrationConfigIds: [ID!]
    $from: dateTime
    $to: dateTime
    $forwardingStatus: String
    $errorHandlingStatus: String
  ) {
    getEventForwardingLogs(
      integrationConfigIds: $integrationConfigIds
      from: $from
      to: $to
      forwardingStatus: $forwardingStatus
      errorHandlingStatus: $errorHandlingStatus
    ) {
      createdAt
      escalationMethod
      escalationStatus
      eventId
      forwardingStatus
      integrationConfigId
      patientExternalId
    }
  }
`;

/**
 * __useGetEventForwardingLogsQuery__
 *
 * To run a query within a Vue component, call `useGetEventForwardingLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForwardingLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventForwardingLogsQuery({
 *   integrationConfigIds: // value for 'integrationConfigIds'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   forwardingStatus: // value for 'forwardingStatus'
 *   errorHandlingStatus: // value for 'errorHandlingStatus'
 * });
 */
export function useGetEventForwardingLogsQuery(
  variables:
    | GetEventForwardingLogsQueryVariables
    | VueCompositionApi.Ref<GetEventForwardingLogsQueryVariables>
    | ReactiveFunction<GetEventForwardingLogsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>(
    GetEventForwardingLogsDocument,
    variables,
    options,
  );
}
export function useGetEventForwardingLogsLazyQuery(
  variables:
    | GetEventForwardingLogsQueryVariables
    | VueCompositionApi.Ref<GetEventForwardingLogsQueryVariables>
    | ReactiveFunction<GetEventForwardingLogsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetEventForwardingLogsQuery, GetEventForwardingLogsQueryVariables>(
    GetEventForwardingLogsDocument,
    variables,
    options,
  );
}
export type GetEventForwardingLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetEventForwardingLogsQuery,
  GetEventForwardingLogsQueryVariables
>;
export const GetAlarmTemplatesForForwardersDocument = gql`
  query getAlarmTemplatesForForwarders {
    getAlarmTemplates {
      id
      code {
        coding {
          display
          code
          system
        }
        text
      }
      status
      technical
    }
  }
`;

/**
 * __useGetAlarmTemplatesForForwardersQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForForwardersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForForwardersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForForwardersQuery();
 */
export function useGetAlarmTemplatesForForwardersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForForwardersQuery,
        GetAlarmTemplatesForForwardersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForForwardersQuery,
          GetAlarmTemplatesForForwardersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForForwardersQuery,
          GetAlarmTemplatesForForwardersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForForwardersQuery,
    GetAlarmTemplatesForForwardersQueryVariables
  >(GetAlarmTemplatesForForwardersDocument, {}, options);
}
export function useGetAlarmTemplatesForForwardersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForForwardersQuery,
        GetAlarmTemplatesForForwardersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForForwardersQuery,
          GetAlarmTemplatesForForwardersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForForwardersQuery,
          GetAlarmTemplatesForForwardersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForForwardersQuery,
    GetAlarmTemplatesForForwardersQueryVariables
  >(GetAlarmTemplatesForForwardersDocument, {}, options);
}
export type GetAlarmTemplatesForForwardersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForForwardersQuery,
  GetAlarmTemplatesForForwardersQueryVariables
>;
export const GetNextOfKinDocument = gql`
  query getNextOfKin($patientId: ID!) {
    getNextOfKin(patientId: $patientId) {
      id
      notifyNextOfKin
      relationship
      name {
        text
      }
      telecom {
        system
        value
      }
    }
  }
`;

/**
 * __useGetNextOfKinQuery__
 *
 * To run a query within a Vue component, call `useGetNextOfKinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextOfKinQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextOfKinQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetNextOfKinQuery(
  variables:
    | GetNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinQueryVariables>
    | ReactiveFunction<GetNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetNextOfKinQuery, GetNextOfKinQueryVariables>(
    GetNextOfKinDocument,
    variables,
    options,
  );
}
export function useGetNextOfKinLazyQuery(
  variables?:
    | GetNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinQueryVariables>
    | ReactiveFunction<GetNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetNextOfKinQuery, GetNextOfKinQueryVariables>(
    GetNextOfKinDocument,
    variables,
    options,
  );
}
export type GetNextOfKinQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNextOfKinQuery,
  GetNextOfKinQueryVariables
>;
export const PatientForViewDocument = gql`
  query patientForView($id: ID!) {
    patient(id: $id) {
      id
      active
      externalPatientIds {
        ...externalPatientIds
      }
      areCamerasEnabled
      userReservations {
        userId
        firstName
        lastName
      }
      name {
        given
        family
        text
      }
      birthDate
      gender
      languages {
        language
        preferred
      }
      identifier {
        value
        use
      }
      telecom {
        system
        value
      }
      skyresponseDetails {
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
      address {
        ...address
      }
      secretAddress
      addressNote
      keyCode
      photo {
        url
      }
      patientGroups {
        ...patientGroups
      }
      tags
      note
      notification {
        ...notification
      }
      documents {
        ...documents
      }
      carePlans {
        ...carePlans
      }
      rpmMedicalDevices {
        ...rpmMedicalDevices
      }
      welfareDevices {
        ...welfareDevices
      }
      dialoggUser {
        ...dialoggUser
      }
      referenceRange {
        ...referenceRange
      }
    }
  }
  ${ExternalPatientIdsFragmentDoc}
  ${AddressFragmentDoc}
  ${PatientGroupsFragmentDoc}
  ${NotificationFragmentDoc}
  ${DocumentsFragmentDoc}
  ${CarePlansFragmentDoc}
  ${RpmMedicalDevicesFragmentDoc}
  ${WelfareDevicesFragmentDoc}
  ${DialoggUserFragmentDoc}
  ${ReferenceRangeFragmentDoc}
`;

/**
 * __usePatientForViewQuery__
 *
 * To run a query within a Vue component, call `usePatientForViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForViewQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientForViewQuery(
  variables:
    | PatientForViewQueryVariables
    | VueCompositionApi.Ref<PatientForViewQueryVariables>
    | ReactiveFunction<PatientForViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientForViewQuery, PatientForViewQueryVariables>(
    PatientForViewDocument,
    variables,
    options,
  );
}
export function usePatientForViewLazyQuery(
  variables?:
    | PatientForViewQueryVariables
    | VueCompositionApi.Ref<PatientForViewQueryVariables>
    | ReactiveFunction<PatientForViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForViewQuery, PatientForViewQueryVariables>(
    PatientForViewDocument,
    variables,
    options,
  );
}
export type PatientForViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForViewQuery,
  PatientForViewQueryVariables
>;
export const PatientForSharedAlarmsDocument = gql`
  query patientForSharedAlarms($id: ID!) {
    patient(id: $id) {
      id
      shareAlarmWith {
        id
        name
        norwegianId
        isPrimary
      }
    }
  }
`;

/**
 * __usePatientForSharedAlarmsQuery__
 *
 * To run a query within a Vue component, call `usePatientForSharedAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForSharedAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForSharedAlarmsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientForSharedAlarmsQuery(
  variables:
    | PatientForSharedAlarmsQueryVariables
    | VueCompositionApi.Ref<PatientForSharedAlarmsQueryVariables>
    | ReactiveFunction<PatientForSharedAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>(
    PatientForSharedAlarmsDocument,
    variables,
    options,
  );
}
export function usePatientForSharedAlarmsLazyQuery(
  variables?:
    | PatientForSharedAlarmsQueryVariables
    | VueCompositionApi.Ref<PatientForSharedAlarmsQueryVariables>
    | ReactiveFunction<PatientForSharedAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>(
    PatientForSharedAlarmsDocument,
    variables,
    options,
  );
}
export type PatientForSharedAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForSharedAlarmsQuery,
  PatientForSharedAlarmsQueryVariables
>;
export const GetSharedSkyResponseAlarmsPatientCandidatesDocument = gql`
  query getSharedSkyResponseAlarmsPatientCandidates($patientId: ID!) {
    getSharedSkyResponseAlarmsPatientCandidates(patientId: $patientId) {
      id
      name {
        given
        family
        text
      }
      externalPatientIds {
        type
        id
      }
    }
  }
`;

/**
 * __useGetSharedSkyResponseAlarmsPatientCandidatesQuery__
 *
 * To run a query within a Vue component, call `useGetSharedSkyResponseAlarmsPatientCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedSkyResponseAlarmsPatientCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSharedSkyResponseAlarmsPatientCandidatesQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetSharedSkyResponseAlarmsPatientCandidatesQuery(
  variables:
    | GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
    | VueCompositionApi.Ref<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>
    | ReactiveFunction<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSharedSkyResponseAlarmsPatientCandidatesQuery,
        GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >(GetSharedSkyResponseAlarmsPatientCandidatesDocument, variables, options);
}
export function useGetSharedSkyResponseAlarmsPatientCandidatesLazyQuery(
  variables?:
    | GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
    | VueCompositionApi.Ref<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>
    | ReactiveFunction<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSharedSkyResponseAlarmsPatientCandidatesQuery,
        GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >(GetSharedSkyResponseAlarmsPatientCandidatesDocument, variables, options);
}
export type GetSharedSkyResponseAlarmsPatientCandidatesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >;
export const GetPatientForSimpleViewDocument = gql`
  query getPatientForSimpleView($patientId: ID!) {
    getPatientWithAllDevicesAndAlarms(patientId: $patientId) {
      patient {
        id
        active
        name {
          given
          family
          text
        }
        birthDate
        identifier {
          value
          use
        }
        photo {
          url
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        addressNote
        keyCode
        telecom {
          system
          value
        }
        note
        areCamerasEnabled
        camerasDisabledAt
        camerasStateOrigin
        responderIsPresent
        camerasReactivateAt
      }
      patientGroups
      cameras {
        identifier
        name
        privacyMode
        privacyModeUntil
        availableHours
        online
        deviceGroup {
          id
          name
          enableFurnitureDetection
          furnitureDetectionPeriodSec
        }
        cameraProfile {
          ...CameraProfileSettings
        }
      }
    }
  }
  ${CameraProfileSettingsFragmentDoc}
`;

/**
 * __useGetPatientForSimpleViewQuery__
 *
 * To run a query within a Vue component, call `useGetPatientForSimpleViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientForSimpleViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientForSimpleViewQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientForSimpleViewQuery(
  variables:
    | GetPatientForSimpleViewQueryVariables
    | VueCompositionApi.Ref<GetPatientForSimpleViewQueryVariables>
    | ReactiveFunction<GetPatientForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>(
    GetPatientForSimpleViewDocument,
    variables,
    options,
  );
}
export function useGetPatientForSimpleViewLazyQuery(
  variables?:
    | GetPatientForSimpleViewQueryVariables
    | VueCompositionApi.Ref<GetPatientForSimpleViewQueryVariables>
    | ReactiveFunction<GetPatientForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientForSimpleViewQuery, GetPatientForSimpleViewQueryVariables>(
    GetPatientForSimpleViewDocument,
    variables,
    options,
  );
}
export type GetPatientForSimpleViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientForSimpleViewQuery,
  GetPatientForSimpleViewQueryVariables
>;
export const GetAllPatientAlarmsForSimpleViewDocument = gql`
  query getAllPatientAlarmsForSimpleView($patientId: ID!) {
    getAllPatientAlarmsForPatient(patientId: $patientId) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      subTasks {
        id
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        icon
        priority
        timestamp
      }
      note {
        authorString
        time
        text
      }
    }
  }
`;

/**
 * __useGetAllPatientAlarmsForSimpleViewQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientAlarmsForSimpleViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientAlarmsForSimpleViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientAlarmsForSimpleViewQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllPatientAlarmsForSimpleViewQuery(
  variables:
    | GetAllPatientAlarmsForSimpleViewQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForSimpleViewQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForSimpleViewQuery,
        GetAllPatientAlarmsForSimpleViewQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForSimpleViewQuery,
          GetAllPatientAlarmsForSimpleViewQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForSimpleViewQuery,
          GetAllPatientAlarmsForSimpleViewQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllPatientAlarmsForSimpleViewQuery,
    GetAllPatientAlarmsForSimpleViewQueryVariables
  >(GetAllPatientAlarmsForSimpleViewDocument, variables, options);
}
export function useGetAllPatientAlarmsForSimpleViewLazyQuery(
  variables?:
    | GetAllPatientAlarmsForSimpleViewQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForSimpleViewQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForSimpleViewQuery,
        GetAllPatientAlarmsForSimpleViewQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForSimpleViewQuery,
          GetAllPatientAlarmsForSimpleViewQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForSimpleViewQuery,
          GetAllPatientAlarmsForSimpleViewQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllPatientAlarmsForSimpleViewQuery,
    GetAllPatientAlarmsForSimpleViewQueryVariables
  >(GetAllPatientAlarmsForSimpleViewDocument, variables, options);
}
export type GetAllPatientAlarmsForSimpleViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientAlarmsForSimpleViewQuery,
  GetAllPatientAlarmsForSimpleViewQueryVariables
>;
export const PatientGroupsForPatientIdsDocument = gql`
  query patientGroupsForPatientIds($patientIds: [ID!]!) {
    patientGroupsForPatientIds(patientIds: $patientIds) {
      patientId
      userGroups {
        id
        name
      }
    }
  }
`;

/**
 * __usePatientGroupsForPatientIdsQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupsForPatientIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupsForPatientIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupsForPatientIdsQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function usePatientGroupsForPatientIdsQuery(
  variables:
    | PatientGroupsForPatientIdsQueryVariables
    | VueCompositionApi.Ref<PatientGroupsForPatientIdsQueryVariables>
    | ReactiveFunction<PatientGroupsForPatientIdsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>(
    PatientGroupsForPatientIdsDocument,
    variables,
    options,
  );
}
export function usePatientGroupsForPatientIdsLazyQuery(
  variables?:
    | PatientGroupsForPatientIdsQueryVariables
    | VueCompositionApi.Ref<PatientGroupsForPatientIdsQueryVariables>
    | ReactiveFunction<PatientGroupsForPatientIdsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientGroupsForPatientIdsQuery, PatientGroupsForPatientIdsQueryVariables>(
    PatientGroupsForPatientIdsDocument,
    variables,
    options,
  );
}
export type PatientGroupsForPatientIdsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupsForPatientIdsQuery,
  PatientGroupsForPatientIdsQueryVariables
>;
export const GetPushNotificationLogDocument = gql`
  query getPushNotificationLog($input: PushNotificationLogInput!) {
    getPushNotificationLog(input: $input) {
      id
      username
      deviceName
      logType
      pushNotificationType
      event {
        id
        patientId
      }
      shiftSession {
        id
        userId
      }
      triggeredAt
      ackedAt
      confirmedAt
      meta
    }
  }
`;

/**
 * __useGetPushNotificationLogQuery__
 *
 * To run a query within a Vue component, call `useGetPushNotificationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushNotificationLogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPushNotificationLogQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPushNotificationLogQuery(
  variables:
    | GetPushNotificationLogQueryVariables
    | VueCompositionApi.Ref<GetPushNotificationLogQueryVariables>
    | ReactiveFunction<GetPushNotificationLogQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>(
    GetPushNotificationLogDocument,
    variables,
    options,
  );
}
export function useGetPushNotificationLogLazyQuery(
  variables?:
    | GetPushNotificationLogQueryVariables
    | VueCompositionApi.Ref<GetPushNotificationLogQueryVariables>
    | ReactiveFunction<GetPushNotificationLogQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPushNotificationLogQuery, GetPushNotificationLogQueryVariables>(
    GetPushNotificationLogDocument,
    variables,
    options,
  );
}
export type GetPushNotificationLogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPushNotificationLogQuery,
  GetPushNotificationLogQueryVariables
>;
export const PatientDocument = gql`
  query patient($id: ID!) {
    patient(id: $id) {
      id
      active
      patientGroups {
        name
        id
      }
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
        configuration {
          registeredInInventory
        }
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
        }
      }
      journalConfigForPatient {
        remoteSupervision {
          enabled
        }
      }
    }
  }
`;

/**
 * __usePatientQuery__
 *
 * To run a query within a Vue component, call `usePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientQuery(
  variables:
    PatientQueryVariables | VueCompositionApi.Ref<PatientQueryVariables> | ReactiveFunction<PatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientQuery, PatientQueryVariables>(PatientDocument, variables, options);
}
export function usePatientLazyQuery(
  variables?:
    PatientQueryVariables | VueCompositionApi.Ref<PatientQueryVariables> | ReactiveFunction<PatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientQuery, PatientQueryVariables>(PatientDocument, variables, options);
}
export type PatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientQuery,
  PatientQueryVariables
>;
export const RetryAlarmJournalingDocument = gql`
  mutation retryAlarmJournaling($alarmId: ID!) {
    retryAlarmJournaling(alarmId: $alarmId) {
      success
      message
    }
  }
`;

/**
 * __useRetryAlarmJournalingMutation__
 *
 * To run a mutation, you first call `useRetryAlarmJournalingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryAlarmJournalingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryAlarmJournalingMutation({
 *   variables: {
 *     alarmId: // value for 'alarmId'
 *   },
 * });
 */
export function useRetryAlarmJournalingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>(
    RetryAlarmJournalingDocument,
    options,
  );
}
export type RetryAlarmJournalingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetryAlarmJournalingMutation,
  RetryAlarmJournalingMutationVariables
>;
export const AvailableColleaguesForShiftDocument = gql`
  query availableColleaguesForShift {
    availableColleaguesForShift {
      userId
      name
      shiftSessionPhoneNumber
    }
  }
`;

/**
 * __useAvailableColleaguesForShiftQuery__
 *
 * To run a query within a Vue component, call `useAvailableColleaguesForShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableColleaguesForShiftQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableColleaguesForShiftQuery();
 */
export function useAvailableColleaguesForShiftQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>(
    AvailableColleaguesForShiftDocument,
    {},
    options,
  );
}
export function useAvailableColleaguesForShiftLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AvailableColleaguesForShiftQuery, AvailableColleaguesForShiftQueryVariables>(
    AvailableColleaguesForShiftDocument,
    {},
    options,
  );
}
export type AvailableColleaguesForShiftQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AvailableColleaguesForShiftQuery,
  AvailableColleaguesForShiftQueryVariables
>;
export const ShiftSessionForUserDocument = gql`
  query shiftSessionForUser($userId: ID!) {
    shiftSessionForUser(userId: $userId) {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
        createdAt
      }
      notificationSettings {
        sendEmail
        sendSms
        mobileNumber
        shiftSessionPhoneNumber
        email
        locale
        name
        username
        userId
      }
      history {
        id
        createdAt
        endedAt
      }
      createdAt
      lastUpdated
      active
    }
  }
`;

/**
 * __useShiftSessionForUserQuery__
 *
 * To run a query within a Vue component, call `useShiftSessionForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftSessionForUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShiftSessionForUserQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useShiftSessionForUserQuery(
  variables:
    | ShiftSessionForUserQueryVariables
    | VueCompositionApi.Ref<ShiftSessionForUserQueryVariables>
    | ReactiveFunction<ShiftSessionForUserQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>(
    ShiftSessionForUserDocument,
    variables,
    options,
  );
}
export function useShiftSessionForUserLazyQuery(
  variables?:
    | ShiftSessionForUserQueryVariables
    | VueCompositionApi.Ref<ShiftSessionForUserQueryVariables>
    | ReactiveFunction<ShiftSessionForUserQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ShiftSessionForUserQuery, ShiftSessionForUserQueryVariables>(
    ShiftSessionForUserDocument,
    variables,
    options,
  );
}
export type ShiftSessionForUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ShiftSessionForUserQuery,
  ShiftSessionForUserQueryVariables
>;
export const GetSupervisionCarePlanDocument = gql`
  query getSupervisionCarePlan($patientId: ID!) {
    getSupervisionCarePlan(patientId: $patientId) {
      alarmActivity {
        id
        identifier {
          value
        }
        interpretation {
          text
          coding {
            code
            display
          }
        }
        description
        code {
          coding {
            display
            code
          }
        }
        alarmIcon
      }
      scheduledTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
    }
  }
`;

/**
 * __useGetSupervisionCarePlanQuery__
 *
 * To run a query within a Vue component, call `useGetSupervisionCarePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisionCarePlanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSupervisionCarePlanQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetSupervisionCarePlanQuery(
  variables:
    | GetSupervisionCarePlanQueryVariables
    | VueCompositionApi.Ref<GetSupervisionCarePlanQueryVariables>
    | ReactiveFunction<GetSupervisionCarePlanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>(
    GetSupervisionCarePlanDocument,
    variables,
    options,
  );
}
export function useGetSupervisionCarePlanLazyQuery(
  variables?:
    | GetSupervisionCarePlanQueryVariables
    | VueCompositionApi.Ref<GetSupervisionCarePlanQueryVariables>
    | ReactiveFunction<GetSupervisionCarePlanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetSupervisionCarePlanQuery, GetSupervisionCarePlanQueryVariables>(
    GetSupervisionCarePlanDocument,
    variables,
    options,
  );
}
export type GetSupervisionCarePlanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSupervisionCarePlanQuery,
  GetSupervisionCarePlanQueryVariables
>;
export const GetAlarmTemplatesForCameraSupervisionDocument = gql`
  query getAlarmTemplatesForCameraSupervision {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      status
      code {
        coding {
          display
          code
          system
        }
      }
      alarmIcon
      interpretation {
        text
        coding {
          code
          display
        }
      }
      description
    }
  }
`;

/**
 * __useGetAlarmTemplatesForCameraSupervisionQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForCameraSupervisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForCameraSupervisionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForCameraSupervisionQuery();
 */
export function useGetAlarmTemplatesForCameraSupervisionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForCameraSupervisionQuery,
        GetAlarmTemplatesForCameraSupervisionQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForCameraSupervisionQuery,
          GetAlarmTemplatesForCameraSupervisionQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForCameraSupervisionQuery,
          GetAlarmTemplatesForCameraSupervisionQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForCameraSupervisionQuery,
    GetAlarmTemplatesForCameraSupervisionQueryVariables
  >(GetAlarmTemplatesForCameraSupervisionDocument, {}, options);
}
export function useGetAlarmTemplatesForCameraSupervisionLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForCameraSupervisionQuery,
        GetAlarmTemplatesForCameraSupervisionQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForCameraSupervisionQuery,
          GetAlarmTemplatesForCameraSupervisionQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForCameraSupervisionQuery,
          GetAlarmTemplatesForCameraSupervisionQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForCameraSupervisionQuery,
    GetAlarmTemplatesForCameraSupervisionQueryVariables
  >(GetAlarmTemplatesForCameraSupervisionDocument, {}, options);
}
export type GetAlarmTemplatesForCameraSupervisionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForCameraSupervisionQuery,
  GetAlarmTemplatesForCameraSupervisionQueryVariables
>;
export const GetAllCompletionOptionsDocument = gql`
  query getAllCompletionOptions {
    getAllCompletionOptions {
      id
      text
      templates {
        id
        code
        title
        system
        displayText
        icon
      }
    }
  }
`;

/**
 * __useGetAllCompletionOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCompletionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompletionOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCompletionOptionsQuery();
 */
export function useGetAllCompletionOptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>(
    GetAllCompletionOptionsDocument,
    {},
    options,
  );
}
export function useGetAllCompletionOptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllCompletionOptionsQuery, GetAllCompletionOptionsQueryVariables>(
    GetAllCompletionOptionsDocument,
    {},
    options,
  );
}
export type GetAllCompletionOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllCompletionOptionsQuery,
  GetAllCompletionOptionsQueryVariables
>;
export const CreateCompletionOptionDocument = gql`
  mutation createCompletionOption($text: String!) {
    createCompletionOption(text: $text) {
      success
      alarmCompletionOption {
        id
        text
        templates {
          id
          code
          title
          system
          displayText
          icon
        }
      }
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateCompletionOptionMutation__
 *
 * To run a mutation, you first call `useCreateCompletionOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompletionOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompletionOptionMutation({
 *   variables: {
 *     text: // value for 'text'
 *   },
 * });
 */
export function useCreateCompletionOptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCompletionOptionMutation, CreateCompletionOptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCompletionOptionMutation, CreateCompletionOptionMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCompletionOptionMutation, CreateCompletionOptionMutationVariables>(
    CreateCompletionOptionDocument,
    options,
  );
}
export type CreateCompletionOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCompletionOptionMutation,
  CreateCompletionOptionMutationVariables
>;
export const UpdateCompletionOptionDocument = gql`
  mutation updateCompletionOption($id: ID!, $text: String!) {
    updateCompletionOption(id: $id, text: $text) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateCompletionOptionMutation__
 *
 * To run a mutation, you first call `useUpdateCompletionOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompletionOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompletionOptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCompletionOptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCompletionOptionMutation, UpdateCompletionOptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCompletionOptionMutation, UpdateCompletionOptionMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCompletionOptionMutation, UpdateCompletionOptionMutationVariables>(
    UpdateCompletionOptionDocument,
    options,
  );
}
export type UpdateCompletionOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCompletionOptionMutation,
  UpdateCompletionOptionMutationVariables
>;
export const DeleteCompletionOptionDocument = gql`
  mutation deleteCompletionOption($id: ID!) {
    deleteCompletionOption(id: $id)
  }
`;

/**
 * __useDeleteCompletionOptionMutation__
 *
 * To run a mutation, you first call `useDeleteCompletionOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompletionOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCompletionOptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompletionOptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCompletionOptionMutation, DeleteCompletionOptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCompletionOptionMutation, DeleteCompletionOptionMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCompletionOptionMutation, DeleteCompletionOptionMutationVariables>(
    DeleteCompletionOptionDocument,
    options,
  );
}
export type DeleteCompletionOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCompletionOptionMutation,
  DeleteCompletionOptionMutationVariables
>;
export const AttachCompletionOptionToAlarmTemplateDocument = gql`
  mutation attachCompletionOptionToAlarmTemplate($alarmTemplateId: [ID!]!, $completionOptionId: ID!) {
    attachCompletionOptionToAlarmTemplate(alarmTemplateId: $alarmTemplateId, completionOptionId: $completionOptionId)
  }
`;

/**
 * __useAttachCompletionOptionToAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useAttachCompletionOptionToAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachCompletionOptionToAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachCompletionOptionToAlarmTemplateMutation({
 *   variables: {
 *     alarmTemplateId: // value for 'alarmTemplateId'
 *     completionOptionId: // value for 'completionOptionId'
 *   },
 * });
 */
export function useAttachCompletionOptionToAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AttachCompletionOptionToAlarmTemplateMutation,
        AttachCompletionOptionToAlarmTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AttachCompletionOptionToAlarmTemplateMutation,
          AttachCompletionOptionToAlarmTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AttachCompletionOptionToAlarmTemplateMutation,
    AttachCompletionOptionToAlarmTemplateMutationVariables
  >(AttachCompletionOptionToAlarmTemplateDocument, options);
}
export type AttachCompletionOptionToAlarmTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AttachCompletionOptionToAlarmTemplateMutation,
    AttachCompletionOptionToAlarmTemplateMutationVariables
  >;
export const RemoveCompletionOptionFromAlarmTemplateDocument = gql`
  mutation removeCompletionOptionFromAlarmTemplate($alarmTemplateId: [ID!]!, $completionOptionId: ID!) {
    removeCompletionOptionFromAlarmTemplate(alarmTemplateId: $alarmTemplateId, completionOptionId: $completionOptionId)
  }
`;

/**
 * __useRemoveCompletionOptionFromAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveCompletionOptionFromAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompletionOptionFromAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCompletionOptionFromAlarmTemplateMutation({
 *   variables: {
 *     alarmTemplateId: // value for 'alarmTemplateId'
 *     completionOptionId: // value for 'completionOptionId'
 *   },
 * });
 */
export function useRemoveCompletionOptionFromAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveCompletionOptionFromAlarmTemplateMutation,
        RemoveCompletionOptionFromAlarmTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveCompletionOptionFromAlarmTemplateMutation,
          RemoveCompletionOptionFromAlarmTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveCompletionOptionFromAlarmTemplateMutation,
    RemoveCompletionOptionFromAlarmTemplateMutationVariables
  >(RemoveCompletionOptionFromAlarmTemplateDocument, options);
}
export type RemoveCompletionOptionFromAlarmTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveCompletionOptionFromAlarmTemplateMutation,
    RemoveCompletionOptionFromAlarmTemplateMutationVariables
  >;
export const GetAvailableDevicesInSafemateProDocument = gql`
  query getAvailableDevicesInSafematePro {
    getAvailableDevicesInSafematePro {
      hasSafemateIntegration
      safemateDevices {
        serial
        name
        status
        lastMessageFromDevice
        customerName
        isInRegistry
        isInWrongHealthProvider
        healthProviderName
      }
    }
  }
`;

/**
 * __useGetAvailableDevicesInSafemateProQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableDevicesInSafemateProQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDevicesInSafemateProQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableDevicesInSafemateProQuery();
 */
export function useGetAvailableDevicesInSafemateProQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableDevicesInSafemateProQuery,
        GetAvailableDevicesInSafemateProQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableDevicesInSafemateProQuery,
    GetAvailableDevicesInSafemateProQueryVariables
  >(GetAvailableDevicesInSafemateProDocument, {}, options);
}
export function useGetAvailableDevicesInSafemateProLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableDevicesInSafemateProQuery,
        GetAvailableDevicesInSafemateProQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableDevicesInSafemateProQuery,
    GetAvailableDevicesInSafemateProQueryVariables
  >(GetAvailableDevicesInSafemateProDocument, {}, options);
}
export type GetAvailableDevicesInSafemateProQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableDevicesInSafemateProQuery,
  GetAvailableDevicesInSafemateProQueryVariables
>;
export const PatientWithCamerasDocument = gql`
  query patientWithCameras($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
        configuration {
          hasExternalUrl
          registeredInInventory
        }
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
          privacyModeUntil
        }
        deviceGroup {
          name
          id
        }
        patientReference {
          reference
        }
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __usePatientWithCamerasQuery__
 *
 * To run a query within a Vue component, call `usePatientWithCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithCamerasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithCamerasQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithCamerasQuery(
  variables:
    | PatientWithCamerasQueryVariables
    | VueCompositionApi.Ref<PatientWithCamerasQueryVariables>
    | ReactiveFunction<PatientWithCamerasQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>(
    PatientWithCamerasDocument,
    variables,
    options,
  );
}
export function usePatientWithCamerasLazyQuery(
  variables?:
    | PatientWithCamerasQueryVariables
    | VueCompositionApi.Ref<PatientWithCamerasQueryVariables>
    | ReactiveFunction<PatientWithCamerasQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>(
    PatientWithCamerasDocument,
    variables,
    options,
  );
}
export type PatientWithCamerasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithCamerasQuery,
  PatientWithCamerasQueryVariables
>;
export const PatientWithWelfareDevicesDocument = gql`
  query patientWithWelfareDevices($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      patientGroups {
        id
        name
      }
      welfareDevices {
        id
        uniqueIdentifier
        tags
        modelNumber
        userFriendlyName
        deviceGroup {
          name
          id
        }
        deviceName {
          name
        }
        configuration {
          hasExternalUrl
          registeredInInventory
        }
        status {
          lastSeen
          lastBatteryStatus
          lastBatteryTimestamp
        }
      }
      skyresponseDetails {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
    }
  }
`;

/**
 * __usePatientWithWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `usePatientWithWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithWelfareDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithWelfareDevicesQuery(
  variables:
    | PatientWithWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWithWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWithWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>(
    PatientWithWelfareDevicesDocument,
    variables,
    options,
  );
}
export function usePatientWithWelfareDevicesLazyQuery(
  variables?:
    | PatientWithWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWithWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWithWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>(
    PatientWithWelfareDevicesDocument,
    variables,
    options,
  );
}
export type PatientWithWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithWelfareDevicesQuery,
  PatientWithWelfareDevicesQueryVariables
>;
export const PatientListDocument = gql`
  query patientList($onlyActive: Boolean, $features: PatientListFeatures) {
    patientList(onlyActive: $onlyActive, features: $features) {
      id
      createdAt
      tags
      openSyncAlarmId
      externalIds {
        type
        id
      }
      active
      firstName
      shareAlarmWithPatients {
        isPrimary
        id
        name
      }
      lastName
      patientGroupNames
      location
      devices {
        name
        type
        deviceType
        isSharedDevice
      }
      secretAddress
      rpmLastActive
      enabledServices
      primaryAddress {
        addressLine
        postalCode
        city
        room
      }
      cmpSensors {
        day
        modelName
        modelValue
        serialNumber
      }
    }
  }
`;

/**
 * __usePatientListQuery__
 *
 * To run a query within a Vue component, call `usePatientListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientListQuery({
 *   onlyActive: // value for 'onlyActive'
 *   features: // value for 'features'
 * });
 */
export function usePatientListQuery(
  variables:
    | PatientListQueryVariables
    | VueCompositionApi.Ref<PatientListQueryVariables>
    | ReactiveFunction<PatientListQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientListQuery, PatientListQueryVariables>(
    PatientListDocument,
    variables,
    options,
  );
}
export function usePatientListLazyQuery(
  variables:
    | PatientListQueryVariables
    | VueCompositionApi.Ref<PatientListQueryVariables>
    | ReactiveFunction<PatientListQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientListQuery, PatientListQueryVariables>(
    PatientListDocument,
    variables,
    options,
  );
}
export type PatientListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientListQuery,
  PatientListQueryVariables
>;
export const PatientsByActivityDocument = gql`
  query patientsByActivity($onlyActive: Boolean) {
    patients(onlyActive: $onlyActive) {
      id
      active
      areCamerasEnabled
      externalPatientIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      name {
        given
        family
        text
      }
      gender
      birthDate
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      addressNote
      keyCode
      patientGroups {
        id
        name
      }
      tags
      cameras {
        modelName
        manufacturer
        id
        name
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        deviceName {
          name
        }
      }
      hasSkyresponseSyncFailed
    }
  }
`;

/**
 * __usePatientsByActivityQuery__
 *
 * To run a query within a Vue component, call `usePatientsByActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsByActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientsByActivityQuery({
 *   onlyActive: // value for 'onlyActive'
 * });
 */
export function usePatientsByActivityQuery(
  variables:
    | PatientsByActivityQueryVariables
    | VueCompositionApi.Ref<PatientsByActivityQueryVariables>
    | ReactiveFunction<PatientsByActivityQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientsByActivityQuery, PatientsByActivityQueryVariables>(
    PatientsByActivityDocument,
    variables,
    options,
  );
}
export function usePatientsByActivityLazyQuery(
  variables:
    | PatientsByActivityQueryVariables
    | VueCompositionApi.Ref<PatientsByActivityQueryVariables>
    | ReactiveFunction<PatientsByActivityQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientsByActivityQuery, PatientsByActivityQueryVariables>(
    PatientsByActivityDocument,
    variables,
    options,
  );
}
export type PatientsByActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientsByActivityQuery,
  PatientsByActivityQueryVariables
>;
export const HealthProviderSettingsWithExternalHumanIdTypesDocument = gql`
  query healthProviderSettingsWithExternalHumanIdTypes {
    healthProviderSettings {
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsWithExternalHumanIdTypesQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsWithExternalHumanIdTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsWithExternalHumanIdTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsWithExternalHumanIdTypesQuery();
 */
export function useHealthProviderSettingsWithExternalHumanIdTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsWithExternalHumanIdTypesQuery,
        HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >(HealthProviderSettingsWithExternalHumanIdTypesDocument, {}, options);
}
export function useHealthProviderSettingsWithExternalHumanIdTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsWithExternalHumanIdTypesQuery,
        HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >(HealthProviderSettingsWithExternalHumanIdTypesDocument, {}, options);
}
export type HealthProviderSettingsWithExternalHumanIdTypesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >;
export const GetPatientByExternalIdDocument = gql`
  query getPatientByExternalId($externalPatientId: String!, $externalHumanIdTypeId: String!) {
    getPatientByExternalId(externalPatientId: $externalPatientId, externalHumanIdTypeId: $externalHumanIdTypeId) {
      success
      found
      patient {
        id
        identityNumber
        active
        enabledServices
        name {
          given
          family
          text
        }
        gender
        birthDate
        telecom {
          system
          value
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        addressNote
        keyCode
        patientGroups {
          id
          name
        }
      }
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useGetPatientByExternalIdQuery__
 *
 * To run a query within a Vue component, call `useGetPatientByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientByExternalIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientByExternalIdQuery({
 *   externalPatientId: // value for 'externalPatientId'
 *   externalHumanIdTypeId: // value for 'externalHumanIdTypeId'
 * });
 */
export function useGetPatientByExternalIdQuery(
  variables:
    | GetPatientByExternalIdQueryVariables
    | VueCompositionApi.Ref<GetPatientByExternalIdQueryVariables>
    | ReactiveFunction<GetPatientByExternalIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>(
    GetPatientByExternalIdDocument,
    variables,
    options,
  );
}
export function useGetPatientByExternalIdLazyQuery(
  variables?:
    | GetPatientByExternalIdQueryVariables
    | VueCompositionApi.Ref<GetPatientByExternalIdQueryVariables>
    | ReactiveFunction<GetPatientByExternalIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>(
    GetPatientByExternalIdDocument,
    variables,
    options,
  );
}
export type GetPatientByExternalIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientByExternalIdQuery,
  GetPatientByExternalIdQueryVariables
>;
export const PatientNameDocument = gql`
  query patientName($id: ID!) {
    patient(id: $id) {
      id
      active
      areCamerasEnabled
      camerasDisabledAt
      camerasReactivateAt
      name {
        given
        family
        text
      }
    }
  }
`;

/**
 * __usePatientNameQuery__
 *
 * To run a query within a Vue component, call `usePatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNameQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNameQuery(
  variables:
    | PatientNameQueryVariables
    | VueCompositionApi.Ref<PatientNameQueryVariables>
    | ReactiveFunction<PatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientNameQuery, PatientNameQueryVariables>(
    PatientNameDocument,
    variables,
    options,
  );
}
export function usePatientNameLazyQuery(
  variables?:
    | PatientNameQueryVariables
    | VueCompositionApi.Ref<PatientNameQueryVariables>
    | ReactiveFunction<PatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNameQuery, PatientNameQueryVariables>(
    PatientNameDocument,
    variables,
    options,
  );
}
export type PatientNameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNameQuery,
  PatientNameQueryVariables
>;
export const GetAllAlarmEventsForPatientPaginatedDocument = gql`
  query getAllAlarmEventsForPatientPaginated(
    $patientId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
  ) {
    getAllAlarmEventsForPatientPaginated(patientId: $patientId, from: $from, to: $to, limit: $limit, cursor: $cursor) {
      events {
        effectiveDateTime
        id
        status
        payload
        code {
          coding {
            code
            display
          }
          text
        }
        handlingStatuses {
          handler
          initiatedAt
          attempts {
            startedAt
            doneAt
            status
            handledBy
            payload
            rawResponse
            rawStatus
            details
          }
        }
        component {
          code {
            text
          }
          valueString
        }
        hasPushNotifications
      }
      cursor
    }
  }
`;

/**
 * __useGetAllAlarmEventsForPatientPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmEventsForPatientPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmEventsForPatientPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmEventsForPatientPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useGetAllAlarmEventsForPatientPaginatedQuery(
  variables:
    | GetAllAlarmEventsForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllAlarmEventsForPatientPaginatedQuery,
        GetAllAlarmEventsForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllAlarmEventsForPatientPaginatedQuery,
    GetAllAlarmEventsForPatientPaginatedQueryVariables
  >(GetAllAlarmEventsForPatientPaginatedDocument, variables, options);
}
export function useGetAllAlarmEventsForPatientPaginatedLazyQuery(
  variables?:
    | GetAllAlarmEventsForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllAlarmEventsForPatientPaginatedQuery,
        GetAllAlarmEventsForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllAlarmEventsForPatientPaginatedQuery,
    GetAllAlarmEventsForPatientPaginatedQueryVariables
  >(GetAllAlarmEventsForPatientPaginatedDocument, variables, options);
}
export type GetAllAlarmEventsForPatientPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmEventsForPatientPaginatedQuery,
  GetAllAlarmEventsForPatientPaginatedQueryVariables
>;
export const GetAllAlarmEventsDocument = gql`
  query getAllAlarmEvents(
    $patientIds: [ID!]
    $from: dateTime
    $to: dateTime
    $sessionFilter: Boolean
    $patientGroupIds: [ID!]
    $eventCodes: [String!]
  ) {
    getAllAlarmEvents(
      patientIds: $patientIds
      from: $from
      to: $to
      sessionFilter: $sessionFilter
      patientGroupIds: $patientGroupIds
      eventCodes: $eventCodes
    ) {
      effectiveDateTime
      id
      status
      code {
        coding {
          code
          display
        }
        text
      }
      handlingStatuses {
        handler
        initiatedAt
        attempts {
          startedAt
          doneAt
          status
          handledBy
          payload
          rawResponse
          rawStatus
          details
        }
      }
      component {
        code {
          text
        }
        valueString
      }
    }
  }
`;

/**
 * __useGetAllAlarmEventsQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmEventsQuery({
 *   patientIds: // value for 'patientIds'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   sessionFilter: // value for 'sessionFilter'
 *   patientGroupIds: // value for 'patientGroupIds'
 *   eventCodes: // value for 'eventCodes'
 * });
 */
export function useGetAllAlarmEventsQuery(
  variables:
    | GetAllAlarmEventsQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>(
    GetAllAlarmEventsDocument,
    variables,
    options,
  );
}
export function useGetAllAlarmEventsLazyQuery(
  variables:
    | GetAllAlarmEventsQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmEventsQuery, GetAllAlarmEventsQueryVariables>(
    GetAllAlarmEventsDocument,
    variables,
    options,
  );
}
export type GetAllAlarmEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmEventsQuery,
  GetAllAlarmEventsQueryVariables
>;
